const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "พื้นหลังอ่านจันทรา",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "ไม่สามารถเผยแพร่ได้เนื่องจากทรัพยากรฉากมากเกินไป โปรดลบทรัพยากรบางส่วนแล้วลองอีกครั้ง",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "ขณะนี้ไม่มีสิทธิ์เข้าถึงคุณสมบัติที่เกี่ยวข้องกับสมาชิก",
  T_12_I_GIFT_SENDER_BELL: "กระดิ่ง",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "แม็กซ์! สปีดดดดดด [FFB300](ซ่อนหมวก)[-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "เคราซานต้า",
  T_12_L_COS_PINKMAN: "สวีทพิงค์ก็อตจิ",
  T_12_L_COS_POLAR: "คริสต์มาสแบร์",
  T_12_L_COS_RENDER: "เรนโบว์ฮอร์นก็อตจิ",
  T_12_L_COS_TIGER: "ไทเกอร์ก็อตจิ",
  T_12_L_MALE_BOTTOM_COS_ELF: "คริสต์มาสเอลฟ์",
  T_12_L_MALE_COS_SANTA: "ชุดต้นไม้ลุงซานต้า",
  T_12_L_MALE_HAIR_COS_ELF: "คริสต์มาสเอลฟ์",
  T_12_L_MALE_SHOE_COS_ELF: "คริสต์มาสเอลฟ์",
  T_12_L_MALE_TOP_COS_ELF: "คริสต์มาสเอลฟ์",
  T_12_O_CAT_NAME: "มิ้วน้อย",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014 - Winterlands",
  T_12_O_MACHETE_GOLD_NAME: "มีดพร้า - The Gold",
  T_12_O_PET_TITLE: "คู่หู",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "รองเท้าโดด",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "รองเท้าสมัยใหม่ ทำให้สามารถกระโดดกลางอากาศได้อีกครั้ง",
  T_12_Q_ITEM_FLYSHOE: "รองเท้าเจ็ต",
  T_12_Q_ITEM_FLYSHOE_DESC: "ที่ทำให้บินได้ ระวังน้ำมันหมดก็แล้วกัน",
  T_12_Q_ITEM_STOCK1: "พานท้ายเลเวล 1",
  T_12_Q_ITEM_STOCK2: "พานท้ายเลเวล 2",
  T_12_Q_ITEM_STOCK3: "พานท้ายเลเวล 3",
  T_12_Q_ITEM_TREATMENTGUN: "Heal Pistol",
  T_12_Q_ITEM_VEST4: "เกราะเลเวล 4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "อันโตนิโอ",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "หงอคง",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "โยกเย้า",
  T_12_R_EMOTE_WAVE_NAME: "โบกสะบัด",
  T_12_R_SKILL_NAME_GANGLEADER: "เลือดมาเฟีย",
  T_12_R_SKILL_NAME_MONKEYGOD: "ร่างจำแลง",
  T_13_I_COLLECTION_V_AMPHIBIAN: "รถสะเทิ้นน้ำสะเทิ้นบก",
  T_13_I_COLLECTION_V_JEEP: "รถจิ๊ป",
  T_13_I_COLLECTION_V_MONSTER: "รถบิ๊กฟุต",
  T_13_I_COLLECTION_V_MOTOBIKE: "มอเตอร์ไซค์",
  T_13_I_COLLECTION_V_ROADSTER: "รถสปอร์ต",
  T_13_I_COLLECTION_V_SUV: "รถกระบะ",
  T_13_I_COLLECTION_V_TUTU: "ตุ๊กตุ๊ก",
  T_13_L_MALE_ACCESSORY_COS_BJD: "บลูแมริโอเน็ต",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "ฮาร์ทฟูลบอย",
  T_13_L_MALE_HAIR_COS_BJD: "บลูแมริโอเน็ต",
  T_13_L_MALE_TOP_COS_VALENTINE: "ฮาร์ทฟูลบอย",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "อาวุธ",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "สกินคู่หู : นักสืบมิ้วน้อย",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR - Cupid",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "โมโค",
  T_13_R_EMOTE_BABYSHARK_NAME: "เบบี้ชาร์ค",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "วิดพื้น",
  T_13_R_EMOTE_EGYPT_NAME: "มัมมี่แดนซ์",
  T_13_R_PVE_WEAPON_SLOT: "ช่องอาวุธ",
  T_13_R_PVE_WEAPONSKIN_RANGE: "ระยะหวังผล",
  T_13_R_PVE_WEAPONSKIN_SPEED: "อัตรายิง",
  T_13_R_SKILL_DESC_HACKERGIRL: "แสดงศัตรูที่โมโคยิงให้ทีมเห็นเป็นเวลา [FFB300]{0} วินาที [-]",
  T_13_R_SKILL_NAME_HACKERGIRL: "ไหวพริบแฮคเกอร์",
  T_13_Z_KICKOFF_BAN: "แบน",
  T_13_Z_ROOM_MORNING: "กลางวัน",
  T_13_Z_ROOM_NIGHT: "กลางคืน",
  T_14_G_ITEM_KATANA: "คาตานะ",
  T_14_I_HEADPIC_SONGKRAN_NAME: "สาด!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "กระต่ายเหลี่ยม",
  T_14_L_COS_EASTER: "Observer 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "เลดี้ไฟร์ไฟเตอร์",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "กระต่ายนรก",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47 - Water Balloon",
  T_14_O_DOG_NAME: "เมทัลลักกี้",
  T_14_O_PETSKIN_IRON_DOG_NAME: "สกิน : ไอรอนลักกี้",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "สกิน : ไลท์นิ่งลักกี้",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "สกิน : แมกเน็ตลักกี้",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "สกิน : มิ้วม่วง",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR - จันทราสีเลือด",
  T_14_O_SCAR_SHARK_NAME: "SCAR - Shark Attack",
  T_14_Q_ITEM_RGS50: "RGS-50",
  T_14_R_CHARACTER_SAMURAI_NAME: "ฮายาโตะ",
  T_14_R_SKILL_DESC_SAMURAI: "ทุกครั้งที่พลังชีวิตลดลง [FFB300]{0}%[-] จะเพิ่มการเจาะเกราะขึ้น [FFB300]{1}%[-].",
  T_14_R_SKILL_NAME_SAMURAI: "บูชิโด",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "THE STARVATION",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "THE PLAGUE",
  T_15_L_MALE_BOTTOM_COS_FAIM: "THE STARVATION",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "THE PLAGUE",
  T_15_L_MALE_SHOE_COS_FAIM: "THE STARVATION",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "THE PLAGUE",
  T_15_L_MALE_TOP_COS_FAIM: "THE STARVATION",
  T_15_L_MALE_TOP_COS_PESTILENCE: "THE PLAGUE",
  T_15_L_TOP_COS_MOTHERSDAY: "เบสท์มัมมี่",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - Cataclysm",
  T_15_O_BASEBALLBAT_VIKING_NAME: "ไม้เบสบอล - The Viking",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 - Cataclysm",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - Cataclysm",
  T_15_O_PANTHER_NAME: "ไวโอจากัวร์",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "สกินคู่หู กัปตัน",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "สกินคู่หู โกลเด้นจากัวร์",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "สกินคู่หู ไวโอจากัวร์ II",
  T_15_O_SKS_DEATH_NAME: "SKS- Death Wish",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP - Cataclysm",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "Gatling",
  T_15_R_CHARACTER_AGENT_NAME: "ลอร่า",
  T_15_R_EMOTE_LETSGROOVE_NAME: "เต้นไปด้วยกันเถอะ",
  T_15_R_SKILL_DESC_AGENT: "เมื่อสโคป จะยิงแม่นขึ้น [FFB300]{0}%[-]",
  T_15_R_SKILL_NAME_AGENT: "นักแม่นปืน",
  T_15_W_BACKPACK_MECHGIRL_NAME: "เม็กกะแพ็ก",
  T_16_B_ITEM_GRAPPLINGHOOK: "ตะขอ",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "ปืนยิงตะขอ",
  T_16_L_MALE_COS_LEGO: "เดอะทอย",
  T_16_L_MALE_SHOE_COS_SUMMER: "รองเท้าคลายร้อน",
  T_16_P_MANUAL_MONSTER: "รถบิ๊กฟุต",
  T_16_P_MANUAL_MUSHROOM1: "เห็ด เลเวล 1",
  T_16_P_MANUAL_MUSHROOM2: "เห็ด เลเวล 2",
  T_16_P_MANUAL_MUSHROOM3: "เห็ด เลเวล 3",
  T_16_P_MANUAL_MUSHROOM4: "เห็ด เลเวล 4",
  T_16_P_MANUAL_ROADSTER_DESC: "รถสปอร์ตคาร์สุดคูล HP น้อย แต่เร็วแรงกว่านรก สามารถจุผู้เล่นได้สูงสุด 2 คน",
  T_16_P_MANUAL_STROP: "สลิง",
  T_16_P_MANUAL_SUV: "รถกระบะ",
  T_16_P_MANUAL_SUV_DESC: "ยานพาหนะที่เป็นสัญลักษณ์แห่ง Free Fire มีเกราะปานกลาง และความเร็วที่เต็มเปี่ยม สามารถบรรทุกผู้เล่นได้สูงสุด 2 คน",
  T_16_P_MANUAL_TUTU_DESC: "มี HP และ ความเร็วค่อนข้างต่ำ สามารถจุผู้เล่นได้สูงสุดถึง 3 คน",
  T_16_P_MANUAL_WEAPON_AR: "ปืนไรเฟิล",
  T_16_P_MANUAL_WEAPON_BOMB: "ระเบิด",
  T_16_P_MANUAL_WEAPON_PISTOL: "ปืนพก",
  T_16_P_MANUAL_WEAPON_SG: "ลูกซอง",
  T_16_P_MANUAL_WEAPON_SMG: "ปืนกลเบา",
  T_16_P_MANUAL_WEAPON_SR: "สไนเปอร์",
  T_16_Q_MINISENTRY: "ป้อมปืน",
  T_16_Q_MINISENTRY_DESC: "ป้อมปืนกลอัตโนมัติ เล็งยิงได้เอง",
  T_16_R_EMOTE_DESERT_NAME: "แสลมนรก",
  T_16_R_EMOTE_EPHUNTER_NAME: "พร้อมรบ!",
  T_16_R_EMOTE_EPHUNTER2_NAME: "ตีมือ",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "มูนฟลิป",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "ส่าย ส่าย",
  T_16_W_AK_FIRE_NAME: "AK47 - Flaming Red",
  T_16_W_SCAR_LLENN_NAME: "SCAR - Pink Devil",
  T_16_W_SCAR_WATER_NAME: "SCAR - Water Elemental",
  T_16_Y_CHARACTER_HITMAN_NAME: "ราฟาเอล",
  T_16_Y_PANDA_NAME: "นักสืบแพนด้า",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "สกินคู่หู แพนโด้แบร์",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "สกินคู่หู สกัลแพนด้า",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "สกินคู่หู แพนด้า Bolt",
  T_17_B_CS_MODE_NAME: "โหมด 4v4",
  T_17_C_SKILL_NAME_PLAYBOY: "สปีดรัช",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "รอยัล เจสเตอร์ (หัว)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "บลัดดี้เชอร์รี่ (หน้ากาก)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "บลัดดี้เชอร์รี่ (กางเกง)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "ทรงผมหญิง Selvedgework",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "บลัดดี้เชอร์รี่ (รองเท้า)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "บลัดดี้เชอร์รี่ (เสื้อ)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "บลัดดี้ไวน์ (หน้ากาก)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "ยากูซ่า (กางเกง)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "บลัดดี้ไวน์ (กางเกง)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "แบล็กเคอร์แรนต์ (หัว)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "เดวานี่ (รองเท้า)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "บลัดดี้ไวน์ (รองเท้า)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "บลัดดี้ไวน์ (เสื้อ)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "โกลเด้น แบรนด์ (เสื้อ)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "สกินคู่หู: เจ้าหญิงมิ้วน้อย",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "สกินคู่หู: เรื่องราวแห่งยุคทอง",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "สกินคู่หู: ผู้สืบทอดแห่ง Azure",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "สกินคู่หู: โคตรไอเคี่ยม",
  T_17_O_SHIBA_NAME: "ชิบะ",
  T_17_Q_FOLDWINGS: "เครื่องร่อน",
  T_17_Q_FOLDWINGS_DESC: "อยากลงผาแบบปลอดภัย ลองใช้เครื่องนี้สิ",
  T_17_Q_SUPERHEAT: "PLASMA",
  T_17_R_EMOTE_PARTYDANCE_NAME: "เต้นจนหยดสุดท้าย",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS - Vampire",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR - Phantom Assassin",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR- Old Fashioned",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "โจเซฟ",
  T_17_Z_CS_NAME: "ชื่อ",
  T_17_Z_ROOM_JUMP_SWITCH: "ความสูงเมื่อกระโดด",
  T_17_Z_ROOM_SPEED_SWITCH: "ความเร็วเคลื่อนที่",
  T_18_B_THROWINGKNIFE_NAME: "มีดบิน",
  T_18_C_DUMMY_NAME: "ระเบิดจอมลวง",
  T_18_C_SKILL_DESC_DJMALE: "สร้างออร่ารัศมี [FFB300]{1} เมตร[-] ที่จะเพิ่มความเร็วเคลื่อนที่ [FFB300]{3}%[-] และฟื้นเลือด [FFB300]{2} หน่วยต่อวินาที[-]  เป็นระยะเวลา [FFB300]{0}วินาที[-] เอฟเฟ็กต์ไม่สามารถซ้อนทับได้ คูลดาวน์:[FFB300]{4} วินาที [-]",
  T_18_C_SKILL_NAME_DJMALE: "อาเพคจิโอ้",
  T_18_C_SKILL_NAME_JUNKENGINEER: "สวย สั่ง ซ่อม",
  T_18_L_COS_INDIANEWYEAR: "อสูรแห่งดิวาลี",
  T_18_L_HAIR_COS_HALLOWEEN2019: "หมวกผีดิบ",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "รูบี้ ฮาร์ท (หน้ากาก)",
  T_18_O_FOX_NAME: "จิ้งจอกเงิน",
  T_18_O_PETSKIN_BLACKFOX_NAME: "สกินคู่หู : จิ้งจอกนักสู้",
  T_18_O_PETSKIN_BLUEFOX_NAME: "สกินคู่หู : จิ้งจอกฟ้า",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "สกินคู่หู : ฟักทองไส้ทะลัก",
  T_18_O_PETSKIN_PINKFOX_NAME: "สกินคู่หู : จิ้งจอกแดง",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "สกินคู่หู : จิตวิญญาณ",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1 - Flaming Skull",
  T_18_W_UMP_GEISHA_N: "UMP - Art of War",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "ซานิ",
  T_19_B_HB_NAME: "โฮเวอร์บอร์ด",
  T_19_C_ICE_GUN_NAME: "Ice Gun",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "เพิ่มความเสียหายจากอาวุธประเภทระเบิด [FFB300]{0}%[-] และเพิ่มระยะ [FFB300]{1}%[-]",
  T_19_C_SKILL_DESC_TOMBOY: "ขณะขับยานพาหนะ จะฟื้นฟู HP [FFB300]{1} หน่วย[-]  ทุก ๆ [FFB300]{0} วินาที[-]  สำหรับทุกคนบนยานพาหนะ สูงสุด [FFB300]{2}[-] HP",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "ระเบิดโปรยปราย",
  T_19_C_SKILL_NAME_TOMBOY: "สิงห์นักบิด",
  T_19_I_EVENT_INFI_ITEM: "ไม่จำกัดจำนวน",
  T_19_L_A_ICEFESTIVAL19_B: "รอยยิ้มเรนเดียร์",
  T_19_L_F_S_ICEFESTIVAL: "เมดแซนตี้ (รองเท้า)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "มนต์รักฟีฟาย (กางเกง)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "มนต์รักฟีฟาย (ทรงผม)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "มนต์รักฟีฟาย (เสื้อ)",
  T_19_O_PETSKIN_NAME: "สกินคู่หู : เริ่มต้น",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "สกินคู่หู : แพนด้าแก๊งค์สเตอร์!",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "สกินคู่หู : หมีขั้วโลก",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "สกินคู่หู : ฟาโรห์ โรโบ",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "สกินคู่หู : โรโบแห่งฤดูใบไม้ผลิ",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "สกินคู่หู : โรโบฤดูหนาว",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "สกินคู่หู : ชิบะแก๊งสเตอร์!",
  T_19_O_ROBOT_NAME: "โรโบ",
  T_19_O_TDM_NAME: "ทีมเดธแมตช์",
  T_19_R_EMOTE_MIGUEL_NAME: "เบรคแดนซ์",
  T_19_S_SECOND_WEAPON_TITLE: "อาวุธรอง",
  T_19_S_VEST_TITLE: "เกราะกันกระสุน",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "แมกกาซีนคู่",
  T_19_W_GROZA_TAGGERCREW_N: "GROZA - Tagger's Revolt",
  T_19_W_M60_ICEFESTIVAL_N: "M60 - Santa's Choice",
  T_19_W_MP40_PARK_N: "MP40 - Carnival Carnage",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR - Aurous Dragon",
  T_19_X_PVE_SAMURAINAME: "ผู้พิทักษ์ ซามูไร",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "อัลวาโร่",
  T_19_Y_CHARACTER_TOMBOY_N: "โนโทร่า",
  T_20_C_INHALER_NAME: "Inhaler",
  T_20_C_SKILL_DESC_PARKOURGUY: "เมื่อโจมตีศัตรูด้วยปืนจะฟื้นฟู HP เล็กน้อย หากล้มศัตรูได้จะฟื้นฟู HP  [FFB300]{0}%[-]",
  T_20_C_SKILL_NAME_GRAFFITIST: "กราฟฟิตี้ ชีลด์",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "แฟลชชิ่ง บูลเล็ต",
  T_20_C_SKILL_NAME_PARKOURGUY: "ชาร์จ วัดใจ",
  T_20_L_A_APRILFOOL2020: "ปุ๊กก้าปั๊ก",
  T_20_L_F_A_METALHEAD_RED: "ไซเบอร์-เบลส (หน้ากาก)",
  T_20_L_F_B_THAIGIRL: "อาทิตยา (ล่าง)",
  T_20_L_F_H_KILLERCUPID: "พิงค์ ครัช (หัว)",
  T_20_L_F_H_THAIGIRL: "อาทิตยา (หัว)",
  T_20_L_F_S_THAIGIRL: "อาทิตยา (เท้า)",
  T_20_L_F_T_METALHEAD_RED: "ไซเบอร์-เบลส (บน)",
  T_20_L_F_T_THAIGIRL: "อาทิตยา (บน)",
  T_20_L_JEANDINO: "ยีนส์ก็อตจิ",
  T_20_L_M_A_METALHEAD_RED: "ไซเบอร์-เรจ (หน้ากาก)",
  T_20_L_M_T_METALHEAD_RED: "ไซเบอร์-เรจ (บน)",
  T_20_L_M_T_STOCKING: "วิคตอเรียน (บน)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "สกินคู่หู: จิ้งจอกวาเลนไทน์",
  T_20_P_CHANNEL_G: "แคลน",
  T_20_P_WORLD_SSPEAKER: "โทรโข่ง",
  T_20_S_CSROOM_COIN: "เงินเริ่มต้น",
  T_20_U_SHIELD_GUN_NAME: "Shield Gun",
  T_20_W_AN94_METALHEAD_N: "AN94 - Carrot Imp-Head",
  T_20_W_P90_EVILBONE_N: "P90 - The Punishers",
  T_20_Y_CHARACTER_GRAFFITIST_N: "สเตฟฟี่",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: "เคลลี่ เดอะสวิฟท์ลี่",
  T_20_Y_CHARACTER_PARKOURGUY_N: "โจตา",
  T_21_B_SMOKEGRENADE_DESC: "ระเบิดควัน เหมาะสำหรับกลยุทธ์ขั้นสูง",
  T_21_B_SMOKEGRENADE_NAME: "ระเบิดควัน",
  T_21_C_AUTOPICKUP_AVERAGE: "ปกติ",
  T_21_C_SKILL_DESC_KPOPSINGER: "เมื่อดึงเพื่อน จะมอบโล่ [FFB300]{0} หน่วย [-] และเพิ่มความเร็วเคลื่อนที่ [FFB300]{1}%[-] ให้กับเพื่อนร่วมทีมคนนั้น เอฟเฟ็กต์เพิ่มความเร็วจะลดลงหลังดึงเพื่อนสำเร็จ ใน [FFB300]{2} วิ[-]  และลดอัตราการลดของเลือดของเพื่อนร่วมทีมที่ล้ม [FFB300]{3}%[-]  เอฟเฟ็กต์ไม่สามารถซ้อนทับได้",
  T_21_C_SKILL_DESC_SOCCERSTAR: "เมื่อสังหารจะได้รับ HP สูงสุดเพิ่มขึ้น [FFB300]{0}[-] สูงสุดที่ [FFB300]{1}[-]",
  T_21_C_SKILL_NAME_KPOPSINGER: "ฮีลลิ่งไอดอล",
  T_21_C_SKILL_NAME_SOCCERSTAR: "แฮททริค",
  T_21_L_ANGELICAL: "แองเจิ้ล ก็อดจิ",
  T_21_L_S_VNSLIPPER: "แตะทั่วไป",
  T_21_O_OTTER_NAME: "นากน้อย",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "เรดิโอ แอคทีฟ",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "เลิฟโลลิป๊อป",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "นีออนแคนดี้",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "สกินคู่หู : เพชรฆาตจักรกล",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "สกินคู่หู : อสูรสายฟ้า",
  T_21_R_EMOTE_SORROW_NAME: "ม่ายย",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "กระเป๋า - พังค์สเตอร์",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "Death's Final Strike",
  T_21_W_M79_RABBITKILLER_N: "M79 - Hipster Bunny",
  T_21_W_PAN_VOLCANO_N: "กระทะ - Volcanic Fury",
  T_21_W_XM8_RAINBOW_N: "XM8 - Songkran",
  T_21_Y_CHARACTER_KPOPSINGER_N: "คาเพลลา",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "ลูกุเอต้า",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "แสดงตำแหน่งศัตรูในระยะ [FFB300]{0}[-]  เมตรที่ยืนอยู่ เป็นเวลา [FFB300]{1} วิ[-]  เพื่อนร่วมทีมจะมองเห็นตำแหน่งของศัตรูด้วย คูลดาวน์ [FFB300]{2} วิ[-]",
  T_22_C_SKILL_NAME_DETECTIVE: "สะกดรอย",
  T_22_C_SKILL_NAME_STREAMERGUY: "ล่าค่าหัว",
  T_22_L_F_H_COLLEGE: "เวลเว็ท โวลต์ (ทรงผม)",
  T_22_L_F_S_SUMMER20: "สวีท ซัมเมอร์ (รองเท้า)",
  T_22_L_M_A_GREENCOAT: "GREEN WARMLIGHT (หน้ากาก)",
  T_22_L_M_A_PINKFUR: "PINK.BOY (หน้ากาก)",
  T_22_L_M_A_PLAGUE2: "เพน ออฟ เพล็ก (หน้ากาก)",
  T_22_L_M_B_FAIM2: "บีสต์ ออฟ เด็ธ (กางเกง)",
  T_22_L_M_B_GREENCOAT: "GREEN WARMLIGHT (กางเกง)",
  T_22_L_M_B_PINKFUR: "PINK.BOY (กางเกง)",
  T_22_L_M_B_PLAGUE2: "เพน ออฟ เพล็ก (กางเกง)",
  T_22_L_M_B_REDPANTS: "O(M)G RED HIP (กางเกง)",
  T_22_L_M_B_TIGERSTRIPE: "TIGER CHAMPION (กางเกง)",
  T_22_L_M_H_COLLEGE: "สการ์เล็ต บลาสต์ (ทรงผม)",
  T_22_L_M_H_FAIM2: "บีสต์ ออฟ เด็ธ (ทรงผม)",
  T_22_L_M_H_GREENCOAT: "GREEN WARMLIGHT (ทรงผม)",
  T_22_L_M_H_PINKFUR: "PINK.BOY (ทรงผม)",
  T_22_L_M_H_PLAGUE2: "เพน ออฟ เพล็ก (ทรงผม)",
  T_22_L_M_H_REDPANTS: "O(M)G RED HIP (ทรงผม)",
  T_22_L_M_H_TIGERSTRIPE: "TIGER CHAMPION (ทรงผม)",
  T_22_L_M_S_FAIM2: "บีสต์ ออฟ เด็ธ (รองเท้า)",
  T_22_L_M_S_PLAGUE2: "เพน ออฟ เพล็ก (รองเท้า)",
  T_22_L_M_T_FAIM2: "บีสต์ ออฟ เด็ธ (เสื้อ)",
  T_22_L_M_T_GREENCOAT: "GREEN WARMLIGHT (เสื้อ)",
  T_22_L_M_T_PINKFUR: "PINK.BOY (เสื้อ)",
  T_22_L_M_T_PLAGUE2: "เพน ออฟ เพล็ก (เสื้อ)",
  T_22_L_M_T_REDPANTS: "O(M)G RED HIP (เสื้อ)",
  T_22_L_M_T_TIGERSTRIPE: "TIGER CHAMPION (เสื้อ)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K - Rebel Academy",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "กระทะ - Watermelon",
  T_22_LC_SCAR_HERMIT_N: "SCAR - Mystic Seeker",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "Heal Pistol - Lifebeam",
  T_22_O_HAWK_NAME: "ฟัลโก้",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "สกินคู่หู : จิ้งจอกลวงตา",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "สกินคู่หู : เพลิงโลกันต์ ฟัลโก้",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "สกินคู่หู : เอเวอร์กรีน ฟัลโก้",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "สกินคู่หู : ซันไชน์ ชิบะ",
  T_22_Q_BOMB_PLIERS: "อุปกรณ์กู้ระเบิด",
  T_22_R_EMOTE_SHIMMY_NAME: "ท่าทาง Shimmy",
  T_22_U_GOLD_AWM_N: "AWM - Y",
  T_22_U_WPNSKN_BITE: "เจาะเกราะ",
  T_22_U_WPNSKN_SPEED_RUN: "ความเร็วเคลื่อนที่",
  T_22_Y_CHARACTER_DETECTIVE_N: "คลูว์",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "เข็มชุบชีวิต",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "Art of Blades",
  T_23_C_SKILL_NAME_SWATGUY: "เรดจิ้ง รีโหลด",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: "ฮายาโตะ ไฟร์แบรนด์",
  T_23_D_CHARACTER_SWATGUY_N: "JAI",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Yellow Clap (กางเกง)",
  T_23_L_F_B_MIKOGIRL: "เจ้าหญิงเมฆา (กางเกง)",
  T_23_L_F_B_NAVYGIRL: "เซเลอร์ เกิร์ล (กระโปรง)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Yellow Clap (ทรงผม)",
  T_23_L_F_H_MIKOGIRL: "เจ้าหญิงเมฆา (ทรงผม)",
  T_23_L_F_H_NAVYGIRL: "เซเลอร์ เกิร์ล (ทรงผม)",
  T_23_L_F_S_MIKOGIRL: "เจ้าหญิงเมฆา (รองเท้า)",
  T_23_L_F_S_ORDERCHALLENGER: "เอมเพรส แบร์ (รองเท้า)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Yellow Clap (เสื้อ)",
  T_23_L_F_T_MIKOGIRL: "เจ้าหญิงเมฆา (เสื้อ)",
  T_23_L_F_T_NAVYGIRL: "เซเลอร์ เกิร์ล (เสื้อ)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Yellow Core (หน้ากาก)",
  T_23_L_M_B_FOXGUY: "อสูรเมฆา (กางเกง)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Yellow Core (กางเกง)",
  T_23_L_M_H_FOXGUY: "อสูรเมฆา (ทรงผม)",
  T_23_LC_SKS_GEMINI_N: "SKS - Hysteria",
  T_23_O_PENGUIN_NAME: "พั๊งค์กวิ้น",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "สกินคู่หู : ปาร์ตี้ พั๊งค์กวิ้น",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "สกินคู่หู : ไซเบอร์พั๊งค์ กวิ้น",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "สกินคู่หู : ไชนิ่ง พั๊งค์กวิ้น",
  T_23_T_ANNI3_LOBBY_NODENAME20: "โหมด 4v4",
  T_23_T_ANNI3_LOBBY_NODENAME5: "ตัวละคร",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "คำเตือน",
  T_24_C_FLAMETHROWER_NAME: "Flamethrower",
  T_24_C_SKILL_DESC_PROFESSOR: "EP สูงสุดเพิ่มขึ้น [FFB300]{0}[-] คริมินอลโหมด : เพื่อนร่วมทีมในระยะ [FFB300]{2} เมตร[-] อัตราการเปลี่ยน EP เป็น HP เพิ่มขึ้น [FFB300]{1}%[-] มาสเตอร์ไมด์โหมด : ฟื้นฟู EP [FFB300]{5} หน่วย[-] ทุก ๆ [FFB300]{4} วิ[-] สูงสุดที่ [FFB300]{6} หน่วย[-] คูลดาวน์สลับโหมด [FFB300]{3} วิ[-]",
  T_24_C_SKILL_NAME_PARTYGIRL: "ปาร์ตี้เกิร์ล",
  T_24_C_SKILL_NAME_PROFESSOR: "ศิลปะแห่งอัจฉริยะ",
  T_24_D_CHARACTER_PARTYGIRL_N: "ดาชา",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "กางเกง MAX",
  T_24_L_H_PUMPKIN2020_A: "พั๊มพ์กิ้น สกัล (ทรงผม)",
  T_24_L_T_TSHIRT_COMEDIAN: "วีรบุรุษนัดสุดท้าย",
  T_24_LC_MP5_RICHBOXER_N: "MP5 - Champion Boxer",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR - Party Animal",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD - Swordsman Legends",
  T_24_U_M21A5: "Woodpecker",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "คะแนนรวม",
  T_24_V_TRAINING_BOX_ATTACH: "ของแต่งปืน",
  T_24_V_TRAINING_BOX_WEAPON: "อาวุธ",
  T_24_W_ARMORY: "อาวุธ",
  T_24_W_ARMOTY_MELEE: "อาวุธประชิด",
  T_24_W_ARMOTY_PISTOL: "ปืนพก",
  T_24_W_ARMOTY_RIFLE: "ปืนไรเฟิล",
  T_24_W_ARMOTY_SHOTGUN: "ปืนลูกซอง",
  T_24_W_ARMOTY_SNIPER: "ปืนสไนเปอร์",
  T_24_W_ARMOTY_SPECIAL: "อื่นๆ",
  T_24_W_ARMOTY_SUBMACHINE: "ปืนกลมือ",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "สกินคู่หู : BOOYAH! แพนด้า",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "สกินคู่หู : สเกเลตั้น ร็อคคูน",
  T_24_W_PETSKIN_RACCOON_MECH_N: "สกินคู่หู : ปาร์ตี้ ร็อคคูน",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "สกินคู่หู : อันเด็ด ร็อคคูน",
  T_24_W_RACCOON_N: "ร็อคคูน",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "โครโน่สเฟียร์",
  T_25_D_CHARACTER_BOUNTY_N: "โครโน่",
  T_25_E_HUD_01: "แบบที่ 1",
  T_25_E_HUD_02: "แบบที่ 2",
  T_25_L_F_B_DEMONKILLER: "กระโปรงเพลิงทมิฬ (หญิง)",
  T_25_L_F_H_DEMONKILLER: "ทรงผมเพลิงทมิฬ (หญิง)",
  T_25_L_F_S_DEMONKILLER: "รองเท้าเพลิงทมิฬ (หญิง)",
  T_25_L_F_T_DEMONKILLER: "เสื้อเพลิงทมิฬ (หญิง)",
  T_25_L_HA_FP_EVIL: "ปีศาจ (ลายเพ้นท์)",
  T_25_L_M_H_ANIMEHAIR: "เมฆทมิฬ (ทรงผม)",
  T_25_L_S_MAXSNEAKERS: "MAX สนิกเกอร์",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "ไม้เบสบอล - Cyber Swing",
  T_25_LC_GLOO_WINTERFEST2020_N: "ไอซ์วอลล์ - Winterlands 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887 - Winterlands 2020",
  T_25_LC_MACHETE_BOUNTY_N: "Cyber Blade",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90 - Tune Blaster Green",
  T_25_LC_P90_MUSICFALL_RED_N: "P90 - Tune Blaster Red",
  T_25_LC_PAN_BOUNTY_N: "กระทะ - Cyber Bounty Hunter",
  T_25_R_LEGEND_REMIND: "แจ้งเตือน",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "เคียว",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "บีสตั้น",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "สกินคู่หู : ฟรอส คิง",
  T_25_W_PETSKIN_BABOON_HELL_N: "สกินคู่หู : ราชันย์เพลิงโลกันต์",
  T_25_W_PETSKIN_BABOON_PURE_N: "สกินคู่หู : เดอะเกรท บีสตั้น",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "สกินคู่หู : ฟรอสคิง",
  T_25_Z_R_SIMULATOR_OFF: "ไม่อนุญาติ",
  T_26_C_SKILL_DESC_SUPERSTAR: "ปลดปล่อยคลื่นเสียงออกไปด้านหน้า [FFB300]{0} เมตร[-] ทำให้สิ่งกีดขวางที่โดนคลื่นเสียงระเบิดออก สร้างความเสียหายให้กับไอซ์วอลล์ในรัศมี [FFB300]{1} เมตร[-] เป็นเวลา [FFB300]{2} วินาที[-] คูลดาวน์ [FFB300]{3} วินาที[-]",
  T_26_C_SKILL_NAME_SUPERSTAR: "ริปไทด์ ริทึ่ม",
  T_26_D_CHARACTER_DELIVERY_N: "ชิโร่",
  T_26_D_CHARACTER_SUPERSTAR_N: "สกายเลอร์",
  T_26_ET_CELLPHONE_NAME: "โดรน",
  T_26_L_A_FLAMING_PREM: "ไฟเออร์ เรมแนนท์ (หน้ากาก)",
  T_26_L_A_SANTAMODE: "สโนวแมน บ็อบ (หน้ากาก)",
  T_26_L_B_SANTAMODE: "สโนวแมน บ็อบ (กางเกง)",
  T_26_L_F_B_WATERFEST21_A: "ซัมเมอร์ บลีซ (กางเกง)",
  T_26_L_F_H_WATERFEST21_A: "ซัมเมอร์ บลีซ (ทรงผม)",
  T_26_L_F_S_WATERFEST21_A: "ซัมเมอร์ บลีซ (รองเท้า)",
  T_26_L_F_T_WATERFEST21_A: "ซัมเมอร์ บลีซ (เสื้อ)",
  T_26_L_M_A_EGGDAY2021: "บันนี่ อิเลคโทร (ช) (หน้ากาก)",
  T_26_L_M_B_EGGDAY2021: "บันนี่ อิเลคโทร (ช) (กางเกง)",
  T_26_L_M_B_PAIRING: "ชุดแต่งงาน (ช) (กางเกง)",
  T_26_L_M_B_WATERFEST21_A: "ซัมเมอร์ เวฟ (กางเกง)",
  T_26_L_M_H_EGGDAY2021: "บันนี่ อิเลคโทร (ช) (ทรงผม)",
  T_26_L_M_H_PAIRING: "ชุดแต่งงาน (ช) (ทรงผม)",
  T_26_L_M_H_WATERFEST21_A: "ซัมเมอร์ เวฟ (ทรงผม)",
  T_26_L_M_S_EGGDAY2021: "บันนี่ อิเลคโทร (ช) (รองเท้า)",
  T_26_L_M_S_PAIRING: "ชุดแต่งงาน (ช) (รองเท้า)",
  T_26_L_M_S_WATERFEST21_A: "ซัมเมอร์ เวฟ (รองเท้า)",
  T_26_L_M_T_EGGDAY2021: "บันนี่ อิเลคโทร (ช) (เสื้อ)",
  T_26_L_M_T_PAIRING: "ชุดแต่งงาน (ช) (เสื้อ)",
  T_26_L_M_T_WATERFEST21_A: "ซัมเมอร์ เวฟ (เสื้อ)",
  T_26_L_S_SANTAMODE: "สโนวแมน บ็อบ (รองเท้า)",
  T_26_L_T_SANTAMODE: "สโนวแมน บ็อบ (เสื้อ)",
  T_26_LC_AWM_KOICARP_N: "AWM - Lucky Koi",
  T_26_LC_KATANA_VALENTINE2021_N: "คาตานะ - Season of Pink",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Sports Car - Cobra",
  T_26_P_SKILL_NAME_DELIVERY: "ดาเมจ เดลิเวอร์เร็ด",
  T_26_V_TRAINING_BHH: "ค้อนมหัศจรรย์",
  T_26_V_TRAINING_DICE: "ลูกเต๋ายักษ์",
  T_26_W_DRAGON_N: "เดรกิ",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "สกินคู่หูเดรกิ : คิง ออฟ ซี",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "สกินคู่หูเดรกิ : ธันเดอร์ ลอร์ด",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "สกินคู่หูเดรกิ : ดราก้อน กาแลคซี่",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "สกินคู่หู : พั๊งค์กวิ้น อิน เลิฟ",
  T_26_XL_SETTING_TEAMMATE_INFO: "รายละเอียดเพื่อนร่วมทีม",
  T_26_YP_HISTORY_WIN: "ชนะ",
  T_26_YP_SOCIAL_GENDER_FEMALE: "หญิง",
  T_26_YP_SOCIAL_GENDER_MALE: "ชาย",
  T_26_YP_SOCIAL_NAME: "ชื่อเล่น",
  T_27_C_SKILL_DESC__RACERGIRL: "ขณะขับรถเพิ่มความเร็วรถ [FFB300]{0}%[-]  และผู้เล่นตกเป็นเป้าหมายยากขึ้น ลดความเสียหายที่ได้รับขณะขับรถลง [FFB300]{1}%[-]",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "สร้างสนามพลังป้องกันความเสียหาย [FFB300]{0} หน่วย[-] จากศัตรู และไม่สามารถโจมตีศัตรูภายนอกจากด้านในวงได้ เป็นระยะเวลา [FFB300]{1} วิ[-] คูลดาวน์ [FFB300]{2} วิ[-]",
  T_27_C_SKILL_DESC_FALCONER: "เพิ่มความเสียหายตามระยะห่าง สูงสุด [FFB300]{0}%[-] ศัตรูที่ติดสถานะ มาร์ค จะโดนความเสียหายเพิ่มขึ้น [FFB300]{1}%[-]",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "ปลุกพลัง: ลดความเสียหายด้านหน้า {1}% สำหรับทุกๆ {0}% ของ HP ที่สูญเสียไป",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "สกิลปลุกพลัง : วิ่งเป็นระยะเวลา [FFB300]{0} วิ[-]  เพื่อเปิดใช้งาน เมื่อสกิลทำงาน ความเสียหาย [FFB300]{2}[-] ครั้งแรกที่ถูกเป้าหมาย ทำความเสียหายเพิ่มเติม [FFB300]{1}%[-]  เป็นระยะเวลา [FFB300]{3}วิ[-]",
  T_27_C_SKILL_NAME_FALCONER: "ฟัลคอน เฟอร์เวอร์",
  T_27_C_SKILL_NAME_XTREME: "เอ็กซ์ตรีม เอนเคาท์เตอร์",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: "แอนดรูว์ เดอะเฟียส",
  T_27_D_CHARACTER_FALCONER_N: "มาโร่",
  T_27_D_CHARACTER_XTREME_N: "เซน",
  T_27_F_EAP_PKG3_D: "ต่อสู้ อย่างมีสไตล์!",
  T_27_HYL_SKILLBOARD_HP: "HP",
  T_27_L_A_CARDBOARD_MID2: "ฟิวรี่ ไทเกอร์ (หน้ากาก)",
  T_27_L_B_CARDBOARD_REG: "เลซี่ แบร์ (กางเกง)",
  T_27_L_M_S_KAZAKHSTAN: "เดอะ บากาเตอร์ (รองเท้า)",
  T_27_L_S_CARDBOARD_REG: "เลซี่ แบร์ (รองเท้า)",
  T_27_L_T_CARDBOARD_REG: "เลซี่ แบร์ (เสื้อ)",
  T_27_LC_VECTOR_FFWS2021_N: "Vector - FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "รถบิ๊กฟุต - FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "Motor Bike - K.O. Night",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "รถสปอร์ต - Emerald Flash",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "รถกระบะ - Flame Draco",
  T_27_P_SKILL_NAME_HITMAN_RE: "สังหารเงียบ",
  T_27_R_EMOTE_GREETING_NAME: "สวัสดี",
  T_27_R_VEHICLE_ACCELERATION: "อัตราเร่ง",
  T_27_R_VEHICLE_HP: "ความทนทาน",
  T_27_R_VEHICLE_SPEED: "ความเร็วสูงสุด",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "การปลุกพลัง: ลดความเสียหายจากเกราะเพิ่มขึ้น [FFB300]{0}%[-]. ลดความเสียหายเพิ่มเติม [FFB300]{1}%[-] สำหรับเพื่อนร่วมทีมแต่ละคนภายในระยะ [FFB300]{2} ม.[-]",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "วูล์ฟแพ็ก",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "มูนี่",
  T_27_W_ARMOTY_DMR: "ปืนไรเฟิลซุ่มยิง",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "สกินคู่หู : คริสตัล มูนี่",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "สกินคู่หู : เกมเมอร์ มูนี่",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "สกินคู่หู : ฮิปสเตอร์ มูนี่",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "สกินคู่หู : หมาน้อย FFWS 2021",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "สกินคู่หู : แพนด้า FFWS 2021",
  T_27_XC_REPLAY_DIE: "ตาย",
  T_27_XC_REPLAY_KILL: "สังหาร",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "ซ่อมแซม",
  T_28_C_G_ICE_NAME: "ระเบิดน้ำแข็ง",
  T_28_C_SKILL_DESC_STREETBEAT: "เมื่อยิงขณะเคลื่อนที่ ความเร็วเคลื่อนที่เพิ่มขึ้น [FFB300]{0}%[-] ความแม่นยำเพิ่มขึ้น [FFB300]{1}%[-]",
  T_28_C_SKILL_NAME_STREETBEAT: "บูลเล็ต บีสท์",
  T_28_D_CHARACTER_STREETBEAT_N: "ดี-บี",
  T_28_HI_UZI: "Mini Uzi",
  T_28_L_B_BRJERSEY_A: "เสื้อนักฟุตบอล หมายเลข 23 (กางเกง)",
  T_28_L_B_BRJERSEY_B: "เสื้อนักฟุตบอล หมายเลข 10 (กางเกง)",
  T_28_L_B_BRJERSEY_C: "เสื้อนักฟุตบอล หมายเลข 24 (กางเกง)",
  T_28_L_B_BRJERSEY_D: "เสื้อนักฟุตบอล หมายเลข 30 (กางเกง)",
  T_28_L_B_BRJERSEY_E: "เสื้อนักฟุตบอล หมายเลข 1 (กางเกง)",
  T_28_L_B_BRJERSEY_F: "เสื้อนักฟุตบอล หมายเลข 20 (กางเกง)",
  T_28_L_F_B_FOURSYMBOLS_C: "ซูซาคุ หงส์แดงสวรรค์ (กางเกง)",
  T_28_L_F_H_FOURSYMBOLS_C: "ซูซาคุ หงส์แดงสวรรค์ (ทรงผม)",
  T_28_L_F_HA_FOURSYMBOLS_C: "ซูซาคุ หงส์แดงสวรรค์ (ลายเพ้นท์)",
  T_28_L_F_S_FOURSYMBOLS_C: "ซูซาคุ หงส์แดงสวรรค์ (รองเท้า)",
  T_28_L_F_T_FOURSYMBOLS_C: "ซูซาคุ หงส์แดงสวรรค์ (เสื้อ)",
  T_28_L_HA_THUNDER: "ดวงตาอัสนี (ลายเพ้นท์)",
  T_28_L_M_A_SPORTSUIT: "บอลซี่ สเก็ตบอย (หน้ากาก)",
  T_28_L_M_B_FOURSYMBOLS_D: "เกนบุ เต่าดำสวรรค์ (กางเกง)",
  T_28_L_M_B_SPORTSUIT: "บอลซี่ สเก็ตบอย (กางเกง)",
  T_28_L_M_H_FOURSYMBOLS_D: "เกนบุ เต่าดำสวรรค์ (ทรงผม)",
  T_28_L_M_H_SPORTSUIT: "บอลซี่ สเก็ตบอย (ทรงผม)",
  T_28_L_M_S_FOURSYMBOLS_D: "เกนบุ เต่าดำสวรรค์ (รองเท้า)",
  T_28_L_M_S_SPORTSUIT: "บอลซี่ สเก็ตบอย (รองเท้า)",
  T_28_L_M_T_FALLWINTER: "พิ๊งค์ สแว็กเกอร์ (เสื้อ)",
  T_28_L_M_T_FOURSYMBOLS_D: "เกนบุ เต่าดำสวรรค์ (เสื้อ)",
  T_28_L_M_T_SPORTSUIT: "บอลซี่ สเก็ตบอย (เสื้อ)",
  T_28_L_T_BRJERSEY_A: "เสื้อนักฟุตบอล หมายเลข 23 (เสื้อ)",
  T_28_L_T_BRJERSEY_B: "เสื้อนักฟุตบอล หมายเลข 10 (เสื้อ)",
  T_28_L_T_BRJERSEY_C: "เสื้อนักฟุตบอล หมายเลข 24 (เสื้อ)",
  T_28_L_T_BRJERSEY_D: "เสื้อนักฟุตบอล หมายเลข 30 (เสื้อ)",
  T_28_L_T_BRJERSEY_E: "เสื้อนักฟุตบอล หมายเลข 1 (เสื้อ)",
  T_28_L_T_BRJERSEY_F: "เสื้อนักฟุตบอล หมายเลข 20 (เสื้อ)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94 - Ruby Bride",
  T_28_LC_GLOO_FALLWINTER_N: "ไอซ์วอลล์ - บีท เรนโบว์",
  T_28_LC_GLOO_FOURSYMBOLS_N: "ไอซ์วอลล์ - กำแพงมังกร",
  T_28_LC_KORD_SHINOBI_N: "Kord - Killspark Shinobi",
  T_28_LC_M21A5_FANTASYEYE_N: "Woodpecker - Merciless Necromancer",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - Lethal Finstooth",
  T_28_LC_PAN_FOURSYMBOLS_N: "กระทะ - เกราะสวรรค์",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "รถจี๊ป - Stormbringer",
  T_28_T_WS_ITEM1: "กล่องไม้",
  T_28_T_WS_ITEM10: "กระท่อม",
  T_28_T_WS_ITEM11: "หอรักษาการณ์",
  T_28_T_WS_ITEM12: "อาคารพักแรม",
  T_28_T_WS_ITEM13: "บ้านแบบที่ 1",
  T_28_T_WS_ITEM14: "บ้านแบบที่ 2",
  T_28_T_WS_ITEM15: "บ้านแบบที่ 3",
  T_28_T_WS_ITEM16: "รูปปั้นทราย",
  T_28_T_WS_ITEM17: "น้ำพุ",
  T_28_T_WS_ITEM18: "ต้นซากุระ",
  T_28_T_WS_ITEM19: "ต้นกล้วย",
  T_28_T_WS_ITEM2: "กล่องไม้ยาว",
  T_28_T_WS_ITEM20: "ชักโครก",
  T_28_T_WS_ITEM21: "รั้ว",
  T_28_T_WS_ITEM3: "พุ่มไม้",
  T_28_T_WS_ITEM4: "กองฟาง",
  T_28_T_WS_ITEM5: "รถ",
  T_28_T_WS_ITEM6: "รถบัส",
  T_28_T_WS_ITEM7: "คอนเทนเนอร์แบบที่ 1",
  T_28_T_WS_ITEM8: "คอนเทนเนอร์แบบที่ 2",
  T_28_T_WS_ITEM9: "คอนเทนเนอร์แบบที่ 3",
  T_28_T_WS_TYPE1: "วัตถุ",
  T_28_T_WS_TYPE4: "ของตกแต่ง",
  T_28_W_DUCK_N: "ดร.บีนนี่",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "สกินคู่หู : มังกรสวรรค์ เดรกิ",
  T_28_W_PETSKIN_DUCK_ARMY_N: "สกินคู่หู : จ่าบีนนี่",
  T_28_W_PETSKIN_DUCK_BLACK_N: "สกินคู่หู : บีนนี่เดอะบอส",
  T_28_W_PETSKIN_DUCK_SHINY_N: "สกินคู่หู : ดีเจ บีนนี่",
  T_28_YF_AR15: "Kingfisher",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "ปลุกพลัง : หากศัตรูถูกมาร์คและเคลื่อนไหว มาร์คจะอยู่นานขึ้น สูงสุด  [FFB300]{0} วินาที[-]",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "Enigma's Eye",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "นักร้องดาวรุ่ง",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "จังหวะหัวใจ",
  T_29_D_CHARACTER_AMOCO_N: 'โมโค่ "อีนิกม่า"',
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "Striped Soccer Jersey (กางเกง)",
  T_29_L_M_A_FALCONER_C: "Moody Lavisher (หน้ากาก)",
  T_29_L_M_A_JUNGLE_GREEN: "Camou War-Turtle (หน้ากาก)",
  T_29_L_M_B_FALCONER_C: "Moody Lavisher (กางเกง)",
  T_29_L_M_B_JUNGLE_GREEN: "Camou War-Turtle (กางเกง)",
  T_29_L_M_H_FALCONER_C: "Moody Lavisher (ทรงผม)",
  T_29_L_M_H_JUNGLE_GREEN: "Camou War-Turtle (ทรงผม)",
  T_29_L_M_S_FALCONER_C: "Moody Lavisher (รองเท้า)",
  T_29_L_M_S_JUNGLE_GREEN: "Camou War-Turtle (รองเท้า)",
  T_29_L_M_T_FALCONER_C: "Moody Lavisher (เสื้อ)",
  T_29_L_M_T_JUNGLE_GREEN: "Camou War-Turtle (เสื้อ)",
  T_29_L_T_TRJERSEY: "Striped Soccer Jersey (เสื้อ)",
  T_29_M_WS_ITEM22: "คอนเทนเนอร์ผุพัง",
  T_29_M_WS_ITEM23: "รั้วผุพัง",
  T_29_M_WS_ITEM24: "จุดเกิด A",
  T_29_M_WS_ITEM25: "จุดเกิด B",
  T_29_M_WS_TYPE5: "ไอเทมพิเศษ",
  T_29_W_PETSKIN_BROWN_TIGER_N: "สกินคู่หู : เจ้าวรยุทธ์ดิน",
  T_29_W_PETSKIN_FIRE_TIGER_N: "สกินคู่หู : เจ้าวรยุทธ์ไฟ",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "สกินคู่หู : ไซเบอร์ ฟัลโก้",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "สกินคู่หู : ปาร์ตี้แพนด้า",
  T_29_W_PETSKIN_WHITE_TIGER_N: "สกินคู่หู : เจ้าวรยุทธ์น้ำแข็ง",
  T_29_W_TIGER_NINJA_N: "ปรมาจารย์ ทิก",
  T_29_YF_MACHETE_MUSICFEST_N: "Soundwave Thrasher",
  T_29_YF_MAGEZINE_CHAIN_N: "แมกกาซีนปืนกล",
  T_29_YF_MUZZLE_CRASH_N: "ปากปืนปืนกลมือ",
  T_29_YF_MUZZLE_WIDE_N: "ปากปืนลูกซอง",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12 - Cosmic Teleportia",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi - Amber Megacypher",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "รถบิ๊กฟุต - Gnawing Rager",
  T_30_AD_RP_ROUNDEND: "END OF ROUND",
  T_30_AD_TRAINING_SNOWBALL: "บอลหิมะ",
  T_30_AD_TRAINING_SNOWBALL_DES: "มาปาบอลหิมะกันเถอะ!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}วินาที[-] หลังจากถูกโจมตี จะฟื้นฟู [FFB300]{1}HP[-] ต่อวินาที เป็นเวลา [FFB300]{2} วินาที[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "เสียงของผู้ชนะ",
  T_30_C_SKILL_NAME_MUERTOGUY: "หมอกแห่งความทรงจำ",
  T_30_D_CHARACTER_BOOYAHGUY_N: "ลีออน",
  T_30_D_CHARACTER_MUERTOGUY_N: "ออโท",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Jai ไมโครชิป",
  T_30_L_A_BRMASCOT_ADULT: "เจ้าไก่ขี้โมโห",
  T_30_L_A_BRMASCOT_KIDS: "เจ้าไก่อารมณ์ดี",
  T_30_L_A_SUGARSKULL21_BANDANA: "หน้ากากแห่งความตาย",
  T_30_L_B_BRFOOTBALL_BLACK: "CBF Soccer Jersey - Black (กางเกง)",
  T_30_L_B_BRFOOTBALL_GREEN: "CBF Soccer Jersey - Green (กางเกง)",
  T_30_L_B_BRFOOTBALL_GREY: "CBF Soccer Jersey - Gray (กางเกง)",
  T_30_L_B_BRUNIFORM: "Little Canary (กางเกง)",
  T_30_L_F_A_SUGARSKULL21: "Goldrim Queen (หน้ากาก)",
  T_30_L_F_B_SUGARSKULL21: "Goldrim Queen (กางเกง)",
  T_30_L_F_B_THASIAN: "Coral Trouble (กางเกง)",
  T_30_L_F_H_CATEARS: "หูแมว",
  T_30_L_F_H_SUGARSKULL21: "Goldrim Queen (ทรงผม)",
  T_30_L_F_H_THASIAN: "Coral Trouble (ทรงผม)",
  T_30_L_F_S_SUGARSKULL21: "Goldrim Queen (รองเท้า)",
  T_30_L_F_S_THASIAN: "Coral Trouble (รองเท้า)",
  T_30_L_F_T_SUGARSKULL21: "Goldrim Queen (เสื้อ)",
  T_30_L_F_T_THASIAN: "Coral Trouble (เสื้อ)",
  T_30_L_H_CHILDRENSDAY_BLUE: "หมวกโลมา",
  T_30_L_H_CHILDRENSDAY_RED: "หมวกเจ้าช้าง",
  T_30_L_H_CLOWNHAT: "Circus Hat - Yellow",
  T_30_L_H_ZASCARF: "ผ้าพันคอ Bold Gold",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Desi Gangster (หน้ากาก)",
  T_30_L_M_A_SUGARSKULL21: "Goldrim King (หน้ากาก)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Desi Gangster (กางเกง)",
  T_30_L_M_B_PKCRICKET: "Champ In Green (กางเกง)",
  T_30_L_M_B_SUGARSKULL21: "Goldrim King (กางเกง)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Wind Racer (กางเกง)",
  T_30_L_M_B_THASIAN: "Coral Rebel (กางเกง)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Desi Gangster (ทรงผม)",
  T_30_L_M_H_SUGARSKULL21: "Goldrim King (ทรงผม)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Wind Racer (ทรงผม)",
  T_30_L_M_H_THASIAN: "Coral Rebel (ทรงผม)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "Alpha Flameborn (ลายเพ้นท์)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Desi Gangster (รองเท้า)",
  T_30_L_M_S_PKCRICKET: "Champ In Green (รองเท้า)",
  T_30_L_M_S_SUGARSKULL21: "Goldrim King (รองเท้า)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Wind Racer (รองเท้า)",
  T_30_L_M_S_THASIAN: "Coral Rebel (รองเท้า)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Desi Gangster (เสื้อ)",
  T_30_L_M_T_PKCRICKET: "Champ In Green (เสื้อ)",
  T_30_L_M_T_SUGARSKULL21: "Goldrim King (เสื้อ)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Wind Racer (เสื้อ)",
  T_30_L_M_T_THASIAN: "Coral Rebel (เสื้อ)",
  T_30_L_S_BRUNIFORM: "Little Canary (รองเท้า)",
  T_30_L_T_BRFOOTBALL_BLACK: "CBF Soccer Jersey - Black (เสื้อ)",
  T_30_L_T_BRFOOTBALL_GREEN: "CBF Soccer Jersey - Green (เสื้อ)",
  T_30_L_T_BRFOOTBALL_GREY: "CBF Soccer Jersey - Gray (เสื้อ)",
  T_30_L_T_BRUNIFORM: "Little Canary (เสื้อ)",
  T_30_M_WS_PARTY_MODE: "สนามเด็กเล่น",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "Challenger",
  T_30_R_EMOTE_MAX_NAME: "Rap Swag",
  T_30_R_LEGEND_HALO_NAME: "Circle of Heat",
  T_30_T_WS_DEFAULTDESCRIPTION: "แผนที่สุดบรรเจิด จากคราฟท์แลนด์",
  T_30_T_WS_ITEM26: "ยาง",
  T_30_T_WS_ITEM27: "ยางที่ไม่สมบูรณ์ A",
  T_30_T_WS_ITEM28: "ยางที่ไม่สมบูรณ์ B",
  T_30_T_WS_ITEM29: "ยางที่ไม่สมบูรณ์ C",
  T_30_T_WS_ITEM30: "รถบั๊มพ์",
  T_30_T_WS_ITEM31: "รถสะเทิ้นน้ำสะเทิ้นบก",
  T_30_T_WS_ITEM32: "รถจิ๊ป",
  T_30_T_WS_ITEM33: "ถังขยะ",
  T_30_T_WS_ITEM34: "เงา",
  T_30_T_WS_ITEM35: "เต้นท์พยาบาล",
  T_30_T_WS_ITEM36: "โรงรถ",
  T_30_T_WS_ITEM37: "กำแพงที่ถูกตกแต่ง",
  T_30_T_WS_ITEM38: "ประตูศาลเจ้า",
  T_30_T_WS_ITEM39: "แผ่นเหล็ก",
  T_30_T_WS_ITEM40: "กระท่อมขนาดเล็ก",
  T_30_T_WS_ITEM41: "เทรลเลอร์",
  T_30_T_WS_ITEM42: "กำแพง A",
  T_30_T_WS_ITEM43: "กำแพง B",
  T_30_T_WS_ITEM44: "กำแพง C",
  T_30_T_WS_ITEM45: "กำแพง D",
  T_30_T_WS_ITEM46: "กำแพง E",
  T_30_T_WS_ITEM47: "กำแพง F",
  T_30_U_ATTACHMENT_1: "ไอเทมเพิ่มโล่",
  T_30_U_ATTACHMENT_4: "ส่วนขยายเสื้อเกราะ",
  T_30_U_ATTACHMENT_5: "แผ่นเหล็กสองชั้นเสริมหมวก",
  T_30_U_ATTACHMENT_6: "แผ่นเหล็กหนาเสริมเกราะ",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "สกินคู่หู : Skull Beaston",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "สกินคู่หู : สแว๊กกวิ้น",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "สกินคู่หู : Bullseye Agent Hop",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "สกินคู่หู : Carnival Agent Hop",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "สกินคู่หู : Cyber Agent Hop",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "สกินคู่หู : Nazar Robo",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "สกินคู่หู : Green Freeze Robo",
  T_30_W_RABBIT_N: "เจ้าหน้าที่ ฮ็อป",
  T_30_XH_PCMAP_P17: "โรงงาน",
  T_30_YF_GLOO_BOOYAHDAY21_N: "ไอซ์วอลล์ - BOOYAH DAY 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "ระเบิด - BOOYAH DAY 2021",
  T_30_YF_Healinggun_Sniper_N: "ปืนสไนเปอร์ฟื้นฟู",
  T_30_YF_MINI_LIGHTFEST_N: "AC80 - Royal Warrior",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL - Crimson Heir",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR - Royal Warrior",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson - Goldrim Tribute",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "รถสปอร์ต - Skull Punker",
  T_31_C_SKILL_NAME_WINTERGUY: "ไอซ์วอลล์แกร่ง",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "ไม้เบสบอล - Winter Basher",
  T_31_HQ_GLOO_EAGLE_N: "ไอซ์วอลล์ - Heatbound Desert",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "Heal Sniper - Ice Bones",
  T_31_HQ_KATANA_WINTERFEST21_N: "คาตานะ - Snow Doom",
  T_31_HQ_PAN_WINTERFEST21_N: "กระทะ - Snow Doom",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "สกินคู่หู : Snow Ottero",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "สกินคู่หู : Waggor On Ice",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "สกินคู่หู : Tribal Yeti",
  T_31_HQ_PETSKIN_YETI_RED_N: "สกินคู่หู : Fiery Yeti",
  T_31_HQ_SICKLE_WINTERFEST21_N: "เคียว - Scythe of Snow",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "มอเตอร์ไซค์ - Ice Blossoms",
  T_31_HQ_YETI_N: "เยติ",
  T_31_KK_WINTER_BUJIX: "กล่องซัปพลาย",
  T_31_KK_WINTER_SANJITOU: "หมวก",
  T_31_L_A_BDCRICKET: "Victory Batter (หน้ากาก)",
  T_31_L_A_WINTERFEST21: "Reindeer Cover",
  T_31_L_B_BDCRICKET: "Victory Batter (กางเกง)",
  T_31_L_B_MEJERSEY_10: "No. 10 Ruby Jersey (กางเกง)",
  T_31_L_B_MEJERSEY_11: "No. 11 Red Jersey (กางเกง)",
  T_31_L_B_MEJERSEY_13: "No. 13 White Jersey (กางเกง)",
  T_31_L_B_MEJERSEY_18G: "No. 18 Green Jersey (กางเกง)",
  T_31_L_B_MEJERSEY_18R: "No. 18 Maroon Jersey (กางเกง)",
  T_31_L_B_MEJERSEY_7: "No. 7 Basil Jersey (กางเกง)",
  T_31_L_F_B_RUMUSICIAN: "Strapped Trance (กางเกง)",
  T_31_L_F_B_THAGENT: "Night Provocateur (กางเกง)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Tie Dye Bucket",
  T_31_L_F_H_RUMUSICIAN: "Strapped Trance (ทรงผม)",
  T_31_L_F_H_THAGENT: "Night Provocateur (ทรงผม)",
  T_31_L_F_HA_RUMUSICIAN: "Strapped Trance (ลายเพ้นท์)",
  T_31_L_F_S_RUMUSICIAN: "Strapped Trance (รองเท้า)",
  T_31_L_F_S_THAGENT: "Night Provocateur (รองเท้า)",
  T_31_L_F_T_RUMUSICIAN: "Strapped Trance (เสื้อ)",
  T_31_L_F_T_THAGENT: "Night Provocateur (เสื้อ)",
  T_31_L_HA_RUMUSICIAN_MU: "Strap Trap (ลายเพ้นท์)",
  T_31_L_HA_WINTERFEST21_BLUE: "Frozen Clown (ลายเพ้นท์)",
  T_31_L_HA_WINTERFEST21_PINK: "Pink Firesparks (ลายเพ้นท์)",
  T_31_L_M_A_REGGAETON_B: "Neon Reggaeton (หน้ากาก)",
  T_31_L_M_A_REGGAETON_P: "Vibrant Vanity (หน้ากาก)",
  T_31_L_M_A_RUMUSICIAN: "Strapped Trap (หน้ากาก)",
  T_31_L_M_A_THAGENT: "Night Scouter (หน้ากาก)",
  T_31_L_M_B_PKCOSTUME: "Smart in Green (กางเกง)",
  T_31_L_M_B_REGGAETON_B: "Neon Reggaeton (กางเกง)",
  T_31_L_M_B_REGGAETON_P: "Vibrant Vanity (กางเกง)",
  T_31_L_M_B_RUMUSICIAN: "Strapped Trap (กางเกง)",
  T_31_L_M_B_THAGENT: "Night Scouter (กางเกง)",
  T_31_L_M_H_GREENCAP: "Winner Cap",
  T_31_L_M_H_PKCOSTUME: "Smart in Green (ทรงผม)",
  T_31_L_M_H_REGGAETON_B: "Neon Reggaeton (ทรงผม)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Tie Dye Hat",
  T_31_L_M_H_REGGAETON_P: "Vibrant Vanity (ทรงผม)",
  T_31_L_M_H_RUMUSICIAN: "Strapped Trap (ทรงผม)",
  T_31_L_M_H_THAGENT: "Night Scouter (ทรงผม)",
  T_31_L_M_S_PKCOSTUME: "Smart in Green (รองเท้า)",
  T_31_L_M_S_REGGAETON_B: "Neon Reggaeton (รองเท้า)",
  T_31_L_M_S_REGGAETON_P: "Vibrant Vanity (รองเท้า)",
  T_31_L_M_S_RUMUSICIAN: "Strapped Trap (รองเท้า)",
  T_31_L_M_S_THAGENT: "Night Scouter (รองเท้า)",
  T_31_L_M_T_PKCOSTUME: "Smart in Green (เสื้อ)",
  T_31_L_M_T_REGGAETON_B: "Neon Reggaeton (เสื้อ)",
  T_31_L_M_T_REGGAETON_P: "Vibrant Vanity (เสื้อ)",
  T_31_L_M_T_REGGAETON_TATOO: "Familia Ink",
  T_31_L_M_T_RUMUSICIAN: "Strapped Trap (เสื้อ)",
  T_31_L_M_T_THAGENT: "Night Scouter (เสื้อ)",
  T_31_L_S_BDCRICKET: "Victory Batter (รองเท้า)",
  T_31_L_T_BDCRICKET: "Victory Batter (เสื้อ)",
  T_31_L_T_BRBANK: "Maroon Bomber",
  T_31_L_T_MEJERSEY_10: "No. 10 Ruby Jersey (เสื้อ)",
  T_31_L_T_MEJERSEY_11: "No. 11 Red Jersey (เสื้อ)",
  T_31_L_T_MEJERSEY_13: "No. 13 White Jersey (เสื้อ)",
  T_31_L_T_MEJERSEY_18G: "No. 18 Green Jersey (เสื้อ)",
  T_31_L_T_MEJERSEY_18R: "No. 18 Maroon Jersey (เสื้อ)",
  T_31_L_T_MEJERSEY_7: "No. 7 Basil Jersey (เสื้อ)",
  T_31_L_T_PKMOBILE: "เสื้อยืด Infinix",
  T_31_L_T_REGGAETON_HOOD: "เสื้อฮู๊ด Gang Smile",
  T_31_MF_CHARACTER_WINTERGUY_N: "ไนริ",
  T_31_R_EMOTE_FALCONER_NAME: "Number 1",
  T_31_RW_COMBINEMACHINE_2: "Akimbo Activator (ระดับสูง)",
  T_31_RW_VIBRATION_EXPLOSION: "ระเบิด",
  T_31_RW_VIBRATION_MELEEWEAPONS: "อาวุธประชิด",
  T_31_RW_VIBRATION_OTHERWEAPONS: "ปืนอื่น ๆ",
  T_31_T_WS_1PLAYERTEAM: "Solo",
  T_31_T_WS_2PLAYERTEAM: "Duo",
  T_31_T_WS_3PLAYERTEAM: "Trio",
  T_31_T_WS_4PLAYERTEAM: "Squad",
  T_31_T_WS_5PLAYERTEAM: "V 5",
  T_31_T_WS_6PLAYERTEAM: "V 6",
  T_31_T_WS_BUFFTIME_TITLE: "เวลารีเฟรช (วินาที)",
  T_31_T_WS_BUFFTYPE_AMMO: "กระสุน",
  T_31_T_WS_BUFFTYPE_ARMOR: "เกราะ",
  T_31_T_WS_BUFFTYPE_HP: "HP",
  T_31_T_WS_BUFFTYPE_RANDOM: "สุ่ม",
  T_31_T_WS_BUFFTYPE_TITLE: "บัฟ",
  T_31_T_WS_DESC48: "พาคุณไปยังที่หมาย ในไม่กี่วินาที",
  T_31_T_WS_DESC49: "ส่งเสียเปียโน",
  T_31_T_WS_DESC51: "ส่งเสียงกลอง",
  T_31_T_WS_DESC53: "ส่งเสียงดนตรี",
  T_31_T_WS_DESC59: "อุปกรณ์ผลิตบัฟ เก็บบัฟเพื่อเพิ่มศักยภาพ",
  T_31_T_WS_DRUMTYPE_CLAPS: "Clap",
  T_31_T_WS_DRUMTYPE_HIHATS: "Hi-hat",
  T_31_T_WS_DRUMTYPE_KICK: "Kick Drum",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Opening Hi-hat",
  T_31_T_WS_DRUMTYPE_RIDES: "Ride Cymbal",
  T_31_T_WS_DRUMTYPE_SNARES: "Snare Drum",
  T_31_T_WS_EARLYSHRINK: "วงบีบเร็ว",
  T_31_T_WS_ITEM48: "ประตู",
  T_31_T_WS_ITEM49: "Piano Key",
  T_31_T_WS_ITEM51: "Drum Key",
  T_31_T_WS_ITEM53: "Combo Key A",
  T_31_T_WS_ITEM55: "Combo Key B",
  T_31_T_WS_ITEM57: "Combo Key B",
  T_31_T_WS_ITEM59: "เครื่องผลิตบัฟ",
  T_31_T_WS_LATESHRINK: "วงบีบช้า",
  T_31_T_WS_ME_DAMAGE: "สร้างความเสียหาย",
  T_31_T_WS_ME_DAMAGED: "รับความเสียหาย",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "EP เริ่มต้น",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "อาณาเขตเซฟโซนแรก",
  T_31_T_WS_ME_EPQUICKRESTORE: "แปลง EP อย่างรวดเร็ว",
  T_31_T_WS_ME_FLOW: "โหมด",
  T_31_T_WS_ME_GENERALSETTING: "ทั่วไป",
  T_31_T_WS_ME_INRANDOMSPAWN: "สุ่มจุดเกิด",
  T_31_T_WS_ME_KILLSCORE: "โบนัสสังหาร",
  T_31_T_WS_ME_MAXEP: "EP สูงสุด",
  T_31_T_WS_ME_MAXHP: "HP สูงสุด",
  T_31_T_WS_ME_NEARTEAM: "ใกล้เพื่อนร่วมทีม",
  T_31_T_WS_ME_REBIRTH: "ระยะเวลาเกิดใหม่",
  T_31_T_WS_ME_REBIRTHLOCATION: "จุดเกิด",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "ระยะเวลาวงบีบ",
  T_31_T_WS_ME_WINSCORE: "คะแนนชนะ",
  T_31_T_WS_MINIZONE: "Mini Zone",
  T_31_T_WS_MUSICTYPE_TITLE: "เพลง",
  T_31_T_WS_UNLIMITEDAMMO: "กระสุนไม่จำกัด",
  T_31_WT_WS_DESC1: "กล่องไม้ทรงสี่เหลี่ยม สามารถวางซ้อนทับกันได้",
  T_31_WT_WS_DESC10: "กระท่อมไม้พร้อมบันไดสำหรับปืนขึ้น",
  T_31_WT_WS_DESC11: "มีช่องหน้าต่างมากมาย เหมาะสำหรับการซุ่มยิง",
  T_31_WT_WS_DESC12: "ทำจากโลหะ มาพร้อมประตูและหน้าต่าง",
  T_31_WT_WS_DESC13: "มาพร้อมประตู และหน้าต่าง",
  T_31_WT_WS_DESC14: "บ้านพร้อมรั้ว",
  T_31_WT_WS_DESC15: "บ้านพร้อมหลังคาปิดตาย",
  T_31_WT_WS_DESC16: "ตกแต่ง - รูปปั้นทรายทรงหัวใจ",
  T_31_WT_WS_DESC17: "ตกแต่ง - น้ำพุใสดุจคริสตัล",
  T_31_WT_WS_DESC18: "ตกแต่ง - ต้นไม้ที่มีดอกสีชมพู",
  T_31_WT_WS_DESC19: "ตกแต่ง - ต้นกล้วยที่ยังไม่โตเต็มที่",
  T_31_WT_WS_DESC2: "กล่องไม้ที่สามารถวางซ้อนทับกันได้",
  T_31_WT_WS_DESC20: "เฟอร์นิเจอร์ห้องน้ำสีขาว สามารถวางในอาคารได้",
  T_31_WT_WS_DESC21: "รั้วขนาดเล็ก ใช้สำหรับการแบ่งพื้นที่",
  T_31_WT_WS_DESC22: "ตู้คอนเทนเนอร์ ด้านที่เป็นไม้สามารถทำลายได้",
  T_31_WT_WS_DESC23: "รั้วขนาดเล็กที่สามารถทำลายได้",
  T_31_WT_WS_DESC24: "จุดเกิดทีม A (เฉพาะในโหมด 4v4, Deathmatch, และ Playgrund เท่านั้น)",
  T_31_WT_WS_DESC25: "จุดเกิดทีม B (เฉพาะในโหมด 4v4, Deathmatch, และ Playgrund เท่านั้น)",
  T_31_WT_WS_DESC26: "ส่งผู้เล่นไปในด้านหน้า ระยะสั้น",
  T_31_WT_WS_DESC27: "ส่งผู้เล่นไปในทิศทางที่แสดง ระยะสั้น",
  T_31_WT_WS_DESC28: "ส่งผู้เล่นไปในทิศทางที่แสดง ระยะกลาง",
  T_31_WT_WS_DESC29: "ส่งผู้เล่นไปในทิศทางที่แสดง ระยะไกล",
  T_31_WT_WS_DESC3: "ตกแต่งสมรภูมิของคุณด้วยดอกไม้หลากสี",
  T_31_WT_WS_DESC30: "รถบั๊มพ์ ที่สามารถขับได้",
  T_31_WT_WS_DESC31: "รถสะเทิ้นน้ำสะเทิ้นบก ที่สามารถขับได้",
  T_31_WT_WS_DESC32: "รถจี๊ป ที่สามารถขับได้",
  T_31_WT_WS_DESC33: "ถังขยะ ถึงจะมีขนาดเล็กแต่ก็สามารถใช้เป็นที่กำบังได้",
  T_31_WT_WS_DESC34: "สนามแข่งทำจากโลหะ",
  T_31_WT_WS_DESC35: "เต้นท์ขนาดกลาง มาพร้อมประตูสองบานแต่ไม่มีหน้าต่าง",
  T_31_WT_WS_DESC36: "โรงรถขนาดใหญ่ สร้างจากอิฐ",
  T_31_WT_WS_DESC37: "กำแพงอิฐขนาดใหญ่ ใช้สำหรับแบ่งพื้นที่ได้เป็นอย่างดี",
  T_31_WT_WS_DESC38: "ป้ายบอกทาง",
  T_31_WT_WS_DESC39: "พื้นโลหะขนาดใหญ่ เหมาะสำหรับเป็นลานประลอง",
  T_31_WT_WS_DESC4: "ขนาดใหญ่ ใช้เป็นที่กำบังได้เป็นอย่างดี",
  T_31_WT_WS_DESC40: "ดูเหมือนรถสมัยใหม่ มาพร้อมหลายประตู หลายหน้าต่าง",
  T_31_WT_WS_DESC41: "ดูเหมือนรถสมัยใหม่ มาพร้อมหลายประตู หลายหน้าต่าง",
  T_31_WT_WS_DESC42: "กำแพงด้านเดียวพร้อมทางเข้า",
  T_31_WT_WS_DESC43: "กำแพงด้านเดียวขนาดพื้นฐาน",
  T_31_WT_WS_DESC44: "มุมกำแพง",
  T_31_WT_WS_DESC45: "มุมกำแพงที่ไม่เท่ากัน",
  T_31_WT_WS_DESC46: "มุมกำแพงที่ไม่เท่ากัน",
  T_31_WT_WS_DESC47: "มุมกำแพงพร้อมหน้าต่าง",
  T_31_WT_WS_DESC5: "ซากรถที่ขนาดเล็ก แต่ก็ยังสามารถใช้เป็นที่กำบังได้",
  T_31_WT_WS_DESC6: "ขนาดใหญ่ สามารถใช้เป็นที่กำบังได้อย่างดี",
  T_31_WT_WS_DESC7: "มีทางเข้าออกทั้งสองทาง สามารถใช้เป็นทางเชื่อม หรือแบ่งพื้นที่ได้",
  T_31_WT_WS_DESC8: "เข้า-ออกทางเดียว เหมาะสำหรับใช้แบ่งพื้นที่",
  T_31_WT_WS_DESC9: "ไม่มีทางเข้าออก เหมาะสำหรับใช้แบ่งพื้นที่",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "ยานพาหนะ",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "พุ่งไปข้างหน้าด้วยความรวดเร็วเป็นเวลา [FFB300]{0} วิ [-]สามารถใช้ได้สูงสุด [FFB300]{2} ครั้ง[-] มีคูลดาวน์ [FFB300]{3} วินาที[-] ก่อนจะกดได้อีกครั้ง ระยะเวลาฟื้นฟูการพุ่ง: [FFB300]{1} วิ[-]",
  T_32_C_SKILL_NAME_YAKUZA: "ไวเหนือแสง",
  T_32_HQ_AUG_VNSTREET_N: "AUG - Roaring Gunfighter",
  T_32_HQ_BACKPACK_REDDRAGON_N: "กระเป๋า Dawnlit Drago",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B - Vampire Malevolence",
  T_32_HQ_GLOO_DUNHUANG_N: "ไอซ์วอลล์ - Frozen Platinum",
  T_32_HQ_GLOO_HURRICANE_2_N: "ไอซ์วอลล์ - Aurora Core",
  T_32_HQ_GRENADE_HURRICANE_N: "ระเบิด - Brassy Mic",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10 - Frozen Platinum",
  T_32_HQ_PETSKIN_DUCK_RED_N: "สกินคู่หู : Red Beanie",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "สกินคู่หู : ไซเบอร์ แฟลช",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "สกินคู่หู : เกมเมอร์ แฟลช",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "สกินคู่หู : เฟสทีฟ แฟลช",
  T_32_HQ_TORTOISE_N: "แฟลช",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "รถสปอร์ต - Buried Purpledust",
  T_32_L_F_A_PHARAOH: "Goldcoated Cleo (หน้ากาก)",
  T_32_L_F_B_PHARAOH: "Goldcoated Cleo (กางเกง)",
  T_32_L_F_H_PHARAOH: "Goldcoated Cleo (ทรงผม)",
  T_32_L_F_HA_PHARAOH: "Goldcoated Cleo (ลายเพ้นท์)",
  T_32_L_F_S_PHARAOH: "Goldcoated Cleo (รองเท้า)",
  T_32_L_F_T_PHARAOH: "Goldcoated Cleo (เสื้อ)",
  T_32_L_M_A_JUNKFOOD: "Burger Lad (หน้ากาก)",
  T_32_L_M_A_PHARAOH: "Goldlined Mummy (หน้ากาก)",
  T_32_L_M_B_JUNKFOOD: "Burger Lad (กางเกง)",
  T_32_L_M_B_PHARAOH: "Goldlined Mummy (กางเกง)",
  T_32_L_M_H_JUNKFOOD: "Burger Lad (ทรงผม)",
  T_32_L_M_H_PHARAOH: "Goldlined Mummy (ทรงผม)",
  T_32_L_M_S_JUNKFOOD: "Burger Lad (รองเท้า)",
  T_32_L_M_S_PHARAOH: "Goldlined Mummy (รองเท้า)",
  T_32_L_M_T_JUNKFOOD: "Burger Lad (เสื้อ)",
  T_32_L_M_T_PHARAOH: "Goldlined Mummy (เสื้อ)",
  T_32_L_T_WHITESWEATER: "White Turtleneck",
  T_32_LC_NEWVAULT_EMOTE: "ท่าทาง",
  T_32_LO_WS_IMMORTAL: "โซนอมตะ",
  T_32_LO_WS_ITEM60: "ท่อ",
  T_32_LO_WS_ITEM60_DESC: "ท่อที่กว้างพอให้เดินได้",
  T_32_LO_WS_ITEM61: "ท่อรูปตัว T",
  T_32_LO_WS_ITEM61_DESC: "ท่อที่กว้างพอให้เดินได้",
  T_32_LO_WS_ITEM62: "ท่อ 4 มุม",
  T_32_LO_WS_ITEM62_DESC: "ท่อที่กว้างพอให้เดินได้",
  T_32_LO_WS_ITEM63: "ท่อเข้ามุม",
  T_32_LO_WS_ITEM63_DESC: "ท่อที่กว้างพอให้เดินได้",
  T_32_LO_WS_ITEM64: "รถขนอาหาร",
  T_32_LO_WS_ITEM64_DESC: "หยุดซักนิด กินซักหน่อย",
  T_32_LO_WS_ITEM65: "เห็ดยักษ์",
  T_32_LO_WS_ITEM65_DESC: "เห็นขนาดใหญ่ ที่มนุษย์สามารถขึ้นไปอยู่ได้",
  T_32_LO_WS_ITEM66: "โรงเก็บเครื่องบิน",
  T_32_LO_WS_ITEM66_DESC: "โรงเก็บเครื่องบินพบเห็นได้ทั่วไป",
  T_32_LO_WS_ITEM67: "แผ่นไม้",
  T_32_LO_WS_ITEM67_DESC: "แผ่นไม้ทั่วไป เหมาะสำหรับใช้ส้างสะพาน",
  T_32_LO_WS_ITEM68: "ระแนง",
  T_32_LO_WS_ITEM68_DESC: "เพิ่มความหรูหรา สบายตา",
  T_32_LO_WS_ITEM69: "เสา",
  T_32_LO_WS_ITEM69_DESC: "สิ่งที่พบเห็นได้ทั่วไป ในไซต์ก่อสร้าง",
  T_32_LO_WS_ITEM70: "ตะบองเพชร",
  T_32_LO_WS_ITEM70_DESC: "ตะบองเพพชรยักษ์ ไร้หนาม",
  T_32_LO_WS_ITEM71: "ต้นที่เหลือแต่ไม้",
  T_32_LO_WS_ITEM71_DESC: "ต้นไม้ที่อยู่มานานกว่าทศวรรษ",
  T_32_LO_WS_ITEM72: "โคมไฟหิน",
  T_32_LO_WS_ITEM72_DESC: "ของตกแต่ง เพิ่มความสวยงามประจำสวน",
  T_32_LO_WS_ITEM73: "โคมไฟถนน",
  T_32_LO_WS_ITEM73_DESC: "พบเห็นได้ตามถนนทั่วไป",
  T_32_LO_WS_ITEM74: "แผงโซล่าเซลล์",
  T_32_LO_WS_ITEM74_DESC: "รับพลังงานจากแสงอาทิตย์",
  T_32_LO_WS_ITEM75: "เครื่องปรับอากาศ A",
  T_32_LO_WS_ITEM75_DESC: "จะร้อนแค่ไหนก็ยังเย็นได้",
  T_32_LO_WS_ITEM76: "พัดลม",
  T_32_LO_WS_ITEM77: "กระทะ",
  T_32_LO_WS_ITEM78: "กล่อง",
  T_32_LO_WS_ITEM79: "แหวน",
  T_32_LO_WS_ITEM80: "ค้อน",
  T_32_LO_WS_ITEM81: "บอร์ด",
  T_32_LO_WS_ITEM82: "เป้าซ้อมยิง",
  T_32_LO_WS_ITEM83: "กำแพงต้องประสงค์",
  T_32_LO_WS_ITEM84AMMO: "จุดเก็บกระสุน",
  T_32_LO_WS_ITEM84AMMO_DESC: "จุดที่วางไว้ จะมีกระสุนที่เลือกเอาไว้ให้เก็บ",
  T_32_LO_WS_ITEM84AR: "จุดเก็บกระสุน",
  T_32_LO_WS_ITEM84AR_DESC: "จุดที่วางไว้ จะมีกระสุนที่เลือกเอาไว้ให้เก็บ",
  T_32_LO_WS_ITEM84ARLV1: "เกราะเลเวล 1",
  T_32_LO_WS_ITEM84ARLV2: "เกราะเลเวล 2",
  T_32_LO_WS_ITEM84ARLV3: "เกราะเลเวล 3",
  T_32_LO_WS_ITEM84CO: "จุดเก็บไอเทม",
  T_32_LO_WS_ITEM84CO_DESC: "จุดที่วางไว้ จะมีไอเทมที่เลือกเอาไว้ให้เก็บ",
  T_32_LO_WS_ITEM84JA: "จุดเก็บระเบิด",
  T_32_LO_WS_ITEM84JA_DESC: "จุดที่วางไว้ จะมีระเบิดที่เลือกเอาไว้ให้เก็บ",
  T_32_LO_WS_ITEM84TE: "จุดเก็บสโคปปืน",
  T_32_LO_WS_ITEM84TE_DESC: "จุดที่วางไว้ จะมีสโคปที่เลือกเอาไว้ให้เก็บ",
  T_32_LO_WS_ITEM84W: "จุดเก็บอาวุธ",
  T_32_LO_WS_ITEM84W_DESC: "จุดที่วางไว้ จะมีอาวุธที่เลือกเอาไว้ให้เก็บ",
  T_32_LO_WS_ITEM85: "โซนหายนะ/อมตะ",
  T_32_LO_WS_ITEM85_DESC: "เมื่อวางแล้ว ผู้เล่นที่เข้ามาใน Trigger Zone จะพบกับเหตุการณ์พิเศษ (ไม่สามารถใช้ได้ในโหมด 4v4, Team Deathmatch, และโหมด Playground)",
  T_32_LO_WS_ITEM85CP: "เช็คพ้อยท์",
  T_32_LO_WS_ITEM85CP_DESC: "ไอเทมที่ใช้สำหรับสร้างรูปแบบการเล่นในโหมด Parkour จุดเช็คพ้อยท์สุดท้ายจะปรากฏเมื่อผู้เล่นผ่านจุดเช็คพ้อยท์ครบทั้งหมดแบบเรียงกัน หากถูกกำจัดระหว่างทาง ผู้เล่นสามารถเลือกเกิดที่จุดเช็คพ้อยท์ล่าสุดได้ (ไม่สามารถใช้ได้ในโหมด 4v4, Team Deathmatch, และโหมด Playground)",
  T_32_LO_WS_ITEM85TM: "จุดตกปลา",
  T_32_LO_WS_ITEM85TM_DESC: "ไอเทมใช้สำหรับสร้างรูปแบบการเล่นในโหมด Parkout ผู้เล่นจะต้องเข้าเส้นชัยเพื่อจบเกม (ไม่สามารถใช้ได้ในโหมด 4v4, Team Deathmatch, และโหมด Playground)",
  T_32_LO_WS_ITEM86: "จุดเกิด",
  T_32_LO_WS_ITEM86_DESC: "ไม่สามารถกำหนดทีมให้เกิดที่จุดนี้ได้ เมื่อวางแล้วจะสุ่มทีมที่จะถูกเกิดที่จุดนี้ (ไม่สามารถใช้ได้ในโหมด 4v4, Team Deathmatch, และโหมด Playground)",
  T_32_LO_WS_ITEM86L: "จุดเกิดขนาดใหญ่",
  T_32_LO_WS_ITEM86L_DESC: "จุดเกิดขนาดใหญ่ แนะนำสำหรับโหมด Parkour ที่ต้องการให้ผู้เล่นเกิดแบบเรียงแถวกัน (ไม่สามารถใช้ได้ในโหมด 4v4, Team Deathmatch, และโหมด Playground)",
  T_32_LO_WS_ITEM87: "บล็อก",
  T_32_LO_WS_ITEM87_DESC: "ปรับแต่งขนาดได้",
  T_32_LO_WS_ITEM88: "ลูกบาศก์และความลาดชัน",
  T_32_LO_WS_ITEM88_DESC: "ขนาดของลูกบาศก์และความลาดชันสามารถปรับขนาดได้",
  T_32_LO_WS_ITEMLINE: "ยก",
  T_32_LO_WS_ITEMMOVE: "ตั้งค่ากลไก",
  T_32_LO_WS_ITEMROT: "แปลงร่าง",
  T_32_LO_WS_ITEMSCALE: "ขนาด",
  T_32_LO_WS_KILLZONE: "โซนสิ้นใจ",
  T_32_LO_WS_LOOT_AMMOTYPE: "กระสุน",
  T_32_LO_WS_LOOT_ARTYPE: "กระสุน",
  T_32_LO_WS_LOOT_COTYPE: "ไอเทม",
  T_32_LO_WS_LOOT_JATYPE: "ระเบิด",
  T_32_LO_WS_LOOT_RANDOM: "สุ่ม",
  T_32_LO_WS_LOOT_TETYPE: "สโคป",
  T_32_LO_WS_LOOT_WEAPONTYPE: "อาวุธ",
  T_32_LO_WS_SCALEX: "ความยาว",
  T_32_LO_WS_SCALEY: "ความสูง",
  T_32_LO_WS_SCALEZ: "ความกว้าง",
  T_32_LO_WS_TRIGGERH: "ซ่อน",
  T_32_LO_WS_TRIGGERHORP: "แสดง/ซ่อน กลไก",
  T_32_LO_WS_TRIGGERP: "แสดง",
  T_32_LO_WS_TRIGGERTYPE: "ประเภทกลไก",
  T_32_M_WS_MODE_ANNIHILATE: "สังหาร",
  T_32_M_WS_MODE_SCORE: "เก็บแต้ม",
  T_32_M_WS_MODE_SPEED: "ปาร์กัว",
  T_32_M_WS_MULTIPLETEAMS: "ต่อสู้หลายทีม",
  T_32_M_WS_ROUNDS: "รอบ",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Switching Steps",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "โซนอันตราย",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "ความเสียหาย",
  T_32_T_WS_ME_BLUECIRCLESETTING: "โซนอันตราย",
  T_32_T_WS_ME_CUSTOM: "ปรับแต่ง",
  T_32_T_WS_ME_ENDTYPE1: "กวาดล้าง",
  T_32_T_WS_ME_ENDTYPE2: "ยึดจุด",
  T_32_T_WS_ME_ENDTYPE3: "ปาร์กัว",
  T_32_T_WS_ME_ENDTYPEDESC1: "อยู่ให้รอดเป็นทีมสุดท้าย",
  T_32_T_WS_ME_ENDTYPEDESC2: `โหมดที่ตัดสินผู้ชนะจากคะแนน ฝ่ายไหนถึงเป้าหมายก่อนชนะ
คุณสามารถตั้งกติกาการเล่นและปรับแต่งพารามิเตอร์การเล่นได้ตามที่ต้องการ รวมถึงการตั้งค่าคะแนนที่ได้จากการกำจัดฝ่ายตรงข้าม`,
  T_32_T_WS_ME_ENDTYPEDESC3: `โหมดปากัวร์ที่ทีมแรกที่มีสมาชิกทั้งหมดไปถึงจุดสิ้นสุดจะชนะ
คุณสามารถกำหนดกติกาการเล่น วัตถุของเส้นทางและเส้นชัยได้ตามต้องการ`,
  T_32_T_WS_ME_MATCHTIME: "ระยะเวลาเกม",
  T_32_T_WS_ME_MECHANIC: "วิธีการเล่น",
  T_32_T_WS_ME_NEARCHECKPOINT: "ใกล้จุดเช็คพ้อยท์",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "มีผู้เล่นได้สูงสุด 12 คน",
  T_32_T_WS_ME_PREGAMETIME: "ระยะเวลาเตรียมตัว",
  T_32_T_WS_ME_RESPAWN: "จุดเกิด",
  T_32_T_WS_ME_RESPAWNSETTING: "จุดเกิด",
  T_32_T_WS_ME_ROUNDNUM: "จำนวนรอบ",
  T_32_T_WS_ME_ROUNDOPEN: "เปิดเล่นหลายรอบ",
  T_32_T_WS_ME_ROUNDRESET: "รีเซตรอบ",
  T_32_T_WS_ME_ROUNDSETTING: "รอบ",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "ความเร็ววง",
  T_32_T_WS_ME_SCORESETTING: "คะแนน",
  T_32_T_WS_ME_TEAMMATENUM: "จำนวนสมาชิกต่อทีม",
  T_32_T_WS_ME_TEAMNUM: "จำนวนทีม",
  T_32_T_WS_ME_TEAMSETTING: "ทีม",
  T_32_U_ATTACHMENT_8: "กระเป๋าเสริม",
  "T_32_U_GOLD_FAMAS-I": "FAMAS-I",
  "T_32_U_GOLD_FAMAS-II": "FAMAS-II",
  "T_32_U_GOLD_FAMAS-III": "FAMAS-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98k-I",
  T_32_U_GOLD_KAR98K_II: "Kar98k-II",
  T_32_U_GOLD_KAR98K_III: "Kar98k-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "ชิปอัปเกรด",
  T_32_WT_WS_BARRIER: "วง",
  T_32_WT_WS_BDS: "ตึก / อาคาร",
  T_32_WT_WS_MMINVALIDERROR: "ไม่พบรหัสแผนที่",
  T_32_WT_WS_TRGS: "ระบบ",
  T_32_YF_CHARGESHOT_N: "Charge Buster",
  T_32_YF_GOLD_GROZA_N: "GROZA-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "ความเสียหายพิเศษ",
  T_32_YS_WEAPON_TAG_3: "อัตราการยิง",
  T_32_YS_WEAPON_TAG_36: "เจาะเกราะ",
  T_32_YS_WEAPON_TAG_39: "สามารถถือคู่",
  T_32_YS_WEAPON_TAG_42: "ไอซ์ วอลล์",
  T_33_C_SKILL_DESC_GRAFFITIST: "สร้างพื้นที่กว้าง [FFB300]{0}เมตร[-]ซึ่งจะป้องกันอาวุธโยนทุกรูปแบบ พันธมิตรที่อยู่ในพื้นที่จะฟื้นฟูความทนทานเกราะ [FFB300]{1}% [-]ทุก 1 วินาทีและลดความเสียหายจากที่ได้รับจากการถูกยิงลง [FFB300]{2}%[-] เป็นระยะเวลา [FFB300]{3} วิ[-] ผลสกิลไม่ทับซ้อน คูลดาวน์ : [FFB300]{4} วิ[-]",
  T_33_C_SKILL_DESC_HITMAN: "เมื่อใช้ปืนสไนเปอร์ และไรเฟิลซุ่มยิง ปืนจะเก็บเสียงและศัตรูที่ถูกคุณล้ม เลือดจะไหลเร็วขึ้น [FFB300]{0}%[-]",
  T_33_C_SKILL_DESC_KENTA: "สร้างโล่ด้านหน้าขนาด [FFB300]{0} เมตร[-] ลดความเสียหายที่ได้รับลง [FFB300]{1}%[-] ขณะยิง การลดความเสียหายจะลดลงเหลือ [FFB300]{2}%[-] เป็นเวลา [FFB300]{3} วินาที[-] คูลดาวน์: [FFB300]{4} วินาที[-]",
  T_33_C_SKILL_DESC_MADEMANA: "ปล่อยคลื่นแม่เหล็กไฟฟ้าที่มีเส้นผ่านศูนย์กลาง [FFB300]{0} เมตร[-] ที่ปิดการใช้งานสกิลของศัตรู สร้างความเสียหาย [FFB300]{3}[-] หน่วย และขัดจังหวะการนับถอยหลังของการโต้ตอบของพวกเขา มีผลนาน [FFB300]{1}วินาที[-] คูลดาวน์: [FFB300]{2}วินาที[-]",
  T_33_C_SKILL_NAME_BODYGUARD: "เชี่ยวชาญปืน",
  T_33_C_SKILL_NAME_KENTA: "เพลงดาบแห่งความโกรธ",
  T_33_C_SKILL_NAME_MADEMANA: "สนามแม่เหล็ก",
  T_33_DY_AXOLOTL_N: "ซาซิล",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "สกินคู่หู : ฟรุ๊ตตี้ ซาซิล",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "สกินคู่หู : FFWS บีนนี่",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "สกินคู่หู : ฟัลโก้สายเขียว",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "ไม้เบสบอล - Deadly Baguette",
  T_33_HQ_EMOTE_SONGKRAN_N: "Come and Dance",
  T_33_HQ_G18_CYBERTHIEF_N: "G18 - Hypercore Blues",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "ระเบิด - Hypercore Blues",
  T_33_HQ_M14_SPIDERLILY_N: "M14 - Burning Lily",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7 - Shadow Rogue",
  T_33_HQ_MP40_FFWS03_N: "MP40 - Haven Warrior",
  T_33_HQ_SCAR_FFWS03_N: "SCAR - Haven Warrior",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "เคียว - Emerald Power",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "มีด - Haven Warrior",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector - Hypercore Blues",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "รถจี๊ป - สายเขียว",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "รถบิ๊กฟุต - Bonebruiser Scorch",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "รถกระบะ - Haven Guardian",
  T_33_LO_WS_BHPARA_A: "เปิดใช้งาน",
  T_33_LO_WS_BHPARA_ATKMODE: "ประเภทโจมตี",
  T_33_LO_WS_BHPARA_GROUP: "ทีม",
  T_33_LO_WS_BHPARA_NA: "ไม่โจมตี",
  T_33_LO_WS_BHPARA_P: "สกิลติดตัว",
  T_33_LO_WS_DICE_DESC: "ลูกเต๋าเพิ่มศักยภาพการกระโดด",
  T_33_LO_WS_DICEVXZ: "ความเร็วแนวนอน",
  T_33_LO_WS_DICEVY: "ความเร็วแนวตั้ง",
  T_33_LO_WS_DTOWER: "หอคอย",
  T_33_LO_WS_DTOWER_DESC: "โจมตีศัตรูที่เข้ามาในระยะโดยอัตโนมัติ เมื่อค่า HP เหลือ 0 จะถูกทำลาย (ไม่สามารถใช้ได้ในโหมด 4v4, Team Deathmatch, และโหมด Playground)",
  T_33_LO_WS_FORT: "ป้อมปราการ",
  T_33_LO_WS_FORT_DESC: "โจมตีศัตรูที่เข้ามาในระยะโดยอัตโรมัติ เมื่อ HP เหลือ 0 จะถูกทำลาย (ไม่สามารถใช้ได้ในโหมด 4v4, Team Deathmatch, และโหมด Playground)",
  T_33_LO_WS_ITEM89: "ถังกลั่น",
  T_33_LO_WS_ITEM89_DESC: "ที่กักเก็บน้ำ",
  T_33_LO_WS_ITEM90: "บ้านหมา",
  T_33_LO_WS_ITEM90_DESC: "บ้านสำหรับน้องหมา",
  T_33_LO_WS_ITEM91: "ป้ายรถเมล์",
  T_33_LO_WS_ITEM91_DESC: "ป้ายรถเมล์ทั่วไป",
  T_33_LO_WS_ITEM92: "กำแพงลายกราฟิตี้",
  T_33_LO_WS_ITEM92_DESC: "ตกแต่งด้วยสีสเปรย์อย่างดี",
  T_33_LO_WS_ITEM93: "คอกม้า",
  T_33_LO_WS_ITEM93_DESC: "ที่เก็บฟางทั่วไป",
  T_33_LO_WS_ITEM94: "ม้านั่ง",
  T_33_LO_WS_ITEM94_DESC: "ม้านั่งในสวนสาธารณะ",
  T_33_LO_WS_ITEM95: "สะพานหิน",
  T_33_LO_WS_ITEM95_DESC: "สะพานที่สร้างจากหิน",
  T_33_LO_WS_ITEM96: "ร่มกันแดด",
  T_33_LO_WS_ITEM96_DESC: "ป้องกันแสงแดด อันร้อนแรง",
  T_33_LO_WS_ITEM97: "เส้นชัย",
  T_33_LO_WS_ITEM97_DESC: "กำหนดเส้นชัย",
  T_33_LO_WS_ITEM98: "ป้ายโฆษณา",
  T_33_LO_WS_ITEM98_DESC: "ภาพทั่วไปสำหรับการโฆษณา",
  T_33_LO_WS_PARA_DM: "ความเสียหาย",
  T_33_LO_WS_PARA_HP: "HP",
  T_33_LO_WS_PARA_RANGE: "ระยะการตรวจจับของศัตรู",
  T_33_LO_WS_PARA_SP: "ความเร็ว",
  T_33_LO_WS_ZBPARA_AMOUNT: "ซอมบี้ต่อรอบ",
  T_33_LO_WS_ZBPARA_INTERVAL: "ช่วงระหว่างคลื่น (วินาที)",
  T_33_LO_WS_ZBPARA_ROUND: "# จากเวฟ",
  T_33_LO_WS_ZBSPAWNER: "ซอมบี้มาแล้ว",
  T_33_LO_WS_ZBSPAWNER_DESC: "เรียกซอมบี้ออกมาโดยอัตโนมัติตามการตั้งค่า พฤติกรรมของซอมบี้สามารถปรับได้ในเมนู (ไม่สามารถใช้ได้ในโหมด 4v4, Team Deathmatch, และโหมด Playground)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "เคนตะ",
  T_33_PD_ZOMBIE_LEVELUP: "เพิ่มเลเวล",
  T_33_RW_SKILL_DESC_GANGGIRL: "เพิ่มอัตรายิง [FFB300]{0} %[-] ทุก 1 นัดที่ยิงโดนศัตรู จะเปลี่ยนอัตรายิงเป็นความเร็วเคลื่อนที่แทน สูงสุดที่ [FFB300]{1} %[-] ผลนี้จะหายไปเมื่อผู้ใช้สกิลรอดจากการต่อสู้",
  T_33_RW_SKILL_NAME_GANGGIRL: "กระสุนตามสั่ง",
  T_33_WT_WS_BASICSET1: "ทั่วไป",
  T_33_WT_WS_QCEPRTIP: "แปลงค่า EP เป็น HP เร็วขึ้น",
  T_33_WT_WS_SKILLSET_TAG: "สกิลไม่จำกัด",
  T_33_WT_WS_SKILLSET1: "ตั้งค่าสกิล",
  T_33_WT_WS_SKILLSET10: "โครโน่สเฟียร์ (โครโน่)",
  T_33_WT_WS_SKILLSET11: "ริปไทด์ ริทึ่ม (สกายเลอร์)",
  T_33_WT_WS_SKILLSET12: "เอ็กซ์ตรีม เอนเคาท์เตอร์ (เซน)",
  T_33_WT_WS_SKILLSET13: "Healing Heartbeat (Dimitri)",
  T_33_WT_WS_SKILLSET2: "สกิลติดตัว",
  T_33_WT_WS_SKILLSET2_TIP: "เปิด/ปิด สกิลติดตัว",
  T_33_WT_WS_SKILLSET3: "สกิลกดใช้ (เปิดเพื่อปรับระยะเวลาคูลดาวน์ที่ด้านล่าง)",
  T_33_WT_WS_SKILLSET3_TIP: "เปิด/ปิด สกิลกดใช้ หากเปิด สามารถปรับ คูลดาวน์ได้ที่ด้านล่าง",
  T_33_WT_WS_SKILLSET4: "ร่างจำแลง (หงอคง)",
  T_33_WT_WS_SKILLSET5: "โอเวอร์คล็อก (A124)",
  T_33_WT_WS_SKILLSET6: "อาเพคจิโอ้ (Alok)",
  T_33_WT_WS_SKILLSET7: "กราฟฟิตี้ ชีลด์ (สเต็ฟฟี่)",
  T_33_WT_WS_SKILLSET8: "สะกดรอย (คลูว์)",
  T_33_WT_WS_SKILLSET9: "ศิลปะแห่งอัจฉริยะ (K)",
  T_33_WT_WS_UNIT_HPSECOND: "HP/วิ",
  T_33_WT_WS_UNIT_METER: "เมตร",
  T_33_WT_WS_UNIT_SECOND: "วินาที",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Raindoll (กางเกง)",
  T_33_YS_H_ONIGIRI: "หน้ากากข้าวปั้น",
  T_33_YS_H_RAINCOAT: "Raindoll (ทรงผม)",
  T_33_YS_HA_CRYINGFACE: "ร้องไห้ (ลายเพ้นท์)",
  T_33_YS_M_H_FROGKING: "หมวกเคโระคิง",
  T_33_YS_S_RAINCOAT: "Raindoll (รองเท้า)",
  T_33_YS_T_BLACKHOLE: "เสื้อฮู๊ด The Doppler Shift",
  T_33_YS_T_RAINCOAT: "Raindoll (เสื้อ)",
  T_33_YS_T_SOCCER_GREEN: "Electrified Kick (เสื้อ)",
  T_33_YS_T_SOCCER_YELLOW: "Energized Kick (เสื้อ)",
  T_33_YS_T_WIFI: "เสื้อยืด สัญญาณใจ",
  T_34_C_SKILL_DESC_STREAMERGUY: "การกำจัดหรือการดูจะได้รับสแต็กของผล เอฟเฟ็กต์แต่ละสแต็กจะลดความเสียหายจากการยิงหัวที่ได้รับลง [FFB300]{0}%[-] (สูงสุดรวม [FFB300]{1}%[-]) และเพิ่มความเสียหายจากการยิงหัวให้กับศัตรูได้ [FFB300]{2}%[-] (สูงสุดรวม [FFB300]{3}%[-])",
  T_34_C_SKILL_DESC_TRACKER: "ปล่อยโดรนไปหาศัตรูที่อยู่ใกล้ที่สุดในระยะ [FFB300]100 เมตร[-]ด้านหน้า ปล่อยคลื่นระเบิดรัศมีกว้าง [FFB300]{5} เมตร[-] ลดความเร็วเคลื่อนที่ [FFB300]{0}%[-] และอัตราการยิง [FFB300]{1}%[-] เป็นระยะเวลา [FFB300]{3} วิ[-] และสร้างความเสียหาย [FFB300]{2} หน่วย[-] คูลดาวน์ : [FFB300]{4} วิ[-]",
  T_34_C_SKILL_NAME_TRACKER: "ค้นหาและทำลาย",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "สกินคู่หู : ฟินเบอร์เซิร์ฟ",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "สกินคู่หู : ฟินเจ้าทะเลลึก",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "สกินคู่หู : ฟิน เจ้าอัสนีย์",
  T_34_DY_PETSKIN_TIGER_BIS_N: "สกินคู่หู : ดิจิทัล ทิก",
  T_34_DY_SURFSHARK_N: "ฟิน",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Great Conductor",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "Energetic",
  T_34_HQ_EMOTE_RIDICULE_N: "Ridicule",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "รถกระบะ - Evil Engineer",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "ตุ๊กตุ๊ก - Husky Pup",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle - Hybrid Explosion",
  T_34_JL_G36_MADBIONIC_N: "G36 - Flaring Bionica",
  T_34_JL_GRENADE_BIS_N: "ระเบิด - Soldier Pixel",
  T_34_JL_MACHETE_RAMPAGE4_N: "มีดพร้า - Night Blade",
  T_34_JL_THROWINGKNIFE_BANANA_N: "มีด - Banana",
  T_34_JL_UMP45_BIS_N: "UMP - Digital Dasher",
  T_34_LY_WS_ABS_DESC: "ดึงค่าคงที่จากเลขนี้",
  T_34_LY_WS_ADD_DESC: "เพิ่มองค์ประกอบใหม่ในส่วนท้ายของรายการ",
  T_34_LY_WS_AUTO_A: "สแกนศัตรูอัตโนมัติ",
  T_34_LY_WS_BOT: "ทั่วไป",
  T_34_LY_WS_BOT_PATH: "เส้นทาง",
  T_34_LY_WS_BOT_TYPE: "ประเภท",
  T_34_LY_WS_BOT4: "ขวาน",
  T_34_LY_WS_BOT5: "ทอสซิ่ง",
  T_34_LY_WS_BOT6: "ระเบิดตัวเอง",
  T_34_LY_WS_BOT8: "โล่",
  T_34_LY_WS_COL_DESC: "เลือกสี",
  T_34_LY_WS_DEL_DESC: "ลบองค์ประกอบที่เกี่ยวข้อง จากสารบัญในรายการ",
  T_34_LY_WS_DF_PER: "ป้องกัน %",
  T_34_LY_WS_FORT_INTERVAL: "ระยะเวลาการโจมตี (วินาที)",
  T_34_LY_WS_GET: "รับ",
  T_34_LY_WS_GET_DESC: "รับค่าองค์ประกอบ ที่เกี่ยวข้องในสารบัญที่เลือก จากรายการ",
  T_34_LY_WS_GLEN_ARR_DESC: "รับค่าจำนวนองค์ประกอบ จากรายการปัจจุบัน",
  T_34_LY_WS_GLEN_DESC: "ดึงข้อมูลความยาวของข้อความนี้",
  T_34_LY_WS_GVX: "ดึงข้อมูลองค์ประกอบ x ของเวกเตอร์",
  T_34_LY_WS_GVX_DESC: "ดึงข้อมูลองค์ประกอบแรกของเวกเตอร์",
  T_34_LY_WS_GVY: "ดึงข้อมูลองค์ประกอบ y ของเวกเตอร์",
  T_34_LY_WS_GVY_DESC: "ดึงข้อมูลองค์ประกอบที่สองของเวกเตอร์",
  T_34_LY_WS_GVZ: "ดึงข้อมูลองค์ประกอบ z ของเวกเตอร์",
  T_34_LY_WS_GVZ_DESC: "ดึงข้อมูลองค์ประกอบที่สามของเวกเตอร์",
  T_34_LY_WS_INDEX: "ข้อมูล",
  T_34_LY_WS_JOIN: "เชื่อมต่อ",
  T_34_LY_WS_NEG_DESC: "ดึงค่าลบของตัวเลขนี้",
  T_34_LY_WS_PATH: "Path Setter",
  T_34_LY_WS_PATH_DESC: "ใช้สำหรับ เพิ่ม/ลบ เส้นทางเดินของไอเทมที่มีชีวิต (ไม่สามารถใช้ได้ในโหมด 4v4, Team Deathmatch, และโหมด Playground)",
  T_34_LY_WS_POINT: "Marker",
  T_34_LY_WS_POINT_DESC: "ใช้สำหรับระบุตำแหน่ง ของตำแหน่งปัจจุบัน (ไม่สามารถใช้ได้ในโหมด 4v4, Team Deathmatch, และโหมด Playground)",
  T_34_LY_WS_RANGE_F: "ไกล",
  T_34_LY_WS_RANGE_M: "กลาง",
  T_34_LY_WS_RANGE_N: "ใกล้",
  T_34_LY_WS_RNDF_DESC: "สร้างทศนิยมแบบสุ่มจากช่วงเวลา",
  T_34_LY_WS_RNDI_DESC: "สร้างจำนวนเต็มแบบสุ่มจากช่วงเวลา",
  T_34_LY_WS_SET: "เซต",
  T_34_LY_WS_SET_DESC: "ตั้งค่า องค์ประกอบที่เกี่ยวข้องกับสารบัญที่เลือก ในรายการ",
  T_34_LY_WS_SQRT_DESC: "ดึงค่าสแคว์ รูทจากเลขนี้",
  T_34_LY_WS_STRC_DESC: "เชื่อมสองข้อความ",
  T_34_LY_WS_SVX: "ตั้งค่าองค์ประกอบเวกเตอร์ x",
  T_34_LY_WS_SVX_DESC: "ตั้งค่าองค์ประกอบแรกของเวกเตอร์",
  T_34_LY_WS_SVY: "ตั้งค่าองค์ประกอบเวกเตอร์y",
  T_34_LY_WS_SVY_DESC: "ตั้งค่าองค์ประกอบที่สองของเวกเตอร์",
  T_34_LY_WS_SVZ: "ตั้งค่าองค์ประกอบเวกเตอร์z",
  T_34_LY_WS_SVZ_DESC: "ตั้งค่าองค์ประกอบที่สามของเวกเตอร์",
  T_34_LY_WS_VADD: "เพิ่มเวกเตอร์",
  T_34_LY_WS_VADD_DESC: "เพิ่มสองเวกเตอร์",
  T_34_LY_WS_VAL_DESC: "เพิ่มจำนวนเต็ม หรือทศนิยม ตามสถานการณ์",
  T_34_LY_WS_VANG_DESC: "คำนวณมุมของสองเวกเตอร์",
  T_34_LY_WS_VCP: "Cross product",
  T_34_LY_WS_VCP_DESC: "ตำนวณสองเวกเตอร์ ด้วยการคูณเชิงเวกเตอร์",
  T_34_LY_WS_VDIS_DESC: "คำนวณระยะห่างระหว่าง สองเวกเตอร์",
  T_34_LY_WS_VDP: "Dot product",
  T_34_LY_WS_VDP_DESC: "คำนวณสองเวกเตอร์ ด้วยการคูณเชิงสเกลาร์",
  T_34_LY_WS_VFX1: "ทรงกลม",
  T_34_LY_WS_VFX2: "ทรงกระบอก",
  T_34_LY_WS_VFX3: "วงแหวน",
  T_34_LY_WS_VFX4: "ระเบิด",
  T_34_LY_WS_VFX5: "พิกเซล",
  T_34_LY_WS_VFX6: "ประกายไฟ",
  T_34_LY_WS_VMOD_DESC: "คำนวณขนาดของเวกเตอร์",
  T_34_LY_WS_VMUL: "คูณเวกเตอร์",
  T_34_LY_WS_VMUL_DESC: "คูณสองเวกเตอร์",
  T_34_LY_WS_VNOR_DESC: "ทำเวกเตอร์ให้เป็นมาตรฐาน",
  T_34_LY_WS_VSUB: "ลบเวกเตอร์",
  T_34_LY_WS_VSUB_DESC: "ผลลบของสองเวกเตอร์",
  T_34_M_WS_ANGLE: "หมุน",
  T_34_M_WS_ARRAY: "รายการ",
  T_34_M_WS_ATT: "คุณสมบัติ",
  T_34_M_WS_BOOL: "Boolean",
  T_34_M_WS_COLORARRAY: "สีอาเรย์",
  T_34_M_WS_COLOUR: "สี",
  T_34_M_WS_CONFRONBANNER: "แบนเนอร์ต่อสู้",
  T_34_M_WS_COORDINATE: "ตำแหน่ง",
  T_34_M_WS_CUSTOMINF: "ปรับแต่งอินเตอร์เฟท",
  T_34_M_WS_CUSTOMMODEDESC: `โหมดที่ว่างเปล่าและปรับแต่งได้เต็มที่โดยไม่มีการปรับแต่งล่วงหน้าของการเล่น คุณสามารถสร้างและเล่นตามกฎของคุณเอง
ค่อนข้างท้าทายสำหรับผู้สร้างแผนที่มือใหม่`,
  T_34_M_WS_DAMAGETYPE: "ประเภทความเสียหาย",
  T_34_M_WS_DAMAGETYPEDESC: "ประเภทความเสียหายปัจจุบัน เป็นค่าเริ่มต้นจากระบบ",
  T_34_M_WS_DESCTEXT: "ข้อความอธิบาย",
  T_34_M_WS_DURACTION: "ระยะเวลา",
  T_34_M_WS_ECAMODE: "โหมดปรับแต่ง",
  T_34_M_WS_ENDPHASEDESC: "จบช่วงเวลาปัจจุบัน และไปช่วงถัดไปโดยทันที",
  T_34_M_WS_ENTITY: "เอนทิตี้",
  T_34_M_WS_FLOAT: "ทศนิยม",
  T_34_M_WS_GAME: "เกม",
  T_34_M_WS_GAMERESULTS: "ผลการแข่ง",
  T_34_M_WS_GETCONTROL2: "ดึง Entity ควบคุมจากหน้าจอผู้เล่นเพื่อปรับแต่ง Entity และคุณสมบัติ (สามารถปรับดีไซน์ สี เนื้อหา และอื่น ๆ)",
  T_34_M_WS_HEIGHT: "ความสูง",
  T_34_M_WS_HUDBUTTONWIDGET: "ควบคุมปุ่ม",
  T_34_M_WS_HUDEMPTYWIDGET: "Empty pivot",
  T_34_M_WS_HUDIMAGEWIDGET: "ควบคุมภาพ",
  T_34_M_WS_HUDINPUTWIDGET: "ควบคุมกล่องข้อความ",
  T_34_M_WS_HUDLABELWIDGET: "ควบคุมข้อความ",
  T_34_M_WS_ICON: "ไอคอน",
  T_34_M_WS_ICON_AIM: "เล็ง",
  T_34_M_WS_ICON_ARROW: "ลูกศร",
  T_34_M_WS_ICON_BLAST: "ระเบิด",
  T_34_M_WS_ICON_CIRCULAR: "วงกลม",
  T_34_M_WS_ICON_CLOTH: "กระดาษ",
  T_34_M_WS_ICON_COLLIMATION: "เป้ายิง",
  T_34_M_WS_ICON_CORPSE: "ซอมบี้",
  T_34_M_WS_ICON_CROSS: "กางเขน",
  T_34_M_WS_ICON_DAY: "พระอาทิตย์",
  T_34_M_WS_ICON_DEFENSE: "โล่",
  T_34_M_WS_ICON_DIALOGUE: "ข้อความ",
  T_34_M_WS_ICON_DIAMONDS: "เพชร",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "เครื่องหมายตกใจ",
  T_34_M_WS_ICON_FLAG: "ธง",
  T_34_M_WS_ICON_FOLDER: "โฟลเดอร์",
  T_34_M_WS_ICON_GLASSES: "ดวงตา",
  T_34_M_WS_ICON_GUN: "ปืน",
  T_34_M_WS_ICON_HEART: "หัวใจ",
  T_34_M_WS_ICON_HEXAGON: "หกเหลี่ยม",
  T_34_M_WS_ICON_HOURGLASS: "นาฬิกาทราย",
  T_34_M_WS_ICON_HOUSE: "บ้าน",
  T_34_M_WS_ICON_KEY: "กุญแจ",
  T_34_M_WS_ICON_LIGHTNING: "สายฟ้า",
  T_34_M_WS_ICON_LOCK: "แม่กุญแจ",
  T_34_M_WS_ICON_LOOP: "ลูป",
  T_34_M_WS_ICON_MAGNIFIER: "แว่นขยาย",
  T_34_M_WS_ICON_MONEY: "เงิน",
  T_34_M_WS_ICON_MONTH: "พระจันทร์",
  T_34_M_WS_ICON_OPENFOLDER: "โฟลเดอร์เปิด",
  T_34_M_WS_ICON_PLUS: "สัญลักษณ์บวก",
  T_34_M_WS_ICON_QUADRI: "สี่เหลี่ยมคางหมู",
  T_34_M_WS_ICON_QUESTIONMARK: "เครื่องหมายคำถาม",
  T_34_M_WS_ICON_RECYCLING: "รีไซเคิล",
  T_34_M_WS_ICON_REFRESH: "รีเฟรช",
  T_34_M_WS_ICON_REST: "พักผ่อน",
  T_34_M_WS_ICON_RETURN: "กลับ",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "สี่เหลี่ยมคางหมูขวา",
  T_34_M_WS_ICON_SCISSORS: "กรรไกร",
  T_34_M_WS_ICON_SETUP: "ตั้งค่า",
  T_34_M_WS_ICON_SIGN: "มาร์ค",
  T_34_M_WS_ICON_SIGNOUT: "ออก",
  T_34_M_WS_ICON_SQUARE: "สี่เหลี่ยม",
  T_34_M_WS_ICON_STAR: "ดาว",
  T_34_M_WS_ICON_STONE: "ค้อน",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "ห่วงยาง",
  T_34_M_WS_ICON_TAGGING: "หมุด",
  T_34_M_WS_ICON_THESWORD: "ดาบ",
  T_34_M_WS_ICON_TRAPEZOID: "สี่เหลี่ยมคางหมู",
  T_34_M_WS_ICON_TRASHCAN: "ถังขยะ",
  T_34_M_WS_ICON_TRIANGLE: "สามเหลี่ยม",
  T_34_M_WS_ICON_TROPHY: "ถ้วยรางวัล",
  T_34_M_WS_ICON_UP: "ยกนิ้ว",
  T_34_M_WS_ICON_WRONG: "ผิด",
  T_34_M_WS_ICON_YES: "ขวา",
  T_34_M_WS_ICONNAME: "ชื่อไอคอน",
  T_34_M_WS_INT: "จำนวนเต็ม",
  T_34_M_WS_KILLZONE: "พื้นที่อันตราย",
  T_34_M_WS_LEFTCOLOR: "สีฝั่งซ้าย",
  T_34_M_WS_LEFTTEAMINDEX: "ข้อมูลทีมฝั่งซ้าย",
  T_34_M_WS_LEFTTEAMSCORE: "คะแนนทีมฝั่งซ้าย",
  T_34_M_WS_LOCSWITCH: "ปุ่มสลับภาษา",
  T_34_M_WS_MAX: "สูงที่สุด",
  T_34_M_WS_MIN: "น้อยที่สุด",
  T_34_M_WS_NUMBER: "ตัวเลข",
  T_34_M_WS_OBJECT: "เอนทิตี้",
  T_34_M_WS_OPEN: "เปิด",
  T_34_M_WS_OPENSATUS: "เปิดสถานะ",
  T_34_M_WS_PICTURE: "กราฟิก",
  T_34_M_WS_RANKARRAY: "อันดับ อาเรย์",
  T_34_M_WS_RESULTS: "ผล",
  T_34_M_WS_RIGHTCOLOR: "สีฝั่งขวา",
  T_34_M_WS_RIGHTTEAMINDEX: "ข้อมูลทีมฝั่งขวา",
  T_34_M_WS_RIGHTTEAMSCORE: "คะแนนทีมฝั่งขวา",
  T_34_M_WS_ROUNDBANNER: "แบนเนอร์รอบ",
  T_34_M_WS_ROUNDDESC: "คำอธิบายแบนเนอร์",
  T_34_M_WS_ROUNDHUD: "หมายเลขรอบ",
  T_34_M_WS_ROUNDPARAMS: "อาเรย์ หมายเลขรอบ",
  T_34_M_WS_SAME_NAME: "ชื่อซ้ำ",
  T_34_M_WS_SCOREARRAY: "อาเรย์ คะแนน",
  T_34_M_WS_SCORINGTYPE: "ประเภทคะแนน",
  T_34_M_WS_SCORINGTYPEDECS: "ประของคะแนนที่ผู้เล่นจะได้รับ สามารถปรับแต่งได้",
  T_34_M_WS_SCUFFLESCORING: "คะแนนหลายทีม",
  T_34_M_WS_SETATTRIBUTES: "ตั้งค่าคุณสมบัติ",
  T_34_M_WS_SHUT: "ปิด",
  T_34_M_WS_SOUND: "เสียงเอฟเฟ็ค",
  T_34_M_WS_SOUNDCLICK: "เสียงคลิก",
  T_34_M_WS_SOUNDDD: "นับถอยหลัง",
  T_34_M_WS_SOUNDFEMALEA: "เสียงบาดเจ็บ (ผู้หญิง)",
  T_34_M_WS_SOUNDM: "เสียงยิงปืน",
  T_34_M_WS_SOUNDMALEA: "เสียงบาดเจ็บ (ผู้ชาย)",
  T_34_M_WS_SOUNDUAV: "เสียงระเบิด",
  T_34_M_WS_ST_ASSISTCOUNT: "สนับสนุน",
  T_34_M_WS_ST_CHECKPROGRESS: "ตัวเช็คความคืบหน้า",
  T_34_M_WS_ST_DAMAGESUM: "ความเสียหาย",
  T_34_M_WS_ST_FINISHCOUNT: "จำนวนวัตถุประสงค์ที่บรรลุ",
  T_34_M_WS_ST_FINISHORDER: "ลำดับวัตถุประสงค์ที่บรรลุ",
  T_34_M_WS_ST_FINISHTIME: "เวลาวัตถุประสงค์ที่บรรลุ",
  T_34_M_WS_ST_KILLCOUNT: "สังหาร",
  T_34_M_WS_ST_MAINSCORE: "คะแนนเป้าหมาย",
  T_34_M_WS_ST_RANKSCORE: "คะแนนอันดับ",
  T_34_M_WS_ST_SURVIVALDURACTION: "เวลาเอาตัวรอด",
  T_34_M_WS_ST_UNKOWN: "ไม่ระบุ",
  T_34_M_WS_STARTBANNER: "แบนเนอร์เริ่ม",
  T_34_M_WS_STARTTIME: "เวลาเริ่ม",
  T_34_M_WS_STRING: "ช้อตวาม",
  T_34_M_WS_STUDIO: "สตูดิโอ",
  T_34_M_WS_TEAMARRAY: "อาเรย์ ทีม",
  T_34_M_WS_TEXTCONTENT: "เนื้อหา",
  T_34_M_WS_THEMECOLOR: "ธีมสี",
  T_34_M_WS_TIME: "HUD นับถอยหลัง",
  T_34_M_WS_TITLETEXT: "ข้อความหัวเรื่อง",
  T_34_M_WS_TYPE: "ประเภท",
  T_34_M_WS_UODATETYPE: "อัปเดตประเภท",
  T_34_M_WS_VARNAME: "ชื่อตัวแปร",
  T_34_M_WS_VECTOR: "เวกเตอร์",
  T_34_M_WS_VFX: "เอฟเฟ็กต์พิเศษ",
  T_34_M_WS_WIDTH: "ความกว้าง",
  T_34_MF_CHARACTER_TRACKER_N: "โฮเมอร์",
  T_34_PD_FlagBattle_HYPE_1: "ไฟ",
  T_34_SP_WS_BLOCK1_NAME: "เปลี่ยนช่วง",
  T_34_SP_WS_BLOCK1_NAMEDESC: "เปลี่ยนช่วงของเกม เพื่อเข้าสู่ช่วงที่ต้องการ (หรือรอบ) ในแต่ละรอบก็มีช่วงเวลาที่มีผลพิเศษเฉพาะช่วงเวลานั้น",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "ข้อมูลของช่วงที่เลือก",
  T_34_SP_WS_BLOCK10_NAME: "สร้างเอฟเฟ็กต์พิเศษ",
  T_34_SP_WS_BLOCK10_NAMEDESC: "สร้างไอคอนสำหรับเอฟเฟ็กต์พิเศษ สามารถเพิ่มคุณสมบัติให้กับเอฟเฟ็กต์พิเศษได้ใน Entity ของเอฟเฟ็กต์พิเศษ",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "เอฟเฟ็กต์พิเศษ",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "เอฟเฟ็กต์พิเศษที่สามารถใช้งานได้",
  T_34_SP_WS_BLOCK12_NAME: "ลบเอฟเฟ็กต์พิเศษ",
  T_34_SP_WS_BLOCK12_NAMEDESC: "ลบเอฟเฟ็กต์พิเศษที่เลือก",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Entity เอฟเฟ็กต์พิเศษ",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "เลือก Entity เอฟเฟ็กต์พิเศษที่ต้องการลบ",
  T_34_SP_WS_BLOCK13_NAMEDESC: "สั่งให้เอฟเฟ็กต์พิเศษทำงาน",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "รายชื่อผู้เล่น",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "ผู้เล่นที่จะได้รับข้อความ",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "เส้นทางทรัพยากร",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "ระบบเส้นทางทรัพยากร อยู่ในการปรับแต่งเส้นทางทรัพยากร ค่าเริ่มต้นคือว่างเปล่า",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "RGBA ค่าสีในแต่ละช่อง ระหว่าง 0 และ 255 บันทึกค่าสีในแบบ 32 ค่าเริ่มขึ้นคือสีขาว (255,255,255,255)",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "ซูม",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "ระดับการซูม : ค่าเริ่มต้นคือ 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "คำแหน่งการแสดงผลที่ต้องการให้แสดงบนโลก ค่าเริ่มต้นคือ เวกเตอร์ 3(0)",
  T_34_SP_WS_BLOCK14_NAME: "เล่นเสียงเอฟเฟ็กต์",
  T_34_SP_WS_BLOCK14_NAMEDESC: "สั่งให้เสียงเอฟเฟ็กต์ทำงาน",
  T_34_SP_WS_BLOCK15_NAME: "บันทึกการส่งออก",
  T_34_SP_WS_BLOCK15_NAMEDESC: "ส่งเนื้อหาออกไปยังหน้าต่างบันทึก",
  T_34_SP_WS_BLOCK2_NAMEDESC: "เปิดใช้งานความเสียหาย เมื่อผู้เล่นอยู่นอกเขตปลอดภัย",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "ศูนย์กลางของเขตปลอดภัย",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "รัศมี",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "รัศมีของเขตปลอดภัย",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "ระยะเวลานับถอยหลังก่อนที่วงจะเริ่มบีบ",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "ระยะเวลาบีบของวง",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "จำนวนความเสียหายเมื่ออยู่นอกเขตปลอดภัย",
  T_34_SP_WS_BLOCK3_NAMEDESC: "หากปิดความเสียหายนอกวง ผู้เล่นที่อยู่นอกพื้นที่ปลอดภัยจะไม่ได้รับความเสียหาย",
  T_34_SP_WS_BLOCK4_NAMEDESC: "ใช้สำหรับกำหนดแอคชั่นให้แสดงตามเวลาที่กำหนด",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "ระยะเวลาการรอ โดยมีหน่วยเป็นมิลลิวินาที",
  T_34_SP_WS_BLOCK5_NAMEDESC: "ใช้สำหรับรอแอคชั่นให้แสดงในเฟรมถัดไป",
  T_34_SP_WS_BLOCK6_NAME: "สร้างหน้าต่างพิเศษ",
  T_34_SP_WS_BLOCK6_NAMEDESC: "สร้างหน้าต่าง HUD แบบปรับแต่งพิเศษ",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "ชื่อที่ใช้สำหรับการสร้าง Entity HUD ตัวแปรที่กำหนดต้องสอดคล้องกับ Entity ของ HUD ที่สร้าง",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "ผู้เล่น",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "Entity ผู้เล่น",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "ข้อมูลของหน้าต่าง HUD",
  T_34_SP_WS_BLOCK7_NAMEDESC: "สร้างหน้าต่าง HUD แบบพื้นฐาน รูปแบบโดยทั่วไปสำหรับผู้เล่นทุกคน",
  T_34_SP_WS_BLOCK8_NAMEDESC: "เมื่อลบแล้ว จะไม่มีหน้าต่าง HUD แสดงในตัวเกม (ที่ไม่ใช่การซ่อนหรือการปิดใช้งาน)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD Entity",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "HUD Entity จะถูกลบ",
  T_34_SP_WS_BLOCK9_NAMEDESC: "เมื่อลบแล้ว หน้าต่าง HUD แบบพิเศษจะถูกลบออกจากตัวเกม (ที่ไม่ใช่การซ่อน หรือปิดการใช้งาน)",
  T_34_T_WS_BLOCK1_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อเริ่มเกม",
  T_34_T_WS_BLOCK10_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อมีการกำจัดผู้เล่น",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อผู้เล่นถูกกำจัด",
  T_34_T_WS_BLOCK13_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อผู้เล่นช่วยยิงสนับสนุนผู้เล่นอื่น",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อผู้เล่นถูกกำจัด",
  T_34_T_WS_BLOCK14_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อผู้เล่นสร้างความเสียหาย",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อผู้เล่นได้รับความเสียหาย",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "ประเภทความเสียหายที่เกิดขึ้น",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "จำนวนความเสียหายที่สร้างขึ้น",
  T_34_T_WS_BLOCK15_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่าง เมื่อมีผู้เล่นสังหาร ผู้เล่นอีกคนได้",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "ผู้เล่นที่ถูกกำจัด",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "ประเภทของความเสียหายที่ถูกกำจัด",
  T_34_T_WS_BLOCK16_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อผู้เล่นเข้าร่วมเกม",
  T_34_T_WS_BLOCK17_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อผู้เล่นถูกชุบ",
  T_34_T_WS_BLOCK18_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อมีการยุบทีม",
  T_34_T_WS_BLOCK19_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อมีการเพิ่มทีม",
  T_34_T_WS_BLOCK2_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อเกมสิ้นสุดลง",
  T_34_T_WS_BLOCK20_NAMEDESC: "เหตุการณ์จะเกิดขึ้น เมื่อทีมถูกจำกัดทั้งหมด",
  T_34_T_WS_BLOCK3_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อเริ่มรอบ",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "รอบจะเริ่มนับจาก 0",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "ข้อมูลรอบ",
  T_34_T_WS_BLOCK4_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อสิ้นสุดรอบ",
  T_34_T_WS_BLOCK5_NAMEDESC: "เหตุการณ์จะทำงาน เมื่อเริ่มช่วง",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "ช่วงที่ถูกกำหนดจะเริ่มจาก 0",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "Entity ช่วงเกม",
  T_34_T_WS_BLOCK6_NAMEDESC: "เหตุการณ์จะทำงาน เมื่อสิ้นสุดช่วง",
  T_34_T_WS_BLOCK7_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อผู้เล่นออกจากเกม",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "ผู้เล่นจะเป็นตัวทำให้เกิดเหตุการณ์บางอย่าง",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "ผู้เล่น",
  T_34_T_WS_BLOCK8_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อคะแนนของผู้เล่นเปลี่ยน",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "ประเภทของคะแนนที่ถูกเปลี่ยน",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "ค่าของคะแนนหลังการเปลี่ยนแปลง",
  T_34_T_WS_BLOCK9_NAMEDESC: "กำหนดให้เกิดเหตุการณ์บางอย่างเมื่อคะแนนทีมเปลี่ยน",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "ทีมจะเป็นตัวที่ทำให้เกิดเหตุการณ์",
  T_34_WT_WS_BORNENTITY_PARAM1: "จุดเกิด",
  T_34_WT_WS_BORNENTITY_PARAM2: "ตำแหน่งที่สามารถเลือกได้",
  T_34_WT_WS_BORNENTITY_PARAM3: "ตั้งเป็นจุดเกิดเริ่มต้น",
  T_34_WT_WS_BORNENTITY_PARAM4: "แสดงขอบเขต",
  T_34_WT_WS_BORNENTITY_PARAM5: "กำลังใช้งานอยู่หรือไม่",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "HUD เช็คพ้อยท์",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "เปิดสถานะ",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "ทำงานด้วยสถานะ",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "ทริกเกอร์การกำจัด หรือไม่",
  T_34_WT_WS_ENTITY_PARAM1: "Entity ของเกม",
  T_34_WT_WS_ENTITY_PARAM10: "จำนวนทีม",
  T_34_WT_WS_ENTITY_PARAM11: "จำนวนสมาชิก",
  T_34_WT_WS_ENTITY_PARAM12: "รีเซตอุปกรณ์ในแต่ละรอบ",
  T_34_WT_WS_ENTITY_PARAM13: "เปิดใช้งานความเสียหายนอกวง",
  T_34_WT_WS_ENTITY_PARAM14: "ขนาดวง",
  T_34_WT_WS_ENTITY_PARAM15: "ระยะเวลาวงบีบ",
  T_34_WT_WS_ENTITY_PARAM16: "ระยะเวลาวง",
  T_34_WT_WS_ENTITY_PARAM17: "ความเสียหายนอกวง",
  T_34_WT_WS_ENTITY_PARAM18: "คะแนน",
  T_34_WT_WS_ENTITY_PARAM19: "คะแนนสังหาร",
  T_34_WT_WS_ENTITY_PARAM2: "สถานะไม่ถูกค้อง",
  T_34_WT_WS_ENTITY_PARAM20: "ประเภทการชุบ",
  T_34_WT_WS_ENTITY_PARAM21: "เกณฑ์การจัดอันดับคะแนน (ผู้เล่น)",
  T_34_WT_WS_ENTITY_PARAM22: "เกณฑ์ความสำคัญ (ผู้เล่น)",
  T_34_WT_WS_ENTITY_PARAM23: "เกณฑ์การจัดอันดับคะแนน (ทีม)",
  T_34_WT_WS_ENTITY_PARAM24: "เกณฑ์ความสำคัญ (ทีม)",
  T_34_WT_WS_ENTITY_PARAM25: "เกณฑ์การจัดอันดับคะแนน (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "เกณฑ์ความสำคัญ (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "คะแนนอันดับ",
  T_34_WT_WS_ENTITY_PARAM28: "แสดงเกณฑ์ในหน้าผลลัพธ์",
  T_34_WT_WS_ENTITY_PARAM29: "รอบทั้งหมด",
  T_34_WT_WS_ENTITY_PARAM3: "ระยะเวลาเกม",
  T_34_WT_WS_ENTITY_PARAM4: "ข้อมูลรอบปัจจุบัน",
  T_34_WT_WS_ENTITY_PARAM5: "ข้อมูลด่านปัจจุบัน",
  T_34_WT_WS_ENTITY_PARAM6: "โหมด Template ID",
  T_34_WT_WS_ENTITY_PARAM7: "เปิดใช้งานชุบผู้เล่น",
  T_34_WT_WS_ENTITY_PARAM8: "เปิดใช้งานชุบบอท",
  T_34_WT_WS_ENTITY_PARAM9: "ระยะเวลาการชุบ",
  T_34_WT_WS_ENTITY1_NAME: "Entity ปัจจุบัน",
  T_34_WT_WS_ENTITY1_NAMEDESC: "กลับไปที่ Entity ปัจจุบัน",
  T_34_WT_WS_ENTITY10_NAME: "ลบไอคอน",
  T_34_WT_WS_ENTITY10_NAMEDESC: "ลบไอคอนที่เลือก",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "เลือกไอคอนที่ต้องการลบ",
  T_34_WT_WS_ENTITY11_NAME: "ลบข้อความ",
  T_34_WT_WS_ENTITY11_NAMEDESC: "ลบ Entity ข้อความ",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "เลือกข้อความที่ต้องการลบ",
  T_34_WT_WS_ENTITY12_NAMEDESC: "เพิ่มไอเทมให้ผู้เล่นที่กำหนด",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "ผู้เล่นจะได้รับไอเทม",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "ID ไอเทม ที่จะได้รับ",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "จำนวนไอเทมที่ต้องการมอบ",
  T_34_WT_WS_ENTITY12_PARAM3: "จำนวน",
  T_34_WT_WS_ENTITY13_PARAM1: "ประเภท",
  T_34_WT_WS_ENTITY13_PARAM2: "ตำแหน่ง",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "ตำแหน่งที่ต้องการเรียกวัตถุออกมา",
  T_34_WT_WS_ENTITY13_PARAM4: "วัตถุ",
  T_34_WT_WS_ENTITY14_NAME: "ลบวัตถุ",
  T_34_WT_WS_ENTITY14_NAMEDESC: "ลบวัตถุที่กำหนด",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "ลบวัตถุ",
  T_34_WT_WS_ENTITY15_NAMEDESC: "ดึงข้อมูล Entity ของผู้เล่นทั้งหมด",
  T_34_WT_WS_ENTITY16_NAMEDESC: "ดึงข้อมูล Entity ทีมทั้งหมด",
  T_34_WT_WS_ENTITY17_NAMEDESC: "ฟื้นฟู HP ตามจำนวนที่กำหนดให้กับผู้เล่น ถ้าหากจำนวน HP ฟื้นฟูที่กำหนดสูงกว่าค่าสูงสุด HP จะฟื้นฟูแค่ถึงค่าสูงสุดเท่านั้น",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "ผู้เล่นจะถูกปรับค่า HP ตามที่กำหนด",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "จำนวน HP ที่จะได้รับการฟื้นฟู",
  T_34_WT_WS_ENTITY18_NAME: "รับค่าสุ่ม พิกัดจุดเกิด",
  T_34_WT_WS_ENTITY18_NAMEDESC: "ตั้งค่าตำแหน่งจุดเกิดให้กับผู้เล่นที่เลือก",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "ผู้เล่นจะเกิดแบบสุ่ม ในพื้นที่บริเวณนี้",
  T_34_WT_WS_ENTITY18_RETURNDESC: "พิกัดของตำแหน่งที่จะกำหนดให้ผู้เล่น",
  T_34_WT_WS_ENTITY19_NAME: "คะแนนผู้เล่น",
  T_34_WT_WS_ENTITY19_NAMEDESC: "ดึงข้อมูลคะแนนของผู้เล่นที่กำหนด",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "ดึงข้อมูล Entity คะแนนของผู้เล่น",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "รับประเภทคะแนน",
  T_34_WT_WS_ENTITY19_RETURNDESC: "จะได้รับค่าคะแนนเฉพาะ",
  T_34_WT_WS_ENTITY2_NAME: "ตั้งคุณสมบัติ",
  T_34_WT_WS_ENTITY2_NAMEDESC: "ปรับค่าคุณสมบัติ ของคุณสมบัติที่เลือก",
  T_34_WT_WS_ENTITY2_PARAM1: "เอนทิตี้",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "ค่าคุณสมบัติของ Entity ของเกม",
  T_34_WT_WS_ENTITY2_PARAM3: "คุณสมบัติ",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "คุณสมบัติของ Entity นั้น ๆ",
  T_34_WT_WS_ENTITY2_PARAM4: "ค่า",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "ค่าเฉพาะของคุณสมบัติ ตรวจสอบให้แน่ใจว่าประเภทคุณสมบัติตรงกับประเภทที่เลือกและตรงกับประเภทที่กำหนดค่าไว้ในบล็อกที่เกี่ยวข้อง",
  T_34_WT_WS_ENTITY20_NAMEDESC: "ตั้งค่าคะแนนให้กับผู้เล่นที่กำหนด",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "ตั้งค่า Entity คะแนนให้กับผู้เล่น",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "ตั้งค่าประเภทคะแนน",
  T_34_WT_WS_ENTITY20_PARAM3: "คะแนน",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "คะแนนที่ถูกตั้งค่าเอาไว้",
  T_34_WT_WS_ENTITY21_NAME: "รับคะแนนรวมของทีม",
  T_34_WT_WS_ENTITY21_NAMEDESC: "รับค่าคะแนนรวม ของทีมที่เลือก",
  T_34_WT_WS_ENTITY21_PARAM1: "ทีม",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "ดึงข้อมูล Entity คะแนนของทีม",
  T_34_WT_WS_ENTITY22_NAME: "ตั้งคะแนนทีมในรอบปัจจุบัน",
  T_34_WT_WS_ENTITY22_NAMEDESC: "ตั้งค่าคะแนนของรอบปัจจุบัน ให้กับทีมที่เลือก",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "ตั้งค่าคะแนนให้กับทีม",
  T_34_WT_WS_ENTITY23_NAME: "ดึงข้อมูลในรอบของผู้เล่น",
  T_34_WT_WS_ENTITY23_NAMEDESC: "ดึงข้อมูลรอบนั้น ๆ ของผู้เล่นที่กำหนด",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "ดึงข้อมูลในรอบนั้น ๆ ของผู้เล่น",
  T_34_WT_WS_ENTITY23_PARAM2: "รอบ",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "ดึงข้อมูลคะแนนในรอบนี้",
  T_34_WT_WS_ENTITY24_NAME: "ดึงข้อมูลในรอบของทีม",
  T_34_WT_WS_ENTITY24_NAMEDESC: "ดึงข้อมูลในรอบนั้น ๆ ของทีมที่กำหนด",
  T_34_WT_WS_ENTITY25_NAME: "เทเลพอร์ต",
  T_34_WT_WS_ENTITY25_NAMEDESC: "เทเลพอร์ตผู้เล่นที่กำหนด ไปยังตำแหน่งที่กำหนด",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "เทเลพอร์ตผู้เล่น",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "ตำแหน่งที่จะเทเลพอร์ตผู้เล่นไป",
  T_34_WT_WS_ENTITY26_NAMEDESC: "เปิดให้ผู้เล่นสามารถสร้างความเสียหายแก่เป้าหมายได้ ถ้าหากไม่ได้เลือกผู้เล่นจู่โจม เป้าหมายที่กำหนดจะได้รับความเสียหายจากระบบแทน",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Entity อาการบาดเจ็บ",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "จำนวนความเสียหายที่ทำได้",
  T_34_WT_WS_ENTITY28_NAMEDESC: "ชุบชีวิตผู้เล่นที่กำหนด",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "Entity ผู้เล่นที่สามารถชุบชีวิตได้",
  T_34_WT_WS_ENTITY3_NAMEDESC: "ปรับประเภทของบล็อก",
  T_34_WT_WS_ENTITY3_PARAM1: "เป็น",
  T_34_WT_WS_ENTITY4_NAME: "ได้รับคุณสมบัติ",
  T_34_WT_WS_ENTITY4_NAMEDESC: "รับคุณสมบัติของ Entity นั้น ๆ",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "ดึง Entity ของเกมตามค่าคุณสมบัติที่ระบุ",
  T_34_WT_WS_ENTITY4_RETURNDESC: "จะได้รับค่าคุณสมบัติเฉพาะ",
  T_34_WT_WS_ENTITY5_NAMEDESC: "เปิดการเคลื่อนไหวให้ผู้เล่นทั้งหมด",
  T_34_WT_WS_ENTITY6_NAME: "สร้างไอคอน",
  T_34_WT_WS_ENTITY6_PARAM1: "ไอคอน",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "ภาพที่จะแสดงใน หน้าต่างเกม สามารถเลือกรูปแบบได้หลากหลาย",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "เลือกไอคอนที่ต้องการใช้",
  T_34_WT_WS_ENTITY7_NAMEDESC: "สร้าง HUD ไอคอน ให้กับผู้เล่นที่กำหนด หากไม่ได้ทำการเลือก Entity ผู้เล่น จะทำการสร้าง HUD ไอคอนให้กับผู้เล่นทั้งหมด",
  T_34_WT_WS_ENTITY7_PARAM1: "ผู้เล่น",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "สร้าง หน้าต่างไอคอนสำหรับผู้เล่นที่เลือก",
  T_34_WT_WS_ENTITY8_NAME: "เพิ่มข้อความ",
  T_34_WT_WS_ENTITY8_PARAM1: "ข้อความ",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "เนื้อหาของข้อความ ที่จะถูกสร้างด้วยคำสั่งนี้",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "Entity ข้อความ ที่ถูกสร้าง",
  T_34_WT_WS_ENTITY9_NAMEDESC: "เพิ่มหน้าต่างข้อความ ให้กับผู้เล่นที่กำหนด ถ้าหาไม่ได้ทำการเลือกผู้เล่นจะทำการสร้างหน้าต่างข้อความให้กับผู้เล่นทั้งหมด",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "เพิ่มหน้าต่างข้อความ ให้กับผู้เล่นที่เลือก",
  T_34_WT_WS_ICONENTITY_PARAM1: "ไอคอน",
  T_34_WT_WS_ICONENTITY_PARAM2: "ดีไซน์",
  T_34_WT_WS_ICONENTITY_PARAM3: "สี",
  T_34_WT_WS_ICONENTITY_PARAM4: "ขนาด",
  T_34_WT_WS_ICONENTITY_PARAM5: "ตำแหน่งที่แสดง",
  T_34_WT_WS_ICONENTITY_PARAM6: "ติดตามเป้าหมาย",
  T_34_WT_WS_ICONENTITY_PARAM7: "มองเห็นทะลุกำแพง",
  T_34_WT_WS_ICONENTITY_PARAM8: "แสดงบนหน้าจอเสมอ",
  T_34_WT_WS_ONETEAM_TAG: "ทีมเดี่ยว",
  T_34_WT_WS_PHASEENTITY_PARAM1: "ด่าน",
  T_34_WT_WS_PHASEENTITY_PARAM2: "ข้อมูลด่าน",
  T_34_WT_WS_PHASEENTITY_PARAM3: "เวลาเริ่ม",
  T_34_WT_WS_PHASEENTITY_PARAM4: "เวลาจบ",
  T_34_WT_WS_PHASEENTITY_PARAM5: "ระยะเวลา",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "ผู้เล่น",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "จุดชุบชีวิต",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "อัตราส่วนความเสียหาย",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "โมเดลตัวละคร 3D",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "ตัวตน",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "HP ปัจจุบัน",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "HP สูงสุด",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "ถูกกำจัด หรือไม่",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "ระยะเวลาเอาตัวรอด",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "อมตะ",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "ทีม",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "ID เช็คพ้อยท์ที่เลือก",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "จุดเกิด",
  T_34_WT_WS_PROCIRCLE_ICON: "ไอคอน",
  T_34_WT_WS_PVEDESC1: "ขอแค่ผู้เล่นเพียง 1 คนของทีม เข้าเส้นชัยได้ก่อนเวลาหมด ทีมนั้นจะเป็นฝ่ายชนะ แต่ถ้าเกิดผู้เล่นทุกคนถูกกำจัดหมดก่อน จะแพ้ทันที",
  T_34_WT_WS_PVEDESC2: "เอาตัวรอดให้ถึงเวลาที่กำหนด ถ้าเกิดผู้เล่นถูกกำจัดทั้งหมดพร้อมกัน เกมจบทันที",
  T_34_WT_WS_PVENAME1: "Rush",
  T_34_WT_WS_PVENAME2: "Endurance",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "ID เช็คพ้อยท์ปัจจุบัน",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "จำนวนเช็คพ้อยท์ในฟรีรันนิ่งโหมด",
  T_34_WT_WS_SKILLSET14: "Swordsman's Wrath (เคนตะ)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "ทีม",
  T_34_WT_WS_TEAMENTITY_PARAM2: "Ace",
  T_34_WT_WS_TEAMENTITY_PARAM3: "สมาชิกทั้งหมด",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "การทำงานแบบปกติ",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "ประเภท รูปลักษณ์",
  T_34_WT_WS_TXTENTITY_PARAM1: "ข้อความ",
  T_34_WT_WS_TXTENTITY_PARAM2: "เนื้อหา",
  T_34_WT_WS_VFXENTITY_PARAM1: "Entity เอฟเฟ็กต์พิเศษ",
  T_34_WZ_WS_LOGIC10_NAME: "ไปต่อที่",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "ข้ามการวนซ้ำปัจจุบัน และดำเนินการต่อ",
  T_34_WZ_WS_LOGIC11_NAME: "กลับ",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "ยุติการดำเนินการปัจจุบันและกลับสู่โปรแกรมหลัก อนุญาตให้ส่งข้อมูลกลับ เมื่อกลับมา",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "คืนค่า",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "ข้อมูลที่ต้องการส่งกลับไปยังโปรแกรมหลัก",
  T_34_WZ_WS_LOGIC2_NAME: "เปรียบเทียบ",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "เปรียบเทียบ 2 ค่า โดยใช้สัญลักษณ์ที่กำหนด",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "ค่าซ้าย",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "ค่าด้านซ้ายใช้สำหรับเปรียบเทียบ",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "ฟังค์ชั่นเปรียบเทียบ",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "เลือกวิธีที่คุณต้องการเปรียบเทียบค่า สัญลักษณ์ที่ใช้ได้: >, ≥, ==, ≠, ≤, <, AND (เฉพาะ Boolean เท่านั้น), OR (เฉพาะ Boolean เท่านั้น)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "ค่าที่เหมาะสม",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "ค่าทางด้านขวา ใช้สำหรับเปรียบเทียบ",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "ผลการเปรียบเทียบ",
  T_34_WZ_WS_LOGIC3_NAME: "NOT",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "ให้ค่าตรรกะย้อนหลัง",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "ค่าที่คุณต้องการใช้ ในการคำนวณ NOT",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "ผลลัพธ์จากการไม่ใส่สัญลักษณ์",
  T_34_WZ_WS_LOGIC4_NAME: "เช็คค่าว่าง",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "เช็ค Entity ว่างเปล่า",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "เอนทิตี้",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "ตัวตรวจเช็ค Entity ว่าง",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "ไม่ว่า Entity จะว่างเปล่าหรือไม่",
  T_34_WZ_WS_LOGIC5_NAME: "ถ้า",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "ดำเนินการตามเงื่อนไขว่าเป็นไปตามเงื่อนไขหรือไม่ กระบวนการย่อยจะเหมือนกับสาขาตรรกะที่ตามมา",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "ค่า",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "จำนวนเงื่อนไขและจำนวน กระบวนการย่อย (logic branches) ต้องเท่ากัน",
  T_34_WZ_WS_LOGIC6_NAME: "ลูปของช่วงจำนวนเต็ม",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "วนจาก x ถึง y ทีละขั้นของ z กระบวนการย่อยคือการวนซ้ำ",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "ชื่อของดัชนีลูป ที่ใช้ดึงค่าดัชนีลูปตัวแปรในเครื่อง",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "ค่าเริ่มต้น",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "ค่า เมื่อลูปเริ่มต้น",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "ค่าสิ้นสุด",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "ค่า เมื่อสิ้นสุดการลูป",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "ขั้นตอน",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "ขั้นตอนของแต่ละ loop เมื่อค่าเริ่มต้นน้อยกว่าค่าสิ้นสุด ขั้นตอนควรมีมากกว่า 0 เมื่อค่าเริ่มต้นมากกว่าค่าสิ้นสุด ขั้นตอนควรน้อยกว่า 0",
  T_34_WZ_WS_LOGIC7_NAME: "ลูปของช่วงคอนเทนเนอร์",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "เปิดใช้งานการโอนย้ายข้อมูล ไปยังองค์ประกอบย่อยของกระบวนการในลูป",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "องค์ประกอบ",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "การข้ามไปยังชื่อนี้ จะดึงค่าองค์ประกอบย่อยของตัวแปรในเครื่อง",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "ที่เก็ยข้อมูล",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "ที่เก็บข้อมูลสำหรับค้นหา ปัจจุบัน รองรับการค้นหาประเภทรายการ",
  T_34_WZ_WS_LOGIC8_NAME: "ลูปแบบมีเงื่อนไข",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "วนซ้ำแบบมีเงื่อนไขจนกว่าจะตรงตามเงื่อนไข หยุดเมื่อเงื่อนไขเป็นเท็จ",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "เงื่อนไข",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "วนซ้ำหากเงื่อนไขเป็นจริง และหยุดจนกว่าเงื่อนไขจะเป็นเท็จ",
  T_34_WZ_WS_LOGIC9_NAME: "ออกจากลูป",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "หยุดกระบวนการลูปปัจจุบัน และกระโดดออกจากลูป",
  T_34_Y_B_DINOSAURS: "Dinosaur Illusion (กางเกง)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Pure Angel (ผู้หญิง)",
  T_34_YS_F_B_PANDACATTLE: "Moo Zoo (กางเกง)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Aqua Rogue (กางเกง)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Aqua Rogue (ทรงผม)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Aqua Rogue (ลายเพ้นท์)",
  T_34_YS_F_S_PANDACATTLE: "Moo Zoo (รองเท้า)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Aqua Rogue (รองเท้า)",
  T_34_YS_F_T_PANDACATTLE: "Moo Zoo (เสื้อ)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Aqua Rogue (เสื้อ)",
  T_34_YS_M_B_ANGEL_BW: "Pure Angel (ผู้ชาย)",
  T_34_YS_M_B_PANDACATTLE: "Panda Pyjamas (กางเกง)",
  T_34_YS_M_H_PANDACATTLE: "Panda Pyjamas (ทรงผม)",
  T_34_YS_M_S_PANDACATTLE: "Panda Pyjamas (รองเท้า)",
  T_34_YS_M_T_PANDACATTLE: "Panda Pyjamas (เสื้อ)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "รับ [FFB300]{0} EP[-] เมื่อทำการล้มศัตรูได้",
  T_35_DY_PET_OWL_N: "ฮูท",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "สกินคู่หู : Spaceship Moony",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "สกินคู่หู : Azulcrema Trace ซาซิล",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "สกินคู่หู : Agui Blue",
  T_35_DY_PETSKIN_OWL_FIRE_N: "สกินคู่หู : Hoot On Fire",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "สกินคู่หู : Nocturnal Hoot",
  T_35_DY_PETSKIN_OWL_STORM_N: "สกินคู่หู : Frosty Hoot",
  T_35_JL_KNOCKEDDOWN: "ถูกล้ม",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "ใน [FFB300]{1}วิ[-] ยิงไอซ์วอลล์ เพื่อแสดงตำแหน่งของศัตรูที่อยู่ในระยะ [FFB300]{3} เมตร[-]ของไอซ์วอลล์ สามารถยิงทะลุไอซ์วอลล์เพื่อสร้างความเสียหายได้ (ความเสียหายที่ทำได้จะน้อยกว่าปกติ) สูงสุด [FFB300]{0}[-] ไอซ์วอลล์ คูลดาวน์ [FFB300]{2} วิ[-]",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "ทะลุทะลวง",
  T_35_KY_INFECTION_MAPNAME: "ดินแดนรกร้าง",
  T_35_M_WS_BUTTONCLICKDESC: "กระตุ้นเหตุการณ์นี้เมื่อกดปุ่มที่เกี่ยวข้อง ผู้เล่นที่กระตุ้นสามารถรับได้โดยใช้พารามิเตอร์",
  T_35_M_WS_GETTEAMMATEPOS: "แสดงตำแหน่งเพื่อนร่วมทีมใกล้เคียง",
  T_35_M_WS_ROUND2: "รอบปัจจุบัน",
  T_35_PD_Infection_HUMANSELECT: "เลือกอาวุธ",
  T_35_PD_INFECTION_MODENAME: "Droid Apocalypse",
  T_35_QX_WS_ICONTYPE_ITEM: "วัตถุ",
  T_35_QX_WS_ICONTYPE_NATURE: "รูปร่างของธรรมชาติ",
  T_35_QX_WS_ICONTYPE_SHAPE: "เรขาคณิต",
  T_35_QX_WS_ICONTYPE_SYMBOL: "สัญลักษณ์",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "อาวุธ",
  T_35_R_EMOTE_TAG_MUSIC_N: "Music",
  T_35_RW_SKILL_DESC_Singers: "ผู้ใช้และเพื่อนร่วมทีมในระยะ [FFB300]{0} เมตร[-]  สามารถป้องกัน [FFB300]{1}%[-]  ของความเสียหายโดยการใช้ EP ค่า EP ที่ลดลงของเพื่อนร่วมทีม จะถูกเพิ่มให้กับเจ้าของสกิล",
  T_35_RW_SKILL_NAME_Singers: "EP ไร้เสียง",
  T_35_SP_WS_COMMENTKEY_01: "ความยากที่เหมาะสม",
  T_35_SP_WS_COMMENTKEY_02: "มีความคิดสร้างสรรค์",
  T_35_SP_WS_COMMENTKEY_03: "รูปแบบน่าสนใจ",
  T_35_SP_WS_COMMENTKEY_04: "เล่นซ้ำได้ไม่มีเบื่อ",
  T_35_SP_WS_COMMENTKEY_05: "เนื้อเรื่องน่าติดตาม",
  T_35_SP_WS_COMMENTKEY_06: "สมดุลย์ดีมาก",
  T_35_SP_WS_COMMENTKEY_07: "สนุก",
  T_35_SP_WS_COMMENTKEY_08: "มีความยืดหยุ่น",
  T_35_SP_WS_COMMENTKEY_09: "สุดยอดมาก",
  T_35_SP_WS_COMMENTKEY_10: "ยากเกินไป",
  T_35_SP_WS_COMMENTKEY_11: "ง่ายเกินไป",
  T_35_SP_WS_COMMENTKEY_12: "น่าเบื่อ",
  T_35_SP_WS_COMMENTKEY_13: "นานเกินไป",
  T_35_SP_WS_COMMENTKEY_14: "ไม่สมดุลย์",
  T_35_SP_WS_COMMENTKEY_15: "ไม่สนุก",
  T_35_SP_WS_IMAGE03: "พื้นผืว",
  T_35_SP_WS_IMAGE04: "กรอบ",
  T_35_SY_CHARGESHOT_TEARS_N: "Charge Buster - Lava Lustre",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "ระเบิด - Crystal Eerie",
  T_35_SY_GRENADE_PIRATES_N: "ระเบิด - Rowdy Searuler",
  T_35_SY_GRENADE_RIDERS_N: "ระเบิด - Grim Rider",
  T_35_SY_M24_KUN_N: "M24 - Riverdust Splasher",
  T_35_SY_SCAR_PARKOUR_N: "SCAR - Gusto Freerunner",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "รถจิ๊ป - Monochrome Jigsaw",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "มาฉลองกัน!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "มอเตอร์ไบค์ - Crystal Symmetry",
  T_35_WT_WS_PREFAB_MENUBAR_1: "ตกแต่งโครงสร้าง",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "โครสร้าง",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "อื่น ๆ",
  T_35_WT_WS_PREFAB_MENUBAR_2: "สถาปัตยกรรม",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "ตึกขนาดใหญ่",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "ตึกขนาดกลาง",
  T_35_WT_WS_PREFAB_MENUBAR_3: "วัตถุที่ใช้งานได้",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "วัตถุสำคัญ",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "เพลง",
  T_35_WT_WS_PVEMODE_TAG: "โหมดเอาตัวรอด",
  T_35_WZY_WS_BECRE_NAMEDESC: "ทำงานเมื่อ Entity ถูกสร้างขึ้น",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'Triggers เมื่อ Entity ถูกกำจัด ที่มาของการโจมตีสามารถระบุได้โดยการใช้ "Trigger Entity" และประเภทของการโจมตี สามารถระบุได้โดยการใช้ "Damage Type".',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "Entity ที่เป็นตัว Trigger เหตุการณ์",
  T_35_WZY_WS_CREPROP_NAMEDESC: "สร้างประเภทไอเทม หรือชุดของไอเทมในตำแหน่งที่กำหนด เมื่อสร้างประเภทของไอเทม จำนวน คือจำนวนที่ต้องการระบุให้กับไอเทม เมื่อสร้างชุดไอเทม จำนวน คือ จำนวนของชุดไอเทมที่ต้องการ ไอเทมที่ถูกสร้างขึ้นจะอิงจาก แผนที่",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "รายการที่ระบุไอเทมที่ถูกสร้างขึ้น สามารถเป็นชุดไอเทม หรือไอเทมชิ้นเดียวก็ได้",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "จำนวน ของรายการไอเทมที่เกี่ยวข้อง ในรายการอาจจะมีไอเทมประเภทเดียว",
  T_35_WZY_WS_DAMTYPE_CAR: "ยานพาหนะ",
  T_35_WZY_WS_DAMTYPE_FALL: "ตกจากที่สูง",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "ปืน",
  T_35_WZY_WS_DAMTYPE_GRENADE: "ระเบิด",
  T_35_WZY_WS_DAMTYPE_MELEE: "อาวุธประชิด",
  T_35_WZY_WS_DAMTYPE_ZONE: "นอกพื้นที่",
  T_35_WZY_WS_DELPROP_NAMEDESC: "ลบจำนวนไอเทมจากผู้เล่นที่กำหนด",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "เข้า  Trigger area",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'ทำงานเมื่อ "Trigger Entity" เข้าสู่ Trigger area',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "ผู้เล่นที่ต้องการดึงค่า Entity เมื่อลิ้งก์กับผู้เล่น ข้อมูลของ Entity  จะอัปเดตให้เฉพาะผู้เล่นที่เลือกเท่านั้น หากไม่ได้ทำการลิ้งค์ผู้เล่น จะรับข้อมูลของผู้เล่นทั้งหมด",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Battle Entity",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "รับค่าวัตถุทั้งหมด ตามประเภทที่กำหนด แสดงผลลัพธ์ในรายการ",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "ประเภทวัตถุ",
  T_35_WZY_WS_HUDWIDGET_NAME: "UI Control",
  T_35_WZY_WS_HURT_NAMEDESC: 'ทำงานเมื่อ Entity ได้รับความเสียหาย ที่มาของความเสียหายสามารถระบุได้โดยการตรจสอบ "Trigger Entity".',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "ประเภทของไอเทม",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Stage Object",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'ทำงาน เมื่อ Entity หนึ่งกำจัดอีก Entity หนึ่ง ประเภทของ Entity ที่ถูกกำจัด สามารถระบุได้โดยการตรวจสอบ "Entity ที่ถูกกำจัด".',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "Entity ที่ถูกกำจัด",
  T_35_WZY_WS_ONHURT_NAMEDESC: "ทำงานเมื่อ Entity สร้างความเสียหาย",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "Entity ที่สร้างความเสียหาย",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "เอนทิตี้ เป้าหมาย",
  T_35_WZY_WS_PREFABID_NAME: "Template ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "สิทธิ์ขั้นสูงปัจจุบัน",
  T_35_WZY_WS_PROPERTY_JUMP: "กระโดดสูง",
  T_35_WZY_WS_QUITTRIGGER_NAME: "ออกจาก Trigger area",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: "ทำงานเมื่อ Entity ที่กำหนด ออกจาก Trigger area",
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "ลบ องค์ประกอบที่เลือกจากรายการ [List] คือ รายการองค์ประกอบ [Element] คือ องค์ประกอบที่จะถูกลบ",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "ค่าขององค์ประกอบ",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "ค่าขององค์ประกอบที่ต้องการลบ",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Round Entity",
  T_35_WZY_WS_TOWER_PARAM1: "หอคอย และป้อมปราการ",
  T_35_WZY_WS_TOWER_PARAM2: "Team ID",
  T_35_WZY_WS_TOWER_PARAM3: "HP ปัจจุบัน",
  T_35_WZY_WS_TOWER_PARAM4: "HP สูงสุด",
  T_35_WZY_WS_TOWER_PARAM5: "ความเสียหาย",
  T_35_WZY_WS_TOWER_PARAM6: "ช่วงการโจมตี",
  T_35_WZY_WS_TOWER_PARAM7: "ระยะการโจมตี",
  T_35_WZY_WS_TOWER_PARAM8: "ป้องกัน %",
  T_35_XYL_PDM_REVENGE: "แก้แค้น",
  T_35_XYL_WS_BISPARTERRE: "แปลงดอกไม้ กราฟิตี้",
  T_35_XYL_WS_BISPARTERRE_DESC: "แปลงดอกไม้ ในแบบ Battle-In-Style",
  T_35_XYL_WS_BISWALL: "กำแพงกราฟิตี้",
  T_35_XYL_WS_BISWALL_DESC: "กำแพงในแบบ Battle-In-Style ที่สามารถรวมได้",
  T_35_XYL_WS_BOTDROP: "เปิด/ปิด เก็บของ",
  T_35_XYL_WS_CUSTOMTRIGGER: "Custom trigger",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "วางวัตถุที่จะ Trigger เอฟเฟ็กต์ปรับแต่งพิเศษ เมื่อมีผู้เล่นเปิดใช้งาน เอฟเฟ็กต์สามารถปรับแต่งได้ในสคริปท์ (เฉพาะในโหมดปรับแต่งเท่านั้น)",
  T_35_XYL_WS_DOUBLEDOOR: "ประตู",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "ประตูที่ถูกเปิดออก",
  T_35_XYL_WS_RESET: "รีเซตทุกรอบ",
  T_35_XYL_WS_RESETN: "ไม่",
  T_35_XYL_WS_RESETY: "ใช่",
  T_35_XYL_WS_ROADBLOCK: "แนวกั้น A",
  T_35_XYL_WS_ROADBLOCK_DESC: "ใช้กันสำหรับไม่ให้ผ่านไป",
  T_35_XYL_WS_STAIRS: "บันได",
  T_35_XYL_WS_STAIRS_DESC: "บันได ที่สามารถรวมกับจุดจอดได้",
  T_35_XYL_WS_STAIRSL: "จุดจอด B",
  T_35_XYL_WS_STAIRSL_DESC: "แพลตฟอร์มที่สามารถรวมกับบันไดได้",
  T_35_XYL_WS_STAIRSZ: "จุดจอด A",
  T_35_XYL_WS_STAIRSZ_DESC: "แพลตฟอร์มที่สามารถรวมกับบันไดได้",
  T_35_XYL_WS_TBOOTH: "ตู้โทรศัพท์",
  T_35_XYL_WS_TBOOTH_DESC: "พบเห็นได้ทั่วไปตามท้องถนน",
  T_35_YF_PP19_N: "Bizon",
  T_35_YS_A_CATEAM_HW: "Agui",
  T_35_YS_A_CUBBY: "Cub Mask",
  T_35_YS_F_A_PANTOMIME: "Two-toned Grief (หน้ากาก)",
  T_35_YS_F_A_RIDERS: "Fatal Rider (หน้ากาก)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Beauty Reuniter (กางเกง)",
  T_35_YS_F_B_GOLDCHAIN: "Armor of Riches (กางเกง)",
  T_35_YS_F_B_PANTOMIME: "Two-toned Grief (กางเกง)",
  T_35_YS_F_B_RIDERS: "Fatal Rider (กางเกง)",
  T_35_YS_F_H_BEAR_HW: "Cub Cap",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Beauty Reuniter (ทรงผม)",
  T_35_YS_F_H_GOLDCHAIN: "Armor of Riches (ทรงผม)",
  T_35_YS_F_H_PANTOMIME: "Two-toned Grief (ทรงผม)",
  T_35_YS_F_H_RIDERS: "Fatal Rider (ทรงผม)",
  T_35_YS_F_HA_GOLDCHAIN: "Armor of Riches (ลายเพ้นท์)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Beauty Reuniter (รองเท้า)",
  T_35_YS_F_S_GOLDCHAIN: "Armor of Riches (รองเท้า)",
  T_35_YS_F_S_PANTOMIME: "Two-toned Grief (รองเท้า)",
  T_35_YS_F_S_RIDERS: "Fatal Rider (รองเท้า)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Beauty Reuniter (เสื้อ)",
  T_35_YS_F_T_GOLDCHAIN: "Armor of Riches (เสื้อ)",
  T_35_YS_F_T_PANTOMIME: "Two-toned Grief (เสื้อ)",
  T_35_YS_F_T_RIDERS: "Fatal Rider (เสื้อ)",
  T_35_YS_ITEM_SUPERFAK: "Super Med",
  T_35_YS_M_A_GOLDCHAIN: "Chainz of Lux (หน้ากาก)",
  T_35_YS_M_A_RIDERS: "Grim Rider (หน้ากาก)",
  T_35_YS_M_B_GOLDCHAIN: "Chainz of Lux (กางเกง)",
  T_35_YS_M_B_RIDERS: "Grim Rider (กางเกง)",
  T_35_YS_M_H_BEAR_HW: "Cub Cap",
  T_35_YS_M_H_GOLDCHAIN: "Chainz of Lux (ทรงผม)",
  T_35_YS_M_H_RIDERS: "Grim Rider (ทรงผม)",
  T_35_YS_M_S_GOLDCHAIN: "Chainz of Lux (รองเท้า)",
  T_35_YS_M_S_RIDERS: "Grim Rider (รองเท้า)",
  T_35_YS_M_T_GOLDCHAIN: "Chainz of Lux (เสื้อ)",
  T_35_YS_M_T_RIDERS: "Grim Rider (เสื้อ)",
  T_35_YS_T_CHAMPION: "เสื้อยืด Atack All Around",
  T_35_YS_T_PAINTING: "ผมรัดคุณ",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "ไอริส",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "เหรียญที่ได้รับ เมื่อเกมเริ่ม",
  T_36_JH_WS_CESAYCLOSE: "เปิดใช้งานระบบ เปิด/ปิด เองหรือไม่",
  T_36_JH_WS_CHOOSEEDITSHOP: "เลือกร้านค้าที่ต้องการแก้ไข",
  T_36_JH_WS_CHOOSESHOP: "เลือกร้านค้า",
  T_36_JH_WS_COINCOUNT: "จำนวนเงิน",
  T_36_JH_WS_COINHUD: "แสดงจำนวนเหรียญ หรือไม่",
  T_36_JH_WS_CRAFTSHOP: "แก้ไขร้านค้า",
  T_36_JH_WS_CREATEGOLD: "เครื่องสร้างเหรียญ",
  T_36_JH_WS_CSHOPENTITY: "Entity ร้านค้าที่ผูก",
  T_36_JH_WS_CSHOPHUD: "หน้าต่างร้านค้า",
  T_36_JH_WS_CURRENTLIMIT: "จำนวนที่สามารถซื้อได้",
  T_36_JH_WS_ECONOMIC: "ระบบเงินในเกม",
  T_36_JH_WS_INGAMEECONOMI: "ระบบเงินในเกม",
  T_36_JH_WS_ITEMINDEXID: "จำนวนสินค้า",
  T_36_JH_WS_KILLMONEY: "รับเหรียญ จากการกำจัด",
  T_36_JH_WS_KILLMONEYTIP: "จำนวนเหรียญที่จะได้รับจากการกำจัดซอมบี้ ในโหมดคนเดือด และโหมดเอาตัวรอด",
  T_36_JH_WS_LISTINDEX: "รายการประเภทสินค้า",
  T_36_JH_WS_NULL: "ว่างเปล่า",
  T_36_JH_WS_NUMBER: "จำนวน",
  T_36_JH_WS_OPTIONNAME: "เฉพาะโหมด Droid Apocalypse",
  T_36_JH_WS_REALSHOPENTITY: "Entity ร้านค้า",
  T_36_JH_WS_SEEORHIDE: "แสดงตู้กดอัตโนมัติ",
  T_36_JH_WS_SHOPFRONT: "ร้านค้า",
  T_36_JH_WS_SHOPITEMLIST: "ประเภทสินค้า",
  T_36_JH_WS_SHOPOPENCON: "สถานะ เปิด",
  T_36_JH_WS_SSHOPNAME: "ชื่อร้าน",
  T_36_JH_WS_TOTALLIMIT: "จำกัดการซื้อ",
  T_36_JH_WS_TRIGGERWIDE: "ระยะทำงาน",
  T_36_JH_WS_VENDMACHINE: "ตู้กดอัตโนมัติ",
  T_36_JH_WS_WINMONEY: "รับเหรียญ จากชัยชนะ",
  T_36_JH_WS_WORTH: "สุดคุ้ม",
  T_36_JL_FOREGRIP_MR_N: "Marksman grip",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "พานท้ายลูกซอง",
  T_36_JL_STOCK_SR_N: "พานท้ายสไนเปอร์",
  T_36_KK_WS_MONTSTERDES: "รถ 4 ที่นั่ง ความทนทานสูง สามารถลุยได้ทุกพื้นผิว",
  T_36_M_WS_SETTEMPVAR: "ตั้งค่าตัวแปรชั่วคราว",
  T_36_M_WS_TEMPVAR: "ตัวแปรชั่วคราว",
  T_36_SY_AK47_MAMBAS_N: "AK47 - Mamba Gnaw",
  T_36_SY_AN94_MAMBAS_N: "AN94 - Mamba Gnaw",
  T_36_SY_AR15_MAMBAS_N: "Kingfisher - Mamba Gnaw",
  T_36_SY_AUG_MAMBAS_N: "AUG - Mamba Gnaw",
  T_36_SY_AWM_MAMBAS_N: "AWM - Mamba Gnaw",
  T_36_SY_BLT_MAMBAS_N: "M82B - Mamba Gnaw",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Charge Buster - Mamba Gnaw",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle - Mamba Gnaw",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS - Mamba Gnaw",
  T_36_SY_G18_MAMBAS_N: "G18 - Mamba Gnaw",
  T_36_SY_G36_MAMBAS_N: "G36 - Mamba Gnaw",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "ระเบิด - Navy Festivity",
  T_36_SY_GROZA_MAMBAS_N: "Groza - Mamba Gnaw",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Hand Cannon - Mamba Gnaw",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Heal Sniper- Mamba Gnaw",
  T_36_SY_ICE_GUN_MAMBAS_N: "Ice Gun - Mamba Gnaw",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k - Mamba Gnaw",
  T_36_SY_KORD_MAMBAS_N: "Kord - Mamba Gnaw",
  T_36_SY_M1014_MAMBAS_N: "M1014 - Mamba Gnaw",
  T_36_SY_M14_MAMBAS_N: "M14 - Mamba Gnaw",
  T_36_SY_M1873_MAMBAS_N: "M1873 - Mamba Gnaw",
  T_36_SY_M1887_MAMBAS_N: "M1887 - Mamba Gnaw",
  T_36_SY_M1917_MAMBAS_N: "M1917 - Mamba Gnaw",
  T_36_SY_M21A5_MAMBAS_N: "Woodpecker - Mamba Gnaw",
  T_36_SY_M24_MAMBAS_N: "M24 - Mamba Gnaw",
  T_36_SY_M249_MAMBAS_N: "M249 - Mamba Gnaw",
  T_36_SY_M4A1_MAMBAS_N: "M4A1 - Mamba Gnaw",
  T_36_SY_M500_MAMBAS_N: "M500 - Mamba Gnaw",
  T_36_SY_M60_MAMBAS_N: "M60 - Mamba Gnaw",
  T_36_SY_M79_MAMBAS_N: "M79 - Mamba Gnaw",
  T_36_SY_MAC10_MAMBAS_N: "MAC10 - Mamba Gnaw",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7 - Mamba Gnaw",
  T_36_SY_MINI_MAMBAS_N: "AC80 - Mamba Gnaw",
  T_36_SY_MP40_MAMBAS_N: "MP40 - Mamba Gnaw",
  T_36_SY_MP5_MAMBAS_N: "MP5 - Mamba Gnaw",
  T_36_SY_P90_MAMBAS_N: "P90 - Mamba Gnaw",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL - Mamba Gnaw",
  T_36_SY_PP19_MAMBAS_N: "Bizon - Mamba Gnaw",
  T_36_SY_PP19_POLICEMAN_N: "Bizon - Wraith Patrol",
  T_36_SY_SCAR_MAMBAS_N: "SCAR - Mamba Gnaw",
  T_36_SY_SKS_MAMBAS_N: "SKS - Mamba Gnaw",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12 - Mamba Gnaw",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA - Mamba Gnaw",
  T_36_SY_SVD_MAMBAS_N: "SVD - Mamba Gnaw",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson - Mamba Gnaw",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "มีด - Mamba Dagger",
  T_36_SY_THROWINGKNIFE_MENA_N: "มีด - Boho Dagger",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Heal Pistol - Mamba Gnaw",
  T_36_SY_UMP45_MAMBAS_N: "UMP - Mamba Gnaw",
  T_36_SY_USP45_MAMBAS_N: "USP - Mamba Gnaw",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi - Mamba Gnaw",
  T_36_SY_VECTOR_MAMBAS_N: "Vector - Mamba Gnaw",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "รถบิ๊กฟุต - Blinding Gold",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "มอเตอร์ไบค์ - Spectral Ride",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "รถสปอร์ต - Speed Acer",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "ตุ๊กตุ๊ก - Netherworld Ride",
  T_36_SY_VSS_MAMBAS_N: "VSS - Mamba Gnaw",
  T_36_SY_XM8_MAMBAS_N: "XM8 - Mamba Gnaw",
  T_36_WZY_AFTERACCUMULATOR: "คำนวณด้านหลัง",
  T_36_WZY_AVAILAB: "เปิดใช้งาน",
  T_36_WZY_BACKANDFORTH: "ไป - กลับ",
  T_36_WZY_BASEMULTIPLIER: "คูณปกติ",
  T_36_WZY_BASIC: "ประเภทพื้นฐาน",
  T_36_WZY_BEFORACCUMULATOR: "คำนวณด้านหน้า",
  T_36_WZY_CYLIC: "วงกลม-กลับ",
  T_36_WZY_GUNPRO_PARAM1: "ความเสียหายพื้นฐาน",
  T_36_WZY_GUNPRO_PARAM10: "กระสุนกระจายเริ่มต้น",
  T_36_WZY_GUNPRO_PARAM11: "ขอบเขตกระจายสูงสุด",
  T_36_WZY_GUNPRO_PARAM12: "แบบชุด",
  T_36_WZY_GUNPRO_PARAM2: "กระสุนในแมกกาซีน",
  T_36_WZY_GUNPRO_PARAM3: "จำนวนแมกกาซีนที่ใช้",
  T_36_WZY_GUNPRO_PARAM4: "อัตรายิงต่อเนื่อง",
  T_36_WZY_GUNPRO_PARAM7: "ระยะสร้างความเสียหาย สูงสุด",
  T_36_WZY_GUNPRO_PARAM8: "ระยะสร้างความเสียหาย น้อยสุด",
  T_36_WZY_GUNPRO_PARAM9: "ความเสียหายขั้นต่ำ",
  T_36_WZY_MULTIPLIR: "คูณ",
  T_36_WZY_PRICE: "ราคา",
  T_36_WZY_SUMMULTIPLIER: "ตัวคำนวณแบบคูณ",
  T_36_WZY_WS_3DZOOM: "ซูมแบบ 3 มิติ",
  T_36_WZY_WS_ABSRES: "ผลค่าคงที่",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "เพิ่มองค์ประกอบทั้งหมดจาก [Source list] ไปต่อที่ด้านล่างของ [Target list]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "รายการที่ต้องการ เพิ่มองค์ประกอบ",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "รายการต้นทาง ที่มีองค์ประกอบที่ต้องการเพิ่ม",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "เพิ่มเงินในจำนวนที่ต้องการ ไปยังกระเป๋าที่กำหนด",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "กระเป๋า",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "กระเป๋าที่ต้องการเพิ่มเงิน",
  T_36_WZY_WS_ADDSUB: "เพิ่ม หรือ ลบ ค่า",
  T_36_WZY_WS_AIENTITY: "Entity AI",
  T_36_WZY_WS_ALLSHOP_DESC: "รายการทีมีที่เกี่ยวข้องกับ Entity ของร้านค้า",
  T_36_WZY_WS_ANGLE_DESC: "การวัดมุม",
  T_36_WZY_WS_ANYTYPE: "ประเภทใดก็ได้",
  T_36_WZY_WS_ARILEFT: "ค่าฝั่งซ้าย ของการดำเนินการ",
  T_36_WZY_WS_ARIRES: "ผลการดำเนินการ",
  T_36_WZY_WS_ARIRIGHT: "ค่าฝั่งขวา ของการดำเนินการ",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 ตัวดำเนินการทางคณิตศาสตร์",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "ตัวคำนวณเลขจำนวนเต็มแบบพื้นฐาน รองรับ การบวก ลบ คูณ หาร และเศษส่วน การคำนวณแบบลอย รองรับเฉพาะ การบวก ลบ คูณ และหาร",
  T_36_WZY_WS_ARRAY_DESC: "รายการเป้าหมาย",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "ตรวจสอบรายการว่ามีองค์ประกอบที่กำหนดหรือไม่ ค่าที่ได้เป็น Boolean",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "รายการที่กำหนด",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "องค์ประกอบที่ต้องการค้นหาในรายการ",
  T_36_WZY_WS_ARRCONELERES: "ผลลัพธ์การค้นหาองค์ประกอบที่กำหนดว่ามีในรายการหรือไม่ คืนค่าเป็น Boolean",
  T_36_WZY_WS_ATTACK: "ลาดตระเวน และจู่โจม",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "ทำงาน เมื่อผู้เล่นถูกล้ม",
  T_36_WZY_WS_BIGFLOAT: "ทศนิยมใหญ่",
  T_36_WZY_WS_BIGTOYBALL: "ลูกเต๋า",
  T_36_WZY_WS_BOOLLIST: "รายการ Boolean",
  T_36_WZY_WS_CEIL_NAME_DESC: "ปัดเศษขึ้นตามจำนวนเลขด้านหน้า",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "ค่าที่จะปัดเศษขึ้น",
  T_36_WZY_WS_CEILRES: "ผลลัพธ์การปัดเศษ",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "AI ที่เลือกจะไล่ตาม Entity นี้ ในระยะที่กำหนด [Chased entity] จะเป็น Entity อะไรก็ได้ เมื่อ [Chased entity] ไม่มีค่า HP เมื่อนั้น Entity AI จะไม่ทำดาเมจ",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "Entity ที่ทำการไล่ตาม",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "Entity เป้าหมายที่ถูกไล่ตาม จะเป็น Entity อะไรก็ได้",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "เลือกวัตถุที่ต้องการคัดลอกด้วยเคอร์เซอร์ คุณสมบัติและสคริปท์ของตัวตัดลอก จะเหมือนกับต้นแบบ",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "Entity วัตถุที่จะถูกคัดลอก",
  T_36_WZY_WS_CONDITION: "เงื่อนไข",
  T_36_WZY_WS_CONDITIONLIST: "รายการเงื่อนไข",
  T_36_WZY_WS_CONOFHUD: "Entity HUD ที่มีการควบคุม",
  T_36_WZY_WS_CONTROL_DESC: "ดัชนีเดียวของ ตัวควบคุม",
  T_36_WZY_WS_COS_NAMEDESC: "หาค่าโคไซน์ของมุม",
  T_36_WZY_WS_COSRES: "โคไซน์ของมุม",
  T_36_WZY_WS_CREABLEOB: "วัตถุ ที่สามารถสร้างได้",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "สร้าง Entity วัตถุ ในตำแหน่งที่กำหนด (เวอร์ชั่นทดสอบ)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "ตำแหน่งพิกัด ที่ต้องการสร้างวัตถุ",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "ประเภทของวัตถุ ที่จะถูกสร้าง",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "Entity ของวัตถุ ที่จะถูกสร้าง",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "สกุลเงิน",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Entity สินค้า",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "สร้าง Entity สินค้า",
  T_36_WZY_WS_CREWALL_NAMEDESC: "สร้าง Entity กระเป๋าเงิน [Bind player] คือ ผู้เล่นที่จะเห็นกระเป๋าตังส์นี้ [Owner] คือ ผู้เล่นที่เป็นเจ้าของกระเป๋าเงิน ไม่สามารถทำได้ หากมีกระเป๋าเงินอยู่แล้ว",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "ผูกผู้เล่น",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "ผู้เล่นที่สามารถใช้งาน กระเป๋าเงินได้ หากไม่มีตั้งค่า ไม่ว่าใครก็สามารถใช้กระเป๋าเงินได้",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "เจ้าของกระเป๋าเงิน",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Entity กระเป๋าเงิน",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "สร้าง Entity กระเป๋าเงินแล้ว",
  T_36_WZY_WS_CURRAMT: "จำนวนเงิน",
  T_36_WZY_WS_DATA_TYPE1: "เพิ่ม พารามิเตอร์",
  T_36_WZY_WS_DATA_TYPE2: "คำนวณ ตรรกะพื้นฐาน",
  T_36_WZY_WS_DATA_TYPE3: "รายการ การจัดการ",
  T_36_WZY_WS_DATA_TYPE4: "คำนวณ เวคเตอร์",
  T_36_WZY_WS_DESTITEM_NAME: "ทำลายไอเทมของผู้เล่น",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "ทำลายประเภทไอเทมที่เลือก จากผู้เล่นที่เลือก",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "ไอเทมที่สามารถทำลายได้ เช่น อาวุธ เกราะ และหมวก",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "ดัชนีช่อง ของประเภทรายการที่เลือก ดัชนีอาวุธคือ [1,3] ค่าเริ่มต้นของหมวกและเกราะ คือ 1",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "สูญเสียไอเทม เมื่อถูกกำจัด",
  T_36_WZY_WS_DESTOBJ: "วัตถุที่ทำลายได้",
  T_36_WZY_WS_DIRPOINT: "จุดทิศทาง",
  T_36_WZY_WS_DIRPOINTDESC: "สร้างจุดทิศทาง",
  T_36_WZY_WS_ELEFINDRES: "สารบัญองค์ประกอบ ตำแหน่งแรก",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'รับค่าดัชนี องค์ประกอบแรกของรายการ ถ้าหากองค์ประกอบเป้าหมาย ไม่อยู่ในรายการ ผลลัพธ์ที่ได้คือ "-1".',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "องค์ประกอบที่สามารถพบได้ในรายการ",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'รับค่าดัชนี องค์ประกอบตำแหน่งสุดท้ายของรายการ ถ้าหากองค์ประกอบเป้าหมาย ไม่อยู่ในรายการ ผลลัพธ์ที่ได้คือ "-1".',
  T_36_WZY_WS_ELELINDRES: "ดีชนีขององค์ประกอบ ตำแหน่งสุดท้าย",
  T_36_WZY_WS_ELEMENTSNUM: "# ขององค์ประกอบในรายการ",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "ทำงานเมื่อ [Triggering entity] มีปฏิสัมพันธ์กับตัวกลไก",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "เอนทีตี้ที่ ตัวกลไกนี้ ซ้อนทับอยู่",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "ทำงานเมื่อ [Triggering entity] ขับยานพาหนะ",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "Entity ที่กำลังขับยานพาหนะ",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "ทำงานเมื่อผู้เล่น เข้าไปยังตัวทำงาน",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "ทำงานเพื่อ เข้า",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "ทำงานเมื่อ [Triggering entity] ออกจากยานพาหนะ",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "Entity ที่ออกจากยานพาหนะ",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "ทำงานเมื่อ [Triggering entity] เข้ายานพาหนะ",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "Entity ที่เข้ายานพาหนะ",
  T_36_WZY_WS_ENTITY_TYPE1: "ใช้โดยทั่วไป",
  T_36_WZY_WS_ENTITY_TYPE2: "คุณสมบัติ",
  T_36_WZY_WS_ENTITY_TYPE3: "วัตถุ และไอเทม",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "ค่าขององค์ประกอบที่ต้องการเปลี่ยน",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "ผู้เล่นเป้าหมาย",
  T_36_WZY_WS_ENTITYLIST: "รายการ Entity",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "ทำงาน [Triggering entity] กระเด้งออกจากยาง",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "Entity ที่กระเด้งกับยาง",
  T_36_WZY_WS_ENTTP_NAMEDESC: "ทำงานเมื่อ [Triggering entity] เข้าประตู และเทเลพอร์ต",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "Entity ที่ทำการเทเลพอร์ต",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "ประเภทของเกราะที่ถูกสวมใส่ นับรวมทั้งหมด เกราะ หมวก และกระเป๋า",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "ทำงาน เมื่อผู้เล่นสวมใส่อาวุธสำเร็จ [Trigger player] คือผู้เล่นที่สวมใส่อาวุธสำเร็จ [Weapon entity] คืออาวุธที่ผู้เล่นสวมใส่",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "เอนทิตี้ อาวุธที่สวมใส่",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "ประเภทอาวุธ",
  T_36_WZY_WS_EULERANGLE: "มุม Euler",
  T_36_WZY_WS_FACECAMERA: "มองที่กล้องเสมอ",
  T_36_WZY_WS_FLOATLIST: "รายการ Float",
  T_36_WZY_WS_FLOOR_NAME_DESC: "ปัดเศษเป็นค่าจำนวนเต็ม",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "ค่าที่ปัดเศษลง",
  T_36_WZY_WS_FLOORRES: "ผลลัพธ์ปัดเศษลง",
  T_36_WZY_WS_FORMUENT: "Entity คุณสมบัติที่สามารถใส่สูตรคำนวณได้",
  T_36_WZY_WS_FORMUFACT: "ประเภทของสูตรคำนวณ ในคุณสมบัติ",
  T_36_WZY_WS_GAME_TYPE2: "เกมเพลย์",
  T_36_WZY_WS_GAME_TYPE3: "เอฟเฟ็กต์พิเศษ",
  T_36_WZY_WS_GENENT_NAMEDESC: "ทำงานเมื่อ ตัวสร้าง สร้างยูนิต [Unit entity list] คือรายการยูนิตที่ถูกสร้างขึ้น ด้วยตัวสร้าง [# ของรอบ] คือ รอบที่ตัวสร้าง สร้างขึ้น",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "เอนทิตี้ ยูนิต",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "รายการเอนทิตี้ ยูนิต ที่ถูกสร้างขึ้นโดยตัวสร้าง",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "จำนวนรอบที่เครื่องสร้าง สร้างขึ้น",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "รับค่าร้านค้าทั้งหมดที่อยู่ในแมตช์ ค่าที่คืนมาจะแสดง Entity ของร้านค้าที่เกี่ยวข้อง",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "รับค่าสีโดยใช้ค่า RGB",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "รับค่า จำนวนเงิน โดยเลือกเฉพาะที่อยู่ในเกระเป๋าเท่านั้น",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "กระเป๋า ที่ถูกเลือกในการดึงข้อมูล",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "ประเภทของจำนวนเงิน ที่จะถูกดึง",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "รับประเภท Entity ของ Entity เป้าหมาย",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "ประเภทของ Entity ที่จะถูกดึง",
  T_36_WZY_WS_GETENTTYPERES: "ประเภท Entity ของ Entity เป้าหมาย",
  T_36_WZY_WS_GETFOR_NAME: "รับพิกัดทิศทาง",
  T_36_WZY_WS_GETFOR_NAMEDESC: "รับค่า เวคเตอร์ ของจุดทิศทางที่กำหนด",
  T_36_WZY_WS_GETFORRES: "เวคเตอร์ของจุดทิศทาง",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "รับค่า Entity เงินจาก ประเภทของเงินในกระเป๋า",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "กระเป๋าที่มี Entity เงินอยู่",
  T_36_WZY_WS_GETPOS_NAME: "รับค่า พิกัด",
  T_36_WZY_WS_GETPOS_NAMEDESC: "รับค่าพิกัด ของจุดทิศทางที่กำหนด",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "จุดทิศทางที่กำหนด",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "ประเภทของไอเทม",
  T_36_WZY_WS_GETWALLET_NAME: "รับค่า กระเป๋าเงิน",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "รับค่า กระเป๋าเงินจากเจ้าของที่เลือก",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "ไม่ว่ากระเป๋ามีสถานะผูกอยู่หรือไม่",
  T_36_WZY_WS_GETWALLETRES: "Entity เจ้าของกระเป๋า",
  T_36_WZY_WS_HUDCONTROL_DESC: "Entity ตัวควบคุม HUD",
  T_36_WZY_WS_HUDTYPE: "ประเภท HUD",
  T_36_WZY_WS_INCIDENT_TYPE1: "เหตุการณ์ทั้วแผนที่",
  T_36_WZY_WS_INCIDENT_TYPE2: "เอนทิตี้ เหตุการณ์",
  T_36_WZY_WS_INDEX_DESC: "ค่าดัชนีของรายการ เริ่มจาก 0",
  T_36_WZY_WS_INTLIST: "รายการ จำนวนเต็ม",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "ตรวจสอบดูว่า Entity ประเภทไหน ที่อยู่ในหมวดย่อย ผลลัพธ์จะแสดงเป็นค่า Boolean",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "หมวดหลักที่ ใช้สำหรับตรวจสอบว่า มี Entity อยู่รึเปล่า",
  T_36_WZY_WS_JENTSUBCLRES: "ผลลัพธ์การตรวจสอบ หมวดหมู่หลัก",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "ตรวจสอบว่า Entity ที่อยู่นั้นเป็น Entity ประเภทไหน ผลลัพธ์ที่ได้แสดงเป็นค่า Boolean",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "Entity ที่จะตรวจเช็ค",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "หมายความว่า เป็นค่าเดียวกันกับประเภทของ Entity",
  T_36_WZY_WS_JENTTYPERES: "ผลการตรวจสอบ Entity",
  T_36_WZY_WS_JUSTPATROL: "เฉพาะลาดตระเวนเท่านั้น",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "ทำงานเมื่อผู้เล่น ออกจากตัวทำงาน",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "ทำงานเพื่อ ออก",
  T_36_WZY_WS_LEVELOBLIST: "รายการวัตถุ",
  T_36_WZY_WS_LEVOBJSLIST: "รายการวัตถุทั้งหมด ในแมตช์นี้",
  T_36_WZY_WS_LEVOBTYPE: "ประเภทของวัตถุ",
  T_36_WZY_WS_LISTT: "รายการใดก็ได้",
  T_36_WZY_WS_LOGCONTEXT_DESC: "เนื้อหาที่จะถูกพิมพ์ออกมา",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "String ด้านซ้ายที่จะเชื่อมต่อ",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "String ที่จะทำการเชื่อมต่อ",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "ค่าขององค์ประกอบที่จะถูกเพิ่ม",
  T_36_WZY_WS_LOGOPER: "เมื่อผ่านการตำนวณตรรกะแล้ว (และ & หรือ) : ถ้าหากค่า Boolean ที่ได้รับทั้งสองค่า มีค่าเป็น จริง ผลลัพธ์เป็น จริง และถ้าหากค่า Boolean ทั้งสองค่าไม่ใช่ค่า เท็จ ทั้งคู่ ผลลัพธ์เป็นจริง",
  T_36_WZY_WS_LOOTPOINT: "จุดเก็บของ",
  T_36_WZY_WS_MAINWEAP: "อาวุธปัจจุบัน",
  T_36_WZY_WS_MAX_DESC: "ชุดข้อมูลที่สูงกว่า ของเลขจำนวนเต็มที่ถูกสร้างขึ้น (ช่วงเปิด)",
  T_36_WZY_WS_MIN_DESC: "ขอบเขตขั้นต่ำของ เลขจำนวนเต็มที่สร้างขึ้น (แบบปิด)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Entity อาวุธ",
  T_36_WZY_WS_MONENT: "Entity ค่าเงิน",
  T_36_WZY_WS_MONTYPE: "ประเภทค่าเงิน",
  T_36_WZY_WS_MOVETO_NAMEDESC: "สั่งการให้ AI เดินไปข้างหน้ายังจุดหมาย ใช้ [Return or not] เพื่อกำหนดว่า ต้องการให้ AI เดินกลับไปยังจุดเริ่มต้นหรือไม่ ใช้ [Attack or not] เพื่อกำหนดว่า ต้องการให้ AI ค้นหาศัตรูที่อยู่ในระยะ ระหว่างการเดินหรือไม่",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "Entity AI ที่ทำการเดินทาง",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "จุดหมาย",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "ใช้สำหรับตั้งค่า AI ว่าต้องการให้เดินกลับไปยังจุดเริ่มต้น หลังจากเดินถึงจุดหม่ยหรือไม่ จริง คือ ให้เดินกลับ เท็จ คือ ไม่เดินกลับ",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "โจมตี หรือ ไม่",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "ใช้สำหรับตั้งค่า AI ว่าต้องการให้ค้นหาศัตรูในระยะ ระหว่างการเดินหรือไม่ จริง คือให้ค้นหาศัตรู เท็จ คือไม่ให้ค้นหาศัตรู",
  T_36_WZY_WS_MULVALUE: "สเกลาร์",
  T_36_WZY_WS_MULVEC: "สเกลาร์ คูณ เวคเตอร์",
  T_36_WZY_WS_NEGRES: "ผลลัพธ์ ค่าติดลบ",
  T_36_WZY_WS_NEUTRAL: "ปกติ",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "บังคับให้ตัวสร้างที่เลือก สร้างรอบถัดไปโดยทันที ตัวสร้างนี้รวมไปถึง ซอมบี้ และไอเทมต่าง ๆ",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "ตัวสร้าง Entity",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "Entity ของตัวสร้างที่เลือก เช่น ซอมบี้ หรือไอเทม",
  T_36_WZY_WS_OBJENT: "Entity วัตถุ",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "ทำงาน เมื่อได้รับไอเทม [Item type] คือ ประเภทของไอเทมที่ได้รับ",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "ทำงานเมื่อได้รับอาวุธ [Weapon entity] คืออาวุธที่ได้รับ",
  T_36_WZY_WS_ONEWAY: "ทางเดียว",
  T_36_WZY_WS_OPENSTATE: "สถานะ",
  T_36_WZY_WS_OPERMETHOD_NAME: "ตัวดำเนินการ",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "กาคำนวณพื้นฐานทางคณิตศาสตร์ สามารถ บวก ลบ คูณ หาร และเศษส่วน ของจำนวนเต็ม และสำหรับค่า Float สามารถ บวก ลบ คูณ และหาร เท่านั้น",
  T_36_WZY_WS_OWNERENT_DESC: "เอนทิตี้ เจ้าของกระเป๋า",
  T_36_WZY_WS_PERCENTAGE: "ปรับค่า เปอร์เซ็นต์",
  T_36_WZY_WS_PLACOLLIDE_NAME: "เมื่อผู้เล่นซ้อนทับ กับตัวกลไก",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "ทำงานเมื่อผู้เล่น [Trigger player] ซ้อนทับกับ ตัวกลไก",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "ผู้เล่น ที่ซ้อนทับกับ ตัวกลไก",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "Entity วัตถุที่ผู้เล่นซ้อนทับ",
  T_36_WZY_WS_PLADRIVEH_NAME: "เมื่อผู้เล่นขับยานพาหนะ",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "ทำงานเมื่อ [Trigger player] ขับยานพาหนะ",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "ผู้เล่นที่กำลังขับยานพาหนะ",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "Entity ยานพาหนะที่ผู้เล่นกำลังขับ",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "เมื่อผู้เล่นออกจากยานพาหนะ",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "ทำงานเมื่อ [Trigger player] ออกจากยานพาหนะ",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "ผู้เล่นที่ออกจากยานพาหนะ",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "Entity ยานพาหนะ ที่ผู้เล่นออก",
  T_36_WZY_WS_PLAGETONVEH_NAME: "เมื่อผู้เล่นเข้ายานพาหนะ",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "ทำงานเมื่อ [Trigger player] เข้ายานพาหนะ",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "Entity ยานพาหนะที่ผู้เล่นเข้า",
  T_36_WZY_WS_PLAKNOFLY_NAME: "เมื่อผู้เล่น กระเด้งออกจากยาง",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "ทำงานเมื่อ [Trigger player] กระเด้งออกจากยาง",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "ผู้เล่นที่กระเด้งกับยาง",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "Entity วัตถุ ที่ผู้เล่นกระเด้งไปหา",
  T_36_WZY_WS_PLATP_NAME: "หลังจากที่ผู้เล่นเทเลพอร์ต",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "ผู้เล่นที่ใช้งานประตู",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "Entity ประตู ที่ผู้เล่นใช้งาน",
  T_36_WZY_WS_PLAYERLIST_DESC: "รายการผู้เล่น ที่อยู่ในแมตช์นี้",
  T_36_WZY_WS_POINTPICKER: "เส้นทางสำคัญ",
  T_36_WZY_WS_PORTALENT: "Entity ประตู",
  T_36_WZY_WS_PREFAB: "รูปแบบ",
  T_36_WZY_WS_PRODLIST: "รายการสินค้า",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "ลำดับการจัดเลียง",
  T_36_WZY_WS_PROPMOD: "วิธีการเปลี่ยนคุณสมบัติ",
  T_36_WZY_WS_RANKABLEE: "Entity จัดอันดับ",
  T_36_WZY_WS_REDCURR_NAMEDESC: "ใช้จำนวนเงินตามกำหนด โดยกำหนดจากกระเป๋าเงิน",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "กระเป๋าเงินที่ใช้จ่ายเงิน",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "ประเภทของเงิน ที่ถูกใช้",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "จำนวนของเงินที่ถูกใช้",
  T_36_WZY_WS_RNDFRES: "สร้างค่า float แบบสุ่ม",
  T_36_WZY_WS_RNDIRES: "ผลลัพธ์ สุ่มสร้างเลขจำนวนเต็ม",
  T_36_WZY_WS_ROUND_NAME_DESC: "ปัดเศษค่า เป็นจำนวนเต็มที่ใกล้เคียงที่สุด",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "ค่าที่ต้องการปัดเศษ",
  T_36_WZY_WS_ROUNDRES: "ผลลัพธ์ การปัดเศษ",
  T_36_WZY_WS_RUNAI_NAMEDESC: "รายการพฤติกรรมที่เลือกให้ AI ทำงาน",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "Entity ยูนิต ที่จะหยุด/เริ่ม พฤติกรรมพื้นฐาน",
  T_36_WZY_WS_SCOREABLEE: "Entity นับคะแนน",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "ทำงานเมื่อคะแนนเปลี่ยน [Score type] คือประเภทของคะแนนที่เปลี่ยน [Score] คือคะแนนใหม่",
  T_36_WZY_WS_SETDIRPOINT_NAME: "สร้างจุดทิศทาง",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "รับค่า จุดทิศทางที่สร้างขึ้นใหม่ ใช้ [Location] เพื่อตั้งค่าจุด และพิกัด และ [Direction] เพื่อตั้งค่าเวกเตอร์ ของทิศทาง",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "พิกัด ของจุดทิศทาง",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "ทิศทาง",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "เวกเตอร์ ของจุดทิศทาง",
  T_36_WZY_WS_SETPATH_NAMEDESC: "Entity AI จะเดินทางตามลำดับที่กำหนด สามารถเลือกให้เดินทางแบบวน ไปอย่างเดียว หรือไปแล้วกลับ คุณสามารถเลือกได้ว่า ต้องการให้ AI ค้นหาศัตรู ระหว่างเดินทางหรือไม่",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "รายการที่เกี่ยวข้อง ในจุดที่ AI จะเดินทางไป",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "ประเภท การเดินทาง",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "ประเภทของการเดินทางแบ่งออกเป็น แบบทางเดียว AI จะเดินทางไปยังจุดหมายและสิ้นสุดการทำงาน แบบวน เมื่อ AI ถึงที่หมายแล้ว จะทำการค้นหาเส้นทางเพื่อเดินกลับ แบบไปกลับ เมื่อ AI เดินถึงที่หมายแล้ว จะเดินกลับไปยังจุดเริ่มต้น โดยใช้เส้นทางเดิม",
  T_36_WZY_WS_SHOPECON: "ร้านค้า และระบบเงินในเกม",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "ใช้สำหรับ แสดงแจ้งเตือนบนหน้าจอ ตั้งค่าเนื้อหา [Text] สีที่ต้องการใช้ [Color] และระยะเวลา [Duration] (ค่าเป็นมิลลิวินาที)",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "เนื้อหาแจ้งเตือน",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "สีของแจ้งเตือน",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "ระยะเวลาแสดงแจ้งเตือน ค่าเป็นมิลลิวินาที",
  T_36_WZY_WS_SIN_NAMEDESC: "ค้นหาค่า ไซน์ ของมุม",
  T_36_WZY_WS_SINRES: "ค่า sine ของมุม",
  T_36_WZY_WS_SKIPKNODOWN: "เมื่อถูกกำจัดขณะล้ม",
  T_36_WZY_WS_SQRTRES: "ผลลัพธ์การคำนวณ รากที่สอง",
  T_36_WZY_WS_STRCONRES: "ผลลัพธ์การเชื่อมต่อ ค่า String",
  T_36_WZY_WS_STRINGLIST: "รายการ String",
  T_36_WZY_WS_STRLEN: "ความยาว String",
  T_36_WZY_WS_STRVAL: "ผลลัพธ์ String",
  T_36_WZY_WS_TAN_NAMEDESC: "หา แทนเจนต์ของมุม",
  T_36_WZY_WS_TANRES: "แทนเจนต์ของมุม",
  T_36_WZY_WS_TEAMLIST: "รายการทีม",
  T_36_WZY_WS_TEAMLIST_DESC: "รายการทีมทั้งหมด ในแมตช์นี้",
  T_36_WZY_WS_TIMETWEENTIPS: "Entity นับถอยหลังแจ้งเตือน",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "เปลี่ยนค่าเป้าหมาย เป็น String",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "ค่าเป้าหมาย ที่จะเปลี่ยนเป็น String",
  T_36_WZY_WS_TOSTRINGRES: "ผลลัพธ์ การเปลี่ยนเป็น String",
  T_36_WZY_WS_TOWERCAMP_DESC: "หมายเลข และหมายเลขทีมคือเลขเดียวกัน หอคอยปกติ และป้อมปราการโจมตีผู้เล่น และ AIs ทั้งหมดในระยะ",
  T_36_WZY_WS_TRACURR_NAMEDESC: "โอนจำนวนเงิน ไปยังอีกกระเป๋านึงตามกำหนด",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "กระเป๋าที่ต้องการ โอนเงินเข้า",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "ประเภทของเงิน ที่ต้องการดำเนินการ",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "จำนวนเงินที่ต้องการดำเนินการ",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "กระเป๋าเงิน ที่ถูกเพิ่มเงินเข้าไป",
  T_36_WZY_WS_TWEENTIPS: "Entity แจ้งเตือน Floating",
  T_36_WZY_WS_TYPEENUM: "ประเภท Enum",
  T_36_WZY_WS_USEPROP_NAMEDESC: "ทำงานเมื่อผู้เล่นใช้ไอเทม [Triggeri player] คือผู้เล่นที่ใช้ไอเทม [Item type] คือไอเทมที่ผู้เล่นใช้",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "ประเภทของไอเทม ที่ผู้เล่นใช้",
  T_36_WZY_WS_VECADDLEFT: "ค่าฝั่งซ้าย ในการบวกเวกเตอร์",
  T_36_WZY_WS_VECADDRES: "ผลลัพธ์การบวกเวกเตอร์",
  T_36_WZY_WS_VECADDRIGHT: "ค่าฝั่งขวา ในการบวกเวกเตอร์",
  T_36_WZY_WS_VECANGLEFT: "ค่าฝั่งซ้าย มุมของเวกเตอร์",
  T_36_WZY_WS_VECANGRES: "มุมระหว่าง 2 เวกเตอร์",
  T_36_WZY_WS_VECANGRIGHT: "ค่าฝั่งขวา ของมุมเวคเตอร์",
  T_36_WZY_WS_VECCROLEFT: "มูลค่าของสินค้า ที่กากบาท",
  T_36_WZY_WS_VECCRORES: "ผลลัพธ์ การข้ามสินค้า",
  T_36_WZY_WS_VECCRORIGHT: "ค่าฝั่งขวา ของสินค้าที่ข้าม",
  T_36_WZY_WS_VECDISLEFT: "ค่าฝั่งซ้าย ของระยะเวคเตอร์",
  T_36_WZY_WS_VECDISRES: "ความห่างระหว่าง เวคเตอร์ทั้ง 2 ค่า",
  T_36_WZY_WS_VECDISRIGHT: "ค่าฝั่งขวา ของระยะเวคเตอร์",
  T_36_WZY_WS_VECDOCLEFT: "ค่าฝั่งซ้าย ของดอทสินค้า",
  T_36_WZY_WS_VECDOCRES: "ผลลัพธ์ ของการดอทสินค้า",
  T_36_WZY_WS_VECDOCRIGHT: "ค่าฝั่งขวา ของการดอทสินค้า",
  T_36_WZY_WS_VECMULRES: "ผลลัพธ์ การคุณสเกลาร์",
  T_36_WZY_WS_VECNORRES: "Vector มาตรฐาน",
  T_36_WZY_WS_VECSIZERES: "ขนาดของเวกเตอร์",
  T_36_WZY_WS_VECSUBLEFT: "ค่าฝั่งซ้าย ของการลบเวคเตอร์",
  T_36_WZY_WS_VECSUBRES: "ผลการลบเวกเตอร์",
  T_36_WZY_WS_VECSUBRIGHT: "ค่าฝั่งขวา ของการลบเวคเตอร์",
  T_36_WZY_WS_VECTORLIST: "รายการ เวกเตอร์",
  T_36_WZY_WS_VECX: "ส่วนประกอบ X",
  T_36_WZY_WS_VECY: "ส่วนประกอบ Y",
  T_36_WZY_WS_VECZ: "ส่วนประกอบ Z",
  T_36_WZY_WS_VEHENT: "Entity ยานพาหนะ",
  T_36_WZY_WS_WALLCONT: "ข้อมูลกระเป๋าตังส์",
  T_36_WZY_WS_ZOMBIESPERWAVE: "ต่อเนื่อง",
  T_36_XYL_WS_AIBOT: "ยูนิต",
  T_36_XYL_WS_AIGENERATOR: "ตัวสร้างยูนิต",
  T_36_XYL_WS_AIGENERATOR_DESC: "ตัวสร้าง ที่สามารถสร้างยูนิตที่กำหนด ได้อย่างต่อเนื่อง (เช่น ซอมบี้)",
  T_36_XYL_WS_AIWAVE: "# คือจำนวนยูนิต ต่อรอบ",
  T_36_XYL_WS_ARROW: "ป้ายบอกทาง",
  T_36_XYL_WS_ARROW_DESC: "ป้ายที่สามารถบอกทิศทาง",
  T_36_XYL_WS_BREAKBOX: "กล่องที่สามารถทำลายได้",
  T_36_XYL_WS_BREAKBOX_DESC: "กล่องไม้ที่สามารถถูกทำลายได้ เมื่อโดนโจมตี",
  T_36_XYL_WS_FENCE: "รั้วเหล็ก",
  T_36_XYL_WS_FENCE_DESC: "รั้วที่กระสุน สามารถพุ่งผ่านได้",
  T_36_XYL_WS_STAIRI: "จุดจอด C",
  T_36_XYL_WS_STAIRI_DESC: "พื้น ที่สามารถรวมเข้ากับบันได",
  T_36_XYL_WS_ZOMBIEAI: "ซอมบี้",
  T_36_XYL_WS_ZOMBIEAI_DESC: "ซอมบี้ ที่คุณสามาารถปรับแต่ง และคัดลอกใส่ตัวสร้าง ยูนิต ได้",
  T_36_YF_CORRODE_GRENADE_N: "ระเบิดกัดกร่อน",
  T_36_YF_SETTING_TYPE3: "แบบที่ 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (กางเกง)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (กางเกง)",
  T_36_YS_F_A_GHOSTHUNTER: "Fiendish Foxtail (หน้ากาก)",
  T_36_YS_F_B_GHOSTHUNTER: "Fiendish Foxtail (กางเกง)",
  T_36_YS_F_H_GHOSTHUNTER: "Fiendish Foxtail (ทรงผม)",
  T_36_YS_F_S_GHOSTHUNTER: "Fiendish Foxtail (รองเท้า)",
  T_36_YS_SETTING_GRENADE: "อาวุธโยน",
  T_36_YS_SETTING_MOVE: "การเคลื่อนไหว",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (เสื้อ)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (เสื้อ)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "ลูน่า",
  T_36_YZY_CHARACTER_YAKUZA_N: "ทัตสึยะ",
  T_36_YZY_PET_WOLF_N: "แฟงค์",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "สกินคู่หู : Purple ซาซิล",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "สกินคู่หู : Lightning Falco",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "สกินคู่หู : Lava Fang",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "สกินคู่หู : Spectral Guide",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "สกินคู่หู : Arctic Fang",
  T_37_B_WS_HIDE: "ซ่อนหา",
  T_37_HZ_WS_CATMODEDESC1: "ซ่อนหา",
  T_37_JH_WS_CREATEGOLD_DESC: "ผู้เล่นสามารถซื้อไอเทมได้ จากตู้กดอัตโนมัติ (ยกเว้นโหมด 4v4,ทีมเด็ธแมตช์, สนามเด็กเล่น และ Droid Apocalypse)",
  T_37_JH_WS_NAME1: "FF Knife (Droid Apocalypse)",
  T_37_JH_WS_NAME10: "M1887-X (Droid Apocalypse)",
  T_37_JH_WS_NAME11: "SPAS12 (Droid Apocalypse)",
  T_37_JH_WS_NAME12: "M1014 (Droid Apocalypse)",
  T_37_JH_WS_NAME13: "MP40 (Droid Apocalypse)",
  T_37_JH_WS_NAME14: "MP5-III (Droid Apocalypse)",
  T_37_JH_WS_NAME15: "P90 (Droid Apocalypse)",
  T_37_JH_WS_NAME16: "M60-III (Droid Apocalypse)",
  T_37_JH_WS_NAME17: "Thompson (Droid Apocalypse)",
  T_37_JH_WS_NAME18: "UMP (Droid Apocalypse)",
  T_37_JH_WS_NAME19: "SVD (Droid Apocalypse)",
  T_37_JH_WS_NAME2: "GROZA (Droid Apocalypse)",
  T_37_JH_WS_NAME20: "AWM (Droid Apocalypse)",
  T_37_JH_WS_NAME21: "M82B (Droid Apocalypse)",
  T_37_JH_WS_NAME22: "M249-X (Droid Apocalypse)",
  T_37_JH_WS_NAME23: "Kar98k-III (Droid Apocalypse)",
  T_37_JH_WS_NAME3: "AK47 (Droid Apocalypse)",
  T_37_JH_WS_NAME4: "M4A1-III (Droid Apocalypse)",
  T_37_JH_WS_NAME5: "SCAR (Droid Apocalypse)",
  T_37_JH_WS_NAME6: "M14-III (Droid Apocalypse)",
  T_37_JH_WS_NAME7: "PARAFAL (Droid Apocalypse)",
  T_37_JH_WS_NAME8: "XM8 (Droid Apocalypse)",
  T_37_JH_WS_NAME9: "MAG-7 (Droid Apocalypse)",
  T_37_JH_WS_VENDMACHINE_DESC: "โกลด์ สามารถเก็บได้ทั่วทั้งแผนที่ (ยกเว้นโหมด 4v4,ทีมเด็ธแมตช์, สนามเด็กเล่น และ Droid Apocalypse)",
  T_37_JH_WS_X: "X Axis",
  T_37_JH_WS_Y: "Y Axis",
  T_37_JH_WS_Z: "Z Axis",
  T_37_JL_FOOTBALL_TIE: "เสมอ",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "Waggor Snowman",
  T_37_LC_BP_ENTRANCE_GIFT: "ของขวัญ!",
  T_37_M_WS_MISSING: "เกิดข้อผิดพลาด",
  T_37_M_WS_NAMEERROR: "พบตัวอักษรไม่เหมาะสม กรุณาเปลี่ยน",
  T_37_PD_HuntingGround_BOSSTITLE: "นักเชือด",
  T_37_QL_JUMPPAD_DES: "สร้างแท่นกระโดดบนพื้น สามารถใช้เพื่อกระโดดขึ้นกลางอากาศ และทำการยิงกลางอากาศได้",
  T_37_QL_JUMPPAD_NAME: "แทรมโปลีน",
  T_37_R_TAILOR_LIMIT: "จำกัดเวลา",
  T_37_RW_LOADOUT_BORNFIRETAG: "เมื่อเริ่มเกม ได้รับกองไฟ 2 กองซึ่งจะ[FFBA00]ฟื้นฟู 5 HP และ 20 EP ทุกวินาที[-] (สูงสุด 10 วินาที) ให้คุณและเพื่อนร่วมทีมในบริเวณ ผลของกองไฟไม่ซ้อนทับ",
  T_37_RW_PROPCATAPULT_DESC: "เมื่อขยายแล้ว สามารถใช้เป็นแท่นกระโดด และส่งผู้เล่นขึ้นไปกลางอากาศได้ แต่อย่าลืมว่าต้องอยู่ในพื้นที่ปลอดภัยล่ะ!",
  T_37_RW_PROPCATAPULT_NAME: "แท่นกระโดด",
  T_37_SP_WS_COLOR_02: "สี",
  T_37_SP_WS_COLOR_03: "รูปลักษณ์",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "เอนทิตี้เป็นค่าว่างตอนรับค่า หรือตั้งค่าผ่านทางคุณสมบัติ",
  T_37_SP_WS_LOG_PHASE_END: "ด่าน {0} สิ้นสุดลงแล้ว",
  T_37_SP_WS_LOG_PHASE_START: "ด่าน {0} เริ่มขึ้นแล้ว",
  T_37_SP_WS_LOG_ROUND_END: "รอบ {0} สิ้นสุดลงแล้ว",
  T_37_SP_WS_LOG_ROUND_START: "รอบ {0} เริ่มขึ้นแล้ว",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "ประเภทค่าที่ใส่ให้ตัวแปรไม่ถูกต้อง ประเภทต้องการ: {0} ประเภทที่ปัจจุบัน: {1}",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "ตัวแปรที่ไม่ได้กำหนด หรืออยู่นอกขอบเขต {0}",
  T_37_SP_WS_MAPACCESS_08: "แก้ไข",
  T_37_SP_WS_RACEMODE_01: "โหมดนับถอยหลัง",
  T_37_SP_WS_RACEMODE_02: "นับถอยหลัง",
  T_37_SP_WS_RACEMODE_04: "เมื่อเปิด จะทำการนับถอยหลังเมื่อสมาชิกทีมทั้งหมดเข้าถึงเส้นชัย และเกมจะสิ้นสุดลงเมื่อ สิ้นสุดการนับถอยหลัง",
  T_37_SY_AR15_KABUKI_N: "Kingfisher - Song of Hana",
  T_37_SY_BACKPACK_STRAW_N: "กระเป๋า - Straw Hat",
  T_37_SY_GRENADE_FFWS2022_01_N: "ระเบิด - Navy Starsea",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Black Hole",
  T_37_SY_M1216_MAMBAS_N: "Trogon - Mamba Gnaw",
  T_37_SY_PET_FLYINGCREATURE_N: "บลู",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "สกินคู่หู : บีนนี่ แกลมสตาร์",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "สกินคู่หู : บลู ธุลีไฟ",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "สกินคู่หู : บลู กาแล็คซี่",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "สกินคู่หู :  บลู ออนไฟร์",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "สกินคู่หู : แฟลช ฟุทตี้",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "สกินคู่หู : วินเทอร์แลนด์ เยติ",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "รถจิ๊ป - Rockin' Festival Ride",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "รถกระบะ - Starsea Beast",
  T_37_WT_WS_PVE2DESC: `โหมดเอาชีวิตรอดจากซอมบี้ที่ผู้เล่นต้องกำจัดซอมบี้จำนวนหนึ่งภายในเวลาที่กำหนดหรือเอาชีวิตรอดจนถึงที่สุด
คุณสามารถตั้งค่ากฎการเล่นและปรับการตั้งค่าของซอมบี้ตามที่คุณต้องการ รวมถึงจำนวนเป้าหมายของซอมบี้ที่ต้องการกำจัด`,
  T_37_WT_WS_RULEDESC: "กำจัดซอมบี้ให้ครบจำนวนที่กำหนด เพื่อรับชัยชนะ",
  T_37_WT_WS_RULETITLE: "เป้าหมาย",
  T_37_WT_WS_TXT1: "กำจัดซอมบี้",
  T_37_WT_WS_TXT1DESC: "เมื่อเปิด กำจัดซอมบี้ตามจำนวนที่กำหนดเพื่อรับชัยชนะ เมื่อปิด ผู้เล่นต้องเอาตัวรอดจนครบกำหนดเวลา เพื่อรับชัยชนะ",
  T_37_WT_WS_TXT2: "จำนวนกำจัด",
  T_37_WZY_FRIDPLA: "เพื่อนร่วมทีม",
  T_37_WZY_FRIDSIDE: "ฝ่ายพันธมิตร",
  T_37_WZY_FRIDTEAM: "ทีมพันธมิตร",
  T_37_WZY_HOSTPLA: "ผู้เล่นฝั่งตรงข้าม",
  T_37_WZY_HOSTSIDE: "ฝ่ายตรงข้าม",
  T_37_WZY_WS_ACCFRAMES: "จำนวนเฟรมทั้งหมด",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "เพิ่มไอเทมลงสินค้า คุณสามารถเพิ่มชิ้นเดียว หรือหลายชิ้นก็ได้ จำนวนสามารถเป็นได้ทั้งจำนวนไอเทมเดี่ยว ๆ หรือจำนวนของรายการที่มีหลายไอเทมก็ได้",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "เอนทีตี้สินค้า ที่ต้องการเพิ่มไอเทม",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "ไอเทมที่ต้องการเพิ่ม คุณสามารถเพิ่มไอเทมชิ้นเดียว หรือรายการไอเทมก็ได้",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "จำนวนไอเทมที่ต้องการเพิ่ม หรือจำนวนรายการไอเทมที่ต้องการเพิ่ม",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "เพิ่มแท็กให้กับ เอนทิตี้ ที่เลือก",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "เอนทิตี้ที่ต้องการเพิ่มแท็ก",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "เนื้อหาข้อความที่ต้องการเพิ่ม",
  T_37_WZY_WS_AIMABLEENT: "เอนทิตี้ ที่สามารถเล็งได้",
  T_37_WZY_WS_AIMASSISTTYPE: "ประเภทสนับสนุนการยิง",
  T_37_WZY_WS_ALLOWDROP_NAME: "เปิด/ปิด ไอเทมดรอป",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "กำหนดว่าผู้เล่นสามารถ ดรอปไอเทมได้หรือไม่",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "เอนทิตี้ผู้เล่น ที่ต้องการปรับการดรอปไอเทม",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "กำหนดว่าผู้เล่นสามารถ ดรอปไอเทมได้หรือไม่ เป็นค่า Boolean",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "เปิด/ปิด การเก็บไอเทม",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "กำหนดว่าผู้เล่นสามารถ เก็บไอเทมได้หรือไม่",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "เอนทิตี้ผู้เล่น ที่ต้องการปรับการเก็บไอเทม",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "กำหนดว่าผู้เล่นสามารถเก็บไอเทมได้หรือไม่ เป็นค่า Boolean",
  T_37_WZY_WS_AMBIENTCOLOR: "แสง สี บรรยากาศ",
  T_37_WZY_WS_AMRORTOOL: "ซ่อมเกราะ",
  T_37_WZY_WS_ATTACK: "โจมตี",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "ยกเลิกการอำพรางตัว คืนค่ารูปลักษณ์ของผู้เล่น",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "เอนทิตี้ผู้เล่น ที่ต้องการยกเลิกการอำพราง",
  T_37_WZY_WS_BALLADDV_NAMEDES: "เพิ่มความเร็วเคลื่อนที่ของลูกฟุตบอล",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "ลูกบอลที่ต้องการเพิ่มความเร็ว",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "ค่าความเร็วที่ต้องการเพิ่ม",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "ทำงานเมื่อ ลูกฟุตบอลถูกโจมตีโดยผู้ฟุตบอล ชู๊ตเตอร์ [เอนทิตี้ผู้เล่น] คือผู้ที่ยิง [เพิ่มความเร็ว] คือ ค่าความเร็วที่เพิ่มขึ้นของลูกฟุตบอล หลังจากที่ถูกยิง",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "ผู้เล่น ที่เป็นเจ้าของฟุตบอล ชู๊ตเตอร์",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "ความเร็วของลูกบอลที่เพิ่มขึ้น พลังจากถูกยิง",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "ทำงานเมื่อ ลูกฟุตบอลชนเข้ากับเอนทิตี้ และความเร็วลูกฟุตบอลเพิ่มขึ้น [เอนทิตี้ที่ชน] คือเอนทิตี้ที่ชนกับลูกฟุตบอล [เพิ่มความเร็ว] คือ ความเร็วที่จะเพิ่มขึ้นของลูกบอล หลังจากถูกชน",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "เอนทีตี้ที่ชนกับลูกฟุตบอล",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "ความเร็วที่ถูกเพิ่มขึ้นให้กับลูกบอล เมื่อถูกชน",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "ทำงานเมื่อเอนทิตี้ถูกเล็งโดยผู้เล่น",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "ผู้เล่นที่ทำการเล็งเอนทิตี้",
  T_37_WZY_WS_BEHAVIORSTAT: "สถานะพฤติกรรมของผู้เล่น",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "เอนทิตี้อาวุธ ที่ได้โจมตีเอนทิตี้",
  T_37_WZY_WS_BLOODBARENT: "เอนทิตี้หลอดเลือด",
  T_37_WZY_WS_BOMBEND: "ก่อนระเบิด",
  T_37_WZY_WS_BOMBSTART: "สัญญาณระเบิด",
  T_37_WZY_WS_CHANENT: "เอนทิตี้ช่องทาง",
  T_37_WZY_WS_CHEER: "เชียร์",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "ตรวจสอบว่าเอนทิตี้ที่เลือก มีแท็กที่กำหนดหรือไม่",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "เอนทิตี้ที่ต้องการตรวจสอบ ว่ามีแท็กหรือไม่",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "แท็กที่ต้องการตรวจสอบ",
  T_37_WZY_WS_CHELABELRES: "ผลลัพธ์การตรวจสอบแท็ก เป็นค่า Boolean",
  T_37_WZY_WS_CJERSEY_NAME: "เปลี่ยนเสื้อ",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "ผู้เล่นที่ต้องการเปลี่ยนเสื้อ",
  T_37_WZY_WS_CJERSEY_PARAM2: "แบบเสื้อ",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "แบบที่ต้องการเปลี่ยน",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "สี ส่วนที่ 1 ของชุด",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "สี ส่วนที่ 2 ของชุด",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "สี ส่วนที่ 3 ของชุด",
  T_37_WZY_WS_CJERSEYTYPE1: "แบบที่ 1",
  T_37_WZY_WS_CJERSEYTYPE2: "แบบที่ 2",
  T_37_WZY_WS_CJERSEYTYPE3: "แบบที่ 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "เคลียร์องค์ประกอบทั้งหมดในรายการ",
  T_37_WZY_WS_CREABLEOB_DESC: "ประเภทของวัตถุ ที่สามารถใช้ได้ด้วยการใช้บล็อก",
  T_37_WZY_WS_CREPROD_NAMEDESC: "สร้างสินค้าที่สามารถปรับแต่งได้ และคืนค่าเป็น เอนทิตี้สินค้า ข้อมูลสินค้าสามารถปรับได้ผ่านทางการตั้งค่าคุณสมบัติ",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "สร้างรายการสินค้า ที่สามารถปรับแต่งได้ และคืนค่าเป็นเอนทิตี้รายการสินค้า ข้อมูลในรายการสินค้าสามารถปรับได้ผ่านการตั้งค่าคุณสมบัติ",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "เอนทิตี้ รายการสินค้าที่ถูกสร้าง",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "สร้างเอนทิตี้ ฝ่าย",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "เอนทิตี้ ฝ่ายที่ถูกสร้างขึ้น",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "สร้างร้านค้าปรับแต่งได้ และคืนค่าเป็น เอนทิตี้ร้านค้า",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "สร้างเอนทิตี้ ร้านค้าแล้ว",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "เปลี่ยนสภาพแวดล้อมท้องฟ้าในเกม ตัวเลือกมีดังต่อไปนี้ กลางวัน ตอนเย็น และกลางคืน",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "ประเภทของท้องฟ้าที่ต้องการเปลี่ยน ตัวเลือกมีดังต่อไปนี้ กลางวัน ตอนเย็น และกลางคืน",
  T_37_WZY_WS_DARKNESS: "ความมืดโดยรวม",
  T_37_WZY_WS_DELENT_NAMEDESC: "ลบเอนทิตี้ที่เลือก รองรับการลบเอนทีตี้ไอคอน.เอนทิตี้ข้อความ, เอนทิตี้ HUD, เอนทิตี้เอฟเฟ็กต์พิเศษ, เอนทิตี้อาวุธ และเอนทิตี้วัตถุอื่น ๆ",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "เอนทิตี้ที่ต้องการลบ",
  T_37_WZY_WS_DROP: "ข้อผิดพลาด",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "ทำงานเมื่อผู้เล่นทำการดรอปไอเทม [ประเภทไอเทม] คือ ID ของประเภทไอเทมที่ถูกดรอป",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "ID ประเภท ของไอเทมที่ดรอป",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "ทำงานเมื่อผู้เล่นทำการดรอปอาวุธ [เอนทิตี้อาวุธ] คือ อาวุธที่กำลังถูกดรอป",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "อาวุธที่ดรอป",
  T_37_WZY_WS_DUMMYLEOBJ: "วัตถุสำหรับเวทีทั่วไป",
  T_37_WZY_WS_DUST: "พลบค่ำ",
  T_37_WZY_WS_EMPTYCH: "แชแนลว่าง เริ่มต้น",
  T_37_WZY_WS_EMPTYCH1: "ช่องว่าง 1",
  T_37_WZY_WS_EMPTYCH2: "ช่องว่าง 2",
  T_37_WZY_WS_EMPTYCH3: "ช่องว่าง 3",
  T_37_WZY_WS_EMPTYCH4: "ช่องว่าง 4",
  T_37_WZY_WS_EMPTYCH5: "ช่องว่าง 5",
  T_37_WZY_WS_EMPTYCH6: "ช่องว่าง 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: 'รับค่า รายการที่มีเอนทิตี้ ที่ตรงเงื่อนไข 3 เงื่อนไข เนื้อหาจะเป็น "รวมทั้งหมด", "ยกเว้น", และ "รวม" เป็นประเภทองค์ประกอบเดียว หรือเป็นรายการประเภทขององค์ประกอบ ผลลัพธ์แสดงค่าเป็นรายการของเอนทิตี้ ที่ตรงเงื่อนไข',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "เอนทิตี้ที่ถูกคัดกรอง จะต้องมีองค์ประกอบทั้งหมดจากอาเรย์นี้",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "เอนทิตี้ที่ถูกคัดกรอง จะต้องไม่มีองค์ประกอบที่เลือก จากอาเรย์นี้",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "เอนทิตี้ที่ถูกคัดกรอง จะต้องมีองค์ประกอบอย่างน้อยหนึ่งอย่าง จากอาเรย์นี้",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "ประเภทคุณสมบัติที่ต้องการเปลี่ยน ของเอนทิตี้นี้",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "ค่าคุณสมบัติที่ต้องการเปลี่ยน",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "ให้ผู้เล่นออกจากช่องปัจจุบัน เพื่อทำให้ผู้เล่นไม่อยู่ในช่องไหนเลย",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "ผู้เล่นที่จะออกจากแชแนล",
  T_37_WZY_WS_FAKEENT: "เอนทิตี้ การพรางตัว",
  T_37_WZY_WS_FIND_STR_DESC: "ค้นหาข้อความที่กำหนดภายในประโยค",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "ตัวละครที่ต้องค้นหา",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "ค้นหาสตริงจากตำแหน่งเริ่มต้น โดยเริ่มจาก 0",
  T_37_WZY_WS_FINDSTRRES: "ตำแหน่งแรกที่สตริงปรากฏ เริ่มจาก 0",
  T_37_WZY_WS_FOGCOLOR: "สีหมอก",
  T_37_WZY_WS_FRICTIONCON: "ตัวคูณแรงเสียดทาน ปกติ",
  T_37_WZY_WS_FRICTIONIMP: "ตัวคูณแรงเสียดทาน การชน",
  T_37_WZY_WS_FROMDEATH: "ชุบชีวิต",
  T_37_WZY_WS_FROMKNODOWN: "ดึงเพื่อน",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "รับค่า แชแนลที่ผู้เล่นที่เลือกอยู่",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "เอนทิตี้ผู้เล่น ที่แชแนลได้รับค่า",
  T_37_WZY_WS_GETCHANRES: "แชแนลที่ผู้เล่นกำลังอยู่",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "เรียงตาม ID ของแชแนล 1 ถึง 8 รับค่าแชแนลว่าง ที่ถูกสร้างตามค่าปกติเมื่อสร้างเกม",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ID เริ่มต้น ของช่องว่าง",
  T_37_WZY_WS_GETEMPTYCH_RES: "รับค่าเอนทิตี้ช่อง",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "รับค่า เอนทิตี้การปลอมตัวของผู้เล่น",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "วัตถุ ที่รับค่า เอนทิตี้การปลอมตัว",
  T_37_WZY_WS_GETGAMEENT_NAME: "รับค่า เอนทิตี้สากล",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "รับค่า เอนทิตี้เกม จากแมตช์นี้",
  T_37_WZY_WS_GETHOSTPLA_NAME: "รับค่า ผู้เล่นที่สามารถโจมตีได้",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "เอนทิตี้ฝ่าย",
  T_37_WZY_WS_GOAL_NAMEDESC: "ทำงานเมื่อลูกฟุบอลเข้าประตู [ประตู] คือ ประตูสำหรับให้ลูกบอลเข้า [คนทำประตู] คือผู้เล่นคนสุดท้ายที่แตะบอลก่อนเข้าประตู [สนับสนุน] คือผู้เล่นรองสุดท้าย ที่แตะบอล ก่อนบอลจะเข้าประตู",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "ประตูที่ลูกบอลนี้เข้าไป",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "ผู้เล่นคนสุดท้ายที่ได้แตะบอล",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "ผู้เล่นรองสุดท้ายที่ได้แตะบอล",
  T_37_WZY_WS_HEARTBEAT: "อัตราการเต้นหัวใจ",
  T_37_WZY_WS_HEAVYWEAPON: "อาวุธหนัก",
  T_37_WZY_WS_HIHGSHOOTANGLE: "มุมที่เล็กที่สุด",
  T_37_WZY_WS_HOSTPLA: "รายการผู้เล่นที่สามารถโจมตีได้",
  T_37_WZY_WS_HOSTSIDE: "รายการฝ่าย ที่สามารถโจมตีได้",
  T_37_WZY_WS_HOSTTEAM: "รายการ ของทีมที่สามารถโจมตีได้",
  T_37_WZY_WS_ICON_CLOCK: "นับถอยหลัง",
  T_37_WZY_WS_ICON_CLOTHES: "เสื้อผ้า",
  T_37_WZY_WS_ICON_QUIT: "ออก",
  T_37_WZY_WS_INSERT_ARR_DESC: "เพิ่มองค์ประกอบใหม่ ในรายการที่กำหนด",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "แยกสตริงที่มีความยาวตามกำหนด โดยเริ่มจากตำแหน่งแรก หากความยาวของการดึงข้อมูลเกินความยาวของสตริง จะทำการแยกเนื้อหาจนกว่าจะสิ้นสุดความยาวสตริง",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "ความยาวข้อความที่ต้องการแยก",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "ประโยคข้อความ ที่แยกออกมา",
  T_37_WZY_WS_INTORINTL: "จำนวนเต็ม หรือ รายการจำนวนเต็ม",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "อนุญาติให้ผู้เล่น เข้าร่วมฝ่ายที่กำหนด",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "ฝ่าย ที่ผู้เล่นเข้าร่วม",
  T_37_WZY_WS_JUMP: "กระโดด",
  T_37_WZY_WS_LABEL: "แท็ก",
  T_37_WZY_WS_LENSFLARE: "เลนส์ แฟร์",
  T_37_WZY_WS_LENTH: "ความยาว",
  T_37_WZY_WS_LIGHTATTACK: "โจมตีสำเร็จ",
  T_37_WZY_WS_LIGHTCOLOR: "สีแสงสว่าง",
  T_37_WZY_WS_LIGHTINTENSITY: "จุดกำเนิดแสงสว่าง",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "โหลดฉากใหม่",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "ชื่อของฉากที่ต้องการโหลด",
  T_37_WZY_WS_MOROBJECT: "วัตถุอำพรางค์",
  T_37_WZY_WS_MOVEAXISX: "เคลื่อนที่ตามแนวแกน x",
  T_37_WZY_WS_MOVEAXISY: "เคลื่อนที่ตามแนวแกน y",
  T_37_WZY_WS_MOVEAXISZ: "เคลื่อนที่ตามแนวแกน z",
  T_37_WZY_WS_MOVEDISTITLE: "ระยะทางการเคลื่อนที่",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "เปิด-ปิด ข้อความด่วน",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "เปิด หรือ ปิด ข้อความด่วน เมื่อปิด จะไม่สามารถใช้งาน HUD ในส่วนนั้นได้ และผู้เล่นจะไม่สามารถส่ง หรือรับ ข้อความด่วนได้",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "ผู้เล่น ที่ต้องการ เปิด/ปิด ข้อความด่วน",
  T_37_WZY_WS_MUTEVOICE_NAME: "เปิด-ปิด การสนทนาเสียง",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "เปิด หรือ ปิด การสนทนาเสียง เมื่อปิด จะไม่สามารถใช้งาน HUD ของการสนทนาเสียงได้ และผู้เล่นจะไม่สามารถส่ง หรือรับเสียงจากการสนทนาได้",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "ผู้เล่นที่ต้องการเปิด / ปิด การสนทนาเสียง",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Boolean. True หมายถึง ปิด; False หมายถึง เปิด",
  T_37_WZY_WS_NIGHTMODE: "โหมดกลางคืน",
  T_37_WZY_WS_ONAIM_NAMEDESC: "ทำงานเมื่อผู้เล่น เล็งไปยังเอนทิตี้ ที่สามารถเล็งได้ [เอนทิตี้เป้าหมาย] คือ เอนทิตี้ที่สามารถถูกเล็ง เมื่อไม่มีเอนทิตี้ไหนถูกเล็ง คืนค่าเป็นค่าว่าง",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "เอนทิตี้ การเล็ง",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "เอนทีตี้ ที่ถูกอาวุธโจมตี",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "ทำงานเมื่อ โหลดฉากสำเร็จ",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "ชื่อของฉากที่ต้องการโหลด เป็นข้อความเท่านั้น",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "ทำงานเมื่อ สลับฉากสำเร็จ",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "ชื่อของฉากใหม่ ต้องเป็นตัวอักษรเท่านั้น",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "ฟื้นฟูชุดของผู้เล่น ให้เป็นค่าเริ่มต้น",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "ผู้เล่นที่ชุดพื้นฐานได้รับการฟื้นฟู",
  T_37_WZY_WS_PETSET: "ตั้งค่าคู่หู",
  T_37_WZY_WS_PETSKILL: "สกิลคู่หู",
  T_37_WZY_WS_PETSWITCH2: "ตั้งค่า การใช้งานสกิลคู่หู",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "ควบคุมการเคลื่อนไหวของผู้เล่น เป็นค่า Boolean",
  T_37_WZY_WS_PLAYERBEHAVIOR: "ประเภทพฤติกรรมของผู้เล่น",
  T_37_WZY_WS_PRESS: "แตะเบา ๆ",
  T_37_WZY_WS_PROGRESS: "ความคืบหน้าปัจจุบัน",
  T_37_WZY_WS_PROGRESSBAR: "เอนทิตี้ ความคืบหน้า HUD",
  T_37_WZY_WS_RANKDOWN: "อันดับลด",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "ลบแท็ก ออกจากเอมทิตี้ที่เลือก",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "เนื้อหาที่ต้องการลบ",
  T_37_WZY_WS_REPLACE_STR_DESC: "แทนที่เนื้อหาในประโยค ด้วยเนื้อหาที่กำหนด",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "ตัวละครที่ต้องการแทนที่",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "ตัวละครใหม่ที่ต้องการแทนที่",
  T_37_WZY_WS_REVERSE_ARR_DESC: "คืนค่าองค์ประกอบทั้งหมดในรายการ",
  T_37_WZY_WS_REVIVEHERE: "ผู้เล่น ที่กำลังทำการชุบชีวิตเพื่อน ในจุดชุบชีวิต",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "ทำงานเมื่อผู้เล่นกำลัง ชุบชีวิตเพื่อนร่วมทีมที่จุดชุบชีวิต",
  T_37_WZY_WS_REVIVEWAYDESC: "เงื่อนไขที่ผู้เล่นต้องถูกชุบชีวิตจากการถูกกำจัด หรือถูกช่วยเหลือจากการล้ม",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "ตั้งค่าสถานะพฤติกรรมที่แตกต่างกันให้แก่ผู้เล่น เมื่อปิด ปุ่มที่เกี่ยวข้องจะไม่สามารถใ้ช้งานได้บน HUD และไม่สามารถเคลื่อนที่ได้ทั้งแบบควบคุมเอง และแบบอัตโนมัติ เมื่อซ่อน ปุ่มที่เกี่ยวข้องจะไม่แสดงบนหน้าจอ HUD ไม่สามารถเคลื่อนที่แบบควบคุมเองได้ แต่ยังสามารถเคลื่อนที่โดยอัตโนมัติได้ เมื่อเปิด ปุ่มที่เกี่ยวข้องจะแสดงและสามารถใช้งานได้บนหน้าจอ HUD สามารถเคลื่อนที่ได้ทั้งแบบควบคุมเอง และแบบอัตโนมัติ",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "ผู้เล่นที่ต้องการตั้งค่าสถานะ พฤติกรรม",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "พฤติกรรมของผู้เล่น รวมไปถึงการเคลื่อนที่ โจมตี กระโดด และการวิ่ง",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "สถานะรวมไปถึงการปิด ซ่อน และการเปิด เมื่อซ่อน ปุ่มที่เกี่ยวข้องจะไม่แสดงบนหน้าจอ HUD และสามารถเคลื่อนที่โดยอัตโนมัติได้เท่านั้น เมื่อเปิด ปุ่มที่เกี่ยวข้องจะแสดงบนหน้าจอ HUD และสามารถควบคุมการเคลื่อนที่ได้",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "พิกัดของลูกฟุตบอล",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "กำหนดความลูกฟุตบอล ควรรักษาความเร็วมาตรฐานก่อนมีการปรับแต่งหรือไม่ เป็นค่า Boolean",
  T_37_WZY_WS_SETPLAHOST_NAME: "ตั้งค่าการโจมตีของผู้เล่น",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "ตั้งค่า [ตั้งค่าผู้เล่น] ที่สามารถโจมตี [ผู้เล่นเป้าหมาย] ค่าเริ่มต้นจะตั้งว่าผู้เล่นเป้าหมายนั้นอยู่ในทีม และฝ่ายที่สามารถถูกโจมตีได้หรือไม่ การตั้งค่านี้ จะถูกนับความสำคัญสูงกกว่าการตั้งค่า ทีม/ฝ่าย",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "ผู้เล่น ที่ต้องการตั้งค่าศัตรู",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "ผู้เล่นที่เป็นศัตรู",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "สามารถโจมตีได้ หรือไม่",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"ใช่" หมายถึง สามารถโจมตีได้ "ไม่" หมายถึง ไม่สามารถโจมตีได้ ค่าเริ่มต้นนั้นจะอิงจาก ผู้เล่นเป้าหมายเป็นสมาชิกทีม และฝ่ายไหน ที่สามารถทำการโจมตีได้หรือไม่',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"ใช่" หมายความว่า สามารถโจมตีได้; "ไม่" หมายความว่า ไม่สามารถโจมตีได้',
  T_37_WZY_WS_SHADOWSTRENGTH: "เงา",
  T_37_WZY_WS_SHOOTANGLE: "มุมยิงที่เล็กที่สุด",
  T_37_WZY_WS_SKYBOX: "ท้องฟ้า",
  T_37_WZY_WS_SKYBOXENT: "เอนทิตี้ท้องฟ้า",
  T_37_WZY_WS_SKYBOXTYPE: "ประเภทท้องฟ้าปกติ",
  T_37_WZY_WS_STEPPED: "เหยียบตัวทำงาน",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "สลับช่องการสนทนาเสียง ของผู้เล่น",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "ผู้เล่นที่ต้องการสลับแชแนล",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "แชแนล่ที่ต้องการสลับไป",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "สลับฉากที่เลือก",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "ชื่อของฉากที่ต้องการสลับ",
  T_37_WZY_WS_TARGETSTR_DESC: "ประโยคเป้าหมาย",
  T_37_WZY_WS_TEAMASIDE: "ทีม และฝ่าย",
  T_37_WZY_WS_TELEPORTN_AUTO: "อัตโนมัติ",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "เคลื่อนย้ายได้ หรือไม่",
  T_37_WZY_WS_TELEPORTN_MANUAL: "ปรับเอง",
  T_37_WZY_WS_TELEPORTN_NO: "ไม่",
  T_37_WZY_WS_TELEPORTN_TITLE: "เงื่อนไข การเคลื่อนย้าย",
  T_37_WZY_WS_TELEPORTN_YES: "ใช่",
  T_37_WZY_WS_TERRAINWET: "ความชื้นของภูมิประเทศ",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "สลับรูปลักษณ์ [เอนทิตี้ผู้เล่น] กับรูปลักษณ์ [วัตถุในฉาก]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "เอนทิตี้ผู้เล่น ที่ต้องการเปลี่ยนรูปลักษณ์",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "ผู้เล่น ที่เลือกรับค่า เอนทิตี้การปลอมตัว",
  T_37_WZY_WS_TRANSP: "ความโปร่งใส",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "ถอนการติดตั้งฉากที่เลือก",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "ชื่อของฉากที่ต้องการถอนการติดตั้ง",
  T_37_WZY_WS_VFX1: "สัญลักษณ์",
  T_37_WZY_WS_VFX2: "ควัน",
  T_37_WZY_WS_VFX3: "ระเบิด",
  T_37_WZY_WS_VFX5: "แช่แข็ง",
  T_37_WZY_WS_VFX6: "ไฟสปอร์ตไลท์",
  T_37_WZY_WS_VFX7: "ความปั่นป่วนด้านบน",
  T_37_WZY_WS_VFX8: "การระเบิดของบรรยากาศ",
  T_37_WZY_WS_VISABLE: "การมองเห็น",
  T_37_WZY_WS_WEAOPEN: "แสดง หรือ ไม่",
  T_37_WZY_WS_WEAPONENT: "เอนทิตี้อาวุธ",
  T_37_WZY_WS_WEATARGETED: "ตั้งค่า การตกเป็นเป้าด้วย ระบบสนับสนุนการช่วยเล็ง",
  T_37_XYL_CUSTOMJERSEY: "Jersey Machine",
  T_37_XYL_CUSTOMJERSEY_DESC: "ใช้ Jersey Machine เพื่อสร้างชุดที่ต้องการได้",
  T_37_XYL_FOOTGUN: "ฟุตบอล ชู๊ตเตอร์",
  T_37_XYL_SOCCER: "ลูกฟุตบอล",
  "T_37_XYL_SOCCER_ RADIUS": "ระยะ",
  T_37_XYL_SOCCER_DESC: "ลูกฟุตบอล ที่สามารถปรับแต่งคุณสมบัติได้",
  T_37_XYL_SOCCER_HIGHT1: "มุมปกติ",
  T_37_XYL_SOCCER_HIGHT2: "มุมวอลเล่ย์",
  T_37_XYL_SOCCER_RESET: "รีเซตเวลา หลังจากทำประตู (วินาที)",
  T_37_XYL_SOCCER_RESIST1: "Friction (โหมดเตะ)",
  T_37_XYL_SOCCER_RESIST2: "Friction (โหมดยิง)",
  T_37_XYL_SOCCERGOAL: "ประตู",
  T_37_XYL_SOCCERGOAL_DESC: "นี่คือประตู ยิงลูกฟุตบอลเข้าประตูเพื่อทำคะแนน (เฉพาะใน Points Grab เท่านั้น)",
  T_37_XYL_SOCCERITEM: "จุดเกิดไอเทม",
  T_37_XYL_SOCCERITEM_DESC: "เมื่อวาง จะทำการสร้างไอเทมที่เลือก",
  T_37_XYL_SPAWN_PEOPLE: "# ของผู้เล่น",
  T_37_XYL_WS_AIRCONDITIONER001: "แอร์ คอนดิชันเนอร์ B",
  T_37_XYL_WS_AMMUCHEST: "กล่องสงคราม A",
  T_37_XYL_WS_BAFFLE001: "แบร์ริเออร์ A",
  T_37_XYL_WS_BARREL001: "ถัง",
  T_37_XYL_WS_BARREL001_DES: "ถังไม้ทรงกลม พบเห็นได้ทั่วไป",
  T_37_XYL_WS_BOARD001: "ป้ายโฆษณา B",
  T_37_XYL_WS_BOOK001: "กองหนังสือ A",
  T_37_XYL_WS_BOOK002: "บอร์ดเกม A",
  T_37_XYL_WS_BOUGAINVILLEA: "เฟื่องฟ้า",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "ของตกแต่ง - เพิ่มความมีชีวิตชีวาให้กับสถานที่",
  T_37_XYL_WS_BOX001: "กล่องเรียง A",
  T_37_XYL_WS_BOX002: "กล่องขนาดเล็ก",
  T_37_XYL_WS_BUSHCOVER: "พุ่มไม้",
  T_37_XYL_WS_BUSHCOVER_DES: "พุ่มไม้ ที่สามารถใช้ซ่อนตัวได้",
  T_37_XYL_WS_CABINET001: "ลิ้นชัก A",
  T_37_XYL_WS_CHAIR001: "เก้าอี้ A",
  T_37_XYL_WS_COCONUTTREE: "ต้นมะพร้าว",
  T_37_XYL_WS_COCONUTTREE_DES: "ของตกแต่ง - บรรยากาศชายหาด",
  T_37_XYL_WS_COMPUTER001: "คอมพิวเตอร์ A",
  T_37_XYL_WS_DAMAGERATIO: "อัตราความเสียหาย",
  T_37_XYL_WS_FIREEX: "ถังดับเพลิง",
  T_37_XYL_WS_GUIDEPOSE: "ป้ายบอกทาง",
  T_37_XYL_WS_HUGEHOUSE001: "บ้าน 3 ชั้น B",
  T_37_XYL_WS_HUGEHOUSE002: "บ้าน 2 ชั้น B",
  T_37_XYL_WS_JACKSTRAW: "หุ่นไล่กา",
  T_37_XYL_WS_LADDER001: "บันได A",
  T_37_XYL_WS_OILDRUM: "ถังน้ำมัน",
  T_37_XYL_WS_ORNAMENT001: "แจกัน A",
  T_37_XYL_WS_PACKBOX: "กล่องสเบียง",
  T_37_XYL_WS_PILLA001: "เสาคอนกรีต",
  T_37_XYL_WS_PRESENT: "กล่องของขวัญ",
  T_37_XYL_WS_PRESENT_DES: "เปิดเพื่อรับของขวัญ",
  T_37_XYL_WS_PUMPKIN: "แจ็ค โอ แลนเทิร์น เหลี่ยม",
  T_37_XYL_WS_PUMPKINCUT: "แจ็ค โอ แลนเทิร์น",
  T_37_XYL_WS_PUMPKINCUT_DES: "ของตกแต่งพื้นฐาน สำหรับเทศกาลสยองขวัญ",
  T_37_XYL_WS_ROADBLOCK001: "ที่กั้นถนน B",
  T_37_XYL_WS_SHELF001: "ชั้นหนังสือ A",
  T_37_XYL_WS_SOFA001: "โซฟา A",
  T_37_XYL_WS_SPAWNTEAM: "ทีมทั้งหมด",
  T_37_XYL_WS_SUPPLYBOX: "กล่องกระสุน",
  T_37_XYL_WS_TABLE001: "โต๊ะ A",
  T_37_XYL_WS_TABLE002: "โต๊ะ B",
  T_37_XYL_WS_TARGET001: "เป้าหมาย",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "ปลายทางประตู",
  T_37_XYL_WS_TELEPORTNEW: "ประตู A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "ประตู ที่สามารถเคลื่อนย้ายผู้เล่น ไปยังปลายทางของประตูได้",
  T_37_XYL_WS_TIRES001: "ยาง A",
  T_37_XYL_WS_TOOLRACK: "แผงเครื่องมือ",
  T_37_XYL_WS_WALL001: "กำแพง",
  T_37_XYL_WS_WOOD001: "ไม้ที่ถูกตัด",
  T_37_XYL_WS_YELLOWDUCK001: "เป็ดยาง",
  T_37_XYL_WS_YELLOWDUCK001_DES: "ห่วงยางเป็ดน้อย",
  T_37_YM_BOMBSQUAD_DEFUSER: "ตัวปลดชนวน",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF White Jersey (กางเกง)",
  T_37_YS_F_B_VN_STREET: "Crimson Auspicion (กางเกง)",
  T_37_YS_F_H_VN_STREET: "Crimson Auspicion (ทรงผม)",
  T_37_YS_F_S_VN_STREET: "Crimson Auspicion (รองเท้า)",
  T_37_YS_F_T_VN_STREET: "Crimson Auspicion (เสื้อ)",
  T_37_YS_M_A_CRICKET_BLACK: "Bumblebee Cricketer (หน้ากาก)",
  T_37_YS_M_A_THKOL: "หน้ากากราชาลากหัว",
  T_37_YS_M_B_CRICKET_BLACK: "Bumblebee Cricketer (กางเกง)",
  T_37_YS_M_B_SILVERERA: "Fearless Greyguard (กางเกง)",
  T_37_YS_M_B_THKOL: "กางเกงราชาลากหัว",
  T_37_YS_M_H_SILVERERA: "Fearless Greyguard (ทรงผม)",
  T_37_YS_M_H_THKOL: "หมวกราชาลากหัว",
  T_37_YS_M_S_CRICKET_BLACK: "Bumblebee Cricketer (กางเกง)",
  T_37_YS_M_S_SILVERERA: "Fearless Greyguard (รองเท้า)",
  T_37_YS_M_S_THKOL: "รองเท้าราชาลากหัว",
  T_37_YS_M_T_CRICKET_BLACK: "Bumblebee Cricketer (เสื้อ)",
  T_37_YS_M_T_SILVERERA: "Fearless Greyguard (เสื้อ)",
  T_37_YS_M_T_THKOL: "เสื้อราชาลากหัว",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF White Jersey (เสื้อ)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "จำนวนผู้เล่นขั้นต่ำ",
  T_38_BQ_SKILL_NAME_DUMMY1: "ดับเบิ้ล สตั้นท์",
  T_38_BQ_SKILL_NAME_DUMMY2: "สลับร่าง",
  T_38_CJ_F_B_STREAMER_MUSIC: "e-Heartseeker (กางเกง)",
  T_38_CJ_F_H_STREAMER_MUSIC: "e-Heartseeker (หัว)",
  T_38_CJ_F_S_STREAMER_MUSIC: "e-Heartseeker (รองเท้า)",
  T_38_CJ_F_T_STREAMER_MUSIC: "e-Heartseeker (เสื้อ)",
  T_38_JH_WS_CM1: "กฎชัดเจนดี",
  T_38_JH_WS_CM2: "กฎไม่ชัดเจน",
  T_38_JH_WS_CM3: "ออกจากเกมบ่อย",
  T_38_JL_M79_AMMO_N: "กระสุน M79",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J.Biebs's Microchip",
  T_38_M_WS_VECTOR2: "เวกเตอร์ 2 มิติ",
  T_38_R_TACTICS_N: "ตัวละคร",
  T_38_RW_NIW_NIWNAME: "เครื่องสร้างไอซ์วอลล์",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "บล็อกมีเลเยอร์มากเกินไป ขณะนี้: {0} สูงสุด: {1}",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "ไอเทมที่คุณสร้างขึ้นมา ({0}) มีจำนวนเกินกำหนด ({1})",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "เหตุการณ์ที่ได้รับในเฟรมเดียว ({0}) มีจำนวนเกินกำหนด ({1})",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "ถึงขีดจำกัดการสร้างเอนทิตี้แบบไดนามิกต่อเฟรม ({0}); การพยายามสร้าง {1} ครั้งถูกปฏิเสธ",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "ความยาวของรายการแรกเริ่ม ({0}) เกินกำหนด ({1}) แล้ว จะสร้างรายการขีดจำกัดสูงสุดโดยอัตโนมัติ",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "จำนวนการวนซ้ำ ({0}) ถึงจำนวนสูงสุดแล้ว ยกเลิกการวนซ้ำ",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "โครูทีนในปัจจุบัน ({0}) มีจำนวนในสโคปโครูทีนเกินกำหนด ({1})",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "ไม่สามารถเพิ่มองค์ประกอบเข้าในรายการได้ รายการ {0} ไม่มีข้อมูล",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "ประเภทมูลค่าในการคำนวณไม่ถูกต้อง ประเภทมูลค่าทางซ้ายเป็น {0} และทางขวาเป็น {1}",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "คำนิยามซ้ำของตัวแปรชั่วคราว ชื่อตัวแปร: {0}",
  T_38_SP_WS_REVIEW_01: "สร้างความไม่สบายใจให้แก่ผู้อื่น",
  T_38_SP_WS_REVIEW_02: "คำหยาบ",
  T_38_SP_WS_REVIEW_03: "สบประมาท",
  T_38_SP_WS_REVIEW_04: "สร้างความไม่สบายใจให้แก่ผู้อื่นอย่างที่สุด",
  T_38_SP_WS_REVIEW_05: "คุกคาม",
  T_38_SP_WS_REVIEW_06: "ไม่เคารพ",
  T_38_SP_WS_REVIEW_07: "อยู่ระหว่างรีวิว",
  T_38_SP_WS_REVIEW_08: "{0} ชื่อ {1} ไม่เป็นไปตามกฎ {2}",
  T_38_SP_WS_REVIEW_09: "String",
  T_38_SP_WS_REVIEW_10: "ร้านค้า",
  T_38_SP_WS_REVIEW_11: "ตัวแปร",
  T_38_SP_WS_REVIEW_12: "ฟังก์ชัน",
  T_38_SP_WS_REVIEW_13: "วัตถุ",
  T_38_SP_WS_REVIEW_14: "ไปที่คำนิยาม",
  T_38_SP_WS_REVIEW_15: "ไปที่ จัดการวัตถุ",
  T_38_SP_WS_REVIEW_16: "ไม่มีทิศทาง",
  T_38_SP_WS_REVIEW_17: "ชื่อแผนที่",
  T_38_SP_WS_REVIEW_18: "คำอธิบาย",
  T_38_SP_WS_REVIEW_19: "ภาพปก",
  T_38_SP_WS_REVIEW_20: "ข้อความมีคำไม่เหมาะสม",
  T_38_SP_WS_REVIEW_21: "การบันทึกล้มเหลว ไม่สามารถรีวิวได้",
  T_38_SP_WS_REVIEW_22: "รีวิวอยู่ระหว่างคูลดาวน์",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "ไม้เบสบอล - Mayhem",
  T_38_SY_CHARACTER_DESIGNER_N: "ซานติโน่",
  T_38_SY_PET_CACTUS_N: "แคคตัส",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "สกินคู่หู: ผีน้อยแคคตัส",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "สกินคู่หู: แคคตัส นีออน",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "สกินคู่หู: แคคตัส ปาล์มดรีม",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "สกินคู่หู: บลู ปาร์ตี้",
  T_38_SY_PETSKIN_RACCOON_MO_N: "สกินคู่หู: ร็อคกี้ เทรนดี้",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Nightfire Kami",
  T_38_SY_SICKLE_ES_N: "เคียว - Pop-Pow",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "รถกระบะ - Mochi Food Truck",
  T_38_WT_WS_MUITLEVEL: "หลายระดับ",
  T_38_WT_WS_SKILLSET15: "Thrill of Battle (A124)",
  T_38_WT_WS_SKILLSET16: "Senses Shockwave (โฮเมอร์)",
  T_38_WT_WS_SKILLSET17: "Wall Brawl (ไอริส)",
  T_38_WT_WS_SKILLSET18: "ไวเหนือแสง (ทัตสึยะ)",
  T_38_WZY_WS_ACTIVEA: "จะใช้งานในฉากหรือไม่",
  T_38_WZY_WS_ACTIVEB: "จะเปิดการรีเฟรชล็อกอินหรือไม่",
  T_38_WZY_WS_ACTIVEVALUE: "สถานะกิจกรรม",
  T_38_WZY_WS_AIR: "อากาศ",
  T_38_WZY_WS_ALLOWMOVE: "เคลื่อนที่ได้หรือไม่",
  T_38_WZY_WS_AMMOAMOUNT: "จำนวนกระสุน",
  T_38_WZY_WS_AMMONAME: "เอนทิตี้กระสุน",
  T_38_WZY_WS_ARMOR_DAMRED: "ตัวคูณการลดความเสียหาย",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "ตัวคูณการลดความเสียหายจากระเบิด",
  T_38_WZY_WS_ARMOR_DURABILITY: "ความทนทานตอนนี้",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "ความทนทานสูงสุด",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "เสียหายได้ หรือไม่",
  T_38_WZY_WS_ARMOR_ISDESTROY: "ถูกทำลายได้ หรือไม่",
  T_38_WZY_WS_ARMOR_LEVEL: "เลเวล",
  T_38_WZY_WS_ASSCONZOM: "ช่วยสนับสนุนการยิงซอมบี้",
  T_38_WZY_WS_BAGNAME: "เอนทิตี้กระเป๋า",
  T_38_WZY_WS_BAGSPACEEX: "พื้นที่กระเป๋าเพิ่มเติม",
  T_38_WZY_WS_BRIDGING: "องค์ประกอบในการเรนเดอร์สะพาน",
  T_38_WZY_WS_BUBBLE: "ฟอง",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "เคลียร์ไอเทมทั้งหมดในกระเป๋า [ของเอนทิตี้ผู้เล่น]",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "เคลียร์ไอเทมที่ไม่ต้องการซึ่งกระจัดกระจายอยู่ทั่วแม็ป เช่น สมบัติ, เศษอาวุธปา และกล่องสมบัติ เป็นต้น",
  T_38_WZY_WS_CLEARPRO: "เคลียร์ปัจจัยคุณสมบัติเดี่ยว",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "คัดลอกเอนทิตี้ [วัตถุในฉาก] ในสถานที่ของ [เอนทิตี้ผู้เล่น] และคืน [เอนทิตี้อำพราง]",
  T_38_WZY_WS_COMPONENT: "องค์ประกอบ",
  T_38_WZY_WS_COSTAMMO: "ใช้กระสุน",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "สร้างกล้องและกลับไปที่ [เอนทิตี้กล้อง] เพื่อปรับแต่งคุณสมบัติผ่านการตั้งค่าคุณสมบัติ",
  T_38_WZY_WS_CYCLES: "จำนวนครั้งที่เล่น",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "ใช้เพื่อเช็คว่า [เอนทิตี้] อยู่ภายในระยะเสาเป้าหมายหรือไม่ [จุดศูนย์กลาง] คือจุดศูนย์กลางของเสา [รัศมี] คือรัศมีของพื้นที่ผิวเป้าหมาย [ความสูง] คือความสูงของเสา [มุมออยเลอร์] คือองศาของมุม 3D ของเสา",
  T_38_WZY_WS_CYLINDERJUD_RES: "นี่คือผลลัพธ์ของเครื่องมือเช็คระยะเสา แสดงเป็นค่า Boolean",
  T_38_WZY_WS_DAMSUMZOM: "ความเสียหายต่อซอมบี้",
  T_38_WZY_WS_DARKNESS: "ความมืด",
  T_38_WZY_WS_DIFCOLOR: "สีของพื้นผิว",
  T_38_WZY_WS_DIFTEXTURE: "ลักษณะพื้นผิว",
  T_38_WZY_WS_DRUMMUSIC: "ประเภทองค์ประกอบ: กลอง",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "ผู้เล่นหลุดจากการเชื่อมต่อ",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "ผู้เล่นกำลังเชื่อมต่อกลับมา",
  T_38_WZY_WS_EUIANCHOR: "HUD Anchor Type Enumeration",
  T_38_WZY_WS_FEATHER: "ขนนก",
  T_38_WZY_WS_FLAMEAMMO: "กระสุนเพลิง",
  T_38_WZY_WS_FLOWER: "ดอกไม้",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "ตั้งค่า [เอนทิตี้] ให้ติดตาม [เอนทิตี้เป้าหมาย] อยู่เสมอ [พิกัดตั้งฉาก] คือระยะระหว่างเอนทิตี้สองหน่วย",
  T_38_WZY_WS_FOLLOWENT: "เอนทิตี้เป้าหมาย",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "ได้รับเอนทิตี้กล้องที่ [เอนทิตี้ผู้เล่น] กำลังใช้",
  T_38_WZY_WS_GETCURCAMDESC: "กล้องที่กำลังมีผู้เล่นใช้อยู่",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "ได้รับไอเทมจำนวนหนึ่งใน [ประเภทไอเทมที่กำหนด] ของ [ผู้เล่น]",
  T_38_WZY_WS_GETITEMNUM_RES: "จำนวนของไอเทมที่กำหนดซึ่งผู้เล่นครอบครองอยู่",
  T_38_WZY_WS_GETVEC_NAME: "ได้รับเวกเตอร์",
  T_38_WZY_WS_GETVEC_NAMEDESC: "รับเวกเตอร์ได้โดยใช้องค์ประกอบในแกน X, Y และ Z ของพิกัด",
  T_38_WZY_WS_GETVECRES: "เวกเตอร์ที่ได้รับจากองค์ประกอบในแกน X, Y และ Z",
  T_38_WZY_WS_GHOST: "ผี",
  T_38_WZY_WS_GRENADEFROZENNAME: "เอนทิตี้ระเบิดน้ำแข็ง",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "รัศมีพื้นที่แช่แข็ง",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "ระยะเวลาแช่แข็ง",
  T_38_WZY_WS_GRENADENAME: "เอนทิตี้ระเบิด",
  T_38_WZY_WS_GRENADEPARAM1: "ความเสียหายขั้นต่ำ",
  T_38_WZY_WS_GRENADEPARAM2: "ความเสียหายสูงสุด",
  T_38_WZY_WS_GRENADEPARAM4: "ระยะระเบิด",
  T_38_WZY_WS_GRENADEPARAM5: "ความเร็วในการขว้าง",
  T_38_WZY_WS_GRENADEPARAM6: "ดีเลย์ของระเบิด",
  T_38_WZY_WS_GRENADEPARAM7: "ตัวคูณความเสียหายจากตัวเอง",
  T_38_WZY_WS_GRENADEPARAM8: "ตัวคูณความเสียหายจากพื้นร่วมทีม",
  T_38_WZY_WS_GRENADEPARAM9: "ตัวคูณความเสียหายจากยานพาหนะ",
  T_38_WZY_WS_GUNFIRE: "ปืน",
  T_38_WZY_WS_GUNPRO_PARAM2: "ความเร็วรีโหลด",
  T_38_WZY_WS_GUNPRO_PARAM3: "อัตราความเสียหายของการยิงลำตัว",
  T_38_WZY_WS_GUNPRO_PARAM4: "อัตราความเสียหายของเฮดช็อต",
  T_38_WZY_WS_GUNPRO_PARAM5: "อัตราความเสียหายของการยิงแขนขา",
  T_38_WZY_WS_GUNPRO_PARAM7: "ความเสียหายเพิ่ม",
  T_38_WZY_WS_HELMET_NAME: "เอนทิตี้หมวก",
  T_38_WZY_WS_ICON1: "มงกุฎ",
  T_38_WZY_WS_ICON2: "ต่อสู้",
  T_38_WZY_WS_INITPOS: "ตำแหน่งที่ตั้งแรกเริ่ม",
  T_38_WZY_WS_ISRESET: "เคลื่อนที่ไปข้างหน้าสลับถอยหลัง",
  T_38_WZY_WS_KILLCONZOM: "จำนวนซอมบี้ที่กำจัดไปแล้ว",
  T_38_WZY_WS_KILLENT_NAMEDESC: "กำจัด [เอนทิตี้] เป้าหมายซึ่งจะต้องเป็นเอนทิตี้ประเภทต่อสู้โดยไม่สนสถานะอมตะ",
  T_38_WZY_WS_LABELPARAM: "รายการพารามิเตอร์ของเนื้อหาที่เป็นตัวอักษร",
  T_38_WZY_WS_LEADMUSICA: "ประเภทองค์ประกอบ: เปียโน (เทร็บเบิล)",
  T_38_WZY_WS_LEADMUSICB: "ประเภทองค์ประกอบ: เปียโน (อัลโต)",
  T_38_WZY_WS_LEADMUSICC: "ประเภทองค์ประกอบ: เปียโน (เบส)",
  T_38_WZY_WS_LINE: "เส้น",
  T_38_WZY_WS_LIQUID: "ของเหลว",
  T_38_WZY_WS_LOCALKEY: "คำแปล",
  T_38_WZY_WS_LOCALPOS: "ตำแหน่งที่ตั้งใกล้เคียง",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "ตั้งค่า [เอนทิตี้] เพื่อจับไปที่ [เอนทิตี้เป้าหมาย] อยู่เสมอ [พิกัดตั้งฉาก] คือระยะห่างระหว่างพิกัดของเป้าหมายและตำแหน่งของเอนทิตี้",
  T_38_WZY_WS_MAINWEAPONA: "อาวุธหลัก 1",
  T_38_WZY_WS_MAINWEAPONB: "อาวุธหลัก 2",
  T_38_WZY_WS_MOTIONTIME: "ระยะเวลาการเคลื่อนที่",
  T_38_WZY_WS_MOTIONTYPE: "วิธีเคลื่อนที่",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "EP ที่ถูกปรับแต่ง",
  T_38_WZY_WS_MUSHROOMNAME: "เอนทิตี้เห็ด",
  T_38_WZY_WS_OBFACTION: "ส่วนผู้เข้าชม",
  T_38_WZY_WS_OBGLOBAL: "เข้าชมทั้งหมด",
  T_38_WZY_WS_OBSERVER: "ตัวเลือกผู้เข้าชม",
  T_38_WZY_WS_OBTEAM: "เข้าชมทีม",
  T_38_WZY_WS_OFFSETVEC: "พิกัดตั้งฉาก",
  T_38_WZY_WS_ONBUY_NAMEDESC: "จะแสดงผลเมื่อผู้เล่นซื้อไอเทมจากตู้กดอัตโนมัติ [เอนทิตี้ผู้เล่น] คือผู้เล่นที่ทำการซื้อของ [เอนทิตี้สินค้า] คือไอเทมที่ซื้อ",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "จะแสดงผลเมื่อ [เอนทิตี้ผู้เล่น] กดสวมใส่",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "จะแสดงผลเมื่อผู้เล่นกระโดดเสร็จ",
  T_38_WZY_WS_ONLIE_NAMEDESC: "จะแสดงผลเมื่อผู้เล่นหมอบ",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "จะแสดงผลเมื่อรีโหลดอาวุธ",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "จะแสดงผลเมื่อผู้เล่นวิ่งเสร็จ",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "จะแสดงผลเมื่อผู้เล่นออกย่อเสร็จ",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "จะแสดงผลเมื่อใช้อาวุธกำจัดยูนิตได้สำเร็จ [เอนทิตี้ที่ถูกกำจัด] คือยูนิตที่ถูกกำจัดออกจากเกม",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "จะแสดงผลเมื่ออาวุธสร้างความเสียหายให้กับเอนทิตี้ในการต่อสู้ [เป้าหมายที่ถูกโจมตี] คือเอนทิตี้ในการต่อสู้ที่ได้รับความเสียหาย [ความเสียหาย] คือความเสียหายที่ผู้เล่นสร้างขึ้น",
  T_38_WZY_WS_OWNER: "เจ้าของ",
  T_38_WZY_WS_PARAMLIST: "รายการพารามิเตอร์",
  T_38_WZY_WS_PARTICALMAP: "วางพิกัดอนุภาค",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'หยุดหรือเล่นอีโมตในปัจจุบันต่อสำหรับ [เอนทิตี้ผู้เล่น] [หยุดหรือเล่นต่อ] เป็นค่า Boolean "Yes" จะเป็นการหยุดเล่น "No" จะเป็นการเล่นต่อไป',
  T_38_WZY_WS_PLAENTTRI_DESC: "จะทำงานเมื่อมีผู้เล่นเข้าสู่พื้นที่กระตุ้น",
  T_38_WZY_WS_PLAQUITTRI_DESC: "จะทำงานเมื่อมีผู้เล่นออกจากพื้นที่กระตุ้น",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "ทำให้ [เอนทิตี้ของผู้เล่น] แสดง [อีโมต] ที่เลือกหนึ่งครั้งและกลับสู่ท่าเดิมเมื่อเล่นเสร็จ",
  T_38_WZY_WS_PLAYSPEED: "เปอร์เซ็นต์ความเร็วในการเล่นซ้ำ",
  T_38_WZY_WS_PREHUD_NAME: "ไอคอนปรับแต่ง",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "ให้ [เอนทิตี้ผู้เล่น] ออกจากฝ่ายปัจจุบัน",
  T_38_WZY_WS_RESETENT: "รีเซตองค์ประกอบทุกรอบ",
  T_38_WZY_WS_RESUUID: "UUID ทรัพยากร",
  T_38_WZY_WS_RIMCOLOR: "สีกรอบ",
  T_38_WZY_WS_RIMTEXTURE: "ลักษณะกรอบ",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "ใช้เพื่อเช็คว่า [เอนทิตี้] อยู่ภายในกรวยหรือไม่ [จุดศูนย์กลาง] และ [รัศมี] คือจุดศูนย์กลางและรัศมีของกรวย [รัศมีส่วนเกิน] คือรัศมีของพื้นที่เล็ก ๆ ภายในกรวย ความสูงคือความสูงของโครงสร้าง 3D [มุม] คือมุมบริเวณศูนย์กลางของกรวย [มุมของทิศทาง] คือเวกเตอร์บอกทิศทางที่พุ่งออกจากแกนกลาง",
  T_38_WZY_WS_SECTORJUD_RES: "นี่คือผลลัพธ์ของเครื่องเช็คระยะทรงพัด แสดงเป็นค่า Boolean",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "ตั้งค่าสถานะกิจกรรมของ [เอนทิตี้เป้าหมาย] [สถานะกิจกรรม] เป็นค่า Boolean ซึ่งส่งผลต่อความพร้อม การมองเห็น และการชนของเอนทิตี้",
  T_38_WZY_WS_SETROUNDSCORE: "ตั้งคะแนนในรอบของผู้เล่น",
  T_38_WZY_WS_SHOOTANGMAX: "มุมยิงสูงสุด",
  T_38_WZY_WS_SHOWMAPINFO: "แสดงข้อมูลแผนที่สำหรับฝั่งเดียวกัน",
  T_38_WZY_WS_SHOWNAMEHUD: "แสดง HUD ของชื่อสำหรับฝั่งเดียวกัน",
  T_38_WZY_WS_SOUND1: "เร่งความเร็ว",
  T_38_WZY_WS_SOUND10: "เริ่มรอบ",
  T_38_WZY_WS_SOUND11: "ซอมบี้",
  T_38_WZY_WS_SOUND12: "สยองขวัญ",
  T_38_WZY_WS_SOUND13: "แปลงร่าง",
  T_38_WZY_WS_SOUND14: "หัวใจเต้นรัว ๆ",
  T_38_WZY_WS_SOUND15: "หัวใจเต้น",
  T_38_WZY_WS_SOUND16: "หัวใจเต้นช้า ๆ",
  T_38_WZY_WS_SOUND17: "ช่วงเร่งด่วน",
  T_38_WZY_WS_SOUND18: "คลิก",
  T_38_WZY_WS_SOUND19: "สกิลฟื้นฟู",
  T_38_WZY_WS_SOUND2: "แจ้งเตือนว่าหายไป",
  T_38_WZY_WS_SOUND20: "เข้าร่วมเกม",
  T_38_WZY_WS_SOUND3: "วิชวลเอฟเฟ็กต์",
  T_38_WZY_WS_SOUND4: "เสียงจิ้งหรีดตอนกลางคืน",
  T_38_WZY_WS_SOUND5: "โจมตี (ทื่อ)",
  T_38_WZY_WS_SOUND6: "รีแอคชั่น",
  T_38_WZY_WS_SOUND7: "เจอเรื่องเซอร์ไพรส์",
  T_38_WZY_WS_SOUND8: "ผี",
  T_38_WZY_WS_SOUNDENT: "เอนทิตี้ดนตรี",
  T_38_WZY_WS_SPAWNPOS: "จุดเกิดเดิม",
  T_38_WZY_WS_SPHERENAME: "วงพื้นฐาน",
  T_38_WZY_WS_SPHERERADIUS: "รัศมีวง",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "ใช้เพื่อเช็คว่า [เอนทิตี้] อยู่ภายในระยะทรงกลมหรือไม่ [จุดศูนย์กลาง] และ [รัศมี] คือจุดศูนย์กลางและรัศมีของโครงสร้างทรงกลม",
  T_38_WZY_WS_SPHERICALJUD_RES: "นี่คือผลลัพธ์ของเครื่องมือเช็คระยะทรงกลม แสดงเป็นค่า Boolean",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "ใช้เพื่อเช็คว่า [เอนทิตี้] อยู่ภายในระยะทรงเหลี่ยมหรือไม่ [จุดศูนย์กลาง] คือจุดศูนย์กลางของทรงเหลี่ยม [ความยาว], [ความกว้าง] และ [ความสูง] คือความยาว กว้าง และสูงของทรงเหลี่ยม ส่วน [มุมออยเลอร์] คือองศาของมุม 3D ของทรงเหลี่ยม",
  T_38_WZY_WS_SQUAREJUD_RES: "นี่คือผลลัพธ์ของเครื่องมือเช็คระยะทรงเหลี่ยม แสดงเป็นค่า Boolean",
  T_38_WZY_WS_STARTGENTIME: "เวลาเริ่มเกิด",
  T_38_WZY_WS_STAYTIME: "ระยะเวลาการหยุดเคลื่อนที่",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "เปลี่ยนกล้องของผู้เล่นไปเป็น [เอนทิตี้กล้อง] ใน [โหมดเปลี่ยนมุมกล้อง] อาจมีหรือไม่มีการเคลื่อนไหวก็ได้ ส่วน [เวลาในการเปลี่ยน] คือเวลาตอนที่เปลี่ยนมุมกล้องขณะมีการเคลื่อนไหว",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "ในการเปลี่ยนโหมดกล้อง คุณจะสามารถเลือกระหว่าง &quotไม่มีการเคลื่อนไหว&quot กับ &quotมีการเคลื่อนไหว&quot ได้",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'เวลาในการเปลี่ยนโหมดขณะมีการเคลื่อนไหว เมื่อเลือก "ไม่มีการเคลื่อนไหว" การตั้งค่านี้จะถูกยกเลิก',
  T_38_WZY_WS_TEXTHUD: "องค์ประกอบตัวอักษรของ HUD",
  T_38_WZY_WS_TEXTTYPE: "ขนาดตัวอักษร",
  T_38_WZY_WS_TEXTUREID: "ประเภทพื้นผิว",
  T_38_WZY_WS_TRANDIST: "ระยะสูงสุด",
  T_38_WZY_WS_TWEENERENABLED: "เปิดใช้สคริปต์ UITweener หรือไม่",
  T_38_WZY_WS_TYPELIST: "รายการประเภท",
  T_38_WZY_WS_TYPELISTORLIST: "ประเภทหรือรายการประเภท",
  T_38_WZY_WS_VEST_NAME: "เอนทิตี้เกราะ",
  T_38_WZY_WS_VFX1: "กำจัดผู้ซ่อน",
  T_38_WZY_WS_VFX10: "ไหม้ต่อเนื่อง",
  T_38_WZY_WS_VFX11: "แก๊สพิษ",
  T_38_WZY_WS_VFX13: "หัวใจ",
  T_38_WZY_WS_VFX15: "ประตู",
  T_38_WZY_WS_VFX2: "Rampage",
  T_38_WZY_WS_VFX3: "กำจัดร่างโคลน",
  T_38_WZY_WS_VFX4: "แรงดีด",
  T_38_WZY_WS_VFX5: "ร่างโคลน",
  T_38_WZY_WS_VFX6: "พรางตัว",
  T_38_WZY_WS_VFX7: "ระเบิดแฟลช",
  T_38_WZY_WS_VFX8: "ร่องรอยการเคลื่อนไหว",
  T_38_WZY_WS_VFX9: "ชาร์จยิง",
  T_38_WZY_WS_VFXENT: "ตัวอย่างวิชวลเอฟเฟ็กต์",
  T_38_WZY_WS_VFXTYPEA_NAME: "วิชวลเอฟเฟ็กต์ในการวางพิกัดแบบปรับแต่งเองได้",
  T_38_WZY_WS_VFXTYPEB_NAME: "วิชวลเอฟเฟ็กต์ในการวางพิกัดแบบปรับแต่งไม่ได้",
  T_38_WZY_WS_VISIBILITY: "ประเภทการมองเห็น",
  T_38_WZY_WS_VOLUME: "ระดับเสียง",
  T_38_WZY_WS_WEAPONGEN: "เครื่องสร้างอาวุธ",
  T_38_WZY_WS_WHECYCLE: "เล่นซ้ำ",
  T_38_XXJ_WS_BLOCKMODE: "โหมดบล็อก",
  T_38_XXJ_WS_CUSTOMCAMARA: "กล้องปรับแต่งเอง",
  T_38_XXJ_WS_FFCLASSIC: "FF พื้นฐาน (เกมยิง)",
  T_38_XXJ_WS_FOV: "ขอบเขตการมองเห็น",
  T_38_XXJ_WS_FOVDESC: "ขอบเขตการมองเห็นคือระยะที่กล้องสามารถมองเห็นได้",
  T_38_XXJ_WS_FPS: "มุมมองบุคคลที่หนึ่ง (เกมยิง)",
  T_38_XXJ_WS_HORIZONTALANGLE: "มุมแนวนอน",
  T_38_XXJ_WS_INVISICAM: "กึ่งใส",
  T_38_XXJ_WS_OFFSET: "ระยะตั้งฉาก",
  T_38_XXJ_WS_ORTHOGRAPHIC: "ภาพฉาย",
  T_38_XXJ_WS_PERSPECTIVE: "มุมมอง",
  T_38_XXJ_WS_PROJECTIONMODE: "โหมดภาพฉาย",
  T_38_XXJ_WS_STABLE: "ล็อกมุมกล้อง",
  T_38_XXJ_WS_STARTCAMERA: "กล้องค่าเริ่มต้น",
  T_38_XXJ_WS_STARTCAMERAMODE: "โหมดกล้องค่าเริ่มต้น",
  T_38_XXJ_WS_THIRD: "กล้องติดตามผู้เล่น",
  T_38_XXJ_WS_TOPVIEW: "มุมสูง",
  T_38_XXJ_WS_TPS: "มุมมองบุคคลที่ 3",
  T_38_XXJ_WS_TRANSVERSE: "เคลื่อนไหวในแนวราบ",
  T_38_XXJ_WS_VERTICALANGLE: "มุมแนวตั้ง",
  T_38_XXJ_WS_ZOOM: "ซูม",
  T_38_XYL_WS_AISTARTTIME: "เวลาเริ่มต้น (วินาที)",
  T_38_XYL_WS_ARMORDESTROY: "ตัวคูณดาเมจเกราะ",
  T_38_XYL_WS_BONFIRE: "กองไฟ",
  T_38_XYL_WS_CANDLE01: "เทียน A",
  T_38_XYL_WS_CANNON01: "ปืนใหญ่",
  T_38_XYL_WS_CLIPAMMOSIZE: "ความจุแมกกาซีน",
  T_38_XYL_WS_DAMAGEDTRUCK: "รถบรรทุกพัง",
  T_38_XYL_WS_DOLL01: "ตุ๊กตาชวนขนลุก",
  T_38_XYL_WS_ENTERANCEHOUSE01: "บ้านอิฐ A",
  T_38_XYL_WS_FENCE002: "รั้วเหล็ก B",
  T_38_XYL_WS_FIREWORK01: "ดอกไม้ไฟ A",
  T_38_XYL_WS_GENERATOR: "เครื่องสร้าง",
  T_38_XYL_WS_GRAVITY: "ความเร่งโน้มถ่วง",
  T_38_XYL_WS_GRAVITYAREA: "โซนแรงโน้มถ่วงผิดปกติ",
  T_38_XYL_WS_GRAVITYAREA_DESC: "พื้นที่ที่ผู้เล่นสามารถเปลี่ยนค่าแรงโน้มถ่วงได้",
  T_38_XYL_WS_HOLDWEAPON: "อาวุธที่มีอยู่",
  T_38_XYL_WS_INDOORFURNITURE: "เฟอร์นิเจอร์ภายในอาคาร",
  T_38_XYL_WS_LIGHTTUBE001: "หลอดไฟ A",
  T_38_XYL_WS_LOVEBALLOON01: "บอลลูนวาเลนไทน์ A",
  T_38_XYL_WS_LOVELAMP01: "เสาไฟรูปหัวใจ",
  T_38_XYL_WS_LOVESIGN01: "ป้ายไฟนีออน Love",
  T_38_XYL_WS_OILDRUM_DAMAGE: "อัตราดาเมจถังน้ำมัน",
  T_38_XYL_WS_OUTDOORPROPS: "เฟอร์นิเจอร์ภายนอกอาคาร",
  T_38_XYL_WS_PIPEANDBOX: "ท่อน้ำและภาชนะ",
  T_38_XYL_WS_PLANT: "พืช",
  T_38_XYL_WS_ROSE01: "ดอกกุหลาบ",
  T_38_XYL_WS_ROSEN: "ช่อดอกกุหลาบ",
  T_38_XYL_WS_SMALLBUILDING: "ตึกเล็ก ๆ",
  T_38_XYL_WS_SOFA002: "โซฟา B",
  T_38_XYL_WS_TOWNHOUSE01: "บ้านเก่า 2 ชั้น",
  T_38_XYL_WS_TV001: "ทีวีเก่า",
  T_38_ZP_CC_EXCHANGESTATUS: "สถานะ",
  T_39_BQ_SKILL_NAME_VILLAIN: "โลหิตอาฆาต",
  T_39_CJ_A_BURN: "Victory Glintmark",
  T_39_HJ_WS_Arrow002: "ลูกศร 2",
  T_39_HJ_WS_LIKERATE2: "{0} นาที",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} นาที",
  T_39_HJ_WS_SOUND10: "เสียงเดิน",
  T_39_HJ_WS_SOUND11: "ภารกิจสำเร็จ 1",
  T_39_HJ_WS_SOUND13: "เตือนอันตราย 1",
  T_39_HJ_WS_SOUND14: "เตือนอันตราย 2",
  T_39_HJ_WS_SOUND15: "เคาท์ดาวน์ 3",
  T_39_HJ_WS_SOUND16: "เสียงคำแนะนำ",
  T_39_HJ_WS_SOUND17: "เสียงการ้อง",
  T_39_HJ_WS_SOUND18: "เสียงเทเลพอร์ตไปยังจุดหมายที่ผิด",
  T_39_HJ_WS_SOUND19: "เสียงเทเลพอร์ตไปยังจุดหมายที่ถูกต้อง",
  T_39_HJ_WS_SOUND2: "เคาท์ดาวน์ 1",
  T_39_HJ_WS_SOUND20: "เทเลพอร์ต",
  T_39_HJ_WS_SOUND21: "ไฟฟ้าช็อต",
  T_39_HJ_WS_SOUND23: "ได้รับไอเทม",
  T_39_HJ_WS_SOUND24: "BGM อิเลคโทรสุดคิวท์",
  T_39_HJ_WS_SOUND25: "BGM เกมแบบสบาย ๆ",
  T_39_HJ_WS_SOUND4: "เสียงเอคโค่อุปกรณ์มีกลไก",
  T_39_HJ_WS_SOUND5: "ยุง",
  T_39_HJ_WS_SOUND6: "ดิ้ง ดิ้ง ดิ้ง 1",
  T_39_HJ_WS_SOUND7: "ดิ้ง ดิ้ง ดิ้ง 2",
  T_39_HJ_WS_SOUND8: "เปลี่ยนอาวุธ",
  T_39_HJ_WS_SOUND9: "ชาร์จ 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "ไอซ์วอลล์ไม่จำกัด",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "อาวุธปาไม่จำกัด",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "เสียงยิงพิเศษ",
  T_39_HQ_UGC_CUSTOMRES: "ทรัพยากรสร้างเอง",
  T_39_M_ACCOUNTID: "บัญชี",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "แสดงผลเมื่อแตะปุ่ม 2 ครั้ง",
  T_39_MF_SKILLTAG_4: "การเคลื่อนที่",
  T_39_PD_HuntingGroundSnow_MYNAME: "Mr. V",
  T_39_QL_SKILL_OTHO_DES: "เมื่อยิงศัตรูล้ม จะทำเครื่องหมายเพื่อนในทีมศัตรูในระยะ [FFB300]{0}ม[-] ของศัตรูที่ล้ม และลดความเร็วในการเคลื่อนที่ของพวกศัตรูลง [FFB300]{1}%[-] เป็นเวลา [FFB300]{2}วินาที[-] เมื่อถูกศัตรูที่อยู่ใกล้ๆยิงล้ม จะทำเครื่องหมายและทำให้ศัตรูที่โจมตีและเพื่อนในทีมศัตรูความเร็วลดลง",
  T_39_QL_SKILL_WOLFRAHH_DES: "หลังยิงศัตรูล้มได้จะเข้าสู่โหมดระเบิดพลังเป็นเวลา [FFB300]{2} วินาที[-] เพิ่มอัตราการยิง [FFB300]{0}%[-] และความเร็วเคลื่อนที่ [FFB300]{1}%[-] แต่จากนั้นจะลดลงอย่างรวดเร็ว ในโหมดระเบิดพลัง การยิงศัตรูล้มต่อเนื่องจะรีเซตตัวนับถอยหลัง เพิ่มอัตราการยิง [FFB300]{3}%[-] และความเร็วเคลื่อนที่ [FFB300]{4}%[-]",
  T_39_QL_SKILL_XAYNE_DES1: "โหมดเอ็กซ์ตรีม: ได้รับ HP ชั่วคราว [FFB300]{0} หน่วย[-]  เป็นเวลา [FFB300]{1} วินาที[-]  ในระหว่างนี้ เอฟเฟ็กต์การฮีล HP จะเพิ่มขึ้น [FFB300]{2}%[-]  คูลดาวน์: [FFB300]{3} วินาที[-]",
  T_39_RW_GM_DEFEAT: "ล้มเหลว",
  T_39_RW_SKILL_DESC_FORD: "เมื่อได้รับความเสียหาย คุณจะได้รับ HP  [FFB300]{1}[-] หน่วยต่อวินาที เป็นเวลา [FFB300]{0} วินาที[-] หลังปล่อยสกิลกดใช้ออกไป สกิลติดตัวจะรีเซตทันที คูลดาวน์: [FFB300]{2} วินาที[-]",
  T_39_SP_WS_ITEMENTITY_01: "เอนทิตี้ไอเทม",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'อัลวาโร่ "ระเบิดโทสะ"',
  T_39_SY_CHARACTER_VILLAIN_N: "โอไรออน",
  T_39_SY_KATANA_FASTBREAKING23_N: "คาตานะ - เขียวเหนี่ยวฟัน",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "บลูนี้สีเขียว",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "สกินคู่หู : รอยัลทิก",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "สกินคู่หู : คมเขี้ยวโลหิตอาฆาต",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "รถบิ๊กฟุตพันธุ์ข้าวเหนียว",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "ตุ๊กตุ๊ก - Floral Chariot",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "ปลุกพลัง: [FFB300]{0} วินาที[-]ก่อนระเบิด ระเบิดมือจะปล่อยระเบิดเพิ่ม [FFB300]{1}[-] ลูก สร้างความเสียหายเพิ่มจากเดิม [FFB300]{2}%[-]",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Split Blitz",
  T_39_WT_WS_EMPTYMAP_TAG: "พื้นที่ว่าง",
  T_39_WT_WS_FEMAPMODE: "ชื่อโหมด",
  T_39_WT_WS_FEMAPTAG: "แท็กของแผนที่",
  T_39_WT_WS_MAPPLAYER: "จำนวนผู้เล่น",
  T_39_WT_WS_MEDENTERNUM: "จำนวนผู้เล่นที่เข้าร่วมกลางเกมสูงสุด",
  T_39_WT_WS_MIDENTER: "กำลังเข้าร่วมกลางเกม",
  T_39_WT_WS_MIDENTERCOUNT: "จำนวนผู้เล่นที่เข้าร่วมกลางเกมได้",
  T_39_WT_WS_MIDENTERTIME1: "กำหนดเวลาเข้าร่วมกลางเกม",
  T_39_WT_WS_MIDENTERTIME2: "ระยะเวลาเข้าร่วมกลางเกม",
  T_39_WT_WS_MIDENTERTIMETIP: "หากจำนวนผู้เล่นในเกมยังไม่ถึงจำนวนสูงสุด เปิดให้ผู้เล่นเข้าร่วมเกมได้ภายใน N วินาทีหลังเกมเริ่ม เมื่อผ่านไป N วินาทีแล้ว ผู้เล่นจะไม่สามารถเข้าร่วมได้",
  T_39_WT_WS_MIDENTERTIP: "เมื่อเปิดใช้งาน ผู้เล่นจะเข้าร่วมแผนที่นี้กลางเกมได้",
  T_39_WT_WS_PLAYERCOUNT: "จำนวนผู้เล่นแรกเริ่ม",
  T_39_WT_WS_PLAYERCOUNTTIP: "จำนวนผู้เล่นเมื่อเริ่มเกม ผู้เล่นคนอื่นสามารถเข้าร่วมกลางเกมได้จนกว่าจะถึงจำนวนสูงสุด",
  T_39_WT_WS_TAG1: "Free For All",
  T_39_WT_WS_TAG10: "ง่าย",
  T_39_WT_WS_TAG11: "ยากปานกลาง",
  T_39_WT_WS_TAG12: "ยากมาก",
  T_39_WT_WS_TAG13: "ท้าทายสุด ๆ",
  T_39_WT_WS_TAG14: "หนีเอาชีวิตรอด",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "ทรัพยากรสร้างเอง",
  T_39_WT_WS_TAG18: "ปริศนา",
  T_39_WT_WS_TAG19: "แข่งความเร็ว",
  T_39_WT_WS_TAG2: "สงครามกระสุน",
  T_39_WT_WS_TAG20: "ดนตรี",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "ผจญภัย",
  T_39_WT_WS_TAG23: "ล่าซอมบี้",
  T_39_WT_WS_TAG24: "PVP",
  T_39_WT_WS_TAG25: "Party Game",
  T_39_WT_WS_TAG26: "ทีมเดธแมตช์",
  T_39_WT_WS_TAG27: "ป้องกันป้อม",
  T_39_WT_WS_TAG28: "ฝึกซ้อม",
  T_39_WT_WS_TAG3: "ออกอาวุธ",
  T_39_WT_WS_TAG4: "เกิดใหม่",
  T_39_WT_WS_TAG5: "สไนเปอร์",
  T_39_WT_WS_TAG6: "เอาชีวิตรอด",
  T_39_WT_WS_TAG7: "เล่นคนเดียว",
  T_39_WT_WS_TAG8: "สยองขวัญ",
  T_39_WT_WS_TAG9: "ชิล ๆ",
  T_39_WT_WS_TAGMAXTIP: "เลือกได้สูงสุด {0} แท็ก",
  T_39_WT_WS_TAGTYPE1: "ประเภทเกมเพลย์",
  T_39_WT_WS_TAGTYPE2: "ประเภทแผนที่",
  T_39_WT_WS_TAGTYPE3: "ประเภทโหมด",
  T_39_WT_WS_TAGTYPE4: "ขนาดทีม",
  T_39_WZY_WS_ACCSPEED: "การเร่ง",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "เพิ่มสคริปต์ [ชื่อสคริปต์] สำหรับ [เอนทิตี้]",
  T_39_WZY_WS_ASC: "มากไปน้อย",
  T_39_WZY_WS_ASCIGZERO: "มองข้ามเลขศูนย์โดยเรียงจากมากไปน้อย",
  T_39_WZY_WS_BALLISTMOVENT: "เอนทิตี้การเคลื่อนไหวแบบขีปนาวุธ",
  T_39_WZY_WS_BEUSED_NAMEDESC: "จะทำงานเมื่อ [เอนทิตี้ผู้เล่น] ใช้งานไอเทม",
  T_39_WZY_WS_BODYSCALE: "ขนาดตัว",
  T_39_WZY_WS_BRAKETORQUE: "แรงม้าของเบรก",
  T_39_WZY_WS_CAMTRANTYPE: "ประเภทการเปลี่ยนมุมกล้อง",
  T_39_WZY_WS_CARVEHICLE: "โฟร์วีล",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "เช็คว่ามีสคริปต์ [ชื่อสคริปต์] ใน [เอนทิตี้] หรือไม่ (ค่าที่ได้กลับมาควรเป็นค่า Boolean)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "เช็คว่าในเอนทิตี้มีผลของสคริปต์ที่ระบุอยู่หรือไม่ (ค่า Boolean)",
  T_39_WZY_WS_COMBINEALL: "อาวุธคู่ (ปืนคนละประเภท)",
  T_39_WZY_WS_COMBINESELF: "อาวุธคู่ (ปืนแบบเดียวกัน)",
  T_39_WZY_WS_CONENAME: "กรวยพื้นฐาน",
  T_39_WZY_WS_COORSYS: "ระบบพิกัด",
  T_39_WZY_WS_CRASHMAXD: "ความเสียหายสูงสุดของการชน",
  T_39_WZY_WS_CRASHMIND: "ความเสียหายขั้นต่ำของการชน",
  T_39_WZY_WS_CRAWLSPEED: "เปอร์เซ็นต์ความเร็วเคลื่อนที่ (หมอบ)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "สร้างการเคลื่อนไหวแบบขีปนาวุธให้กับ [เอนทิตี้เป้าหมาย] สามารถปรับ [ความเร็วแรกเริ่ม], [ค่าเร่ง] และ [ระยะสูงสุด] ที่สะสมในทิศทางความเร็วแรกเริ่มของเอนทิตี้เป้าหมายได้ และแสดง [เอนทิตี้การเคลื่อนไหวแบบขีปนาวุธ]",
  T_39_WZY_WS_CRETWEEN_NAME: "สร้างการเคลื่อนไหวสอดแทรก",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "สร้างการเคลื่อนไหวสอดแทรกสำหรับ [เอนทิตี้] ด้วย [คุณสมบัติ] ของเอนทิตี้ที่เคลื่อนไหวจาก [ค่าเริ่มต้น] ไปสู่ [ค่าเป้าหมาย] อย่างนุ่มนวล ภายใน [เวลา] [วิธี] แสดงการเคลื่อนไหวประกอบด้วย [ทางเดียว], [กระเด้ง] และ [เป็นวงกลม] [แนวโค้ง]  คือแนวโค้งของการเคลื่อนไหว และ [การเคลื่อนไหวสอดแทรก] จะกลับมาหลังมีการสร้างการเคลื่อนไหว",
  T_39_WZY_WS_CURVE: "แนวโค้ง",
  T_39_WZY_WS_CUSTRESULT: "หน้าสรุปผลเกมสร้างเอง",
  T_39_WZY_WS_CYLINDERNAME: "กระบอกพื้นฐาน",
  T_39_WZY_WS_DEFAULT: "ไม่มีแอนิเมชั่น (ค่าเริ่มต้น)",
  T_39_WZY_WS_DESC: "น้อยไปมาก",
  T_39_WZY_WS_DIFFUSEALPHA: "ความโปร่งใสของพื้นผิว",
  T_39_WZY_WS_DISCONNECT: "หลุดการเชื่อมต่อ",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "พลังงานที่ฟื้นฟูต่อวินาที",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "ใช้พลังงาน",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "ความสูงสูงสุดของการกระโดดครั้งที่ 2",
  T_39_WZY_WS_ENABLEJOIN: "อนุญาตการเข้าเล่นกลางเกม",
  T_39_WZY_WS_ENDPOS: "พิกัดจุดหมาย",
  T_39_WZY_WS_ENGINETORQUE: "แรงม้าของเครื่องยนต์",
  T_39_WZY_WS_EXPLODED: "ความเสียหายของการระเบิด",
  T_39_WZY_WS_FEELDSPEED: "เปอร์เซ็นต์ความเร็วเคลื่อนที่ (ล้ม)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "เวลาการกระพิบที่ศูนย์กลาง",
  T_39_WZY_WS_FLASH_CRANGE: "ระยะศูนย์กลาง",
  T_39_WZY_WS_FLASH_EFLASHTIME: "เวลาการกระพิบที่ขอบ",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "ผลการโดนระเบิดแสง",
  T_39_WZY_WS_FLASH_RANGE: "ระยะการระเบิด",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "ความเร็วในการลงสู่พื้น",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "ความสูงสูงสุด",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "ความเร็วการไถลในแนวนอน",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "ความเร็วการไถลในแนวตั้ง",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "ความสูงขั้นต่ำในการลงสู่พื้น",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "ความสูงขั้นต่ำในการออกตัว",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "ความเร็วในการลงสู่พื้นหลังขึ้นไปสูงมาก",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "ความเร็วในการโค้ว",
  T_39_WZY_WS_FOLMOVENT: "เอนทิตี้การเคลื่อนไหวติดตามตำแหน่ง",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "ได้รับรายการสกิลของ [เอนทิตี้ผู้เล่น]",
  T_39_WZY_WS_HB_BOOSTCD: "คูลดาวน์ในการวิ่ง",
  T_39_WZY_WS_HB_BOOSTDURATION: "ระยะเวลาในการวิ่ง",
  T_39_WZY_WS_HB_BOOSTINITIAL: "คูลดาวน์การวิ่งบนสกายบอร์ด",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "คูลดาวน์การวิ่งบนสกายบอร์ด",
  T_39_WZY_WS_HB_BOOSTSPEED: "ความเร็วการวิ่ง",
  T_39_WZY_WS_HB_HOVERBCD: "คูลดาวน์สกายบอร์ด",
  T_39_WZY_WS_HB_JUMPCD: "คูลดาวน์การกระโดด",
  T_39_WZY_WS_HB_JUMPH: "ความสูงของการกระโดดบนสกายบอร์ด",
  T_39_WZY_WS_HEADSCALE: "ขนาดหัว",
  T_39_WZY_WS_HEADSHOTDESCALE: "ลดความเสียหายของการยิงหัว",
  T_39_WZY_WS_INTITALSPEED: "ความเร็วแรกเริ่ม",
  T_39_WZY_WS_INVENTORYBASE: "ประเภทไอเทมพื้นฐาน",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "พลังงานที่ใช้ต่อวินาที",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "ความเร็วพื้นฐานในแนวนอน",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "ความเร็วพื้นฐานในแนวตั้ง",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "พลังงานที่ใช้ในการพุ่งต่อวินาที",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "ความเร็วการวิ่งในแนวนอน",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "ระยะในการวิ่ง",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "พลังงานที่ใช้ในการเร่งต่อวินาที",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "ความเร็วการวิ่งในแนวตั้ง",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "พลังงานที่ใช้ในแนวตั้งต่อวินาที",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "สามารถโจมตีได้",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "ทำงานได้ด้วยตัวเอง",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "กำหนดว่าเพื่อนร่วมทีมจะทำให้กับระเบิดทำงานหรือไม่",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "ทำงานได้ด้วยพาหนะ",
  T_39_WZY_WS_LANDMINE_LIFETIME: "ระยะเวลา",
  T_39_WZY_WS_LANDMINE_STARTTIME: "เวลาเปิดใช้งาน",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "รัศมีการทำงาน",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "ระยะเวลาการทำงาน",
  T_39_WZY_WS_LEAVE: "ออก",
  T_39_WZY_WS_LIMBSCALE: "ขนาดแขนขา",
  T_39_WZY_WS_LISTLOCSTR: "เกี่ยวกับเกมนี้",
  T_39_WZY_WS_LOADRESULT_NAME: "อัปโหลดผลการต่อสู้",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "อัปโหลดผลการต่อสู้ของ [ผู้เล่น] รวมถึง [แรงก์], [ผลการต่อสู้], [ชื่อคะแนน] และ [จำนวนคะแนน]  ประเภทของคะแนนจะเป็นจำนวนเต็ม 1 สำหรับการชนะ, 2 สำหรับการแพ้, 3 สำหรับ Booyah และ 4 สำหรับการเสมอ",
  T_39_WZY_WS_LOOKMOVENT: "เอนทิตี้การเคลื่อนไหวตามสายตา",
  T_39_WZY_WS_MAXCOUNT: "จำนวนสูงสุด",
  T_39_WZY_WS_MAXDISTANCE: "ระยะสูงสุด",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "มุมลดตัวของป้อม",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "ความเร็วเชิงมุมของป้อม",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "มุมยกตัวของป้อม",
  T_39_WZY_WS_MINISENTRY_DAM: "ความเสียหายจากป้อม",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "อัตราการลดความเสียหาย",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "มุมยิง",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "อัตราการโจมตีโดนของป้อม",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "ช่วงการโจมตีของป้อม",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "จำนวนป้อมสูงสุด",
  T_39_WZY_WS_MINISENTRY_RANGE: "ระยะโจมตีของป้อม",
  T_39_WZY_WS_MOVEENT: "เอนทิตี้การเคลื่อนไหว",
  T_39_WZY_WS_NOCOMBINE: "ไม่สามารถถือเป็นอาวุธคู่ได้",
  T_39_WZY_WS_ONCE: "หนึ่งครั้ง",
  T_39_WZY_WS_ONDROP_NAMEDESC: "จะทำงานเมื่อ [เอนทิตี้ผู้เล่น] ทิ้งไอเทม",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "จะทำงานเมื่อ [เอนทิตี้ผู้เล่น] สวมใส่ไอเทม",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "จะทำงานเมื่อใช้ปืนยิงตะขอ",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "จะทำงานเมื่อกับระเบิดทำงาน",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "จะทำงานเมื่อ [เอนทิตี้ผู้เล่น] ทำให้กับระเบิดทำงาน",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "จะทำงานเมื่อเอนทิตี้หยุดเคลื่อนไหว",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "จะทำงานเมื่อเอนทิตี้เริ่มขยับอีกครั้งหลังหยุดลง",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "จะทำงานเมื่อเอนทิตี้เริ่มเคลื่อนไหว",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "จะทำงานเมื่อ [เอนทิตี้ผู้เล่น] เลือกไอเทม",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "จะทำงานเมื่ออาวุธปาโดนเป้าหมาย",
  T_39_WZY_WS_OPENATTACK: "กำหนดว่าจะเปิดใช้งานการโจมตีหรือไม่",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "หยุดเอนทิตี้การเคลื่อนไหวหรือรายการเอนทิตี้การเคลื่อนไหว",
  T_39_WZY_WS_PAUSESOUND_NAME: "เสียงเอฟเฟ็กต์การหยุด",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "เอนทิตี้เสียงหยุดหรือรายการเอนทิตี้เสียง",
  T_39_WZY_WS_PIANOTYPE: "ประเภทขององค์ประกอบดนตรี",
  T_39_WZY_WS_PINGPONG: "กระเด้ง",
  T_39_WZY_WS_PLAYABLELIST: "รายการเอนทิตี้เคลื่อนไหว",
  T_39_WZY_WS_PLAYINGSTATUE: "สถานะ",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "ฟื้นคืนเอนทิตี้การเคลื่อนไหวที่หยุดไว้หรือรายการเอนทิตี้การเคลื่อนไหว สามารถเลือกเล่นต่อหรือเริ่มใหม่ได้",
  T_39_WZY_WS_PLAYSOUND_NAME: "เอฟเฟ็กต์เสียงเล่น",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "ฟื้นคืนเอนทิตี้เสียงหยุดหรือรายการเอนทิตี้เสียง สามารถเลือกเล่นต่อหรือเริ่มใหม่ได้",
  T_39_WZY_WS_PROCIRCLE_NAME: "วงแหวนความคืบหน้า",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "ปล่อยรังสีไปตาม [ทิศทาง] จาก [พิกัดแรกเริ่ม] ตรวจหาเอนทิตี้แรกที่รังสีตกกระทบภายใน [ระยะ] และแสดง [รายการเอนทิตี้ที่ตกกระทบ] และ [รายการพิกัดที่ตกกระทบ]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "ปล่อยรังสีไปตาม [ทิศทาง] จาก [พิกัดแรกเริ่ม] ตรวจหาเอนทิตี้แรกที่รังสีตกกระทบภายใน [ระยะ] และแสดง [การตกกระทบเอนทิตี้] และ [การตกกระทบพิกัด]",
  T_39_WZY_WS_REAHEALHP: "ค่าการฟื้นฟูเกราะ",
  T_39_WZY_WS_REAHEALTIME: "ระยะเวลาแสดงผล",
  T_39_WZY_WS_RELATCOORSYS: "ระบบพิกัดสัมพันธ์",
  T_39_WZY_WS_REPAIRARM: "กล่องซ่อมแซม",
  T_39_WZY_WS_REVERSE: "กลับด้าน",
  T_39_WZY_WS_RIMALPHA: "ความโปร่งใสของขอบ",
  T_39_WZY_WS_SCORENAME: "ชื่อคะแนน",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "ส่งสัญญาณให้เอนทิตี้เป้าหมาย พารามิเตอร์ที่อัปโหลดแล้วจะถูกกำหนดโดยพารามิเตอร์สัญญาณซึ่งกำหนดไว้ก่อนหน้านี้ เมื่อเลือกประเภทของเอนทิตี้ขณะกำหนด จะสร้างกิจกรรมรับสัญญาณที่เกี่ยวข้องขึ้นมา",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "สร้างการเคลื่อนไหวติดตามตำแหน่งสำหรับ [เอนทิตี้เป้าหมาย] [เอนทิตี้เป้าหมาย] จะติดตาม [เอนทิตี้ที่ติดตามอยู่] ส่วน [พิกัดตั้งฉาก] คือระยะระหว่าง [เอนทิตี้เป้าหมาย] และ [เอนทิตี้ที่ติดตามอยู่] สามารถเลือก [ระบบพิกัด] ได้ระหว่าง ระบบพิกัดโลก และ ระบบพิกัดสัมพันธ์ ตามการกำหนดตำแหน่งของเอนทิตี้ที่ติดตามอยู่ [เอนทิตี้การเคลื่อนไหวติดตามตำแหน่ง] จะกลับมาหลังมีการสร้างการเคลื่อนไหว",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "สร้างการเคลื่อนไหวตามสายตาสำหรับ [เอนทิตี้เป้าหมาย] [เอนทิตี้เป้าหมาย] จะติดตาม [เอนทิตี้ที่ติดตามอยู่] [พิกัดตั้งฉาก] คือพิกัดที่ตั้งฉากระหว่าง [เอนทิตี้เป้าหมาย] และ [เอนทิตี้ที่ติดตามอยู่] สามารถเลือก [ระบบพิกัด] ได้ระหว่าง ระบบพิกัดโลก และ ระบบพิกัดสัมพันธ์ ตามการกำหนดตำแหน่งของเอนทิตี้ที่ติดตามอยู่ [เอนทิตี้การเคลื่อนไหวตามสายตา] จะกลับมาหลังมีการสร้างการเคลื่อนไหว",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "เปอร์เซ็นต์ความเสียหายจากการตก",
  T_39_WZY_WS_SHOE_MAXENERGY: "พลังงานสูงสุด",
  T_39_WZY_WS_SKILLLIST: "รายการสกิล",
  T_39_WZY_WS_SKILLTYPE: "สกิลตัวละคร",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "ระยะเวลาของเอฟเฟ็กต์ควัน",
  T_39_WZY_WS_SMOOTH: "เปลี่ยนมุมกล้อง",
  T_39_WZY_WS_SOUNDENTL: "รายการอินทิตี้เสียงเอฟเฟ็กต์",
  T_39_WZY_WS_SOUNDENTLORSENT: "รายการหรือเอนทิตี้เสียงเอฟเฟ็กต์",
  T_39_WZY_WS_SPRINTSPEED: "เปอร์เซ็นต์ความเร็วในการวิ่ง",
  T_39_WZY_WS_SQUATSPEED: "เปอร์เซ็นต์ความเร็วเคลื่อนที่ (ย่อ)",
  T_39_WZY_WS_STARTCOO: "พิกัดแรกเริ่ม",
  T_39_WZY_WS_STATE: "สถานะเกม",
  T_39_WZY_WS_TARGETVAL: "ค่าเป้าหมาย",
  T_39_WZY_WS_THROWSPEED: "ความเร็วตะขอขณะเหวี่ยง",
  T_39_WZY_WS_TOWER_PARAM10: "มุมในการหมุน",
  T_39_WZY_WS_TOWER_PARAM11: "สถานะป้อม",
  T_39_WZY_WS_TOWER_PARAM12: "ไอดีของเอนทิตี้",
  T_39_WZY_WS_TOWER_PARAM9: "โจมตีเป้าหมาย",
  T_39_WZY_WS_TOWSPEED: "ความเร็วการเคลื่อนที่ของผู้เล่น",
  T_39_WZY_WS_TWEENCURVE_NAME: "แนวโค้งตั้งเอง",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "สามารถใช้แนวโค้งตั้งเองสำหรับการเคลื่อนไหวสอดแทรกได้",
  T_39_WZY_WS_TWEENENT: "เอนทิตี้การเคลื่อนไหวสอดแทรก",
  T_39_WZY_WS_TWEENPLAYST_NAME: "วิธีเคลื่อนไหว",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "วิธีเคลื่อนไหวแบบสอดแทรก",
  T_39_WZY_WS_TWEENSTYLE: "วิธี",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "ลบสคริปต์ [ชื่อสคริปต์] สำหรับ [เอนทิตี้]",
  T_39_WZY_WS_UPSET_NAMEDESC: "สุ่มองค์ประกอบในรายการ",
  T_39_WZY_WS_VISIBLEONBACK: "มองเห็นบนหลัง",
  T_39_WZY_WS_WEAPCOMBINET: "ประเภทอาวุธคู่",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "ความเสียหายเพิ่มเติมต่อศัตรูที่ล้มอยู่",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "จำนวนกระสุนต่อนัด",
  T_39_WZY_WS_WEAREPLAY: "เริ่มการเคลื่อนไหวใหม่?",
  T_39_WZY_WS_WORLDCOORSYS: "ระบบพิกัดโลก",
  T_39_XXJ_WS_ADDFRIEND: "เพิ่มเพื่อน",
  T_39_XXJ_WS_ALLOWZ: "เปิดใช้งานการเคลื่อนไหวของผู้เล่นในแกน X",
  T_39_XXJ_WS_BLOCKMODEDESC: "การเคลื่อนไหวของกล้องเมื่อมีวัตถุอยู่ระหว่างกล้องและเป้าหมาย",
  T_39_XXJ_WS_CAMERADISTANCE: "ระยะห่างจากเป้าหมาย",
  T_39_XXJ_WS_CAMERATYPEDESC: "สามารถตั้งค่าการปรับแต่งและเลือกกล้องเองได้หลายแบบ",
  T_39_XXJ_WS_CAMERAUSER: "ผู้ใช้กล้อง",
  T_39_XXJ_WS_CURENTCAMERA: "กล้องที่ใช้อยู่",
  T_39_XXJ_WS_DETAILS: "รายละเอียดเกม",
  T_39_XXJ_WS_FFECONOMY: "การเงิน",
  T_39_XXJ_WS_FOCUSTARGET: "เป้าหมายที่เข้าชม",
  T_39_XXJ_WS_FOLLOWTARGET: "เป้าหมายที่ติดตาม",
  T_39_XXJ_WS_GAMERESULT: "ผลการแข่ง",
  T_39_XXJ_WS_GAMETITLE1: "เกม 1",
  T_39_XXJ_WS_GAMETITLE2: "เกม 2",
  T_39_XXJ_WS_GIFT: "ของขวัญ",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "มุมหมุนกล้องในแนวนอน",
  T_39_XXJ_WS_INVISICAM: "โปร่งแสง",
  T_39_XXJ_WS_INVISICAMDESC: "วัตถุที่อยู่ระหว่างกล้องและเป้าหมายจะเข้าสู่สภาวะโปร่งแสง",
  T_39_XXJ_WS_LEFTSCORE: "คะแนนทีมซ้าย",
  T_39_XXJ_WS_LIKE: "ไลก์",
  T_39_XXJ_WS_LOBBY: "ล็อบบี้",
  T_39_XXJ_WS_MAINSCORENAME: "ชื่อของคะแนนรวม",
  T_39_XXJ_WS_MAINSCORENUM: "จำนวนคะแนนรวม",
  T_39_XXJ_WS_MAPEVALUATE: "คะแนนของแผนที่",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "ผลการแข่งของหลาย ๆ ทีม",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "ระยะตั้งฉากกับจุดเข้าชม",
  T_39_XXJ_WS_OFFSET2DESC: "หมายถึงระยะตั้งฉากระหว่างจุดโฟกัสของกล้องและตำแหน่งเริ่มต้นของผู้เล่น (ค่าจะแตกต่างไปตามประเภทของกล้อง)",
  T_39_XXJ_WS_OFFSETDESC: "หมายถึงระยะตั้งฉากระหว่างมุมกล้องและตำแหน่งเริ่มต้นของผู้เล่น (ค่าจะแตกต่างไปตามประเภทของกล้อง)",
  T_39_XXJ_WS_ORTHOGONAL: "มุมฉาก",
  T_39_XXJ_WS_ORTHOGONALDESC: "กล้องจะแสดงเป้าหมายที่อยู่ไกลและใกล้ในขนาดเท่ากัน",
  T_39_XXJ_WS_PERSPECTIVE: "มุมมอง",
  T_39_XXJ_WS_PERSPECTIVEDESC: "กล้องจะฉายภาพมุมมองผู้เล่นเพื่อเข้าชมเป้าหมาย",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "ข้อมูลภาพจากกล้องเมื่อประมวลผล",
  T_39_XXJ_WS_RANK1: "แรงก์ทีม",
  T_39_XXJ_WS_RANK2: "แรงก์ผู้เล่น",
  T_39_XXJ_WS_REPORT: "รายงาน",
  T_39_XXJ_WS_REVIEW: "รีเพลย์",
  T_39_XXJ_WS_RIGHTSCORE: "คะแนนทีมขวา",
  T_39_XXJ_WS_SCORENUM1: "คะแนน 1",
  T_39_XXJ_WS_SCORENUM2: "คะแนน 2",
  T_39_XXJ_WS_SCORENUM3: "คะแนน 3",
  T_39_XXJ_WS_SCORENUM4: "คะแนน 4",
  T_39_XXJ_WS_SCORENUM5: "คะแนน 5",
  T_39_XXJ_WS_SCORETITLELIST: "รายชื่อของคะแนน",
  T_39_XXJ_WS_SHARE: "แชร์",
  T_39_XXJ_WS_SPECTATORSWITCH: "ผู้เข้าชม",
  T_39_XXJ_WS_STABLE: "คงที่",
  T_39_XXJ_WS_STABLEDESC: "กล้องจะคงที่หากมีวัตถุอยู่ระหว่างกล้องและเอนทิตี้ที่ติดตามอยู่",
  T_39_XXJ_WS_TEAMNAME1: "ชื่อทีมฝั่งซ้าย",
  T_39_XXJ_WS_TEAMNAME2: "ชื่อทีมขวา",
  T_39_XXJ_WS_TEAMRANK: "แรงก์ทีม",
  T_39_XXJ_WS_TRANSITIONTIME: "ช่วงเปลี่ยนกล้อง",
  T_39_XXJ_WS_TRANSITIONTYPE: "ประเภทการเปลี่ยนกล้อง",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "ผลการแข่งของทั้ง 2 ทีม",
  T_39_XXJ_WS_VERTICALANGLEDESC: "มุมหมุนกล้องในแนวตั้ง",
  T_39_XXJ_WS_ZOOM: "ซูม",
  T_39_XXJ_WS_ZOOMDESC: "กล้องจะซูมเข้าหากมีวัตถุอยู่ระหว่างกล้องและเอนทิตี้ที่ติดตามอยู่",
  T_39_XYL_WS_LIGHTINTENSITY: "ความเข้มแสง",
  T_39_XYL_WS_LIGHTRANGE: "ระยะแสง",
  T_39_XYL_WS_POINTLIGHT: "จัดแสง",
  T_39_XYL_WS_WATERZONE: "โซนน้ำปรับเอง",
  T_40_B_DISABLE_RECONNECT: "ปิดใช้งานการเชื่อมต่ออัตโนมัติ",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Midnight Jersey",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Arctic Blaze Jersey",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Cherry Coal Jersey",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Sunny Sky Jersey",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Flame Up Jersey",
  T_40_DYEING_CLEAR: "ล้างสถานะการพ่นสี",
  T_40_HJ_WS_EFFECT32: "รองเท้าผ้าใบ",
  T_40_HJ_WS_EFFECT33: "การระเบิด",
  T_40_HJ_WS_EFFECT34: "จุดเกิด",
  T_40_HJ_WS_EFFECT35: "เลเซอร์",
  T_40_HJ_WS_EFFECT36: "กระสุน",
  T_40_HJ_WS_EFFECT37: "เอฟเฟ็กต์ยิงโดน",
  T_40_HJ_WS_EFFECT38: "เอฟเฟ็กต์ยิง",
  T_40_HJ_WS_EFFECT43: "ใยแมงมุม",
  T_40_HJ_WS_EFFECT44: "ปล่อยสกิล",
  T_40_HJ_WS_SOUND69: "เปิดกล่อง",
  T_40_HJ_WS_SOUND70: "เพิ่มเลเวล",
  T_40_HJ_WS_SOUND71: "เลเวลสูงสุด",
  T_40_HJ_WS_SOUND72: "แตะปุ่ม",
  T_40_HJ_WS_SOUND73: "นับถอยหลัง 1",
  T_40_HJ_WS_SOUND74: "ผิวปาก",
  T_40_HJ_WS_SOUND75: "เกมโอเวอร์",
  T_40_HJ_WS_SOUND76: "เร่งไปข้างหน้า",
  T_40_HJ_WS_SOUND77: "บูย่าห์",
  T_40_HJ_WS_SOUND78: "จุดตรวจ",
  T_40_HJ_WS_SOUND79: "นับถอยหลัง 2",
  T_40_HJ_WS_SOUND80: "เริ่มเกม",
  T_40_HJ_WS_SOUND81: "ได้รับเหรียญจำนวนมาก",
  T_40_HJ_WS_SOUND82: "ได้รับเหรียญ",
  T_40_HJ_WS_SOUND83: "ได้รับเหรียญบางส่วน",
  T_40_HJ_WS_SOUND84: "เข้าร่วมเกม",
  T_40_HJ_WS_SOUND85: "เปิดกล่องแคลน",
  T_40_HJ_WS_SOUND86: "เขาสัตว์",
  T_40_HJ_WS_SOUND87: "กำจัดบอสได้",
  T_40_HJ_WS_SOUND88: "เปิดกล่องสงคราม",
  T_40_HJ_WS_SOUND89: "สกิลระเบิดสี",
  T_40_HJ_WS_SOUND90: "กระสุนกระทบ",
  T_40_HJ_WS_SOUND91: "สกิลโล่สี",
  T_40_HJ_WS_SOUND92: "แตะปุ่มปิดการใช้งาน",
  T_40_HJ_WS_SOUND93: "ชาร์จสกิลเสร็จสิ้น",
  T_40_HJ_WS_SOUND95: "สกิลเลเซอร์",
  T_40_HJ_WS_SOUND96: "รับไอเทม 2",
  T_40_HJ_WS_SOUND97: "เกมโอเวอร์ 2",
  T_40_HJ_WS_SOUND98: "แจ้งเตือนการสังหาร",
  T_40_HJ_WS_SOUNDTYPE_BMG: "ดนตรีพื้นหลัง",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "เสียงเอฟเฟ็กต์ในเกม",
  T_40_HJ_WS_SOUNDTYPE_UI: "เสียงเอฟเฟ็กต์วิตเจ็ด UI",
  T_40_JH_WS_MAPTAG1: "ลับสมอง ประลองสี",
  T_40_JH_WS_MAPTAG10: "ซ่อนหาแบบสี",
  T_40_JH_WS_MAPTAG11: "วันครบรอบ",
  T_40_JH_WS_MAPTAG12: "สวมบทบาท",
  T_40_JH_WS_MAPTAG13: "จำลองสถานการณ์",
  T_40_JH_WS_MAPTAG14: "ไม่สมมาตร",
  T_40_JH_WS_MAPTAG15: "ศึกชิงทรัพยากร",
  T_40_JH_WS_MAPTAG16: "คุ้มกันรถ",
  T_40_JH_WS_MAPTAG17: "แผนที่ทางการ",
  T_40_JH_WS_MAPTAG18: "มินิเกม",
  T_40_JH_WS_MAPTAG19: "ประลองความเร็ว",
  T_40_JH_WS_MAPTAG2: "พ่นสี",
  T_40_JH_WS_MAPTAG20: "สุ่มทุกอย่าง",
  T_40_JH_WS_MAPTAG3: "สมรภูมิสีสัน",
  T_40_JH_WS_MAPTAG4: "สมรภูมิกระสุนสี",
  T_40_JH_WS_MAPTAG5: "สนามเด็กเล่นสีสัน",
  T_40_JH_WS_MAPTAG6: "สนามเด็กเล่นสี",
  T_40_JH_WS_MAPTAG7: "ปาร์ตี้สีสัน",
  T_40_JH_WS_MAPTAG8: "ปาร์กัวหลากสี",
  T_40_JH_WS_MAPTAG9: 'ปาร์กัว "Spider-Verse"',
  T_40_JH_WS_TAG30: "เรียกข้าว่าเศรษฐี",
  T_40_JH_WS_TAG31: "ฝ่ามหาหายนะ",
  T_40_JH_WS_TAG32: "ปมปริศนาฆาตกรรม",
  T_40_JH_WS_TAG33: "วิกฤติยามรุ่งอรุณ",
  T_40_JH_WS_TAG34: "มันไม่ยอมตาย",
  T_40_JH_WS_TAG35: "ศึกหมัดมวย",
  T_40_JH_WS_TAG36: "หลังคาโรงงานเก่า",
  T_40_JH_WS_UGCTOKENNAME: "โทเคนคราฟท์แลนด์",
  T_40_L_QUICKMESSAGE_MODE2: "โหมด 4v4",
  T_40_M_WS_HIS: "ของ",
  T_40_SP_WS_DYEING: "สี",
  T_40_SP_WS_DYEING_AREA: "การพ่นทั่วบริเวณ",
  T_40_SP_WS_DYEING_COLOR: "หมายเลขสี",
  T_40_SP_WS_DYEING_COUNT: "จำนวนการพ่น",
  T_40_SP_WS_DYEING_DIR: "ทิศทางการพ่น",
  T_40_SP_WS_DYEING_DIS: "ระยะการพ่น",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "ล็อกบริเวณที่ถูกพ่น",
  T_40_SP_WS_DYEING_NORMAL: "ปกติ",
  T_40_SP_WS_DYEING_PLANE: "พ่นสีบริเวณเครื่องบิน",
  T_40_SP_WS_DYEING_POSITION: "พิกัด",
  T_40_SP_WS_DYEING_RANDOMDECAY: "อัตราการลดลงของการพ่นสีโดยสุ่ม",
  T_40_SP_WS_DYEING_RANDOMRATIO: "อัตราการพ่นสีโดยสุ่ม",
  T_40_SP_WS_DYEING_RANGE: "บริเวณที่ถูกพ่น",
  T_40_SP_WS_DYEING_STATE: "สถานะการพ่นสี",
  T_40_SP_WS_FACTIONTIPS_11: "ม่วง",
  T_40_SP_WS_SHOE_CURENERGY: "พลังงานที่มี",
  T_40_SW_SKILL_Name_Nanoscientist: "โล่พลังนาโน",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - Waggor's Wonder",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Alok ปลุกพลัง",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "โซเนีย",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Waggor's Wonder",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - Waggor's Wonder",
  T_40_SY_M24_PENGUIN_W_N: "M24 - Waggor's Wonder",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - Waggor's Wonder",
  T_40_SY_PET_PUG_N: "บอสปั๊ก",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'สกินคู่หู: "Spider-Verse" Moony',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "สกินคู่หู: บลูพลังไฟฟ้า",
  T_40_SY_PETSKIN_PUG_BLACK_N: "สกินคู่หู: ปั๊กเลเซอร์อาย",
  T_40_SY_PETSKIN_PUG_GREEN_N: "สกินคู่หู: ปั๊กอะโลฮ่า",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "สกินคู่หู: ปั๊กโฮกปิ๊บ",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - Waggor's Wonder",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson - Waggor's Wonder",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - Waggor's Wonder",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Waggor's Wonder",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi - Waggor's Wonder",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "รายละเอียดการเปิดใช้งาน",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "รายละเอียดเนื้อหาว่าง",
  T_40_W_DJMALE_AWAKENING_D: "ปลุกพลัง: ขณะที่ออร่าทำงาน จะปล่อยโน้ตดนตรีซึ่งอยู่ได้นาน [FFB300]{2} วิ[-] ออกมาด้านหลังผู้ใช้สกิล [FFB300]{1}เมตร[-] ทุก ๆ [FFB300]{0}วิ[-] เพื่อนร่วมทีมที่เก็บตัวโน้ตขึ้นมาจะได้รับผลแบบเดียวกับออร่า",
  T_40_W_DJMALE_AWAKENING_N: "ปาร์ตี้รีมิกซ์",
  T_40_W_NURSE_D: "กระจาย [FFB300]{0}%[-] ของเอฟเฟ็กต์ฮีลเดี่ยวของผู้ใช้ (สกิล, กล่องพยาบาล, ปืนฮีล ฯลฯ) ไปยังเพื่อนในทีมในระยะ [FFB300]{1}ม[-] ของผู้ใช้",
  T_40_WH_MP_BOXING_NAME: "สังเวียนเดือด",
  T_40_WH_MP_C_PACK: "กระเป๋าเถื่อน",
  T_40_WH_MP_EXCH_COIN: "แคช",
  T_40_WH_MP_EXCH_TEMPCOIN: "เงินเถื่อน",
  T_40_WH_MP_PAYCHECK: "ค่าจ้าง",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "ดึงเพื่อนเร็วขึ้น [FFB300]{0}%[-] คูลดาวน์: [FFB300]{3} วิ[-] เพื่อนร่วมทีมที่ถูกดึงจะฟื้นฟู HP [FFB300]{2} หน่วย[-] ใน [FFB300]{1} วิ[-]",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "สร้างอาณาเขตฟื้นฟูความกว้าง [FFB300]{0} เมตร[-] ผู้เล่นที่อยู่ในอาณาเขตทั้งตัวเองและเพื่อนร่วมทีมจะได้รับฟื้นฟู HP [FFB300]{1} หน่วย/วิ[-] เมื่อจำเป็น การชุบชีวิตจะทำงานโดยอัตโนมัติ อาณาเขตนี้จะคงอยู่เป็นเวลา [FFB300]{2} วินาที[-] สามารถเสริมพลังให้การดึงเพื่อนด้วยสกิลอื่นได้ คูลดาวน์: [FFB300]{3} วิ[-]",
  T_40_WT_WS_ICONENTITY_PARAM6: "วิธีแสดงผล",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "แคปซูล",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "ความสูง",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "รัศมี",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "ทรงกลม",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "อ่ารบิกตัวย่อ",
  T_40_WZY_WS_FONT_SUPERMARKET: "ซูเปอร์มาร์เก็ต",
  T_40_WZY_WS_ICONENTITY_COLOR: "สี",
  T_40_WZY_WS_ICONENTITY_FILLED: "ก้าวหน้า",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "ทรัพยากรรูป",
  T_40_WZY_WS_ICONENTITY_NAME: "วัตถุไอคอน",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "วิธีแสดงผล",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "เรียบ",
  T_40_WZY_WS_ICONENTITY_SLICED: "9 ช่อง",
  T_40_WZY_WS_ICONENTITY_TILED: "กระเบื้อง",
  T_40_WZY_WS_NEWMAPTAG: "ไอคอนแผนที่ใหม่",
  T_40_WZY_WS_NEWVFX1: "ฮาโหล",
  T_40_WZY_WS_NEWVFX10: "คำสาป",
  T_40_WZY_WS_NEWVFX11: "พื้นที่แช่แข็ง",
  T_40_WZY_WS_NEWVFX12: "อากาศเย็น",
  T_40_WZY_WS_NEWVFX13: "เกล็ดหิมะ",
  T_40_WZY_WS_NEWVFX14: "เปลวเพลิง",
  T_40_WZY_WS_NEWVFX15: "ลำแสง",
  T_40_WZY_WS_NEWVFX16: "แก๊สพิษแพร่กระจาย",
  T_40_WZY_WS_NEWVFX17: "แก๊สพิษ",
  T_40_WZY_WS_NEWVFX18: "ลมจากการระเบิด",
  T_40_WZY_WS_NEWVFX19: "เอฟเฟ็กต์แสง",
  T_40_WZY_WS_NEWVFX2: "ฟองสบู่",
  T_40_WZY_WS_NEWVFX20: "ดาว",
  T_40_WZY_WS_NEWVFX3: "ขี้เถ้า",
  T_40_WZY_WS_NEWVFX4: "หินกระจาย",
  T_40_WZY_WS_NEWVFX5: "เส้นสาย",
  T_40_WZY_WS_NEWVFX6: "เปลวไฟสั่น",
  T_40_WZY_WS_NEWVFX7: "แหวน",
  T_40_WZY_WS_NEWVFX8: "ละอองลอยขึ้น",
  T_40_WZY_WS_NEWVFX9: "ควัน",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "ขนาดตัวอักษร",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "สไตล์ฟอนต์",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "ฟอนต์",
  T_40_WZY_WS_TEXTENTITY_NAME: "วัตถุข้อความ",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "องค์ประกอบ HUD ปุ่มปฏิสัมพันธ์",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'ตั้งค่าการทำงานของฟังก์ชันในฉาก ส่วนนี้เป็นรายละเอียดที่อ่านได้อย่างเดียวเท่านั้น และจะเป็นไปตามการตั้งค่า "มีค่าต้นหรือไม่" และ "สถานะกิจกรรม"',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "ตั้งค่าการทำงานของค่าต้น เป็นแบบอ่านได้อย่างเดียวและผู้เล่นจะไม่เห็นข้อมูลส่วนนี้",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "มีค่าต้นหรือไม่",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "แสดงเมื่อสถานะการเปิดเป็นจริง ไม่งั้นจะถูกปิด",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'ตั้งค่าให้ฟังก์ชันทำงานเองได้ หากต้องการใช้ในฉาก จะต้องตั้งค่าที่ "ใช้ในฉากหรือไม่" ส่วนนี้เป็นรายละเอียดที่อ่านได้อย่างเดียวเท่านั้นและถูกตั้งค่าผ่าน API',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "ตั้งค่าการมองเห็น cullingMask ของกล้องในบางเลเยอร์",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "สร้างโทเคนที่ตำแหน่งหนึ่ง ๆ",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "ไอเทมที่สามารถปล้นได้ซึ่งจะมอบให้กับผู้เล่น",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "ทิศทางปัจจุบันของผู้เล่น",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "ทิศทาง",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "AI กำลังโจมตีเอนทิตี้",
  T_40_XXJ_WS_AITARGET_DESCKEY: "AI ที่กำลังโจมตี",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "สไตล์ที่สอดคล้องกัน",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "จัดระเบียบแนวนอน",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "จัดระเบียบแนวตั้ง",
  T_40_XXJ_WS_ALPHA_DESCKEY: "ความโปร่งใส",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "จำนวนของกระสุนที่เหลือ",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "กระสุนที่เหลือ",
  T_40_XXJ_WS_ANCHORMAX: "จุดยึดสูงสุด",
  T_40_XXJ_WS_ANCHORMIN: "จุดยึดต่ำสุด",
  T_40_XXJ_WS_APOSITION_DESCKEY: "ตำแหน่งปัจจุบันของผู้เล่น",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "ตำแหน่ง",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "เปลี่ยน HUD เกราะ",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "ID วัตถุที่ตั้งไว้",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "ID วัตถุ",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "เป้าหมายการโจมตี",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "อาวุธปาที่โจมตีได้",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "เอนทิตี้ที่โดน AI โจมตี",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "เป้าหมายที่โดนโจมตี",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "พิกัดจุดเกิดที่ใช้งานได้",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "พิกัดที่ใช้งานได้",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "ภาพด้านล่าง",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "พื้นหลัง",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "กระเป๋า",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "ความโปร่งใสของพื้นหลัง",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "สีพื้นหลัง",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "สีพื้นหลัง",
  T_40_XXJ_WS_BGFILL_DESCKEY: "ตั้งค่าการเติมพื้นหลัง",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "เติมพื้นหลัง",
  T_40_XXJ_WS_BGNAME_DESCKEY: "ชื่อพื้นหลัง",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "ชื่อพื้นหลัง",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "เดลต้าขนาดพื้นหลัง",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "เดลต้าขนาดพื้นหลัง",
  T_40_XXJ_WS_BLUE: "ฟ้า",
  T_40_XXJ_WS_BODY_DESCKEY: "ลำตัว",
  T_40_XXJ_WS_BODY_NAMEKEY: "ลำตัว",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "ขนาดกระดูก",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "จุดเกิดของผู้เล่น",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "จุดเกิด",
  T_40_XXJ_WS_BOTH: "หรือ",
  T_40_XXJ_WS_BUTTONNAME: "ชื่อองค์ประกอบปุ่ม",
  T_40_XXJ_WS_CAMERA_DESCKEY: "กล้อง",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "ทิศทางที่กล้องไคลเอนต์หันไป",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "ตำแหน่งที่ตั้งของกล้องไคลเอนต์",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "ตรวจจับแนวกล้องของไคลเอนต์",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "ระะบบตรวจจับรังสีกล้อง",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "หยุดลากเหมือนซ้อนกับหน้าจอ",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "เมื่อพอดีกันแล้ว ให้ลากเพื่อออก",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "ระยะห่างระหว่างกึ่งกลางครึ่งวงกลมของวงรีต้องไม่เล็กกว่าสองเท่าของรัศมีทรงกลม",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "ขนาดช่อง",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "ความสูงของช่องเด็ก",
  T_40_XXJ_WS_CELLVALUE: "อ่านเนื้อหาในช่องหนึ่ง ๆ และคืนวัตถุให้",
  T_40_XXJ_WS_CENTER_DESCKEY: "พิกัดโลกที่เป็นไปตามศูนย์แผนที่ย่อ จะอยู่ที่ 0 เป็นค่าเริ่มต้น",
  T_40_XXJ_WS_CENTER_NAMEKEY: "ศูนย์แผนที่ย่อ",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "พิกัดตั้งฉากของตำแหน่งปุ่ม",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "ระยะตั้งฉากของตำแหน่ง",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "จุดศูนย์กลางวัตถุเมื่อเทียบกับพิกัดในตำแหน่งที่ตั้ง",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "จุดศูนย์กลางวัตถุ",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "ตั้งค่าการแสดงเส้นกลาง",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "แสดงเส้นกลางหรือไม่",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "ตำแหน่งเส้นกลาง [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "ตำแหน่งเส้นกลาง",
  T_40_XXJ_WS_CHASERANGE: "ความใกล้เคียงในการไล่ตาม",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "เอนทิตี้ที่โดน AI ไล่ตาม",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "เป้าหมายที่โดนไล่ตาม",
  T_40_XXJ_WS_CHILD_DESCKEY: "เอนทิตี้เด็ก",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "ผลของค่าตั้งต้น",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "จุดที่แนวกล้องตกกระทบ",
  T_40_XXJ_WS_CHOOSECARHUD: "เอนทิตี้ HUD เลือกการ์ด",
  T_40_XXJ_WS_CLAMP_DESCKEY: "หากพารามิเตอร์เป็นค่าที่อยู่ระหว่างค่ามากสุดและต่ำสุด ฟังก์ชันนี้จะคืนพารามิเตอร์ แต่หากพารามิเตอร์มีค่าเกินกว่าช่วงที่กำหนด ฟังก์ชันนี้จะคืนค่ามากสุด และหากตัวเลขน้อยกว่าช่วงที่กำหนด ฟังก์ชันนี้จะคืนค่าต่ำสุด",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "รองรับเฉพาะเอนทิตี้ที่มีองค์ประกอบ Transform เท่านั้น ขณะนี้จำกัดเฉพาะวัตถุ",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "ขนาดของพื้นที่คลิกได้",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "ClickSize",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "ประเภทการหนีบ",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "ประเภทการหนีบ",
  T_40_XXJ_WS_CLONEENT_D: "ก็อปปี้เอนทิตี้ที่เลือกและค่าสถานะของเอนทิตี้โดยยังคงค่าต้นไว้ หากวัตถุบนเวทีถูกเลือก จะเป็นไปตามการสร้างวัตถุบนเวที",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "รายการชุด",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "ID ชุด",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "ID ชุด",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "ID ชุด",
  T_40_XXJ_WS_COL_DESC: "คอลัมน์ที่จะดู",
  T_40_XXJ_WS_COLNAME_DESC: "ชื่อของคอลัมน์",
  T_40_XXJ_WS_COLOR_DESCKEY: "สี",
  T_40_XXJ_WS_COLOR_NAMEKEY: "ค่า",
  T_40_XXJ_WS_COLOR1_DESCKEY: "เพิ่มเลเยอร์สีโดยใช้ช่องสี RGBA ค่าในช่องจะมีตั้งแต่ 0-255 และจะถูกบันทึกไว้ใน Int32 ค่าเริ่มต้นคือสีขาว (255, 255, 255, 255)",
  T_40_XXJ_WS_COLOR2_DESCKEY: "สีแถบความคืบหน้า",
  T_40_XXJ_WS_COLOR3_DESCKEY: "ประเภทช่องสี ตั้งแต่ 0 - 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "สีของข้อความ",
  T_40_XXJ_WS_COLOR5_DESCKEY: "สีของ HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "สีของแสง",
  T_40_XXJ_WS_COLORA_DESCKEY: "ค่าของสี A (อัลฟ่า)",
  T_40_XXJ_WS_COLORB_DESCKEY: "ค่าของสี B (สีฟ้า)",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "สีแถบความคืบหน้า",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "ถังน้ำมันสี",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "ถังน้ำมันสี",
  T_40_XXJ_WS_COLORG_DESCKEY: "ค่าของสี G (สีเขียว)",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "เปิดเพื่อรับค่าสี RGBA",
  T_40_XXJ_WS_COLORGUN: "ไรเฟิลสเปรย์สีรุ้ง",
  T_40_XXJ_WS_COLORGUN_01: "ไรเฟิลสเปรย์สีรุ้ง (แดง)",
  T_40_XXJ_WS_COLORGUN_02: "ไรเฟิลสเปรย์สีรุ้ง (เหลือง)",
  T_40_XXJ_WS_COLORGUN_03: "ไรเฟิลสเปรย์สีรุ้ง (ฟ้า)",
  T_40_XXJ_WS_COLORGUN_04: "ไรเฟิลสเปรย์สีรุ้ง (เขียว)",
  T_40_XXJ_WS_COLORGUN_05: "ไรเฟิลสเปรย์สีรุ้ง (ม่วง)",
  T_40_XXJ_WS_COLORR_DESCKEY: "ค่าของสี R (สีแดง)",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "สีของข้อความ",
  T_40_XXJ_WS_COLVALUE: "เนื้อหาในคอลัมน์",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "เอนทิตี้ HUD ขณะเปลี่ยน HUD ทั่วไป",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "เอนทิตี้ HUD ขณะเปลี่ยน HUD ทั่วไป",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "ข้อจำกัด",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "ข้อจำกัด",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "จำนวนข้อจำกัด",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "จำนวนข้อจำกัด",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "เนื้อหาแรกเริ่ม",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "ทิศทางเริ่มต้น",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "จุดเริ่มต้นของการเลื่อนขึ้นลง เริ่มที่มุมซ้ายบนเป็นค่าเริ่มต้น",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "สร้างพิกเซ็ลนิ่งสำหรับวัตถุในแผนที่ พิกเซ็ลจะไม่เคลื่อนที่พร้อมวัตถุ",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "สร้างไอคอนแผนที่ย่อ",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "ระบุวันและเวลาที่แปลข้อความ",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "สร้างองค์ประกอบ UI แบบปรับแต่งเองที่ HUD ปรับเองที่กำหนดและองค์ประกอบตั้งต้น",
  T_40_XXJ_WS_CREEP_NAMEKEY: "คลาน",
  T_40_XXJ_WS_CROUCH_DESCKEY: "แสดงเมื่อเป็นจริง ไม่งั้นจะถูกปิด",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "ย่อ",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "นี่คือเลเยอร์แปรผล CullingMask ของกล้อง คุณสามารถกรองเอนทิตี้แปรผลได้โดยใช้ระดับของเลเยอร์",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "CullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "ID เสื้อ",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "เสื้อ",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "ID ลายเพ้นท์",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "ID รองเท้า",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "รองเท้า",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "ID หัว",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "หัว",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "ID ลายเพ้นท์",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "หน้ากาก",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "ID กางเกงหรือกระโปรง",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "กางเกงหรือกระโปรง",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "ลายเพ้นท์",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "ID แพ็ก",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "ชุดหมี",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "จำนวนการลากในแนว XY",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "ลากในแนว XY",
  T_40_XXJ_WS_DB: "อ่านค่าตาราง",
  T_40_XXJ_WS_DB_DESC: "อ่านค่าที่เกี่ยวข้องของตัวยืนยันในตารางในฐานข้อมูล",
  T_40_XXJ_WS_DBDELETE_DESC: "ลบค่าที่เกี่ยวข้องของตัวยืนยันในตารางในฐานข้อมูล",
  T_40_XXJ_WS_DBKEY_DESCKEY: "ชื่อตั้งเองสำหรับยืนยันข้อมูล",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "ตัวยืนยัน",
  T_40_XXJ_WS_DBTABLENAME: "ชื่อตารางในฐานข้อมูล",
  T_40_XXJ_WS_DBTABLENAME_DESC: "ชื่อตารางในฐานข้อมูล",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "ค่าของการเขียน",
  T_40_XXJ_WS_DBWRITE: "เขียนค่าตาราง",
  T_40_XXJ_WS_DBWRITE_DESC: "เขียนค่าที่เกี่ยวข้องของตัวยืนยันในตารางในฐานข้อมูล",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "ป้องกันอาวุธปา",
  T_40_XXJ_WS_DEFULT: "ค่าเริ่มต้น",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "ลบค่าที่เกี่ยวข้องของ KEY บาง KEY บนกระดานอันดับในฐานข้อมูล",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "ลบค่าที่เกี่ยวข้องของบางระดับบนกระดานอันดับในฐานข้อมูล",
  T_40_XXJ_WS_DEPTH: "ชั้น HUD",
  T_40_XXJ_WS_DEPTH_D: "ชั้นพื้นฐานของ HUD",
  T_40_XXJ_WS_DICTANDLIST: "รายการและพจนานุกรรม",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "ค่าของพจนานุกรมเป้าหมาย",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "ความโปร่งใสของพื้นผิว",
  T_40_XXJ_WS_DIR_DESCKEY: "เวกเตอร์",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "จุดแสดงตำแหน่ง สามารถใช้เป็นจุดชุบและอื่น ๆ ได้",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "พิกัด",
  T_40_XXJ_WS_DISABLEALL: "ยกเลิกการเลือกทั้งหมด",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "สีที่ใช้งานไม่ได้",
  T_40_XXJ_WS_DISTANT_DESCKEY: "ระยะห่างของระบบตรวจจับแนวกล้อง",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "ระยะการปา",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "รองรับทิศทางการลากหลายทิศทาง",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "เอฟเฟ็กต์ลาก",
  T_40_XXJ_WS_DRIVER_DESCKEY: "คนขับพาหนะ",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "คนขับ",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "ปรับแต่งค่า",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "แสดงเอฟเฟ็กต์พิเศษ",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "แสดงเอฟเฟ็กต์พิเศษ",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "สีเอฟเฟ็กต์",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "เอนทิตี้เอฟเฟ็กต์พิเศษที่สื่อถึงเอฟเฟ็กต์พิเศษที่จะแสดง",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "วัตถุเอฟเฟ็กต์พิเศษ",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "เปลี่ยน HUD อีโมจิ",
  T_40_XXJ_WS_ENABLEALL: "เลือกทั้งหมด",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "ตั้งค่าเปิดใช้การอัปเดตตรรกะ หากปิดใช้ จะปิดกั้นไม่ให้เอนทิตี้นี้อัปเดตในทุก ๆ เฟรม",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "เมื่อเขียนแล้ว สกินอาวุธจะส่งผลต่อค่าสถานะพื้นฐานของอาวุธ",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "เขียนค่าสถานะสกินอาวุธ",
  T_40_XXJ_WS_ENTITY_DESCKEY: "เอนทิตี้คือตัวกลางที่มีองค์ประกอบทั้งหมด ต้องเพิ่มเข้าไปในเอนทิตี้แล้วจึงจะใช้งานได้",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "ประเภทเอนทิตี้",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "องค์ประกอบพื้นฐานของเอนทิตี้ องค์ประกอบทั้งหมดจะรวมถึงองค์ประกอบนี้ด้วย",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "เอนทิตี้ใช้แปลง",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "ชื่อพารามิเตอร์ในโค้ดสำหรับใช้แสดงเอนทิตี้ขของตัวควบคุม UI ปรับแต่งเองที่เพิ่มเข้ามาใหม่ ค่าตัวแปรที่เกี่ยวข้องในพื้นที่จะเป็นเอนทิตี้ของตัวควบคุม UI ปรับแต่งเองที่เพิ่มเข้ามาใหม่",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "ชื่อของตัวแปรเอนทิตี้",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "ชื่อพารามิเตอร์ในโค้ดสำหรับใช้แสดงเอนทิตี้ของไอคอนที่ถูกสร้าง ค่าตัวแปรที่เกี่ยวข้องในพื้นที่จะเป็นเอนทิตี้ของไอคอน",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "เปลี่ยน HUD แถบ EP",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "มุมออยเลอร์",
  T_40_XXJ_WS_FACINFECTION: "ฝั่ง (Droid Apocalypse)",
  T_40_XXJ_WS_FACINFECTION_DESC: "ฝั่งของผู้เล่น 1 = มนุษย์ และ 2 = ดรอยด์",
  T_40_XXJ_WS_FEMALE: "ผู้หญิง",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "ทิศทางการเติม",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "ทิศทางการค้นหา",
  T_40_XXJ_WS_FIRE_NAMEKEY: "ไฟ",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "ค่า Float",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "เอนทิตี้เป้าหมายที่จะติดตาม จะว่างเป็นค่าเริ่มต้น",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "ขนาดของข้อความ",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "ขนาดฟอนต์",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "สไตล์ฟอนต์",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "ไอซ์วอลล์ - ฟุตบอล",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "สไตล์ของรูปแบบ",
  T_40_XXJ_WS_FORWARD_DESCKEY: "ทิศทางของผู้เล่น",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "ทิศทางที่จะเทเลพอร์ต",
  T_40_XXJ_WS_FREE_DESCKEY: "กล้องที่ผู้เล่นควบคุมได้และเคลื่อนไหวได้อิสระ",
  T_40_XXJ_WS_FREE_NAMEKEY: "มุมกล้องอิสระ",
  T_40_XXJ_WS_GENDER: "เพศ",
  T_40_XXJ_WS_GENDER_DESCKEY: "เพศ",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "รายการเพศ",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "รับค่า cullingMask ของกล้อง",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "รองรับเฉพาะเอนทิตี้ที่มีองค์ประกอบ Transform เท่านั้น ขณะนี้จำกัดเฉพาะวัตถุ",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "รองรับเฉพาะเอนทิตี้ที่มีองค์ประกอบ Transform เท่านั้น ขณะนี้จำกัดเฉพาะวัตถุ",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "รองรับเฉพาะเอนทิตี้ที่มีองค์ประกอบ Transform เท่านั้น ขณะนี้จำกัดเฉพาะวัตถุ",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "รับ ID ชุดของผู้เล่น",
  T_40_XXJ_WS_GETPLAYERRANK: "ตั้งค่าแรงก์ของผู้เล่น",
  T_40_XXJ_WS_GETPLAYERRANK_D: "ตั้งค่าแรงก์รวมของผู้เล่น",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "ตั้งค่าแรงก์ในรอบของผู้เล่น",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "ตั้งค่าแรงก์เฉพาะรอบของผู้เล่น",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "ค้นหาข้อมูลโทเคนของผู้เล่น",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "รับสกินอาวุธของผู้เล่น",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "หาพิกัดที่ไม่ใช่จุดเกิดสุ่ม",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "รับท้องฟ้าในฉาก",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "ดูภูมิภาคของเซิร์ฟเวอร์",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "ดูวันและเวลาของเซิร์ฟเวอร์",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "หาตำแหน่งของเพื่อนร่วมทีมที่อยู่ใกล้เคียง จะหลีกเลี่ยงพื้นที่ที่ผู้เล่นไม่สามารถยืนได้",
  T_40_XXJ_WS_GETTEAMRANK: "ตั้งค่าแรงก์ของทีม",
  T_40_XXJ_WS_GETTEAMRANK_D: "ตั้งค่าแรงก์รวมของทีม",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "ตั้งค่าแรงก์ในรอบของทีม",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "ตั้งค่าแรงก์เฉพาะรอบของทีม",
  T_40_XXJ_WS_GREEN: "เขียว",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "ขนาดครึ่งหนึ่งของรูปทรง 3 มิติ",
  T_40_XXJ_WS_HEAD_DESCKEY: "หัว",
  T_40_XXJ_WS_HEAD_NAMEKEY: "หัว",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "เอนทิตี้เอฟเฟ็กต์เสียงหัวใจเต้น",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "เอนทิตี้เอฟเฟ็กต์เสียงหัวใจเต้น",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "ส่วนสูง",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "ปุ่มคำใบ้",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "ปุ่มเคล็ดลับ",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "เอนทิตี้ที่จะแสดงที่จุดหมาย",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "ตั้งเป้าที่เอนทิตี้แล้ว",
  T_40_XXJ_WS_HITPOS_DESCKEY: "จุดที่โดนยิงหรือตกกระทบ",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "ประเภทการแสดงผลแนวนอน",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "ประเภทการแสดงผลแนวนอน",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "เอนทิตี้ที่ติดตามอีกเอนทิตี้อยู่",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "เอนทิตี้ที่มองอีกเอนทิตี้อยู่",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "เปลี่ยน HUD แถบเลือด",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "เอนทิตี้ที่ใส่เข้าใน HUD เป็น HUD ที่ผู้เล่นใช้ตัวแก้ไขในการปรับแต่ง",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "องค์ประกอบแผง HUD เปล่า",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "เอนทิตี้ HUD ที่เกี่ยวข้อง",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "เอนทิตี้ที่ใส่เข้าใน HUD เป็น HUD ที่ผู้เล่นใช้ตัวแก้ไขในการปรับแต่ง",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "องค์ประกอบตาราง HUD",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "เอนทิตี้ที่ใส่เข้าใน HUD เป็น HUD ที่ผู้เล่นใช้ตัวแก้ไขในการปรับแต่ง",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "องค์ประกอบแผง HUD",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "เอนทิตี้ที่ใส่เข้าใน HUD เป็น HUD ที่ผู้เล่นใช้ตัวแก้ไขในการปรับแต่ง",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "องค์ประกอบมุมมองเลื่อนขึ้นลงของ HUD",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "ID โมเดลมนุษย์",
  T_40_XXJ_WS_ICON_DESCKEY: "ชื่อทรัพยากรของไอคอน",
  T_40_XXJ_WS_ICON_NAMEKEY: "ไอคอน",
  T_40_XXJ_WS_ICON1_DESCKEY: "เลือกไอคอน",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "เอนทิตี้ไอคอนที่สื่อถึงไอคอนที่จะแสดง",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "Path ทรัพยากร ทรัพยากรที่มาพร้อมกันจะเป็น in:path ทรัพยากรสร้างเองจะเป็น out:path จะว่างเป็นค่าเริ่มต้น",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "ชื่อไอคอน",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "ชื่อไอคอน",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "Path ทรัพยากร จะว่างเป็นค่าเริ่มต้น",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "ไม่ว่าจะสามารถสแกนหาทริกเกอร์ได้หรือไม่",
  T_40_XXJ_WS_INDEX_DESCKEY: "ดัชนีของค่าผลใต้ค่าต้น",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "ค่าเริ่มต้น [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "ค่าตัวเลข",
  T_40_XXJ_WS_IS3D: "เสียงเอฟเฟ็กต์ 3D",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "หันเข้ากล้องเสมอ",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "ตัวหนา",
  T_40_XXJ_WS_ISBYORDER_D: "ตรวจจับว่าผู้เล่นควรทำให้วัตถุในระดับทำงานตามลำดับเวลาหรือไม่",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "ปุ่ม Is FirEditor",
  T_40_XXJ_WS_ISHIT_DESCKEY: "ตั้งค่าแนวกล้องให้โดนเอนทิตี้",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "ตั้งค่าให้มองเห็นได้ในเลเยอร์",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "ตัวเอียง",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "ตั้งค่าการทำเครื่องหมายด้วยเครื่องสแกน",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "สแกนหรือไม่",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "ตั้งค่าการทำเครื่องหมายด้วยปุ่มหมุุด",
  T_40_XXJ_WS_ISTRIGGER: "เป็นจุดที่ทำให้ระบบทำงาน",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "ขีดเส้นใต้แล้ว",
  T_40_XXJ_WS_ITEMID_DESCKEY: "ID ไอเทมที่เกี่ยวข้องกับเอนทิตี้",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "ID ของไอเทม",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "ID ของไอเทม (เฉพาะ ID ของอาวุธที่อยู่ในเกมเวอร์ชันปัจจุบันเท่านั้น)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "ID ของอาวุธ",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "ID ของไอเทม",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "มหานคร",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "มหานคร",
  T_40_XXJ_WS_JUMP_NAMEKEY: "กระโดด",
  T_40_XXJ_WS_KEY_DESCKEY: "ค่าของ KEY",
  T_40_XXJ_WS_KEY_NAMEKEY: "KEY",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "ชื่อ KEY ที่จะข้ามผ่าน สามารถใช้รับค่าของตัวแปรในพื้นที่ได้",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "แถบชื่อสังหาร",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "สีข้อความ",
  T_40_XXJ_WS_LANDMINEOBJ: "เอนทิตี้หลังสร้างกับระเบิด",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "หน้ากากของชั้นชนกัน เลเยอร์ที่ไม่ได้เลือกจะไม่รวมอยู่ในการสแกน เมื่อว่าง เลเยอร์ทั้งหมดจะอยู่ในการสแกน",
  T_40_XXJ_WS_LAYERSEDIT: "แก้ไขเลเยอร์",
  T_40_XXJ_WS_LAYERSETTING: "ตั้งค่าเลเยอร์ที่มองเห็นได้",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "เลเยอร์ระบบตรวจจับแนวกล้องที่ชนกัน",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "เลเยอร์",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "ประเภทการจัดแสดง",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "ประเภทการจัดแสดง",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "องค์ประกอบ HUD ตารางคะแนน",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "เอนทิตี้ HUD ของตารางคะแนน การปรับคุณสมบัติของเอนทิตี้จะส่งผลต่อเนื้อหาที่จะแสดงบน UI ที่เกี่ยวข้อง",
  T_40_XXJ_WS_LEADERBOARDNAME: "ชื่อกระดานอันดับ",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "ชื่อกระดานอันดับในฐานข้อมูล",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "ความเร่งขณะแกว่ง",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "ความเร่งในการออก",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "แขนซ้าย",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "แขนซ้าย",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "สีฝั่งซ้าย",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "สีฝั่งซ้าย",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "ตั้งค่าการแสดงเอฟเฟ็กต์พิเศษทางด้านซ้าย",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "แสดงเอฟเฟ็กต์ทางซ้ายหรือไม่",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "เท้าซ้าย",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "เท้าซ้าย",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "มือซ้าย",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "มือซ้าย",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "ไอคอนทางซ้าย",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "ไอคอนทางซ้าย",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "ขาซ้าย",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "ขาซ้าย",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "ข้อความคะแนนทางด้านซ้าย",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "ข้อความคะแนนทางด้านซ้าย",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "ข้อความทางซ้าย",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "ข้อความทางซ้าย",
  T_40_XXJ_WS_LERP_DESCKEY: 'T จะมีค่าระหว่าง 0 ถึง 1 เมื่อ T=0 จะคืนค่า "จาก" หาก T=1 จะคืนค่า "ให้กับ" เมื่อ T=0.5 จะคืนค่าเฉลี่ยของ "จาก" และ "ให้กับ"',
  T_40_XXJ_WS_LEVELOBJECT: "วัตถุบนเวที",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "ระยะห่างระหว่างบรรทัด",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "เปรียบเทียบค่าในรายการและคืนค่ามากสุด",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "เปรียบเทียบค่าในรายการและคืนค่าที่น้อยที่สุด",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "List หรือ Dict",
  T_40_XXJ_WS_LOCALPOSITION: "ตำแหน่งท้องถิ่น",
  T_40_XXJ_WS_LOCALROTA: "มุมออยเลอร์ในท้องถิ่น",
  T_40_XXJ_WS_LOCALROTATIONQ: "การหมุนแบบควอเตอร์เนียนท้องถิ่น",
  T_40_XXJ_WS_LOCALSACLE: "ขนาดท้องถิ่น",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "เปลี่ยนการแปลภาษา",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "ตัวบรรจุที่จะเปลี่ยน",
  T_40_XXJ_WS_MALE: "ผู้ชาย",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "นำพจนานุกรมออก",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "รับค่าความยาวของแผนที่",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "รับค่าของ KEY เป้าหมายจากองค์ประกอบพจนานุกรม",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "นำค่าคู่ของ KEY เป้าหมายในพจนานุกรมออก",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "ตั้งค่า KEY เป้าหมายในพจนานุกรม",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "ขนาดแผนที่ย่อซึ่งมีความกว้างและความสูงเท่ากัน",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "ขนาดแผนที่",
  T_40_XXJ_WS_MAPT: "รูปแบบของ Dict",
  T_40_XXJ_WS_MAPT_D: "รูปแบบข้อมูลสำหรับพจนานุกรม คุณสามารถตั้งประเภทเนื้อหาได้ผ่าน T1และ T2",
  T_40_XXJ_WS_MAPVALUE_D: "ตัวบันทึกข้อมูลสำหรับพจนานุกรม ประกอบด้วยชุด KEY และค่าของ KEY",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "พจนานุกรมเป้าหมาย",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Dict",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "ประเภทหน้ากากคือชื่อรูปที่ใช้เมื่อใส่หน้ากาก",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "ชื่อหน้ากาก",
  T_40_XXJ_WS_MASS_DESCKEY: "มวล (หน่วยเป็นกิโลกรัม)",
  T_40_XXJ_WS_MASS_NAMEKEY: "มวล (กก.)",
  T_40_XXJ_WS_MAX_DESCKEY: "เปรียบเทียบค่า 2 ค่าและคืนค่าที่มากกว่า",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "ความยาวสูงสุด",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "ค่าสูงสุด",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "ID องค์ประกอบใหญ่สุด",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "ID วิดเจ็ตสูงสุด",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "ไอเทมฮีล",
  T_40_XXJ_WS_MIN_DESCKEY: "เปรียบเทียบค่า 2 ค่าและคืนค่าที่น้อยกว่า",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "องค์ประกอบแผนที่ย่อ",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "พิกเซ็ลแผนที่ย่อ",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "ไอคอนแผนที่ย่อ",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "แผนที่ย่อ",
  T_40_XXJ_WS_MINNUM_DESCKEY: "ค่าต่ำสุด",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "ปัจจันของแรงดัน ยิ่งค่ามาก โมเมนตัมขณะเลื่อนขึ้นลงยิ่งสูง",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "ปัจจัยโมเมนตัม",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "ปุ่มการเคลื่อนไหว",
  T_40_XXJ_WS_MRESULT_DESCKEY: "ผลการแข่งขัน",
  T_40_XXJ_WS_NEWENTITY_D: "เอนทิตี้ไอเทมใหม่หลังกระบวนการสร้าง (อาจเว้นว่าง)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "สร้างพจนานุกรมเล่มใหม่",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "พจนานุกรมเล่มใหม่",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "สถานะปกติของการตกกระทบ",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "ตำแหน่ง HUD [0, 1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "ตำแหน่ง HUD",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "รายการแปลงดัชนีเป็นตัวเลข",
  T_40_XXJ_WS_OBJECT_DESCKEY: "วัตถุที่กาพ่นสีระบายสีลง",
  T_40_XXJ_WS_OBSOLETE: "ไม่สามารถทำได้ เพื่อความปลอดภัย กรุณาเปลี่ยนบล็อกนี้",
  T_40_XXJ_WS_OFFSET_DESCKEY: "ตำแหน่งการจัดวาง เมื่อมีเป้าหมายที่ติดตาม จะแสดงระยะตั้งฉากระหว่างตำแหน่งใหม่และตำแหน่งแรกเริ่ม แต่หากไม่มีเป้าหมายที่ติดตาม จะแสดงพิกัดของจอ (ค่าเริ่มต้นคือ Vector3(0))",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "พิกัดจอ (ค่าเริ่มต้นคือ Vector3(0))",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "ตำแหน่งการจัดวาง เมื่อมีเป้าหมายที่ติดตาม จะแสดงพิกัดระหว่างตำแหน่งใหม่และตำแหน่งแรกเริ่ม แต่หากไม่มีเป้าหมายที่ติดตาม จะแสดงพิกัดของจอ (ค่าเริ่มต้นคือ Vector3(0))",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "ตำแหน่งการจัดวาง (Anchor อยู่ที่มุมขวาบน)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "ระยะตั้งฉากในแนวนอน",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "ระยะตั้งฉากในแนวนอน",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "ระยะตั้งฉากในแนวตั้ง",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "ระยะตั้งฉากในแนวตั้ง",
  T_40_XXJ_WS_OK_DESCKEY: "แปลงสำเร็จ",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "เหตุการณ์นี้จะเกิดขึ้นเมื่อเอนทิตี้เข้าสู่บริเวณโจมตี",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "เหตุการณ์นี้จะเกิดขึ้นเมื่อเอนทิตี้เข้าสู่บริเวณไล่ล่า",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "เหตุการณ์นี้จะเกิดขึ้นเมื่อเอนทิตี้ออกจากบริเวณโจมตี",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "เหตุการณ์นี้จะเกิดขึ้นเมื่อเอนทิตี้ออกจากบริเวณใกล้เคียง",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "ทำให้ระบบตรวจจับแนวกล้องทำงานผ่านไคลเอนต์",
  T_40_XXJ_WS_ONCOLLISION_D: "เฉพาะเอนทิตี้ที่มีส่วนประกอบ Collider รวมอยู่ด้วย จะสามารถใช้ในกิจกรรมนี้ได้",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "เหตุการณ์นี้จะเกิดขึ้นเมื่อกาพ่นสีระบายสีโดนเอนทิตี้",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "เมื่อหยุดยิง",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "เมื่อผู้เล่นเปลี่ยนฉาก",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "จะแสดงเมื่อสถานะการเปิดเป็นจริง ไม่งั้นจะถูกปิดไว้",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "สถานะการเปิด",
  T_40_XXJ_WS_ORANGE: "ส้ม",
  T_40_XXJ_WS_ORDER_DESC: "อันดับบนกระดานอันดับ",
  T_40_XXJ_WS_ORDER1: "อันดับเริ่ม",
  T_40_XXJ_WS_ORDER2: "อันดับจบ",
  T_40_XXJ_WS_ORIGINAL: "ใช้ตรรกะเริ่มต้น",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "วิธี Overflow",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "เมื่อใช้งาน ค่าสถานะอาวุธของผู้เล่นจะเข้าแทนที่ค่าสถานะดั้งเดิมของอาวุธ",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "เน้นสกินอาวุธของผู้เล่นก่อน",
  T_40_XXJ_WS_OWNER_DESCKEY: "ผู้เล่นที่มีเอนทิตี้นี้",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "UID สากลของค่าผลที่เกี่ยวข้อง",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "UID ทั่วโลกของฉากเด็ก",
  T_40_XXJ_WS_PARENT_DESCKEY: "เอนทิตี้ค่าต้น",
  T_40_XXJ_WS_PARENT_NAMEKEY: "ค่าต้น",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "ID ของเอนทิตี้องค์ประกอบตั้งต้น",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "ID ไฟล์ขององค์ประกอบค่าต้น",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "ผู้โดยสารทั้งหมดในพาหนะ",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "ผู้โดยสาร",
  T_40_XXJ_WS_PHYSICALLAYER: "ชั้นกายภาพ",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "เมทริกซ์ของชั้นกายภาพ",
  T_40_XXJ_WS_PHYSICALTIP1: "ชื่อนี้ถูกใช้แล้ว",
  T_40_XXJ_WS_PHYSICALTIP2: "เอาชื่อเลเยอร์ออกและทำให้มองไม่เห็นในเมทริกซ์ของชั้นกายภาพและรายการเลเยอร์ แต่วัตถุเอนทิตี้ในเลเยอร์นั้นจะไม่ได้รับผลกระทบ",
  T_40_XXJ_WS_PHYSICS: "ฟิสิกส์",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "เปลี่ยน HUD รายการสมบัติ",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "เอนทิตี้ที่เล่นได้",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "เอนทิตี้ที่หันเข้าหาอีกเอนทิตี้หนึ่งเสมอ",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "เอนทิตี้ที่ติดตามอีกเอนทิตี้หนึ่ง",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "แอนิเมชันร่องรอยกระสุนเป็นแอนิเมชันแสดงร่องรอยกระสุน",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "ผู้เล่นที่จะได้รับข้อความ",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "โปรไฟล์ที่ผู้เล่นใช้",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "ชุดที่ผู้เล่นใส่",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "ชุดผู้เล่น",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "ประเภท HUD ของผู้เล่น",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "ประเภท HUD ของผู้เล่น",
  T_40_XXJ_WS_PLAYERIDINFAC: "หมายเลขซีเรียลของฝ่าย",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "ผู้เล่นที่จะจดบันทึก",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "ใช้โทเคนของผู้เล่น",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "รายการสกิลของผู้เล่น",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "สถานะผู้เล่น: มีชีวิตรอด, ล้ม หรือโดนสังหาร",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "ความเร็วการกรอ",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "ความเร็วการกรอ",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "ยกตัวอย่างเช่น 1.25 จะแปลว่าเร็วกว่าความเร็วแรกเริ่ม 25%",
  T_40_XXJ_WS_POS_DESCKEY: "พิกัดเป้าหมายของการเทเลพอร์ต",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "ประเภทของสติกเกอร์เอฟเฟ็กต์พิเศษ",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "สีเมื่อกด",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "ข้ามผ่านตัวบรรจุเพื่อรับค่า KEY คู่ รวมถึงกระบวนการย่อยที่เกิดขึ้นวนซ้ำ",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "เข้าถึงพจนานุกรมซ้ำ",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "ความคืบหน้า [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "ความคืบหน้า [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "ปุ่มสำหรับความคืบหน้าของสกิล",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "ปุ่มความคืบหน้าของสกิล",
  T_40_XXJ_WS_QUATERNION: "หมุนแบบควอเทอร์เนียน",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "เปลี่ยน HUD ข้อความด่วน",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "ข้อความข้างรายชื่อทีม",
  T_40_XXJ_WS_RADIUS_DESCKEY: "รัศมีของรูปครึ่งของวงรีสองวง",
  T_40_XXJ_WS_READCELL: "อ่านเนื้อหาในช่อง",
  T_40_XXJ_WS_READCSV: "อ่านเนื้อหาในกระดาน",
  T_40_XXJ_WS_READCSV_DESC: "อ่านเนื้อหาในกระดานอันดับทั้งหมด จะคืนเป็นลำดับสองมิติ",
  T_40_XXJ_WS_READCSVCELL: "อ่านโดยใช้ # ของแถวและชื่อคอลัมน์",
  T_40_XXJ_WS_READCSVCOL_DESC: "อ่านเนื้อหาในคอลัมน์บนกระดานอันดับ จะคืนเป็นลำดับ",
  T_40_XXJ_WS_READCSVROW_DESC: "อ่านเนื้อหาในแถวบนกระดานอันดับ จะคืนเป็นลำดับ",
  T_40_XXJ_WS_READLEADERBOARD: "อ่านค่ากระดานอันดับ",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "อ่านค่าที่เกี่ยวข้องกับตัวยืนยันบนกระดานอันดับในฐานข้อมูล",
  T_40_XXJ_WS_READLEADERBOARD2: "อ่านโดยใช้ช่วงอันดับ",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "อ่านค่าความแตกต่างระหว่างอันดับบนกระดานอันดับในฐานข้อมูล",
  T_40_XXJ_WS_RED: "แดง",
  T_40_XXJ_WS_RELOAD: "รีโหลด",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "วิธีแสดงผล",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "ใช้ชุดแฟชั่นเริ่มต้นของผู้เล่น",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "ใช้สกินอาวุธเริ่มต้นของผู้เล่น",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "ตั้งค่าการลากให้อยู่ระยะหน้าจอ จะถูกเลือกไว้เป็นค่าเริ่มต้น",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "จำกัดการลากหรือไม่",
  T_40_XXJ_WS_RESULT_DESCKEY: "ผลการคำนวณ",
  T_40_XXJ_WS_RESULT_NAMEKEY: "ผลลัพธ์",
  T_40_XXJ_WS_RESULT1_DESCKEY: "ตั้งค่าการค้นหาค่าที่มากที่สุดในรายการ",
  T_40_XXJ_WS_RESULT2_DESCKEY: "ตั้งค่าการค้นหาค่าที่น้อยที่สุดในรายการ",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "หาค่าที่น้อยที่สุดในรายการ",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "หาค่าที่มากที่สุดในรายการ",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "จุดชุบชีวิตผู้เล่น หากไม่มีจุดตรวจจะใช้เป็นจุดเกิด ไม่อย่างนั้นจะใช้จุดตรวจ",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "จุดชุบชีวิต",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "แขนขวา",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "แขนขวา",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "สีฝั่งขวา",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "สีฝั่งขวา",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "ตั้งค่าการแสดงเอฟเฟ็กต์พิเศษทางด้านขวา",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "แสดงเอฟเฟ็กต์ทางขวาหรือไม่",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "เท้าขวา",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "เท้าขวา",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "มือขวา",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "มือขวา",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "ไอคอนทางขวา",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "ไอคอนทางขวา",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "ขาขวา",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "ขาขวา",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "ข้อความคะแนนทางด้านขวา",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "ข้อความคะแนนทางด้านขวา",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "ข้อความทางขวา",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "ข้อความทางขวา",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "องค์ประกอบวัตถุแข็ง",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "องค์ประกอบวัตถุแข็ง",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "รายการประเภทวัตถุแข็ง",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "รายการประเภทวัตถุแข็ง",
  T_40_XXJ_WS_ROW_DECS: "แถวที่ต้องอ่าน",
  T_40_XXJ_WS_ROWVALUE: "เนื้อหาในแถว",
  T_40_XXJ_WS_SCALE_DESCKEY: "ตั้งค่าสัดส่วนการซูมของวัตถุ",
  T_40_XXJ_WS_SCALE_NAMEKEY: "สัดส่วน",
  T_40_XXJ_WS_SCALE0_DESCKEY: "ระดับการซูมในระบบพิกัดโลก",
  T_40_XXJ_WS_SCALE1_DESCKEY: "ระดับการซูม เริ่มต้นที่ 1",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "ค่ามาตราส่วน",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "ชื่อพื้นที่",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "แถบคะแนน",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "แถบคะแนน",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "รองรับการเลื่อนหลายทิศทาง",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "ทิศทางการเลื่อน",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "ปัจจัยของการเลื่อนขึ้นลง ยิ่งค่ามาก ยิ่งเลื่อนไว",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "ปัจจัยการเลื่อนขึ้นลง",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "ตั้งค่า cullingMask ของกล้อง",
  T_40_XXJ_WS_SETGLOBAL: "ตั้งเป็นสากล",
  T_40_XXJ_WS_SETPARENT_D: "รองรับเฉพาะเอนทิตี้ที่มีองค์ประกอบ Transform เท่านั้น",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "ตั้งค่า ID ชุด",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "ปรับชุดของผู้เล่นหลายคน",
  T_40_XXJ_WS_SETPLAYERFORWAR: "ตั้งค่าทิศทางของผู้เล่น",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "ตั้งค่าการเปลี่ยน HUD ของผู้เล่น",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "ตั้งค่าสกินอาวุธของผู้เล่น",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "ตั้งค่าการแสดงเอนทิตี้ที่ตำแหน่งเป้าหมาย",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "แสดงเอนทิตี้บนเป้าหมาย",
  T_40_XXJ_WS_SHOWPLAYER: "แสดงผล",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "เอนทิตี้ HUD รายละเอียดเกมเล่นคนเดียว",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "เอนทิตี้ HUD สำหรับเกมเล่นคนเดียว เมื่อปรับคุณสมบัติเอนทิตี้จะส่งผลต่อเนื้อหาที่จะแสดงใน UI ที่เกี่ยวข้อง",
  T_40_XXJ_WS_SIZEDELTA: "เดลต้าขนาดกล่องจุดยึดและองค์ประกอบ",
  T_40_XXJ_WS_SKELETON: "โครงกระดูก",
  T_40_XXJ_WS_SKELETON_D: "แกนหมุนเข้าสู่หน้ากากโครงกระดูก",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Skeleton part",
  T_40_XXJ_WS_SKILLBUTTONHUD: "เอนทิตี้ HUD ปุ่มสกิล",
  T_40_XXJ_WS_SLOT_DESCKEY: "ช่องอาวุธ",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "เมื่อเลือก ท่าทางการลากจะเป็นไปแบบช้า ๆ เมื่อนำออก การลากจะขึ้นอยู่กับความไวของเมาส์",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "ตั้งค่าการเคลื่อนไหวแบบนุ่มนวล",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "นุ่มนวล",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "นุ่มนวล",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "เอนทิตี้เสียง",
  T_40_XXJ_WS_SPACE_DESCKEY: "ช่องว่าง",
  T_40_XXJ_WS_SPACE_NAMEKEY: "ระยะห่างของช่องเด็ก",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "พิกัดจุดเกิดของ AI",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "พิกัดจุดเกิด",
  T_40_XXJ_WS_SPEED_DESCKEY: "ความเร็ว",
  T_40_XXJ_WS_SPEED_NAMEKEY: "ความเร็ว",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "วิ่ง",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "รัศมีของทรงกลม",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "สีสเปรย์",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "สีสเปรย์",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "ผลการสเปรย์",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "ผลการสเปรย์",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "ปืนสเปรย์ (ไรเฟิลจู่โจม)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "ไรเฟิลสเปรย์",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "ความเร็วเริ่มต้น",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "กลับด้านสติกเกอร์",
  T_40_XXJ_WS_SPRITEID: "ID ของ Sprite",
  T_40_XXJ_WS_SPRITEID_D: "ID ใช้เพื่ออธิบาย Sprite",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "ประเภทสติกเกอร์",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "เอนทิตี้เป้าหมายที่จะสร้างพิกเซ็ลนิ่ง",
  T_40_XXJ_WS_STARTPOSITION_D: "พิกัดของจุดศูนย์กลางทางเรขาคณิตของรูปทรง",
  T_40_XXJ_WS_STAY_D: "คงตำแหน่งโลกปัจจุบัน, การหมุน และขนาดของค่าผลไว้? โดยทั่วไปจะตั้งค่าไว้เป็นจริง การตั้งค่า UI ไม่มีผลกับตัวเลือกนี้",
  T_40_XXJ_WS_STRING_NAMEKEY: "ข้อความ",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "แปลงข้อความเป็นเลขทศนิยม",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "แปลงข้อความเป็นตัวเลข",
  T_40_XXJ_WS_STYLE_DESCKEY: "วิธีเล่นการสอดแทรก สามารถเลือกได้ระหว่างเล่น 1 ครั้ง, เล่นซ้ำ และเล่นอีกครั้ง",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "เปลี่ยนพื้นที่ของผู้เล่น",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "เปลี่ยนค่า",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "เปลี่ยนอาวุธตามช่องของผู้เล่น",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "เปลี่ยนช่องไอเทม",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "เปลี่ยนไอเทม",
  T_40_XXJ_WS_TABLENAME_DESC: "แสดงเป็นชื่อตารางแต่จริง ๆ แล้วเป็นเลข UID",
  T_40_XXJ_WS_TABLEVALUE: "เนื้อหาในตาราง",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "รายการแท็ก",
  T_40_XXJ_WS_TARGET_DESCKEY: "เอนทิตี้เป้าหมายที่สร้างพิกเซ็ลของแผนที่ จะว่างเป็นค่าเริ่มต้น",
  T_40_XXJ_WS_TARGET_NAMEKEY: "เอนทิตี้สร้างพิกเซ็ลของแผนที่",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "โจมตีเป้าหมาย",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "เอนทิตี้เป้าหมาย",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "เอนทิตี้",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "เอนทิตี้ที่มีฟังก์ชันปรับแต่งเองได้",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "เอนทิตี้ที่ถูก AI โจมตี",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "เอนทิตี้เป้าหมายที่จะติดตาม",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "เอนทิตี้ไอเทม (เว้นว่างได้)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "เอนทิตี้เป้าหมายที่จะดู",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "เอนทิตี้เสียงที่จะหยุดเล่น",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "เอนทิตี้เสียงที่จะเล่นหลังเลือกเล่นต่อ",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "เอนทิตี้เสียงที่จะลบ",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "ข้อมูลเพื่อนร่วมทีม",
  T_40_XXJ_WS_TELEPORTA_D: "เคลื่อนย้ายผู้เล่นไปยังจุดและทิศทางที่กำหนดไว้",
  T_40_XXJ_WS_TEXT_NAMEKEY: "ข้อความเคล็ดลับ",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "สีข้อความแจ้งเตือน",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "เอนทิตี้ข้อความที่สื่อถึงข้อความที่จะแสดง",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "ข้อความที่จะแสดง",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "ข้อความ",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "วันที่และเวลา",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "รูปแบบการแสดงวันที่และเวลาที่ได้รับการแปลแล้ว",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "รูปแบบการแสดงวันที่และเวลา",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "วันที่และเวลาที่ได้รับการแปลแล้ว",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "วันและเวลาที่แปลข้อความ",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "คำใบ้",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "เคล็ดลับ",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "จำนวนไอเทมที่สามารถปล้นได้",
  T_40_XXJ_WS_TOKENID_DESCKEY: "ID ของไอเทมที่สามารถปล้นได้",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "ความเร็วในการจูงของผู้เล่น",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "ประเภทคำแปล",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "เอนทิตี้แอนิเมชันสอดแทรก",
  T_40_XXJ_WS_TYPE_DESCKEY: 'นี่คือประเภทของคำอธิบาย เมื่อใช้ "typeof" จะทำให้คำอธิบายคืนสู่ประเภทของมัน',
  T_40_XXJ_WS_TYPE_NAMEKEY: "ประเภทวัตถุแข็ง",
  T_40_XXJ_WS_TYPE2_DESCKEY: "วัตถุแข็งประเภทต่าง ๆ กันมีฟังก์ชันแตกต่างกันไป",
  T_40_XXJ_WS_TYPE3_DESCKEY: "รองรับเฉพาะสกุลเงินพื้นฐานในเวอร์ชันปัจจุบันเท่านั้น",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "ตั้งค่าการแสดงผลความลึกในแผนที่ย่อ",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "ใช้แผนที่เชิงลึก",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "ตั้งค่าแรงดึงดูดของวัตถุ",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "เป็นไปตามแรงดึงดูดหรือไม่",
  T_40_XXJ_WS_UUID_DESCKEY: "ตัวยืนยันเฉพาะผู้เล่น",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "ค่า",
  T_40_XXJ_WS_VALUE_NAMEKEY: "ค่า",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "ค่า [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "ค่าที่หนึ่ง",
  T_40_XXJ_WS_VALUE2_DESCKEY: "ค่าที่สอง",
  T_40_XXJ_WS_VALUE6_DESCKEY: "ค่า [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "ค่าเริ่มต้น",
  T_40_XXJ_WS_VALUEB_DESCKEY: "ค่าของเป้าหมาย",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "ชื่อของค่าที่จะข้าม สามารถใช้เพื่อรับค่าของตัวแปรในพื้นที่ได้",
  T_40_XXJ_WS_VALUET_DESCKEY: "ความคืบหน้าของการสอดแทรก จะอยู่ระหว่าง 0 ถึง 1",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "ประเภทตัวแปร",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "ประเภทการแสดงผลแนวตั้ง",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "ประเภทการแสดงผลแนวตั้ง",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "ระดับการมองเห็นวัตถุ",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "ชั้นที่มองเห็นได้",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "ชุดแฟชั่นแบ่งออกเป็นแพ็ก, หัว, หน้ากาก, ลายเพ้นท์, เสื้อ, กางเกงหรือกระโปรง และรองเท้า",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "ประเภทชุดแฟชั่น",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "ช่องชุด",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "อาวุธ",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "ID สกินอาวุธ",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "ID สกินอาวุธ",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "ID ของสกินอาวุธ",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "สกินอาวุธของผู้เล่น",
  T_40_XXJ_WS_WIDGETTYPEENUM: "รายการประเภทองค์ประกอบ",
  T_40_XXJ_WS_WIDTH_DESCKEY: "ความกว้าง",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Word Wrap",
  T_40_XXJ_WS_WRITELEADERBOARD: "เขียนค่าบนกระดานอันดับ",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "เขียนค่าที่เกี่ยวข้องกับ KEY บนกระดานอันดับในฐานข้อมูล",
  T_40_XYL_WS_BUMPERFACTORY: "โรงงานรถบัมพ์",
  T_40_XYL_WS_BURNDAMAGE: "ความเสียหายจากการไหม้",
  T_40_XYL_WS_BURNINTERVAL: "ช่วงเวลาความเสียหายจากการเผาไหม้ (วินาที)",
  T_40_XYL_WS_BURNTIME: "ระยะเวลาไหม้หลังระเบิด",
  T_40_XYL_WS_COLORFULSKY: "ท้องฟ้าหลากสี",
  T_40_XYL_WS_CRANEMACHINE: "เครื่องคีบ",
  T_40_XYL_WS_CRASHMAXDAMAGE: "ความเสียหายสูงสุดของการชน",
  T_40_XYL_WS_CRASHMAXSPEED: "ขีดจำกัดความเร็วของความเสียหายสูงสุดของการชน",
  T_40_XYL_WS_CRASHMESS: "พารามิเตอร์มวลระหว่างการชน",
  T_40_XYL_WS_CRASHMINDAMAGE: "ความเสียหายขั้นต่ำจากการชน",
  T_40_XYL_WS_DISPLAYBOARD: "ป้ายโฆษณาใหญ่",
  T_40_XYL_WS_EXPLODEDAMAGE: "ความเสียหายจากการระเบิด",
  T_40_XYL_WS_EXPLODEDELAY: "ระยะเวลาดีเลย์ของระเบิด",
  T_40_XYL_WS_EXPLODERANGE: "ระยะการระเบิด",
  T_40_XYL_WS_FERRISWHEEL: "ชิงช้าสวรรค์",
  T_40_XYL_WS_FOODTRUCK002: "รถขนอาหาร B",
  T_40_XYL_WS_GEARSHIFTDELAY: "ระยะเวลาการเปลี่ยนอุปกรณ์ (วินาที)",
  T_40_XYL_WS_ICAROUSEL001: "องค์ประกอบ A ม้าหมุน",
  T_40_XYL_WS_ICAROUSEL002: "องค์ประกอบ B ม้าหมุน",
  T_40_XYL_WS_ICAROUSEL003: "ม้าหมุน",
  T_40_XYL_WS_ICEDANCEDOOL: "ตุ๊กตาสีฟ้า",
  T_40_XYL_WS_IDLEBRAKEINPUT: "อัตราแรงม้าขณะจอดที่ไม่มีการควบคุม",
  T_40_XYL_WS_LOLLIPOP: "อมยิ้มอันใหญ่",
  T_40_XYL_WS_NEWHOOKGUN: "ซูเปอร์ปืนตะขอ",
  T_40_XYL_WS_OPENSWING: "ปุ่มแกว่ง",
  T_40_XYL_WS_OPENTRACTION: "ปุ่มจูง",
  T_40_XYL_WS_PODIUM: "โพเดี้ยม",
  T_40_XYL_WS_SKYCITY: "เมือง",
  T_40_XYL_WS_SKYSCRAPER_A001: "องค์ประกอบ A ตึกระฟ้า A",
  T_40_XYL_WS_SKYSCRAPER_A002: "องค์ประกอบ B ตึกระฟ้า A",
  T_40_XYL_WS_SKYSCRAPER_A003: "องค์ประกอบ C ตึกระฟ้า A",
  T_40_XYL_WS_SKYSCRAPER_B001: "องค์ประกอบ A ตึกระฟ้า B",
  T_40_XYL_WS_SKYSCRAPER_B002: "องค์ประกอบ B ตึกระฟ้า B",
  T_40_XYL_WS_SKYSCRAPER_B003: "องค์ประกอบ C ตึกระฟ้า B",
  T_40_XYL_WS_SKYSCRAPER_C001: "องค์ประกอบ C ตึกระฟ้า A",
  T_40_XYL_WS_SKYSCRAPER_C002: "องค์ประกอบ C ตึกระฟ้า B",
  T_40_XYL_WS_SKYSCRAPER_C003: "องค์ประกอบ C ตึกระฟ้า C",
  T_40_XYL_WS_SKYSCRAPER_D001: "องค์ประกอบ A ตึกระฟ้า D",
  T_40_XYL_WS_SKYSCRAPER_D002: "องค์ประกอบ B ตึกระฟ้า D",
  T_40_XYL_WS_SKYSCRAPER_D003: "องค์ประกอบ C ตึกระฟ้า D",
  T_40_XYL_WS_SKYSCRAPER_E001: "องค์ประกอบ A ตึกระฟ้า E",
  T_40_XYL_WS_SKYSCRAPER_E002: "องค์ประกอบ B ตึกระฟ้า E",
  T_40_XYL_WS_SKYSCRAPER_E003: "องค์ประกอบ C ตึกระฟ้า E",
  T_40_XYL_WS_STEERANGLE: "รัศมีการเลี้ยวด้วยความเร็วสูง",
  T_40_XYL_WS_STEERSPEED: "ความเร็วสูงสุดเมื่อเลี้ยวด้วยความเร็วสูง",
  T_40_XYL_WS_SWINGSPEED: "ความเร็วการแกว่ง",
  T_40_XYL_WS_TARGETOBJECT: "Anchor การเคลื่อนไหว",
  T_40_XYL_WS_TRACTIONSPEED: "ความเร็วการจูง",
  T_40_XYL_WS_TRIGGERCAPSULE: "จุดที่ทำให้แคปซูลสร้างเองทำงาน",
  T_40_XYL_WS_TRIGGERSPHERE: "จุดที่ทำให้บริเวณสร้างเองทำงาน",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "วัตถุสร้างเอง",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "องค์ประกอบวัตถุที่ว่างไว้ สามารถใช้กับองค์ประกอบประมวลผลและองค์ประกอบปะทะได้",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "องค์ประกอบประมวลผลเอง",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "องค์ประกอบประมวลผลเอง ใช้เพื่อประมวลผลทรัพยากรสร้างเองได้",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "ศัตรูที่ถูกมาร์คมีค่าหัว หากใครในทีมกำจัดศัตรูที่มีมาร์คได้ จะได้รับ [FFB300]{0} เหรียญ[-] และจะได้รับโบนัส [FFB300]100 เหรียญ[-] หากกำจัดศัตรูได้เพิ่ม รับ [FFB300]{1}เหรียญ FF[-] เพิ่มจากแท่นจ่ายเหรียญในโหมดทั่วไป",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "มาร์คเงิน",
  T_41_CJ_A_ESPORTS_TH: "White God (หน้ากาก)",
  T_41_CJ_B_ESPORTS_TH: "White God (กางเกง)",
  T_41_CJ_H_ESPORTS_TH: "White God (หัว)",
  T_41_CJ_S_ESPORTS_TH: "White God (รองเท้า)",
  T_41_CJ_T_ESPORTS_TH: "White God (เสื้อ)",
  T_41_CJ_T_FFSI: "FFSI Champion Jersey (เสื้อ)",
  T_41_CJ_T_FOOTBALL_EU01: "เสื้อ Sunburst",
  T_41_CJ_T_FOOTBALL_EU02: "เสื้อ Bold Red",
  T_41_CJ_T_FOOTBALL_EU03: "เสื้อ Majestic Crown",
  T_41_CJ_T_FOOTBALL_EU04: "เสื้อ Regal Titan",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "ซูซี่",
  T_41_LXW_TabName_Items: "ไอเทม",
  T_41_R_CD_COIL: "วงบีบ",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "จะเปิดใช้อุปกรณ์นี้ไหม",
  T_41_SJ_WS_SPECIALITEM_NAME: "อุปกรณ์",
  T_41_SW_SKILL_DESC_DELIVERY: "เมื่อโดนโจมตีจากศัตรูในระยะ [FFB300]{0}ม. [-] คนโจมตีจะโดนมาร์คตำแหน่งเป็นระยะเวลา [FFB300]{1} วิ [-] (เพื่อนร่วมทีมจะเห็นตำแหน่งของศัตรู. จำกัด. [FFB300]{2} [-] จุด",
  T_41_SW_SKILL_DESC_GANGLEADER: "รับค่าโล่ [FFB300]{0}หน่วย[-] เมื่อเริ่มเกม ฟื้นฟูค่าโล่หลังจากจบการต่อสู้และรอดชีวิต",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "เมื่อกดใช้สกิล จะได้รับค่าโล่ [FFB300]{1}[-] หน่วย ให้กับตัวเองและเพื่อนร่วมทีมที่อยู่ในระยะ [FFB300]{0} ม. [-]. ค่าโล่จะลดลงหลังจาก [FFB300]{2} วิ[-], และจะสามารถใช้ได้ใหม่อีกครั้ง คูลดาวน์: [FFB300]{3}วิ[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "ฟื้นฟูไอซ์วอลล์ [FFB300]{0}[-] หน่วยต่อวิ เมื่อไอซ์วอลล์โดนโจมตี เพื่อนในทีม [FFB300]{1}เมตร[-] จะได้รับการฟื้นฟู HP [FFB300]{2} หน่วยต่อวิ[-] สูงสุด [FFB300]{3} หน่วย[-]ต่อผู้เล่น จากแต่ละไอซ์วอลล์",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "สกินคู่หู: Recollective Kactus",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "สกินคู่หู: Inked Falco",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "ประเภท",
  T_41_WT_SKILL_DESC_FIREBOY: "ปล่อยม่านไฟที่มีความกว้าง [FFB300]{1} ม.[-] ซึ่งจะคงอยู่เป็นเวลา [FFB300]{0} วิ[-] และเคลื่อนที่ไปข้างหน้าด้วยความเร็ว [FFB300]{2} ม./วิ[-] ได้นานสุด [FFB300]{3} วิ[-] เมื่ออยู่ในช่วงเวลาดังกล่าว ใช้สกิลอีกครั้งเพื่อหยุดม่าน หาก [FFB300]ศัตรู (หรือไอซ์วอลล์)[-] สัมผัสกับม่านจะได้รับความเสียหาย [FFB300]{4} (หรือ {5}) หน่วย[-] ทันที และจากนั้นจะได้รับความเสียหาย [FFB300]{6} (หรือ {7}) หน่วย/วิ[-] คงอยู่เป็นเวลา [FFB300]{8} วิ[-] คูลดาวน์: [FFB300]{9} วิ[-] สามารถเก็บสะสมการใช้งานสกิลได้ถึง [FFB300]{10}[-] ครั้ง โดยมีคูลดาวน์ [FFB300]{11} วิ[-] ระหว่างการใช้แต่ละครั้ง",
  T_41_WT_SKILL_NAME_FIREBOY: "เพลิงมายา",
  T_41_WZY_WS_CHARGEMAX: "ความเร็วสูงสุดในการสร้างไอซ์วอลล์",
  T_41_WZY_WS_CROSSBOWNAME: "หน้าไม้",
  T_41_WZY_WS_DECELERATIONRATIO: "% การลดความเร็วในน้ำ",
  T_41_WZY_WS_DEICEWALLPARAM1: "รัศมีของการละลาย",
  T_41_WZY_WS_DEICEWALLPARAM2: "เวลาในการละลาย",
  T_41_WZY_WS_EXPPERCHIP: "EXP จากชิปไอซ์วอลล์",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP จากการสร้างความเสียหาย",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP จากระยะทางทีเดินทาง",
  T_41_WZY_WS_EXPPERSECOND: "EXP ต่อวินาที",
  T_41_WZY_WS_GRENADEEXPTIME: "ระยะเวลาดีเลย์ของระเบิด",
  T_41_WZY_WS_GRENADELAUNCHNAME: "ระเบิด",
  T_41_WZY_WS_GRENADEMAX: "ความเสียหายสูงสุด",
  T_41_WZY_WS_GRENADEMIN: "ความเสียหายต่ำสุด",
  T_41_WZY_WS_GRENADERANGE: "รัศมีของระเบิด",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "ความเสียหาย coefficient เมื่ออยู่บนพาหนะ",
  T_41_WZY_WS_GRENADERATIOSELF: "ความเสียหาย coefficient กับตัวเอง",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "ความเสียหาย coefficient กับเพื่อนร่วมทีม",
  T_41_WZY_WS_GRENADTHROWSPEED: "ความเร็วของระเบิด",
  T_41_WZY_WS_HANDCANNONNAME: "Hand Cannon",
  T_41_XXJ_WS_ACCELERATION: "การเร่งความเร็ว",
  T_41_XXJ_WS_ACCELERATION_D: "สร้างเอฟเฟ็กต์การเร่งความเร็ว",
  T_41_XXJ_WS_ACTION: "โนดการกระทำ",
  T_41_XXJ_WS_ACTION_D: "การกระทำจุดหมุน",
  T_41_XXJ_WS_ADDHP: "ไอเทมฟื้นฟู",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "เพิ่ม HP สูงสุด",
  T_41_XXJ_WS_AICASTSKILL_D: "AI ปล่อยสกิล",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "ศูนย์กลางการเล็งอัตโนมัติ",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "ระยะการเล็งอัตโนมัติ",
  T_41_XXJ_WS_AIMASSISTENTITY: "เอนทิตี้การเล็งอัตโนมัติ",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "เอนทิตี้ ที่สามารถเล็งอัตโนมัติได้",
  T_41_XXJ_WS_AISKILLTYPE: "ประเภทของสกิลซฮมบี้",
  T_41_XXJ_WS_AISKILLTYPE_D: "ชนิดของสกิลซอมบี้",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "ไอเทมทั้งหมด",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "ไอเทมทั้งหมด",
  T_41_XXJ_WS_AMMOCLIPSIZE: "ปรับแต่งจำนวนกระสุนในแมกกาซีน",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "กระสุนในแมกกาซีน",
  T_41_XXJ_WS_ANCHORPOSITION_D: "จุดยึดจะประสานกับตัวตั้งต้น",
  T_41_XXJ_WS_ANGLE_D: "มุมการหมุนเวียนของแกน z",
  T_41_XXJ_WS_ANGULARDRAG: "ลากเชิงมุม",
  T_41_XXJ_WS_ANGULARVELOCITY: "ความเร็วเชิงมุม",
  T_41_XXJ_WS_ANIMATIONCLIP: "สถานะแอนิเมชัน",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "ตัวควบคุมแอนิเมชัน",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "เอนทิติี้แอนิเมชัน",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "ไฟล์และทรัพยากรนี้จะถูกใช้จัดการตัวควบคุมแอนิเมชัน",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "ตัวควบคุมแอนิเมชัน ทรัพยากร UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "ประเภทของการวนซ้ำของ enum",
  T_41_XXJ_WS_ANIMATIONSTATE: "สถานะแอนิเมชัน",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "การดำเนินการซึ่งรองรับการกำหนดค่าทุกประเภท และประเภทดิจิตัลยังรองรับการเพิ่มเอง การลบเอง การคูณเอง และการหารเอง",
  T_41_XXJ_WS_ATTACHMENT: "สิ่งที่แนบมา",
  T_41_XXJ_WS_ATTACHMENT_D: "สิ่งที่แนบมา",
  T_41_XXJ_WS_ATTACHTARGET: "เอนทิตี้ที่ถูกเชื่อมต่อ",
  T_41_XXJ_WS_BAG: "กระเป๋า",
  T_41_XXJ_WS_BAG_D: "องค์ประกอบกระเป๋า",
  T_41_XXJ_WS_BANNERID: "ไอดีพื้นหลัง",
  T_41_XXJ_WS_BANNERID_D: "ไอดีพื้นหลัง",
  T_41_XXJ_WS_BEHAVIOURTREE: "Behavior tree",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Behavior Tree",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "เอนทิตี้ behavior tree",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "เอนทิตี้ behavior tree ที่สามารถติดตั้งได้",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "โนดของ behavior tree ที่ปรับแต่งได้",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "จุดหมุนที่ปรับแต่งได้ของ Behavior Tree",
  T_41_XXJ_WS_BODY: "ลำตัว",
  T_41_XXJ_WS_BORDERLR: "ขอบ (ซ้าย&ขวา)",
  T_41_XXJ_WS_BORDERLR_D: "ขอบด้านซ้ายและขวา",
  T_41_XXJ_WS_BORDERTB: "ขอบ (บน&ล่าง)",
  T_41_XXJ_WS_BORDERTB_D: "ขอบด้านบนและล่าง",
  T_41_XXJ_WS_BRPEAKRANK: "แรงค์สูงสุดในโหมดโหมดทั่วไป",
  T_41_XXJ_WS_BRPEAKRANK_D: "แรงค์สูงสุดในโหมดโหมดทั่วไป",
  T_41_XXJ_WS_BRRANK: "แรงก์โหมดทั่วไป",
  T_41_XXJ_WS_BRRANK_D: "แรงก์โหมดทั่วไป",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "ประเภทโนดของ behavior tree",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "ประเภทจุดหมุนของ behavior tree",
  T_41_XXJ_WS_BTREE: "Behavior tree",
  T_41_XXJ_WS_BTREENODESTATE: "สถานะของโนด behavior tree",
  T_41_XXJ_WS_BTREENODESTATE_D: "สถานะการทำงานของจุดหมุน Behavior Tree",
  T_41_XXJ_WS_BUFFABLEENTITY: "Entity ที่เพิ่มบัฟได้",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "อนุญาตการเพิ่มลดบัฟและรับรายการบัฟที่เพิ่มเข้าไปได้",
  T_41_XXJ_WS_BUILDINGICEWALL: "ไอซ์วอลล์",
  T_41_XXJ_WS_CAMOUFLAGE: "ไอเทมสำหรับใช้งาน",
  T_41_XXJ_WS_CAMOUFLAGE_D: "สกายบอร์ดพรางตัว...",
  T_41_XXJ_WS_CAPICITY_D: "ความจุตั้งต้น",
  T_41_XXJ_WS_CENTERINVISIBLE: "ไม่แสดงเป้ายิง",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "ไม่สามารถแสดงได้ตรงกลาง",
  T_41_XXJ_WS_COLOR: "สี",
  T_41_XXJ_WS_COLOR_D: "สี",
  T_41_XXJ_WS_CONDITION: "โนดที่มีเงื่อนไข",
  T_41_XXJ_WS_CONDITION_D: "เงื่อนไขคือค่า Boolean ประเภทพิเศษ",
  T_41_XXJ_WS_CONDITION1_D: "เงื่อนไขจุดหมุน",
  T_41_XXJ_WS_CONSTRAIN: "ข้อจำกัดของวัตถุที่มีรูปทรงคงตัว",
  T_41_XXJ_WS_CONSTRAIN_D: "เพิ่มข้อจำกัดเกี่ยวกับวัตถุแข็ง นี่คือการรวบรวมประเภทข้อจำกัดเกี่ยวกับวัตถุแข็ง",
  T_41_XXJ_WS_COUNT_D: "ปริมาณ",
  T_41_XXJ_WS_CROSSBOW_D: "หน้าไม้",
  T_41_XXJ_WS_CSPEAKRANK: "แรงค์สูงสุดในโหมด 4v4",
  T_41_XXJ_WS_CSPEAKRANK_D: "แรงค์สูงสุดในโหมด 4v4",
  T_41_XXJ_WS_CSRANK: "แรงค์ 4v4",
  T_41_XXJ_WS_CSRANK_D: "แรงค์ 4v4",
  T_41_XXJ_WS_CSVNAME_D: "ไฟล์ csv ใต้ SceneData จะสอดคล้องกับโหมด จบด้วย .csv. หัวข้อจะถูกเขียนด้วยอักษรตัวเล็ก",
  T_41_XXJ_WS_CURCAPACITY: "พื้นที่ที่ใช้ไปแล้ว",
  T_41_XXJ_WS_CURPROGRESS: "ความคืบหน้าปัจจุบัน",
  T_41_XXJ_WS_CURRENTCLIP: "คลิปปัจจุบัน",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "สถานะปัจจุบันของคลิป",
  T_41_XXJ_WS_CURRENTSTATE: "สถานะปัจจุบัน",
  T_41_XXJ_WS_CUSTOMHUDID: "ไอดีของ HUD แบบปรับแต่งเอง",
  T_41_XXJ_WS_CUSTOMHUDID_D: "ไอดีที่ใช้ในการอธิบาย HUD แบบปรับแต่งเอง",
  T_41_XXJ_WS_DASHATTACK: "พุ่งโจมตี",
  T_41_XXJ_WS_DEBUG: "กำลังเริ่มตรวจสอบบั๊ก",
  T_41_XXJ_WS_DEBUG_D: "แก้",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "การลดความเร็ว %: การลดความเร็วเมื่อวัตถุอยู่ในน้ำ (ระยะถูกตั้งไว้ที่ 0-100 ชั่วคราว)",
  T_41_XXJ_WS_DEPTH_D: "ความลึก",
  T_41_XXJ_WS_DRAG: "การลากค่า coefficient",
  T_41_XXJ_WS_DRAG_D: "ค่า coefficient สูงจะทำให้ความเร็วการเคลื่อนที่ช้าลง",
  T_41_XXJ_WS_DUMMY: "Dummy",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "เปิดการใช้งานโหมดกราฟฟิกต่ำ",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "เมื่อเปิดโหมด fps ต่ำ เกมจะทำงานที่ 15 หรือ 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "คืนรายการเอนทิตี้ที่ถูกสร้างขึ้น",
  T_41_XXJ_WS_ENTITYNAME: "ชื่อของวัตถุ",
  T_41_XXJ_WS_ENTITYNAME_D: "ชื่อของวัตถุที่ถูกปรับแต่งโดยผู้เล่น",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "เอนทิตี้ logical หรือไอดี prefab",
  T_41_XXJ_WS_EQUIPANDBAG: "เกราะและกระเป๋า",
  T_41_XXJ_WS_EQUIPMENTSLOT: "ช่องอุปกรณ์ enum",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "ช่องอุปกรณ์ enum",
  T_41_XXJ_WS_EXPLODE: "ระเบิดด้วยตัวเอง",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "อาวุธประเภทระเบิด",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "ความเร็วรีโหลดอัตโนมัติ",
  T_41_XXJ_WS_FILEID: "Internal ID",
  T_41_XXJ_WS_FILEID_D: "Internal ID ของตัวควบคุมของ prefab",
  T_41_XXJ_WS_FILLAMOUNT: "ปริมาณการเติม",
  T_41_XXJ_WS_FILLAMOUNT_D: "ค่าของการเติม",
  T_41_XXJ_WS_FILLDIR: "ทิศทางของการเติม",
  T_41_XXJ_WS_FILLDIR_D: "ทิศทางของการเติม",
  T_41_XXJ_WS_FILLDIR_D1: "ทิศทางในการเติม enum",
  T_41_XXJ_WS_FILLTYPE: "ชนิดการเติม",
  T_41_XXJ_WS_FILLTYPE_D: "ชนิดการเติม",
  T_41_XXJ_WS_FILLTYPE_D1: "ชนิดของการเติม enum",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "หาเส้นทาง",
  T_41_XXJ_WS_FINISH: "สำเร็จ",
  T_41_XXJ_WS_FIREINTERVAL: "ความหน่วงระหว่างยิง",
  T_41_XXJ_WS_FIREINTERVAL_D: "ความหน่วงระหว่างโจมตี",
  T_41_XXJ_WS_FLIP: "วิธีการกลับด้าน",
  T_41_XXJ_WS_FLIP_D: "วิธีการกลับด้าน",
  T_41_XXJ_WS_FLYBOMBBEE: "ซอมบี้บิน",
  T_41_XXJ_WS_FORCE: "แรง",
  T_41_XXJ_WS_FORCE_D: "สร้างแรงที่มีความแรงตามที่กำหนด",
  T_41_XXJ_WS_FORCETYPE: "ปะเภทแรง",
  T_41_XXJ_WS_FORCETYPE_D: "ประเภทของแรงต่าง ๆ บนวัตถุแข็ง ป.ล. ใช้ได้กับวัตถุแข็งประเภทเคลื่อนไหวได้",
  T_41_XXJ_WS_FREEZEALL: "แช่แข็งการเคลื่อนไหวและหมุนเวียน",
  T_41_XXJ_WS_FREEZEPOSITION: "แช่แข็งการเคลื่อนที่แบบเชิงเส้น",
  T_41_XXJ_WS_FREEZEPOSITIONX: "แช่เข็งแกน x",
  T_41_XXJ_WS_FREEZEPOSITIONY: "แช่เข็งแกน y",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "แช่เข็งแกน z",
  T_41_XXJ_WS_FREEZEROTATION: "แช่แข็งการหมุนเวียนทุกทิศทาง",
  T_41_XXJ_WS_FREEZEROTATIONX: "แช่แข็งการหมุนเวียนแกน x",
  T_41_XXJ_WS_FREEZEROTATIONY: "แช่แข็งการหมุนเวียนแกน y",
  T_41_XXJ_WS_FREEZEROTATIONZ: "แช่แข็งการหมุนเวียนแกน z",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "ระยะการทำความเสียหายสูงสุด",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "ระยะการทำความเสียหายสูงสุด",
  T_41_XXJ_WS_GAMEID_D: "ID ภารกิจ",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "ให้ไอเทมมหานคร",
  T_41_XXJ_WS_GRADIENT: "การไล่ระดับสี",
  T_41_XXJ_WS_GRADIENT_D: "การไล่ระดับสี",
  T_41_XXJ_WS_GRADIENTBOTTOM: "การไล่ระดับสีต่ำสุด",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "การไล่ระดับสีต่ำสุด",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "ความโปร่งใสต่ำสุด",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "ความโปร่งใสต่ำสุด",
  T_41_XXJ_WS_GRADIENTTOP: "การไล่ระดับสีสูงสุด",
  T_41_XXJ_WS_GRADIENTTOP_D: "การไล่ระดับสีสูงสุด",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "ความโปร่งใสสูงสุด",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "ความโปร่งใสสูงสุด",
  T_41_XXJ_WS_GRAPHID: "Script ID",
  T_41_XXJ_WS_GRAPHID_D: "ไอดีที่ใช้ในการอธิบาย Script",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "องค์ประกอบระเบิดกัดกร่อน",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "ระยะเวลาดีเลย์ของระเบิด",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "อาวุธปาที่โจมตีได้",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "ความเสียหายสูงสุด",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "ความเสียหายขั้นต่ำ",
  T_41_XXJ_WS_GRENADERANGE_D: "ระยะระเบิด",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "ตัวคูณความเสียหายส่วนตัว",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "ตัวคูณความเสียหายของเพื่อนร่วมทีม",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "ตัวคูณความเสียหายของยานพาหนะ",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "ความเร็วของการโยน",
  T_41_XXJ_WS_GRENADEWEAPON: "ประเภทอาวุธปาที่โจมตีได้",
  T_41_XXJ_WS_GRENADEWEAPON_D: "ประเภทอาวุธปาที่โจมตีได้ขั้นพื้นฐาน",
  T_41_XXJ_WS_HANDCANNON_D: "อาวุธปาที่โจมตีได้",
  T_41_XXJ_WS_HEAD: "หัว",
  T_41_XXJ_WS_HEADID: "ไอดีโปรไฟล์",
  T_41_XXJ_WS_HEADID_D: "ไอดีโปรไฟล์",
  T_41_XXJ_WS_HEAVYWEAPON_D: "อาวุธหนัก",
  T_41_XXJ_WS_HELMET_D: "หมวกกันน็อคปัจจุบัน",
  T_41_XXJ_WS_HELMET1_D: "หมวกกันน็อค",
  T_41_XXJ_WS_HELMET2_D: "เอนทิตี้หมวกกันน็อค",
  T_41_XXJ_WS_HITBODYPART_D: "ส่วนของร่างกายที่ถูกโจมตี",
  T_41_XXJ_WS_HITBPDYPART: "โจมตีร่างกาย",
  T_41_XXJ_WS_HITENTITY_D: "เอนทิตี้เป้าเล็ง",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "เอนทิตี้ HUD ที่เป็นเจ้าของ",
  T_41_XXJ_WS_HUD3DCONTAINER: "คอนเทนเนอร์สามมิติ",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "คอนเทนเนอร์สามมิติ HUD เป็น HUD ที่ผู้เล่นใช้ตัวแก้ไขในการปรับแต่ง",
  T_41_XXJ_WS_HUDGRID: "ตัวควบคุมเค้าโครงที่ปรับแต่งได้ (panel)",
  T_41_XXJ_WS_HUDLAYOUT: "ตัวควบคุมเค้าโครง",
  T_41_XXJ_WS_HUDLAYOUT_D: "เอนทิตี้ที่ใส่เข้าใน HUD เป็น HUD ที่ผู้เล่นใช้ตัวแก้ไขในการปรับแต่ง",
  T_41_XXJ_WS_HUDPROFILEINFO: "การควบคุมอวาตาร์แบบกำหนดเอง",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "ข้อมูลโปรไฟล์ HUD นี่คือ HUD ที่ผู้เล่นปรับแต่งจาก Editor",
  T_41_XXJ_WS_HUDTEXTURE: "การควบคุมพื้นผิว",
  T_41_XXJ_WS_HUDTEXTURE_D: "เอนทิตี้พื้นผิว HUD เป็น HUD ที่ผู้เล่นใช้ตัวแก้ไขในการปรับแต่ง",
  T_41_XXJ_WS_HUDTRANSFORM: "องค์ประกอบ UI ในการแปลง",
  T_41_XXJ_WS_HUDTRANSFORM_D: "เอนทิตี้ UI ในการแปลงตัวควบคุม",
  T_41_XXJ_WS_IMPULSE: "โจมตี",
  T_41_XXJ_WS_IMPULSE_D: "สร้างการโจมตีที่มีความรุนแรงที่กำหนด",
  T_41_XXJ_WS_INITIALWORLDPOS: "พิกัดโลกเบื้องต้น",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "บัฟ Buff enum",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "ที่เกี่ยวข้องกับคอลัมน์ ID ในบัฟData.csv. โปรดเช็คว่าเนื้อหาใหม่สามารถเข้ากับ GPP ได้",
  T_41_XXJ_WS_INVERTFILL: "กลับด้านการเติม",
  T_41_XXJ_WS_INVERTFILL_D: "กลับด้านการเติม",
  T_41_XXJ_WS_ISLOOP: "เป็นการวนซ้ำ",
  T_41_XXJ_WS_ISLOOP_D: "ค่าตั้งต้นจะเป็นเท็จเสมอไม่ว่าจะมีการเล่นวนซ้ำหรือไม่",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "การสร้าง NavMesh แบบนิ่ง",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "ใช้เพื่อตรวจสอบการสร้าง NavMesh แบบนิ่งเมื่อดาวน์โหลดวัตถุเท่านั้น",
  T_41_XXJ_WS_ISSUCCESS_D: "ถูกทำลายหรือไม่",
  T_41_XXJ_WS_ITEMENTITY_D: "เอนทิตี้ไอเทม",
  T_41_XXJ_WS_ITEMID: "ID ของไอเทม",
  T_41_XXJ_WS_ITEMID_D: "ไอดีของไอเทม",
  T_41_XXJ_WS_ITEMID_D1: "ไอดีของไอเทมที่ถูกแนบมา",
  T_41_XXJ_WS_ITEMLIST: "รายการไอเทม",
  T_41_XXJ_WS_ITEMTYPE_D: "ประเภทไอเทม",
  T_41_XXJ_WS_JUMPATTACK: "กระโดดโจมตี",
  T_41_XXJ_WS_LANDMINE: "กับระเบิด",
  T_41_XXJ_WS_LENGTH: "ความยาวคลิป",
  T_41_XXJ_WS_LENGTH_D: "ความยาวของแถบความคืนหน้า ค่าตั้งต้นคือความยาวชอง prefab UI",
  T_41_XXJ_WS_LIMB: "แขนขา",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "ล้มเหลวในการเพิ่มไอเทมเนื่องจากไอเทมเกินขีดขำกัด",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "รายการบัฟ",
  T_41_XXJ_WS_LOOP: "เล่นวนซ้ำ",
  T_41_XXJ_WS_LOOP_D: "เล่นวนซ้ำ",
  T_41_XXJ_WS_MAXCAPACITY: "ความจุ",
  T_41_XXJ_WS_MAXCAPACITY_D: "ความจุกระเป๋า",
  T_41_XXJ_WS_MAXPROGRESS: "ความคืบหน้าสูงสุด",
  T_41_XXJ_WS_MELEEWEAPON_D: "อาวุธประชิด",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "ระยะการทำความเสียหายต่ำสุด",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "ระยะการทำความเสียหายต่ำสุด",
  T_41_XXJ_WS_MINISENTRY: "ป้อมอัตโนมัติ",
  T_41_XXJ_WS_NAME: "ชื่อ",
  T_41_XXJ_WS_NAME_D: "ชื่อของปุ่มสกิล จะถูกใช้เพื่อส่งพารามิเตอร์เวลาเกิดเหตุการณ์ OnClick ดังนั้นชื่อนี้จะต้องไม่เหมือนชื่ออื่น ๆ",
  T_41_XXJ_WS_NAME1_D: "ชื่อสินค้า",
  T_41_XXJ_WS_NAME2_D: "รายการชื่อสินค้า",
  T_41_XXJ_WS_NAME3_D: "ชื่อตู้กดอัตโนมัติ",
  T_41_XXJ_WS_NICKNAME: "ชื่อเล่น",
  T_41_XXJ_WS_NICKNAME_D: "ชื่อผู้เล่น",
  T_41_XXJ_WS_NOCHANGE: "ไม่มีการเปลี่ยนแปลง",
  T_41_XXJ_WS_NONE: "ไม่มีข้อจำกัด",
  T_41_XXJ_WS_NONE1: "ไม่มี",
  T_41_XXJ_WS_OFFSET: "Offset",
  T_41_XXJ_WS_OFFSET_D: "การชดเชย",
  T_41_XXJ_WS_OFFSET1_D: "ค่า offset",
  T_41_XXJ_WS_ONCE: "ครั้งหนึ่ง",
  T_41_XXJ_WS_ONCE_D: "ครั้งหนึ่ง",
  T_41_XXJ_WS_ONHIDE: "เมื่อปิดอินเตอร์เฟส",
  T_41_XXJ_WS_ONHIDE_D: "เมื่อปิดอินเตอร์เฟส",
  T_41_XXJ_WS_ONNODEENTER_D: "เมื่อโนดเข้ามา",
  T_41_XXJ_WS_ONSHOW: "เมื่อเปิดอินเตอร์เฟส",
  T_41_XXJ_WS_ONSHOW_D: "เมื่อเปิดอินเตอร์เฟส",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "แสดงเมื่อกล่องข้อความเปลี่ยน",
  T_41_XXJ_WS_PERSONALUAV: "โดรน",
  T_41_XXJ_WS_PINID: "พินไอดี",
  T_41_XXJ_WS_PINID_D: "พินไอดี",
  T_41_XXJ_WS_PLAYERBAG: "เอนทิตี้กระเป๋าของผู้เล่น",
  T_41_XXJ_WS_PLAYERBAG_D: "เอนทิตี้กระเป๋าของผู้เล่น",
  T_41_XXJ_WS_PLAYERBAGENTITY: "กระเป๋าของผู้เล่น",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "กระเป๋าของผู้เล่น",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "ปรับแต่งความไวในการเข้าสโคป",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "ผลกระทบของความเร็วในการเคลื่อนไหวเมื่อยิง",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "ผลกระทบของความเร็วในการเคลื่อนไหวเมื่อยิง",
  T_41_XXJ_WS_PREFABID: "Prefab ID",
  T_41_XXJ_WS_PREFABID_D: "ไอดีที่ใช้ในการอธิบาย prefab",
  T_41_XXJ_WS_PREFABID1_D: "เอนทิตี้ของรูปแบบ HUD ที่ไอดีนี้แสดง",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "อาวุธหลัก 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "อาวุธหลัก 2",
  T_41_XXJ_WS_PROFILEINFO: "โปรไฟล์ของผู้เล่น",
  T_41_XXJ_WS_PROFILEINFO_D: "ประวัติผู้เล่น",
  T_41_XXJ_WS_PROGRESSICON_D: "ไอคอนแสดงความคืบหน้า",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "ชื่อไอคอนความคืบหน้า",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "ออกจากมินิเกมมหานคร",
  T_41_XXJ_WS_RANGE: "ระยะยิง",
  T_41_XXJ_WS_RANGE_D: "ระยะการโจมตี",
  T_41_XXJ_WS_RANGE_D1: "ระยะการระเบิด",
  T_41_XXJ_WS_RANGE_D2: "ระยะป้อม",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "อ่านเนื้อหาในกระดานอันดับทั้งหมด จะคืนเป็นลำดับสองมิติ",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "อ่านเนื้อหาของ ช่อง",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "อ่านเนื้อหาในคอลัมน์ จะคืนเป็นลำดับ",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "อ่านเนื้อหาในแถว จะคืนเป็นลำดับ",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "อ่านฐานข้อมูลสะสม",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "อ่านค่าที่สอดคล้องกับ KEY ในตารางในฐานข้อมูลสะสม",
  T_41_XXJ_WS_RECOVERPLAYERHP: "ฟื้นฟู HP อย่างต่อเนื่อง",
  T_41_XXJ_WS_RELOADSPEED: "ความเร็วรีโหลด",
  T_41_XXJ_WS_RELOADSPEED_D: "ความเร็วรีโหลด(ความเร็วพื้นฐานXตัวคูณ)",
  T_41_XXJ_WS_RESOURCEID: "ทรัพยากร UUID",
  T_41_XXJ_WS_RESOURCEID_D: "ทรัพยากร UUID",
  T_41_XXJ_WS_RESUUID: "ไอดีทรัพยากร",
  T_41_XXJ_WS_RESUUID_D: "ทรัพยากร UUID ที่ถูกเลือกไปเรนเดอร์",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "ประเภทข้อจำกัดของวัตถุแข็ง",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "ข้อจำกัดแต่ละข้อถูกกำหนดโดยการทำเครื่องหมายและสามารถใช้รวมกันได้",
  T_41_XXJ_WS_ROTATION: "การหมุน",
  T_41_XXJ_WS_ROTATION_D: "การหมุนในโลกเกี่ยวข้องกัน x,y,z สื่อถึงแนวเฉียง แนวตั้ง และการหมุนตามลำดับ",
  T_41_XXJ_WS_ROTATION1_D: "การหมุน",
  T_41_XXJ_WS_RUNNING: "กำลังประมวลผล",
  T_41_XXJ_WS_SCALE: "สัดส่วน",
  T_41_XXJ_WS_SCALE_D: "สัดส่วน",
  T_41_XXJ_WS_SCALE1_D: "สัดส่วนบนแกนซึ่งสามารถรวมทั้งสามแกนได้",
  T_41_XXJ_WS_SCATTERMAX: "ระยะกระสุนกระจายสูงสุด",
  T_41_XXJ_WS_SCATTERMAX_D: "ค่าเริ่มต้นก่อนกระสุนกระจาย",
  T_41_XXJ_WS_SCATTERMOVE1: "ขยายขนาดเมื่อเคลื่อนไหว",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "ฟื้นฟูความเร็วของการกระจาย",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "ฟื้นฟูความเร็วของการกระจาย",
  T_41_XXJ_WS_SCATTERSPEED: "ความเร็วของการกระจายเพิ่ม",
  T_41_XXJ_WS_SCATTERSPEED_D: "ความเร็วของการกระจาย (0.1 = พื้นที่การเล็งใหญ่ขึ้น 10% ทุก ๆ การระเบิดเพิ่ม)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "กระสุนกระจายน้อยลงขณะนั่งหรือนอน",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "อาวุธรอง",
  T_41_XXJ_WS_SHADERNAME: "ชื่อ shader",
  T_41_XXJ_WS_SHADERNAME_D: "ชื่อ shader",
  T_41_XXJ_WS_SHIELDBROKEN: "การโจมตีโล่แตก",
  T_41_XXJ_WS_SHIELDUP: "โจมตีโล่",
  T_41_XXJ_WS_SHOCKWAVE: "คลื่นกระแทก",
  T_41_XXJ_WS_SHOWNAME: "แสดงชื่อเล่น",
  T_41_XXJ_WS_SHOWNAME_D: "แสดงชื่อเล่น",
  T_41_XXJ_WS_SHOWPIN: "แสดงเข็มกลัด",
  T_41_XXJ_WS_SHOWPIN_D: "แสดงเข็มกลัด",
  T_41_XXJ_WS_SHOWRANK: "แสดงแรงก์",
  T_41_XXJ_WS_SHOWRANK_D: "แสดงแรงก์",
  T_41_XXJ_WS_SHOWTYPE: "ออกแบบ",
  T_41_XXJ_WS_SHOWTYPE_D: "ประเภท",
  T_41_XXJ_WS_SHRINKSPEED: "ความไววงบีบ",
  T_41_XXJ_WS_SIGHTAIMASSIST: "เปิดการเล็งอัตโนมัติเมื่อสโคป",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "ระยะการเล็งอัตโนมัติ",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "ค่าตัวเลขเมื่อจัดลำดับความสำคัญของระยะทางเพื่อช่วยเล็ง (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "ระยะขั้นสูงสุดที่ต้องให้ความสำคัญสำหรับการเล็งอัตโนมัติ",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "ระยะขั้นต่ำที่ต้องให้ความสำคัญสำหรับการเล็งอัตโนมัติ",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "ให้ความสำคัญกับระยะห่างสำหรับการเล็งอัตโนมัติ",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "ปรับแต่งความแรงการเล็งอัตโนมัติ (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "ระยะการซูมของสโคป",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "ระยะการซูม",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "การหมุนเวียนสโคปตอบสนองต่อค่า coefficient",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "ปรับแต่งอัตราความเสียหายขณะเข้าสโคป",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "ตัวขยายการซูมเมื่อเข้าสโคป",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "ปรับแต่งรูปแบบการเข้าสโคป",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "ความไวในการออกสโคป",
  T_41_XXJ_WS_SPEED: "ความเร็วการกรอ",
  T_41_XXJ_WS_SPEEQUIP: "อุปกรณ์สำหรับใช้งาน",
  T_41_XXJ_WS_SPEITEM: "อุปกรณ์",
  T_41_XXJ_WS_STATICGRAPHID: "Static script ID",
  T_41_XXJ_WS_STATICGRAPHID_D: "ไอดีที่ใช้ในการอธิบาย Static script",
  T_41_XXJ_WS_STATICWAINING: "ปรับแต่งล้มเหลว",
  T_41_XXJ_WS_TARGETTREE: "เอนทิตี้ behavior tree",
  T_41_XXJ_WS_TARGETTREE_D: "เอนทิตี้ behavior tree",
  T_41_XXJ_WS_TEAMINDEX: "เลขทีม",
  T_41_XXJ_WS_TEAMINDEX_D: "ดัชนี ของทีมซึ่งตรงกับ ดัชนี ของทีมในห้อง",
  T_41_XXJ_WS_TEAMINDEX_D1: "เลขทีม",
  T_41_XXJ_WS_TEMPLATEPREFABID: "ไอดีแบบสำเร็จรูป",
  T_41_XXJ_WS_TEXT_D: "เนื้อหา",
  T_41_XXJ_WS_TEXTURENAME: "ชื่อของพื้นผิว",
  T_41_XXJ_WS_TEXTURENAME_D: "ชื่อของพื้นผิว",
  T_41_XXJ_WS_THROWATTACK: "ระเบิด",
  T_41_XXJ_WS_TICKINTERVAL: "รีเฟรชระยะ",
  T_41_XXJ_WS_TICKINTERVAL_D: "รีเฟรชระยะหากตัวเลขค่าสูง การรีเฟรชจะใช้เวลามากขึ้น",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "เปิดใช้งานอุปกรณ์พิเศษในกระเป๋าของผู้เล่น",
  T_41_XXJ_WS_UVRECTWH: "ความกว้าง&ความสูงของแสง UV",
  T_41_XXJ_WS_UVRECTWH_D: "ความกว้างและสูงของแสง UV",
  T_41_XXJ_WS_UVRECTXY: "การชดเชยแสง UV",
  T_41_XXJ_WS_UVRECTXY_D: "การชดเชยแสง UV",
  T_41_XXJ_WS_VELOCITY: "ความเร็ว",
  T_41_XXJ_WS_VELOCITY_D: "งดเปลี่ยนความเร็วของวัตถุประเภทแข็งโดยตรง คุณสามารถเปลี่ยนได้โดยการใช้ API ที่เกี่ยวข้อง",
  T_41_XXJ_WS_VEST_D: "เกราะปัจจุบัน",
  T_41_XXJ_WS_VEST1_D: "เกราะ",
  T_41_XXJ_WS_WIDGETID: "ไอดีการควบคุม",
  T_41_XXJ_WS_WIDGETID_D: "ไอดีนี้ถูกใช้เพื่ออธิบายการควบคุมในหน้า Interface ต้องจับคู่กับไอดี HUD แบบปรับแต่งเองเพื่อที่ให้สามารถทำงานกับไอดีการควบคุมได้",
  T_41_XXJ_WS_WINDATTACK: "การโจมตีพายุทอร์นาโด",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "เขียนค่า offset ในฐานข้อมูลสะสม",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "เขียน offset ที่สอดคล้องกับ KEY ในตารางในฐานข้อมูลสะสม",
  T_41_XXJ_WS_ZONEDURATION_D: "ระยะเวลาการแช่แข็ง",
  T_41_XXJ_WS_ZONEDURATION1_D: "ความทนของระเบิดกัดกร่อน",
  T_41_XXJ_WS_ZONERADIUS_D: "ระยะแช่แข็ง",
  T_41_XXJ_WS_ZONERADIUS1_D: "รัศมีระเบิดกัดกร่อน",
  T_41_XYL_WS_BOT12: "ตัวเจาะดิน",
  T_41_XYL_WS_BOT9: "ซอมบี้กลายพันธุ์ประเภทโยนของได้",
  T_41_XYL_WS_ITEM262: "แผงเหล็กแช่แข็ง A",
  T_41_XYL_WS_ITEM263: "ตู้แช่แข็ง A",
  T_41_XYL_WS_ITEM264: "ตู้เสบียงแช่แข็ง",
  T_41_XYL_WS_ITEM265: "ประตูเหล็กแช่แข็ง",
  T_41_XYL_WS_ITEM266: "ตู้แช่แข็ง B",
  T_41_XYL_WS_ITEM267: "หินแช่แข็ง A",
  T_41_XYL_WS_ITEM268: "หินแช่แข็ง B",
  T_41_XYL_WS_ITEM269: "หินแช่แข็ง C",
  T_41_XYL_WS_ITEM270: "หินแช่แข็ง D",
  T_41_XYL_WS_ITEM271: "รถใต้ดินที่ถูกทิ้ง",
  T_41_XYL_WS_MODELMATCHNAME: "การประกวดคราฟท์แลนด์",
  T_41_XYL_WS_NAVMESH: "Dynamic navmesh",
  T_41_XYL_WS_REFCUBE: "Reflective Cube",
  T_41_XYL_WS_SNOWSKY: "Frost Galaxy",
  T_41_XYL_WS_TOYCUBE: "Cube ของเล่น",
  T_42_CJ_F_B_VOCATIONAL: "Gearing Blueprint (กางเกง)",
  T_42_CJ_F_H_VOCATIONAL: "Gearing Blueprint (หัว)",
  T_42_CJ_F_S_VOCATIONAL: "Gearing Blueprint (รองเท้า)",
  T_42_CJ_F_T_VOCATIONAL: "Gearing Blueprint (เสื้อ)",
  T_42_CJ_HA_THUNDER_GOLD: "ลายเพ้นท์ Lightning",
  T_42_CJ_M_B_VOCATIONAL: "Mechanic Masterplan (กางเกง)",
  T_42_CJ_M_H_VOCATIONAL: "Mechanic Masterplan (หัว)",
  T_42_CJ_M_S_VOCATIONAL: "Mechanic Masterplan (รองเท้า)",
  T_42_CJ_M_T_VOCATIONAL: "Mechanic Masterplan (เสื้อ)",
  T_42_H_CHARACTER_SUPERTEEN_N: "อิกนิส",
  T_42_H_GLOO_EVOTIGER_N: "ไอซ์วอลล์ - Tiger's Fury",
  T_42_H_GRENADE_SMUDGE_N: "ระเบิด - Feline Shadow",
  T_42_H_M1917_EMPIRE_N: "M1917 - Crowned Conqueror",
  T_42_HJ_WS_VFX_INK: "หมึก",
  T_42_JH_WS_BANMATCHMAKING: "ไม่อนุญาตให้จับคู่ในแผนที่นี้",
  T_42_JH_WS_BANROOMCREATE: "ไม่สามารถสร้างห้องได้",
  T_42_JH_WS_FPS: "มุมมองบุคคลที่ 1",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "ปาร์ตี้รีมิกซ์ (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "เพลิงมายา (อิกนิส)",
  T_42_JH_WS_SKILLSETSANTINO: "สลับร่าง (ซานติโน่)",
  T_42_JH_WS_SKILLSETSONIA: "โล่พลังนาโน (โซเนีย)",
  T_42_JH_WS_TAG1: "Frost Brawl",
  T_42_JH_WS_TAG10: "ซิ่งไม่มีสุด",
  T_42_JH_WS_TAG11: "การแข่งรถ",
  T_42_JH_WS_TAG12: "รถแข่ง",
  T_42_JH_WS_TAG13: "ไม่นิยม",
  T_42_JH_WS_TAG14: "วอร์โซน",
  T_42_JH_WS_TAG15: "สงครามซอมบี้",
  T_42_JH_WS_TAG16: "ระดับตำนาน",
  T_42_JH_WS_TAG2: "ย่านคนชิล 1.0",
  T_42_JH_WS_TAG3: "ย่านคนชิล 2.0",
  T_42_JH_WS_TAG4: "เล่นด้วยกัน",
  T_42_JH_WS_TAG5: "เดนตายล่มสลาย",
  T_42_JH_WS_TAG6: "ปาร์ตี้ออกล่า",
  T_42_JH_WS_TAG7: "ปาร์ตี้ล่าเหยื่อ",
  T_42_JH_WS_TAG8: "ป้อมปราการ 2.0",
  T_42_JH_WS_TAG9: "ล่าเงินรางวัล",
  T_42_RW_PORTALSFORPERSONAL_DESC: "วางประตูไว้ที่ใดก็ได้แล้วเทเลพอร์ตออกไป!",
  T_42_RW_PORTALSPERSONAL_NAME: "ประตูวาร์ป",
  T_42_SJ_WS_ACCESSORIESITEM: "ติดตั้งอุปกรณ์เสริม",
  T_42_SJ_WS_AUTOPLAY: "เล่นอัตโนมัติ",
  T_42_SJ_WS_CLIMB: "ปีนขึ้นไป",
  T_42_SJ_WS_CLOCK_EVENTS: "รวมกิจกรรม",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "นับถอยหลังหรือไม่",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "วนซ้ำ",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "หยุดกิจกรรมชั่วคราว",
  T_42_SJ_WS_CLOCK_START_EVENT: "เริ่มกิจกรรม",
  T_42_SJ_WS_CLOCK_START_TIME: "เวลาเริ่มต้นนับถอยหลัง",
  T_42_SJ_WS_CLOCK_STATE: "สถานะตัวจับเวลา",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "หยุดกิจกรรม",
  T_42_SJ_WS_DAMRATIOHEAD: "การเปลี่ยนแปลงค่าตัวเลขความเสียหายการยิงหัว",
  T_42_SJ_WS_DAMRATIOLIMB: "การเปลี่ยนแปลงค่าตัวเลขความเสียหายของแขนขา",
  T_42_SJ_WS_DAMREDUCEXPLODE: "ลดค่าตัวเลขความเสียหายจากระเบิด",
  T_42_SJ_WS_DRIVE: "ขับ",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "แสดงเลเยอร์",
  T_42_SJ_WS_EXTRABAGCAPACITY: "เพิ่มความจุกระเป๋า",
  T_42_SJ_WS_EXTRAHPRATIO: "อัตราส่วน HP",
  T_42_SJ_WS_GETOFF_DRIVE: "ออกจากยานพาหนะ",
  T_42_SJ_WS_GETON_DRIVE: "ขึ้นยานพาหนะ",
  T_42_SJ_WS_KNIFEITEM: "มีด",
  T_42_SJ_WS_KNIFEITEMPICK: "มีด (หยิบจากพื้น)",
  T_42_SJ_WS_MARKBTNHUD: "ปุ่มปักหมุดบน HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "คุณสามารถเปิดหรือปิดใช้งานปุ่มปักหมุดได้",
  T_42_SJ_WS_MAXDISTANCE: "ระยะทางสูงสุด",
  T_42_SJ_WS_MAXDURARATIO: "อัตราส่วนความทนทานสูงสุด",
  T_42_SJ_WS_MICBTNHUD: "สวิตช์ไมโครโฟนบน HUD",
  T_42_SJ_WS_MICBTNHUD_D: "คุณสามารถเปิดหรือปิดใช้งานปุ่มไมโครโฟนได้",
  T_42_SJ_WS_MINDISTANCE: "ระยะทางขั้นต่ำ",
  T_42_SJ_WS_OPE_VEHICLE: "ใช้งานยานพาหนะ",
  T_42_SJ_WS_PLANE_DESC: "ตารางพื้นฐานที่ปรับขนาดได้อย่างอิสระ",
  T_42_SJ_WS_PLANENAME: "ระนาบพื้นฐาน",
  T_42_SJ_WS_PRIORITY: "ลำดับความสำคัญ",
  T_42_SJ_WS_REPLACEPRIORITY: "แทนที่ลำดับความสำคัญ",
  T_42_SJ_WS_SETBTNHUD: "ปุ่มการตั้งค่าบน HUD",
  T_42_SJ_WS_SETBTNHUD_D: "คุณสามารถเปิดหรือปิดการใช้งานปุ่มการตั้งค่า",
  T_42_SJ_WS_SIGNALBTNHUD: "ปุ่มเชื่อมต่อเครือข่ายบน HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "คุณสามารถเปิดหรือปิดใช้งานปุ่มการเชื่อมต่อเครือข่ายได้",
  T_42_SJ_WS_SPEAKERBTNHUD: "ปุ่มแตรบน HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "คุณสามารถเปิดหรือปิดใช้งานปุ่มแตรรถได้",
  T_42_SJ_WS_START_TIME: "เวลาเริ่มต้น (วินาที)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "เพิ่มความจุกระเป๋า [FFB300]{0}[-] สำหรับกระสุน ไม่รวม ปืนยิงลูกระเบิด ([FFB300]{1}[-] กระสุน AR, [FFB300]{2}[-] กระสุน SMG, [FFB300]{3}[-] กระสุนสไนเปอร์, [FFB300]{4}[-] กระสุน SG)",
  T_42_SW_SKILL_DESC_Bodyguard: "เพิ่มความเร็วในการรีโหลดขึ้น [FFB300]{0}%[-] ทุกครั้งที่ผู้ใช้สกิลโจมตีศัตรู เป้าหมายจะลดอัตราการฟื้นฟู [FFB300]{1}%[-] เป็นเวลา [FFB300]{3}วิ[-] (ลดสูงสุด: [FFB300]{2} %[-])",
  T_42_SW_SKILL_DESC_Playboy: "สกิลก่อกวนไม่มีผล (เช่น ลดความเร็ว ถูกมาร์ค ห้ามใช้สกิล) และได้รับความเร็วเคลื่อนที่เพิ่มขึ้น [FFB300]{1}%[-] เป็นเวลา [FFB300]{2}วิ[-] คูลดาวน์: [FFB300]{0}วิ[-]",
  T_42_SW_SKILL_DESC_SwatGuy: "หลังจากล้มศัตรูหรือใช้สกิลกดใช้ [FFB300]{0}%[-] ของกระสุนในแมกกาซีนจะถูกรีโหลดอัตโนมัติ",
  T_42_SW_SKILL_NAME_Playboy: "สปีดรัช",
  T_42_SY_BACKPACK_EMPIRE_N: "กระเป๋า - Crowned Roar",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "สกินคู่หู: Icy Hop",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "มอเตอร์ไบค์ - Urban Scooter",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno Nero Nemesis",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno Rosso Efesto",
  T_42_TYC_CST_LOSE_MONEY_1: "จำนวนเงิน 4V4",
  T_42_TYC_CST_LOSE_MONEY_2: "จำนวนเงิน 4V4 ที่ได้รับจากการแพ้ติดต่อกัน 2 รอบ",
  T_42_TYC_CST_LOSE_MONEY_3: "จำนวนเงิน 4V4 ที่ได้รับจากการแพ้ติดต่อกัน 3 รอบ",
  T_42_WH_ITEM_HEALUAV: "โดรนฟื้นฟู",
  T_42_WH_ITEM_HEALUAV_DESC: "ปล่อยโดรนที่บินไปข้างหน้าและฟื้นฟูพลังชีวิตให้เพื่อนร่วมทีมภายในระยะด้านล่างอย่างต่อเนื่อง",
  T_42_WH_ITEM_SKILLCARD: "สกิล: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `ใช้เพื่อใช้สกิล [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "ประเภทกระสุน",
  T_42_XXJ_WS_AMMOTYPE_D: "ประเภทกระสุน",
  T_42_XXJ_WS_ASSETCONFIGID: "ID สกิน",
  T_42_XXJ_WS_ASSETCONFIGID_D: "สกิน",
  T_42_XXJ_WS_ATTACKSTATUS: "สถานะ การโจมตี",
  T_42_XXJ_WS_AUTOPLAY: "เล่นอัตโนมัติ",
  T_42_XXJ_WS_AUTOPLAY_D: "เล่นอัตโนมัติ",
  T_42_XXJ_WS_AVATARABLE: "องค์ประกอบรูปลักษณ์ที่เปลี่ยนได้",
  T_42_XXJ_WS_AVATARABLE_D: "รูปลักษณ์เปลี่ยนไปตามส่วนต่างๆ",
  T_42_XXJ_WS_AVATARRESUUID: "UUID ทรัพยากรรูป",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "แปลงการหมุนที่แสดงด้วยมุมแกนเป็นควอเทอร์เนียน",
  T_42_XXJ_WS_B_D: "ค่าของสี B (สีฟ้า)",
  T_42_XXJ_WS_BASEVALUE_D: "ฐานของลอการิทึม",
  T_42_XXJ_WS_BEZIERCURVE: "โค้งเบซีเย",
  T_42_XXJ_WS_BEZIERCURVE_D: "โค้งเบซีเย",
  T_42_XXJ_WS_BOTDIFFICULTY: "ระดับความยากของบอท",
  T_42_XXJ_WS_BOUNCE_COMBINE: "วิธีการผสมความยืดหยุ่น",
  T_42_XXJ_WS_BOUNCINES: "ความเด้ง",
  T_42_XXJ_WS_BTREEID: "ID แผนผังพฤติกรรม",
  T_42_XXJ_WS_BTREEID_D: "ID แผนผังพฤติกรรม",
  T_42_XXJ_WS_CANPURCHAS: "สามารถซื้อได้หรือไม่",
  T_42_XXJ_WS_CANPURCHAS_D: "สามารถซื้อได้หรือไม่",
  T_42_XXJ_WS_CLIMBSTATUS: "การปีนเขา",
  T_42_XXJ_WS_CLOCK: "วัตถุตัวจับเวลา",
  T_42_XXJ_WS_CLOCK_D: "วัตถุตัวจับเวลา",
  T_42_XXJ_WS_CLOCK_D1: "ตัวจับเวลา",
  T_42_XXJ_WS_CONTAINER: "คอนเทนเนอร์",
  T_42_XXJ_WS_CONTROLPOINTS: "จุดควบคุม",
  T_42_XXJ_WS_CONTROLPOINTS_D: "จุดควบคุม",
  T_42_XXJ_WS_COROUTINEID: "ตัวจัดการโครูทีน",
  T_42_XXJ_WS_COROUTINEID_D: "หมายถึงหมายเลขอ้างอิงของ โครูทีน ซึ่งสามารถดำเนินการบางอย่างเกี่ยวกับหมายเลขอ้างอิงได้",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "สร้างความสัมพันธ์",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "สร้างความสัมพันธ์",
  T_42_XXJ_WS_CREATESOUND: "สร้างเสียงเอฟเฟ็กต์",
  T_42_XXJ_WS_CREATESOUND_D: "เล่นเอฟเฟ็กต์เสียงที่กำหนดไว้ หากต้องการตั้งค่าคุณสมบัติเพิ่มเติม คุณสามารถกำหนดค่าคุณสมบัติของ เอนทิตี้ นั้นได้",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "ทำภารกิจที่กำหนดให้สำเร็จ",
  T_42_XXJ_WS_DAMAGELIST_D: "รายการเพิ่มความเสียหาย",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "อัตราส่วนความเสียหายการยิงหัว",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "ตัวคูณการลดความเสียหายจากระเบิด",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "วัตถุดิบเริ่มต้น",
  T_42_XXJ_WS_DEFAULTFIST_D: "หมัดเริ่มต้น",
  T_42_XXJ_WS_DELTA: "เดลต้า",
  T_42_XXJ_WS_DELTA_D: "เดลต้า",
  T_42_XXJ_WS_DELTATIME: "ความหน่วงเฟรม",
  T_42_XXJ_WS_DELTATIME_D: "GS สองช่วงเวลาการอัปเดตลอจิคเฟรม",
  T_42_XXJ_WS_DEPTH: "เลเยอร์",
  T_42_XXJ_WS_DEPTH_D: "แสดงเลเยอร์บนไอคอน",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "รายการไอเทมบนพื้นทีที่ถูกปิดใช้งาน",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "รายการไอเทมที่ไม่ได้เก็บจากพื้น",
  T_42_XXJ_WS_DRIVER: "ที่นั่งคนขับ",
  T_42_XXJ_WS_DRIVINGSTATUS: "ขับ",
  T_42_XXJ_WS_DURATION_D1: "ระยะเวลานับถอยหลังเป็นวินาที",
  T_42_XXJ_WS_DURATION_D2: "ระยะเวลาเป็นวินาที",
  T_42_XXJ_WS_DURATION_D3: "ระยะเวลา",
  T_42_XXJ_WS_DURATION_D4: "ระยะเวลาอมตะเป็นวินาที",
  T_42_XXJ_WS_DURATIONTIMES: "ระยะเวลา",
  T_42_XXJ_WS_DURATIONTIMES_D: "ระยะเวลาเป็นวินาที",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "แรงเสียดทานแบบไดนามิก",
  T_42_XXJ_WS_EASY: "ง่ายมาก",
  T_42_XXJ_WS_ENDTIMES: "เวลาจบ",
  T_42_XXJ_WS_ENDTIMES_D: "เวลาสิ้นสุดการนับถอยหลัง หน่วยเป็นวินาที",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "เกณฑ์พลังงานสากล",
  T_42_XXJ_WS_ENTITYVARNAME_D: "เอนทิตี้ที่สัมพันธ์กัน",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "ติดตั้งอุปกรณ์เสริม",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "แปลงมุมออยเลอร์ที่กำหนดให้เป็นควอเทอร์เนียน",
  T_42_XXJ_WS_EXPONENTIATION_D: "การยกกำลัง",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "เพิ่มความจุกระเป๋า",
  T_42_XXJ_WS_FIST: "หมัด",
  T_42_XXJ_WS_FONTTYPE: "อักษร enum",
  T_42_XXJ_WS_FONTTYPE_D: "อักษร enum",
  T_42_XXJ_WS_FORCESYNCVALUE: "บังคับให้ซิงค์สถานะ",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "ค่าการบังคับซิงค์",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "GS บังคับให้ซิงค์ข้อมูลตำแหน่ง",
  T_42_XXJ_WS_FORCESYNCVALUE1: "ข้อมูลตำแหน่งจากการซิงค์แบบบังคับ",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "เอนทิตี้ที่สามารถกำหนดคุณสมบัติได้",
  T_42_XXJ_WS_FORWARD_D: "เวกเตอร์บอกทิศทาง",
  T_42_XXJ_WS_FRICTION_COMBINE: "วิธีรวมแรงเสียดทาน",
  T_42_XXJ_WS_FUNCPOINT: "ตัวชี้ฟังก์ชัน",
  T_42_XXJ_WS_FUNCPOINT_D: "ตัวชี้ที่ชี้ไปที่ตัวอย่างของฟังก์ชัน ถูกใช้เพื่อใช้ฟังก์ชันเสมือนหรือกลไกการมอบหมาย",
  T_42_XXJ_WS_GETMAPID_D: "รับ ID แผนที่",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "ออกจากยานพาหนะ",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "ขึ้นยานพาหนะ (คนขับ)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "ขึ้นยานพาหนะ (ผู้โดยสาร)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "ค้นหาข้อมูลโทเคนของผู้เล่นในปัจจุบัน",
  T_42_XXJ_WS_GRAVITY: "แรงโน้มถ่วงของโลก",
  T_42_XXJ_WS_HANDHELDITEM: "รายการที่ถืออยู่ในปัจจุบัน",
  T_42_XXJ_WS_HANDHELDITEM_D: "รายการที่ถืออยู่ในปัจจุบัน",
  T_42_XXJ_WS_HARD: "ยาก",
  T_42_XXJ_WS_HASCOMPONENT_D: "ไม่ว่าจะมีองค์ประกอบอยู่หรือไม่",
  T_42_XXJ_WS_HEIGHTLIST_D: "รายการเพิ่มความสูง",
  T_42_XXJ_WS_INDEXLIST_D: "เข้าถึงรายการดัชนีของคำ",
  T_42_XXJ_WS_INSCENE: "ในฉาก",
  T_42_XXJ_WS_INSCENE_D: "ในฉาก",
  T_42_XXJ_WS_IS3D_D: "ไม่ว่าจะเป็นเพลงสามมิติ",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "นับถอยหลังหรือหยุดเวลา",
  T_42_XXJ_WS_ISLOOP: "วนซ้ำหรือไม่",
  T_42_XXJ_WS_ISLOOP_D: "คำสั่ง IsLoop",
  T_42_XXJ_WS_ISREPLAY_D: "ไม่ว่าจะเริ่มต้นใหม่หรือไม่ก็ตาม",
  T_42_XXJ_WS_ISSWITCH_D: "เมื่อตั้งค่าเป็นจริง จะสามารถรวมกับการเคลื่อนไหวสัมพัทธ์ได้ เมื่อตั้งค่าเป็นเท็จ จะสามารถรวมกับการเคลื่อนไหวแบบสัมบูรณ์ได้",
  T_42_XXJ_WS_JEEP: "รถจิ๊ป",
  T_42_XXJ_WS_JUMPSTATUS: "สถานะการกระโดด",
  T_42_XXJ_WS_LEFTVALUE: "ค่าทางซ้าย",
  T_42_XXJ_WS_LEFTVALUE_D: "ฐาน",
  T_42_XXJ_WS_LOGARITHM_D: "ลอการิทึม",
  T_42_XXJ_WS_LOOPABLE: "วนซ้ำได้",
  T_42_XXJ_WS_LOOPABLE_D: "ทำซ้ำได้",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "รับคีย์ทั้งหมดจากพจนานุกรม",
  T_42_XXJ_WS_MAPVALUE_D: "พจนานุกรมเป้าหมาย",
  T_42_XXJ_WS_MARKBTNHUD: "ปุ่มปักหมุดบน HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "ระยะทางสูงสุด",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "สวิตช์ไมโครโฟนบน HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "ระยะทางขั้นต่ำ",
  T_42_XXJ_WS_MISSIONID_D: "ID ภารกิจ",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "ความคืบหน้า (ไม่เป็นจำนวนลบ)",
  T_42_XXJ_WS_MODERATE: "ปานกลาง",
  T_42_XXJ_WS_MONSTERTRUCK: "รถบิ๊กฟุต",
  T_42_XXJ_WS_MOTORBIKE: "มอไซค์",
  T_42_XXJ_WS_MOVEMENTSTATUS: "สถานะการเคลื่อนที่",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "การคูณควอเทอร์เนียนสองตัว (แทนการซ้อนทับการหมุน)",
  T_42_XXJ_WS_NORMAL: "ปกติ",
  T_42_XXJ_WS_OBSOLETE: "ทิ้ง",
  T_42_XXJ_WS_OPENPLAYERVIEW: "เปิดใช้งานมุมมองของผู้เล่น",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "เปิดใช้งานมุมมองของผู้เล่น",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "ประเภทอาวุธ",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "ประเภทอาวุธ",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "การกำหนดค่าผู้เล่นตามลำดับ",
  T_42_XXJ_WS_PARAMSARRAY: "พารามิเตอร์ อาร์เรย์",
  T_42_XXJ_WS_PARAMSARRAY_D: "พารามิเตอร์ อาร์เรย์คือรายการของพารามิเตอร์ที่เกี่ยวข้องในการแสดงผล จะต้องสอดคล้องกับจำนวน %v ในคำอธิบายรูปแบบ",
  T_42_XXJ_WS_PARAMSARRAY_D1: "รายการพารามิเตอร์จริงที่ส่งไปยังฟังก์ชันที่กำหนดเอง",
  T_42_XXJ_WS_PARTVISABLEMASK1: "หน้ากากมองเห็นส่วน 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "หน้ากากมองเห็นส่วน 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "หน้ากากมองเห็นส่วน 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "หน้ากากมองเห็นส่วน 4",
  T_42_XXJ_WS_PASSENGER1: "ที่นั่งผู้โดยสาร 1",
  T_42_XXJ_WS_PASSENGER2: "ที่นั่งผู้โดยสาร 2",
  T_42_XXJ_WS_PASSENGER3: "ที่นั่งผู้โดยสาร 3",
  T_42_XXJ_WS_PHYMAT: "วัสดุทางกายภาพ",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "เอนทิตี้",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "การเคลื่อนไหวสัมพันธ์กันในแต่ละเฟรม",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "การเคลื่อนไหวแบบสัมพันธ์กันทุกเฟรม",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "การเคลื่อนไหวด้วยตนเอง",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "การเคลื่อนไหวสัมพัทธ์ตนเอง",
  T_42_XXJ_WS_PLAYER_D: "ผู้เล่นต้องขึ้นยานพาหนะ",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "การซิงค์คุณสมบัติพฤติกรรมผู้เล่น",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "เอนทิตี้ของการซิงค์คุณสมบัติพฤติกรรมของผู้เล่น",
  T_42_XXJ_WS_PRIORITY_D: "ลำดับความสำคัญ",
  T_42_XXJ_WS_PROPID_D: "ID คุณสมบัติ",
  T_42_XXJ_WS_QUATERNION: "ควอเทอร์เนียน",
  T_42_XXJ_WS_QUATERNION_D: "ควอเทอร์เนียนเป็นเวกเตอร์สี่มิติพิเศษที่ใช้เพื่อแสดงการหมุนเท่านั้น",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "แปลงควอเทอร์เนียนที่กำหนดให้เป็นการแสดงมุมแกน",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "แปลงค่าควอเทอร์เนียนที่กำหนดให้เป็นมุมออยเลอร์ หากค่าควอเทอร์เนียนไม่เป็นไปตามมาตรฐาน กลับเป็น (0,0,0)",
  T_42_XXJ_WS_REPEATTIMES_D: "จำนวนครั้งที่เล่น ค่าเริ่มต้นคือ 1",
  T_42_XXJ_WS_RESETPLAYABLE_D: "รีเซต",
  T_42_XXJ_WS_RIGHTVALUE: "ค่าทางขวา",
  T_42_XXJ_WS_RIGHTVALUE_D: "กำลัง",
  T_42_XXJ_WS_SEATTYPE: "ที่นั่ง enum",
  T_42_XXJ_WS_SEPSTR_D: "คำที่ใช้ในการแยก",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "ตั้งค่าความเสียหายจากการตกของผู้เล่น",
  T_42_XXJ_WS_SETTINGSBTNHUD: "ปุ่มการตั้งค่าบน HUD",
  T_42_XXJ_WS_SHOWPOSITION: "แสดงตำแหน่ง",
  T_42_XXJ_WS_SHOWPOSITION_D: "แสดงตำแหน่ง",
  T_42_XXJ_WS_SIGNALICOHUD: "ปุ่มเชื่อมต่อเครือข่ายบน HUD",
  T_42_XXJ_WS_SIMPLE: "ง่าย",
  T_42_XXJ_WS_SLERPQUATERNION_D: "การประมาณค่าควอเทอร์เนียนทรงกลมจาก A ถึง B",
  T_42_XXJ_WS_SOUNDENTITY_D: "เอนทิตี้เอฟเฟ็กต์เสียงแสดงถึงเอฟเฟ็กต์เสียงที่กำลังเล่น",
  T_42_XXJ_WS_SPEAKERBTNHUD: "ปุ่มแตรบน HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "ใช้คำบางคำเป็นตัวคั่นเพื่อแยกเป็นคำๆออกมา",
  T_42_XXJ_WS_SPORTSCAR: "รถสปอร์ต",
  T_42_XXJ_WS_SPRINTSTATUS: "สถานะ การวิ่ง",
  T_42_XXJ_WS_SRCVAL_D: "มูลค่าแหล่งที่มา",
  T_42_XXJ_WS_STARTTICKCOUNT: "ช่วงเวลาที่ GS เริ่มเดิน",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "ช่วงเวลาที่ GS เริ่มเดิน",
  T_42_XXJ_WS_STARTTIME_D: "เวลาเริ่มต้น",
  T_42_XXJ_WS_STARTTIME_D1: "เวลาเริ่มต้น",
  T_42_XXJ_WS_STATE_D: "สถานะของผู้เล่น: ยังอยู่, ล้ม หรือถูกกำจัด",
  T_42_XXJ_WS_STATE_D1: "ตรวจสอบว่าเสียงเอฟเฟ็กต์นี้กำลังเล่นอยู่หรือไม่",
  T_42_XXJ_WS_STATIC_FRICTION: "แรงเสียดทานสถิต",
  T_42_XXJ_WS_STRELEMS_D: "ตั้งค่าคำเป้าหมาย",
  T_42_XXJ_WS_STRINGFINDAT_D: "รวมคำสุดท้ายกลับคืนตามรายการดัชนี",
  T_42_XXJ_WS_STRINGJOIN_D: "รวมคำโดยใช้ตัวระบุที่ระบุไว้",
  T_42_XXJ_WS_STRINGLOWER_D: "แปลงตัวอักษรทั้งหมดเป็นตัวพิมพ์เล็ก",
  T_42_XXJ_WS_STRINGSTRIP_D: "ลบช่องว่างออกทั้งสองด้านของคำ",
  T_42_XXJ_WS_STRINGUPPER_D: "แปลงตัวอักษรทั้งหมดเป็นตัวพิมพ์ใหญ่",
  T_42_XXJ_WS_STYLE_D: "วิธีการเล่น",
  T_42_XXJ_WS_SUV: "รถกระบะ",
  T_42_XXJ_WS_SWITCH: "สลับ",
  T_42_XXJ_WS_SWITCH_D: "เมื่อตั้งค่าเป็นจริง จะสามารถรวมกับการเคลื่อนไหวสัมพัทธ์ได้ เมื่อตั้งค่าเป็นเท็จ จะต้องรวมกับการเคลื่อนไหวแบบสัมบูรณ์ ไม่เช่นนั้นคุณสมบัติจะไม่มีผลเมื่อใช้งานไม่ถูกต้อง",
  T_42_XXJ_WS_TARGETENTITY_D: "เอนทิตี้เป้าหมาย",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "แบนเนอร์คะแนนรอบทีม",
  T_42_XXJ_WS_TEAMSEQ_D: "เลขซีเรียลของทีมที่สอดคล้องกับคุณสมบัติเลขซีเรียลของเอนทิตี้ในทีม",
  T_42_XXJ_WS_TEMPORARYSHIELD: "โล่ชั่วคราว",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "โล่ชั่วคราว",
  T_42_XXJ_WS_TEXT_D: "ข้อความเริ่มต้นที่จะใช้กรองคำหยาบคาย",
  T_42_XXJ_WS_THREESTATESWITCH: "สวิตช์ 3 สถานะ",
  T_42_XXJ_WS_THROWINGKNIFE_D: "มีด (หยิบจากพื้น)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "มีด",
  T_42_XXJ_WS_TUKTUK: "รถตุ๊กตุ๊ก",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "รายละเอียดทีมแข่ง",
  T_42_XXJ_WS_UNIQUEID: "ID ไม่ซ้ำกัน",
  T_42_XXJ_WS_UNIQUEID_D: "ID ไม่ซ้ำกัน",
  T_42_XXJ_WS_VALUE_D: "ค่า",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "เวกเตอร์บอกทิศทางเป็นมุมออยเลอร์",
  T_42_XXJ_WS_VEHICLEID: "ID พาหนะ",
  T_42_XXJ_WS_VEHICLESKINID: "ID สกินยานพาหนะ",
  T_42_XXJ_WS_VERYHARD: "ยากมาก",
  T_42_XXJ_WS_VOLUME_D: "ระดับเสียง ค่าเริ่มต้นคือ 50",
  T_42_XXJ_WS_WEAPONTYPE_D: "ประเภทหลักของอาวุธ",
  T_42_XXJ_WS_WORKSHOPCODE: "รหัสแผนที่",
  T_42_XXJ_WS_WORKSHOPCODE_D: "รหัสแผนที่ที่สอดคล้องกับข้อมูลในฐานข้อมูล",
  T_42_XXJ_WS_WORLDPOSITION: "พิกัดโลก",
  T_42_XXJ_WS_WORLDPOSITION_D: "พิกัดโลก",
  T_42_XYL_WS_ITEM275: "ถังน้ำมัน",
  T_42_XYL_WS_ITEM276: "กระสอบทราย A",
  T_42_XYL_WS_ITEM277: "กระสอบทราย B",
  T_42_XYL_WS_ITEM278: "กระสอบทราย C",
  T_42_XYL_WS_ITEM279: "กระสอบทราย",
  T_42_XYL_WS_ITEM280: "Double Deck Villa",
  T_42_XYL_WS_ITEM281: "โรงงานอาวุธ",
  T_42_XYL_WS_ITEM282: "Stone Wall A",
  T_42_XYL_WS_ITEM283: "กำแพงหิน B",
  T_42_XYL_WS_ITEM284: "Stone Wall C",
  T_42_XYL_WS_ITEM285: "Stone Wall D",
  T_42_XYL_WS_ITEM286: "กล่องเสบียงทหาร A",
  T_42_XYL_WS_ITEM287: "เหรียญทองแดง",
  T_42_XYL_WS_ITEM288: "เหรียญเงิน",
  T_42_XYL_WS_ITEM289: "เหรียญทอง",
  T_42_XYL_WS_ITEM290: "เพชร",
  T_42_XYL_WS_ITEM291: "เศษเพชร",
  T_42_XYL_WS_ITEM292: "ทับทิม",
  T_42_XYL_WS_ITEM293: "มรกต",
  T_42_XYL_WS_ITEM294: "ไพลิน",
  T_42_XYL_WS_ITEM295: "ป้ายเตือน",
  T_42_XYL_WS_ITEM297: "ซากปรักหักพัง",
  T_42_XYL_WS_ITEM297TRUE: "อุปกรณ์ควบคุม",
  T_42_XYL_WS_ITEM298: "Supply Container B",
  T_42_XYL_WS_ITEM299: "Snow Pile",
  T_42_XYL_WS_ITEM300: "กำแพงไฮเทค A",
  T_42_XYL_WS_ITEM301: "กำแพงไฮเทค B",
  T_42_XYL_WS_ITEM302: "หินแช่แข็ง F",
  T_42_XYL_WS_ITEM303: "หินแช่แข็ง E",
  T_42_XYL_WS_ITEM304: "แพลตฟอร์มไฮเทค A",
  T_42_XYL_WS_ITEM305: "บันไดไฮเทค A",
  T_42_XYL_WS_ITEM306: "Exploration Lamp A",
  T_42_XYL_WS_ITEM307: "Ruin Baffle A",
  T_42_XYL_WS_ITEM308: "Ruin Baffle B",
  T_42_XYL_WS_ITEM309: "Ruin Steel Bracket A",
  T_42_XYL_WS_ITEM310: "Ruin Stone A",
  T_42_XYL_WS_ITEM311: "Ruin Stone B",
  T_42_XYL_WS_ITEM312: "Ruin Stone C",
  T_42_XYL_WS_ITEM313: "Flashlight A",
  T_42_XYL_WS_ITEM314: "Ruin Rebar A",
  T_42_XYL_WS_LOGICALOBJECT: "ตรรกะ",
  T_42_XYL_WS_THEMEHIGHTECH: "ไฮเทค",
  T_42_XYL_WS_THEMEICE: "น้ำแข็ง",
  T_42_XYL_WS_THEMEMILITARY: "ทหาร",
  T_42_XYL_WS_THEMEOBJECTS: "วัตถุธีม",
  T_42_XYL_WS_TIMERCONTINUE: "เวลาเดินต่อ",
  T_42_XYL_WS_TIMERCYCLE: "จำนวนวนซ้ำ",
  T_42_XYL_WS_TIMERDOWN: "นับถอยหลัง",
  T_42_XYL_WS_TIMEREND: "ยุติความสัมพันธ์",
  T_42_XYL_WS_TIMEREVENT: "กำหนดเอง",
  T_42_XYL_WS_TIMEREVENT1: "ควบคุมตัวจับเวลา",
  T_42_XYL_WS_TIMEREVENT2: "ตั้งค่าตัวจับเวลา",
  T_42_XYL_WS_TIMERORDER: "วิธีการกำหนดเวลา",
  T_42_XYL_WS_TIMERPAUSE: "หยุดเวลาชั่วคราว",
  T_42_XYL_WS_TIMERSTART1: "เวลาเริ่ม",
  T_42_XYL_WS_TIMERSTART2: "เริ่มจับเวลา",
  T_42_XYL_WS_TIMERUP: "นับขึ้น",
  T_42_XYL_WS_TRIGGERTIME_MS: "แสดงเวลา (เป็นมิลลิวินาที)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "สกายวิงที่สามารถขึ้นได้หลายคน",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "คะแนนรายคน",
  T_42_ZZ_GUILDWAR_SCORE: "คะแนน",
  T_43_B_SKILL_DESC_MONKEYGOD: "แปลงร่างเป็นพุ่มไม้เป็นเวลา [FFB300]{1}วินาที[-] . คูลดาวน์: [FFB300]{0}วินาที[-]. การโจมตีผู้อื่นหรือถูกโจมตีจะทำให้หงอคงกลับสู่สภาพเดิม คูลดาวน์จะรีเซตเมื่อกำจัดศัตรูได้",
  T_43_B_SKILL_DESC_Nanoscientist: "เมื่อได้รับความเสียหายร้ายแรง จะเข้าสู่สถานะอมตะและไม่สามารถเคลื่อนที่ได้เป็นเวลา [FFB300]{0}วิ[-] จากนั้นจะได้รับโล่ป้องกัน [FFB300]{1} หน่วย[-] เป็นเวลา [FFB300]{2} วิ[-] ผู้ใช้สกิลจะถูกสังหารเมื่อโล่หายไป คูลดาวน์: [FFB300]{3}วิ[-]",
  T_43_B_SKILL_DESC_ORION: "EP จะถูกแทนที่ด้วย [FFB300]{0} พลังโลหิตอาฆาต[-] ใช้ [FFB300]{1} พลังโลหิตอาฆาต[-] เพื่อเปิดใช้การป้องกัน ทำให้คุณไม่ได้รับความเสียหายหรือโจมตีศัตรู และจะดูด [FFB300]{4} HP[-] (โดยไม่สนใจค่าโล่ของศัตรู) จากศัตรูที่อยู่ในระยะ [FFB300]{3}ม.[-] เป็นเวลา [FFB300]{2}วิ[-] และความเร็วในการเคลื่อนที่ของคุณจะลดลง [FFB300]{6}%[-] คูลดาวน์: [FFB300]{5}วิ[-]",
  T_43_CJ_F_A_RACER: "Velocity Racer (หน้ากาก)",
  T_43_CJ_F_B_RACER: "Velocity Racer (กางเกง)",
  T_43_CJ_F_H_RACER: "Velocity Racer (หัว)",
  T_43_CJ_F_HA_RACER: "Velocity Racer (ลายเพ้นท์)",
  T_43_CJ_F_S_RACER: "Velocity Racer (รองเท้า)",
  T_43_CJ_F_T_RACER: "Velocity Racer (เสื้อ)",
  T_43_CJ_M_A_RACER: "Turbo Racer (หน้ากาก)",
  T_43_CJ_M_B_MACHINERY: "Turquoise Tech (กางเกง)",
  T_43_CJ_M_B_RACER: "Turbo Racer (กางเกง)",
  T_43_CJ_M_H_MACHINERY: "Turquoise Tech (หัว)",
  T_43_CJ_M_H_RACER: "Turbo Racer (หัว)",
  T_43_CJ_M_HA_MACHINERY: "Turquoise Tech (ลายเพ้นท์)",
  T_43_CJ_M_S_MACHINERY: "Turquoise Tech (รองเท้า)",
  T_43_CJ_M_S_RACER: "Turbo Racer (รองเท้า)",
  T_43_CJ_M_T_MACHINERY: "Turquoise Tech (เสื้อ)",
  T_43_CJ_M_T_RACER: "Turbo Racer (เสื้อ)",
  T_43_H_CHARACTER_GEEK_N: "ไรเดน",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Mamba Gnaw",
  T_43_HJ_WS_OPTION8: "อื่น ๆ",
  T_43_HJ_WS_TEXTURE_BAMBOO: "ไม้ไผ่",
  T_43_HJ_WS_TEXTURE_BEACH: "ชายหาด",
  T_43_HJ_WS_TEXTURE_BRICK1: "กำแพงอิฐ A",
  T_43_HJ_WS_TEXTURE_BRICK2: "กำแพงอิฐ B",
  T_43_HJ_WS_TEXTURE_BRICK3: "กำแพงอิฐ C",
  T_43_HJ_WS_TEXTURE_CEMENT: "พื้นคอนกรีต",
  T_43_HJ_WS_TEXTURE_CEMENT2: "คอนกรีต",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "คริสตัล",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "หญ้า A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "หญ้า B",
  T_43_HJ_WS_TEXTURE_ICE: "บล็อกน้ำแข็ง",
  T_43_HJ_WS_TEXTURE_IRON: "พื้นโลหะ",
  T_43_HJ_WS_TEXTURE_IRON2: "คอนเทนเนอร์",
  T_43_HJ_WS_TEXTURE_LAVA: "ลาวา",
  T_43_HJ_WS_TEXTURE_MARBLE: "พื้นหินอ่อน",
  T_43_HJ_WS_TEXTURE_NONE: "ว่างเปล่า",
  T_43_HJ_WS_TEXTURE_STONE: "หิน",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "ผ้าปูโต๊ะ A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "ผ้าปูโต๊ะ B",
  T_43_HJ_WS_TEXTURE_WOOD: "ไม้",
  T_43_HJ_WS_TEXTURE_WOODEN: "พื้นไม้ A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "พื้นไม้ B",
  T_43_JH_WS_MAPTAG1: "เป็นมิตรกับผู้เล่นใหม่",
  T_43_JH_WS_MAPTAG10: "เนื้อหาใหม่ที่น่าเบื่อ",
  T_43_JH_WS_MAPTAG11: "รางวัลมีน้อยเกินไป",
  T_43_JH_WS_MAPTAG12: "รางวัลไม่สมดุล",
  T_43_JH_WS_MAPTAG13: "ความคืบหน้าไม่ชัดเจน",
  T_43_JH_WS_MAPTAG14: "ไม่เป็นมิตรกับผู้เล่นใหม่",
  T_43_JH_WS_MAPTAG15: "บทช่วยสอนที่สับสน",
  T_43_JH_WS_MAPTAG16: "ขาดบทช่วยสอน",
  T_43_JH_WS_MAPTAG17: "ผู้เล่นหลายคนเลิกเล่น",
  T_43_JH_WS_MAPTAG18: "การควบคุมที่ซับซ้อน",
  T_43_JH_WS_MAPTAG19: "UI ยุ่งเหยิง",
  T_43_JH_WS_MAPTAG2: "เนื้อหาใหม่ที่น่าตื่นเต้น",
  T_43_JH_WS_MAPTAG20: "การออกแบบแผนที่แย่",
  T_43_JH_WS_MAPTAG21: "เกมยิงสุดตื่นเต้น",
  T_43_JH_WS_MAPTAG22: "รวดเร็ว ฉับไว",
  T_43_JH_WS_MAPTAG23: "ผจญภัยในโลกกว้าง",
  T_43_JH_WS_MAPTAG24: "เนื้อหาเข้มข้น",
  T_43_JH_WS_MAPTAG25: "ความคืบหน้า",
  T_43_JH_WS_MAPTAG26: "จำลองกีฬา",
  T_43_JH_WS_MAPTAG27: "ภารกิจ Co-op",
  T_43_JH_WS_MAPTAG28: "สังคม/พูดคุย",
  T_43_JH_WS_MAPTAG29: "ด่านหลายรูปแบบ",
  T_43_JH_WS_MAPTAG3: "ผู้เล่นที่เล่นอยู่",
  T_43_JH_WS_MAPTAG30: "อิสระในการสำรวจ",
  T_43_JH_WS_MAPTAG31: "ท้าทายจัดอันดับ",
  T_43_JH_WS_MAPTAG32: "เก็บความสำเร็จ",
  T_43_JH_WS_MAPTAG33: "แลกสกุลเงิน",
  T_43_JH_WS_MAPTAG4: "แผนที่ที่ออกแบบมาอย่างดี",
  T_43_JH_WS_MAPTAG40: "รางวัลมากมาย",
  T_43_JH_WS_MAPTAG41: "ความคืบหน้าที่น่าพอใจ",
  T_43_JH_WS_MAPTAG42: "โซนฟรีสไตล์ยอดนิยม",
  T_43_JH_WS_MAPTAG43: "Solo Tower ยอดนิยม",
  T_43_JH_WS_MAPTAG44: "War Zone ยอดนิยม",
  T_43_JH_WS_MAPTAG5: "ไม่เสถียร",
  T_43_JH_WS_MAPTAG6: "Co-op แบบยาก",
  T_43_JH_WS_MAPTAG7: "ข้อผิดพลาด",
  T_43_JH_WS_MAPTAG8: "อัปเดตเล็กน้อย",
  T_43_JH_WS_MAPTAG9: "กิจกรรมแมตช์ที่น่าเบื่อ",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "แมงมุมจักรกล (ไรเดน)",
  T_43_SJ_WS_AIRDROP_ITEMS: "ปล่อยไอเทม",
  T_43_SJ_WS_AIRDROP_NAME: "แอร์ดรอป",
  T_43_SJ_WS_AIRDROP_TIME: "เวลาเริ่มต้น",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "ปล่อยไอเทม",
  T_43_SJ_WS_ANITRIGGER_AUTO: "เล่นอัตโนมัติ",
  T_43_SJ_WS_ANITRIGGER_CENTER: "จุดตรงกลาง",
  T_43_SJ_WS_ANITRIGGER_CLIP: "ID คลิปแอนิเมชัน",
  T_43_SJ_WS_ANITRIGGER_LOOP: "วนซ้ำ",
  T_43_SJ_WS_ANITRIGGER_NAME: "HUD เปิดใช้งานแอนิเมชันส่วนประกอบ",
  T_43_SJ_WS_RESET_ROUND: "รีเซตหลังจากแต่ละรอบ",
  T_43_SJ_WS_START_DROPTIME: "เวลาเริ่มต้นการดรอป (มิลลิวินาที)",
  T_43_SJ_WS_TRIGGER_ANIMA: "เปิดใช้งานแอนิเมชัน",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "สกินคู่หู: เมี๊ยว เมี๊ยว ซาซิล",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "มอเตอร์ไบค์ - Incarnational Speed",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "ประกอบด้วยไอเทมที่จำเป็น เช่น กระสุนและกล่องพยาบาล",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "กล่องเสบียง",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "สร้างร่างปลอม [FFB300]HP {1}[-] เคลื่อนที่อัตโนมัติเป็นเวลา [FFB300]{0}วิ[-] เมื่อร่างปลอมอยู่ในระยะ [FFB300]{3}ม.[-] กดใช้สกิลอีกครั้งเพื่อสลับตำแหน่ง คุณสามารถสลับตำแหน่งได้เพียงครั้งเดียวภายใน [FFB300]{4}วิ[-] สูงสุด [FFB300]{2} ครั้ง[-] ผู้เล่นที่ทำลายร่างปลอมจะถูกทำเครื่องหมาย [FFB300]{5}วิ[-] คูลดาวน์: [FFB300]{6}วิ[-]",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "สกิลกดใช้",
  T_43_XXJ_WS_AIRDROP: "แอร์ดรอปและซอมบี้",
  T_43_XXJ_WS_ALPHA: "Alpha",
  T_43_XXJ_WS_ALPHA_D: "ความโปร่งใสโดยรวมของ HUD โดยมีช่วงตั้งแต่ 0 ถึง 1",
  T_43_XXJ_WS_ANIMATIONCTRLID: "ID ตัวควบคุมแอนิเมชัน",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "ID ที่ใช้อธิบายเนื้อหาตัวควบคุมแอนิเมชัน",
  T_43_XXJ_WS_AUDIOID: "ID เสียง",
  T_43_XXJ_WS_AUDIOID_D: "ID ที่ใช้อธิบายเนื้อหาเสียง",
  T_43_XXJ_WS_BACKGRCOLOR: "สีพื้นหลัง",
  T_43_XXJ_WS_BACKGRCOLOR_D: "สีของแถบเลือดและพื้นหลังเบลอ",
  T_43_XXJ_WS_BURNING: "การเผาไหม้",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "ID ที่ใช้อธิบายเนื้อหาตารางการกำหนดค่า",
  T_43_XXJ_WS_CURRENTHP: "HP ปัจจุบัน",
  T_43_XXJ_WS_CURRENTHP_D: "ค่า HP ปัจจุบัน",
  T_43_XXJ_WS_DAMAGEMAKER_D: "เอนทิตี้เกมที่สร้างความเสียหาย",
  T_43_XXJ_WS_DAMAGEZONE: "พื้นที่ความเสียหาย",
  T_43_XXJ_WS_DEFAULT: "ค่าเริ่มต้น",
  T_43_XXJ_WS_DEFAULT_D: "ค่าเริ่มต้น",
  T_43_XXJ_WS_EFFECTID: "ID เอฟเฟ็กต์",
  T_43_XXJ_WS_EFFECTID_D: "ID ที่ใช้อธิบายเนื้อหาเอฟเฟ็กต์พิเศษ",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "เอนทิตี้ที่สามารถต่อสู้ได้ (เช่น เปิดการโจมตี ถูกโจมตี หรือถูกสังหาร)",
  T_43_XXJ_WS_FOLLOWTARGET: "ติดตามเป้าหมาย",
  T_43_XXJ_WS_FOLLOWTARGET_D: "ต้องติดตามเอนทิตี้ที่มีองค์ประกอบที่มีการแปลง",
  T_43_XXJ_WS_GAINHPCOLOR: "ได้รับสี HP",
  T_43_XXJ_WS_GAINHPCOLOR_D: "HP ที่เพิ่มขึ้นจะแสดงเป็นสีนี้ในช่วงเวลาสั้นๆ",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "ไม่มีความเสียหายจากการตกใช่หรือไม่",
  T_43_XXJ_WS_ISOPENTWEEN: "เปิด Tween ใช่หรือไม่?",
  T_43_XXJ_WS_ISOPENTWEEN_D: "เปิดใช้งานเพื่อแสดงการเปลี่ยนแปลงของ HP ในสีที่แตกต่าง",
  T_43_XXJ_WS_KNOCKDOWN_D1: "ผู้เล่นอยู่ในสถานะล้ม",
  T_43_XXJ_WS_KNOCKDOWN_D2: "การตั้งค่าสำหรับการตอบสนองต่อสถานะล้มเมื่อถูกสังหาร",
  T_43_XXJ_WS_KNOCKDOWN_D3: "ประเภทแหล่งที่มาของการชุบชีวิต ผู้เล่นสามารถชุบชีวิตได้ในขณะที่ล้ม",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "สถานะการล้ม",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "ประเภทสถานะการล้ม",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "การตอบสนองต่อสถานะล้ม: คงตรรกะเริ่มต้นไว้ ข้ามสถานะล้ม หรือบังคับให้เข้าสู่สถานะล้ม",
  T_43_XXJ_WS_LEVEL: "เลเวล",
  T_43_XXJ_WS_LEVEL_D: "เลเวล",
  T_43_XXJ_WS_LEVEL_D1: "เลเวลซอมบี้ปัจจุบัน",
  T_43_XXJ_WS_LINESPACING: "ระยะห่างระหว่างบรรทัด",
  T_43_XXJ_WS_LINESPACING_D: "ไม่แสดงเมื่อ HP แบ่งส่วนระหว่างตัวแบ่งสองตัว ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "สี HP ที่สูญเสีย",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "HP ที่ลดลงจะแสดงเป็นสีนี้ในช่วงเวลาสั้นๆ",
  T_43_XXJ_WS_MAINCOLOR: "สีหลัก",
  T_43_XXJ_WS_MAINCOLOR_D: "สีสำหรับ HP, เลเวล, และเส้นขอบ",
  T_43_XXJ_WS_MINISENTRY: "ป้อมปืน",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "enum สำหรับประเภทเป้าหมายที่ป้อมปืนสามารถโจมตีได้",
  T_43_XXJ_WS_MISSILEEXPLODE: "มิสไซล์ระเบิด",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "ต้องล้ม",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "บังคับล้ม",
  T_43_XXJ_WS_OFFSET: "การชดเชย",
  T_43_XXJ_WS_OFFSET_D: "ออฟเซตสัมพันธ์กับเป้าหมายที่ตามมา",
  T_43_XXJ_WS_OILDRUMEXPLODE: "ถังน้ำมันระเบิด",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "ทำงานเมื่อตัวควบคุมเริ่มการเคลื่อนไหวเท่านั้น",
  T_43_XXJ_WS_PLAYER_D: "เอนทิตี้ผู้เล่นในเกม หนึ่งรายการต่อผู้เล่น",
  T_43_XXJ_WS_PLAYERHEADHUD: "HUD หัวของผู้เล่น",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "ข้อมูลที่แสดงอยู่เหนือศีรษะของผู้เล่น",
  T_43_XXJ_WS_PLAYERNAME: "ชื่อผู้เล่น",
  T_43_XXJ_WS_PLAYERNAME_D: "แสดงชื่อของเจ้าของแถบเลือดปัจจุบัน",
  T_43_XXJ_WS_PLAYERORVEHICLE: "ผู้เล่นหรือยานพาหนะ",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "ชื่อเล่นของประเภทเอนทิตี้ของผู้เล่น/ยานพาหนะ",
  T_43_XXJ_WS_SCALE: "มาตราส่วน",
  T_43_XXJ_WS_SCALE_D: "HUD กำหนดขนาดมาตราส่วนโดยรวม โดยปรับขนาดแบบอักษรให้ตรงกัน",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "แสดงตัวเลขความเสียหาย",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "จริงตามค่าเริ่มต้น แสดงตวเลขความเสียหาย",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "ข้ามการล้ม",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "ข้ามสถานะล้มและถูกสังหารทันที",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "ข้ามแอนิเมชันหรือไม่",
  T_43_XXJ_WS_TEAM_D: "(เลิกใช้แล้ว โปรดใช้ ID ทีม)",
  T_43_XXJ_WS_TERRAIN: "ภูมิประเทศ",
  T_43_XXJ_WS_TERRAIN_D: "ส่วนประกอบภูมิประเทศที่ไม่สามารถแก้ไขแอตทริบิวต์ได้ ใช้เพื่อทดสอบฟังก์ชันเท่านั้น",
  T_43_XXJ_WS_TOTALHP: "HP โดยรวม",
  T_43_XXJ_WS_TOTALHP_D: "ค่า HP โดยรวม",
  T_43_XXJ_WS_TWEENENTITY: "เอนทิตี้ Tween",
  T_43_XXJ_WS_VEHICLEEXPLODE: "ยานพาหนะระเบิด",
  T_43_XXJ_WS_WIDTH: "ความกว้าง",
  T_43_XXJ_WS_WIDTH_D: "ความกว้างของแถบเลือด ที่แสดง",
  T_43_XXJ_WS_ZOMBIE: "ซอมบี้",
  T_43_XYL_WS_DROIDFIST: "หมัด (Droid Apocalypse)",
  T_43_XYL_WS_DROIDFLAME: "Flamethrower (Droid Apocalypse)",
  T_43_XYL_WS_JAPANESE: "สไตล์ญี่ปุ่น",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "ปรับแต่งบันทึกคะแนนการแข่งขันสำหรับการวิเคราะห์ข้อมูลประสบการณ์ผู้ใช้",
  T_43_YU_WS_AIRDROPSTATE: "สถานะแอร์ดรอป",
  T_43_YU_WS_AIRDROPSTATE_D: "สถานะ แอร์ดรอป (1: พร้อม, 2: กำลังหล่น, 3: ลงสู่พื้น)",
  T_43_YU_WS_ANIMATIONCLIPID: "ID คลิปแอนิเมชัน",
  T_43_YU_WS_ANIMATIONCLIPID_D: "ปรับแต่ง ID คลิปแอนิเมชัน",
  T_43_YU_WS_ASKBUYTARGET: "ถามซื้อเป้าหมาย",
  T_43_YU_WS_ASKBUYTARGET_D: "ระบุเป้าหมายและส่งคำขอซื้อ",
  T_43_YU_WS_ASKEDLIST: "รายการที่ถาม",
  T_43_YU_WS_ASKEDLIST_D: "รายการไอเทมที่ร้องขอ",
  T_43_YU_WS_BACKGROUNDCOLOR1: "สีพื้นหลัง 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "สีพื้นหลังด้านบน",
  T_43_YU_WS_BACKGROUNDCOLOR2: "สีพื้นหลัง 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "สีพื้นหลังด้านล่าง",
  T_43_YU_WS_BATCHCOMBINERENDER: "การเรนเดอร์การรวมเป็นกลุ่ม",
  T_43_YU_WS_BINDMONEYENTITYLIST: "รายการผูกเอนทิตี้เงิน",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "รายการเอนทิตีสกุลเงินที่ถูกผูกไว้",
  T_43_YU_WS_BINDWALLETENTITYID: "ผูก ID เอนทิตี้ กระเป๋าเงิน",
  T_43_YU_WS_BINDWALLETENTITYID_D: "ID ของเอนทิตี้กระเป๋าเงินที่ถูกผูกไว้",
  T_43_YU_WS_CENTEROFFSET: "ชดเชยศูนย์กลาง",
  T_43_YU_WS_CENTEROFFSET_D: "ค่าชดเชยสำหรับตัวชนของแคปซูล",
  T_43_YU_WS_COLLECTIONID: "ID คอลเลกชัน",
  T_43_YU_WS_COLLECTIONID_D: "ID คอลเลกชันที่ใช้สำหรับการรวบรวมข้อมูลสินทรัพย์",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "สร้างแอร์ดรอป",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "สร้างหมายเลขความเสียหาย",
  T_43_YU_WS_CROSSPLATFORM_D: "หลังจากเลือกแล้ว หากถูกเรียกบนเซิร์ฟเวอร์ ก็จะถูกส่งไปยังไคลเอนต์ หากถูกเรียกบนไคลเอนต์ ก็จะถูกส่งไปยังเซิร์ฟเวอร์",
  T_43_YU_WS_CSROUNDRESULTHUD: "HUD ผลการแข่งขันรอบ 4V4",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "ผลลัพธ์จะแสดงเมื่อสิ้นสุดแต่ละรอบ",
  T_43_YU_WS_CURRENTEMOTECLIP: "คลิปท่าทางปัจจุบัน",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID ของคลิป ท่าทาง ปัจจุบัน",
  T_43_YU_WS_DAMAGE_D: "ความเสียหายนอกพื้นที่",
  T_43_YU_WS_DICTIONARY: "พจนานุกรรม",
  T_43_YU_WS_DIRECTIONRULERHUD: "HUD เส้นทางไม้บรรทัด",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "เข็มทิศอยู่ด้านบน",
  T_43_YU_WS_DOTWEEN_D: "ไม่ว่าจะทำแอนิเมชัน tween หรือไม่ก็ตาม",
  T_43_YU_WS_DROPITEMS_D: "ไอเทมในแอร์ดรอป",
  T_43_YU_WS_DURATION: "ระยะเวลา",
  T_43_YU_WS_ENERGY: "พลังงาน",
  T_43_YU_WS_ENERGY_D: "ค่าแก้ไข EP",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "หมอบ",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "หมอบ",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "การวิ่ง",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "ยืน",
  T_43_YU_WS_EVENTID: "ID กิจกรรม",
  T_43_YU_WS_EVENTID_D: "แสดงเหตุการณ์",
  T_43_YU_WS_FACTION: "ฝ่าย",
  T_43_YU_WS_FACTION_D: "เอนทิตี้ฝ่าย",
  T_43_YU_WS_FACTION_D1: "ขอความช่วยเหลือจากฝ่ายในการซื้อ",
  T_43_YU_WS_FINALRADIUS_D: "รัศมีสุดท้ายของพื้นที่ปลอดภัย",
  T_43_YU_WS_FIRSTAIDKIT: "กล่องพยาบาล",
  T_43_YU_WS_FIRSTAIDKIT_D: "กล่องพยาบาล",
  T_43_YU_WS_FIRSTPERSONMODEL: "โมเดลบุคคลที่หนึ่ง",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "กล้องมุมมองบุคคลที่หนึ่ง",
  T_43_YU_WS_FONTCOLOR_D: "สีตัวอักษร",
  T_43_YU_WS_FONTSIZE_D: "ขนาดตัวอักษร",
  T_43_YU_WS_FORBIDEN: "หวงห้าม",
  T_43_YU_WS_FORBIDEN_D: "ปิดการใช้งาน HUD สำหรับคำขอซื้อ",
  T_43_YU_WS_FREEZINGTIME: "เวลาหยุดเดิน",
  T_43_YU_WS_FREEZINGTIME_D: "เวลาหยุดนิ่งเกิดขึ้นหลังจากโจมตีเป้าหมาย",
  T_43_YU_WS_GRAVITY: "แรงโน้มถ่วง",
  T_43_YU_WS_GRAVITY_D: "ความเร่งโน้มถ่วง ส่งผลต่อตัวควบคุมผู้เล่นเท่านั้น",
  T_43_YU_WS_HANDCATAPULT: "แท่นกระโดด",
  T_43_YU_WS_HANDCATAPULT_D: "แท่นกระโดด",
  T_43_YU_WS_HEALTH: "สุขภาพ",
  T_43_YU_WS_HEALTH_D: "ค่าการฟื้นตัวของความทนทานของเกราะ",
  T_43_YU_WS_HEIGHT: "ความสูง",
  T_43_YU_WS_HELPEDPLAYER_D: "ผู้เล่นที่ได้รับการช่วยเหลือ",
  T_43_YU_WS_HELPPLAYER_D: "ผู้เล่นที่ช่วยซื้อ",
  T_43_YU_WS_HORIZONTALMAXANGLE: "มุมแนวนอนสูงสุด",
  T_43_YU_WS_HORIZONTALMINANGLE: "มุมต่ำสุดแนวนอน",
  T_43_YU_WS_HUDTOGGLE: "HUD Toggle",
  T_43_YU_WS_HUDTOGGLE_D: "เอนทิตี้ HudToggle ที่ผู้เล่นสามารถแก้ไขได้ในตัวแก้ไข HUD",
  T_43_YU_WS_INHALER: "Inhaler",
  T_43_YU_WS_INHALER_D: "Inhaler",
  T_43_YU_WS_INITRADIUS_D: "รัศมีเริ่มต้นของพื้นที่ปลอดภัย",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "จำนวนเต็มที่ลงนามแบบ 64-bit",
  T_43_YU_WS_ISAPPLYSHADOW: "ใช้เงาหรือไม่",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "ส่วนล่างชนกันหรือไม่",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "ท่าทางวนซ้ำในปัจจุบันใช่หรือไม่",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "ไม่ว่าจะตั้งค่าแอนิเมชัน ท่าทาง ปัจจุบันให้วนซ้ำหรือไม่",
  T_43_YU_WS_ISSIDECOLLIDING: "ขอบชนกันหรือไม่",
  T_43_YU_WS_ISSLIDING: "กำลังสไลด์",
  T_43_YU_WS_ISTOPCOLLIDING: "ส่วนบนชนกันหรือไม่",
  T_43_YU_WS_ITEM331: "อุปกรณ์ล้ำสมัย A",
  T_43_YU_WS_ITEM332: "หินเรืองแสง A",
  T_43_YU_WS_ITEM333: "ฉากล้ำสมัย A",
  T_43_YU_WS_ITEM334: "คอนเทนเนอร์ล้ำสมัย A",
  T_43_YU_WS_ITEM335: "คอนเทนเนอร์ล้ำสมัย A",
  T_43_YU_WS_ITEM336: "โซฟาหิน A",
  T_43_YU_WS_ITEM337: "สวิตช์ล้ำสมัย A",
  T_43_YU_WS_ITEM338: "ท่อล้ำสมัย A",
  T_43_YU_WS_ITEM339: "แพลตฟอร์มโลหะ A",
  T_43_YU_WS_ITEM340: "โต๊ะล้ำสมัย A",
  T_43_YU_WS_ITEM341: "โต๊ะล้ำสมัย B",
  T_43_YU_WS_ITEM342: "โต๊ะล้ำสมัย C",
  T_43_YU_WS_ITEM343: "คอมพิวเตอร์ล้ำสมัย A",
  T_43_YU_WS_ITEM344: "หิน A",
  T_43_YU_WS_ITEM345: "หิน B",
  T_43_YU_WS_ITEM346: "หิน C",
  T_43_YU_WS_ITEM347: "หิน D",
  T_43_YU_WS_ITEM348: "หิน E",
  T_43_YU_WS_ITEM349: "หิน F",
  T_43_YU_WS_ITEM350: "หิน G",
  T_43_YU_WS_ITEM351: "ม่านสไตล์ญี่ปุ่น A",
  T_43_YU_WS_ITEM352: "ม่านสไตล์ญี่ปุ่น B",
  T_43_YU_WS_ITEM353: "ม่านสไตล์ญี่ปุ่น C",
  T_43_YU_WS_ITEM354: "บันไดสไตล์ญี่ปุ่น A",
  T_43_YU_WS_ITEM355: "รั้วสไตล์ญี่ปุ่น A",
  T_43_YU_WS_ITEM356: "รั้วสไตล์ญี่ปุ่น B",
  T_43_YU_WS_ITEM357: "รั้วสไตล์ญี่ปุ่น C",
  T_43_YU_WS_ITEM358: "แพลตฟอร์มสไตล์ญี่ปุ่น A",
  T_43_YU_WS_ITEM359: "กำแพงสไตล์ญี่ปุ่น B",
  T_43_YU_WS_ITEM360: "ประตูสไตล์ญี่ปุ่น B",
  T_43_YU_WS_ITEM361: "กำแพงไฮเทค D",
  T_43_YU_WS_ITEM362: "กำแพงไฮเทค B",
  T_43_YU_WS_ITEM363: "บัวพื้นแบบมุมไฮเทค",
  T_43_YU_WS_LEFTCOLOR: "สีทางด้านซ้าย",
  T_43_YU_WS_LEFTCOLOR_D: "สีด้านซ้าย",
  T_43_YU_WS_LEFTPLAYERARRAY: "อาร์เรย์ผู้เล่นซ้าย",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "อาร์เรย์ผู้เล่นด้านซ้าย",
  T_43_YU_WS_LEFTSCORE: "คะแนนทางซ้าย",
  T_43_YU_WS_LEFTSCORE_D: "คะแนนทางด้านซ้าย",
  T_43_YU_WS_LEFTSCOREAFTER: "คะแนนสุดท้ายทางด้านซ้าย",
  T_43_YU_WS_LEFTSCOREAFTER_D: "คะแนนสุดท้ายทางด้านซ้ายใช้สำหรับเล่นแอนิเมชันการเปลี่ยนคะแนน",
  T_43_YU_WS_LEVELOBJECTID: "ID ระดับวัตถุ",
  T_43_YU_WS_LEVELOBJECTID_D: "อธิบายประเภทของวัตถุ ต้องมีการแยกวิเคราะห์ผ่านตารางการกำหนดค่า SceneEditPrefab ก่อนที่จะโหลด",
  T_43_YU_WS_LOCALPOSITION_D: "พิกัดในระบบพิกัดท้องถิ่น",
  T_43_YU_WS_LOCALPOSITION_D1: "ตำแหน่งสัมพัทธ์",
  T_43_YU_WS_LOCALPOSITION_D2: "ตำแหน่งที่สัมพันธ์กับจุดยึดมุมขวาล่าง",
  T_43_YU_WS_LOCALPOSITION_D3: "ตำแหน่งสัมพันธ์กับจุดยึด",
  T_43_YU_WS_LOCALROTATION_D: "มุมการหมุนในระบบพิกัดเฉพาะที่ (X: yaw, Y: pitch และ Z: roll)",
  T_43_YU_WS_LOCALROTATIONQ_D: "ควอเทอร์เนียนในระบบพิกัดท้องถิ่น",
  T_43_YU_WS_LOCALSCALE_D: "ขนาดมาตราส่วนในระบบพิกัดโลก",
  T_43_YU_WS_MASS: "มวล",
  T_43_YU_WS_MATERIALS: "วัตถุดิบ",
  T_43_YU_WS_MATERIALS_D: "รายการวัตถุดิบที่ใช้ในการเรนเดอร์",
  T_43_YU_WS_MAXSPEED: "ความเร็วสูงสุด",
  T_43_YU_WS_MAXSPEED_D: "หลังจากที่ถึงความเร็วสูงสุดแล้วจะไม่สร้างแรงม้าอีกต่อไป แต่ความเร็วของรถอาจเกินขีดจำกัด (เช่น จากการเร่งความเร็วเมื่อลงเนิน)",
  T_43_YU_WS_MESHID: "ID ตาราง",
  T_43_YU_WS_MESHID_D: "อธิบายประเภทของตาราง",
  T_43_YU_WS_MESHID1: "ID ตาราง",
  T_43_YU_WS_MESHID1_D: "The mesh to be used for rendering",
  T_43_YU_WS_MINMOVEDISTANCE: "ระยะเคลื่อนที่ตำ่สุด",
  T_43_YU_WS_MINMOVEDISTANCE_D: "การเคลื่อนที่ด้วยระยะทางที่สั้นกว่าค่านี้จะไม่ถูกดำเนินการ ขอแนะนำให้ตั้งค่าเป็น 0 เว้นแต่จะมีข้อกำหนดพิเศษ",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "แอร์ดรอป",
  T_43_YU_WS_MODULE_ANIMATION: "แอนิเมชัน",
  T_43_YU_WS_MODULE_AVATAR: "โปรไฟล์",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "คุณสมบัติพื้นฐาน",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "แผนผังพฤติกรรม",
  T_43_YU_WS_MODULE_BUFF: "บัฟ",
  T_43_YU_WS_MODULE_CAMERA: "กล้อง",
  T_43_YU_WS_MODULE_CHATCHANNEL: "ช่องแชท",
  T_43_YU_WS_MODULE_CHECKPOINT: "จุดตรวจ",
  T_43_YU_WS_MODULE_COLLECTION: "คอลเลกชัน",
  T_43_YU_WS_MODULE_COMBAT: "การต่อสู้",
  T_43_YU_WS_MODULE_COMPONENT: "ส่วนประกอบ",
  T_43_YU_WS_MODULE_CONVERT: "เปลี่ยน",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "ปรับแต่งพารามิเตอร์ของห้อง",
  T_43_YU_WS_MODULE_DATABASE: "การจัดเก็บข้อมูล",
  T_43_YU_WS_MODULE_DYEING: "การย้อมสี",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "NavMesh แบบไดนามิก",
  T_43_YU_WS_MODULE_ECONOMY: "ระบบเงินในเกม",
  T_43_YU_WS_MODULE_FF_PLATFORM: "แพลตฟอร์ม FF",
  T_43_YU_WS_MODULE_FOOTBALL: "ฟุตบอล",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "โหมดอัตราเฟรม",
  T_43_YU_WS_MODULE_GAMERESULT: "สรุปผลเกม",
  T_43_YU_WS_MODULE_GLOBAL: "ทั่วโลก",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "สคริปต์ทั่วโลก",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK และ การโกง",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "ระบบอินพุต",
  T_43_YU_WS_MODULE_ITEMS: "ไอเทม",
  T_43_YU_WS_MODULE_LEVELOBJECT: "วัตถุบนเวที",
  T_43_YU_WS_MODULE_LIST: "รายการ",
  T_43_YU_WS_MODULE_MAP: "แผนที่",
  T_43_YU_WS_MODULE_MATCHING: "จับคู่",
  T_43_YU_WS_MODULE_MATH: "คณิตศาสตร์",
  T_43_YU_WS_MODULE_MECHANISM: "พารามิเตอร์กลไก",
  T_43_YU_WS_MODULE_MINIMAP: "แผนที่ย่อ",
  T_43_YU_WS_MODULE_MORPH: "มอร์ฟ",
  T_43_YU_WS_MODULE_OTHER: "อื่น ๆ",
  T_43_YU_WS_MODULE_PET: "คู่หู",
  T_43_YU_WS_MODULE_PHYSICS: "ฟิสิกส์",
  T_43_YU_WS_MODULE_PLAYABLE: "เล่นได้",
  T_43_YU_WS_MODULE_PLAYER: "ผู้เล่น",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "สคริปต์ผู้เล่น",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "ตัวละครที่ตั้งไว้ล่วงหน้า",
  T_43_YU_WS_MODULE_PROFILE: "โปรไฟล์",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "สูตรคุณสมบัติ",
  T_43_YU_WS_MODULE_SAFEZONE: "พื้นที่ปลอดภัย",
  T_43_YU_WS_MODULE_SCENE: "ฉาก",
  T_43_YU_WS_MODULE_SKILL: "สกิล",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "สคริปต์แบบคงที่",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "รายงาน",
  T_43_YU_WS_MODULE_STDLIBRARY: "ห้องสมุด STD",
  T_43_YU_WS_MODULE_STRINGS: "สตริง",
  T_43_YU_WS_MODULE_TEAM: "ทีม",
  T_43_YU_WS_MODULE_WORKFLOW: "ขั้นตอนการทำงาน",
  T_43_YU_WS_MONEYICON: "ไอคอนเงิน",
  T_43_YU_WS_MONEYICON_D: "ไอคอนสกุลเงิน",
  T_43_YU_WS_MONEYICONCOLOR: "สีไอคอนเงิน",
  T_43_YU_WS_MONEYICONCOLOR_D: "สีไอคอนสกุลเงิน",
  T_43_YU_WS_MOVESAFEZONE_D: "พื้นที่ปลอดภัยเคลื่อนจากตำแหน่งเริ่มต้นไปยังตำแหน่งสิ้นสุดอย่างราบรื่น ผู้เล่นที่อยู่นอกโซนจะได้รับความเสียหายจำนวนหนึ่ง",
  T_43_YU_WS_NEWVECTOR2: "Vector2 ใหม่",
  T_43_YU_WS_NEWVECTOR2_D: "รับเวกเตอร์ 2D ใหม่",
  T_43_YU_WS_OFFSET_D: "ตำแหน่งโลกชดเชยสัมพันธ์กับเอนทิตี้เป้าหมาย",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "เมื่อเป็นไปตามคำขอซื้อของผู้เล่น",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "เมื่อผู้เล่นขอความช่วยเหลือในการซื้อของในร้านค้า",
  T_43_YU_WS_ONTOGGLECHANGE_D: "แสดงผลเมื่อสถานะองค์ประกอบ เปลี่ยนแปลง",
  T_43_YU_WS_OPENSTATE: "เปิดสถานะ",
  T_43_YU_WS_OPENSTATE_D: "แสดงเมื่อตั้งค่าเป็นจริงและซ่อนหากไม่ใช่",
  T_43_YU_WS_PACEMAKER: "เข็มชุบชีวิต",
  T_43_YU_WS_PACEMAKER_D: "เข็มชุบชีวิต",
  T_43_YU_WS_PARAMS_D: "รายการพารามิเตอร์",
  T_43_YU_WS_PARENT_D: "ID เอนทิตี้ที่บันทึกไว้ระหว่างการทำให้เป็นอนุกรม",
  T_43_YU_WS_PHYSICALCCT: "CCT ทางกายภาพ",
  T_43_YU_WS_PHYSICALCCT_D: "ตัวควบคุมผู้เล่นพร้อมเอฟเฟ็กต์ทางกายภาพ",
  T_43_YU_WS_PLAYER_D: "ผู้เล่นที่ซื้อ",
  T_43_YU_WS_PLAYERDATAID: "ID ข้อมูลผู้เล่น",
  T_43_YU_WS_PLAYERDATAID_D: "ปรับแต่ง ID สินทรัพย์ตัวละคร",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "ผู้เล่นประเภท PhysX Pose",
  T_43_YU_WS_POSITION: "ตำแหน่ง",
  T_43_YU_WS_POSITION_D: "พิกัดในระบบพิกัดโลก",
  T_43_YU_WS_POSITION_D1: "พิกัดในระบบพิกัดโลก มีผลเฉพาะกับเพลง 3D เท่านั้น",
  T_43_YU_WS_PRESSEDSPRITE: "Sprite แบบกด",
  T_43_YU_WS_PRESSEDSPRITE_D: "Sprite แบบกด",
  T_43_YU_WS_PRESSEDSPRITETYPE: "ประเภท Sprite แบบกด",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "ประเภท Sprite แบบกด",
  T_43_YU_WS_PRETIME: "ก่อนเวลา",
  T_43_YU_WS_RADIUS: "รัศมี",
  T_43_YU_WS_RANDOMRANGE_D: "แก้ไขตำแหน่งที่ตั้งไว้ตามช่วงสุ่ม",
  T_43_YU_WS_REQUESTPURCHASETYPE: "ประเภทขอซื้อ",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "คำขอซื้อในร้านค้า",
  T_43_YU_WS_REQUESTTYPE: "ประเภทคำขอ",
  T_43_YU_WS_REQUESTTYPE_D: "ประเภทของเป้าหมายร้องขอโดยผู้เล่น HUD ปัจจุบัน",
  T_43_YU_WS_RESPLAYERUUID: "ประเภทผู้เล่นที่ตั้งไว้ล่วงหน้า",
  T_43_YU_WS_RESPLAYERUUID_D: "ID ทรัพย์สินของผู้เล่น",
  T_43_YU_WS_RESUUID: "UUID ของสินทรัพย์",
  T_43_YU_WS_RESUUID_D: "ระบุ UUID ของเนื้อหา Batch ที่จะแสดงผล",
  T_43_YU_WS_RIGHTCOLOR: "สีทางด้านขวา",
  T_43_YU_WS_RIGHTCOLOR_D: "สีด้านขวา",
  T_43_YU_WS_RIGHTPLAYERARRAY: "อาร์เรย์ผู้เล่นขวา",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "อาร์เรย์ผู้เล่นด้านขวา",
  T_43_YU_WS_RIGHTSCORE: "คะแนนทางด้านขวา",
  T_43_YU_WS_RIGHTSCORE_D: "คะแนนฝั่งขวา",
  T_43_YU_WS_RIGHTSCOREAFTER: "หลังคะแนนทางด้านขวา",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "คะแนนสุดท้ายทางด้านขวาใช้สำหรับเล่นแอนิเมชันการเปลี่ยนคะแนน",
  T_43_YU_WS_ROTATIONQ_D: "ควอเทอร์เนียนในระบบพิกัดโลก",
  T_43_YU_WS_ROUNDINFOHUD: "HUD ข้อมูลรอบ",
  T_43_YU_WS_ROUNDINFOHUD_D: "ข้อมูลที่แสดงเมื่อเริ่มรอบ",
  T_43_YU_WS_SELECTEDCOLOR: "สีที่เลือก",
  T_43_YU_WS_SELECTEDCOLOR_D: "สี Sprite ที่เลือก",
  T_43_YU_WS_SELECTEDSPRITE: "Sprite ที่เลือก",
  T_43_YU_WS_SELECTEDSPRITE_D: "Sprite ที่เลือก",
  T_43_YU_WS_SELECTEDTYPE: "ประเภทที่เลือก",
  T_43_YU_WS_SELECTEDTYPE_D: "ประเภท Sprite ที่เลือก",
  T_43_YU_WS_SHADOWCOLOR: "สีเงา",
  T_43_YU_WS_SHADOWOFFSET: "ชดเชยเงา",
  T_43_YU_WS_SHOWTAG: "แสดงแท็ก",
  T_43_YU_WS_SHOWTAG_D: "แสดงเครื่องหมายทีม/ฝ่าย",
  T_43_YU_WS_SHRINKDURATION_D: "ระยะเวลาที่ลดลงของพื้นที่ปลอดภัย",
  T_43_YU_WS_SIMPLERENDER_D: "คอมโพเนนต์การเรนเดอร์แบบเชื่อมโยงที่ใช้สำหรับการเรนเดอร์ด้วยโมเดลในตัว",
  T_43_YU_WS_SKINWIDTH: "ความกว้างของผิว",
  T_43_YU_WS_SKINWIDTH_D: "ความลึกของการเจาะเข้าไปในแคปซูลเพื่อป้องกันไม่ให้ตัวละครติดหรือเกิดการกระตุก",
  T_43_YU_WS_SLOPELIMIT: "ขีดจำกัดความลาดชัน",
  T_43_YU_WS_SLOPELIMIT_D: "วัตถุที่วางอยู่บนความลาดชันเกินมุมนี้จะเลื่อนลงมา",
  T_43_YU_WS_SPEED: "ความเร็ว",
  T_43_YU_WS_STARTDROPTIME_D: "เวลาของแอร์ดรอป หน่วยเป็นมิลลิวินาที",
  T_43_YU_WS_STARTPOS_D: "ตำแหน่งเริ่มต้นของพื้นที่ปลอดภัย",
  T_43_YU_WS_STATICICONCOLORS: "สีไอคอนคงที่",
  T_43_YU_WS_STATICICONCOLORS_D: "สีไอคอนที่แสดงบนไม้บรรทัด",
  T_43_YU_WS_STATICICONS: "ไอคอนคงที่",
  T_43_YU_WS_STATICICONS_D: "ไอคอนที่แสดงบนไม้บรรทัด",
  T_43_YU_WS_STEPOFFSET: "ชดเชยขั้น",
  T_43_YU_WS_STEPOFFSET_D: "เฉพาะสิ่งกีดขวางที่เกินความสูงนี้เท่านั้นที่จะมีผลในการบล็อก",
  T_43_YU_WS_SUBTITLE: "คำบรรยาย",
  T_43_YU_WS_SUBTITLE_D: "คำบรรยาย",
  T_43_YU_WS_TARGET: "เป้าหมาย",
  T_43_YU_WS_TARGET_D: "เอนทิตี้เป้าหมายสำหรับแสดงค่าความเสียหาย",
  T_43_YU_WS_TARGETICONCOLORS: "สีไอคอนเป้าหมาย",
  T_43_YU_WS_TARGETICONCOLORS_D: "สีของไอคอนที่แสดงโดยเป้าหมายที่ทำเครื่องหมายไว้",
  T_43_YU_WS_TARGETICONS: "ไอคอนเป้าหมาย",
  T_43_YU_WS_TARGETICONS_D: "ไอคอนที่แสดงโดยเป้าหมายที่ทำเครื่องหมายไว้",
  T_43_YU_WS_TARGETPOS_D: "ตำแหน่งสิ้นสุดเป้าหมายของพื้นที่ปลอดภัย",
  T_43_YU_WS_TEAM: "ทีม",
  T_43_YU_WS_TEAM_D: "เอนทิตีของทีมในเกม แต่ละทีมมีหนึ่งเอนทิตี้",
  T_43_YU_WS_TEAM_D1: "ขอความช่วยเหลือจากทีมในการซื้อ",
  T_43_YU_WS_TIMEOFSTAY_D: "ระยะเวลาการแสดงผลเป็นมิลลิวินาที",
  T_43_YU_WS_TITLE: "ชื่อ",
  T_43_YU_WS_TITLE_D: "ชื่อหลัก",
  T_43_YU_WS_TRANSFORM_D: "การหมุน การปรับขนาด และบันทึกผลของค่าตั้งต้น",
  T_43_YU_WS_UNSELECTEDCOLOR: "สีที่ไม่ได้เลือก",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "สี Sprite ที่ไม่ได้เลือก",
  T_43_YU_WS_UNSELECTEDSPRITE: "Sprite ที่ไม่ได้เลือก",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "Sprite ที่ไม่ได้เลือก",
  T_43_YU_WS_UNSELECTEDTYPE: "ประเภทที่ไม่ได้เลือก",
  T_43_YU_WS_UNSELECTEDTYPE_D: "ประเภท Sprite ที่ไม่ได้เลือก",
  T_43_YU_WS_USEPHYSICALCCT: "ใช้ CCT ทางกายภาพ",
  T_43_YU_WS_VALUE_D: "เนื้อหาที่แสดง",
  T_43_YU_WS_VECTOR2ADD: "เพิ่ม Vector2",
  T_43_YU_WS_VECTOR2GETX: "Vector2 รับ X",
  T_43_YU_WS_VECTOR2GETY: "Vector2 รับ Y",
  T_43_YU_WS_VECTOR2SCALE: "มาตราส่วน Vector2",
  T_43_YU_WS_VECTOR2SETX: "Vector2 ตั้งค่า X",
  T_43_YU_WS_VECTOR2SETY: "Vector2 ตั้งค่า Y",
  T_43_YU_WS_VECTOR2SUB: "Vector2 Sub",
  T_43_YU_WS_VELOCITY: "ความเร็ว",
  T_43_YU_WS_VERTICALMAXANGLE: "มุมสูงสุดแนวตั้ง",
  T_43_YU_WS_VERTICALMINANGLE: "มุมแนวตั้งขั้นต่ำ",
  T_43_YU_WS_VISIBILITY_D: "ระบุว่าสามารถตั้งค่าการมองเห็นได้หรือไม่",
  T_43_YU_WS_VISIBLE_D: "การตั้งค่าการมองเห็น หากตั้งค่าเป็นมองไม่เห็น ไคลเอ็นต์จะหยุดแสดงผลเป้าหมาย",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "กำแพงไฮเทค A",
  T_43_ZY_WS_ITEM320: "กำแพงไฮเทค C",
  T_43_ZY_WS_ITEM321: "หน้าต่างไฮเทค",
  T_43_ZY_WS_ITEM322: "ประตูไฮเทค",
  T_43_ZY_WS_ITEM323: "หลังคาแบบมุมไฮเทค",
  T_43_ZY_WS_ITEM324: "หลังคาแบบวงกลมไฮเทค",
  T_43_ZY_WS_ITEM325: "บัวพื้นไฮเทค",
  T_43_ZY_WS_ITEM326: "บัวพื้นแบบวงกลมไฮเทค",
  T_43_ZY_WS_ITEM327: "บันไดไฮเทค",
  T_43_ZY_WS_ITEM328: "การตกแต่งแบบไฮเทค A",
  T_43_ZY_WS_ITEM329: "อาคารไฮเทค A",
  T_43_ZY_WS_ITEM330: "อาคารไฮเทค B",
  T_44_CJ_M_B_SPORT_TH: "ไฮสคูลเซนเซ (กางเกง)",
  T_44_CJ_M_H_SPORT_TH: "ไฮสคูลเซนเซ (หัว)",
  T_44_CJ_M_S_SPORT_TH: "ไฮสคูลเซนเซ (รองเท้า)",
  T_44_CJ_M_T_SPORT_TH: "ไฮสคูลเซนเซ (เสื้อ)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "ไครอส",
  T_44_H_M24_ONIMUSHA_N: "M24 - Attack-o'-the-Wisp",
  T_44_H_USP45_CARNIVORE_N: "USP - Poison Tooth",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "มอเตอร์ไบค์ - Thunderstrokes",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "บังคับให้เริ่มเกมด้วยผู้เล่นจำนวนน้อยสุด",
  T_44_JH_WS_HALFWAYKEY1: "จะเริ่มเล่นก็ต่อเมื่อปาร์ตี้ครบ",
  T_44_PD_PVE_DRAGON_NAME: "Mechadrake",
  T_44_QL_GRENADE_DRAGON: "ระเบิดน้ำแข็งมังกร",
  T_44_QL_GRENADE_DRAGON_DES: "ระเบิดน้ำแข็งรุ่นพิเศษที่สามารถระเบิดอย่างต่อเนื่องได้ 3 ครั้ง",
  T_44_QL_JUMPSHOESX: "รองเท้ามังกรทะยาน",
  T_44_QL_JUMPSHOESX_DES: "รองเท้ากระโดดพิเศษคู่หนึ่งที่สามารถวิ่งในอากาศขณะกระโดดครั้งที่สองได้",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "เวลาที่วงจะปิด",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "เวลาเมื่อพื้นที่ปลอดภัยหายไป หากเวลาปิดพื้นที่ปลอดภัยน้อยกว่าเวลาเริ่มต้นพื้นที่ปลอดภัย จะไม่มีการสร้างพื้นที่ปลอดภัย",
  T_44_SJ_WS_SAFEZONE_COLOR: "สีพื้นที่ปลอดภัย",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "ช่วงเวลาที่รับดาเมจ",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "ช่วงเวลาที่รับดาเมจ",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "ค่าความเสียหาย",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "ทำความเสียหายต่อผู้เล่นนอกวงในคราวเดียว",
  T_44_SJ_WS_SAFEZONE_DESC: "วัตถุที่สามารถวางได้นอกโซน",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "รัศมีสุดท้ายพื้นที่นอกวง",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "รัศมีสุดท้ายของพื้นที่นอกวง",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "รายชื่อผู้เล่นในพื้นที่ปลอดภัย",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "ได้รับรายชื่อผู้เล่นในพื้นที่ปลอดภัย",
  T_44_SJ_WS_SAFEZONE_NAME: "พื้นที่นอกวง",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "ระยะเวลาที่วงบีบ (วินาที)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "ระยะเวลาที่วงบีบ",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "รัศมีเริ่มต้นพื้นที่นอกวง",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "รัศมีเริ่มต้นของพื้นที่นอกวง",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "วงเริ่มบีบ",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "เวลาที่วงเริ่มบีบ",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "เวลาเริ่มในพื้นที่ปลอดภัย",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "ค่าเวลาเบื่องต้นเมื่อพื้นที่ปลอดภัยเกิดขึ้นในแต่ละรอบคือ 0",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "พลาสมา-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "เปิดใช้งานอัลฟา",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "เปิดใช้งานโปร่งใส",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "HUD สกิลกดใช้",
  T_44_XXJ_WS_ADDCOMPONENT_D: "เพิ่มส่วนประกอบให้กับเอนทิตี รองรับเฉพาะส่วนประกอบที่กำหนดเอง (ส่วนประกอบจะไม่ถูกเพิ่มซ้ำหากมีอยู่แล้ว)",
  T_44_XXJ_WS_ALLMEMBERS: "สมาชิกทั้งหมด",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "อนุญาตให้กดภายนอก",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "อนุญาตให้เรียกใช้งานนอกพื้นที่ที่กำหนดไว้",
  T_44_XXJ_WS_ARROWIMAGE: "ภาพลูกศร",
  T_44_XXJ_WS_ARROWIMAGE_D: "รูปภาพลูกศร",
  T_44_XXJ_WS_ARROWOFFSET: "การเลื่อนตำแหน่งลูกศร",
  T_44_XXJ_WS_ARROWOFFSET_D: "การเลื่อนตำแหน่งลูกศร",
  T_44_XXJ_WS_ARROWSIZE: "ขนาดลูกศร",
  T_44_XXJ_WS_ARROWSIZE_D: "ขนาดลูกศร",
  T_44_XXJ_WS_AUTOPLAY_D: "เล่นโดยอัตโนมัติทันทีที่สร้าง",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "ภาพพื้นหลัง",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "รูปภาพพื้นฐาน",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "รัศมีพื้นหลัง",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "รัศมีพื้นฐาน",
  T_44_XXJ_WS_BAGSKINID: "เลขสกินกระเป๋า",
  T_44_XXJ_WS_BAGSKINID_D: "เลขสกินกระเป๋า",
  T_44_XXJ_WS_BONEPOSITION: "ตำแหน่งกระดูก",
  T_44_XXJ_WS_BONEPOSITION_D: "พิกัดโลกของโหนดกระดูก",
  T_44_XXJ_WS_CCTMOVE: "ย้าย CCT",
  T_44_XXJ_WS_COLLIDER: "การชนกัน",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "การรวบรวมคอลไลเดอร์",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "องค์ประกอบที่ใช้ในการอธิบายรูปร่าง",
  T_44_XXJ_WS_COLOR: "สี",
  T_44_XXJ_WS_CONTENT: "หัวข้อ",
  T_44_XXJ_WS_CONTENT_D: "กระเป๋าเงินคือการสะสมของสกุลเงิน",
  T_44_XXJ_WS_CONTEXT_D: "เนื้อหาที่จะพิมพ์",
  T_44_XXJ_WS_CROSSHAIRSHUD: "HUD เป้าเล็ง",
  T_44_XXJ_WS_CURVE_D: "เส้นโค้ง",
  T_44_XXJ_WS_EFFECTCOLOR_D: "สีของลักษณะพื้นผิว",
  T_44_XXJ_WS_ENABLE: "เปิดใช้งาน",
  T_44_XXJ_WS_ENTITY_D: "เอนทิตี",
  T_44_XXJ_WS_GETBAGSKINID_D: "ได้รับค่าสกินกระเป๋าของผู้เล่น",
  T_44_XXJ_WS_GETFACTION_D: "การรับข้อมูล",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "ได้รับฉากโหลดเข้าที่ไม่ได้ถูกติดตั้งสมบูรณ์",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "ได้ผู้เล่นประจำถิ่น",
  T_44_XXJ_WS_GROUPID: "กลุ่มตัวเลข",
  T_44_XXJ_WS_GROUPID_D: "สำหรับตรรกะภายใน",
  T_44_XXJ_WS_HUDJOYSTICK: "วิดเจ็ต HUD แบบจอยสติ๊ก",
  T_44_XXJ_WS_HUDJOYSTICK_D: "เอนทิตีจอยสติ๊ก ผู้เล่นสามารถแก้ไข HUD ผ่านตัวแก้ไข HUD ได้",
  T_44_XXJ_WS_HUDTOUCHPAD: "วิดเจ็ตปุ่มสัมผัส HUD",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "วิดเจ็ตปุ่มสัมผัส HUD ที่ผู้เล่นสามารถแก้ไขได้ในตัวแก้ไข HUD",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "ปรับแต่ง HUD หรือวิดเจ็ต HUD",
  T_44_XXJ_WS_ICON: "ไอคอน",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "เปิดใช้งานมาร์กตลอด",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "เปิดใช้งานมาร์กบนเข็มทิศ",
  T_44_XXJ_WS_INACTIVATEDALPHA: "ปิดใช้งานอัลฟา",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "ปิดใช้งานอัลฟา",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "เมื่อเรียกใช้งาน จำนวนพารามิเตอร์ที่เป็นจริงไม่ตรงกับจำนวนพารามิเตอร์ที่กำหนดไว้ ซึ่งค่าที่คาดการณ์ไว้คือ {0} ส่วนค่าความจริงคือ {1}",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "สิ่งกีดขวางที่เคลื่อนไหว",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "เป็นอุปสรรคที่เคลื่อนไหวสำหรับ NavMesh",
  T_44_XXJ_WS_ISEND: "สิ้นสุด",
  T_44_XXJ_WS_ISEND_D: "จุดสิ้นสุด",
  T_44_XXJ_WS_ISSERVERDRIVEN: "ที่มาจากเซิร์ฟเวอร์",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "ถ้าเกิดข้อผิดพลาด วัตถุที่กำหนดเองจะไม่สามารถควบคุมด้วย API ได้",
  T_44_XXJ_WS_ISSUC_D: "คืนค่าการดำเนินการ",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "รัศมีลากจอยสติก",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "รัศมีการลากจอยสติก",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "รูปภาพจอยสติก",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "รูปภาพจอยสติก",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "รัศมีจอยสติก",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "รัศมีของจอยสติก",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "ลำดับเลขสกิลตัวละคร",
  T_44_XXJ_WS_LOOPTYPE_D: "การวนซ้ำ",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "ออกจากการตั้งค่ากลางคัน",
  T_44_XXJ_WS_MOUNTABLE: "ลำดับชั้น",
  T_44_XXJ_WS_MOUNTABLE_D: "เอนทิตีที่สามารถเสริมโหนดลูกได้",
  T_44_XXJ_WS_MOVEMENT: "การเคลื่อนที่",
  T_44_XXJ_WS_NAME_D: "ชื่อ",
  T_44_XXJ_WS_NATURALCONST: "ค่าคงที่ธรรมชาติ",
  T_44_XXJ_WS_NATURALCONST_D: "การเรียกค่าคงที่ธรรมชาติเพื่อลดความซ้ำซ้อน",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "เล่นแอนิเมชันไอคอน",
  T_44_XXJ_WS_OFFSET_D: "การตั้งค่าตำแหน่งฐานเริ่มต้น",
  T_44_XXJ_WS_ONFIRE_D: "เริ่มดำเนินเหตุการณ์เมื่อเริ่มยิงหรือโจมตีด้วยหมัดหรืออาวุธระยะประชิด",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "ดำเนินเหตุการณ์เมื่อผู้เล่นยืนขึ้นจากการคลาน",
  T_44_XXJ_WS_ONSTARTFIRE_D: "เริ่มกิจกรรมเมื่อผู้เล่นกดปุ่มยิง",
  T_44_XXJ_WS_OPTION: "ตัวเลือก",
  T_44_XXJ_WS_PASSIVESKILLHUD: "HUD สกิลติดตัว",
  T_44_XXJ_WS_PHYSICALMOVER: "การย้ายทางกายภาพ",
  T_44_XXJ_WS_PHYSICALMOVER_D: "ผู้เล่นบนแพลตฟอร์มนี้จะติดตามการเคลื่อนไหวและการหมุนโดยอัตโนมัติ",
  T_44_XXJ_WS_PHYSICALOBJECT: "วัตถุทางกายภาพ",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "สามารถใช้แรงกับสิ่งนี้",
  T_44_XXJ_WS_PI: "ค่าพาย",
  T_44_XXJ_WS_PI_D: "ค่าพาย",
  T_44_XXJ_WS_PLAYERS: "รายชื่อผู้เล่น",
  T_44_XXJ_WS_PLAYERS_D: "ลำดับผู้เล่น",
  T_44_XXJ_WS_PLAYERSKILLID: "เลขสกิลตัวละคร",
  T_44_XXJ_WS_PLAYERSKILLID_D: "ไอดีทักษะตัวละครใน AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "ท่าทางล่าสุดก่อนผู้เล่นยืนขึ้น",
  T_44_XXJ_WS_PRINT: "พิมพ์",
  T_44_XXJ_WS_PRINTERROR: "ผิดพลาดในการพิมพ์",
  T_44_XXJ_WS_PRINTERROR_D: "พิมพ์ข้อมูลเป้าหมายเป็นข้อผิดพลาดที่คอนโซล",
  T_44_XXJ_WS_PRINTWARNING: "คำเตือนการพิมพ์",
  T_44_XXJ_WS_PRINTWARNING_D: "พิมพ์ข้อมูลเป้าหมายเป็นคำเตือนที่คอนโซล",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "ลำดับความสำคัญค่าสกินผู้เล่น",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "ให้ลำดับความสำคัญกับการกำหนดค่าสกินของผู้เล่นนอกเกม",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "การอ่านเนื้อหาในเซลล์ของแถวโดยใช้ตัวเลขในคอลัมน์และคีย์",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "ล้างค่าสกินกระเป๋าของผู้เล่น",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "ลบส่วนประกอบจากเอนทิตี้ รองรับเฉพาะส่วนประกอบที่กำหนดเอง",
  T_44_XXJ_WS_RESETBAGSKINID_D: "รีเซตการกำหนดค่าสกินกระเป๋าของผู้เล่นเป็นค่าที่ไม่สามารถเข้าการแข่งขันได้",
  T_44_XXJ_WS_SETBAGSKINID_D: "ตั้งค่าสกินกระเป๋าของผู้เล่น",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "เอนทิตีที่สนับสนุนกการเปลี่ยนรูปร่าง ส่วนของกระดูก ผู้เล่น และส่วนประกอบของจุดยึด",
  T_44_XXJ_WS_SHOWBACKGROUND: "แสดงภาพพื้นหลัง",
  T_44_XXJ_WS_SKINID_D: "ตั้งค่าสกินและเลขสกินกระเป๋า",
  T_44_XXJ_WS_SPEED_D: "ความเร็วการเล่น",
  T_44_XXJ_WS_TARGET: "เป้าหมาย",
  T_44_XXJ_WS_TARGET_D: "เป้าหมาย",
  T_44_XXJ_WS_TITLE: "หัวข้อ",
  T_44_XXJ_WS_TYPEID_D: "รหัสประเภทของส่วนประกอบ รองรับเฉพาะส่วนประกอบที่กำหนดเอง",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "อัปโหลดผลการแข่งขันที่กำหนดเอง",
  T_44_XXJ_WS_WARNINGCSVTYPE: "ประเภทไม่ถูกต้อง ไม่สามารถอ่านค่าได้",
  T_44_XXJ_WS_X_D: "แกน X",
  T_44_XXJ_WS_Y_D: "แกน Y",
  T_44_XYL_WS_CTZSAFEZONE: "ปรับแต่งพื้นที่ปลอดภัย",
  T_44_XYL_WS_CTZSAFEZONEDESC: "สร้างจุดเริ่มต้นและจุดสิ้นสุดของพื้นที่ปลอดภัยขึ้นอยู่กับตำแหน่งและคุณสมบัติที่กำหนด",
  T_44_XYL_WS_HEMISPHERICALSHELL: "เปลือกทรงกลมครึ่งวงกลม",
  T_44_XYL_WS_QUARTERCYLINDER: "ท่อนรูปสี่เหลี่ยม",
  T_44_XYL_WS_SQUAREPYRAMID: "พีระมิดสี่เหลี่ยม",
  T_44_XYL_WS_TORUS: "ลูกโคมรูปแหลม",
  T_44_XYL_WS_TRIANGULARPYRAMID: "พีระมิดสามเหลี่ยม",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "เพิ่มแผนที่บันทึกกิจกรรม",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "เพิ่ม log กิจกรรมของผู้เล่น",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "ปรับแต่ง Log กิจกรรมเพื่อใช้สำหรับการวิเคราะห์ข้อมูล",
  T_44_YU_WS_ITEM366: "กำแพงทหาร A",
  T_44_YU_WS_ITEM367: "กำแพงทหาร B",
  T_44_YU_WS_ITEM368: "กำแพงทหาร C",
  T_44_YU_WS_ITEM369: "กำแพงทหาร D",
  T_44_YU_WS_ITEM370: "หน้าต่างทหาร A",
  T_44_YU_WS_ITEM371: "หน้าต่างทหาร B",
  T_44_YU_WS_ITEM372: "หน้าต่างทหาร C",
  T_44_YU_WS_ITEM373: "ประตูทหาร A",
  T_44_YU_WS_ITEM374: "ประตูทหาร B",
  T_44_YU_WS_ITEM375: "มุมหลังคาทหาร A",
  T_44_YU_WS_ITEM376: "มุมหลังคาทหาร B",
  T_44_YU_WS_ITEM377: "บันไดทหาร A",
  T_44_YU_WS_ITEM378: "บันไดทหาร B",
  T_44_YU_WS_ITEM379: "เสาทหาร A",
  T_44_YU_WS_ITEM380: "ราวมือจับทหาร A",
  T_45_C_WEAPON_CUST_ENTRANCE: "ปรับแต่ง",
  T_45_CJ_TREATMENTGUN_Y_N: "Heal Pistol-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "แคสซี่",
  T_45_H_EMOTE_MVPDANCE_N: "เดินอย่างแชมป์",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "ตรวจสอบ",
  T_45_HL_Moderation_fail_1: "ขออภัย โปรเจกต์ที่คุณส่งเข้ามา ไม่ผ่านการตรวจสอบ",
  T_45_HL_Moderation_fail_2: "เกี่ยวข้อง",
  T_45_HL_Moderation_fail_3: "สาเหตุ:",
  T_45_HL_Moderation_fail_Location_1: "เนื้อหาเกม",
  T_45_HL_Moderation_fail_reason_1: "เนื้อหาที่มีคำพูดที่ไม่เหมาะสม",
  T_45_HL_Moderation_fail_reason_10: "การละเมิดกฎระเบียบชุมชน",
  T_45_HL_Moderation_fail_reason_11: "ผลกระทบทางลบต่อการเงินภายในเกมและการละเมิดทรัพย์สิน",
  T_45_HL_Moderation_fail_reason_2: "เนื้อหาที่ไม่เหมาะสม",
  T_45_HL_Moderation_fail_reason_3: "เกี่ยวกับการเมือง",
  T_45_HL_Moderation_fail_reason_4: "ข้อมูลผิดพลาด",
  T_45_HL_Moderation_fail_reason_5: "การละเมิดลิขสิทธิ์",
  T_45_HL_Moderation_fail_reason_6: "การละเมิดความเป็นส่วนตัว",
  T_45_HL_Moderation_fail_reason_7: "ปัญหาความปลอดภัย",
  T_45_HL_Moderation_fail_reason_8: "คำพูดที่เกี่ยวกับการเกลียดชัง",
  T_45_HL_Moderation_fail_reason_9: "สแปม",
  T_45_HL_Moderation_fail_reason_999: "ปัญหาอื่นๆ",
  T_45_JH_WS_CLEMPTYOBJECT: "หมวดวัสดุ",
  T_45_JH_WS_PETSWITCH1: "แสดงคู่หูในการแข่งขันหรือไม่",
  T_45_QL_CSFPP_DES: "กำจัดศัตรูทุกคนกับภาพมุมมองบุคคลที่หนึ่งในโหมด 4v4 พิเศษนี้!",
  T_45_QL_CSFPP_NAME: "4v4: มุมมองบุคคลที่หนึ่ง",
  T_45_QL_CSFPP_RANKNAME: "บุคคลที่หนึ่ง",
  T_45_SJ_WS_REVIEW_23: "เนื้อหาเกม",
  T_45_SJ_WS_REVIEW_24: "{0} เกี่ยวข้องกับ {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} เกี่ยวข้องกับ {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]แตะเพื่อดูรายละเอียด >>[-]",
  T_45_SJ_WS_REVIEW_27: "ไม่อนุญาต",
  T_45_SJ_WS_REVIEW_28: "รีวิวและคำติชม",
  T_45_SJ_WS_REVIEW_29: "เนื้อหานี้มีการละเมิด {0} ครั้ง",
  T_45_SJ_WS_REVIEW_31: "ไม่อนุญาต",
  T_45_SJ_WS_REVIEW_32: "การตรวจสอบล้มเหลวเนื่องจากข้อยกเว้นของเซิร์ฟเวอร์",
  T_45_SJ_WS_REVIEW_TITLE: "รายละเอียดการฝ่าฝืน",
  T_45_SJ_WS_VAULTTRIGGER_DES: "ตรวจพบการกระโดด (กระโดดข้ามสิ่งกีดขวาง)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "ระยะทางกระโดด",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "ดัดแปลงระยะทางการกระโดด",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "ความสูงกระโดดข้าม",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "ควบคุมความสูงของการขยับขึ้นและลงเมื่อกระโดดข้าม",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "ตรวจพบการกระโดด",
  T_45_TYC_CL_TEMPLATE_WS: `โหมดการคัดออกที่ผู้เล่นต้องเอาชนะทุกทีมตรงข้ามในศึกสุดวุ่นวายเพื่อคว้าชัยชนะ
คุณสามารถตั้งกฎการเล่นและแก้ไขพารามิเตอร์การเล่นเกมได้ตามต้องการ`,
  T_45_W_SPEEDMODE_FLIGHT_N: "ยานบิน",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = โจมตีอัตโนมัติ, 1 = รูปแบบป้องกัน, 2 = ไม่โจมตี",
  T_45_XXJ_WS_ADDFRIEND: "เพื่มเพื่อน",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "อัตโนมัติ",
  T_45_XXJ_WS_BASEDATA: "ฐานข้อมูล",
  T_45_XXJ_WS_BOTH: "ทั้งคู่",
  T_45_XXJ_WS_BYHIERARCHY: "ตามลำดับชั้น",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "ตามลำดับความสำคัญจากสูงไปต่ำ",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "ตามลำดับความสำคัญจากต่ำไปสูง",
  T_45_XXJ_WS_CAMERA: "มุมกล้อง",
  T_45_XXJ_WS_CAMERATYPE: "ประเภทมุมกล้อง",
  T_45_XXJ_WS_CENTERINVISIBLE: "ปิดการมองเห็นศูนย์กลาง",
  T_45_XXJ_WS_CLIENT: "Client",
  T_45_XXJ_WS_COLLIDERID: "รหัสซ้ำ",
  T_45_XXJ_WS_COLLIDERID_D: "รหัสซ้ำ",
  T_45_XXJ_WS_COMPONENT: "ส่วนประกอบ",
  T_45_XXJ_WS_CURRENTCAMERA: "มุมกล้องปัจจุบัน",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "ปรับเเรงกระเเทก",
  T_45_XXJ_WS_DOUBLE: "คูณสอง",
  T_45_XXJ_WS_DUMP: "ขว้าง",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "เปิดใช้งานการเคลื่อนไหวกลางอากาศ",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "เปิดใช้งานการหมุนกับแรงโน้มถ่วง",
  T_45_XXJ_WS_ENUM: "Enum",
  T_45_XXJ_WS_EVENT: "กิจกรรม",
  T_45_XXJ_WS_FILLAMOUNT: "เติมจำนวน",
  T_45_XXJ_WS_FILLDIR: "กำหนดทิศทาง",
  T_45_XXJ_WS_FIRETYPE: "รูปแบบการยิง",
  T_45_XXJ_WS_FIRETYPE_D: "ประเภทการยิง",
  T_45_XXJ_WS_FIXEDDELTATIME: "Fixed Delta Time",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "The fixed time interval for frame updates in milliseconds",
  T_45_XXJ_WS_FORWARD: "ไปข้างหน้า",
  T_45_XXJ_WS_FORWARD_D: "ทิศทางของแกน Z ในระบบ",
  T_45_XXJ_WS_FUNCTIONTYPE: "ประเภทของฟังก์ชัน",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "ประเภทของฟังก์ชัน",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "ทิศทางทางเล็งของผู้เล่น",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "แสดงเวลาปัจจุบัน",
  T_45_XXJ_WS_GRADIENT: "ไล่ระดับสี",
  T_45_XXJ_WS_GRADIENTBOTTOM: "ไล่ระดับสีพื้นล่าง",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Gradient Bottom Alpha",
  T_45_XXJ_WS_GRADIENTTOP: "ไล่ระดับสีด้านบน",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Gradient Top Alpha",
  T_45_XXJ_WS_HITPOSITION_D: "ตำแหน่งที่ถูกโจมตีจากกระสุน",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "เครืองมือปรับรูปแบบปุ่มกิจกรรม",
  T_45_XXJ_WS_INVERTFILL: "Invert Fill",
  T_45_XXJ_WS_ISGROUNDED: "มีการทับซ้อน",
  T_45_XXJ_WS_ISSILENCE: "ปิดเเจ้งเตือน",
  T_45_XXJ_WS_ISSILENCE_D: "อยู่ในโหมดปิดการแจ้งเตือนหรือไม่",
  T_45_XXJ_WS_ISSINGLESHOT: "ยิงนัดเดียว",
  T_45_XXJ_WS_ISSINGLESHOT_D: "เป็นการยิงครั้งเดียวหรือไม่",
  T_45_XXJ_WS_JUMPHEIGHT: "กระโดดสูง",
  T_45_XXJ_WS_JUMPHEIGHT_D: "ความสูงการกระโดด",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "ประเภทของการจัดเรียง",
  T_45_XXJ_WS_LIGHT_D: "แสง",
  T_45_XXJ_WS_LOCAL: "Local",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "จำนวนกระโดดสูงสุด",
  T_45_XXJ_WS_MODULE: "Module",
  T_45_XXJ_WS_NONE: "ไม่มี",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Execute the command each time before the entity deals damage",
  T_45_XXJ_WS_ONDISABLE_D: "ทำงานเมื่อเอนทิตี้ถูกปิดใช้งาน",
  T_45_XXJ_WS_ONEACHLOOP_D: "ทำงานทุกครั้งเมื่อการเล่นถูกวนลูป มีผลเฉพาะด้าน Client สำหรับเอนทิตี้ เช่น เอฟเฟ็กต์เสียงและเอฟเฟ็กต์พิเศษ",
  T_45_XXJ_WS_ONENABLE_D: "ทำงานเมื่อเอนทิตี้ถูกเปิดใช้งาน",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "เมื่อเข้าเกมจะรีเซตเป็น 30 เฟรมอัตโนมัติ",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "จะส่งผลต่อกิจกรรม หากมีการเพิ่มหรือลบเพื่อน",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "ทำงานเมื่อหยุดเกมชั่วขณะ",
  T_45_XXJ_WS_ONGAMERESUME_D: "ทำงานอีกครั้งเมื่อกลับเข้าสู่เกม",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "เมื่อผู้เล่นหยุดวิ่ง",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "เมื่อผู้เล่นหยุดโต้คลื่น",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "เมื่อผู้เล่นกำลังโต้คลื่น",
  T_45_XXJ_WS_PHYSICALLAYER_D: "ปรับแต่งระดับชั้น จาก 0 ถึง 31",
  T_45_XXJ_WS_PLATFORMTYPE: "ประเภทของแพลทฟอร์ม",
  T_45_XXJ_WS_PLATFORMTYPE_D: "ประเภทของแพลตฟอร์ม",
  T_45_XXJ_WS_PLAYER: "ผู้เล่น",
  T_45_XXJ_WS_PLAYERCCT: "Player CCT",
  T_45_XXJ_WS_PLAYERCCT_D: "ใช้ระบบฟิสิกส์ควบคุมตัวละคร เฉพาะตัวละคร Free Fire เท่านั้น",
  T_45_XXJ_WS_PRIORITY: "ความสำคัญ",
  T_45_XXJ_WS_REMAINMULTINUM: "จำนวนการกระโดดคงเหลือ",
  T_45_XXJ_WS_REPORT: "รายงาน",
  T_45_XXJ_WS_RIGHT: "ขวา",
  T_45_XXJ_WS_RIGHT_D: "ทิศทางของแกน X ในระบบ",
  T_45_XXJ_WS_SERVER: "เซิร์ฟเวอร์",
  T_45_XXJ_WS_SINGLE: "คนเดียว",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "ประเภทของปุ่มกิจกรรม",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "รูปแบบปุ่มกิจกรรม",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "ประเภทของปุ่มกิจกรรม",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "ประเภทของปุ่มกิจกรรม",
  T_45_XXJ_WS_SORTTYPE_D: `รูปแบบการเรียง: 
จากมากไปน้อย และจากน้อยไปหามาก`,
  T_45_XXJ_WS_SPEEDWHILEAIMING: "ความเร็วการเคลื่อนที่ขณะเล็ง",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "ความเร็วในการเคลื่อนที่เมื่อไม่เล็งเป้า",
  T_45_XXJ_WS_STRINGORLOCSTRING: "String or Localized String",
  T_45_XXJ_WS_TRIPLE: "สามเท่า",
  T_45_XXJ_WS_UP: "ขึ้น",
  T_45_XXJ_WS_UP_D: "ทิศทางของแกน Y ในระบบ",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "ใช้ค่าแรงกระแทกที่เลือก",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "โยนสัญญาณพลุสู่พื้นที่ที่กำหนดเพื่อเรียกสุ่มพาหนะ",
  T_45_ZD_VEHICLEDROP_R_NAME: "ยานพาหนะลึกลับ",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "ไลล่า",
  T_46_HJ_SHARE_GAMEDURATION: "เวลาเล่น",
  T_46_HJ_WS_SHAREBY: "โดย {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "โหมด",
  T_46_HJ_WS_SHARETEAM: "ทีม",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "ป๊อปไฮสคูล (กางเกง)",
  T_46_HX_H_SCHOOL_VN: "ป๊อปไฮสคูล (หัว)",
  T_46_HX_S_SCHOOL_VN: "ป๊อปไฮสคูล (รองเท้า)",
  T_46_HX_T_SCHOOL_VN: "ป๊อปไฮสคูล (เสื้อ)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "วิธีเล่น",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "อื่นๆ",
  T_46_XXJ_WS_ACTUALPOSITION: "ตำแหน่งจริง",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "เพิ่มวัตถุไปยังการตรวจสอบด้วยการซิงโครไนซ์ AOI นอกสายตา",
  T_46_XXJ_WS_APPEARANCE: "รูปลักษณ์",
  T_46_XXJ_WS_APPEARANCERES: "ทรัพยากรรูปลักษณ์",
  T_46_XXJ_WS_BECOME: "เปิดใช้งาน",
  T_46_XXJ_WS_BRAKETORQUE_D: "แรงม้าที่เพิ่มให้กับพาหนะเมื่อใช้เบรก/ถอยหลัง",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "ประเภทของการจำกัดมุมการหมุนของกล้อง",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "ล้างวัตถุที่ถูกตรวจสอบทั้งหมดของเป้าหมาย",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "ความเสียหายจากการชนสูงสุดที่ใช้ในการคำนวณความเสียหาย",
  T_46_XXJ_WS_CRASHMAXSPEED: "ชนความเร็วสูงสุด",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "ใช้สำหรับคำนวณความเสียหายจากการชน เมื่อความเร็วเกินกว่านี้ จะไม่มีการเพิ่มความเสียหายอีก",
  T_46_XXJ_WS_CRASHMESSFACTOR: "ปัจจัยการชน",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "พารามิเตอร์ที่ใช้ในสูตรคำนวณความเสียหายจากการชน",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "ความเสียหายขั้นต่ำที่ใช้ในการคำนวณความเสียหาย",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "ขีดจำกัดการอ่านและเขียนข้อมูลถูกเกินแล้ว",
  T_46_XXJ_WS_DB_PARAMERROR_D: "พารามิเตอร์ผิดปกติ",
  T_46_XXJ_WS_DB_TIMEOUT_D: "การจัดเก็บข้อมูลหมดเวลา ส่วนใหญ่ใช้กับการอ่านและเขียนตอนนี้",
  T_46_XXJ_WS_DELTA: "เดลต้า",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "แก้ไขรูปลักษณ์",
  T_46_XXJ_WS_ENDVALUE_D: "จุดหมายปลายทาง",
  T_46_XXJ_WS_ENGINETORQUE_D: "แรงม้าที่ส่งไปยังพาหนะเมื่อเหยียบคันเร่ง",
  T_46_XXJ_WS_ERRORCODE_D: "รหัสข้อผิดพลาด",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "มุมออยเลอร์เป็นเวกเตอร์สามมิติ",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "แปลงมุมยูเลอร์เป็นเวกเตอร์ 3 มิติ",
  T_46_XXJ_WS_EXPIRE: "หมดอายุ",
  T_46_XXJ_WS_FEMALEAVATAR: "ตัวละครหญิง",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "รับวันหมดอายุสมาชิก",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "ถ้าผู้สังเกตการณ์กำลังเฝ้าดูวัตถุหรือไม่",
  T_46_XXJ_WS_HELICOPTER: "ยานบิน",
  T_46_XXJ_WS_HELICOPTER_D: "พาหนะบินได้ประเภทหนึ่ง",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "ข้อจำกัดการบังคับเลี้ยวความเร็วสูง",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "มุมเลี้ยวสูงสุดขณะอยู่ในสภาวะความเร็วสูง",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "มุมเลี้ยวความเร็วสูงขณะใช้ความเร็ว",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "เกณฑ์ความเร็วสำหรับมุมเลี้ยวสูงสุดที่ความเร็วสูงสุด",
  T_46_XXJ_WS_IDLE: "แอนิเมชันขณะพัก",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "เบรกขณะว่าง",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "เมื่อไม่ได้ขับพาหนะ ให้ลดความเร็วโดย (การเบรกขณะว่าง) x (แรงบิดเบรก)",
  T_46_XXJ_WS_INTTOFLOAT: "แปลง Int เป็นค่า Float",
  T_46_XXJ_WS_INTTOFLOAT_D: "แปลงค่าตัวเลขเป็นค่า Float",
  T_46_XXJ_WS_ISPREMIUM: "เป็นสมาชิก",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "ชื่อกระดานอันดับในฐานข้อมูล",
  T_46_XXJ_WS_MALEAVATAR: "ตัวละครผู้ชาย",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "บุคลิกภาพ AI",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "รูปลักษณ์ UMA ใหม่",
  T_46_XXJ_WS_NONE_D: "ไม่มีผิดพลาด",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "วัตถุ NPC",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "เคล็ดลับ: NPC มนุษย์มักจะมีโมเดลการชนเป็นแคปซูลที่สูง 1.4 เมตรและมีรัศมี 0.25 เมตร คู่หู NPC มักจะมีโมเดลการชนเป็นแคปซูลที่สูง 1 เมตรและมีรัศมี 0.4 เมตร",
  T_46_XXJ_WS_OBSERVER_D: "ผู้สังเกตการณ์ที่กำลังเฝ้าดูวัตถุ",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "เข้าสู่สมาชิกคราฟท์แลนด์",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "ยกเลิกสมาชิกคราฟท์แลนด์",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "เปิดสมาชิกคราฟท์แลนด์",
  T_46_XXJ_WS_PERSONA: "บุคคล",
  T_46_XXJ_WS_PERSONACENTER: "ศูนย์กลางส่วนบุคคล",
  T_46_XXJ_WS_PET: "คู่หู",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "ผู้เล่น หรือ เปลี่ยนร่าง",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "ชื่อเล่นสำหรับผู้เล่นและเอนทิตี้ Transform",
  T_46_XXJ_WS_PREMIUM: "สมาชิก",
  T_46_XXJ_WS_PREMIUMSTATUS: "สถานะการเป็นสมาชิก",
  T_46_XXJ_WS_PROXYOBSERVER: "ผู้สังเกตการณ์พร็อกซี่",
  T_46_XXJ_WS_PROXYOBSERVER_D: "ตัวแทนผู้สังเกตการณ์",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "ลบวัตถุที่ถูกเฝ้าดูและยกเลิกการซิงโครไนซ์ AOI นอกสายตา",
  T_46_XXJ_WS_RENEWAL: "ต่ออายุ",
  T_46_XXJ_WS_ROTATEVECTOR: "หมุนเวกเตอร์",
  T_46_XXJ_WS_ROTATEVECTOR_D: "หมุนเวกเตอร์ตามควอเทอร์เนียน",
  T_46_XXJ_WS_SKIN: "อุปกรณ์",
  T_46_XXJ_WS_STARTVALUE_D: "ค่าแหล่งที่มา",
  T_46_XXJ_WS_STATUS: "สถานะ",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "เปลี่ยนผู้สังเกตการณ์พร็อกซีของผู้ใช้",
  T_46_XXJ_WS_TARGET_D: "เป้าหมายที่ถูกติดตาม",
  T_46_XXJ_WS_USER_D: "ผู้ใช้งาน",
  T_46_XXJ_WS_VALUE: "มูลค่า",
  T_46_XXJ_WS_VALUE_D: "เวกเตอร์",
  T_46_XYL_WS_CTZSAFEZONEEND: "จุดสิ้นสุดพื้นที่ปลอดภัย",
  T_46_XYL_WS_RESOURCETYPE1: "โครงสร้างพื้นฐาน",
  T_46_XYL_WS_RESOURCETYPE1_1: "เรขาคณิต",
  T_46_XYL_WS_RESOURCETYPE1_2: "ภาพและเสียง",
  T_46_XYL_WS_RESOURCETYPE2: "ไอเทมในฉาก",
  T_46_XYL_WS_RESOURCETYPE2_2: "อุปกรณ์การต่อสู้",
  T_46_XYL_WS_RESOURCETYPE3: "ธรรมชาติ",
  T_46_XYL_WS_RESOURCETYPE4: "องค์ประกอบโมดูลาร์",
  T_46_XYL_WS_TYPEOTHERPROP: "เบ็ดเตล็ด",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "คอนเทนเนอร์และกล่อง",
  T_47_CJ_FOREGRIP_SOFT_N: "ด้ามจับขั้นสูง",
  T_47_CJ_MAGEZINE_FAST_N: "แมกกาซีนขั้นสูง",
  T_47_CJ_STOCK_FAST_N: "พานท้ายขั้นสูง",
  T_47_GT_WS_USERMANUAL: "คู่มือผู้ใช้",
  T_47_HJ_WS_VFX_FOG: "เอฟเฟ็กต์หมอก",
  T_47_HJ_WS_VFX_LIGHTING: "เอฟเฟ็กต์แสง",
  T_47_HJ_WS_VFX_TRAILING: "เอฟเฟ็กต์ตามตัว",
  T_47_HL_CL_CREATOR_LABEL1: "บุคคลต้นแบบในชุมชน",
  T_47_HL_CL_MAP_LABEL1: "เลือกผลงานบุคคลต้นแบบในชุมชน",
  T_47_JH_WS_MODERATION_REASON12: "เกี่ยวกับการพนัน",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "ความร่วมมือกับ NARUTO SHIPPUDEN",
  T_47_SD_RES_MATERIAL: "ไฟล์วัสดุ",
  T_47_SD_RES_MESH: "ตาข่าย",
  T_47_SD_WS_MAPTAG_AI: "สร้างแผนที่ด้วย AI",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "มีดพิเศษที่ติดอยู่กับจุดที่ถูกปา หลังจากถูกขว้างไปแล้วจะเกิดการระเบิดเพลิงหลังจากหน่วงเวลาเล็กน้อยเพื่อสร้างความเสียหายจากการเผาไหม้",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "คุไนเพลิง",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "มีดพิเศษที่ติดอยู่กับจุดที่ปา หลังจากถูกโยนไปแล้วจะเกิดสายฟ้าฟาดหลังจากเวลาผ่านไปสั้น ๆ เพื่อทำให้เป้าหมายเป็นอัมพาต",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "คุไนสายฟ้า",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "มีดพิเศษที่ยึดติดกับจุดที่กระทบหลังจากถูกขว้างออกไป ก่อให้เกิดพายุลมหลังจากผ่านไปสักครู่เพื่อชะลอเป้าหมายที่เคลื่อนที่เข้าหาศูนย์กลาง",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "คุไนสายลม",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "ดาวกระจายชนิดหนึ่งที่เหมาะสำหรับการต่อสู้ระยะกลางถึงไกล การขว้างหนึ่งครั้งจะปล่อยชิ้นส่วนหนึ่งชิ้นอย่างรวดเร็ว  สร้างความเสียหายอย่างมาก",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "ดาวกระจายทรงพลัง",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "ดาวกระจายชนิดหนึ่งที่เหมาะสำหรับการต่อสู้ระยะใกล้ถึงกลาง มีโหมดการโจมตีสองแบบ การขว้างหนึ่งครั้งปล่อยสามชิ้น สร้างความเสียหายเล็กน้อย",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "ดาวกระจายจิ๋ว",
  T_47_XXJ_WS_ACTION: "การกระทำ",
  T_47_XXJ_WS_AOISETTING: "การตั้งค่า AOI",
  T_47_XXJ_WS_BAGSKINTYPE: "ประเภทสกินกระเป๋า",
  T_47_XXJ_WS_CLEARMEMORY: "ล้างหน่วยความจำ",
  T_47_XXJ_WS_CLNPC: "NPC ขั้นสูง",
  T_47_XXJ_WS_CLOTHTYPE: "ประเภทสกินชุด",
  T_47_XXJ_WS_COMMON_ERROR: "ข้อผิดพลาดทั่วไป",
  T_47_XXJ_WS_CONTENT: "เนื้อหา",
  T_47_XXJ_WS_CREATERANDOMSEED: "สร้าง Seed แบบสุ่ม",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "เปอร์เซ็นต์ที่ผ่านไปแล้ว",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "เปิดใช้งานฟีเจอร์หมอก",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "เปิดฟีเจอร์หมุนแสง",
  T_47_XXJ_WS_ERRORCODE: "รหัสข้อผิดพลาด",
  T_47_XXJ_WS_EXPONENTIAL: "เอ็กซ์โพเนนเชียล",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "ยกกำลัง 2 แบบเอ็กซ์โพเนนเชียล",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "สร้างห้องไม่สำเร็จ: ไม่มีไอดี Persona ที่ใช้ได้",
  T_47_XXJ_WS_FOG: "หมอก",
  T_47_XXJ_WS_FOGDENSITY: "ความหนาแน่นของหมอก",
  T_47_XXJ_WS_FOGENDDISTANCE: "สิ้นสุดระยะหมอก",
  T_47_XXJ_WS_FOGMODE: "โหมดหมอก",
  T_47_XXJ_WS_FOGMODETYPE: "โหมดหมอก",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "ระยะเริ่มต้นของหมอก",
  T_47_XXJ_WS_HEIGHTSCALE: "มาตราส่วนความสูง",
  T_47_XXJ_WS_ISVISIBLE: "มองเห็นได้",
  T_47_XXJ_WS_JOINNEWTEAM: "เข้าร่วมทีมใหม่",
  T_47_XXJ_WS_JOINTEAM: "เข้าร่วมทีม",
  T_47_XXJ_WS_LIGHTROTATE: "การหมุนแสง",
  T_47_XXJ_WS_LINEAR: "เชิงเส้น",
  T_47_XXJ_WS_LLMCHATHUD: "UI Persona Chat",
  T_47_XXJ_WS_NEWTEAM: "ทีมใหม่",
  T_47_XXJ_WS_NEXT: "ต่อไป",
  T_47_XXJ_WS_NPC_TIP: "คุณสามารถแก้ไขรูปลักษณ์ของ NPC และทำให้ NPC เล่นแอนิเมชันได้",
  T_47_XXJ_WS_OBSERVERS: "ผู้สังเกตการณ์",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "เมื่อผู้เล่นส่งข้อความผ่าน UI Persona Chat",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "เมื่อสถานะสมาชิกเปลี่ยนแปลง",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "เมื่อได้รับการกระทำจาก Persona",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "เมื่อได้รับเนื้อหาจาก Persona",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "เมื่อได้รับการเสร็จสิ้นจาก Persona",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "เมื่อได้รับสถานะจาก Persona",
  T_47_XXJ_WS_PARTICLESID: "เลขพาร์ติเคิล",
  T_47_XXJ_WS_PERSONAAVATAR: "ภาพโปรไฟล์ตัวละคร",
  T_47_XXJ_WS_PERSONAID: "รหัสบุคคล",
  T_47_XXJ_WS_PERSONANICKNAME: "ชื่อเล่นของ Persona",
  T_47_XXJ_WS_PLAYERORNPC: "ผู้เล่นหรือ NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "ปิดรับสมาชิก",
  T_47_XXJ_WS_RANDOM: "สุ่ม",
  T_47_XXJ_WS_SEED: "Seed",
  T_47_XXJ_WS_SENDER: "ผู้ส่ง",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "เซตเพอร์โซนาออบเซิร์ฟเวอร์",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "เซตผู้เล่นสามารถออกกลางคันได้",
  T_47_XXJ_WS_SHOULDREPLY: "ควรตอบกลับ",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "แสดงการตอบกลับของระบบ",
  T_47_XXJ_WS_SPOTANGLE: "มุมมอง",
  T_47_XXJ_WS_SPOTLIGHT: "สปอตไลต์",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "ส่งข้อความระบบถึงตัวละคร",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "ระบบสตรีมข้อความถึงบุคคล",
  T_47_XXJ_WS_TARGETTEAM: "เป้าหมายทีม",
  T_47_XXJ_WS_THISENTITY: "เอนทิตี้นี้",
  T_47_XXJ_WS_USERAVATAR: "ภาพโปรไฟล์ผู้ใช้",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "ส่งข้อความถึงผู้เล่น",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "สตรีมข้อความผู้ใช้ไปยังตัวตน",
  T_47_XXJ_WS_USERNICKNAME: "ชื่อเล่นผู้ใช้",
  T_47_XXJ_WS_VEHICLESKINTYPE: "ประเภทสกินพาหนะ",
  T_47_XXJ_WS_WEAPONSKINTYPE: "ประเภทสกินอาวุธ",
  T_47_XYL_NB_UGC_EFFECT001: "เอฟเฟ็กต์ภาพกระสุนวงจักร",
  T_47_XYL_NB_UGC_EFFECT002: "เอฟเฟ็กต์ภาพพันปักษา",
  T_47_XYL_NB_UGC_EFFECT003: "เอฟเฟ็กต์ภาพแก่นซากุระ",
  T_47_XYL_NB_UGC_EFFECT004: "เอฟเฟ็กต์ภาพคาถาเพลิง ลูกไฟยักษ์",
  T_47_XYL_NB_UGC_EFFECT005: "เอฟเฟ็กต์ภาพคาถาน้ำ ระเบิดมังกรวารี",
  T_47_XYL_NB_UGC_EFFECT006: "เอฟเฟ็กต์ภาพคาถาลม กระแสมหาวายุ",
  T_47_XYL_NB_UGC_EFFECT007: "เอฟเฟ็กต์ภาพบอลสัตว์หาง",
  T_47_XYL_NB_UGC_EFFECT008: "เอฟเฟ็กต์ภาพอักขระสาป",
  T_47_XYL_UGC_CRAFTLANDSHOP: "ร้านค้าทรัพยากร",
  T_47_XYL_UGC_DONKEYCART: "รถลากลา",
  T_47_XYL_UGC_SPOTLIGHT: "สปอตไลท์",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "มุมสปอตไลท์",
  T_48_H_EMOTE_WATERFEST25_N: "ท่าเต้นสุดหล่อสาดน้ำ",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "มอเตอร์ไบก์สุดหล่อสาดน้ำ",
  T_48_HJ_AC_STATENOTEXIST: "สถานะ {0} ไม่มีอยู่ในตัวควบคุมแอนิเมชัน",
  T_48_HL_CODESCRIPT: "สคริปต์โค้ด",
  T_48_HL_GLOBAL_VAR: "ชื่อตัวแปรทั่วโลก",
  T_48_HL_GRAPH: "บล็อก",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "กระดานผู้นำ",
  T_48_HL_LOCAL_VAR: "ชื่อตัวแปรภูมิภาค",
  T_48_HL_LOCALIZATION: "ชื่อการแปลภาษา",
  T_48_HL_OPEN_ATTRIBUTES: "เปิดชื่อคุณสมบัติ",
  T_48_HX_A_WATERFEST25: "สุดหล่อสาดน้ำ (หน้ากาก)",
  T_48_HX_B_WATERFEST25: "สุดหล่อสาดน้ำ (กางเกง)",
  T_48_HX_F_B_BLACKDRESS: "Black Goddess (กางเกง)",
  T_48_HX_F_H_BLACKDRESS: "Black Goddess (หัว)",
  T_48_HX_F_HA_BLACKDRESS: "Black Goddess (ลายเพ้นท์)",
  T_48_HX_F_S_BLACKDRESS: "Black Goddess (รองเท้า)",
  T_48_HX_F_T_BLACKDRESS: "Black Goddess (เสื้อ)",
  T_48_HX_H_WATERFEST25: "สุดหล่อสาดน้ำ (หัว)",
  T_48_HX_HA_WATERFEST25: "สุดหล่อสาดน้ำ (ลายเพ้นท์)",
  T_48_HX_M_A_BLACKDRESS: "Black God (หน้ากาก)",
  T_48_HX_M_B_BLACKDRESS: "Black God (กางเกง)",
  T_48_HX_M_H_BLACKDRESS: "Black God (หัว)",
  T_48_HX_M_HA_BLACKDRESS: "Black God (ลายเพ้นท์)",
  T_48_HX_M_S_BLACKDRESS: "Black God (รองเท้า)",
  T_48_HX_M_T_BLACKDRESS: "Black God (เสื้อ)",
  T_48_HX_S_WATERFEST25: "สุดหล่อสาดน้ำ (รองเท้า)",
  T_48_HX_T_WATERFEST25: "สุดหล่อสาดน้ำ (เสื้อ)",
  T_48_JH_WS_STRINGDESC: "ใส่ย่อหน้าของข้อความหรือสตริงอื่น ๆ บางวิดเจ็ตสามารถแสดงข้อความที่มีสีสันได้ ใช้ข้อความสีด้วยรูปแบบต่อไปนี้: [#XXXXXX] ข้อความ ข้อความ [-] ซึ่ง “#XXXXXX” คือสีที่คุณต้องการแสดง โปรดทราบว่าต้องตั้งค่าสีข้อความของวิดเจ็ตที่เกี่ยวข้องเป็นสีขาว",
  T_48_M_WS_P_ICON: "โปรไฟล์",
  T_48_META_API_10001: "ค้นหาเอนทิตีตามไอดี",
  T_48_META_API_10001_P0: "รหัสเอนทิตี",
  T_48_META_API_1098: "อ่านค่าในชีตฐานข้อมูลแบบกลุ่ม",
  T_48_META_API_1098_D: "อ่านข้อมูลหลายรายการจากชีตฐานข้อมูลที่ระบุ โดยที่รายการในรายชื่อรหัสผู้เล่นที่ไม่ซ้ำกันตรงกับรายการของรายชื่อคีย์แบบหนึ่งต่อหนึ่ง",
  T_48_META_API_1098_P1: "รหัสบัญชี",
  T_48_META_API_1098_P1_D: "รายการรหัสผู้เล่นที่ไม่ซ้ำกัน ซึ่งอ่านข้อมูลที่ตรงกับคีย์ในดัชนีเดียวกันในรายการคีย์",
  T_48_META_API_1098_P2: "คีย์",
  T_48_META_API_1098_P2_D: "รายการคีย์ที่อ่านข้อมูลที่สอดคล้องกับรหัสผู้เล่นเฉพาะในดัชนีเดียวกันในรายการรหัสผู้เล่น",
  T_48_META_API_1098_P5: "รหัสสถานะ",
  T_48_META_API_1098_P5_D: "รายการรหัสสถานะ",
  T_48_META_API_1105: "แจ้งเตือนเมื่อเริ่มพล็อต",
  T_48_META_API_1105_D: "เริ่มเล่นพล็อตที่กำหนดสำหรับผู้เล่นที่เป็นตัวกระทำ",
  T_48_META_API_1105_P1_D: "รหัสพล็อต",
  T_48_META_API_1108: "รับภาษาท้องถิ่น",
  T_48_META_API_1500_P0: "เวกเตอร์",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "ตั้งค่าน้ำหนักส่วนของร่างกาย",
  T_48_META_API_3300_D: "ตั้งค่าน้ำหนักของส่วนร่างกายเป้าหมายเมื่อผสมกับแอนิเมชันที่มีลำดับความสำคัญต่ำกว่า",
  T_48_META_API_3300_P0_D: "ส่วนประกอบตัวควบคุมแอนิเมชันที่สามารถเพิ่มได้ซึ่งเป็นของส่วนร่างกาย",
  T_48_META_API_3300_P1: "ชื่อส่วนของร่างกาย",
  T_48_META_API_3300_P1_D: "ชื่อส่วนของร่างกาย",
  T_48_META_API_3300_P2: "น้ำหนัก",
  T_48_META_API_3300_P2_D: "น้ำหนักที่มีค่าช่วง [0, 1] แสดงถึงระดับการผสมกับแอนิเมชันที่มีลำดับความสำคัญต่ำกว่า",
  T_48_META_API_3315: "เล่นคลิปแอนิเมชันตัวละครแบบกำหนดเอง",
  T_48_META_API_3315_D: "เล่นคลิปแอนิเมชันตัวละครโดยมีตัวเลือกให้แทนที่แอนิเมชันเริ่มต้นของเกม",
  T_48_META_API_3315_P3: "ควบคุมการเล่นเกมแทนที่",
  T_48_META_API_3315_P3_D: "ว่าจะเปลี่ยนแปลงแอนิเมชันเริ่มต้นของเกมหรือไม่",
  T_48_META_API_3316: "หยุดแอนิเมชัน",
  T_48_META_API_3316_D: "หยุดเล่นแอนิเมชันสำหรับเป้าหมายในสถานะที่กำหนด",
  T_48_META_API_90_P1: "สามารถออกกลางคันได้",
  T_48_META_API_93: "สร้างการเคลื่อนไหวตามเส้นทาง",
  T_48_META_API_93_D: "สร้างการเคลื่อนไหวแบบอินเทอร์โพเลตตามเส้นทางเพื่อให้วัตถุเคลื่อนที่ตามเส้นทางที่กำหนด",
  T_48_META_API_93_P1: "เส้นทาง",
  T_48_META_API_93_P1_D: "เส้นทางการเคลื่อนที่",
  T_48_META_API_93_P3_D: "ขนาดของความเร็ว",
  T_48_META_API_93_P4: "หันหน้าไปตามเส้นสัมผัส",
  T_48_META_API_93_P4_D: "วัตถุหันหน้าไปในทิศทางการเคลื่อนที่หรือไม่ คุณสมบัตินี้จะไม่เปลี่ยนแปลงแม้ว่าการวางแนวของวัตถุจะถูกปรับเปลี่ยนโดยวิธีอื่นก็ตาม",
  T_48_META_API_96: "สร้างพรีแฟบขึ้นมาใหม่",
  T_48_META_API_96_D: "สร้างอินสแตนซ์พรีแฟบโดยมีตัวเลือกในการประมวลผลแบบอะซิงโครนัส",
  T_48_META_API_96_P2: "โหลดแบบอะซิงโครนัส",
  T_48_META_API_96_P2_D: "การโหลดเป็นแบบอะซิงโครนัสหรือไม่",
  T_48_META_EVT_3140: "เมื่อเปลี่ยนทีม",
  T_48_META_EVT_3140_D: "ทำงานเมื่อทีมของเอนทิตีปัจจุบันเปลี่ยนแปลง",
  T_48_META_EVT_3140_P0: "ทีมเดิม",
  T_48_META_EVT_3140_P0_D: "ทีมที่เคยสังกัดก่อนการเปลี่ยนแปลง",
  T_48_META_EVT_3140_P1: "ทีมปัจจุบัน",
  T_48_META_EVT_3140_P1_D: "ทีมที่สังกัดหลังจากการเปลี่ยนแปลง",
  T_48_META_EVT_3141: "เมื่อเริ่มพล็อต",
  T_48_META_EVT_3141_D: "เริ่มทำงานเมื่อพล็อตเริ่มเล่น",
  T_48_META_EVT_3141_P1: "รหัสพล็อต",
  T_48_META_EVT_3141_P1_D: "รหัสพล็อต",
  T_48_META_EVT_3142: "เมื่อสิ้นสุดพล็อต",
  T_48_META_EVT_3142_D: "ทำงานเมื่อพล็อตจบลง",
  T_48_META_EVT_3142_P0_D: "ผู้เล่นที่เป็นตัวกระตุ้น",
  T_48_META_EVT_3142_P1_D: "รหัสพล็อต",
  T_48_META_EVT_3143: "เมื่อเปิดใช้งานตัวเลือกพล็อต",
  T_48_META_EVT_3143_D: "ทำงานเมื่อเลือกตัวเลือกในพล็อต",
  T_48_META_EVT_3143_P1_D: "รหัสพล็อต",
  T_48_META_EVT_3143_P2: "รหัสตัวเลือก",
  T_48_META_EVT_3143_P2_D: "รหัสของตัวเลือกที่เลือก",
  T_48_META_TYP_409_I10: "เปลี่ยนทีมล้มเหลว_ทีมไม่ถูกต้อง",
  T_48_META_TYP_409_I11: "การเปลี่ยนทีมล้มเหลว_ถูกคัดออกแล้ว",
  T_48_META_TYP_409_I12: "เปลี่ยนทีมล้มเหลว_อยู่ในยานพาหนะ",
  T_48_META_TYP_409_I7: "เปลี่ยนทีมล้มเหลว_ไม่รองรับ",
  T_48_META_TYP_409_I8: "การเปลี่ยนทีมล้มเหลว_อยู่ในทีมแล้ว",
  T_48_META_TYP_409_I9: "เปลี่ยนทีมล้มเหลว_เป้าหมายไม่ถูกต้อง",
  T_48_META_TYP_41_I19: "ปิดการใช้งานตัวชน",
  T_48_META_TYP_417: "อนุภาค",
  T_48_META_TYP_428: "การแปลงร่างผู้เล่น หรือ ชุด NPC",
  T_48_META_TYP_431: "การเคลื่อนที่ตามเส้นทาง",
  T_48_META_TYP_431_I1: "เส้นทาง",
  T_48_META_TYP_432: "จุดทางผ่านเส้นทางโค้งที่กำหนดเอง",
  T_48_META_TYP_432_I0: "หมุน",
  T_48_META_TYP_432_I1: "เส้นสัมผัส",
  T_48_META_TYP_433: "ประเภทเส้นทางโค้งที่กำหนดเอง",
  T_48_META_TYP_433_I0: "เชิงเส้น",
  T_48_META_TYP_433_I1: "ราบรื่น",
  T_48_META_TYP_433_I2: "กำหนดเอง",
  T_48_META_TYP_434: "เส้นทางโค้งที่กำหนดเอง",
  T_48_META_TYP_434_I2: "ปิดลูป",
  T_48_META_TYP_434_I3: "จุดนำทาง",
  T_48_META_TYP_437_I5: "ชื่อประเภทคะแนน",
  T_48_META_TYP_437_I6: "เนื้อหาคะแนนฝั่งซ้าย",
  T_48_META_TYP_437_I7: "เนื้อหาคะแนนฝั่งขวา",
  T_48_META_TYP_438_I1: "ผู้เล่น",
  T_48_META_TYP_438_I2: "อันดับ",
  T_48_META_TYP_438_I3: "คะแนนรวม",
  T_48_META_TYP_438_I4: "ชื่อประเภทคะแนน",
  T_48_META_TYP_438_I5: "สี",
  T_48_META_TYP_438_I6: "คะแนน",
  T_48_META_TYP_439: "กลุ่ม",
  T_48_META_TYP_442_I1: "คะแนนด้านซ้าย",
  T_48_META_TYP_442_I10: "ไอคอนกำจัดด้านขวา",
  T_48_META_TYP_442_I2: "คะแนนด้านขวา",
  T_48_META_TYP_442_I3: "จำนวนผู้รอดชีวิตด้านซ้าย",
  T_48_META_TYP_442_I4: "จำนวนผู้รอดชีวิตด้านขวา",
  T_48_META_TYP_442_I5: "จำนวนการกำจัดด้านซ้าย",
  T_48_META_TYP_442_I6: "จำนวนการกำจัดด้านขวา",
  T_48_META_TYP_442_I7: "ไอคอนฝั่งซ้ายที่ยังมีชีวิตอยู่",
  T_48_META_TYP_442_I8: "ไอคอนฝั่งขวาที่ยังมีชีวิตอยู่",
  T_48_META_TYP_442_I9: "ไอคอนกำจัดด้านซ้าย",
  T_48_META_TYP_444: "ประเภทภาษา",
  T_48_META_TYP_444_I0: "อังกฤษ",
  T_48_META_TYP_444_I1: "จีนตัวย่อ",
  T_48_META_TYP_444_I10: "ฝรั่งเศส",
  T_48_META_TYP_444_I11: "เยอรมัน",
  T_48_META_TYP_444_I12: "ตุรกี",
  T_48_META_TYP_444_I13: "ฮินดี",
  T_48_META_TYP_444_I14: "ญี่ปุ่น",
  T_48_META_TYP_444_I15: "โรมาเนีย",
  T_48_META_TYP_444_I16: "อารบิก",
  T_48_META_TYP_444_I17: "พม่า",
  T_48_META_TYP_444_I18: "อูรดู",
  T_48_META_TYP_444_I19: "เบงกอล",
  T_48_META_TYP_444_I2: "จีน",
  T_48_META_TYP_444_I3: "ไทย",
  T_48_META_TYP_444_I4: "เวียดนาม",
  T_48_META_TYP_444_I5: "อินโดนีเซีย",
  T_48_META_TYP_444_I6: "โปรตุเกส",
  T_48_META_TYP_444_I7: "สเปน",
  T_48_META_TYP_444_I8: "รัสเซีย",
  T_48_META_TYP_444_I9: "เกาหลี",
  T_48_SD_ERROR_DIVISOR: "ตัวหารไม่สามารถเป็น 0 ได้",
  T_48_SD_ERROR_KEY_NOTINMAP: "ไม่พบคีย์ที่ระบุในแผนที่: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "ดัชนีรายการเกินขอบเขต: {0}",
  T_48_SD_SK_WARNING: "ไม่พบ {1} ใน {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'เนื่องจากแอตทริบิวต์ "IsServerDriven" ของตัวควบคุมตัวละครคราฟท์แลนด์ {0} ถูกปิดใช้งาน API ของเซิร์ฟเวอร์ที่เกี่ยวข้องจึงไม่ทำงาน',
  T_48_XXJ_WS_PARENTERROR: "ไม่สามารถตั้งค่าตัวหลักได้",
  T_48_XXJ_WS_PERFORMANCE: "ประสิทธิภาพ",
  T_48_XXJ_WS_TANGENT: "เส้นสัมผัส",
  T_48_XXJ_WS_WAYPOINT: "จุดหมาย",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "รายการของวัตถุ",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "ใช้มินิแมปแบบกำหนดเอง",
  T_48_XYL_UGC_HIDEMINIMAP: "ซ่อน HUD มินิแมป",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "พื้นผิวกำหนดเองพื้นฐาน",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "การตัดทรงกระบอก",
  T_48_XYL_WS_BASICHEMISPHERE: "ซีกโลกพื้นฐาน",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "ทอรัสหนึ่งในสี่ส่วน",
  T_48_XYL_WS_BASICQUARTERTORUS: "ควอเตอร์สแควร์โทอรัส",
  T_48_XYL_WS_BASICROUNDEDTORUS: "ทอรัส",
  T_48_XYL_WS_BASICTRIANGLE: "พื้นผิวสามเหลี่ยม",
  T_48_XYL_WS_MAPPLAYERSTIPS: "จำนวนผู้เล่นในแมตช์ = จำนวนทีม x จำนวนผู้เล่นต่อทีม ยิ่งมีผู้เล่นในแมตช์มากเท่าไร เวลาการจับคู่ก็จะนานขึ้น",
  T_48_XYL_WS_MAPPLAYERSWARNING: "จำนวนผู้เล่นที่มากอาจทำให้เวลาค้นหาคู่ต่อสู้นานขึ้น",
  T_49_HL_CL_CREATOR_LABEL2: "ชุมชนคราฟต์แลนด์ครีเอเตอร์",
  T_49_HL_CL_MAPS_LABEL2: "ผู้ชนะในแผนที่",
  T_49_HL_CL_MAPS_LABEL3: "ผู้ชนะในการเล่นเกม",
  T_49_HX_T_TUNG: "ทุง ทุง ทุง",
  T_49_HZY_CONTROLLER_TRAJECTORY: "เส้นทางการเคลื่อนที่",
  T_49_JH_WS_SKILLKASSIE: "รักษาด้วยไฟฟ้า (แคสซี่)",
  T_49_JH_WS_SKILLKODA: "ออร่าหยั่งรู้ (โคด้า)",
  T_49_JH_WS_SKILLOSCAR: "ชนกระจาย (ออสการ์)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "สร้างด้วย AI",
  T_49_META_API_10065: "สลับกล้องแบบกำหนดเอง",
  T_49_META_API_10067: "รับกล้องที่กำหนดเองปัจจุบัน",
  T_49_META_API_10069: "สร้างกล้องแบบกำหนดเอง",
  T_49_META_API_10070: "เซตหน้ากากกำหนดเองสำหรับกล้อง",
  T_49_META_API_10070_D: "ตั้งหน้ากากการตัดของกล้องเป้าหมายเพื่อควบคุมการมองเห็นในทุกชั้น",
  T_49_META_API_10071: "รับหน้ากากการเลือกกล้องที่กำหนดเอง",
  T_49_META_API_10071_D: "รับหน้ากากคัดกรองของกล้องเป้าหมาย",
  T_49_META_API_10072: "ตั้งค่าชั้น หน้ากาก กล้องกำหนดเอง",
  T_49_META_API_10072_D: "ตั้งค่าการมองเห็นของกล้องเป้าหมายสำหรับเลเยอร์เฉพาะ",
  T_49_META_API_10073: "จับภาพหน้าจอ",
  T_49_META_API_10073_D: "บันทึกภาพหน้าจอ (สำหรับการทดสอบภายใน)",
  T_49_META_API_106: "รับเวลาที่ถูกประทับจากเซิร์ฟเวอร์ (มิลลิวินาที)",
  T_49_META_API_106_D: "รับเวลาจากเซิร์ฟเวอร์ด้วยความละเอียดระดับมิลลิวินาที",
  T_49_META_API_107: "แปลงเวลาประทับเป็นสตริงที่แปลเป็นภาษาท้องถิ่น (มิลลิวินาที)",
  T_49_META_API_107_D: "แปลงการประทับเวลา (ใน ms) เป็น string ตามรูปแบบที่กำหนด",
  T_49_META_API_107_P0: "Timestamp (มิลลิวินาที)",
  T_49_META_API_107_P0_D: "เวลาประทับในหน่วยมิลลิวินาที",
  T_49_META_API_108: "เลิร์ป เวกเตอร์3",
  T_49_META_API_108_D: "ทำการสอดแทรกเชิงเส้นจากเวกเตอร์ 3 มิติ A ไปยังเวกเตอร์ B",
  T_49_META_API_1089_P2: "รหัสคำขอ",
  T_49_META_API_109: "อัปเดตบริบทเป็นบุคลิกภาพ",
  T_49_META_API_109_D: "อัปเดตบริบทโมเดลของบุคคลที่กำหนดในห้องปัจจุบันและเขียนทับบริบทเดิมหลังจากดำเนินการเสร็จสิ้น บริบทจะมีอิทธิพลต่อการแปลความหมายของพื้นหลัง ประวัติศาสตร์ หรือพารามิเตอร์บางอย่างสำหรับบทสนทนาปัจจุบัน",
  T_49_META_API_109_P1: "บริบท",
  T_49_META_API_109_P1_D: "รายละเอียดในบริบท",
  T_49_META_API_110: "ความคิดเห็นเกี่ยวกับการตอบสนองของตัวละคร",
  T_49_META_API_110_D: "ส่งความคิดเห็นเกี่ยวกับเนื้อหาคำตอบของบุคคล ซึ่งจะถูกใช้เพื่อปรับปรุงแบบจำลองของเรา",
  T_49_META_API_110_P1: "ถูกใจ",
  T_49_META_API_110_P1_D: "ไม่ว่าจะชอบคำตอบนั้นหรือไม่ก็ตาม True = ชอบ",
  T_49_META_API_1109: "เซตตำแหน่งผู้เล่นในพื้นที่",
  T_49_META_API_1109_D: "เมื่อผู้เล่นใช้ตัวละครเกมคลาสสิก API นี้สามารถตั้งค่าตำแหน่งของผู้เล่นได้",
  T_49_META_API_1109_P0_D: "ตำแหน่งเป้าหมาย",
  T_49_META_API_111: "สเลิร์ป เวกเตอร์3",
  T_49_META_API_111_D: "ทำการสอดแทรกทรงกลมจากเวกเตอร์ 3 มิติ A ไปยังเวกเตอร์ B เพื่อการหมุนที่ราบรื่น",
  T_49_META_API_1110: "ตั้งผู้เล่นท้องถิ่นไปข้างหน้า",
  T_49_META_API_1110_D: "เมื่อผู้เล่นใช้ตัวละครเกมคลาสสิก API นี้สามารถตั้งค่าทิศทางที่ผู้เล่นกำลังเผชิญได้",
  T_49_META_API_1110_P0_D: "เวกเตอร์ไปข้างหน้า",
  T_49_META_API_112: "ย้อนคืนความทรงจำของตัวละคร",
  T_49_META_API_112_D: "ย้อนความทรงจำของบุคคลไปก่อนหน้ารหัสตอบสนองเฉพาะ ความทรงจำของบทสนทนา รวมถึงหลังจากการตอบสนองจะถูกลบออก",
  T_49_META_API_113: "เล่นเสียงช็อตเดียว",
  T_49_META_API_113_D: "เล่นเอฟเฟ็กต์เสียงสั้น ๆ พร้อมปรับระดับเสียงได้",
  T_49_META_API_113_P0_D: "รหัสทรัพยากรเสียงเอฟเฟ็กต์ที่จะเล่น",
  T_49_META_API_113_P1: "ระดับเสียง",
  T_49_META_API_113_P1_D: "ระดับความดังของเสียงเอฟเฟ็กต์ ตั้งแต่ 0 ถึง 1",
  T_49_META_API_97: "สร้างตัวควบคุมการมองสำหรับโครงกระดูก",
  T_49_META_API_97_D: "หลังจากสร้างเอนทิตี้ตัวควบคุมส่วนโครงกระดูกแล้ว คุณสามารถใช้เอนทิตี้นี้เพื่อควบคุมส่วนโครงกระดูกที่ระบุและทำให้มันหันหน้าไปยังเป้าหมายที่เฉพาะเจาะจงเสมอ",
  T_49_META_API_97_P0_D: "เอนทิตี้ควบคุมการมองของส่วนโครงกระดูก ถ้าเอนทิตี้ถูกทำลาย ฟังก์ชันการมองจะหยุดทำงาน",
  T_49_META_API_97_P1_D: "ส่วนที่เป็นโครงกระดูกที่ถูกควบคุมอยู่",
  T_49_META_API_97_P2_D: "เป้าหมายที่กำลังถูกมองอยู่",
  T_49_META_API_98: "การฉายภาพ",
  T_49_META_API_98_D: "คำนวณการฉายของเวกเตอร์ A ลงบนเวกเตอร์ B",
  T_49_META_API_99: "รับเวลาปัจจุบัน (มิลลิวินาที)",
  T_49_META_API_99_D: "รับเวลาในท้องถิ่นด้วยความละเอียดระดับมิลลิวินาที",
  T_49_META_EVT_16_P1_D: "เริ่มจาก 0 การร้องขอออกแต่ละครั้งจะใช้ตัวเลข ID ตามลำดับ เช่น สำหรับการสร้างห้องและล้างหน่วยความจำ",
  T_49_META_EVT_16_P2: "รหัสการตอบกลับ",
  T_49_META_EVT_16_P2_D: "แต่ละคำตอบที่สมบูรณ์จะมี ID ที่ไม่ซ้ำกัน",
  T_49_META_TYP_122_I19: "วัสดุที่กำหนดเอง",
  T_49_META_TYP_122_I19_D: "อนุญาตให้เปลี่ยน Skybox ด้วยวัสดุที่กำหนดเอง",
  T_49_META_TYP_14_I78_D: "รับหรือเซตเอนทิตี้กล้องที่กำลังแสดงผลฉากบนเครื่องลูกข่ายของผู้เล่น หมายเหตุ: เอนทิตี้กล้องโดยพื้นฐานแล้วหมายถึงข้อมูลการตั้งค่าสำหรับควบคุมกล้องฝั่งลูกข่าย",
  T_49_META_TYP_335_I9: "เวลาที่ผ่านไป (มิลลิวินาที)",
  T_49_META_TYP_335_I9_D: "ระยะเวลาการเล่นของเอฟเฟ็กต์เสียงในหน่วยมิลลิวินาที คุณสมบัตินี้สามารถเข้าถึงได้ที่ฝั่งไคลเอนต์เท่านั้น",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Failed",
  T_49_META_TYP_409_I14_D: "LLM_Failed",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Invalid_Persona",
  T_49_META_TYP_409_I16_D: "LLM_Invalid_PersonaOrRoom",
  T_49_META_TYP_409_I17: "LLM_Token_Limit",
  T_49_META_TYP_409_I17_D: "LLM_Token_Limit",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19_D: "LLM_Frequent_Request",
  T_49_META_TYP_441: "รหัสประสิทธิภาพ",
  T_49_META_TYP_445: "รหัสควบคุมที่เล่นได้",
  T_49_META_TYP_446: "ตัวควบคุมแบบติดตั้งได้",
  T_49_META_TYP_446_I0: "ตัวควบคุมที่เล่นได้",
  T_49_META_TYP_447: "ตัวควบคุมส่วนโครงกระดูก",
  T_49_META_TYP_448: "คอนโทรลเลอร์ส่วนดูโครงกระดูก",
  T_49_META_TYP_448_I0: "เป้าหมายที่ถูกควบคุม",
  T_49_META_TYP_448_I1: "มองเป้าหมาย",
  T_49_META_TYP_449: "กล้องกำหนดเอง",
  T_49_META_TYP_449_I2: "ขนาดอักษร",
  T_49_META_TYP_449_I2_D: "ควบคุมขนาดของพื้นที่ที่กล้องมองเห็น",
  T_49_META_TYP_450: "ประทับเวลาข้อความ (ms)",
  T_49_META_TYPE_449_D: "กล้องที่กำหนดเองถูกควบคุมโดยผู้พัฒนาโดยสมบูรณ์และกำหนดสิ่งที่ผู้เล่นเห็นระหว่างการเล่นเกม",
  T_49_META_TYPE_450_D: "แปลงหมายเวลาระดับมิลลิวินาทีให้เป็นข้อความที่อ่านได้",
  T_49_SD_SEARCH_ICONDESC: "กลุ่มอัจฉริยะ",
  T_49_SD_SEARCHKEY_ACTION: "การกระทำ",
  T_49_SD_SEARCHKEY_ANICLIPID: "รหัสคลิปแอนิเมชัน",
  T_49_SD_SEARCHKEY_AS: "ในฐานะ",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "รหัสไฟล์แนบ",
  T_49_SD_SEARCHKEY_AUDIOENUM: "ประเภทเสียงเอฟเฟ็กต์",
  T_49_SD_SEARCHKEY_BAGSKINID: "รหัสสกินกระเป๋า",
  T_49_SD_SEARCHKEY_BEZIER: "เส้นโค้งเบซิเยร์",
  T_49_SD_SEARCHKEY_BOOL: "ค่า Boolean",
  T_49_SD_SEARCHKEY_BREAK: "พัก",
  T_49_SD_SEARCHKEY_BTREEID: "รหัสพฤติกรรมต้นไม้",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "เมื่อปุ่มถูกคลิก",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "เมื่อคลิกปุ่มสองครั้ง",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "เมื่อกดปุ่ม",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "เมื่อปล่อยปุ่ม",
  T_49_SD_SEARCHKEY_CLOTHENUM: "ประเภทชุด",
  T_49_SD_SEARCHKEY_COLOR: "สี",
  T_49_SD_SEARCHKEY_COMMENT: "หมายเหตุความคิดเห็น",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "องค์ประกอบ enum",
  T_49_SD_SEARCHKEY_CONCANT: "เชื่อม",
  T_49_SD_SEARCHKEY_CONTINUE: "ต่อไป",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "ปรับแต่ง HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "วิดเจ็ต HUD ที่กำหนดเอง",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "สร้างวัตถุประเภทระดับแบบไดนามิก",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "ประเภทของเอฟเฟ็กต์ภาพ",
  T_49_SD_SEARCHKEY_ENTITY: "เลือกวัตถุในฉาก",
  T_49_SD_SEARCHKEY_FLOAT: "ค่า Float",
  T_49_SD_SEARCHKEY_FOR: "สำหรับดัชนี",
  T_49_SD_SEARCHKEY_FOREACH: "สำหรับแต่ละรายการ",
  T_49_SD_SEARCHKEY_FUNCTION: "ฟังก์ชัน",
  T_49_SD_SEARCHKEY_GETCSV: "ดึงข้อมูล CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "รับทรัพยากรที่ลงทะเบียนโดยใช้คีย์",
  T_49_SD_SEARCHKEY_GETVALUE: "รับทรัพย์สิน",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "รับตัวแปรทั่วโลก",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "กำหนดตัวแปรเซตสากล",
  T_49_SD_SEARCHKEY_IF: "ถ้า",
  T_49_SD_SEARCHKEY_IFELSE: "ถ้าไม่เช่นนั้น",
  T_49_SD_SEARCHKEY_IMGENUM: "ประเภทสไปรต์",
  T_49_SD_SEARCHKEY_INT: "จำนวนเต็ม",
  T_49_SD_SEARCHKEY_INTERNALHUD: "ประเภท HUD",
  T_49_SD_SEARCHKEY_ITEMENUM: "ประเภทไอเทม",
  T_49_SD_SEARCHKEY_LISTAPPEND: "เพิ่มในรายการ",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "เพิ่มรายการในลิสต์ตามช่วง",
  T_49_SD_SEARCHKEY_LISTCLEAR: "ล้างลิสต์",
  T_49_SD_SEARCHKEY_LISTCLONE: "คัดลอกรายการ",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "รายการประกอบด้วย",
  T_49_SD_SEARCHKEY_LISTCREATE: "สร้างรายการ",
  T_49_SD_SEARCHKEY_LISTDELETE: "ลบรายการ",
  T_49_SD_SEARCHKEY_LISTGET: "รับรายการ",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "ดัชนีรายการของ",
  T_49_SD_SEARCHKEY_LISTINSERT: "แทรกรายการ",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "รายการดัชนีสุดท้ายของ",
  T_49_SD_SEARCHKEY_LISTLENGTH: "ความยาวของลิสต์",
  T_49_SD_SEARCHKEY_LISTREVERSE: "รายการย้อนกลับ",
  T_49_SD_SEARCHKEY_LISTSET: "ตั้งค่าลิสต์",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "สับเปลี่ยนรายการ",
  T_49_SD_SEARCHKEY_LOCALKEY: "คีย์ที่แปล",
  T_49_SD_SEARCHKEY_LOCALVAR: "ตัวแปรภายใน",
  T_49_SD_SEARCHKEY_LOGICAL: "และ หรือ",
  T_49_SD_SEARCHKEY_LOGINFO: "พิมพ์ข้อมูลล็อก",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "dict รับคีย์ทั้งหมด แผนที่รับคีย์ทั้งหมด",
  T_49_SD_SEARCHKEY_MAPCLEAR: "ล้าง dict ล้างแผนที่",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "dict มีคีย์ที่มีแผนที่ของคีย์",
  T_49_SD_SEARCHKEY_MAPCREATE: "สร้าง dict สร้างแผนที่",
  T_49_SD_SEARCHKEY_MAPGET: "ดึงค่าจาก dict ด้วยคีย์ ดึงค่าจากแผนที่ด้วยคีย์",
  T_49_SD_SEARCHKEY_MAPLENGTH: "ความยาว dict ความยาวแผนที่",
  T_49_SD_SEARCHKEY_MAPREMOVE: "ลบ dict ลบแผนที่",
  T_49_SD_SEARCHKEY_MAPSET: "ตั้งค่าเซตค่า dict ตั้งค่าเซตค่าแผนที่",
  T_49_SD_SEARCHKEY_MATH: "บวก ลบ คูณ หาร",
  T_49_SD_SEARCHKEY_NEWLIST: "ลิสต์ใหม่",
  T_49_SD_SEARCHKEY_NULL: "ว่าง",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "แปลงตัวเลขเป็นสตริง",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "คุณสมบัติของอนุภาค",
  T_49_SD_SEARCHKEY_PERSONA: "บุคลิกภาพ",
  T_49_SD_SEARCHKEY_PI: "พาย",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "ข้อมูลผู้เล่น ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "ประเภททักษะของตัวละคร",
  T_49_SD_SEARCHKEY_PREEFFECT: "ประเภทสติกเกอร์พิเศษ",
  T_49_SD_SEARCHKEY_PREFAB: "พรีแฟบ",
  T_49_SD_SEARCHKEY_RAWID: "รหัสดิบ",
  T_49_SD_SEARCHKEY_READSTATIS: "อ่านข้อมูลที่สะสม",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "รหัสทรัพยากร",
  T_49_SD_SEARCHKEY_RETURN: "กลับ",
  T_49_SD_SEARCHKEY_SCENEENUM: "ไฟล์ฉาก",
  T_49_SD_SEARCHKEY_SCRIPTID: "สคริปต์",
  T_49_SD_SEARCHKEY_SETVALUE: "ค่าเซตคุณสมบัติ",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "ประเภทรหัสไอเทมพิเศษ",
  T_49_SD_SEARCHKEY_TEXT: "ข้อความ",
  T_49_SD_SEARCHKEY_TEXTUREID: "ประเภทพื้นผิว",
  T_49_SD_SEARCHKEY_THISENTITY: "เอนทิตี้นี้",
  T_49_SD_SEARCHKEY_TIMELINE: "ไทม์ไลน์",
  T_49_SD_SEARCHKEY_TYPEENUM: "ทุกประเภท",
  T_49_SD_SEARCHKEY_V2VCREATE: "สร้างเวกเตอร์2",
  T_49_SD_SEARCHKEY_V2VGET: "รับคอมโพเนนต์ Vector2",
  T_49_SD_SEARCHKEY_V2VOPERATION: "เวกเตอร์2 การดำเนินการ การบวก การลบ การคูณ ผลคูณดอท ระยะห่าง มุม",
  T_49_SD_SEARCHKEY_V2VSET: "เซตองค์ประกอบเวกเตอร์2",
  T_49_SD_SEARCHKEY_V3VCREATE: "สร้างเวกเตอร์3",
  T_49_SD_SEARCHKEY_V3VGET: "รับองค์ประกอบเวกเตอร์3",
  T_49_SD_SEARCHKEY_V3VOPERATION: "เวกเตอร์3 การดำเนินการ บวก ลบ คูณ ผลิตภัณฑ์จุด ผลิตภัณฑ์ไขว้ ระยะทาง มุม",
  T_49_SD_SEARCHKEY_V3VSET: "เซตองค์ประกอบเวกเตอร์3",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "รหัสสกินยานพาหนะ",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "รหัสสกินอาวุธ",
  T_49_SD_SEARCHKEY_WHILE: "ในขณะที่",
  T_49_SD_SEARCHKEY_WRITESTATIS: "เขียนออฟเซตฐานข้อมูลที่สะสม",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "เขียนค่าการเปลี่ยนแปลงฐานข้อมูลที่สะสมตามรหัสแผนที่",
  T_49_XXJ_WS_DURATIONS: "ระยะเวลา (วินาที)",
  T_49_XXJ_WS_EDITPERFORMANCE: "แก้ไขประสิทธิภาพ",
  T_49_XXJ_WS_PERFORMANCE: "ประสิทธิภาพ",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "ลบประสิทธิภาพ",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "การลบประสิทธิภาพจะไม่สามารถกู้คืนได้ ต้องการดำเนินการต่อหรือไม่?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "กำลังแก้ไข {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "ชื่อนี้ถูกใช้ไปแล้ว กรุณาเปลี่ยนชื่อและลองอีกครั้ง",
  T_49_XXJ_WS_PERFORMANCENAME: "ชื่อการแสดง",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "เพิ่มคีย์เฟรม",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "เพิ่มซับแทร็ก",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "เพิ่มแทร็ค",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "ลบแทร็ก",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "แทร็กนักแสดง",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "แทร็คกิจกรรม",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "คีย์เฟรมมีอยู่แล้ว",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "แทร็กนักแสดงที่สอดคล้องกันมีอยู่แล้ว",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "เนื้อหา",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "ตรวจพบชื่อแทร็กซ้ำ กรุณาเปลี่ยนและลองอีกครั้ง",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "กรุณาเริ่มการบันทึกหรือเลือกกรอบหลักก่อน",
  T_49_XXJ_WS_TIMELINE_RECORDING: "กำลังบันทึก...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "ลบคีย์เฟรม",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "มุมมองฉาก",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "เลือกวัตถุเพื่อสร้างแทร็กหรือตรงไปที่ปุ่มเพิ่มแทร็ก",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "แตะปุ่มเพิ่มแทร็กเพื่อสร้างแทร็กใหม่",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "ซับแทร็ก",
  T_49_XXJ_WS_TIMELINE_TRACK: "แทร็ก",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "ดูแทร็ค",
  T_49_XYL_WS_DAILYPROPS: "พื้นฐาน",
  T_49_XYL_WS_STOREGAMPLAY: "เกมเพลย์",
  T_49_YU_QCITEM_ALL_11: "ทุง ทุง ทุง ซะอูร์!",
  T_50_H_M4A1_VA_N: "M4A1 - ผีสิง",
  T_50_H_MACHETE_VA_N: "มีดพร้า - ผีสิง",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "พื้นที่กระดานอันดับ",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "ล้น",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "พันรอบ",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "ย่อขนาดตัวอักษร",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "สร้างทูเพิล",
  T_50_HJ_SEARCHKEY_TUPLEGET: "รับทูเพิล",
  T_50_HJ_SEARCHKEY_TUPLESET: "เซตทูเพิล",
  T_50_HJ_TEXTOBGJ_H: "ความสูง",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "ตัวเลือกสำรอง",
  T_50_HJ_TEXTOBGJ_W: "ความกว้าง",
  T_50_HZY_REVIEW_TEXTOBJ: "เนื้อหาของวัตถุ",
  T_50_JH_WS_HIDEMAPERROR: "ไม่สามารถซ่อนมินิแมปได้หากไม่มีภาพปกที่กำหนดเอง",
  T_50_JH_WS_HIDEMAPTIP: "เมื่อมินิแมปถูกซ่อนไว้ จะไม่ถูกใช้เป็นภาพปกอีกต่อไป",
  T_50_JH_WS_HIDEMINIMAP: "ซ่อนมินิแมป",
  T_50_META_API_10073_P0: "ชื่อไฟล์",
  T_50_META_API_10073_P0_D: "ชื่อไฟล์",
  T_50_META_API_10073_P1_D: "ผลลัพธ์ของการดำเนินการ ตรวจสอบสถานะโค้ดจาก enum",
  T_50_META_API_1102: "อ่านค่าคอลัมน์จากแผ่นฐานข้อมูล",
  T_50_META_API_1102_D: "อ่านค่าของคอลัมน์เฉพาะสำหรับคีย์ที่กำหนดจากตารางฐานข้อมูลมาตรฐาน",
  T_50_META_API_1102_P3: "ดัชนีคอลัมน์",
  T_50_META_API_1102_P3_D: "ดัชนีคอลัมน์ของตารางฐานข้อมูล (0 = คอลัมน์แรก)",
  T_50_META_API_1106: "สร้างการแสดง",
  T_50_META_API_1106_D: "สร้างผลงานเอนทิตี้",
  T_50_META_API_1106_P0_D: "ข้อมูลทรัพย์สินการแสดง",
  T_50_META_API_1111: "อ่านค่าร่วมของกระดานอันดับในฐานข้อมูล",
  T_50_META_API_1111_D: "อ่านค่าผสมจากตารางกระดานอันดับและตารางที่เกี่ยวข้องในฐานข้อมูล",
  T_50_META_API_1111_P5: "รหัสสถานะการเชื่อมโยง",
  T_50_META_API_1111_P5_D: "รหัสข้อผิดพลาดของการเชื่อมโยง",
  T_50_META_API_1112: "อ่านค่าแถวจากฐานข้อมูลกระดานอันดับโดยใช้ช่วง",
  T_50_META_API_1112_D: "อ่านค่าจากตารางกระดานอันดับภายในช่วงอันดับที่กำหนด อ่านค่าที่เกี่ยวข้องโดยใช้คีย์ที่ดึงมาจากตารางที่เกี่ยวข้องแล้วรวมกัน",
  T_50_META_API_1112_P6: "รหัสสถานะการเชื่อมโยง",
  T_50_META_API_1112_P6_D: "รหัสข้อผิดพลาดของสมาคม",
  T_50_META_API_1113: "เขียนค่าการเชื่อมโยงกระดานอันดับของฐานข้อมูล",
  T_50_META_API_1113_D: "บันทึกค่าของคีย์ที่กำหนดลงในกระดานอันดับและตารางที่เกี่ยวข้องในฐานข้อมูล",
  T_50_META_API_1113_P5: "รหัสสถานะการเชื่อมโยง",
  T_50_META_API_1113_P5_D: "รหัสข้อผิดพลาดของสมาคม",
  T_50_META_API_114_D: "สร้าง UI แบบกำหนดเอง",
  T_50_META_API_114_P0_D: "โค้ดนี้ถูกใช้เป็นชื่อตัวแปรสำหรับสร้างเอนทิตี้ UI และค่าตัวแปรภายในที่เกี่ยวข้องจะแทนเอนทิตี้ UI ที่สร้างขึ้น",
  T_50_META_API_114_P1_D: "เอนทิตี้ผู้เล่นที่มันเป็นของ, มองเห็นได้เฉพาะผู้เล่นเท่านั้น",
  T_50_META_API_114_P2: "รหัสทรัพยากร UI",
  T_50_META_API_114_P2_D: "ID ทรัพย์สิน UI ที่กำหนดเอง",
  T_50_META_API_115_D: "สร้าง UI ที่กำหนดเองตามที่ระบุ",
  T_50_META_API_116: "เซตระดับไฮไลต์วัตถุ",
  T_50_META_API_116_D: "ตั้งค่าสถานะการเน้นของวัตถุ อาจได้รับผลกระทบจากตรรกะอื่นในเกม",
  T_50_META_API_116_P0_D: "วัตถุเป้าหมาย",
  T_50_META_API_116_P1_D: "สถานะเน้น",
  T_50_META_API_117: "บิตไวส์ระดับทั่วไป",
  T_50_META_API_117_D: "บิตไวส์และ/หรือ/xor/เลื่อนซ้าย/เลื่อนขวา",
  T_50_META_API_117_P0_D: "ค่าด้านซ้าย",
  T_50_META_API_117_P1_D: "ค่าด้านขวา",
  T_50_META_API_117_P2_D: "ประเภทการดำเนินการ",
  T_50_META_API_118: "บิตไวส์น็อต",
  T_50_META_API_118_D: "บิตไวส์ NOT หรือที่เรียกว่าบิตไวส์คอมพลีเมนต์",
  T_50_META_API_118_P0_D: "ค่า",
  T_50_META_API_119: "เปลี่ยนรายการบิตไวส์เป็นจำนวนเต็ม",
  T_50_META_API_119_D: "ดำเนินการบิตไวส์ OR บนอาเรย์ทั้งหมดในรายการและแปลงผลลัพธ์เป็นค่าตัวเลข",
  T_50_META_API_119_P0: "บิตอาเรย์",
  T_50_META_API_119_P0_D: "บิตไวส์อาเรย์",
  T_50_META_API_120: "เปลี่ยนจำนวนเต็มบิตไวส์เป็นรายการ",
  T_50_META_API_120_D: "แปลงค่าทศนิยมที่แทนด้วยบิตในตำแหน่ง 1 ของค่าตัวเลขในรูปแบบไบนารีให้อยู่ในรูปแบบรายการ",
  T_50_META_API_120_P0_D: "ค่าตัวเลข",
  T_50_META_API_121: "มุมควอเทอร์เนียน",
  T_50_META_API_121_D: "คำนวณมุมระหว่างสองควอเทอร์เนียน",
  T_50_META_API_121_P0_D: "ควอเทอร์เนียน 1",
  T_50_META_API_121_P1_D: "ควอเทอร์เนียน 2",
  T_50_META_API_122: "จุดควอเทอร์เนียน",
  T_50_META_API_122_D: "คำนวณดอทโปรดักต์ของสองควอเทอร์เนียน",
  T_50_META_API_123: "การผกผันของควอเทอร์เนียน",
  T_50_META_API_123_D: "คำนวณอินเวอร์สของควอเทอร์เนียน",
  T_50_META_API_123_P0_D: "ควอเทอร์เนียน",
  T_50_META_API_124: "จากควอเทอร์เนียนสู่การหมุน",
  T_50_META_API_124_D: 'คำนวณควอเทอร์เนียนการหมุนจาก "จาก" ไป "ถึง"',
  T_50_META_API_124_P0_D: "จุดเริ่มต้น",
  T_50_META_API_124_P1_D: "จุดสิ้นสุด",
  T_50_META_API_125: "คอเทอร์เนียนหมุนเข้าหา",
  T_50_META_API_125_D: 'คำนวณควอเทอร์เนียนการหมุนจาก "จาก" ไป "ถึง" โดยมีมุมหมุนสูงสุดเป็นรัศมี',
  T_50_META_API_125_P0: "จาก",
  T_50_META_API_125_P0_D: "ควอเทอร์เนียนเริ่มต้น",
  T_50_META_API_125_P1: "ถึง",
  T_50_META_API_125_P1_D: "ควอเทอร์เนียนเป้าหมาย",
  T_50_META_API_125_P2: "องศาสูงสุดของเดลต้า",
  T_50_META_API_125_P2_D: "มุมการหมุนสูงสุด",
  T_50_META_API_126: "รับการหมุนของไจโรสโคป",
  T_50_META_API_126_D: "อุปกรณ์หมุนในอวกาศ 3 มิติ แสดงถึงมุมหมุนรอบแกนทั้งสาม",
  T_50_META_API_127: "รับแรงโน้มถ่วงของไจโรสโคป",
  T_50_META_API_127_D: "ส่วนประกอบแรงโน้มถ่วงที่ตรวจพบโดยเซ็นเซอร์บนอุปกรณ์ของคุณ",
  T_50_META_API_128: "รับอัตราการหมุนของไจโรสโคป",
  T_50_META_API_128_D: "นี่หมายถึงอัตราการหมุนของอุปกรณ์ ซึ่งเป็นคำที่เกี่ยวข้องกับเซนเซอร์ไจโรสโคป ซึ่งอธิบายถึงความเร็วเคลื่อนที่ในการหมุนตัวของอุปกรณ์ในพื้นที่สามมิติ",
  T_50_META_API_129: "รับการหมุนของไจโรสโคปที่ปราศจากอคติ",
  T_50_META_API_129_D: "อธิบายอัตราหมุนของอุปกรณ์และให้ผลลัพธ์ที่แม่นยำมากขึ้นโดยชดเชยสัญญาณรบกวนหรือความเหลื่อมล้ำของเซนเซอร์อุปกรณ์",
  T_50_META_API_130: "รับความเร่งของผู้ใช้ไจโรสโคป",
  T_50_META_API_130_D: "ส่วนของการเร่งความเร็วของอุปกรณ์ที่เอาองค์ประกอบของแรงโน้มถ่วงออก ซึ่งเกิดจากการกระทำของผู้ใช้หรือแรงภายนอก",
  T_50_META_API_131: "รับข้อมูลการสัมผัส",
  T_50_META_API_131_D: "รับข้อมูลการสัมผัสหน้าจอตามดัชนีที่ระบุ (รวมถึงตำแหน่ง การกระจัด และเวลาที่เปลี่ยนแปลง)",
  T_50_META_API_131_P0_D: "แจกจ่ายรหัสจุดสัมผัส โดยเริ่มจาก 0",
  T_50_META_API_131_P1_D: "ตำแหน่งการสัมผัส",
  T_50_META_API_131_P2: "ตำแหน่งเดลต้า",
  T_50_META_API_131_P2_D: "ตำแหน่งที่เปลี่ยนไปเมื่อเทียบกับเฟรมสุดท้าย",
  T_50_META_API_131_P3: "เวลาเดลต้า",
  T_50_META_API_131_P3_D: "เวลาเริ่มตั้งแต่เฟรมสุดท้าย",
  T_50_META_API_132: "รับจำนวนการสัมผัสหน้าจอ",
  T_50_META_API_132_D: "รับจำนวนจุดสัมผัสบนหน้าจอในปัจจุบัน",
  T_50_META_API_133: "เปิดการสั่นของอุปกรณ์",
  T_50_META_API_133_D: "ทำให้เครื่องสั่นหนึ่งครั้ง",
  T_50_META_API_134_D: "แจ้งเตือนอุปกรณ์ของผู้เล่นเป้าหมายให้เล่นเสียง",
  T_50_META_API_134_P0_D: "เป้าหมายผู้เล่น",
  T_50_META_API_134_P1_D: "ทรัพยากรเสียง",
  T_50_META_API_134_P2_D: "ความเร็วในการเล่นกลับ (ช่วงที่ใช้ได้: 0.1~3.0; 1 = ปกติ, <1 = ช้าลง, >1 = เร็วขึ้น)",
  T_50_META_API_135_D: "เล่นไฟล์เสียงเพียงครั้งเดียว",
  T_50_META_API_135_P0_D: "ทรัพยากรเสียง",
  T_50_META_API_135_P1_D: "ความเร็วในการเล่น",
  T_50_META_API_136: "รูปแบบ String",
  T_50_META_API_136_D: "จัดรูปแบบ string",
  T_50_META_API_136_P0_D: "จัดรูปแบบสตริงที่ควบคุมการจัดรูปแบบของ Go",
  T_50_META_API_136_P1: "อาเรย์พารามิเตอร์",
  T_50_META_API_136_P1_D: "รายการพารามิเตอร์",
  T_50_META_API_137: "วางองค์ประกอบ",
  T_50_META_API_137_D: "คัดลอกหรือเพิ่มข้อมูลองค์ประกอบ",
  T_50_META_API_137_P0: "แหล่งข้อมูล",
  T_50_META_API_137_P0_D: "แหล่งเอนทิตี้",
  T_50_META_API_137_P1_D: "เป้าหมายเอนทิตี้",
  T_50_META_API_137_P2: "ประเภทขององค์ประกอบ",
  T_50_META_API_137_P2_D: "ประเภทขององค์ประกอบ",
  T_50_META_API_137_P3: "สำเร็จหรือไม่",
  T_50_META_API_137_P3_D: "ไม่ว่าจะสำเร็จหรือไม่ก็ตาม",
  T_50_META_API_138: "ชุบชีวิตที่เฟรมถัดไป",
  T_50_META_API_138_D: "ชุบชีวิตที่เฟรมถัดไป",
  T_50_META_API_139: "กำจัดในเฟรมถัดไป",
  T_50_META_API_139_D: "กำจัดเอนทิตี้การต่อสู้ในเฟรมถัดไป",
  T_50_META_API_139_P0_D: "เอนทิตี้การต่อสู้",
  T_50_META_API_140: "ออกจากเกมในเฟรมถัดไป",
  T_50_META_API_140_D: "ออกจากเกมในเฟรมถัดไป",
  T_50_META_API_141: "รับระดับเสียงจากไมโครโฟน",
  T_50_META_API_141_D: "รับระดับเสียงของไมโครโฟน คืนสถานะเมื่อไมโครโฟนของผู้เล่นถูกปิดหรือไม่ได้รับสิทธิ์การเข้าถึง",
  T_50_META_API_141_P0: "ระดับเสียง",
  T_50_META_API_141_P0_D: "ระดับเสียงไมโครโฟน",
  T_50_META_API_141_P1_D: "ไมโครโฟนเปิดหรือปิด",
  T_50_META_API_142: "รับคุณภาพการแสดงผล",
  T_50_META_API_142_D: "รับคุณภาพการแสดงผลปัจจุบัน (enum: ต่ำ/กลาง/สูง/สูงสุด)",
  T_50_META_API_143: "รับความละเอียดการแสดงผล",
  T_50_META_API_143_D: "รับความละเอียดการเรนเดอร์ปัจจุบัน",
  T_50_META_API_144: "ผูกผู้เล่นแบบกำหนดเอง",
  T_50_META_API_144_D: "กำหนดเป้าหมายที่ผู้เล่นนี้ผูกไว้แบบไดนามิก ที่จะยกเลิกการผูกที่มีอยู่ คืนค่าเป็นเท็จถ้าล้มเหลว",
  T_50_META_API_144_P0: "ผู้เล่นแบบกำหนดเอง",
  T_50_META_API_144_P0_D: "หลังจากผูกผู้เล่นที่กำหนดเองนี้กับผู้เล่น ข้อมูล เช่น ตำแหน่งและทิศทางจะถูกซิงค์อัตโนมัติ",
  T_50_META_API_144_P1_D: "ผู้เล่นเป้าหมาย",
  T_50_META_API_145: "ยกเลิกการเชื่อมต่อผู้เล่นที่กำหนดเอง",
  T_50_META_API_145_D: "ยกเลิกการผูก คืนค่าเป็นเท็จถ้าล้มเหลว",
  T_50_META_API_145_P0: "ผู้เล่นแบบกำหนดเอง",
  T_50_META_API_145_P0_D: "ล้างการผูกทั้งหมดสำหรับเป้าหมายนี้ หลังยกเลิกการผูก ข้อมูล เช่น ตำแหน่งและทิศทางจะไม่ถูกซิงค์อัตโนมัติอีกต่อไป",
  T_50_META_API_146_P0_D: "ผู้เล่นกำหนดเอง",
  T_50_META_API_147: "ตั้งค่าสถานะผู้เล่นแบบกำหนดเอง",
  T_50_META_API_147_D: "อัปโหลดไปยังเซิร์ฟเวอร์และซิงค์กับไคลเอนต์ทั้งหมดโดยอัตโนมัติ คืนค่าเป็นเท็จถ้าล้มเหลว",
  T_50_META_API_147_P0: "ผู้เล่นแบบกำหนดเอง",
  T_50_META_API_147_P1: "สถานะ",
  T_50_META_API_147_P1_D: "ใช้บ่อยสำหรับการบันทึกสถานะการแสดงอนิเมชัน รับสถานะที่ซิงค์ด้วย รับสถานะผู้เล่นที่กำหนดเอง",
  T_50_META_API_148: "รับสภาพผู้เล่นที่กำหนดเอง",
  T_50_META_API_148_D: "ข้อมูลสถานะถูกซิงค์ไปยังเซิร์ฟเวอร์โดยอัตโนมัติ คืนค่าเป็นเท็จถ้าล้มเหลว",
  T_50_META_API_148_P0: "ผู้เล่นกำหนดเอง",
  T_50_META_API_148_P1: "สถานะ",
  T_50_META_API_148_P1_D: "ตั้งสถานะด้วยการเซตสถานะผู้เล่นแบบกำหนดเอง",
  T_50_META_API_149: "เซตระยะทางและปริมาตร",
  T_50_META_API_149_D: "กำหนดช่วงระยะห่างระหว่างผู้เล่นเพื่อปรับระดับเสียงโดยอัตโนมัติ",
  T_50_META_API_149_P0: "รายการระยะทาง",
  T_50_META_API_149_P0_D: "รายการช่วงระยะทางแต่ละช่วงตรงกับองค์ประกอบหนึ่งในรายการปริมาตร",
  T_50_META_API_149_P1: "รายการปริมาตร",
  T_50_META_API_149_P1_D: "รายการปริมาตรแต่ละรายการตรงกับองค์ประกอบหนึ่งในรายการระยะทาง",
  T_50_META_API_150: "ดูเพื่อน",
  T_50_META_API_150_D: "รับรายการไอดีเพื่อนของผู้เล่น",
  T_50_META_API_151: "ดูข้อมูล UI เริ่มต้น",
  T_50_META_API_151_D: "รับตำแหน่ง UI เริ่มต้นของผู้เล่น",
  T_50_META_API_151_P0_D: "อินเตอร์เฟซเริ่มต้น",
  T_50_META_API_151_P1_D: "สถานะ",
  T_50_META_API_151_P2_D: "ตำแหน่ง UI",
  T_50_META_API_151_P3: "ขนาด",
  T_50_META_API_151_P3_D: "ขนาด UI",
  T_50_META_API_152: "ออกอากาศเหตุการณ์ที่กำหนดเอง",
  T_50_META_API_152_D: "กระจายเหตุการณ์แบบกำหนดเองให้เอนทิตี้ใด ๆ สามารถรับเหตุการณ์นี้ได้ (ฟัง)",
  T_50_META_API_153: "ส่งอีเวนต์ไปยังเอนทิตี้",
  T_50_META_API_153_D: "ส่งอีเวนต์ที่กำหนดเองไปยังเอนทิตี้เป้าหมาย",
  T_50_META_EVT_17: "เมื่อเริ่มสัมผัสหน้าจอ",
  T_50_META_EVT_17_D: "เริ่มกิจกรรมเมื่อสัมผัสหน้าจอ",
  T_50_META_EVT_17_P0: "ดัชนีการสัมผัส",
  T_50_META_EVT_17_P0_D: "ดัชนีจุดสัมผัส",
  T_50_META_EVT_17_P1_D: "ตำแหน่งสัมผัส",
  T_50_META_EVT_18: "เมื่อสิ้นสุดการสัมผัสหน้าจอ",
  T_50_META_EVT_18_D: "สิ้นสุดเหตุการณ์เมื่อสัมผัสหน้าจอ",
  T_50_META_EVT_18_P0: "ดัชนีการสัมผัส",
  T_50_META_EVT_18_P0_D: "ดัชนีจุดสัมผัส",
  T_50_META_EVT_18_P1_D: "ตำแหน่งสัมผัสบนหน้าจอ ",
  T_50_META_EVT_19: "เมื่อได้รับผลลัพธ์การสร้างห้องตัวละคร",
  T_50_META_EVT_19_D: "รับผลลัพธ์ที่สอดคล้องเมื่อสร้างห้องแชทบุคคลที่ล้มเหลว",
  T_50_META_EVT_19_P1: "เลขห้อง",
  T_50_META_EVT_19_P1_D: "เลขห้อง",
  T_50_META_EVT_20: "เมื่อผู้เล่นออกจากเกมหรือจบการแข่งขัน",
  T_50_META_EVT_20_D: "เริ่มทำงานเมื่อผู้เล่นออกจากการแข่งขันหรือเมื่อการแข่งขันสิ้นสุดลง",
  T_50_META_TYP_11_I44: "ระยะทาง ปริมาตร",
  T_50_META_TYP_11_I44_D: "ปรับระดับเสียงตามระยะห่างระหว่างผู้เล่นแบบอัตโนมัติ",
  T_50_META_TYP_22_I9_D: "ID ของทรัพยากรที่ใช้สร้าง UI",
  T_50_META_TYP_244_I12_D: "ความกว้างของกล่องข้อความ",
  T_50_META_TYP_244_I13_D: "ความสูงของกล่องข้อความ",
  T_50_META_TYP_244_I14_D: "ประเภทการล้น",
  T_50_META_TYP_335_I10_D: "ความเร็วในการเล่น (ค่าที่ใช้ได้ > 0, ค่าเริ่มต้น = 1)",
  T_50_META_TYP_409_I20: "IO_Create_File_Failed",
  T_50_META_TYP_409_I20_D: "การดำเนินการ IO ล้มเหลว: เกิดข้อผิดพลาดในขณะสร้างไฟล์",
  T_50_META_TYP_409_I21: "ชื่อไฟล์ไม่ถูกต้อง",
  T_50_META_TYP_409_I21_D: "การดำเนินการ IO ล้มเหลว ชื่อไฟล์ไม่ถูกต้อง",
  T_50_META_TYP_448_I0_D: "ส่วนโครงกระดูกที่ควบคุม",
  T_50_META_TYP_448_I1_D: "เป้าหมายที่ชิ้นส่วนโครงกระดูกกำลังมองอยู่",
  T_50_META_TYP_451: "ประเภทล้น",
  T_50_META_TYP_451_D: "วิธีการจัดการข้อความล้น",
  T_50_META_TYP_452: "รหัสทรัพยากร UI ที่กำหนดเอง",
  T_50_META_TYP_452_D: "รหัสที่อธิบายทรัพยากร HUD ที่กำหนดเอง",
  T_50_META_TYP_453: "ประเภทคุณภาพการแสดงผล",
  T_50_META_TYP_453_D: "คุณภาพการแสดงผลแบบเลือก",
  T_50_META_TYPE_448_D: "เอนทิตี้นี้ใช้เพื่อควบคุมส่วนของโครงกระดูกให้มองไปที่เป้าหมาย",
  T_50_SD_WS_MAPTAG_AI3DGEN: "3D วัตถุ สร้างแผนที่",
  T_50_SD_WS_MAPTAG_AIRACING: "สร้างแผนที่การแข่งขันโดย AI",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "ชื่อการกำหนดสถานะการเคลื่อนไหว",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "ปิดการสั่นสะเทือนของเสียงฝีเท้า",
  T_50_XXJ_WS_NOPERFORMANCE: "ยังไม่มีไฟล์ประสิทธิภาพ",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "เวอร์ชันเบต้า",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "ถึงผู้สร้างแผนที่ทุกท่าน เครื่องมือแก้ไขประสิทธิภาพยังอยู่ในขั้นตอนการทดสอบ อาจมีบั๊กหรือขาดฟีเจอร์ที่จำเป็น กรุณาใช้งานด้วยความระมัดระวัง",
  T_50_XXJ_WS_PERFORMANCE_NEW: "เพิ่มประสิทธิภาพ",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "เพิ่มคลิปคีย์",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "ติดตามตามเส้นทาง",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "แอนิเมชัน",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "แทร็กแอนิเมชัน",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "แทร็กเสียง",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "ถือ",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "วนไปไม่มีที่สิ้นสุด",
  T_50_XXJ_WS_TIMELINE_DURATION: "ระยะเวลา: {0} วินาที",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "แอนิเมชันไม่ตรงกับโมเดล",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "การซ้อนทับคลิปสำคัญ",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "ขาดเอนทิตี้ที่กำหนด",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "ชื่อแทร็กไม่สามารถเว้นว่างได้",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "ติดตาม NPC",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "เส้นทางทรัพย์สิน",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "ลบคลิปสำคัญ",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0} วินาที",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "จำนวนแทร็กเกินขีดจำกัด",
  T_50_XYL_WS_AIGETERATESHOW: "บล็อกอาคาร",
  T_50_YU_F_B_VA_WITCH: "แม่มดมะลึกกึ๊กกึ๋ยย์ (กางเกง)",
  T_50_YU_F_H_VA_WITCH: "แม่มดมะลึกกึ๊กกึ๋ยย์ (หัว)",
  T_50_YU_F_HA_VA_WITCH: "แม่มดมะลึกกึ๊กกึ๋ยย์ (ลายเพ้นท์)",
  T_50_YU_F_S_VA_WITCH: "แม่มดมะลึกกึ๊กกึ๋ยย์ (รองเท้า)",
  T_50_YU_F_T_VA_WITCH: "แม่มดมะลึกกึ๊กกึ๋ยย์ (เสื้อ)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "เหตุการณ์ที่กำหนดเอง",
  T_51_GT_WS_BASIC: "พื้นฐาน",
  T_51_GT_WS_GLOBALEVENT: "กิจกรรมทั่วโลก",
  T_51_GT_WS_PRIVATEEVENT: "กิจกรรมส่วนตัว",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "เวลาเตรียมตัวก่อนเริ่มเกม",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "คุณสมบัติที่อ่านได้อย่างเดียว",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "แจ็คเก็ตหนังดำ(หญิง)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "ช่างประปาสาว",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "ปราดเปรียวทมิฬ (รองเท้า)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "กางเกงขาสั้นเรดไลท์ (หญิง)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "กระโปรงเรดไลท์",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "ปราดเปรียวทมิฬ (ฮู้ด)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "เสื้อลายดอกน้ำเงิน",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "กุหลาบและเห็ด",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "เสื้อเรดไลท์ (หญิง)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "รวยวาสนา (ล่าง)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "กางเกงวอร์มดำ (ชาย)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "กางเกงแก๊ง",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "กางเกงผู้อยู่รอด",
  TXT_AVATAR_MALE_PANTS_MARIO: "ช่างประปาชาย",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "รองเท้าผู้รอดชีวิต",
  TXT_AVATAR_MALE_SHOE_RED: "รองเท้าแดง(ชาย)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "รวยวาสนา (บน)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "เบสบอลดำ(ชาย)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "เสื้อก่อการร้าย",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "เจ๋งจ๊าบ (ฮู้ด)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "เสื้อหัวหน้าแก๊ง",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "เสื้อผู้อยู่รอด",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "ช่างประปาโรแมนติก",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "แจ็คเก็ตนักซิ่ง (หญิง)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "ตัวตลกร้าย (ชาย)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "แจ็คเก็ตนักซิ่ง ชาย)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "ทีมต้องการแทงค์!",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "ทาโกะมอนสเตอร์ (ม่วง)",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "หน้ากากคาบูกิ",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "รอยสักพิงค์แก๊งสเตอร์",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "กระดุมหน้า",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "วิกตอเรีย",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "แองเจิลวิง",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "กางเกงลูกท้อ",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "กลีบซากุระ",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "แอร์ฟอร์ซคูล",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "รัดรูปแซฟไฟร์",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "ซากุระโปรยปราย",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "แมงป่องดำ",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "แฟนธอมเฟเธอร์",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "ร่างทรงเงา",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "ผ้าผสม",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "บูทสูงทิมเบอร์",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "ร่างทรงเงา",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "คาร์บอนสปีด",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "ยีนส์แซฟไฟร์",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "เสื้อแมงป่องดำ",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "เยลโล่พาร์ท",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "ร่างทรงเงา",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "กางเกงบอลสีขาว",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "กางเกงเบสบอลหญิง",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "แจ็คเก็ตสมาร์ทบลู (หญิง)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "เสื้อเบสบอลหญิง",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "กางเกงเบสบอลชาย",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "สเต็ปอัปเฮดเซตชาย",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "รองเท้าเบสบอลชาย",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "แจ็กเก็ตสมาร์ทบลู (ชาย)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "เสื้อเบสบอลอาชีพชาย",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "กรีนก๊อตจิ",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "รองเท้าสตั๊ดเงิน",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "สิงโตคำราม",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "หน้ากากบุรุษปริศนา",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "สุภาพบุรุษปริศนา",
  TXT_AVATAR_PARACHUTE_8: "ร่มชูชีพ - แย้มยิ้ม",
  TXT_AVATAR_SHIRT_PLAID_2: "ขวัญใจไร่อ้อย (แดง)",
  TXT_AVATAR_SHOES_1: "รองเท้าผ้าใบ(สีขาว)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "เสื้อนักเรียน (เบโกเนีย)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "เสื้อนักเรียน (กุหลาบ)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "เสื้อนักเรียน (เบญจมาศ)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "เสื้อนักเรียน (ม่วง)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "เสื้อนักเรียน (มะลิ)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "สาวมัธยม (เข้ม)",
  TXT_AVATAR_TSHIRT_WEEK_007: "อาทิตย์เลื่องลือ",
  TXT_BANNER_NAME_MISHA: "สปีด",
  TXT_CHARACTER_ADAM_NAME: "ไพรมิส",
  TXT_CHARACTER_BODYGUARD_NAME: "นิกิตา",
  TXT_CHARACTER_COP_NAME: "แอนดรูว์",
  TXT_CHARACTER_EVA_NAME: "นูลล่า",
  TXT_CHARACTER_NURSE_NAME: "โอลิเวีย",
  TXT_CHARACTER_RACERGIRL_NAME: "มิชา",
  TXT_CHARACTER_RUNNER_NAME: "เคลลี่",
  TXT_CHARACTER_SEAMAN_NAME: "ฟอร์ด",
  TXT_CLAN_NAME: "ชื่อ",
  TXT_COLLECTION_DESCRIPTION: "คำอธิบาย",
  TXT_COLLECTION_HEADPORTRAIT: "รูป",
  TXT_INVENTORY_TITLE_EQUIPMENT: "อุปกรณ์",
  TXT_ITEM_AK: "AK",
  TXT_ITEM_ARAMMO: "กระสุน AR",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "กระเป๋า Lv1",
  TXT_ITEM_BAG2: "กระเป๋า Lv2",
  TXT_ITEM_BAG3: "กระเป๋า Lv3",
  TXT_ITEM_BASEBALLPOLE: "ไม้เบสบอล",
  TXT_ITEM_BOWAMMO: "ลูกศรหน้าไม้",
  TXT_ITEM_CHANGUO: "กระทะ",
  TXT_ITEM_CROSSBOW: "หน้าไม้",
  TXT_ITEM_DESC_FLASH: "ระเบิดที่ตัดประสาทสัมผัสของศัตรูชั่วคราว",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "พยาบาล",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "หมัด",
  TXT_ITEM_FLASH: "ระเบิดแสง",
  TXT_ITEM_FOREGRIP1: "ด้ามจับหน้าเลเวล 1",
  TXT_ITEM_FOREGRIP2: "ด้ามจับหน้าเลเวล 2",
  TXT_ITEM_FOREGRIP3: "ด้ามจับหน้าเลเวล 3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "ระเบิดมือ",
  TXT_ITEM_GROZA: "Groza",
  TXT_ITEM_HANDCANNON: "Hand Cannon",
  TXT_ITEM_HEATSIGHT: "กล้องจับความร้อน",
  TXT_ITEM_HELMET1: "หมวก Lv1",
  TXT_ITEM_HELMET2: "หมวก Lv2",
  TXT_ITEM_HELMET3: "หมวก Lv3",
  TXT_ITEM_HGAMMO: "กระสุนปืนพก",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mmSR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "มีดพร้า",
  TXT_ITEM_MAGEZINE1: "แมกกาซีนเลเวล 1",
  TXT_ITEM_MAGEZINE2: "แมกกาซีนเลเวล 2",
  TXT_ITEM_MAGEZINE3: "แมกกาซีนเลเวล 3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "ปากปืนเลเวล 1",
  TXT_ITEM_MUZZLE2: "ปากปืนเลเวล 2",
  TXT_ITEM_MUZZLE3: "ปากปืนเลเวล 3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "กระสุน SG",
  TXT_ITEM_SIGHT2: "สโคป x2",
  TXT_ITEM_SIGHT4: "สโคป x4",
  TXT_ITEM_SILENCER1: "ปลอกเก็บเสียง",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "กระสุน SMG",
  TXT_ITEM_SNAMMO: "กระสุนสไนเปอร์",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "เกราะ Lv1",
  TXT_ITEM_VEST2: "เกราะ Lv2",
  TXT_ITEM_VEST3: "เกราะ Lv3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "ผลการแข่งขัน",
  TXT_MESSAGEBOX_ERROR: "ล้มเหลว",
  TXT_OB10_HQW_ITEM_BIPOD: "ขาตั้งปืน",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "ถังน้ำมัน",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "มิเกล",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "สังหารคลั่ง",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "ไม้เบสบอล - Mexican Grilled Corn",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "ระยะการระเบิด",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "The Executioner",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "กับระเบิด",
  TXT_OB11_HQW_LANDMINE_DESC: "ระเบิดที่สามารถวางดักบนพื้น ระวัง! อย่าเหยียบเองแล้วกัน",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "แคโรลีน",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "ปรบมือ",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "แด๊บ",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "กะต๊าก",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "ไงพวก!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "ก๊าก",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "อ่อนน่า",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "เมื่อถือปืนลูกซอง เคลื่อนที่เร็วขึ้น [FFB300]{0}%",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "ควง ซอง ซิ่ง",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "SCAR - Yellow Puma",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "SCAR - TOP GAMER",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "กล่องเสริมเกราะ",
  TXT_OB5_HISTORY_HEADSHOOT: "ยิงหัว",
  TXT_OB5_HISTORY_LIVE: "รอดชีวิต",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "แม็กซิม",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "ลดเวลาในการกินเห็ดและใช้ยา [FFB300]{0}%",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "จอมกินแหลก",
  TXT_OB7_ZC_CLAN_NICKNAME: "ชื่อเล่น",
  TXT_OB7_ZJS_HISTORY_TIME: "เวลา",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "กองไฟ",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "ร่มชูชีพ - ฟ้าคะนอง",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "กล้า",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "เพิ่มดาเมจของหมัด [FFB300]{0}%",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "มวยไทย",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "AWM - Purple Meadows",
  TXT_OB8_ZXR_G18_CAMO_NAME: "G18 - Atom Splitter",
  TXT_OB8_ZXR_M249_CAMO_NAME: "M249 - Withered",
  TXT_OB8_ZXR_M79_CAMO_NAME: "M79 - Skysplitter",
  TXT_OB8_ZXR_USP_CAMO_NAME: "USP - Snow Leopard",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "พาโลม่า",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "นักค้าอาวุธ",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "สกายบอร์ด - บูย่าบอร์ด",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "ไอซ์วอลล์",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "AK47 - Digital Camo",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "FAMAS - Bloody Jaw",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "G18 - Tropical Camo",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "GROZA- Electric Shock",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "M1014 - Galactic Wyvern",
  TXT_OB9_ZXR_M14_CAMO_NAME: "M14 - Colour Bits",
  TXT_OB9_ZXR_M1873_NAME: "M1873 - Sapphire Blue",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "MACHETE -  Swordfish",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "MP5 - Emerald Green",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "SCAR - Purple Quartz",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "SKS - Earthen Military",
  TXT_OPTION_HIGH_BRIGHTNESS: "สว่าง",
  TXT_PLAYER_RANK: "อันดับ",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "เกาะสวรรค์",
  TXT_SETTING_CHANGEWEAPON: "ปุ่มลัดสลับอาวุธ",
  TXT_SETTING_OB4_NOTREAL: "มืด",
  TXT_SKILL_DESC_COP: "ความทนทานเกราะลดลง [FFB300]{0}%[-]",
  TXT_SKILL_DESC_RUNNER: "ความเร็วในการวิ่งเพิ่มขึ้น [FFB300]{0}%[-]",
  TXT_SKILL_NAME_COP: "เซียนชุดเกราะ",
  TXT_SKILL_NAME_NURSE: "สัมผัสเยียวยา",
  TXT_SKILL_NAME_RACERGIRL: "เบิร์นรถ",
  TXT_SKILL_NAME_RUNNER: "วิ่งสู้ฟัด",
  TXT_SKILL_NAME_SEAMAN: "ปณิธานเหล็กกล้า",
  TXT_TUTORIAL_HUD: "หน้าต่างใช้งาน",
  TXT_TUTORIAL_HUD_LABEL10: "วิ่งเร็ว",
  TXT_TUTORIAL_PICKUP_LABEL0: "อาวุธ",
  T_34_M_WS_VFXTYPE: "ประเภท VFX",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "เป้าหมายของการโจมตี",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "ประเภท UI ของผู้เล่น",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "ประเภทสกิลของสัตว์ประหลาด",
  T_45_META_WS_DESCRIPTIVECOLOR: "สีเพื่อการบรรยาย",
  T_45_META_WS_GAMETIME: "เวลาเกม",
  T_45_META_WS_PROPERTY: "คุณสมบัติ",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "ประเภทของรูปแบบปุ่ม UI",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "ประเภทของ UI ปุ่มสังคม",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "ความเร่ง",
  T_46_META_WS_A_ACCOUNTID: "รหัสเลขที่บัญชี",
  T_46_META_WS_A_ACTIONTYPE: "ประเภทของการกระทำ",
  T_46_META_WS_A_ACTIVE: "เปิดการทำงาน",
  T_46_META_WS_A_ANGLE: "มุม",
  T_46_META_WS_A_ANY: "ใดๆ",
  T_46_META_WS_A_APPEARANCEGROUP: "กลุ่มรูปลักษณ์",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "การแสดงออกยืนยัน",
  T_46_META_WS_A_ATTACHMENT: "อุปกรณ์เสริม",
  T_46_META_WS_A_ATTACHMENTS: "รายการอุปกรณ์เสริม",
  T_46_META_WS_A_ATTACKABLE: "สามารถโจมตีได้",
  T_46_META_WS_A_ATTACKER: "ผู้โจมตี",
  T_46_META_WS_A_ATTACKTARGET: "เป้าหมายการโจมตี",
  T_46_META_WS_A_AUTOPLAY: "เล่นอัตโนมัติ",
  T_46_META_WS_A_AXIS: "แกน",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "ฐาน",
  T_46_META_WS_A_BOUNDTARGET: "เป้าหมายที่ถูกผูกไว้",
  T_46_META_WS_A_BTREE: "ผังต้นไม้พฤติกรรม",
  T_46_META_WS_A_BUFF: "การเสริมพลัง",
  T_46_META_WS_A_CAMERA: "กล้อง",
  T_46_META_WS_A_CAPICITY: "ความจุ",
  T_46_META_WS_A_CENTER: "จุดศูนย์กลาง",
  T_46_META_WS_A_CHANGEROTATION: "เปลี่ยนการหมุน",
  T_46_META_WS_A_CHANNEL: "ช่อง",
  T_46_META_WS_A_CHASEENEMY: "ไล่ตามศัตรู",
  T_46_META_WS_A_CHILD: "ลูก",
  T_46_META_WS_A_COLOR: "สี",
  T_46_META_WS_A_COLUMN: "แถวแนวตั้ง",
  T_46_META_WS_A_COLUMNNAME: "ชื่อของแถวแนวตั้ง",
  T_46_META_WS_A_COMEBACK: "กลับมา",
  T_46_META_WS_A_COMPONENT: "ส่วนประกอบ",
  T_46_META_WS_A_CONTENT: "เนื้อหา",
  T_46_META_WS_A_COORDINATESYSTEM: "ระบบพิกัด",
  T_46_META_WS_A_COUNT: "นับ",
  T_46_META_WS_A_COUNTS: "นับจำนวน",
  T_46_META_WS_A_CREATEDENTITY: "สร้างเอนทิตี้",
  T_46_META_WS_A_CROSSPLATFORM: "ข้ามแพลตฟอร์ม",
  T_46_META_WS_A_CULLINGMASK: "คัลลิงมาสก์ (Culling Mask)",
  T_46_META_WS_A_CURVE: "ส่วนโค้ง",
  T_46_META_WS_A_CUSTOMTAG: "แท็กที่กำหนดเอง",
  T_46_META_WS_A_CUTRADIUS: "ตัดรัศมี",
  T_46_META_WS_A_DAMAGE: "ความเสียหาย",
  T_46_META_WS_A_DAMAGESEGMENTS: "ส่วนของความเสียหาย",
  T_46_META_WS_A_DEGREE: "มุม (Degree)",
  T_46_META_WS_A_DELTA: "ความแตกต่าง (Delta)",
  T_46_META_WS_A_DEPTH: "ความลึก",
  T_46_META_WS_A_DESTVAL: "ค่าของเป้าหมาย",
  T_46_META_WS_A_DIFFICULTY: "ความยาก",
  T_46_META_WS_A_DIRECTION: "ทิศทาง",
  T_46_META_WS_A_DISABLE: "ถูกปิดใช้งานอยู่หรือไม่",
  T_46_META_WS_A_DISPLACEMENT: "การกระจัด (Displacement)",
  T_46_META_WS_A_DISTANCE: "ระยะทาง",
  T_46_META_WS_A_DIVINGMAXSPEED: "ความเร็วสูงสุดของการดำน้ำ",
  T_46_META_WS_A_DOTWEEN: "ทำอนิเมชั่นระหว่างภาพหลัก (Do Tween)",
  T_46_META_WS_A_DURATION: "ระยะเวลา",
  T_46_META_WS_A_EMOTE: "ท่าทาง",
  T_46_META_WS_A_ENABLE: "เปิดใช้งาน",
  T_46_META_WS_A_ENDAREACENTER: "จุดกึ่งกลางของพื้นที่จุดจบ",
  T_46_META_WS_A_ENDAREARANGE: "ระยะของพื้นที่จุดจบ",
  T_46_META_WS_A_ENDPOSITION: "ตำแหน่งของจุดจบ",
  T_46_META_WS_A_ENDRANK: "ระดับของจุดจบ",
  T_46_META_WS_A_EQUIPMENTS: "อุปกรณ์",
  T_46_META_WS_A_EVENTID: "รหัสเหตุการณ์",
  T_46_META_WS_A_EXPONENT: "เลขยกกำลัง",
  T_46_META_WS_A_FACTION: "ฝ่าย",
  T_46_META_WS_A_FACTORTYPE: "ประเภทปัจจัย",
  T_46_META_WS_A_FILTERTYPE: "ประเภทตัวกรอง",
  T_46_META_WS_A_FINALRADIUS: "รัศมีจุดสุดท้าย",
  T_46_META_WS_A_FINDVALUE: "หาค่า",
  T_46_META_WS_A_FIXEDRANGE: "ระยะคงที่",
  T_46_META_WS_A_FOLLOWTARGET: "ตามเป้าหมาย",
  T_46_META_WS_A_FONTCOLOR: "สีตัวอักษร",
  T_46_META_WS_A_FONTSIZE: "ขนาดตัวอักษร",
  T_46_META_WS_A_FOOTBALL: "ฟุตบอล",
  T_46_META_WS_A_FORCE: "แรงกระทำ",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "ระยะบังคับใช้ร่มชูชีพ",
  T_46_META_WS_A_FORCEMODE: "รูปแบบของแรงกระทำ",
  T_46_META_WS_A_FORWARD: "ไปข้างหน้า",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "รหัสบัญชีเกม",
  T_46_META_WS_A_HALFEXTENTS: "ยืดขนาด (ครึ่ง)",
  T_46_META_WS_A_HEIGHT: "ความสูง",
  T_46_META_WS_A_HEIGHTSEGMENTS: "ช่วงความสูง",
  T_46_META_WS_A_HITDISTANCE: "ระยะตี",
  T_46_META_WS_A_HITDISTANCES: "ระยะตี",
  T_46_META_WS_A_HITENTITIES: "ตีเอนทีตี้",
  T_46_META_WS_A_HITENTITY: "ตีเอนทีตี้",
  T_46_META_WS_A_HITNORMAL: "ตีปกติ",
  T_46_META_WS_A_HITNORMALS: "ตีปกติ",
  T_46_META_WS_A_HITPOINTS: "จุดตีโดน / HP",
  T_46_META_WS_A_HITPOSITION: "ตำแหน่งที่ตีโดน",
  T_46_META_WS_A_INCLUDETRIGGER: "รวมทริกเกอร์",
  T_46_META_WS_A_INDEX: "อินเด็กซ์",
  T_46_META_WS_A_INDEXS: "รายการอินเด็กซ์",
  T_46_META_WS_A_INITIALVELOCITY: "ความเร็วเริ่มต้น",
  T_46_META_WS_A_INITRADIUS: "รัศมีเริ่มต้น",
  T_46_META_WS_A_INWALLET: "เข้ากระเป๋าตัง",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "ด้านล่างกำลังชนหรือไม่",
  T_46_META_WS_A_ISEXIST: "มีอยู่หรือไม่",
  T_46_META_WS_A_ISLOOP: "ลูปหรือไม่",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "ถูกวางไว้บนหน้าจอหรือไม่",
  T_46_META_WS_A_ISPAUSE: "หยุดชั่วคราวอยู่หรือไม่",
  T_46_META_WS_A_ISSIDECOLLIDING: "ด้านข้างกำลังชนหรือไม่",
  T_46_META_WS_A_ISSUCCESS: "สำเร็จหรือไม่",
  T_46_META_WS_A_ISTOPCOLLIDING: "ข้างบนกำลังชนหรือไม่",
  T_46_META_WS_A_ITEM: "ไอเทม",
  T_46_META_WS_A_ITEMID: "รหัสไอเทม",
  T_46_META_WS_A_ITEMS: "รายการไอเทม",
  T_46_META_WS_A_ITEMTYPE: "ประเภทไอเทม",
  T_46_META_WS_A_JERSEYTYPE: "ประเภทเสื้อเจอร์ซี่",
  T_46_META_WS_A_KEEPVELOCITY: "เก็บค่าความเร็ว",
  T_46_META_WS_A_KEY: "คีย์ (Key)",
  T_46_META_WS_A_KEYCOLUMN: "แถวแนวตั้งของคีย์",
  T_46_META_WS_A_KEYS: "คีย์ (Keys)",
  T_46_META_WS_A_LAYER: "เลเยอร์ (Layer)",
  T_46_META_WS_A_LAYERMASK: "เลเยอร์มาสก์ (Layer Mask)",
  T_46_META_WS_A_LEFT: "ซ้าย",
  T_46_META_WS_A_LEFTVALUE: "ค่าซ้าย",
  T_46_META_WS_A_LENGTH: "ความยาว",
  T_46_META_WS_A_LEVELOBJECT: "ระดับวัตถุ",
  T_46_META_WS_A_LOG: "บันทึกข้อมูล",
  T_46_META_WS_A_LOOKATTARGET: "มองที่เป้าหมาย",
  T_46_META_WS_A_LOOPTYPE: "ประเภทของลูป (Loop)",
  T_46_META_WS_A_MAINCOLOR1: "สีหลักที่ 1",
  T_46_META_WS_A_MAINCOLOR2: "สีหลักที่ 2",
  T_46_META_WS_A_MAPCODE: "รหัสแผนที่",
  T_46_META_WS_A_MAPPEDPOSITION: "ตำแหน่งที่ถูกกำหนดไว้",
  T_46_META_WS_A_MAX: "ค่ามากสุด",
  T_46_META_WS_A_MAXDISPLACEMENT: "การเปลี่ยนแปลงตำแหน่งสูงสุด",
  T_46_META_WS_A_MAXDISTANCE: "ระยะทางสูงสุด",
  T_46_META_WS_A_MIN: "น้อยสุด",
  T_46_META_WS_A_MISSIONID: "รหัสภารกิจ",
  T_46_META_WS_A_MISSIONPROGRESS: "ความคืบหน้าภารกิจ",
  T_46_META_WS_A_MODIFYTYPE: "ปรับเปลี่ยนประเภท",
  T_46_META_WS_A_MONEYTYPE: "ประเภทของเงิน",
  T_46_META_WS_A_MUST: "ต้อง",
  T_46_META_WS_A_NAME: "ชื่อ",
  T_46_META_WS_A_NEWVALUE: "ค่าใหม่",
  T_46_META_WS_A_NODE: "โหนด (Node)",
  T_46_META_WS_A_NORMAL: "ปกติ",
  T_46_META_WS_A_NOT: "ต้องไม่มี",
  T_46_META_WS_A_OBSERVER: "ผู้สังเกตการณ์",
  T_46_META_WS_A_OFFSET: "ชดเชย (Offset)",
  T_46_META_WS_A_OLDVALUE: "ค่าเก่า",
  T_46_META_WS_A_OPERATIOMETHOD: "วิธีดำเนินงาน",
  T_46_META_WS_A_OPTIONS: "ตัวเลือก",
  T_46_META_WS_A_OTHERCOLOR: "สีอื่น ๆ",
  T_46_META_WS_A_OUTFIT: "เครื่องแต่งกาย",
  T_46_META_WS_A_OUTFITS: "รายการเครื่องแต่งกาย",
  T_46_META_WS_A_OUTWALLET: "ออกกระเป๋าตัง",
  T_46_META_WS_A_OWNER: "เจ้าของ",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "ความเร็วสูงสุดของการกระโดดร่ม",
  T_46_META_WS_A_PARAMS: "ตัวแปร (Parameter)",
  T_46_META_WS_A_PARENT: "หลัก (Parent)",
  T_46_META_WS_A_PARENTWIDGET: "วิดเจ็ตหลัก",
  T_46_META_WS_A_PATH: "เส้นทาง",
  T_46_META_WS_A_PATHPOINTS: "จุดเส้นทาง",
  T_46_META_WS_A_PHASEINDEX: "อินเด็กซ์ของช่วง",
  T_46_META_WS_A_PLATFORM: "แพลตฟอร์ม",
  T_46_META_WS_A_PLAYER: "ผู้เล่น",
  T_46_META_WS_A_PLAYSPEED: "ความเร็วของการเล่น",
  T_46_META_WS_A_POSITION: "ตำแหน่ง",
  T_46_META_WS_A_POSITIONS: "หลายตำแหน่ง",
  T_46_META_WS_A_POSTION: "ตำแหน่ง",
  T_46_META_WS_A_PREFAB: "พรีแฟบ (Prefabs)",
  T_46_META_WS_A_PROPERTY: "คุณสมบัติ",
  T_46_META_WS_A_PROPERTYID: "รหัสคุณสมบัติ",
  T_46_META_WS_A_PURSUITTARGET: "ไล่ล่าเป้าหมาย",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "รัศมี",
  T_46_META_WS_A_RANDOMDECAY: "สุ่มเน่าสลาย",
  T_46_META_WS_A_RANDOMRANGE: "ระยะการสุ่ม",
  T_46_META_WS_A_RANDOMRATIO: "อัตราส่วนการสุ่ม",
  T_46_META_WS_A_RANGE: "ระยะ",
  T_46_META_WS_A_RANK: "อันดับ",
  T_46_META_WS_A_REALCOIN: "เหรียญจริง",
  T_46_META_WS_A_REALNUMBER: "ตัวเลขจริง",
  T_46_META_WS_A_RESET: "รีเซต",
  T_46_META_WS_A_RESOURCE: "ทรัพยากรณ์",
  T_46_META_WS_A_RESULT: "ผลลัพธ์",
  T_46_META_WS_A_RIGHT: "ขวา",
  T_46_META_WS_A_RIGHTVALUE: "ค่าขวา",
  T_46_META_WS_A_ROTATION: "การหมุน",
  T_46_META_WS_A_ROW: "แถวแนวนอน",
  T_46_META_WS_A_SAMPLEPOINT: "จุดตัวอย่าง",
  T_46_META_WS_A_SCALE: "ขนาด",
  T_46_META_WS_A_SCENEID: "รหัสหน้าจอ",
  T_46_META_WS_A_SCORE: "คะแนน",
  T_46_META_WS_A_SCORENAME: "ชื่อคะแนน",
  T_46_META_WS_A_SCREENPOSITION: "ตำแหน่งบนหน้าจอ",
  T_46_META_WS_A_SCRIPT: "สคริปต์",
  T_46_META_WS_A_SEAT: "ที่นั่ง",
  T_46_META_WS_A_SEP: "ตัวระบุแบบคั่น",
  T_46_META_WS_A_SEPSTR: "ตัวคั่น",
  T_46_META_WS_A_SHEETNAME: "ชื่อแผ่นงาน",
  T_46_META_WS_A_SHOPITEM: "ไอเทมร้านค้า",
  T_46_META_WS_A_SHOWBACKGROUND: "แสดงพื้นหลัง",
  T_46_META_WS_A_SHOWMATCHRESULT: "แสดงผลลัพธ์ของเกม",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "แสดงข้อความเมื่อยกเลิก",
  T_46_META_WS_A_SKILL: "ทักษะ",
  T_46_META_WS_A_SKILLS: "รายการทักษะ",
  T_46_META_WS_A_SKILLTARGET: "เป้าหมายทักษะ",
  T_46_META_WS_A_SKIN: "สกินกระเป๋า",
  T_46_META_WS_A_SLOT: "ช่อง",
  T_46_META_WS_A_SRCVAL: "แหล่งที่มาของค่า",
  T_46_META_WS_A_SRCVALUE: "แหล่งที่มาของค่า",
  T_46_META_WS_A_STARTAREACENTER: "ศูนย์กลางพื้นที่จุดเริ่ม",
  T_46_META_WS_A_STARTAREARANGE: "ระยะพื้นที่จุดเริ่ม",
  T_46_META_WS_A_STARTINDEX: "อินเด็กซ์จุดเริ่ม",
  T_46_META_WS_A_STARTPOSITION: "ตำแหน่งจุดเริ่ม",
  T_46_META_WS_A_STARTRANK: "ลำดับเริ่มต้น",
  T_46_META_WS_A_STATE: "สถานะ",
  T_46_META_WS_A_STATUS: "สถานภาพ",
  T_46_META_WS_A_STATUSCODE: "รหัสสถานภาพ",
  T_46_META_WS_A_STYLE: "รูปแบบ",
  T_46_META_WS_A_SURFINGMAXSPEED: "ความเร็วสูงสุดของการเซิร์ฟ",
  T_46_META_WS_A_TARGET: "เป้าหมาย",
  T_46_META_WS_A_TARGETPOSITION: "ตำแหน่งของเป้าหมาย",
  T_46_META_WS_A_TEAMSEQ: "ลำดับฉากทีม",
  T_46_META_WS_A_THRESHOLD: "เกณฑ์",
  T_46_META_WS_A_TIMESTAMP: "สแตมป์เวลา",
  T_46_META_WS_A_TIPS: "เคล็ดลับ",
  T_46_META_WS_A_TITLE: "หัวเรื่อง",
  T_46_META_WS_A_TOKENCOUNT: "จำนวนโทเคน",
  T_46_META_WS_A_TOKENID: "รหัสโทเคน",
  T_46_META_WS_A_TORQUE: "แรงบิด",
  T_46_META_WS_A_TOUCHPOINT: "จุดสัมผัส",
  T_46_META_WS_A_TRANSITIONTIME: "เวลาการเปลี่ยนเฟรม (มิลลิวินาที)",
  T_46_META_WS_A_TRANSITIONTYPE: "ประเภทการเปลี่ยนเฟรม",
  T_46_META_WS_A_TRIGGER: "ทริกเกอร์",
  T_46_META_WS_A_TYPE: "ประเภท",
  T_46_META_WS_A_UI: "UI",
  T_46_META_WS_A_UIID: "รหัส UI",
  T_46_META_WS_A_UPWARD: "ขึ้นไป",
  T_46_META_WS_A_VALUE: "ค่า",
  T_46_META_WS_A_VALUEA: "ค่า A",
  T_46_META_WS_A_VALUEB: "ค่า B",
  T_46_META_WS_A_VALUES: "รายการค่า",
  T_46_META_WS_A_VALUET: "ค่า T",
  T_46_META_WS_A_VALUETYPE: "ประเภทของค่า",
  T_46_META_WS_A_VEHICLE: "ยานพาหนะ",
  T_46_META_WS_A_VEHICLESKIN: "สกินยานพาหนะ",
  T_46_META_WS_A_VELOCITY: "ความเร็ว",
  T_46_META_WS_A_VELOCITYXZ: "ความเร็ว (XZ)",
  T_46_META_WS_A_VELOCITYY: "ความเร็ว (Y)",
  T_46_META_WS_A_VISIBLE: "การมองเห็น",
  T_46_META_WS_A_WAITTIME: "ระยะเวลารอ (วินาที)",
  T_46_META_WS_A_WALLET: "กระเป๋าตัง",
  T_46_META_WS_A_WEAPON: "อาวุธ",
  T_46_META_WS_A_WEAPONSKIN: "สกินอาวุธ",
  T_46_META_WS_A_WIDGETID: "รหัสวิดเจ็ต",
  T_46_META_WS_A_WIDGETTYPE: "ประเภทวิดเจ็ต",
  T_46_META_WS_A_WIDTH: "ความกว้าง",
  T_46_META_WS_A_WORLDPOSITION: "ตำแหน่งบนโลก",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "ตำแหน่งบนโลกอยู่",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "Abs",
  T_46_META_WS_ACOS: "ACos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "เพิ่มการติดตามแบบพิเศษของ AOI",
  T_46_META_WS_ADDATTACHMENTS: "เพิ่มอุปกรณ์เสริม",
  T_46_META_WS_ADDBUFF: "เพิ่มการเสริมพลัง",
  T_46_META_WS_ADDCOMPONENT: "เพิ่มส่วนประกอบ",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "เพิ่มความเร็วฟุตบอล",
  T_46_META_WS_ADDFORCE: "เพิ่มแรงกระทำ",
  T_46_META_WS_ADDFORCEATPOSITION: "เพิ่มแรงกระทำ ณ ตำแหน่ง",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "เพิ่มปัจจัยคุณสมบัติของสูตร",
  T_46_META_WS_ADDGAMEEVENTLOG: "เพิ่มการจดบันทึกเหตุการณ์ในเกม",
  T_46_META_WS_ADDHP: "เพิ่ม HP",
  T_46_META_WS_ADDITEM: "เพิ่มไอเทม",
  T_46_META_WS_ADDITEMINSCENE: "สร้างไอเทมในฉาก",
  T_46_META_WS_ADDITEMTOSHOPITEM: "เพิ่มไอเทมที่ไอเทมร้านค้า",
  T_46_META_WS_ADDMONEY: "เพิ่มเงิน",
  T_46_META_WS_ADDSCRIPT: "เพิ่มสคริปต์",
  T_46_META_WS_ADDTAG: "เพิ่มแท็ก",
  T_46_META_WS_ADDTOKEN: "เพิ่มโทเคน",
  T_46_META_WS_ADDTORQUE: "เพิ่มแรงบิด",
  T_46_META_WS_ADDUSEREVENTLOG: "เพิ่มการจดบันทึกเหตุการณ์ของผู้ใช้งาน",
  T_46_META_WS_ANGEL: "มุมเวกเตอร์",
  T_46_META_WS_APPEND: "ผนวก",
  T_46_META_WS_APPENDRANGE: "ผนวกในระยะ",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "ใช้การตั้งค่า UI เพื่อออกจากระบบกลางทาง",
  T_46_META_WS_ASIN: "ASin",
  T_46_META_WS_ASSERT: "การยืนยัน",
  T_46_META_WS_ASSISTPLAYER: "ช่วยเหลือผู้เล่น",
  T_46_META_WS_ATAN2: "Atan2",
  T_46_META_WS_ATTACKER: "ผู้โจมตี",
  T_46_META_WS_ATTACKTARGET: "โจมตีเป้าหมาย",
  T_46_META_WS_AXISANGLETOQUATERNION: "มุมของแกนเป็นควอเตอร์เนียน",
  T_46_META_WS_BOXCAST: "สร้างกล่องแสกน",
  T_46_META_WS_BOXOVERLAP: "กล่องทับซ่อน",
  T_46_META_WS_BUTTONNAME: "ชื่อปุ่ม",
  T_46_META_WS_C_ACTIONTYPE: "ประเภทการกระทำ",
  T_46_META_WS_C_AIMABLE: "สามารถเล็งได้",
  T_46_META_WS_C_AIMASSISTABLE: "สามารถใช้ตัวช่วยเล็งได้",
  T_46_META_WS_C_AIMASSISTTYPE: "ประเภทของตัวช่วยเล็ง",
  T_46_META_WS_C_AIRDROP: "แอร์ดรอป",
  T_46_META_WS_C_AMMO: "กระสุน",
  T_46_META_WS_C_AMMOTYPE: "ประเภทกระสุน",
  T_46_META_WS_C_AMPHIBIAN: "รถสะเทินน้ำสะเทินบก",
  T_46_META_WS_C_ANIMATIONCLIP: "คลิปแอนิเมชั่น",
  T_46_META_WS_C_ANIMATIONCLIPID: "รหัสคลิปแอนิเมชั่น",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "ตัวควบคุมแอนิเมชั่น",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "สามารถติดตัวควบคุมแอนิเมชั่น",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "รหัสตัวควบคุมแอนิเมชั่น",
  T_46_META_WS_C_ANIMATIONSTATE: "สถานะแอนิเมชั่น",
  T_46_META_WS_C_ANIMATIONTRIGGER: "ทริกเกอร์แอนิเมชั่น",
  T_46_META_WS_C_APPEARENCE: "รูปลักษณ์ภายนอก",
  T_46_META_WS_C_ASSETCONFIGID: "รหัสการกำหนดแอสเซ็ส",
  T_46_META_WS_C_ASSETID: "รหัสแอสเซ็ส",
  T_46_META_WS_C_ATTACHMENT: "อุปกรณ์เสริม",
  T_46_META_WS_C_ATTACKABLETYPE: "ประเภทที่สามารถโจมตีได้",
  T_46_META_WS_C_AUDIOID: "รหัสเสียง",
  T_46_META_WS_C_BACKPACK: "กระเป๋าเป๋",
  T_46_META_WS_C_BACKPACKSKINID: "รหัสสกินกระเป๋าเป๋",
  T_46_META_WS_C_BASEDATAALIAS: "ข้อมูลพื้นฐานของนามแฝง",
  T_46_META_WS_C_BASICAPPEARANCE: "รูปลักษณ์ภายนอกพื้นฐาน",
  T_46_META_WS_C_BASICCYLINDER: "ทรงกระบอกพื้นฐาน",
  T_46_META_WS_C_BASICSCALABLE: "ปรับขนาดได้แบบพื้นฐาน",
  T_46_META_WS_C_BASICSPHERE: "ทรงกลมพื้นฐาน",
  T_46_META_WS_C_BATCHCOMBINERENDER: "การเรนเดอร์แบบรวมแบตช์",
  T_46_META_WS_C_BEVTREE: "ผังต้นไม้พฤติกรรม",
  T_46_META_WS_C_BEVTREEATTACHABLE: "ผังต้นไม้พฤติกรรมที่สามารถติดได้",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "ผังต้นไม้พฤติกรรมโหนดปรับแต่ง",
  T_46_META_WS_C_BEVTREEID: "รหัสผังต้นไม้พฤติกรรม",
  T_46_META_WS_C_BEVTREENODESTATUS: "สถานะโหนดผังต้นไม้พฤติกรรม",
  T_46_META_WS_C_BEVTREENODETYPE: "ประเภทโหนดผังต้นไม้พฤติกรรม",
  T_46_META_WS_C_BEZIERCURVE: "เส้นโค้งเบเซียร์",
  T_46_META_WS_C_BOOL: "Bool",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "ประเภทความยากของบอท",
  T_46_META_WS_C_BOUNCINGTIRE: "ความเด้งของยางรถ",
  T_46_META_WS_C_BUFFABLE: "สามารถเสริมพลังได้ไหม",
  T_46_META_WS_C_BUFFGENERATOR: "ตัวสร้างการเสริมพลัง",
  T_46_META_WS_C_BUFFTYPE: "ประเภทของตัวเสริมพลัง",
  T_46_META_WS_C_BUILTINRENDER: "บิวท์อินเรนเดอร์",
  T_46_META_WS_C_BUILTINUI: "บิวท์อิน UI",
  T_46_META_WS_C_BUILTINUITYPE: "ประเภทบิวท์อิน UI",
  T_46_META_WS_C_CAMERA: "กล้อง",
  T_46_META_WS_C_CAMERABLOCKMODE: "โหมดปิดกั้นกล้อง",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "โหมดการฉายกล้อง",
  T_46_META_WS_C_CAMERARAYCASTUI: "UI Raycast กล้อง",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "ประเภททรานซิชันกล้อง",
  T_46_META_WS_C_CAMERATYPE: "ประเภทกล้อง",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "ประเภทของข้อจำกัดมุมมองกล้อง",
  T_46_META_WS_C_CAPSULETRIGGER: "ตัวทริกเกอร์แบบแคปซูล",
  T_46_META_WS_C_CAR: "รถยนต์",
  T_46_META_WS_C_CHARACTERCONTROLLER: "ตัวควบคุมตัวละคร",
  T_46_META_WS_C_CHATCHANNEL: "ช่องพูดคุย",
  T_46_META_WS_C_CHATCHANNELTYPE: "ประเภทช่องพูดคุย",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "ตัวทริกเกอร์จุดเช็กพอยต์",
  T_46_META_WS_C_COINGENERATOR: "ตัวสร้างเหรียญ",
  T_46_META_WS_C_COLLECTIONID: "รหัสชุดเก็บข้อมูล",
  T_46_META_WS_C_COLLIDER: "ตัวเช็กการชน",
  T_46_META_WS_C_COLLIDERCOLLECTION: "รูปทรงตัวเช็กการชน",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "รหัสชุดเก็บข้อมูลตัวเช็กการชน",
  T_46_META_WS_C_COLORDRUM: "ถังสี",
  T_46_META_WS_C_COMBATABLE: "สามารถต่อสู้ได้",
  T_46_META_WS_C_COMPONENT: "ส่วนประกอบ",
  T_46_META_WS_C_CONDITION: "เงื่อนไข",
  T_46_META_WS_C_CONTAINER: "ภาชนะ",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "ประเภทระบบระบุตำแหน่ง",
  T_46_META_WS_C_CROSSBOW: "หน้าไม้ระเบิกมือ",
  T_46_META_WS_C_CSVID: "รหัส CSV",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "ทริกเกอร์ปรับแต่ง",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "วัตถุปรับแต่ง",
  T_46_META_WS_C_CUSTOMPATH: "เส้นทางปรับแต่ง",
  T_46_META_WS_C_CUSTOMUI: "UI ปรับแต่ง",
  T_46_META_WS_C_CUSTOMUIID: "รหัส UI ปรับแต่ง",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "UI หรือวิดเจ็ตปรับแต่ง",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "รหัส UI หรือวิดเจ็ตปรับแต่ง",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "ประเภทชิ้นส่วนร่างกายที่เสียหาย",
  T_46_META_WS_C_DAMAGETYPE: "ประเภทความเสียหาย",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "ทริกเกอร์ ตายหรือเป็นอมตะ",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "วัตถุที่สามารถทำลายได้",
  T_46_META_WS_C_DICE: "ลูกเต้า",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "ร้องเท้ากระโดด 2 ชั้น",
  T_46_META_WS_C_DRUMMUSIC: "เพลงกลอง",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "ประเภทอาวุธคู่",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "วัตถุระดับทั่วไป",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "ประเภทวัตถุที่สร้างได้แบบไดนามิก",
  T_46_META_WS_C_DYNAMICFENCE: "รั่วแบบไดนามิก",
  T_46_META_WS_C_EFFECT: "เอฟเฟ็กต์",
  T_46_META_WS_C_EFFECTCONTAINER: "ตัวเก็บเอฟเฟ็กต์",
  T_46_META_WS_C_EFFECTID: "รหัสเอฟเฟ็กต์",
  T_46_META_WS_C_EMOTETYPE: "ประเภทท่าทาง",
  T_46_META_WS_C_ENDPOINTTRIGGER: "ทริกเกอร์จุดจบ",
  T_46_META_WS_C_ENTITY: "เอนทิตี้",
  T_46_META_WS_C_ENTITYORPREFABID: "รหัสเอนทิตี้หรือพรีเฟ่บ",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "อุปกรณ์ อุปกรณ์เสริม",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "ประเภทช่องอุปกรณ์",
  T_46_META_WS_C_EQUIPMENTTYPE: "ประเภทอุปกรณ์",
  T_46_META_WS_C_EVENTID: "รหัสเหตุการณ์",
  T_46_META_WS_C_FACTION: "ฝ่าย",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "เติมประเภททิศทาง",
  T_46_META_WS_C_FILLTYPE: "เติมประเภท",
  T_46_META_WS_C_FIRETYPE: "ประเภทไฟ",
  T_46_META_WS_C_FLOAT: "เลขทศนิยม",
  T_46_META_WS_C_FOLDWING: "พับปีก",
  T_46_META_WS_C_FOLLOW: "ตาม",
  T_46_META_WS_C_FONTTYPE: "ประเภทรูปแบบตัวอักษร",
  T_46_META_WS_C_FOOTBALL: "ฟุตบอล",
  T_46_META_WS_C_FORCETYPE: "ประเภทแรงกระทำ",
  T_46_META_WS_C_FORMULABLE: "สามารถกำหนดสูตรได้",
  T_46_META_WS_C_FRAMESELFRELATIVE: "กรอบญาติตัวเอง",
  T_46_META_WS_C_GAMERESULTTYPE: "ประเภทผลลัพธ์เกม",
  T_46_META_WS_C_GENDERTYPE: "ประเภทของเพศ",
  T_46_META_WS_C_GENERALSPAWNPOINT: "จุดเกิดทั่วไป",
  T_46_META_WS_C_GRENADEDEICEWALL: "ระเบิดกำแพงทำแข็ง",
  T_46_META_WS_C_GRENADEFLASHBANG: "ระเบิดแสง",
  T_46_META_WS_C_GRENADEFROZEN: "ระเบิดแช่แข็ง",
  T_46_META_WS_C_GRENADELAUNCHER: "ปืนระเบิด",
  T_46_META_WS_C_GRENADESMOKE: "ระเบิดควัน",
  T_46_META_WS_C_GRENADEWEAPON: "ระเบิดทั่วไป",
  T_46_META_WS_C_GRID: "กริด",
  T_46_META_WS_C_HANDCANNON: "ปืนใหญ่มือ ระเบิด",
  T_46_META_WS_C_HELMET: "หมวกนิรภัย",
  T_46_META_WS_C_HIERARCHICAL: "Hierarchical",
  T_46_META_WS_C_HOOKGUN: "ปืนตะขอ",
  T_46_META_WS_C_HORIZALINE: "Horizaline",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "ตำแหน่ง UI",
  T_46_META_WS_C_HUMANMODELID: "รหัสโมเดลมนุษย์",
  T_46_META_WS_C_ICEWALL: "กำแพงน้ำแข็ง",
  T_46_META_WS_C_ICEWALLCREATED: "สร้างกำแพงน้ำแข็งแล้ว",
  T_46_META_WS_C_ICEWALLMAKER: "ตัวสร้างกำแพงน้ำแข็ง",
  T_46_META_WS_C_ICON: "ไอคอนเอนทิตี้",
  T_46_META_WS_C_ICONTYPE: "ประเภทไอตอน",
  T_46_META_WS_C_INHALER: "เครื่องพ่นยา",
  T_46_META_WS_C_INT: "จำนวนเต็ม (Int)",
  T_46_META_WS_C_INT64: "จำนวนเต็ม 64 (Int64)",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "เทมเพลตแผนที่จำนวนเต็ม",
  T_46_META_WS_C_INTORINTLIST: "จำนวนเต็ม หรือ รายการจำนวนเต็ม",
  T_46_META_WS_C_INVENTORYTYPE: "ประเภทคลัง",
  T_46_META_WS_C_ITEMBASE: "ไอเทมพื้นฐาน",
  T_46_META_WS_C_ITEMCONTAINER: "ภาชนะเก็บไอเทม",
  T_46_META_WS_C_ITEMID: "รหัสไอเทม",
  T_46_META_WS_C_ITEMIDTYPE: "ประเภทรหัสไอดี",
  "T_46_META_WS_C_JERSEY STYLE": "รูปแบบเสื้อเจอร์ซี่",
  T_46_META_WS_C_JERSEYMACHINE: "เครื่องเสื้อเจอร์ซี่",
  T_46_META_WS_C_JETSHOES: "รองเท้าเจ็ท",
  T_46_META_WS_C_KEYBOARD: "คีย์บอร์ด",
  T_46_META_WS_C_KNOCKDOWNTYPE: "ประเภทของการน็อคดาวน์",
  T_46_META_WS_C_LANDMINE: "กับระเบิด",
  T_46_META_WS_C_LANDMINECREATED: "สร้างกับระเบิดแล้ว",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "ระดับของวัตถุแท่นปล่อยตัว",
  T_46_META_WS_C_LAUNCHPAD: "แท่นปล่อยตัว",
  T_46_META_WS_C_LAYOUTSORTTYPE: "ประเภทการเรียงลำดับเรย์เอาต์",
  T_46_META_WS_C_LEAD1MUSIC: "เพลงนำ 1",
  T_46_META_WS_C_LEAD2MUSIC: "เพลงนำ 2",
  T_46_META_WS_C_LEAD3MUSIC: "เพลงนำ 3",
  T_46_META_WS_C_LEVELOBJECTID: "รหัสวัตถุในด่าน",
  T_46_META_WS_C_LEVELOBJECTTYPE: "ประเภทวัตถุในด่าน",
  T_46_META_WS_C_LIST: "รายการ (List)",
  T_46_META_WS_C_LISTORMAP: "รายการหรือแผนที่",
  T_46_META_WS_C_LISTT: "เทมเพลตรายการ",
  T_46_META_WS_C_LISTT_BOOL: "รายการ Bool",
  T_46_META_WS_C_LISTT_CONDITION: "รายการเงื่อนไข",
  T_46_META_WS_C_LISTT_ENTITY: "รายการเอนทิตี้",
  T_46_META_WS_C_LISTT_FLOAT: "รายการเลขทศนิยม",
  T_46_META_WS_C_LISTT_INT: "รายการจำนวนนับ",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "รายการไอเทม",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "รายการวัตถุในด่าน",
  T_46_META_WS_C_LISTT_LOCKEY: "รายการข้อความที่แปลแล้ว",
  T_46_META_WS_C_LISTT_PLAYABLE: "รายการที่สามารถเล่นได้",
  T_46_META_WS_C_LISTT_PLAYER: "รายการผู้เล่น",
  T_46_META_WS_C_LISTT_SKILLID: "รายการรหัสทักษะ",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "รายการเอฟเฟ็กต์เสียง",
  T_46_META_WS_C_LISTT_STRING: "รายการตัวอักษร",
  T_46_META_WS_C_LISTT_TEAM: "รายการทีม",
  T_46_META_WS_C_LISTT_TYPE: "รายการประเภท",
  T_46_META_WS_C_LISTT_VECTOR3: "รายการเวกเตอร์ 3",
  T_46_META_WS_C_LOCKEY: "คีย์ที่แปลแล้ว",
  T_46_META_WS_C_LOOKAT: "ดูที่",
  T_46_META_WS_C_LOOPABLE: "สามารถทำซ้ำได้",
  T_46_META_WS_C_LOOPTYPE: "ประเภทของการทำซ้ำ",
  T_46_META_WS_C_LOOTAMMOTYPE: "ประเภทกระสุนที่เก็บ",
  T_46_META_WS_C_LOOTARMOR: "เก็บเกราะ",
  T_46_META_WS_C_LOOTARMORTYPE: "ประเภทเกราะที่เก็บ",
  T_46_META_WS_C_LOOTCONSUMABLE: "เก็บของที่บริโภคได้",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "ประเภทของที่บริโภคได้",
  T_46_META_WS_C_LOOTIAMMO: "เก็บกระสุน",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "เก็บกล่องไอเทมฟุตบอล",
  T_46_META_WS_C_LOOTSCOPE: "เก็บกล้องส่อง",
  T_46_META_WS_C_LOOTSCOPETYPE: "ประเภทกล้องส่องที่เก็บ",
  T_46_META_WS_C_LOOTSOCCERTYPE: "ประเภทฟุตบอลที่เก็บ",
  T_46_META_WS_C_LOOTTHROWABLE: "เก็บของขว้าง",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "ประเภทของขว้างที่เก็บ",
  T_46_META_WS_C_LOOTWEAPON: "เก็บอาวุธ",
  T_46_META_WS_C_LOOTWEAPONTYPE: "ประเภทอาวุธที่เก็บ",
  T_46_META_WS_C_LOWGRAVITY: "พื้นที่แรงโน้มถ่วงต่ำ",
  T_46_META_WS_C_MAP: "แผนที่",
  T_46_META_WS_C_MAPT: "เทมเพลตแผนที่",
  T_46_META_WS_C_MATERIALID: "รหัสเมททรีเรียล (Material)",
  T_46_META_WS_C_MEDKIT: "ชุดปฐมพยาบาล",
  T_46_META_WS_C_MESHID: "รหัสเมช (Mesh)",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "การกำหนดค่าการออกกลางเกม",
  T_46_META_WS_C_MINIMAP: "แผนที่ย่อ",
  T_46_META_WS_C_MINIMAPICON: "ไอคอนแผนที่ย่อ",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "ตัวเรนเดอร์พิกเซลแผนที่ย่อ",
  T_46_META_WS_C_MINISENTRY: "ป้อมปืนขนาดเล็ก",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "ประเภทระยะโจมตีป้อมปืนขนาดเล็ก",
  T_46_META_WS_C_MINISENTRYCREATED: "สร้างป้อมปืนขนาดเล็กแล้ว",
  T_46_META_WS_C_MONEY: "เงิน",
  T_46_META_WS_C_MONEYTYPE: "ประเภทเงิน",
  T_46_META_WS_C_MONSTER: "สัตว์ประหลาด",
  T_46_META_WS_C_MONSTERSPAWN: "เกิดสัตว์ประหลาด",
  T_46_META_WS_C_MONSTERTYPE: "ประเภทสัตว์ประหลาด",
  T_46_META_WS_C_MORPHABLEOBJECT: "วัตถุที่เปลี่ยนรูปได้",
  T_46_META_WS_C_MORPHOBJECT: "วัตถุที่เปลี่ยนร่าง",
  T_46_META_WS_C_MOTOBIKE: "รถมอเตอร์ไซค์",
  T_46_META_WS_C_MOVEPLATFORM: "พื้นที่ขยับได้",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "ประเภทของพื้นที่ขยับได้",
  T_46_META_WS_C_MUSHROOM: "เห็ด",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "ประเภทธรรมชาติชนิดคงที่",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "ตัวเลข",
  T_46_META_WS_C_OBJECT: "วัตถุ",
  T_46_META_WS_C_OILDRUM: "ถังน้ำมัน",
  T_46_META_WS_C_OUTFITID: "รหัสเครื่องแต่งกาย",
  T_46_META_WS_C_OUTFITSLOTTYPE: "ประเภทช่องเครื่องแต่งกาย",
  T_46_META_WS_C_PATHPOINT: "จุดเส้นทาง",
  T_46_META_WS_C_PATROLSTYLETYPE: "ประเภทรูปแบบการลาดตระเวน",
  T_46_META_WS_C_PATROLTYPE: "ประเภทการลาดตระเวน",
  T_46_META_WS_C_PERSONA: "บุคคลตัวแทน",
  T_46_META_WS_C_PHASE: "ช่วง",
  T_46_META_WS_C_PHYSICALMOVER: "ตัวเคลื่อนที่แบบกายภาพ",
  T_46_META_WS_C_PHYSICALOBJECT: "วัตถุกายภาพ",
  T_46_META_WS_C_PLATFORMTYPE: "ประเภทของพื้นแพลตฟอร์ม",
  T_46_META_WS_C_PLAYABLE: "สามารถเล่นได้",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "สามารถเล่นได้",
  T_46_META_WS_C_PLAYER: "ผู้เล่น",
  T_46_META_WS_C_PLAYERBACKPACK: "กระเป๋าเป้ของผู้เล่น",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "ประเภทสถานะพฤติกรรมของผู้เล่น",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "ประเภทพฤติกรรมของผู้เล่น",
  T_46_META_WS_C_PLAYERCCT: "CCT ของผู้เล่น",
  T_46_META_WS_C_PLAYERDATAID: "ประเภทของตัวละครที่ตั้งค่าไว้ก่อน",
  T_46_META_WS_C_PLAYERORTRANSFORM: "ผู้เล่นหรือการแปลง",
  T_46_META_WS_C_PLAYERORVEHICLE: "ผู้เล่นหรือยานพาหนะ",
  T_46_META_WS_C_PLAYEROUTFIT: "เครื่องแต่งกายของผู้เล่น",
  T_46_META_WS_C_PLAYERPOSETYPE: "ประเภทท่าโพสของผู้เล่น",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "ประเภทคะแนนการชุบชีวิตของผู้เล่น",
  T_46_META_WS_C_PLAYERSTATETYPE: "ประเภทสถานะของผู้เล่น",
  T_46_META_WS_C_POINTLIGHT: "แหล่งกำเนิดแสงแบบจุด",
  T_46_META_WS_C_PORTAL: "ประตูมิติ",
  T_46_META_WS_C_PREFABID: "รหัสพรีแฟบ",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "ตัวสร้างเอฟเฟ็กต์",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "ประเภทเท็กเจอร์ของเอฟเฟ็กต์",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "วิดเจ็ตภาพโปรไฟล์",
  T_46_META_WS_C_PROPERTY: "คุณสมบัติ",
  T_46_META_WS_C_PROPERTYFORMULA: "สูตรคุณสมบัติ",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "ประเภทปัจจัยสูตรคุณสมบัติ",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "ประเภทการปรับแต่งคุณสมบัติ",
  T_46_META_WS_C_QUATERNION: "ควอเตอร์เนียน",
  T_46_META_WS_C_RANKABLE: "สามารถจัดอันดับได้",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "ประเภทของเรย์เยอร์เรย์เคส",
  T_46_META_WS_C_REPAIRKIT: "ชุดเครื่องมือซ่อมแซม",
  T_46_META_WS_C_RESETABLE: "สามารถรีเซตได้",
  T_46_META_WS_C_RIGIDBODY: "ริจิดบอดี้ (Rigidbody)",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "ประเภทตัวจำกัดริจิดบอดี้ (Rigidbody)",
  T_46_META_WS_C_RIGIDBODYTYPE: "ประเภทริจิดบอดี้ (Rigidbody)",
  T_46_META_WS_C_ROUND: "รอบการแข่ง",
  T_46_META_WS_C_SAFEZONE: "พื้นที่ปลอดภัย",
  T_46_META_WS_C_SCOREABLE: "สามารถทำคะแนนได้",
  T_46_META_WS_C_SCRIPTID: "รหัสสคริปท์",
  T_46_META_WS_C_SEATTYPE: "ประเภทที่นั่ง",
  T_46_META_WS_C_SELFRELATIVE: "สัมพันธ์กับตนเอง",
  T_46_META_WS_C_SHOP: "ร้านค้า",
  T_46_META_WS_C_SHOPITEM: "ไอเทมในร้านค้า",
  T_46_META_WS_C_SHOPSHELF: "ชั้นวางสินค้าในร้านค้า",
  T_46_META_WS_C_SKATEBOARD: "สเก็ตบอร์ด",
  T_46_META_WS_C_SKELETON: "โครงกระดูก",
  T_46_META_WS_C_SKELETONPART: "ชิ้นส่วนโครงกระดูก",
  T_46_META_WS_C_SKILLID: "รหัสทักษะ",
  T_46_META_WS_C_SKYBLASTER: "สกายบลาสเตอร์",
  T_46_META_WS_C_SKYBOX: "กล่องท้องฟ้า",
  T_46_META_WS_C_SKYBOXTYPE: "ประเภทกล่องท้องฟ้า",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "แผ่นเกาะสังคมแบบลูกบอลหิมะ",
  T_46_META_WS_C_SORTTYPE: "จัดลำดับตามประเภท",
  T_46_META_WS_C_SOUNDDRUMTYPE: "ประเภทเสียงกลอง",
  T_46_META_WS_C_SOUNDEFFECT: "เสียงเอฟเฟ็กต์",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "เสียงเอฟเฟ็กต์หรือรายการเสียงเอฟเฟ็กต์",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "ประเภทเสียงเอฟเฟ็กต์",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "ประเภทเสียงนำ 1",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "ประเภทเสียงนำ 2",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "ประเภทเสียงนำ 3",
  T_46_META_WS_C_SOUNDPIANOTYPE: "ประเภทเสียงเปียโน",
  T_46_META_WS_C_SPAWN: "ให้กำเนิด",
  T_46_META_WS_C_SPAWNABLE: "สามารถให้กำเนิดได้",
  T_46_META_WS_C_SPAWNBOX: "โซนเกิด",
  T_46_META_WS_C_SPAWNPOSITION: "จุดกำเนิด",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "ประเภทรหัสไอเทมพิเศษ",
  T_46_META_WS_C_SPHERETRIGGER: "ตัวทริกเกอร์แบบทรงกลม",
  T_46_META_WS_C_SPORTSCAR: "รถสปอร์ต",
  T_46_META_WS_C_SPRAYCOLOR: "สีสเปรย์",
  T_46_META_WS_C_SPRAYGUN: "ปืนสเปรย์",
  T_46_META_WS_C_SPRAYRESULTUI: "UI ผลลัพธ์สเปรย์",
  T_46_META_WS_C_SPRAYRIFLE: "ปืนสเปรย์ยาว",
  T_46_META_WS_C_SPRITEID: "รหัสรูปภาพ",
  T_46_META_WS_C_STATICSCRIPTID: "รหัสสคริปท์ที่ไม่เคลื่อนย้าย",
  T_46_META_WS_C_STRING: "ตัวอักษร",
  T_46_META_WS_C_STRINGORLOCSTRING: "ตัวอักษรหรือตัวอักษรที่แปลแล้ว",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "ตัวทริกเกอร์กล่องทรัพยากรณ์",
  T_46_META_WS_C_SWINGGUN: "ปืนเหวียง",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "ช่องเปลี่ยนอุปกรณ์",
  T_46_META_WS_C_TEAM: "ทีม",
  T_46_META_WS_C_TERRAIN: "ภูมิประเทศ",
  T_46_META_WS_C_TEXT: "เอนทิตี้ข้อความ",
  T_46_META_WS_C_TEXTUREID: "รหัสเท็กเจอร์ (Texture)",
  T_46_META_WS_C_TEXTURETYPE: "เท็กเจอร์ของวัตถุ",
  T_46_META_WS_C_TIMER: "ตัวจับเวลา",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "ประเภทสไตล์รูปแบบการประทับเวลา",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "ตัวอักษรการประทับเวลาที่แปลแล้ว",
  T_46_META_WS_C_TRAJECTORY: "วิถีการเคลื่อนที่",
  T_46_META_WS_C_TRANSFORM: "ทรานฟอร์ม (Transform)",
  T_46_META_WS_C_TUKTUK: "ตุ๊กตุ๊ก",
  T_46_META_WS_C_TURRET: "ป้อมปืน",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Tween Curve",
  T_46_META_WS_C_TWEENSTYLE: "Tween Style Type",
  T_46_META_WS_C_TYPE: "ประเภท",
  T_46_META_WS_C_TYPEENUM: "ประเภท อีนัม (Enum)",
  T_46_META_WS_C_TYPEORTYPELIST: "ประเภทหรือรายการประเภท",
  T_46_META_WS_C_UIADDSCORE: "UI ของการเพิ่มคะแนน",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI ของหน้าจอแสดงข้อมูล",
  T_46_META_WS_C_UIBUILTINSWITCH: "เปลี่ยนบิลด์อิน UI",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "UI เปลี่ยนตัวควบคุมของบิลด์อิน UI",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI สำหรับแผงเลือกการ์ด",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI ตัวระบุจุดเช็กพอยต์",
  T_46_META_WS_C_UICOMPASS: "UI เข็มทิศ",
  T_46_META_WS_C_UICOUNTDOWN5: "UI รับถอยหลัง 5 วินาที",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI คำใบ้นับถอยหลัง",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI แจ้งเตือนการนับถอยหลัง",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "UI ตามหลอดพลังชีวิต",
  T_46_META_WS_C_UIHEALTHBAR: "UI หลอดพลังชีวิต",
  T_46_META_WS_C_UIHEARTBEAT: "UI จังหวะหัวใจ",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI ไอคอนแจ้งเตือน",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI แจ้งเตือนตัวตน",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI ปุ่มโต้ตอบ",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI ปุ่มกระดานผู้นำคะแนน",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI คำบรรยายการแข่งขัน",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI เลเวลสัตว์ประหลาด",
  T_46_META_WS_C_UIMONSTERUI: "UI ของ UI สัตว์ประหลาด",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI กระดานผู้นำคะแนนแบบหลายทีม",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI แผงผลลัพธ์แบบหลายทีม",
  T_46_META_WS_C_UIOPENINGBANNER: "UI ป้ายการเปิด",
  T_46_META_WS_C_UIPANEL: "แผง UI",
  T_46_META_WS_C_UIPANELEMPTY: "แผง UI แบบว่างเปล่า",
  T_46_META_WS_C_UIPHASETIMER: "UI ตัวจับเวลาของช่วง",
  T_46_META_WS_C_UIPROGRESSBAR: "UI แถบความคืบหน้า",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI วงกลมความคืบหน้า",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI ความคืบหน้าปุ่มทักษะ",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI ประเภทของคำขอสั่งซื้อ",
  T_46_META_WS_C_UIROUNDINFOBANNER: "UI ป้ายบอกข้อมูลของรอบ",
  T_46_META_WS_C_UIROUNDNUMBER: "UI ตัวเลขรอบ",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI ป้ายบอกผลลัพธ์ของรอบ",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI ป้ายบอกเริ่มรอบ",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI ทรานซิชันรอบการแข่ง",
  T_46_META_WS_C_UISCOREBAR: "UI แท่งบอกคะแนน",
  T_46_META_WS_C_UISCROLLPANEL: "UI แบบแผงเลื่อน",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI ป้ายคะแนนของรอบแบบธรรมดา",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI ป้ายบอกเริ่มรอบแบบธรรมดา",
  T_46_META_WS_C_UISIMPLETIP: "UI บอกเคล็ดลับแบบธรรมดา",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI ป้ายปะทะแบบธรรมดา (VS)",
  T_46_META_WS_C_UISKILLBUTTON: "UI ปุ่มทักษะ",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "UI วิดเจ็ตปุ่มสังคม",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI กระดานผู้นำคะแนนแบบเดี่ยว",
  T_46_META_WS_C_UISTORE: "UI ของ UI ร้านค้า",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI ข้อมูลการแข่งของทีม",
  T_46_META_WS_C_UITEXTTIP: "UI ข้อความเคล็ดลับ",
  T_46_META_WS_C_UITIMERINFO: "UI รายละเอียดตัวจับเวลา",
  T_46_META_WS_C_UITIPBUTTON: "UI ปุ่มเคล็ดลับ",
  T_46_META_WS_C_UITITLEBANNER: "UI ป้ายพาดหัว",
  T_46_META_WS_C_UITWEENTIP: "UI คำใบ้แบบ Tween",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI ข้อมูลแบบคร่าวๆ สองทีม",
  T_46_META_WS_C_UITWOTEAMINFO: "UI ข้อมูลของแบบสองทีม",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI กระดานคะแนนผู้นำแบบสองทีม",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI แผงผลลัพธ์แบบสองทีม",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI ป้ายคะแนนแบบรอบแบบสองทีม",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI แผงคะแนนแบบสองทีม",
  T_46_META_WS_C_UIVERSUSBANNER: "UI ป้ายปะทะ (Versus)",
  T_46_META_WS_C_UIWIDGET: "UI วิดเจ็ต",
  T_46_META_WS_C_UIWIDGETBUTTON: "UI ปุ่มวิดเจ็ต",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI ที่เก็บวิดเจ็ต",
  T_46_META_WS_C_UIWIDGETEMPTY: "UI วิดเจ็ตแบบว่างเปล่า",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI วิดเจ็ตภาพ",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI วิดเจ็ตฉลากอินพุต",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI วิดเจ็ตจอยสติ๊ก",
  T_46_META_WS_C_UIWIDGETLABEL: "UI วิดเจ็ตฉลาก",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI วิดเจ็ตเค้าโครง",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI วิดเจ็ตโปรไฟล์",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI วิดเจ็ตเท็กเจอร์",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI วิดเจ็ตเปิด/ปิด",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI วิดเจ็ตทัชแพด",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI ป้ายแพ้หรือชนะ",
  T_46_META_WS_C_UNITSPAWN: "ตัวกำเนิดยูนิต",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "วัตถุที่มีตรรกะการปืนกำแพง",
  T_46_META_WS_C_VECTOR2: "เวกเตอร์ 2 (Vector2)",
  T_46_META_WS_C_VECTOR3: "เวกเตอร์ 3 (Vector3)",
  T_46_META_WS_C_VEHICLE: "ยานพาหนะ",
  T_46_META_WS_C_VEHICLEIDTYPE: "ประเภทรหัสยานพาหนะ",
  T_46_META_WS_C_VEHICLESKINID: "รหัสสกินยานพาหนะ",
  T_46_META_WS_C_VENDINGMACHINE: "เครื่องขายสินค้าอัตโนมัติ",
  T_46_META_WS_C_VEST: "เสื้อกั๊ก",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "เอนทิตี้เท็กเจอร์ VFX แบบสามารถเปลี่ยนได้",
  T_46_META_WS_C_VFXTEXTURE: "เท็กเจอร์ VFX",
  T_46_META_WS_C_VISIBILITY: "การมองเห็น",
  T_46_META_WS_C_WALLET: "กระเป๋าตัง",
  T_46_META_WS_C_WALLETHUD: "UI กระเป๋าตัง",
  T_46_META_WS_C_WATERZONE: "พื้นที่น้ำ",
  T_46_META_WS_C_WAVECOUNTTYPE: "ประเภทจำนวนคลื่น",
  T_46_META_WS_C_WAVEINTERVALTYPE: "ประเภทช่วงคลื่น",
  T_46_META_WS_C_WEAPON: "อาวุธ",
  T_46_META_WS_C_WEAPONGENERATOR: "ตัวสร้างอาวุธ",
  T_46_META_WS_C_WEAPONSKINID: "รหัสสกินอาวุธ",
  T_46_META_WS_C_WEAPONTYPE: "ประเภทอาวุธ",
  T_46_META_WS_C_WIDGETTYPE: "ประเภทวิดเจ็ต",
  T_46_META_WS_C_ZIPLINE: "ซิบไลน์",
  T_46_META_WS_CAMERADIRECTION: "ทิศทางกล้อง",
  T_46_META_WS_CAMERAPOSITION: "ตำแหน่งกล้อง",
  T_46_META_WS_CAPSULECAST: "สร้างแคปซูล",
  T_46_META_WS_CAPSULEOVERLAP: "แคปซูลกำลังทับซ้อน",
  T_46_META_WS_CEIL: "เพดาน",
  T_46_META_WS_CHATCHANNEL: "ช่องพูดคุย",
  T_46_META_WS_CHECKTRIGGERBYORDER: "เช็กทริกเกอร์ตามลำดับ",
  T_46_META_WS_CLAMP: "Clamp",
  T_46_META_WS_CLEAR: "ล้าง",
  T_46_META_WS_CLEARALLCHILDREN: "ล้างลูกทั้งหมด",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "ล้าง AOI ติดตามแบบพิเศษ",
  T_46_META_WS_CLEARBACKPACK: "ล้างกระเป๋า",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "ล้างปัจจัยคุณสมบัติสูตร",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "ล้างวัตถุระดับเศษเหลือ",
  T_46_META_WS_CLIPNAME: "ชื่อคลิป",
  T_46_META_WS_CLONE: "โคลน",
  T_46_META_WS_COLLIDEDENTITY: "ชนกับเอนทิตี้",
  T_46_META_WS_COLORGET: "รับค่าสี",
  T_46_META_WS_COMPLETECUSTOMMISSION: "ผ่านภารกิจแบบกำหนดเอง",
  T_46_META_WS_CONNECT: "เชื่อมต่อ",
  T_46_META_WS_CONSUMABLEID: "รหัสของที่บริโภคได้",
  T_46_META_WS_CONTAIN: "ประกอบด้วย",
  T_46_META_WS_CONTAINKEY: "เช็กว่าประกอบไปด้วย คีย์ หรือไม่",
  T_46_META_WS_COPYTOMORPH: "ทำสำเนาเป็น Morph",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "บริโภคเงิน",
  T_46_META_WS_COSTTOKEN: "บริโภคโทเคน",
  T_46_META_WS_CREATEAIRDROP: "สร้างแอร์ดรอป",
  T_46_META_WS_CREATEBOT: "สร้างบอท",
  T_46_META_WS_CREATEBUILTINUI: "สร้างบิ้วอิน UI",
  T_46_META_WS_CREATEBUILTINUICLIENT: "สร้างบิ้วอิน UI",
  T_46_META_WS_CREATECAMERA: "สร้างกล้อง",
  T_46_META_WS_CREATECURVE: "สร้างเส้นโค้ง",
  T_46_META_WS_CREATECUSTOMUI: "สร้าง UI แบบกำหนดเอง",
  T_46_META_WS_CREATECUSTOMUICLIENT: "สร้าง UI แบบกำหนดเอง",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "สร้างวิดเจ็ต UI แบบกำหนดเอง",
  T_46_META_WS_CREATEDAMAGENUM: "สร้างเลขความเสียหาย",
  T_46_META_WS_CREATEEFFECT: "สร้างเอฟเฟ็กต์",
  T_46_META_WS_CREATEEFFECTCLIENT: "สร้างเอฟเฟ็กต์",
  T_46_META_WS_CREATEFACTION: "สร้างฝ่าย",
  T_46_META_WS_CREATEFOLLOW: "สร้างการติดตาม",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "สร้างกรอบญาติตัวเอง",
  T_46_META_WS_CREATEFROMPREFAB: "สร้างจากพรีแฟบ",
  T_46_META_WS_CREATELEVELOBJECT: "สร้างวัตถุด่าน",
  T_46_META_WS_CREATELOOKAT: "สร้างการมองที่",
  T_46_META_WS_CREATEMINIMAPICON: "สร้างไอคอนแมพขนาดย่อ",
  T_46_META_WS_CREATEMINIMAPPIXEL: "สร้างพิกเซลแมพขนาดย่อ",
  T_46_META_WS_CREATEMONSTER: "สร้างสัตว์ประหลาด",
  T_46_META_WS_CREATEMORPH: "สร้าง Morph",
  T_46_META_WS_CREATESELFRELATIVE: "สร้างญาติตัวเอง",
  T_46_META_WS_CREATESHOP: "สร้างร้านค้า",
  T_46_META_WS_CREATESHOPITEM: "สร้างไอเทมร้านค้า",
  T_46_META_WS_CREATESHOPSHELF: "สร้างชั้นวางสินค้า",
  T_46_META_WS_CREATESOUND: "สร้างเสียง",
  T_46_META_WS_CREATESOUNDCLIENT: "สร้างเสียง",
  T_46_META_WS_CREATETOKENINSCENE: "สร้างโทเคนในฉาก",
  T_46_META_WS_CREATETRAJECTORY: "สร้างวิธีการเคลื่อนที่",
  T_46_META_WS_CREATETWEEN: "สร้าง Tween",
  T_46_META_WS_CREATEWALLET: "สร้างกระเป๋าตัง",
  T_46_META_WS_CROSS: "ข้าม",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "ชื่อไฟล์ CSV แถวแนวตั้งไปเป็นจำนวนเต็ม (Int)",
  T_46_META_WS_CURRENTAMMOCOUNT: "นับจำนวนกระสุนปัจจุบัน",
  T_46_META_WS_DAMAGE: "ความเสียหาย",
  T_46_META_WS_DAMAGEDBODYPART: "ชิ้นส่วนร่างกายที่ได้รับความเสียหาย",
  T_46_META_WS_DAMAGEDPLAYERS: "ผู้เล่นที่ได้รับความเสียหาย",
  T_46_META_WS_DAMAGETYPE: "ประเภทความเสียหาย",
  T_46_META_WS_DEALDAMAGE: "ทำความเสียหาย",
  T_46_META_WS_DELETE: "ลบ",
  T_46_META_WS_DELETEAT: "ลบที่",
  T_46_META_WS_DELETECUSTOMUI: "ลบ UI แบบกำหนดเอง",
  T_46_META_WS_DELETEFROMDATABASE: "ลบจากฐานข้อมูล",
  T_46_META_WS_DELETEFROMDATASTORE: "ลบจากที่เก็บข้อมูล",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "ลบออกจากฐานข้อมูลกระดานผู้นำคะแนนด้วยคีย์",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "ลบออกจากฐานข้อมูลกระดานผู้นำคะแนนด้วยอันดับ",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "ลบออกจากที่เก็บข้อมูลกระดานผู้นำคะแนนด้วยคีย์",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "ลบออกจากที่เก็บข้อมูลกระดานผู้นำคะแนนด้วยอันดับ",
  T_46_META_WS_DELETETAG: "ลบแท็ก",
  T_46_META_WS_DELTA: "ค่าความแตกต่าง (Delta)",
  T_46_META_WS_DESTROY: "ทำลาย",
  T_46_META_WS_DESTROYBOT: "ทำลายบอท",
  T_46_META_WS_DESTROYBUILTINUI: "ทำลายบิ้วอิน UI",
  T_46_META_WS_DESTROYEQUIPMENT: "ทำลายอุปกรณ์",
  T_46_META_WS_DESTROYITEM: "ทำลายไอเทม",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "ทิศทางเป็นมุมออยเลอร์",
  T_46_META_WS_DISABLESAFEZONE: "ปิดการใช้งานพื้นที่ปลอดภัย",
  T_46_META_WS_DISPATCHEVENT: "ปล่อยกิจกรรม",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "ปล่อยกิจกรรมด้วยแพลตฟอร์ม",
  T_46_META_WS_DISTANCE: "ระยะทาง",
  T_46_META_WS_DOT: "จุด",
  T_46_META_WS_DROPITEM: "ดรอปไอเทม",
  T_46_META_WS_DYEATAREA: "ย้อมในพื้นที่",
  T_46_META_WS_DYEATPLANE: "ย้อมในเครื่องบิน",
  T_46_META_WS_DYEATPOSITION: "ย้อมในตำแหน่ง",
  T_46_META_WS_E_ABNORMALGRAVZONE: "พื้นที่แรงโน้มถ่วงต่ำ",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "ความเร่ง",
  T_46_META_WS_E_ACTIONNODE: "โหนดการกระทำ",
  T_46_META_WS_E_ACTIVE: "เปิดใช้งาน",
  T_46_META_WS_E_ACTIVESKILL: "เปิดใช้งานทักษะ",
  T_46_META_WS_E_ADBOARD: "บิลบอร์ด (หันหน้าเข้ากล้องเสมอ)",
  T_46_META_WS_E_ADD: "เพิ่ม",
  T_46_META_WS_E_ADDFRIEND: "เพิ่มเพื่อน",
  T_46_META_WS_E_AGENCYFB: "Agency FB",
  T_46_META_WS_E_AIM: "เล็ง",
  T_46_META_WS_E_AIR: "อากาศ",
  T_46_META_WS_E_AIRCONDITIONERA: "เครื่องปรับอากาศ",
  T_46_META_WS_E_AIRDROP: "แอร์ดรอป, ซอมบี้ฆ่าตัวตาย",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "ยังมีชีวิต",
  T_46_META_WS_E_AMMO: "เอฟเฟ็กต์กระสุน",
  T_46_META_WS_E_AMPHIBIANCAR: "ยานพาหนะสะเทินน้ำสะเทินบก",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "เด็กกำลังเล่นอยู่",
  T_46_META_WS_E_AR: "ไรเฟิล",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "กระสุนปืนไรเฟิล",
  T_46_META_WS_E_ARMAGAZINE: "แมกกาซีนปืนไรเฟิล",
  T_46_META_WS_E_ARMOR: "เกราะ",
  T_46_META_WS_E_ARMORBUFF: "เสริมพลังเกราะ",
  T_46_META_WS_E_ARMORLV1: "เกราะเลเวล 1",
  T_46_META_WS_E_ARMORLV2: "เกราะเลเวล 2",
  T_46_META_WS_E_ARMORLV3: "เกราะเลเวล 3",
  T_46_META_WS_E_ARMORPIERCING: "เกราะแตกสลาย",
  T_46_META_WS_E_ARMORSPECIALIST: "ทักษะ 1",
  T_46_META_WS_E_ARROW: "ลูกศร",
  T_46_META_WS_E_ASC: "ลำดับที่เพิ่มขึ้น",
  T_46_META_WS_E_ASCIGNOREZERO: "ลำดับที่เพิ่มขึ้นไม่รวมศูนย์",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "การระเบิดของแก๊ส",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "อุปกรณ์เสริม 1 สำหรับที่เข้ากันได้",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "อุปกรณ์เสริม 4 สำหรับที่เข้ากันได้",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "อุปกรณ์เสริม 5 สำหรับที่เข้ากันได้",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "อุปกรณ์เสริม 6 สำหรับที่เข้ากันได้",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "อุปกรณ์เสริม 8 สำหรับที่เข้ากันได้",
  T_46_META_WS_E_ATTACK: "โจมตี",
  T_46_META_WS_E_ATTACKGRENADE: "โจมตีระเบิดมือ",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "อัตโนมัติ",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "กลับ",
  T_46_META_WS_E_BACKANDFORTH: "ไปและกลับ",
  T_46_META_WS_E_BAG: "กระเป๋า",
  T_46_META_WS_E_BAG1: "กระเป๋า 1",
  T_46_META_WS_E_BAG2: "กระเป๋า 2",
  T_46_META_WS_E_BAG3: "กระเป๋า 3",
  T_46_META_WS_E_BAMBOOA: "ไม้ไผ่ A",
  T_46_META_WS_E_BANANATREE: "ต้นกล้วย",
  T_46_META_WS_E_BASEBALLPOLE: "Baseball Pole",
  T_46_META_WS_E_BASECOEFFICIENT: "ค่าสัมประสิทธิ์พื้นฐาน",
  T_46_META_WS_E_BASIC: "ธรรมดา",
  T_46_META_WS_E_BASICCONE: "กรวยธรรมดา",
  T_46_META_WS_E_BASICCYLINDER: "ทรงกระบอกธรรมดา",
  T_46_META_WS_E_BASICSPHERE: "ทรงกลมธรรมดา",
  T_46_META_WS_E_BATTLEINSTYLE: "การต่อสู้แบบมีสไตล์",
  T_46_META_WS_E_BELL: "กระดิ่ง",
  T_46_META_WS_E_BENCH: "ม้านั่ง",
  T_46_META_WS_E_BIGHEADHAMMER: "ค้อนหัวใหญ่",
  T_46_META_WS_E_BILLBOARD: "หน้าจอขนาดใหญ่",
  T_46_META_WS_E_BIPOD: "ขาทราย",
  T_46_META_WS_E_BISGRAFFITIWALL: "กำแพงธีม BIS",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "VFX การระเบิดของหลุมดำ",
  T_46_META_WS_E_BLACKHOLEBOOM: "VFX บอลคริสตัล",
  T_46_META_WS_E_BLAST: "การระเบิด",
  T_46_META_WS_E_BLOCK: "สี่เหลี่ยม",
  T_46_META_WS_E_BLOODBALL: "VFX หลุมดำ",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "น้ำเงิน",
  T_46_META_WS_E_BLUEDOLL: "ตุ๊กตาน้ำแข็ง",
  T_46_META_WS_E_BOARD: "พื้นที่เคลื่อนไหวได้",
  T_46_META_WS_E_BODY: "ร่างกาย",
  T_46_META_WS_E_BOMBINDICATION: "คำเตือนระเบิด",
  T_46_META_WS_E_BOMBPLIERS: "คีมระเบิด",
  T_46_META_WS_E_BONFIRE: "กองไฟที่ลุกโชน",
  T_46_META_WS_E_BOOM: "บูม",
  T_46_META_WS_E_BOOYAH: "ชัยชนะ",
  T_46_META_WS_E_BOTH: "ทั้งสอง",
  T_46_META_WS_E_BOUNCETIRE: "ยางรถยนต์",
  T_46_META_WS_E_BOWAMMO: "กระสุนธนู",
  T_46_META_WS_E_BREAKABLEBOX: "กล่องไม้ที่สามารถทำลายได้",
  T_46_META_WS_E_BREAKABLECONTAINER: "ที่เก็บของที่สามารถทำลายได้",
  T_46_META_WS_E_BREAKABLEFENCE: "รั่วที่สามารถทำลายได้",
  T_46_META_WS_E_BRICKA: "ก้อนอิฐ A",
  T_46_META_WS_E_BRICKB: "ก้อนอิฐ B",
  T_46_META_WS_E_BRICKC: "ก้อนอิฐ C",
  T_46_META_WS_E_BRICKHOUSEA: "บ้านหลังเล็ก A",
  T_46_META_WS_E_BRIGHT: "สว่าง",
  T_46_META_WS_E_BUBBLE: "ฟองน้ำ",
  T_46_META_WS_E_BUFFGENERATOR: "ตัวสร้างการเสริมพลัง",
  T_46_META_WS_E_BULLETBUFF: "เสริมพลังกระสุน",
  T_46_META_WS_E_BULLETHITTING: "กระสุนโดน",
  T_46_META_WS_E_BUMPERCAR: "รถบั๊ม",
  T_46_META_WS_E_BUMPERCARFACTORY: "ผู้ผลิตรถบั๊ม",
  T_46_META_WS_E_BURNING: "ความเสียหายเผาไหม้จากการระเบิดของยานพาหนะ",
  T_46_META_WS_E_BUSHES: "พุ่มไม้",
  T_46_META_WS_E_BUSSTOP: "สถานีรถบัส",
  T_46_META_WS_E_BUTTOM: "ขา",
  T_46_META_WS_E_BUTTONWIDGET: "วิดเจ็ตปุ่ม",
  T_46_META_WS_E_BYHIERARCHY: "ตามลำดับขั้น (Hierarchy)",
  T_46_META_WS_E_CABINET: "ตู้",
  T_46_META_WS_E_CACTUS: "ต้นกระบองเพชร",
  T_46_META_WS_E_CAMOUFLAGE: "ทักษะ 6",
  T_46_META_WS_E_CAPSULETRIGGER: "ทริกเกอร์รูปแคปซูล",
  T_46_META_WS_E_CARDIOTONIC: "ยากระตุ้นกล้ามเนื้อหัวใจ",
  T_46_META_WS_E_CASUALGAMEBGM: "เพลงพื้นหลังของเกมทั่วไป",
  T_46_META_WS_E_CEMENTA: "ซีเมนต์ A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "ช่อง A",
  T_46_META_WS_E_CHANNELB: "ช่อง B",
  T_46_META_WS_E_CHANNELC: "ช่อง C",
  T_46_META_WS_E_CHANNELD: "ช่อง D",
  T_46_META_WS_E_CHANNELE: "ช่อง E",
  T_46_META_WS_E_CHANNELF: "ช่อง F",
  T_46_META_WS_E_CHARACTERSKILL: "ทักษะของตัวละคร",
  T_46_META_WS_E_CHARACTOR: "ตัวละคร",
  T_46_META_WS_E_CHARGE: "ชาร์จ 1",
  T_46_META_WS_E_CHARGEBUSTER: "Charge Buster",
  T_46_META_WS_E_CHECKPOINT: "เช็กพอยต์",
  T_46_META_WS_E_CHEER: "เชียร์",
  T_46_META_WS_E_CHERRYBLOSSOM: "ต้นซากุระ",
  T_46_META_WS_E_CIRCLE: "วงกลม",
  T_46_META_WS_E_CIRCLEBACK: "วนลูป",
  T_46_META_WS_E_CIRCLEOFHEAT: "ไฟส่องเท้า",
  T_46_META_WS_E_CITY: "เมือง",
  T_46_META_WS_E_CLAPS: "ปรบมือ",
  T_46_META_WS_E_CLEAR: "ชัดเจน",
  T_46_META_WS_E_CLIENT: "ลูกค้า",
  T_46_META_WS_E_CLONE: "เปลี่ยนลุค",
  T_46_META_WS_E_CLONEKILL: "โคลนตาย",
  T_46_META_WS_E_CLOSE: "ปิด",
  T_46_META_WS_E_CLOTHES: "เสื้อผ้า",
  T_46_META_WS_E_COINGENERATOR: "ตัวสร้างทอง",
  T_46_META_WS_E_COLDAIR: "หมอก",
  T_46_META_WS_E_COLORBLOCK: "กล่องสีเหลืองย้อมสี",
  T_46_META_WS_E_COLOROILBARREL: "ถังน้ำมันย้อมสี",
  T_46_META_WS_E_COMBINEALL: "รวมทั้งหมด",
  T_46_META_WS_E_COMBINESELF: "รวมตัวเอง",
  T_46_META_WS_E_COMBOKEYA1: "โน้ตดนตรี - ซินธิไซเซอร์ A",
  T_46_META_WS_E_COMBOKEYA2: "โน้ตดนตรี - ซินธิไซเซอร์ A",
  T_46_META_WS_E_COMBOKEYB1: "โน้ตดนตรี - ซินธิไซเซอร์ B",
  T_46_META_WS_E_COMBOKEYB2: "โน้ตดนตรี - ซินธิไซเซอร์ B",
  T_46_META_WS_E_COMBOKEYC1: "โน้ตดนตรี - ซินธิไซเซอร์ C",
  T_46_META_WS_E_COMBOKEYC2: "โน้ตดนตรี - ซินธิไซเซอร์ C",
  T_46_META_WS_E_CONCRETEPILLAR: "เสาคอนกรีต",
  T_46_META_WS_E_CONDITIONNODE: "โหนดเงื่อนไข",
  T_46_META_WS_E_CONTAINERA: "ที่เก็บของ A",
  T_46_META_WS_E_CONTAINERB: "ตู้คอนเทนเนอร์ B",
  T_46_META_WS_E_CONTAINERC: "ตู้คอนเทนเนอร์ C",
  T_46_META_WS_E_CONTAINERWIDGET: "ที่เก็บวิดเจ็ต",
  T_46_META_WS_E_CONTINUOUS: "ต่อเนื่อง",
  T_46_META_WS_E_COUNTDOWN: "เวลานับถอยหลัง",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "นับถอยหลัง",
  T_46_META_WS_E_COUNTDOWNDIDI: "เสียงบี๊บ นับถอยหลัง",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "นับถอยหลัง",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "นับถอยหลัง 3",
  T_46_META_WS_E_CROSS: "ข้าม",
  T_46_META_WS_E_CROSSBOW: "หน้าไม้",
  T_46_META_WS_E_CROSSHAIR: "เป้าเล็ง",
  T_46_META_WS_E_CROSSHAIRS: "เป้าเล็ง",
  T_46_META_WS_E_CROUCH: "นั่งย่อ",
  T_46_META_WS_E_CROUCHING: "กำลังนั่งย่อ",
  T_46_META_WS_E_CROWCAW: "เสียงอีการ้อง",
  T_46_META_WS_E_CROWN: "มงกุฎ",
  T_46_META_WS_E_CUBE: "ลูกบาศก์กลไก",
  T_46_META_WS_E_CURSE: "เครื่องราง",
  T_46_META_WS_E_CURSEEXPLOSION: "เครื่องรางระเบิด",
  T_46_META_WS_E_CUSTOM: "กำหนดค่าเอง",
  T_46_META_WS_E_CUSTOMTRIGGER: "ทริกเกอร์แบบกำหนดค่าเอง",
  T_46_META_WS_E_CUSTOMWATERZONE: "แหล่งน้ำที่กำหนดเอง",
  T_46_META_WS_E_CYCLICCOMBUSTION: "การเผาไหม้แบบวนลูป",
  T_46_META_WS_E_CYLIC: "วงจร",
  T_46_META_WS_E_DAGGER: "มืดป่า",
  T_46_META_WS_E_DAMAGEDTRUCK: "รถบรรทุกที่ได้รับความเสียหาย",
  T_46_META_WS_E_DAMAGEZONE: "พื้นที่ความเสียหาย",
  T_46_META_WS_E_DANGERALARM: "อันตราย 2",
  T_46_META_WS_E_DANGERVIBRATING: "อันตราย 1",
  T_46_META_WS_E_DARK: "มืด",
  T_46_META_WS_E_DARKNESS: "ความมืด",
  T_46_META_WS_E_DASHATTACK: "พุ่งโจมตี",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "เกินขีดจำกัดการจัดเก็บข้อมูล",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "ข้อผิดพลาดพารามิเตอร์การจัดเก็บข้อมูล",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "การหมดเวลาการจัดเก็บข้อมูล",
  T_46_META_WS_E_DATETIME: "วัน เวลา",
  T_46_META_WS_E_DAY: "วัน",
  T_46_META_WS_E_DEAD: "ตายแล้ว",
  T_46_META_WS_E_DEATH: "ความตาย",
  T_46_META_WS_E_DEFAULT: "ค่าเริ่มต้น",
  T_46_META_WS_E_DEFAULTFIST: "หมัด",
  T_46_META_WS_E_DEFENCEGRENADE: "ระเบิดมือป้องกัน",
  T_46_META_WS_E_DESC: "เรียงลำดับจากมากไปน้อย",
  T_46_META_WS_E_DIALOGUE: "บทสนทนา",
  T_46_META_WS_E_DIAMOND: "เพชร",
  T_46_META_WS_E_DIRECTIONSIGN: "ป้ายบอกทาง",
  T_46_META_WS_E_DIRVEVEHICLE: "ขับขี่ยานพาหนะ",
  T_46_META_WS_E_DISABLE: "ปิดการใช้งาน",
  T_46_META_WS_E_DISABLED: "ปิดการใช้งานแล้ว",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "คำเตือนการหายตัวไป",
  T_46_META_WS_E_DISCONNECT: "ตัดการเชื่อมต่อ",
  T_46_META_WS_E_DISGUISE: "โคลน",
  T_46_META_WS_E_DOGHOUSE: "บ้านสุนัข",
  T_46_META_WS_E_DOOR: "ประตู",
  T_46_META_WS_E_DOUBLE: "สองเท่า",
  T_46_META_WS_E_DOUBLEDOOR: "ประตูบานคู่",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "รองเท้ากระโดด 2 ชั้น",
  T_46_META_WS_E_DOUBLEMAGEZINE: "แมกกาซีนคู่",
  T_46_META_WS_E_DRAW: "เสมอ",
  T_46_META_WS_E_DRILLZOMBIE: "ซอมบี้สว่าน",
  T_46_META_WS_E_DRIVE: "ขับ",
  T_46_META_WS_E_DRIVER: "คนขับรถ",
  T_46_META_WS_E_DROPBEAT: "ทักษะ 4",
  T_46_META_WS_E_DRUMKEY1: "โน้ตดนตรี - กลอง 1",
  T_46_META_WS_E_DRUMKEY2: "โน้ตดนตรี - กลอง 2",
  T_46_META_WS_E_DUEL: "กระต่อสู้",
  T_46_META_WS_E_DUMMY: "หุ่นจำลอง",
  T_46_META_WS_E_DUMMYGRENADE: "ระเบิดจำลอง",
  T_46_META_WS_E_DUMP: "ทิ้ง",
  T_46_META_WS_E_DUSK: "พลบค่ำ",
  T_46_META_WS_E_DUST: "ควันและฝุ่น",
  T_46_META_WS_E_DYNAMIC: "ไดนามิก",
  T_46_META_WS_E_E: "ค่าคงที่ตามธรรมชาติ",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "ง่าย",
  T_46_META_WS_E_ELECTRICSHOCK: "ไฟฟ้าช็อต",
  T_46_META_WS_E_ELECTRICSURFBOARD: "กระดานโต้คลื่นไฟฟ้า",
  T_46_META_WS_E_ELECTRICZONE: "พื้นที่ไฟฟ้า",
  T_46_META_WS_E_ELECTRONICBGM: "BGM แฟนตาซี อิเล็กโทรนิค น่ารัก",
  T_46_META_WS_E_ELIMINATEDBOSS: "หัวหน้ากิลด์ที่ถูกถอดถอน",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "คำเตือนการฆ่า",
  T_46_META_WS_E_EMOTE: "ท่าทาง",
  T_46_META_WS_E_ENABLE: "เปิดใช้งาน",
  T_46_META_WS_E_ENERGETIC: "เต็มไปด้วยพลังงาน",
  T_46_META_WS_E_ENTERVEHICLE: "เข้ายานพาหนะ",
  T_46_META_WS_E_EP: "EP",
  T_46_META_WS_E_EXCLAMATIONMARK: "อัศเจรีย์",
  T_46_META_WS_E_EXIT: "ออก",
  T_46_META_WS_E_EXITVEHICLE: "ออกยานพาหนะ",
  T_46_META_WS_E_EXPLODE: "ระเบิดตัวเอง",
  T_46_META_WS_E_EXPLOSION: "VFX การระเบิด",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "ไฟการระเบิด",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "ทักษะลูกแก้วพลังงาน",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "ซอมบี้ระเบิด",
  T_46_META_WS_E_EYE: "แว่นตา",
  T_46_META_WS_E_FACEPAINT: "การเพ้นท์หน้า",
  T_46_META_WS_E_FACTION: "ฝ่าย",
  T_46_META_WS_E_FALLING: "การตก",
  T_46_META_WS_E_FALLINGSTAR: "รับของบริโภคได้",
  T_46_META_WS_E_FALSE: "ไม่ใช่",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "กลไกใบพัด",
  T_46_META_WS_E_FAR: "ไกล",
  T_46_META_WS_E_FEATHER: "ขนนก",
  T_46_META_WS_E_FEMALE: "เพศหญิง",
  T_46_META_WS_E_FENCE: "รั้ว",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "เอนทิตี้กำลังต่อสู้",
  T_46_META_WS_E_FILLED: "เติมเต็ม",
  T_46_META_WS_E_FINISH: "เสร็จ",
  T_46_META_WS_E_FINISHINGPOINT: "จุดจบ",
  T_46_META_WS_E_FINISHLINEARCH: "ป้ายเสร็จ",
  T_46_META_WS_E_FIRE: "ไฟ",
  T_46_META_WS_E_FIRECHARGE: "บอลไฟ",
  T_46_META_WS_E_FIREWORK: "พุ/ดอกไม้ไฟ",
  T_46_META_WS_E_FIRINGEFFECT: "VFX การยิง",
  T_46_META_WS_E_FIRSTPERSON: "บุคคลที่หนึ่ง",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "บุคคลที่หนึ่งแบบดั้งเดิม",
  T_46_META_WS_E_FIST: "หมัด",
  T_46_META_WS_E_FIT: "พอดี",
  T_46_META_WS_E_FLAG: "ธง",
  T_46_META_WS_E_FLAME: "เปลวไฟ",
  T_46_META_WS_E_FLAMEGUN: "ปืนไฟ",
  T_46_META_WS_E_FLAMETHROWER: "Flamethrower",
  T_46_META_WS_E_FLASH: "ระเบิดแสง",
  T_46_META_WS_E_FLASHBANG: "ระเบิดแสง",
  T_46_META_WS_E_FLASHBANGSPARKS: "ประกายไฟของระเบิดแสง",
  T_46_META_WS_E_FLASHFREEZE: "แช่แสง",
  T_46_META_WS_E_FLEXWALL: "ผนังเลื่อนได้",
  T_46_META_WS_E_FLICKER: "การกระพริบ",
  T_46_META_WS_E_FLOWER: "ดอกไม้",
  T_46_META_WS_E_FLYBOMBBEE: "ระเบิดผึ้งบิน",
  T_46_META_WS_E_FLYPAN: "กะทะ",
  T_46_META_WS_E_FLYSHOE: "รองเท้าบิน",
  T_46_META_WS_E_FOLDER: "แฟ้ม",
  T_46_META_WS_E_FOLDWINGS: "เก็บปีก",
  T_46_META_WS_E_FOODTRUCK: "รถขายอาหาร",
  T_46_META_WS_E_FOODTRUCKB: "รถขายอาหาร B",
  T_46_META_WS_E_FOOTBALL: "ฟุตบอล",
  T_46_META_WS_E_FOOTBALLGUN: "ปืนฟุตบอล",
  T_46_META_WS_E_FOOTBALLICE: "ฟุตบอลน้ำแข็ง",
  T_46_META_WS_E_FOOTBALLSHIELD: "โล่ฟุตบอล",
  T_46_META_WS_E_FOOTBALLSHOOTER: "ที่ยิงฟุตบอล",
  T_46_META_WS_E_FORCE: "แรง",
  T_46_META_WS_E_FOREGRIP_MR: "ด้ามจับ MR",
  T_46_META_WS_E_FOREGRIP1: "ด้ามจับ 1",
  T_46_META_WS_E_FOREGRIP2: "ด้ามจับ 2",
  T_46_META_WS_E_FOREGRIP3: "ด้ามจับ 3",
  T_46_META_WS_E_FORWARD: "ไปข้างหน้า",
  T_46_META_WS_E_FOUNTAIN: "บ่อน้ำพุ",
  T_46_META_WS_E_FREE: "ฟรี",
  T_46_META_WS_E_FREEZEALL: "แช่ทั้งหมด",
  T_46_META_WS_E_FREEZEPOSITION: "แช่ตำแหน่ง",
  T_46_META_WS_E_FREEZEPOSITIONX: "แช่ตำแหน่ง X",
  T_46_META_WS_E_FREEZEPOSITIONY: "แช่ตำแหน่ง Y",
  T_46_META_WS_E_FREEZEPOSITIONZ: "แช่ตำแหน่ง Z",
  T_46_META_WS_E_FREEZEROTATION: "แช่การหมุน",
  T_46_META_WS_E_FREEZEROTATIONX: "แช่การหมุน X",
  T_46_META_WS_E_FREEZEROTATIONY: "แช่การหมุน Y",
  T_46_META_WS_E_FREEZEROTATIONZ: "แช่การหมุน Z",
  T_46_META_WS_E_FREEZEZONE: "พื้นที่ที่ถูกแช่แข็ง",
  "T_46_META_WS_E_FROST GALAXY": "กาเล็กซี่ที่เย็นยะเยือก",
  T_46_META_WS_E_FROZEN: "แช่แข็ง",
  T_46_META_WS_E_FROZENGRENADE: "ระเบิดน้ำแข็ง",
  T_46_META_WS_E_FUNCTIONALITEMS: "ไอเทมที่ทำงานได้",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "เกม",
  T_46_META_WS_E_GAMEOVER: "เกมจบ 2",
  T_46_META_WS_E_GAMESTART: "เกมเริ่ม",
  T_46_META_WS_E_GARAGE: "โรงรถ",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "เปิดใช้งานกลไก",
  T_46_META_WS_E_GENTLETAP: "แตะเบาๆ",
  T_46_META_WS_E_GETITEM: "ได้รับของบริโภค 2",
  T_46_META_WS_E_GFFLATIN: "GFF Latin",
  T_46_META_WS_E_GHOST: "ผี",
  T_46_META_WS_E_GIANTDICE: "ลูกเต๋า",
  T_46_META_WS_E_GIANTLOLLIPOP: "อมยิ้มยักษ์",
  T_46_META_WS_E_GIFT: "ของขวัญ",
  T_46_META_WS_E_GLOOWALL: "ไอซ์วอลล์",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "BIS ธีมแปลงดอกไม้",
  T_46_META_WS_E_GRAFFITIWALL: "กำแพงกราฟฟิตี้",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "ปืนขอเกี่ยว",
  T_46_META_WS_E_GREATCONDUCTOR: "ตัวนำที่ดี",
  T_46_META_WS_E_GREEN: "สีเขียว",
  T_46_META_WS_E_GRENADE: "ระเบิดมือ",
  T_46_META_WS_E_GRID: "กริด",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "หอคอยสังเกตุการณ์",
  T_46_META_WS_E_GUILD: "กิลด์",
  T_46_META_WS_E_GUN: "ปืน",
  T_46_META_WS_E_GUNFIRE: "การยิงปืน",
  T_46_META_WS_E_HALO: "รัศมี",
  T_46_META_WS_E_HAMMER: "กลไกค้อนขนาดยักษ์",
  T_46_META_WS_E_HANDCANNON: "ปินใหญ่มือ",
  T_46_META_WS_E_HANGER: "ราวตากผ้า",
  T_46_META_WS_E_HARD: "ยาก",
  T_46_META_WS_E_HATTRICK: "ทักษะ8",
  T_46_META_WS_E_HAYSTACK: "กองฟาง",
  T_46_META_WS_E_HEAD: "เครื่องสวมใส่ศรีษะ",
  T_46_META_WS_E_HEADSHOOT: "ยิงเข้าหัว",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "ปืนฮีลแบบสไนเปอร์",
  T_46_META_WS_E_HEALINGPISTOL_X: "ปืนฮีล X",
  T_46_META_WS_E_HEALPISTOL: "ปืนฮีล",
  T_46_META_WS_E_HEART: "หัวใจ",
  T_46_META_WS_E_HEARTBEAT: "จังหวะหัวใจ",
  T_46_META_WS_E_HEATGUN: "ปืนความร้อน",
  T_46_META_WS_E_HEAVYWEAPON: "อาวุธหนัก",
  T_46_META_WS_E_HELL: "ยากมาก",
  T_46_META_WS_E_HELMET: "หมวกนริภัย",
  T_46_META_WS_E_HELMET1: "หมวกนริภัย1",
  T_46_META_WS_E_HELMET2: "หมวกนริภัย2",
  T_46_META_WS_E_HELMET3: "หมวกนริภัย3",
  T_46_META_WS_E_HEXAGON: "หกเหลี่ยม",
  T_46_META_WS_E_HGAMMO: "กระสุน HG",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "เครื่องพ่นไฟแบบซ่อนหา",
  T_46_META_WS_E_HIDERKILL: "ผู้ซ่อนตัวถูกฆ่าตาย",
  T_46_META_WS_E_HIHATS: "ไฮแฮท",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "ตีกระแทกแบบทื้อ",
  T_46_META_WS_E_HITEFFECT: "VFX กระสุนโดน",
  T_46_META_WS_E_HITFEEDBACK: "ผลตอบลัพธ์จากการยิง",
  T_46_META_WS_E_HOOK: "ตะขอ",
  T_46_META_WS_E_HOOKGUN: "ปืนขอเกี่ยว",
  T_46_META_WS_E_HOOKGUNAMMO: "กระสุนปืนขอเกี่ยว",
  T_46_META_WS_E_HORIZALINE: "ฮอริซาลีน",
  T_46_META_WS_E_HORIZONTAL: "แนวนอน",
  T_46_META_WS_E_HORN: "ลำโพง",
  T_46_META_WS_E_HORROR: "สยองขวัญ",
  T_46_META_WS_E_HOURGLASS: "นาฬิกาทราย",
  T_46_META_WS_E_HOUSE: "บ้าน",
  T_46_META_WS_E_HOUSEA: "บ้านชั้นเดียว",
  T_46_META_WS_E_HOUSEB: "บ้านสองชั้น",
  T_46_META_WS_E_HOUSEC: "บ้านสามชั้น",
  T_46_META_WS_E_HP: "พลังชีวิต",
  T_46_META_WS_E_HPBUFF: "เสริมพลัง พลังชีวิต",
  T_46_META_WS_E_HUT: "ห้องโดยสาร",
  T_46_META_WS_E_ICEA: "น้ำแข็ง เอ",
  T_46_META_WS_E_ICEGUN: "ปินน้ำแข็ง",
  T_46_META_WS_E_ICEWALLMAKER: "ตัวสร้างกำแพงน้ำแข็ง",
  T_46_META_WS_E_ICONOBJECT: "ไอคอน",
  T_46_META_WS_E_IMAGEWIDGET: "วิดเจ็ตรูปภาพ",
  T_46_META_WS_E_IMPULSE: "แรงกระตุ้น",
  T_46_META_WS_E_INHALER: "เครื่องพ่นยา",
  T_46_META_WS_E_INJUREDFEMALE: "ผู้หญิงกรีดร้องเมื่อโดนโจมตี",
  T_46_META_WS_E_INJUREDMALE: "ผู้ชายกรีดร้องเมื่อโดนโจมตี",
  T_46_META_WS_E_INK: "VFX หมึก",
  T_46_META_WS_E_INPUTLABLEWIDGET: "วิดเจ็ตฉลากอินพุต",
  T_46_META_WS_E_INSECTCHIRPING: "แมลงร้อง",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 วินาที",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 วินาที",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 วินาที",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 วินาที",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 วินาที",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 วินาที",
  T_46_META_WS_E_INVISIBLE: "ล่องหน",
  T_46_META_WS_E_IPIPE: "ท่อ I",
  T_46_META_WS_E_IRONFENCE: "รั้ว",
  T_46_META_WS_E_IRONFENCEB: "รั้ว B",
  T_46_META_WS_E_IRONPLATFORM: "แท่นเหล็ก",
  T_46_META_WS_E_ITEMENTITY: "ตัวสร้างของบริโภค",
  T_46_META_WS_E_JEEP: "รถจี๊ป",
  T_46_META_WS_E_JERRYCAN: "ถังน้ำมัน",
  T_46_META_WS_E_JERSEYMACHINE: "เครื่องผลิตเจอร์ซี่",
  T_46_META_WS_E_JOINEDGAMEDULL: "เข้าร่วมการต่อสู้",
  T_46_META_WS_E_JOINGAME: "เข้าร่วมเกม",
  T_46_META_WS_E_JOYSTICKWIDGET: "วิดเจ็ตจอยสติ๊ก",
  T_46_META_WS_E_JUMP: "กระโดด",
  T_46_META_WS_E_JUMPATTACK: "กระโดดโจมตี",
  T_46_META_WS_E_JUSTPATROL: "ลาดตระเวนอย่างเดียว",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "ดาบซามูไร",
  T_46_META_WS_E_KEY: "คีย์",
  T_46_META_WS_E_KICK: "เตะ",
  T_46_META_WS_E_KILLINGTIPS: "เคล็ดลับการฆ่า",
  T_46_META_WS_E_KILLZONE: "พื้นที่สังหาร",
  T_46_META_WS_E_KINEMATIC: "จลนศาสตร์",
  T_46_META_WS_E_KNIFE: "มีด",
  T_46_META_WS_E_KNOCKDOWN: "ล้มลง",
  T_46_META_WS_E_KNOCKEDDOWN: "ล้มลง",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "วิดเจ็ตป้ายกำกับ",
  T_46_META_WS_E_LANDINGA: "บันไดลง A",
  T_46_META_WS_E_LANDINGB: "บันไดลง B",
  T_46_META_WS_E_LANDINGC: "บันไดลง C",
  T_46_META_WS_E_LANDMINE: "กับระเบิด",
  T_46_META_WS_E_LANUNCHERAMMO: "กระสุนแล๊นเชอร์",
  T_46_META_WS_E_LASER: "VFX เลเซอร์",
  T_46_META_WS_E_LASERSKILL: "ทักษะเลเซอร์",
  T_46_META_WS_E_LATTICESCREEN: "หน้าจอ",
  T_46_META_WS_E_LAWNA: "สนามหญ้า A",
  T_46_META_WS_E_LAWNB: "สนามหญ้า B",
  T_46_META_WS_E_LAYOUTWIDGET: "วิดเจ็ตเค้าโครง",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "ต้นไม้ไร้ใบ",
  T_46_META_WS_E_LEVELMAXED: "เลเวลสูงสุด",
  T_46_META_WS_E_LEVELUP: "อันดับเพิ่ม",
  T_46_META_WS_E_LEVELUPDISCARDED: "อันดับเพิ่ม",
  T_46_META_WS_E_LIGHTBEAM: "ลำแสง",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "ลำแสง",
  T_46_META_WS_E_LIGHTEFFECT: "เอฟเฟ็กต์แสง",
  T_46_META_WS_E_LIGHTNING: "ฟ้าผ่า",
  T_46_META_WS_E_LIMB: "แขนขา",
  T_46_META_WS_E_LINE: "เส้น",
  T_46_META_WS_E_LIQUID: "ของเหลว",
  T_46_META_WS_E_LOCAL: "ท้องถิ่น(Local)",
  T_46_META_WS_E_LOCALPOSITION: "ตำแหน่งโดยอ้างอิงจากวัตถุแม่",
  T_46_META_WS_E_LOCK: "ล็อค",
  T_46_META_WS_E_LONGBOX: "ลังไม้ยาว",
  T_46_META_WS_E_LOOP: "วนซ้ำ",
  T_46_META_WS_E_LOOTITEMBOX: "ลูทอาวุธ",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "ลูทกระสุน",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "ลูทเกราะ",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "ลูทไอเทมบริโภค",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "ลูทไอเทมปา",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "ลูทกล้อง",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "ลูทฟุตบอล",
  T_46_META_WS_E_LOOTSOCCERICE: "ลูทฟุตบอลน้ำแข็ง",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "ลูทฟุตบอลสุ่ม",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "ลูทโล่ฟุตบอล",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "ลูทอาวุธสุ่ม",
  T_46_META_WS_E_LOSE: "ความพ่ายแพ้",
  T_46_META_WS_E_LOUDSPEAKER: "ลำโพง",
  T_46_META_WS_E_LOWFALLING: "Lowfalling",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "ระเบิดM79",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "M79 ระเบิดเฉพาะทาง",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "มีดมาเชเต้",
  T_46_META_WS_E_MACHINEGUN: "SMG",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "นิตยสาร1",
  T_46_META_WS_E_MAGEZINE2: "นิตยสาร2",
  T_46_META_WS_E_MAGEZINE3: "นิตยสาร3",
  T_46_META_WS_E_MAGMAA: "แม็กม่า A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "แว่นขยาย",
  T_46_META_WS_E_MALE: "ชาย",
  T_46_META_WS_E_MARK: "เครื่องหมาย",
  T_46_META_WS_E_MARKER: "เครื่องหมาย",
  T_46_META_WS_E_MASK: "เพ้นท์หน้า",
  T_46_META_WS_E_MAXVALUE: "ค่าสูงสุด",
  T_46_META_WS_E_MECHANICAL: "เสียงกริ๊กอย่างรวดเร็ว 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "เสียงสะท้อนของอุปกรณ์เครื่องกล",
  T_46_META_WS_E_MEDICALPROPS: "อุปกรณ์ประกอบฉากทางการแพทย์",
  T_46_META_WS_E_MEDICALTENT: "เต็นท์แพทย์",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "การเต้นของหัวใจปานกลาง",
  T_46_META_WS_E_MEDKIT: "ชุดยา",
  T_46_META_WS_E_MELEE: "ระยะประชิด",
  T_46_META_WS_E_MELEEWEAPONS: "อาวุธระยะประชิด",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "ไมโครโฟน",
  T_46_META_WS_E_MIDDLE: "กลาง",
  T_46_META_WS_E_MINIHANDLE: "MiniHandle",
  T_46_META_WS_E_MINIMAP: "แผนที่ขนาดย่อ",
  T_46_META_WS_E_MINISENTRY: "ป้อมปืนขนาดเล็ก",
  T_46_META_WS_E_MINVALUE: "ค่าขั้นต่ำ",
  T_46_META_WS_E_MISSILEEXPLODE: "อาวุธประเภทขีปนาวุธ",
  T_46_META_WS_E_MISSIONCOMPLETE: "ภารกิจสำเร็จ 1",
  T_46_META_WS_E_MISTAKE: "ความผิดพลาด",
  T_46_META_WS_E_MODERATE: "ปานกลาง",
  T_46_META_WS_E_MONEY: "เงิน",
  T_46_META_WS_E_MONSTER: "สัตว์ประหลาด",
  T_46_META_WS_E_MONSTERSPAWN: "จุดเกิดของมอนสเตอร์",
  T_46_META_WS_E_MONSTERTRUCK: "รถบรรทุกล้อโต",
  T_46_META_WS_E_MOON: "ดวงจันทร์",
  T_46_META_WS_E_MOSQUITO: "ยุง",
  T_46_META_WS_E_MOTIONTRAIL: "ด้านหลัง",
  T_46_META_WS_E_MOTOBIKE: "รถมอเตอร์ไบก์",
  T_46_META_WS_E_MOTORBIKE: "รถมอเตอร์ไบก์",
  T_46_META_WS_E_MOVE: "เคลื่อนไหว",
  T_46_META_WS_E_MOVEMENT: "เคลื่อนไหว",
  T_46_META_WS_E_MOVINGJOYSTICK: "จอยสติ๊กกำลังขยับ",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "มิสเตอร์วี",
  T_46_META_WS_E_MULTIPLIER: "ตัวคูณ",
  T_46_META_WS_E_MULTIPLY: "คูณ",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "ทวีคูณสะสม",
  T_46_META_WS_E_MUSHROOM1: "เห็ด1",
  T_46_META_WS_E_MUSHROOM2: "เห็ด2",
  T_46_META_WS_E_MUSHROOM3: "เห็ด3",
  T_46_META_WS_E_MUSHROOM4: "เห็ด4",
  T_46_META_WS_E_MUSHSHADE: "กลุ่มเห็ดยักษ์",
  T_46_META_WS_E_MUSIC: "ดนตรี",
  T_46_META_WS_E_MUZZLE1: "ปากกระบอกปืน1",
  T_46_META_WS_E_MUZZLE2: "ปากกระบอกปืน2",
  T_46_META_WS_E_MUZZLE3: "ปากกระบอกปืน3",
  T_46_META_WS_E_NEAR: "ใกล้",
  T_46_META_WS_E_NIGHT: "กลางคืน",
  T_46_META_WS_E_NOATTACK: "ไม่มีการโจมตี",
  T_46_META_WS_E_NODUALWIELDING: "ไม่มีการถืออาวุธคู่",
  T_46_META_WS_E_NOERROR: "ไม่มีข้อผิดพลาด",
  T_46_META_WS_E_NONE: "ไม่มี",
  T_46_META_WS_E_NORMAL: "ปกติ",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "ไม่มีการข้ามน็อคดาวน์",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "ทักษะ 7",
  T_46_META_WS_E_OBTAINEDCOINS: "รับทองปานกลาง",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "รับทองก้อนใหญ่",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "รับทองขนาดเล็ก",
  T_46_META_WS_E_OILDRUMEXPLODE: "ถังน้ำมันระเบิด",
  T_46_META_WS_E_ONCE: "ครั้งหนึ่ง",
  T_46_META_WS_E_ONEWAY: "วันเวย์",
  T_46_META_WS_E_OPENFOLDER: "เปิดแฟ้ม",
  T_46_META_WS_E_OPENHIHATS: "เปิดไฮแฮช",
  T_46_META_WS_E_OPENINGBOX: "เปิดกล่อง",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "ทรัพยากรณ์กิลด์",
  T_46_META_WS_E_OPENINGWARCHEST: "การจัดเก็บคลัง",
  T_46_META_WS_E_ORANGE: "ส้ม",
  T_46_META_WS_E_ORTHOGONAL: "มุมฉาก",
  T_46_META_WS_E_OUTPOST: "ป้อมยาม",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "ผนังทาสี",
  T_46_META_WS_E_PAINTSHIELDSKILL: "ทักษะสระเลือด",
  T_46_META_WS_E_PALM: "กระดาษ",
  T_46_META_WS_E_PANEL: "แผง",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "ผู้โดยสาร A",
  T_46_META_WS_E_PASSENGERB: "ผู้โดยสาร B",
  T_46_META_WS_E_PASSENGERC: "ผู้โดยสาร ค",
  T_46_META_WS_E_PASSIVE: "พาสซีฟ",
  T_46_META_WS_E_PASSIVESKILL: "ทักษะติดตัว",
  T_46_META_WS_E_PATROLWHILEATTACK: "ตระเวนขณะโจมตี",
  T_46_META_WS_E_PERSONALUAV: "UAV ส่วนบุคคล",
  T_46_META_WS_E_PERSPECTIVE: "มุมมอง",
  T_46_META_WS_E_PETTABBG: "สัตว์เลี้ยง",
  T_46_META_WS_E_PHASESTART: "เฟสเริ่มต้น",
  T_46_META_WS_E_PHONEBOOTH: "ตู้โทรศัพท์",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "เปียโนA3",
  T_46_META_WS_E_PIANOA3SHARP: "เปียโนA3#",
  T_46_META_WS_E_PIANOA4: "เปียโนA4",
  T_46_META_WS_E_PIANOA4SHARP: "เปียโนA4#",
  T_46_META_WS_E_PIANOB3: "เปียโนB3",
  T_46_META_WS_E_PIANOB4: "เปียโนB4",
  T_46_META_WS_E_PIANOC3: "เปียโนC3",
  T_46_META_WS_E_PIANOC3SHARP: "เปียโน C3#",
  T_46_META_WS_E_PIANOC4: "เปียโนC4",
  T_46_META_WS_E_PIANOC4SHARP: "เปียโน C4#",
  T_46_META_WS_E_PIANOD3: "เปียโนD3",
  T_46_META_WS_E_PIANOD3SHARP: "เปียโนD3#",
  T_46_META_WS_E_PIANOD4: "เปียโนD4",
  T_46_META_WS_E_PIANOD4SHARP: "เปียโนD4#",
  T_46_META_WS_E_PIANOE3: "เปียโนE3",
  T_46_META_WS_E_PIANOE4: "เปียโนE4",
  T_46_META_WS_E_PIANOF3: "เปียโนF3",
  T_46_META_WS_E_PIANOF3SHARP: "เปียโนF3#",
  T_46_META_WS_E_PIANOF4: "เปียโนF4",
  T_46_META_WS_E_PIANOF4SHARP: "เปียโนF4#",
  T_46_META_WS_E_PIANOG3: "เปียโนG3",
  T_46_META_WS_E_PIANOG3SHARP: "เปียโนG3#",
  T_46_META_WS_E_PIANOG4: "เปียโนG4",
  T_46_META_WS_E_PIANOG4SHARP: "เปียโน G4#",
  T_46_META_WS_E_PIANOKEY1: "โน้ตดนตรี - เปียโน",
  T_46_META_WS_E_PIANOKEY2: "โน้ตดนตรี - เปียโน",
  T_46_META_WS_E_PICKUPS: "รถกระบะ",
  T_46_META_WS_E_PICKUPTRUCK: "รถเอสยูวี",
  T_46_META_WS_E_PILLAR: "เสาคอนกรีต",
  T_46_META_WS_E_PIN: "เครื่องหมาย",
  T_46_META_WS_E_PINGPONG: "ปิงปอง",
  T_46_META_WS_E_PIPECORNER: "ท่อหักศอก",
  T_46_META_WS_E_PIPEINTERSECTION: "ท่อไขว้",
  T_46_META_WS_E_PISTOL: "ปืนพก",
  T_46_META_WS_E_PISTOLAMMO: "กระสุนปืนพก",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "บล็อกสวนสนุกตารางหมากรุก",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "ผู้เล่น",
  T_46_META_WS_E_PLUS: "บวก",
  T_46_META_WS_E_PODIUM: "แท่น",
  T_46_META_WS_E_POISONGAS: "ก๊าซพิษ",
  T_46_META_WS_E_POISONGASPREDISCARDED: "ก๊าซพิษ",
  T_46_META_WS_E_PORTAL: "พอร์ทัล",
  T_46_META_WS_E_POSTACCUMULATOR: "หลังการสะสม",
  T_46_META_WS_E_POT: "หม้อ",
  T_46_META_WS_E_POUNDINGHEART: "หัวใจเต้นเร็ว",
  T_46_META_WS_E_PREACCUMULATOR: "ก่อนการสะสม",
  T_46_META_WS_E_PRIMARYWEAPONA: "อาวุธหลักA",
  T_46_META_WS_E_PRIMARYWEAPONB: "อาวุธหลักB",
  T_46_META_WS_E_PRIOREXPLOSION: "ก่อนการระเบิดของระเบิด",
  T_46_META_WS_E_PROFILEWIDGET: "วิดเจ็ตโปรไฟล์",
  T_46_META_WS_E_PRONE: "หมอบ",
  T_46_META_WS_E_PUMPKIN: "ฟักทอง",
  T_46_META_WS_E_PURPLE: "สีม่วง",
  T_46_META_WS_E_QUADRILATERAL: "รูปสี่เหลี่ยม",
  T_46_META_WS_E_QUESTIONMARK: "เครื่องหมายคำถาม",
  T_46_META_WS_E_QUICKCHAT: "การพูดคุยด่วน",
  T_46_META_WS_E_QUICKCHATSHOW: "การแสดงการพูดคุยด่วน",
  T_46_META_WS_E_RADIAL180: "รัศมี 180°",
  T_46_META_WS_E_RADIAL360: "รัศมี 360°",
  T_46_META_WS_E_RADIAL90: "รัศมี 90°",
  T_46_META_WS_E_RAMPAGE: "อาละวาด",
  T_46_META_WS_E_RANDOM: "สุ่ม",
  T_46_META_WS_E_RANDOMBUFF: "บัฟแบบสุ่ม",
  T_46_META_WS_E_RANKDOWN: "อันดับลด",
  T_46_META_WS_E_REACTION: "ตอบกลับ",
  T_46_META_WS_E_RECOVER: "ฟื้นตัว",
  T_46_META_WS_E_RECYCLE: "รีไซเคิล",
  T_46_META_WS_E_RED: "สีแดง",
  T_46_META_WS_E_REFINERYTANK: "เหยือกน้ำ",
  T_46_META_WS_E_REFLECTIVECUBE: "บล็อกพื้นฐานสีทึบสะท้อนแสง 1",
  T_46_META_WS_E_REFRESH: "รีเฟรช",
  T_46_META_WS_E_RELEASINGSKILL: "VFX ร่ายทักษะ",
  T_46_META_WS_E_RELOAD: "โหลดซ้ำ",
  T_46_META_WS_E_REMINDER: "คำเตือน",
  T_46_META_WS_E_REPAIR: "ซ่อมแซม",
  T_46_META_WS_E_REPAIREQUIP: "อุปกรณ์ซ่อม",
  T_46_META_WS_E_REPAIRKIT: "ชุดซ่อม",
  T_46_META_WS_E_REPLACER: "Replacer",
  T_46_META_WS_E_REPORT: "รายงาน",
  T_46_META_WS_E_REST: "พักผ่อน",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "ขี่",
  T_46_META_WS_E_RIDICULE: "การล้อเลียน",
  T_46_META_WS_E_RIDICULEFUNNY: "การล้อเลียนแบบตลก",
  T_46_META_WS_E_RIFLE: "ไรเฟิล",
  T_46_META_WS_E_RIFLEAMMO: "กระสุนไรเฟิล",
  T_46_META_WS_E_RIGHT: "ขวา",
  T_46_META_WS_E_RIGHTTRAPEZOID: "สี่เหลี่ยมคางหมูมุมขวา",
  T_46_META_WS_E_RING: "กลไกวงแหวน",
  T_46_META_WS_E_RINGPREDISCARDED: "วงแหวนก่อนที่จะทิ้ง",
  T_46_META_WS_E_RIPTIDERHYTHM: "ทักษะ 9",
  T_46_META_WS_E_RISINGPARTICLE: "อนุภาคที่ขึ้น",
  T_46_META_WS_E_ROADBLOCK: "สิ่งกีดขวางถนน",
  T_46_META_WS_E_ROTATE: "การหมุน",
  T_46_META_WS_E_RUNNING: "วิ่ง",
  T_46_META_WS_E_RUSHTIME: "อาละวาด",
  T_46_META_WS_E_SAMURAI: "ซามูไร",
  T_46_META_WS_E_SANDA: "แซนด์ เอ",
  T_46_META_WS_E_SANDSTRUCTURE: "ประติมากรรมทราย",
  T_46_META_WS_E_SCALE: "มาตราส่วน",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "หุ่นไล่กา",
  T_46_META_WS_E_SCISSORS: "กรรไกร",
  T_46_META_WS_E_SCOPE2X: "กล้อง 2x",
  T_46_META_WS_E_SCOPE4X: "กล้อง 4x",
  T_46_META_WS_E_SCROLLPANEL: "แผงเลื่อน",
  T_46_META_WS_E_SECONDARYWEAPON: "อาวุธรอง",
  T_46_META_WS_E_SENSESSHOCKWAVE: "ทักษะ 10",
  T_46_META_WS_E_SERVER: "เซิร์ฟเวอร์",
  T_46_META_WS_E_SET: "บอดี้สูท",
  T_46_META_WS_E_SETTING: "การตั้งค่า",
  T_46_META_WS_E_SETTINGS: "การตั้งค่า",
  T_46_META_WS_E_SG: "ปืนลูกซอง",
  T_46_META_WS_E_SGAMMO: "กระสุน SN",
  T_46_META_WS_E_SHARPMECHANICAL: "เสียงดังกึกก้องอย่างรวดเร็ว 1",
  T_46_META_WS_E_SHIELD: "โล่",
  T_46_META_WS_E_SHIELDBROKEN: "โล่แตก",
  T_46_META_WS_E_SHIELDGUN: "ปืนโล่",
  T_46_META_WS_E_SHIELDUP: "โล่ขึ้น",
  T_46_META_WS_E_SHOCKWAVE: "คลื่นกระแทก",
  T_46_META_WS_E_SHOES: "รองเท้า",
  T_46_META_WS_E_SHOOTINGTARGET: "เป้าเคลื่อนที่",
  T_46_META_WS_E_SHORTDATE: "วันที่สั้น",
  T_46_META_WS_E_SHORTDATETIME: "วันที่และเวลาสั้น",
  T_46_META_WS_E_SHORTTIME: "เวลาอันสั้น",
  T_46_META_WS_E_SHOTGUN: "ปืนลูกซอง",
  T_46_META_WS_E_SHOTGUNAMMO: "กระสุนปืนลูกซอง",
  T_46_META_WS_E_SHOTGUNMUZZLE: "ปากปืนลูกซอง",
  T_46_META_WS_E_SHOW: "แสดง",
  T_46_META_WS_E_SHRUB: "ลังไม้ยาวหุ้มพุ่มไม้",
  T_46_META_WS_E_SICKLE: "เคียว",
  T_46_META_WS_E_SIDESCROLLING: "การเลื่อนด้านข้าง",
  T_46_META_WS_E_SIGNAL: "สัญญาณ",
  T_46_META_WS_E_SIGNOUT: "ออก",
  T_46_META_WS_E_SILENCER: "ตัวเก็บเสียง",
  T_46_META_WS_E_SIMPLE: "เรียบง่าย",
  T_46_META_WS_E_SIMPLEWIDGET: "วิดเจ็ตแบบทั่วไป",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "ตัวย่ออารบิก",
  T_46_META_WS_E_SINGLE: "เดี่ยว",
  T_46_META_WS_E_SITEHUT: "บ้านคอนเทนเนอร์",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "ชาร์จทักษะเสร็จสมบูรณ์",
  T_46_META_WS_E_SKILLRECOVER: "การฟื้นฟูทักษะ",
  T_46_META_WS_E_SKIPKNOCKDOWN: "ข้ามการน็อคดาวน์",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "หั่น",
  T_46_META_WS_E_SLOPE: "ความลาดชัน",
  T_46_META_WS_E_SLOWHEARTBEAT: "การเต้นของหัวใจช้า",
  T_46_META_WS_E_SMG: "ปืนกลเบา",
  T_46_META_WS_E_SMGAMMO: "กระสุนปินกลเบา",
  T_46_META_WS_E_SMGMUZZLE: "ปากกระบอกปืนกลเบา",
  T_46_META_WS_E_SMILEY: "หน้ายิ้ม",
  T_46_META_WS_E_SMOKE: "ควัน",
  T_46_META_WS_E_SMOKEGRENADE: "ระเบิดควัน",
  T_46_META_WS_E_SMOKEY: "ควัน",
  T_46_META_WS_E_SMOOTH: "เรียบ",
  T_46_META_WS_E_SNAMMO: "กระสุน SN",
  T_46_META_WS_E_SNARES: "บ่วง",
  T_46_META_WS_E_SNEAKERS: "VFX รองเท้าวิ่ง",
  T_46_META_WS_E_SNIPER: "สไนเปอร์ไรเฟิล",
  T_46_META_WS_E_SNIPERAMMO: "กระสุนไรเฟิลซุ่มยิง",
  T_46_META_WS_E_SNOWA: "สโนว์ A",
  T_46_META_WS_E_SNOWFLAKE: "เกล็ดหิมะ",
  T_46_META_WS_E_SOCCER: "ฟุตบอล",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "วิดเจ็ตปุ่มสังคม",
  T_46_META_WS_E_SOLARPANEL: "แผงโซลาร์เซลล์",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "ตามลำดับความสำคัญจากสูงไปต่ำ",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "ตามลำดับความสำคัญจากต่ำไปสูง",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "VFX จุดเกิด",
  T_46_META_WS_E_SPEAKER: "ลำโพง",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "เสียงปืนพิเศษ",
  T_46_META_WS_E_SPECIALGUN: "ปืนพิเศษ",
  T_46_META_WS_E_SPHERE: "ทรงกลม",
  T_46_META_WS_E_SPHERETRIGGER: "ทริกเกอร์การชนกันของทรงกลม",
  T_46_META_WS_E_SPIDERWEB: "VFX ทักษะ",
  T_46_META_WS_E_SPORTSCAR: "รถสปอร์ต",
  T_46_META_WS_E_SPOTLIGHT: "แสงสว่าง",
  T_46_META_WS_E_SPREADOFPOISONGAS: "ก๊าซพิษแพร่กระจาย",
  T_46_META_WS_E_SPRINT: "พุ่งทะยาน",
  T_46_META_WS_E_SQUARE: "สี่เหลี่ยม",
  T_46_META_WS_E_SQUAREBOX: "ลังไม้สี่เหลี่ยม",
  T_46_META_WS_E_SR: "สไนเปอร์ไรเฟิล",
  T_46_META_WS_E_STABLE: "กระท่อมมุงจาก",
  T_46_META_WS_E_STAIRS: "บันได",
  T_46_META_WS_E_STANDING: "ยืน",
  T_46_META_WS_E_STAR: "ดาว",
  T_46_META_WS_E_STATIC: "คงที่",
  T_46_META_WS_E_STATUSTRIGGER: "ทริกเกอร์ความตายหรือการอยู่ยงคงกระพัน",
  T_46_META_WS_E_STEP: "ฝีเท้า",
  T_46_META_WS_E_STEPTRIGGER: "เปิดใช้งานกลไก",
  T_46_META_WS_E_STOCK_S: "พานท้ายปืน S",
  T_46_META_WS_E_STOCK_SR: "พานท้ายปืน SR",
  T_46_META_WS_E_STOCK1: "พานท้ายปืน 1",
  T_46_META_WS_E_STOCK2: "พานท้ายปืน 2",
  T_46_META_WS_E_STOCK3: "พานท้ายปืน 3",
  T_46_META_WS_E_STONE: "หิน",
  T_46_META_WS_E_STONEBRIDGE: "สะพานหินโค้ง",
  T_46_META_WS_E_STONELANTERN: "โคมไฟพระราชวัง",
  T_46_META_WS_E_STONESPLASH: "เศษซากบิน",
  T_46_META_WS_E_STORE: "เก็บ",
  T_46_META_WS_E_STREETLAMP: "ไฟถนน",
  T_46_META_WS_E_STYLEA: "สไตล์ A",
  T_46_META_WS_E_STYLEB: "สไตล์ B",
  T_46_META_WS_E_STYLEC: "สไตล์ C",
  T_46_META_WS_E_SUBMACHINEGUN: "ปืนกลเบา",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "กระสุนปืนกลเบา",
  T_46_META_WS_E_SUCCESSFULHIT: "ตี",
  T_46_META_WS_E_SUN: "ดวงอาทิตย์",
  T_46_META_WS_E_SUNSHADE: "ชุดพาทิโอพร้อมร่ม",
  T_46_META_WS_E_SUPERCAR: "รถสปอร์ต",
  T_46_META_WS_E_SUPERMARKET: "ห้างสรรพสินค้า",
  T_46_META_WS_E_SURPRISEFIND: "ค้นพบความประหลาดใจ",
  T_46_META_WS_E_SUV: "รถเอสยูวี",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "สลับอาวุธอย่างรวดเร็ว",
  T_46_META_WS_E_SWIMRING: "แหวนว่ายน้ำ",
  T_46_META_WS_E_SWORD: "ดาบ",
  T_46_META_WS_E_SYMBOLIC: "เครื่องหมายภาคพื้น",
  T_46_META_WS_E_TANKZOMBIE: "ซอมบี้แท้งค์",
  T_46_META_WS_E_TAP: "แตะ",
  T_46_META_WS_E_TAPPINGBUTTON: "แตะปุ่ม",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "แตะปุ่มปิดการใช้งาน",
  T_46_META_WS_E_TEAM: "ทีม",
  T_46_META_WS_E_TEAMMATESINFO: "ข้อมูลเพื่อนร่วมทีม",
  T_46_META_WS_E_TELEPORT: "เทเลพอร์ต",
  T_46_META_WS_E_TELEPORTCORRECT: "บีคอนปลายทางที่ถูกต้อง",
  T_46_META_WS_E_TELEPORTWRONG: "บีคอนปลายทางที่ผิด",
  T_46_META_WS_E_TEXT: "ข้อความ",
  T_46_META_WS_E_TEXTOBJECT: "ข้อความ",
  T_46_META_WS_E_TEXTUREWIDGET: "วิดเจ็ตพื้นผิว",
  T_46_META_WS_E_THERMALSCOPE: "ขอบเขตความร้อน",
  T_46_META_WS_E_THIRDPERSON: "บุคคลที่สาม",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "บุคคลที่สามคลาสสิก",
  T_46_META_WS_E_THIRDPERSONLOCK: "ล็อคบุคคลที่สาม",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "มีดปา 2 สำหรับความเข้ากันได้",
  T_46_META_WS_E_THRILLBATTLE: "ทักษะ 5",
  T_46_META_WS_E_THROWATTACK: "โจมตีโยน",
  T_46_META_WS_E_THROWINGKNIFE: "มีดปา",
  T_46_META_WS_E_THROWREDZOMBIE: "ขว้างซอมบี้แดง",
  T_46_META_WS_E_THROWZOMBIE: "ขว้างซอมบี้",
  T_46_META_WS_E_THUMBSUP: "ชอบ",
  T_46_META_WS_E_THUNDER: "ไฟฟ้าช็อต",
  T_46_META_WS_E_TILEA: "กระเบื้อง A",
  T_46_META_WS_E_TILEB: "กระเบื้อง B",
  T_46_META_WS_E_TILEC: "กระเบื้อง C",
  T_46_META_WS_E_TILED: "ปูกระเบื้อง",
  T_46_META_WS_E_TIPSSOUND: "แสดงเคล็ดลับ",
  T_46_META_WS_E_TOGGLEWIDGET: "สลับวิดเจ็ต",
  T_46_META_WS_E_TOILETBOWL: "ห้องน้ำ",
  T_46_META_WS_E_TONEA: "โทน A",
  T_46_META_WS_E_TOP: "หน้าอก",
  T_46_META_WS_E_TOPDOWN: "จากบนลงล่าง",
  T_46_META_WS_E_TORII: "โทริอิ",
  T_46_META_WS_E_TOUCHPADWIDGET: "วิดเจ็ตทัชแพด",
  T_46_META_WS_E_TOWER: "ป้อม",
  T_46_META_WS_E_TPIPE: "ท่อ T",
  T_46_META_WS_E_TRACINGSTEPS: "ทักษะ 3",
  T_46_META_WS_E_TRAILER: "ตัวอย่าง",
  T_46_META_WS_E_TRANSFORMATION: "เปลี่ยนลุค",
  T_46_META_WS_E_TRANSPARENT: "โปร่งใส",
  T_46_META_WS_E_TRAPEZOID: "สี่เหลี่ยมคางหมู",
  T_46_META_WS_E_TRASHCAN: "ถังขยะ",
  T_46_META_WS_E_TRIANGLE: "สามเหลี่ยม",
  T_46_META_WS_E_TRIGGERS: "ทริกเกอร์",
  T_46_META_WS_E_TRIPLE: "สาม",
  T_46_META_WS_E_TROPHY: "ถ้วยรางวัล",
  T_46_META_WS_E_TRUE: "ใช่",
  T_46_META_WS_E_TUKTUK: "ตุ๊กตุ๊ก",
  T_46_META_WS_E_TUTUCAR: "ตุ๊กตุ๊ก",
  T_46_META_WS_E_TYRANTZOMBIE: "ซอมบี้ผเด็จการ",
  T_46_META_WS_E_UAVLITE: "UAVLite",
  T_46_META_WS_E_UIFINISH: "จบ",
  T_46_META_WS_E_UITAP: "UI แตะ",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "เครื่องกำเนิดยูนิต",
  T_46_META_WS_E_UPWARDTURBULENCE: "สายลมที่พัดขึ้น",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP 2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "ปืนข้าม/กระโดดข้าม",
  T_46_META_WS_E_VECTOR: "เวกเตอร์",
  T_46_META_WS_E_VEHICLE: "ยานพาหนะ",
  T_46_META_WS_E_VEHICLEEXPLODE: "การระเบิดของยานพาหนะ",
  T_46_META_WS_E_VELOCITY: "ความเร็ว",
  T_46_META_WS_E_VENDINGMACHINE: "ตู้หยอดเหรียญ",
  T_46_META_WS_E_VERTICAL: "แนวตั้ง",
  T_46_META_WS_E_VEST: "เสื้อกั๊ก",
  T_46_META_WS_E_VEST1: "เสื้อกั๊ก 1",
  T_46_META_WS_E_VEST2: "เสื้อกั๊ก 2",
  T_46_META_WS_E_VEST3: "เสื้อกั๊ก 3",
  T_46_META_WS_E_VEST4: "เสื้อกั๊ก 4",
  T_46_META_WS_E_VISUALEFFECTS: "วิชวลเอฟเฟ็กต์",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "กำแพง A",
  T_46_META_WS_E_WALLBRAWL: "ทักษะ 2",
  T_46_META_WS_E_WARNING: "คำเตือน",
  T_46_META_WS_E_WATERRING: "น้ำกระเด็น",
  T_46_META_WS_E_WAVE1: "คลื่น 1",
  T_46_META_WS_E_WAVE2: "คลื่น 2",
  T_46_META_WS_E_WAVE3: "คลื่น 3",
  T_46_META_WS_E_WEAPONGENERATOR: "อาวุธ",
  T_46_META_WS_E_WEAPONSLOT: "สล็อตอาวุธ",
  T_46_META_WS_E_WHISTLE: "เอาชนะศัตรู",
  T_46_META_WS_E_WIDERANGE: "ช่วงกว้าง",
  T_46_META_WS_E_WIN: "ชัยชนะ",
  T_46_META_WS_E_WINDATTACK: "การโจมตีด้วยลม",
  T_46_META_WS_E_WOODA: "ไม้ A",
  T_46_META_WS_E_WOODCUTZOMBIE: "ซอมบี้ตัดไม้",
  T_46_META_WS_E_WOODENPLANK: "สะพานไม้กระดาน",
  T_46_META_WS_E_WORLDPOSITION: "พิกัดโลก",
  T_46_META_WS_E_WRECKEDBUS: "รถบัสที่พัง",
  T_46_META_WS_E_WRECKEDCAR: "รถที่พัง",
  T_46_META_WS_E_WRONG: "ผิด",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "ซอมบี้",
  T_46_META_WS_E_ZOMBIES: "ซอมบี้",
  T_46_META_WS_E_ZOOM: "ซูม",
  T_46_META_WS_ELIMINATE: "กำจัด",
  T_46_META_WS_ELIMINATEDENTITY: "เอนทิตีที่ถูกกำจัด",
  T_46_META_WS_ELIMINATEDPLAYER: "ผู้เล่นที่ถูกกำจัด",
  T_46_META_WS_ENABLEDEFAULTBTREE: "เปิดใช้งานแผนผังพฤติกรรมเริ่มต้น",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "เปิดใช้งานการย้ายโซนปลอดภัย",
  T_46_META_WS_ENABLESAFEZONE: "เปิดใช้งานโซนปลอดภัย",
  T_46_META_WS_ENDCURRENTPHASE: "สิ้นสุดช่วงปัจจุบัน",
  T_46_META_WS_ENDMORPH: "สิ้นสุด Morph",
  T_46_META_WS_ENDPOSITION: "ตำแหน่งสิ้นสุด",
  T_46_META_WS_ENTERVEHICLE: "เข้ารถ",
  T_46_META_WS_ENTITY: "เอนทิตี",
  T_46_META_WS_EQUIPMENTID: "รหัสอุปกรณ์",
  T_46_META_WS_EULERANGLETOQUATERNION: "มุมออยเลอร์เป็นควอเทอร์เนียน",
  T_46_META_WS_EXITVEHICLE: "ออกจากรถ",
  T_46_META_WS_EXPONENTIATION: "การยกกำลัง",
  T_46_META_WS_FILTERENTITY: "เอนทิตีตัวกรอง",
  T_46_META_WS_FILTERLEVELOBJECTS: "ตัวกรองวัตถุในด่าน",
  T_46_META_WS_FIND: "หา",
  T_46_META_WS_FINDAT: "ค้นหาที่",
  T_46_META_WS_FINDPATH: "ค้นหาเส้นทาง",
  T_46_META_WS_FLOOR: "พื้น",
  T_46_META_WS_FOOTBALLGOAL: "เป้าหมายฟุตบอล",
  T_46_META_WS_FORMAT: "รูปแบบ",
  T_46_META_WS_GETALLKEYS: "รับคีย์ทั้งหมด",
  T_46_META_WS_GETALLPLAYERS: "รับผู้เล่นทั้งหมด",
  T_46_META_WS_GETALLSHOPS: "รับทุกร้านค้า",
  T_46_META_WS_GETALLTEAMS: "รับทุกทีม",
  T_46_META_WS_GETATTACKABLEENTITY: "รับเอนทิตีที่สามารถโจมตีได้",
  T_46_META_WS_GETATTACKABLEFACTIONS: "รับฝ่ายที่สามารถโจมตีได้",
  T_46_META_WS_GETBACKPACKSKIN: "รับสกินกระเป๋าเป๋",
  T_46_META_WS_GETBLACKBOARDVALUE: "รับมูลค่ากระดานดำ",
  T_46_META_WS_GETBUFFS: "รับตัวเสริมพลัง",
  T_46_META_WS_GETCHATCHANNEL: "รับช่องพูดคุย",
  T_46_META_WS_GETCHILDBYINDEX: "รับลูกตามอินเด็กซ์",
  T_46_META_WS_GETCHILDBYNAME: "รับลูกตามชื่อ",
  T_46_META_WS_GETCHILDREN: "รับลูก",
  T_46_META_WS_GETCOLORCHANNEL: "รับช่องสี",
  T_46_META_WS_GETCONSUMABLES: "รับไอเทมบริโภค",
  T_46_META_WS_GETCULLINGMASK: "รับคัลลิงมาสก์",
  T_46_META_WS_GETCURRENTCAMERA: "รับกล้องปัจจุบัน",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "รับช่องพูดคุยปัจจุบัน",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "รับความก้าวหน้าของภารกิจแบบกำหนดเอง",
  T_46_META_WS_GETDYEDCOUNT: "รับจำนวนการย้อม",
  T_46_META_WS_GETDYEDSTATUS: "รับสถานะย้อม",
  T_46_META_WS_GETEQUIPMENTS: "รับอุปกรณ์",
  T_46_META_WS_GETFACTION: "รับฝ่าย",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "รับเกณฑ์การนอนหลับทั่วโลก",
  T_46_META_WS_GETITEMCOUNT: "รับจำนวนรายการ",
  T_46_META_WS_GETLOADEDSCENES: "รับฉากที่โหลด",
  T_46_META_WS_GETLOCALAIMDIRECTION: "รับทิศทางการเล็งในพื้นที่",
  T_46_META_WS_GETLOCALPLAYER: "รับผู้เล่นท้องถิ่น",
  T_46_META_WS_GETLOCALTIMESTAMP: "รับการประทับเวลาท้องถิ่น",
  T_46_META_WS_GETMAPID: "รับรหัสแผนที่",
  T_46_META_WS_GETMINIMAP: "รับแผนที่ขนาดย่อ",
  T_46_META_WS_GETMONEY: "รับเงิน",
  T_46_META_WS_GETMONEYCOUNT: "รับเงินนับ",
  T_46_META_WS_GETMORPH: "รับมอร์ฟ",
  T_46_META_WS_GETNODEVARIABLE: "รับตัวแปรโหนด",
  T_46_META_WS_GETOUTFIT: "รับชุด",
  T_46_META_WS_GETOWNER: "รับเจ้าของ",
  T_46_META_WS_GETPARENT: "รับผู้ปกครอง",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "รับตำแหน่งใกล้เพื่อนร่วมทีม",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "รับตำแหน่งเกิดแบบสุ่ม",
  T_46_META_WS_GETRESULTFROMCURVE: "รับผลลัพธ์จาก Curve",
  T_46_META_WS_GETSCENESKYBOX: "รับฉากกล่องท้องฟ้า",
  T_46_META_WS_GETSERVERREGION: "รับภูมิภาคเซิร์ฟเวอร์",
  T_46_META_WS_GETSERVERTIMESTAMP: "รับการประทับเวลาของเซิร์ฟเวอร์",
  T_46_META_WS_GETSKELETONPARTBYNAME: "รับชิ้นส่วนโครงกระดูกตามชื่อ",
  T_46_META_WS_GETSKILLS: "รับทักษะ",
  T_46_META_WS_GETSLEEPTHRESHOLD: "รับเกณฑ์การนอนหลับ",
  T_46_META_WS_GETTOKENCOUNT: "รับจำนวนโทเค็น",
  T_46_META_WS_GETTOKENCOUNTTODAY: "รับจำนวนโทเค็นวันนี้",
  T_46_META_WS_GETTYPE: "รับประเภท",
  T_46_META_WS_GETVEHICLESKIN: "รับสกินยานพาหนะ",
  T_46_META_WS_GETWALLET: "รับกระเป๋าเงิน",
  T_46_META_WS_GETWEAPONSKIN: "รับสกินอาวุธ",
  T_46_META_WS_GETWIDGETBYPATH: "รับวิดเจ็ตตามเส้นทาง",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "รับวิดเจ็ตจาก UI ที่กำหนดเอง",
  T_46_META_WS_GIVEJAILBREAKITEM: "มอบไอเทม Jail Break",
  T_46_META_WS_GIVEJAILBREAKREWARD: "มอบรางวัล Jail Break",
  T_46_META_WS_HASAOISPECIALFOLLOW: "มีการติดตามพิเศษของ AOI",
  T_46_META_WS_HASCOMPONENT: "มีส่วนประกอบ",
  T_46_META_WS_HASSCRIPT: "มีสคริปต์",
  T_46_META_WS_HASTAG: "มีแท็ก",
  T_46_META_WS_HELPEDPLAYER: "ช่วยเหลือผู้เล่น",
  T_46_META_WS_HELPPLAYER: "ช่วยเหลือผู้เล่น",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "ซ่อนกลุ่มของรูปลักษณ์",
  T_46_META_WS_HITENTITY: "ตีโดนเอนทิตี",
  T_46_META_WS_HITFLY: "ตีโดนบิน",
  T_46_META_WS_HITNORMAL: "ตีโดนปกติ",
  T_46_META_WS_HITOBJECT: "ตีโดนวัตถุ",
  T_46_META_WS_HITPOSITION: "ตำแหน่งที่ตีโดน",
  T_46_META_WS_INDEXOF: "อินเด็กซ์ของ",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "การติดเชื้อซอมบี้เติบโตขึ้น",
  T_46_META_WS_INSERT: "แทรก",
  T_46_META_WS_ISATTACKABLE: "สามารถโจมตีได้",
  T_46_META_WS_ISCHATCHANNELEMPTY: "ช่องแชทว่างหรือไม่",
  T_46_META_WS_ISEQUAL: "เท่ากันหรือไม่",
  T_46_META_WS_ISFRIEND: "เป็นเพื่อนหรือไม่",
  T_46_META_WS_ISHIT: "เป็นฮิตหรือไม่",
  T_46_META_WS_ISINSIDEBOX: "อยู่ในกล่องหรือไม่",
  T_46_META_WS_ISINSIDECYLINDER: "อยู่ภายในทรงกระบอกหรือไม่",
  T_46_META_WS_ISINSIDESECTOR: "อยู่ภายในภาค",
  T_46_META_WS_ISINSIDESPHERE: "อยู่ภายในทรงกลม",
  T_46_META_WS_ISSLEEPING: "กำลังนอนหลับ",
  T_46_META_WS_ISSUBTYPEOF: "เป็นประเภทย่อยของ",
  T_46_META_WS_ITEM: "ไอเทม",
  T_46_META_WS_ITEMID: "รหัสไอเทม",
  T_46_META_WS_JOIN: "เข้าร่วม",
  T_46_META_WS_JOINCHATCHANNEL: "เข้าร่วมช่องแชท",
  T_46_META_WS_JOINFACTION: "เข้าร่วมฝ่าย",
  T_46_META_WS_LASTINDEXOF: "อินเด็กซ์ล่าสุดของ",
  T_46_META_WS_LENGTH: "ความยาว",
  T_46_META_WS_LERP: "Lerp",
  T_46_META_WS_LOADSCENE: "โหลดฉาก",
  T_46_META_WS_LOGARITHM: "ลอการิทึม",
  T_46_META_WS_LOGERROR: "บันทึกข้อผิดพลาด",
  T_46_META_WS_LOGINFO: "ข้อมูลเข้าสู่ระบบ",
  T_46_META_WS_LOGWARNING: "บันทึกคำเตือน",
  T_46_META_WS_LOOKROTATION: "ดูการหมุน",
  T_46_META_WS_MAGNITUDE: "ขนาด (Magnitude)",
  T_46_META_WS_MAKER: "ผู้สร้าง",
  T_46_META_WS_MAX: "สูงสุด",
  T_46_META_WS_MECHANISM: "กลไก",
  T_46_META_WS_MIN: "น้อยสุด",
  T_46_META_WS_MONSTERUSESKILL: "ใช้ทักษะ",
  T_46_META_WS_MORPHOBJECT: "แปลงวัตถุ",
  T_46_META_WS_MORPHTO: "แปลงเป็น",
  T_46_META_WS_MORPHTOBYITEMID: "แปลงเป็นตามรหัสรายการ",
  T_46_META_WS_MOVECCT: "ย้าย CCT",
  T_46_META_WS_MOVEPOSITION: "ย้ายตำแหน่ง",
  T_46_META_WS_MOVEROTATION: "ย้ายการหมุน",
  T_46_META_WS_MULTIPLYQUATERNION: "คูณควอเทอร์เนียน",
  T_46_META_WS_MULTIRAYCAST: "มัลติเรย์แคสต์",
  T_46_META_WS_NEGATE: "ปฏิเสธ",
  T_46_META_WS_NEW: "ใหม่",
  T_46_META_WS_NODENAME: "ชื่อโหนด",
  T_46_META_WS_NORMALIZE: "ทำให้เป็นมาตรฐาน",
  T_46_META_WS_NOTIFYPLAYEFFECT: "แจ้งผลการเล่น",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "แจ้งเตือนการเล่นไอคอนแอนิเมชั่น",
  T_46_META_WS_NOTIFYPLAYSOUND: "แจ้งเตือนการเล่นเสียง",
  T_46_META_WS_NOTIFYSHOWTIPS: "แจ้งการแสดงเคล็ดลับ",
  T_46_META_WS_NUMTOSTRING: "หมายเลขเป็นสตริง",
  T_46_META_WS_ONACCESSEQUIPMENT: "เมื่อการเข้าถึงอุปกรณ์",
  T_46_META_WS_ONACCESSITEM: "เมื่อการเข้าถึงรายการ",
  T_46_META_WS_ONACCESSWEAPON: "เมื่อการเข้าถึงอาวุธ",
  T_46_META_WS_ONACE: "เมื่อ ACE",
  T_46_META_WS_ONAIMED: "เมื่อเล็งแล้ว",
  T_46_META_WS_ONAIMING: "เมื่อกำลังเล็ง",
  T_46_META_WS_ONASSIST: "เมื่อช่วยเหลือ",
  T_46_META_WS_ONATTACK: "เมื่อถูกโจมตี",
  T_46_META_WS_ONATTACKSTOP: "เมื่อการโจมตีหยุด",
  T_46_META_WS_ONAWAKE: "เมื่อตื่นขึ้น",
  T_46_META_WS_ONBEKNOCKEDDOWN: "เมื่อถูกล้มลง",
  T_46_META_WS_ONBOUNCEDBYTIRE: "เมื่อเด้งโดยยาง",
  T_46_META_WS_ONBOUNCEENTITY: "เมื่อเด้งเอนทิตี้",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "เมื่อแตะปุ่มบิ้วอิน UI",
  T_46_META_WS_ONBULLETHIT: "เมื่อกระสุนโดน",
  T_46_META_WS_ONCAMERARAYCAST: "เมื่อเรย์แคสต์จากกล้อง",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "เมื่อตัวละครที่ควบคุมตี",
  T_46_META_WS_ONCHASE: "เมื่อไล่ล่า",
  T_46_META_WS_ONCHASESTOP: "เมื่อการไล่ล่าหยุด",
  T_46_META_WS_ONCLIPEND: "เมื่อคลิปจบ",
  T_46_META_WS_ONCOLLISIONENTER: "เมื่อเข้าสู่การชน",
  T_46_META_WS_ONCOLLISIONEXIT: "เมื่อออกจากการชน",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "เมื่อนับถอยหลังเสร็จสิ้น",
  T_46_META_WS_ONCREEP: "เมื่อผู้เล่นนอนราบ",
  T_46_META_WS_ONCROUCH: "เมื่อผู้เล่นนั่งยองๆ",
  T_46_META_WS_ONDEALDAMAGE: "เมื่อสร้างความเสียหาย",
  T_46_META_WS_ONDESTROY: "เมื่อตัวตนถูกทำลาย",
  T_46_META_WS_ONDISABLE: "เมื่อปิดใช้งาน",
  T_46_META_WS_ONDISCONNECT: "เมื่อตัดการเชื่อมต่อ",
  T_46_META_WS_ONDOUBLETAPPED: "เมื่อแตะสองครั้ง",
  T_46_META_WS_ONDRAG: "เมื่อลาก",
  T_46_META_WS_ONDRAGEND: "เมื่อลากสิ้นสุด",
  T_46_META_WS_ONDRAGSTART: "เมื่อลากเริ่มต้น",
  T_46_META_WS_ONDRIVED: "เมื่อขับเคลื่อน",
  T_46_META_WS_ONDRIVEVEHICLE: "บนยานพาหนะขับเคลื่อน",
  T_46_META_WS_ONDROPCONSUMABLE: "เมื่อทิ้งของใช้บริโภค",
  T_46_META_WS_ONDROPPED: "เมื่อถูกทิ้ง",
  T_46_META_WS_ONDROPWEAPON: "เมื่อวางอาวุธ",
  T_46_META_WS_ONEACHLOOP: "ในแต่ละลูป",
  T_46_META_WS_ONELIMINATE: "เมื่อกำจัด",
  T_46_META_WS_ONELIMINATED: "เมื่อถูกคัดออก",
  T_46_META_WS_ONENABLE: "เปิดการใช้งาน",
  T_46_META_WS_ONEND: "เมื่อสิ้นสุด",
  T_46_META_WS_ONENTERED: "เมื่อเข้าแล้ว",
  T_46_META_WS_ONENTERVEHICLE: "เมื่อเข้าสู่ยานพาหนะ",
  T_46_META_WS_ONENTITYENTER: "เมื่อเข้าทริกเกอร์",
  T_46_META_WS_ONENTITYEXIT: "เมื่อออกทริกเกอร์",
  T_46_META_WS_ONEQUIPARMOR: "เมื่อใช้ชุดเกราะ",
  T_46_META_WS_ONEQUIPED: "เมื่อติดตั้งแล้ว",
  T_46_META_WS_ONEQUIPWEAPON: "เมื่อสวมใส่อาวุธ",
  T_46_META_WS_ONEXPLODE: "เมื่อระเบิด",
  T_46_META_WS_ONFALL: "เมื่อล่วง",
  T_46_META_WS_ONFALLSTOP: "เมื่อหยุดล่วง",
  T_46_META_WS_ONFIRE: "เมื่อติดไฟ",
  T_46_META_WS_ONFIXEDUPDATE: "On Fixed Update",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "เมื่อฟุตบอลชน",
  T_46_META_WS_ONFRIENDSUPDATE: "อัปเดตสถานะมิตรภาพ",
  T_46_META_WS_ONGAMEEND: "เมื่อจบเกม",
  T_46_META_WS_ONGAMEPAUSE: "เมื่อเกมหยุดชั่วคราว",
  T_46_META_WS_ONGAMERESUME: "เมื่อเกมกลับมาเล่นอีกครั้ง",
  T_46_META_WS_ONGAMESTART: "เมื่อเริ่มเกม",
  T_46_META_WS_ONGOAL: "เมื่อทำประตูได้",
  T_46_META_WS_ONHITBYBULLET: "เมื่อโดนกระสุน",
  T_46_META_WS_ONHITFLY: "เมื่อตีบิน",
  T_46_META_WS_ONHITFLYENTITY: "เมื่อโดนเอนทิตี้บิน",
  T_46_META_WS_ONHOOKGUNFIRE: "เมื่อยิงปืนฮุก",
  T_46_META_WS_ONIDLE: "เมื่ออยู่ยิ่งๆ",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "Jail Break Area Begin",
  T_46_META_WS_ONJAILBREAKAREAEND: "Jail Break Area End",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "Jail Break Player Join",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "Jail Break Player Quit",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "เมื่อเข้าร่วมช่องแชทสำเร็จ",
  T_46_META_WS_ONJOYSTICKMOVE: "เมื่อจอยสติ๊กขยับ",
  T_46_META_WS_ONJOYSTICKPRESSED: "เมื่อกดแล้ว",
  T_46_META_WS_ONJOYSTICKRELEASED: "เมื่อปล่อยแล้ว",
  T_46_META_WS_ONJUMP: "เมื่อกระโดด",
  T_46_META_WS_ONJUMPSTOP: "เมื่อหยุดกระโดด",
  T_46_META_WS_ONLANDMINEACTIVE: "เมื่อทุ่นระเบิดทำงาน",
  T_46_META_WS_ONLANDMINETRIGGER: "เมื่อทริกเกอร์ทุ่นระเบิด",
  T_46_META_WS_ONLEAVECHATCHANNEL: "เมื่อออกจากช่องพูดคุย",
  T_46_META_WS_ONLEAVEVEHICLE: "เมื่อออกจากยานพาหนะ",
  T_46_META_WS_ONLEFT: "เมื่อรถยนต์ถูกผู้เล่นออก",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "เมื่อวัตถุในแผนที่ถูกผู้เล่นมอฟ",
  T_46_META_WS_ONMOVE: "เมื่อเคลื่อนที่",
  T_46_META_WS_ONNODEENTER: "เมื่อเข้าโหนด",
  T_46_META_WS_ONNODEEXIT: "เมื่อออกโหนด",
  T_46_META_WS_ONPAUSE: "เมื่อหยุดชั่วคราว",
  T_46_META_WS_ONPHASEEND: "เมื่อสิ้นสุดช่วง",
  T_46_META_WS_ONPHASESTART: "เมื่อเฟสเริ่มต้น",
  T_46_META_WS_ONPICKEDUP: "เมื่อหยิบขึ้นมา",
  T_46_META_WS_ONPLAYERASSIST: "เมื่อผู้เล่นได้ช่วยเหลือ",
  T_46_META_WS_ONPLAYERBEELIMINATED: "เมื่อผู้เล่นถูกกำจัด",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "เมื่อผู้เล่นถูกล้มลง",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "เมื่อผู้เล่นทำความเสียหาย",
  T_46_META_WS_ONPLAYERELIMINATE: "เมื่อผู้เล่นกำจัด",
  T_46_META_WS_ONPLAYERENTER: "เมื่อผู้เล่นเข้า",
  T_46_META_WS_ONPLAYERJOIN: "เมื่อผู้เล่นเข้าร่วม",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "เมื่อเข้าร่วมช่องแชทล้มเหลว",
  T_46_META_WS_ONPLAYERLEAVE: "เมื่อผู้เล่นออกจาก",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "เมื่อผู้เล่นขอซื้อ",
  T_46_META_WS_ONPLAYERQUIT: "เมื่อผู้เล่นออกกลางคัน",
  T_46_META_WS_ONPLAYERRANKCHANGE: "เมื่ออันดับของผู้เล่นเปลี่ยน",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "เมื่อคำร้องขอการซื้อของผู้เล่นสำเร็จแล้ว",
  T_46_META_WS_ONPLAYERREVIVED: "เมื่อผู้เล่นฟื้นขึ้นมา",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "เมื่อผู้เล่นฟื้นขึ้นมาในจุดเกิด",
  T_46_META_WS_ONPLAYERSCORECHANGE: "เมื่อคะแนนของผู้เล่นมีการเปลี่ยนแปลง",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "เมื่อผู้เล่นเปลี่ยนฉาก",
  T_46_META_WS_ONPREDEALDAMAGE: "เมื่อทำความเสียหายล่วงหน้า",
  T_46_META_WS_ONPREPURCHASE: "เมื่อซื้อล่วงหน้า",
  T_46_META_WS_ONPRESSED: "เมื่อกดแล้ว",
  T_46_META_WS_ONPRETAKEDAMAGE: "เมื่อรับความเสียหายล่วงหน้า",
  T_46_META_WS_ONPURCHASE: "เมื่อซื้อ",
  T_46_META_WS_ONRANKCHANGED: "เมื่ออันดับของเอนทิตีเปลี่ยนแปลง",
  T_46_META_WS_ONRECONNECT: "เมื่อเชื่อมต่อใหม่",
  T_46_META_WS_ONRELEASED: "เมื่อปล่อย",
  T_46_META_WS_ONRELOAD: "เมื่อเปลี่ยนกระสุน",
  T_46_META_WS_ONRESUME: "เมื่อเล่นต่อ",
  T_46_META_WS_ONREVIVED: "เมื่อฟื้นคืนชีพ",
  T_46_META_WS_ONROUNDEND: "เมื่อสิ้นสุดรอบ",
  T_46_META_WS_ONROUNDSTART: "เมื่อเริ่มรอบ",
  T_46_META_WS_ONSCENELOAD: "เมื่อโหลดฉาก",
  T_46_META_WS_ONSCENESWITCH: "เมื่อเปลี่ยนฉาก",
  T_46_META_WS_ONSCORECHANGE: "เมื่อคะแนนเอนทิตีเปลี่ยนแปลง",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "เมื่อถูกยิงด้วยปืนฟุตบอล",
  T_46_META_WS_ONSLEEP: "เมื่อนอนหลับ",
  T_46_META_WS_ONSPAWN: "เมื่อเกิด",
  T_46_META_WS_ONSPRAY: "เมื่อสเปรย์",
  T_46_META_WS_ONSPRAYED: "เมื่อสเปรย์แล้ว",
  T_46_META_WS_ONSPRINT: "เมื่อวิ่ง",
  T_46_META_WS_ONSPRINTSTOP: "เมื่อหยุดวิ่ง",
  T_46_META_WS_ONSTANDUP: "เมื่อยืนขึ้น",
  T_46_META_WS_ONSTART: "เมื่อเริ่มต้น",
  T_46_META_WS_ONSTARTFIRE: "เมื่อโจมตี",
  T_46_META_WS_ONSTATEEND: "เมื่อสถานะจบ",
  T_46_META_WS_ONSURFING: "เมื่อเซิร์ฟอยู่",
  T_46_META_WS_ONSURFINGSTOP: "เมื่อหยุดเซิร์ฟ",
  T_46_META_WS_ONSWITCHHANDHELD: "เมื่อเปลี่ยนอุปกรณ์มือถือ",
  T_46_META_WS_ONTAKEDAMAGE: "เมื่อได้รับความเสียหาย",
  T_46_META_WS_ONTAPPED: "เมื่อแตะ",
  T_46_META_WS_ONTEAMACE: "เมื่อทีมได้ACE",
  T_46_META_WS_ONTEAMADD: "เมื่อเพิ่มทีม",
  T_46_META_WS_ONTEAMREMOVE: "เมื่อยกเลิกทีม",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "เมื่ออันดับรอบของทีมเปลี่ยนแปลง",
  T_46_META_WS_ONTEAMSCORECHANGE: "เมื่อคะแนนทีมเปลี่ยนแปลง",
  T_46_META_WS_ONTELEPORTENTITY: "เมื่อเอนทิตีถูกเทเลพอร์ต",
  T_46_META_WS_ONTEXTCHANGE: "เมื่อข้อความเปลี่ยนแปลง",
  T_46_META_WS_ONTHROWABLEEXPLODE: "เมื่อของปาระเบิด",
  T_46_META_WS_ONTOGGLE: "เมื่อเปิด/ปิด",
  T_46_META_WS_ONTOUCHDOWN: "เมื่อแตะลง",
  T_46_META_WS_ONTOUCHUP: "เมื่อแตะอัป",
  T_46_META_WS_ONUIHIDE: "เมื่อซ่อน UI",
  T_46_META_WS_ONUISHOW: "เมื่อแสดง UI",
  T_46_META_WS_ONUPDATE: "เมื่ออัปเดต",
  T_46_META_WS_ONUSEAVATARSKILL: "เมื่อใช้ทักษะอวาตาร์",
  T_46_META_WS_ONUSECONSUMABLE: "เมื่อใช้ของบริโภค",
  T_46_META_WS_ONUSED: "เมื่อใช้แล้ว",
  T_46_META_WS_ONUSEPORTAL: "เมื่อใช้งานพอร์ทัล",
  T_46_META_WS_ONWAKEUP: "เมื่อตื่นขึ้นมา",
  T_46_META_WS_ONWEAPONBEEQUIPED: "เมื่อติดอาวุธแล้ว",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "เมื่อสร้างความเสียหายให้กับอาวุธ",
  T_46_META_WS_ONWEAPONELIMINATE: "เมื่อกำจัดอาวุธ",
  T_46_META_WS_ONWEAPONSTOPFIRING: "เมื่ออาวุธหยุดยิง",
  T_46_META_WS_OWNER: "เจ้าของ",
  T_46_META_WS_P_ACCELERATE: "เร่งความเร็ว",
  T_46_META_WS_P_ACCELERATION: "การเร่งความเร็ว",
  T_46_META_WS_P_ACCOUNTID: "รหัสบัญชี",
  T_46_META_WS_P_ACCURACY: "ความแม่นยำ",
  T_46_META_WS_P_ACTIONTYPE: "ประเภทการดำเนินการ",
  T_46_META_WS_P_ACTIVATEDALPHA: "เปิดใช้งานความโปร่งใส",
  T_46_META_WS_P_ACTIVE: "สถานะใช้งานอยู่",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Active In Hierarchy",
  T_46_META_WS_P_ACTIVESELF: "เปิดใช้งานตนเอง",
  T_46_META_WS_P_ACTIVETEXT: "เปิดใช้งานเนื้อหาข้อความ",
  T_46_META_WS_P_ACTUALPOSITION: "ตำแหน่งที่แท้จริง",
  T_46_META_WS_P_AFTERACCUMULATOR: "หลังจากสะสม",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "ออฟเซตศูนย์ช่วยเหลือการเล็ง",
  T_46_META_WS_P_AIMASSISTDISTANCE: "ระยะช่วยเหลือการเล็ง",
  T_46_META_WS_P_AIMASSISTTYPE: "ตัวช่วยเหลือการเล็ง",
  T_46_META_WS_P_AIRDROPSTATE: "สถานะแอร์ดรอป",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "การจัดแนวแนวนอน",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "การจัดแนวแนวตั้ง",
  T_46_META_WS_P_ALLITEMS: "รายการทั้งหมด",
  T_46_META_WS_P_ALLMEMBERS: "สมาชิกทั้งหมด",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "อนุญาตให้ล็อคโดย Aim Assist",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "อนุญาตให้กดด้านนอก",
  T_46_META_WS_P_ALLPLAYERS: "ผู้เล่นทุกคน",
  T_46_META_WS_P_ALLTEAMMATES: "เพื่อนร่วมทีมทุกคน",
  T_46_META_WS_P_ALPHA: "ค่าความโปร่งใส",
  T_46_META_WS_P_ALWAYSSHOWMARK: "แสดงมาร์คเสมอ",
  T_46_META_WS_P_AMBIENTCOLOR: "สีบรรยากาศ",
  T_46_META_WS_P_AMMOCLIPSIZE: "ขนาดคลิปกระสุน",
  T_46_META_WS_P_AMMOMAGSIZE: "ขนาดแม็กกระสุน",
  T_46_META_WS_P_AMMOPERSHOT: "กระสุนต่อนัด",
  T_46_META_WS_P_AMMOTYPE: "ประเภทกระสุน",
  T_46_META_WS_P_ANCHORMAX: "สมอสูงสุด",
  T_46_META_WS_P_ANCHORMIN: "สมอต่ำสุด",
  T_46_META_WS_P_ANCHOROBJECT: "วัตถุที่ถูกสมอ",
  T_46_META_WS_P_ANCHORPOSITION: "ตำแหน่งสมอ",
  T_46_META_WS_P_ANCHORTYPE: "ประเภทสมอ",
  T_46_META_WS_P_ANGLE: "มุม",
  T_46_META_WS_P_ANGLEDOWN: "มุมลง",
  T_46_META_WS_P_ANGLEUP: "มุมขึ้น",
  T_46_META_WS_P_ANGULARDRAG: "การลากเชิงมุม",
  T_46_META_WS_P_ANGULARSPEED: "ความเร็วเชิงมุม",
  T_46_META_WS_P_ANGULARVELOCITY: "ความเร็วเชิงมุม (รัศมี/วินาที)",
  T_46_META_WS_P_ANIMATIONCLIP: "ชื่อแอนิเมชัน",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "ตัวควบคุมแอนิเมชัน",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "รหัสทรัพยากรตัวควบคุมแอนิเมชัน",
  T_46_META_WS_P_ARMORPENETRATION: "การเจาะเกราะ",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "ปัจจัยการเจาะค่าสัมประสิทธิ์",
  T_46_META_WS_P_ARMORTYPE: "ประเภทเกราะ",
  T_46_META_WS_P_ARROWOFFSET: "ออฟเซตลูกศร",
  T_46_META_WS_P_ARROWSIZE: "ขนาดลูกศร",
  T_46_META_WS_P_ARROWSPRITE: "ภาพลูกศร",
  T_46_META_WS_P_ASKBUYTARGET: "ขอเป้าหมายการซื้อ",
  T_46_META_WS_P_ATTACHTARGET: "แนบเป้าหมาย",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "ฝ่ายที่สามารถโจมตีได้",
  T_46_META_WS_P_ATTACKDAMAGE: "ความเสียหายจากการโจมตี",
  T_46_META_WS_P_ATTACKINTERVAL: "ช่วงเวลาการโจมตี",
  T_46_META_WS_P_ATTACKRANGE: "ระยะโจมตี",
  T_46_META_WS_P_ATTACKTARGET: "เป้าหมายโจมตี",
  T_46_META_WS_P_ATTTACKABLETARGETS: "เป้าหมายที่สามารถโจมตีได้",
  T_46_META_WS_P_AUTOPLAY: "สถานะการเล่นอัตโนมัติ",
  T_46_META_WS_P_AVAILABLEPOINT: "จุดที่มีจำหน่าย",
  T_46_META_WS_P_AVATAR: "อวตาร",
  T_46_META_WS_P_AVATARID: "รหัสอวตาร",
  T_46_META_WS_P_BACKGROUND: "พื้นหลัง",
  T_46_META_WS_P_BACKGROUNDALPHA: "ความโปร่งใสของพื้นหลัง",
  T_46_META_WS_P_BACKGROUNDCOLOR: "สีพื้นหลัง",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "สีพื้นหลัง 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "สีพื้นหลัง 2",
  T_46_META_WS_P_BACKGROUNDFILL: "การเติมพื้นหลัง",
  T_46_META_WS_P_BACKGROUNDICONNAME: "ชื่อไอคอนพื้นหลัง",
  T_46_META_WS_P_BACKGROUNDNAME: "ชื่อพื้นหลัง",
  T_46_META_WS_P_BACKGROUNDOFFSET: "ออฟเซตพื้นหลัง",
  T_46_META_WS_P_BACKGROUNDRADIUS: "รัศมีพื้นหลัง",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "เดลต้าขนาดพื้นหลัง",
  T_46_META_WS_P_BACKGROUNDSPRITE: "สไปรท์พื้นหลัง",
  T_46_META_WS_P_BACKPACK: "กระเป๋าเป้",
  T_46_META_WS_P_BACKPACKSKINID: "รหัสสกินกระเป๋าเป้สะพายหลัง",
  T_46_META_WS_P_BACKWARDSPEED: "ความเร็วถอยหลัง",
  T_46_META_WS_P_BANNERID: "รหัสป้ายแบนเนอร์",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "ความเร็วแนวนอนพื้นฐาน",
  T_46_META_WS_P_BASEMULTIPLIER: "ตัวคูณพื้นฐาน",
  T_46_META_WS_P_BASETIME: "เวลาพื้นฐาน",
  T_46_META_WS_P_BASEVERTICALSPEED: "ความเร็วฐานแนวตั้ง",
  T_46_META_WS_P_BEFOREACCUMULATOR: "ก่อนสะสม",
  T_46_META_WS_P_BEVTREEID: "รหัสแผนผังพฤติกรรม",
  T_46_META_WS_P_BINDPROPERTYID: "รหัสผูกคุณลักษณะ",
  T_46_META_WS_P_BODY: "ตัว",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "ตัวคูณความเสียหายของลำตัว",
  T_46_META_WS_P_BONEPOSITION: "ตำแหน่งกระดูก",
  T_46_META_WS_P_BONESCALE: "ขนาดกระดูก",
  T_46_META_WS_P_BOOSTCD: "คูลดาวน์การบูสต์",
  T_46_META_WS_P_BOOSTDURATION: "ระยะเวลาการบูสต์",
  T_46_META_WS_P_BOOSTSPEED: "ความเร็วการบูสต์",
  T_46_META_WS_P_BORDERLR: "ขอบซ้ายขวา",
  T_46_META_WS_P_BORDERTB: "ขอบบนล่าง",
  T_46_META_WS_P_BOTTOMALPHA: "ความโปร่งใสด้านล่าง",
  T_46_META_WS_P_BOUNDWALLET: "ผูกกระเป๋าเงิน",
  T_46_META_WS_P_BRAKEHORSEPOWER: "แรงม้าเบรก",
  T_46_META_WS_P_BRAKETORQUE: "แรงบิดของเบรก",
  T_46_META_WS_P_BRRANK: "อันดับ BR",
  T_46_META_WS_P_BUFFTYPE: "ประเภทบัฟ",
  T_46_META_WS_P_BURNDAMAGE: "ความเสียหายจากการเผาไหม้",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "ช่วงเวลาความเสียหายจากการเผาไหม้",
  T_46_META_WS_P_BURNTIME: "เวลาการเผาไหม้",
  T_46_META_WS_P_BUTTOM: "เสื้อผ้าส่วนล่าง",
  T_46_META_WS_P_BUTTONCOLORS: "อาร์เรย์สีของปุ่ม",
  T_46_META_WS_P_BUTTONNAMES: "อาร์เรย์ของชื่อปุ่ม",
  T_46_META_WS_P_BUTTONSTYLE: "สไตล์ปุ่ม",
  T_46_META_WS_P_CAMERABLOCKMODE: "โหมดบล็อคกล้อง",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "โหมดการฉายภาพด้วยกล้อง",
  T_46_META_WS_P_CAMERATYPE: "กล้อง",
  T_46_META_WS_P_CANCELDRAGIFFITS: "ไม่สามารถเลื่อนเนื้อหาได้หากไม่เกินวิวพอร์ต",
  T_46_META_WS_P_CANCOSTDURABILITY: "สามารถเสียค่าความทนทานได้ไหม",
  T_46_META_WS_P_CANDAMAGED: "สามารถทำความเสียหายได้ไหม",
  T_46_META_WS_P_CANDESTROY: "สามารถทำลายได้ไหม",
  T_46_META_WS_P_CANDESTROYED: "สามารถถูกทำลายได้ไหม",
  T_46_META_WS_P_CANSELFTRIGGER: "มันสามารถทริกเกอร์ตัวเองได้ไหม",
  T_46_META_WS_P_CANTEAMTRIGGER: "ทีมสามารถทริกเกอร์ได้ไหม",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "สามารถถูกทริกเกอร์โดยตัวเองได้ไหม",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "สามารถถูกทริกเกอร์โดยทีมได้ไหม",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "สามารถถูกทริกเกอร์โดยยานพาหนะได้ไหม",
  T_46_META_WS_P_CANVEHICLETRIGGER: "ไม่ว่ารถจะทริกเกอร์ได้หรือไม่",
  T_46_META_WS_P_CELLSIZE: "ขนาดของตาราง",
  T_46_META_WS_P_CELLSPACE: "พื้นที่ของตาราง",
  T_46_META_WS_P_CENTER: "ศูนย์กลาง",
  T_46_META_WS_P_CENTERINVISIBLE: "ศูนย์กลางล่องหน",
  T_46_META_WS_P_CENTEROFFSET: "ออฟเซตจุดศูนย์กลาง",
  T_46_META_WS_P_CENTEROFMASS: "จุดศูนย์ถ่วง",
  T_46_META_WS_P_CENTERRANGE: "ช่วงกลาง",
  T_46_META_WS_P_CENTRALFLASHTIME: "เวลาแฟลชกลาง",
  T_46_META_WS_P_CENTRALLINEACTIVE: "เปิดใช้เส้นกึ่งกลาง",
  T_46_META_WS_P_CENTRALLINEPOSITION: "ตำแหน่งเส้นกึ่งกลาง",
  T_46_META_WS_P_CHANNELID: "รหัสช่องพูดคุย",
  T_46_META_WS_P_CHARGEMAX: "ขีดจำกัดการชาร์จ",
  T_46_META_WS_P_CHASETARGET: "เป้าหมายการไล่ล่า",
  T_46_META_WS_P_CHATCHANNEL: "ช่องพูดคุย",
  T_46_META_WS_P_CHECKPOINTID: "รหัสเช็กพอยต์",
  T_46_META_WS_P_CHILDINDEX: "อินเด็กซ์ของลูก",
  T_46_META_WS_P_CHIPEXP: "ชิปประสบการณ์",
  T_46_META_WS_P_CLICKSIZE: "ขนาดของคลิก",
  T_46_META_WS_P_CLIPLENGTH: "ความยาวคลิป",
  T_46_META_WS_P_CLIPPINGTYPE: "Clipping Type",
  T_46_META_WS_P_COLLIDERID: "รหัสตัสตรวจจับการชน",
  T_46_META_WS_P_CONSTRAIN: "ข้อจำกัด",
  T_46_META_WS_P_CONSTRAINT: "ตัวข้อจำกัด",
  T_46_META_WS_P_CONSTRAINTCOUNT: "จำนวนจำกัด",
  T_46_META_WS_P_CONSUMABLETYPE: "ประเภทเสา",
  T_46_META_WS_P_CONTENT: "เนื้อหา",
  T_46_META_WS_P_CONTENTORIGIN: "ทิศทางเริ่มต้น",
  T_46_META_WS_P_CONTROLPOINTS: "จุดควบคุม",
  T_46_META_WS_P_COORDINATESYSTEM: "ระบบพิกัด",
  T_46_META_WS_P_COUNT: "จำนวน",
  T_46_META_WS_P_COUNTDOWNENDTIME: "เวลาสิ้นสุดการนับถอยหลัง",
  T_46_META_WS_P_COUNTDOWNKEY: "คีย์นับถอยหลัง",
  T_46_META_WS_P_COUNTDOWNTIME: "ความยาวนับถอยหลัง",
  T_46_META_WS_P_COUNTPERWAVE: "จำนวนต่อคลื่น",
  T_46_META_WS_P_CRASHMAXDAMAGE: "ความเสียหายจากแรงกระแทกสูงสุด",
  T_46_META_WS_P_CRASHMAXSPEED: "ขีดจำกัดความเร็วความเสียหายกระแทก",
  T_46_META_WS_P_CRASHMESSFACTOR: "พารามิเตอร์มวลกระแทก",
  T_46_META_WS_P_CRASHMINDAMAGE: "ความเสียหายจากแรงกระแทกขั้นต่ำ",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "อัตราส่วนสเกลความเร็วการคลาน",
  T_46_META_WS_P_CREATEDENTITY: "สร้างเอนทิตีแล้ว",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "อัตราส่วนสเกลความเร็วในการเดิน",
  T_46_META_WS_P_CSRANK: "อันดับ CS",
  "T_46_META_WS_P_CURRENT AMMO": "จำนวนกระสุนปัจจุบัน",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "สทรัพยากรแอนิเมชันที่กำลังเล่นอยู่",
  T_46_META_WS_P_CURRENTCLIP: "คลิปแอนิเมชันปัจจุบัน",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "ความคืบหน้าในการเล่นคลิปแอนิเมชันปัจจุบัน",
  T_46_META_WS_P_CURRENTDURABILITY: "ความทนทานปัจจุบัน",
  T_46_META_WS_P_CURRENTENERGY: "พลังงานปัจจุบัน",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "รายการที่ถืออยู่ในปัจจุบัน",
  T_46_META_WS_P_CURRENTHP: "พลังชีวิตปัจจุบัน",
  T_46_META_WS_P_CURRENTPHASEINDEX: "อินเด็กซ์ของช่วงปัจจุบัน",
  T_46_META_WS_P_CURRENTPROGRESS: "ความคืบหน้าในปัจจุบัน",
  T_46_META_WS_P_CURRENTROUNDINDEX: "อินเด็กซ์รอบปัจจุบัน",
  T_46_META_WS_P_CURRENTSTATE: "สถานะภาพการเคลื่อนไหวปัจจุบัน",
  T_46_META_WS_P_CURRENTVALUE: "มูลค่าปัจจุบัน",
  T_46_META_WS_P_CURRENTWAVE: "คลื่นปัจจุบัน",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "ประเภทผู้เล่นเริ่มต้น",
  T_46_META_WS_P_CUSTOMGAMERESULT: "ผลการแข่งขันเกมแบบกำหนดเอง",
  T_46_META_WS_P_CUSTOMGRAVITY: "แรงโน้มถ่วงแบบกำหนดเอง",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "แรงขับแบบกำหนดเอง",
  T_46_META_WS_P_CUSTOMXY: "XY แบบกำหนดเอง",
  T_46_META_WS_P_DAMAGE: "ความเสียหาย",
  "T_46_META_WS_P_DAMAGE RANGE": "ระยะ",
  T_46_META_WS_P_DAMAGEFACTOR: "ค่าสัมประสิทธิ์ความเสียหาย",
  T_46_META_WS_P_DAMAGEINTERVAL: "ช่วงเวลาความเสียหาย (วินาที)",
  T_46_META_WS_P_DAMAGERADIUS: "รัศมีความเสียหาย",
  T_46_META_WS_P_DAMAGERATIOHEAD: "ค่าสัมประสิทธิ์ความเสียหายที่ศีรษะ",
  T_46_META_WS_P_DAMAGERATIOLIMB: "ค่าสัมประสิทธิ์ความเสียหายของแขนขา",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "ค่าสัมประสิทธิ์การลดความเสียหาย",
  T_46_META_WS_P_DAMAGETAKENPCT: "เปอร์เซ็นต์ความเสียหายที่ได้รับ",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "เปอร์เซ็นต์ความเสียหายที่ได้รับ",
  T_46_META_WS_P_DAMAGEVALUE: "ค่าความเสียหาย",
  T_46_META_WS_P_DARKNESS: "ความมืด",
  T_46_META_WS_P_DECELERATIONPERCENT: "เปอร์เซ็นต์การชะลอตัว",
  T_46_META_WS_P_DEFAULTTEXT: "ข้อความตั้งต้น",
  T_46_META_WS_P_DEFENSE: "อัตราการป้องกัน",
  T_46_META_WS_P_DEFENSERATE: "อัตราการป้องกัน",
  T_46_META_WS_P_DELTA: "เดลต้า",
  T_46_META_WS_P_DELTATIME: "เวลาเดลต้า",
  T_46_META_WS_P_DELTAVALUE: "ค่าเดลต้า",
  T_46_META_WS_P_DEPTH: "ความลึก",
  T_46_META_WS_P_DESC: "ข้อความคำอธิบาย",
  T_46_META_WS_P_DESCRIPTION: "ข้อความคำอธิบาย",
  T_46_META_WS_P_DESCRIPTIONKEY: "ข้อมูลคำอธิบายคีย์",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "พารามิเตอร์คำอธิบาย",
  T_46_META_WS_P_DESTVAL: "DestVal",
  T_46_META_WS_P_DETECTRANGE: "ระยะการตรวจจับ",
  T_46_META_WS_P_DIFFUSEALPHA: "ความโปร่งใสของพื้นผิว",
  T_46_META_WS_P_DIFFUSECOLOR: "สีแผนที่พื้นผิว",
  T_46_META_WS_P_DIFFUSETEXTURE: "แผนที่พื้นผิว",
  T_46_META_WS_P_DISABLECOLOR: "ปิดสี",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "ปิดความเสียหายจากการตก",
  T_46_META_WS_P_DISABLEITEMDROP: "ปิดการดรอปไอเทม",
  T_46_META_WS_P_DISABLEITEMPICKUP: "ปิดการหยิบไอเทม",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "ปิดใช้งานการปิดระบบด้วยตนเอง",
  T_46_META_WS_P_DISABLEQUICKCHAT: "ปิดการพูดคุยแบบด่วน",
  T_46_META_WS_P_DISABLERECIPROCATING: "ปิดการเคลื่อนไหวแบบลูกสูบ",
  T_46_META_WS_P_DISABLEVOICECHAT: "ปิดการพูดคุยด้วยเสียง",
  T_46_META_WS_P_DISTANCE: "ระยะทาง",
  T_46_META_WS_P_DOUBLEGUNTYPE: "ประเภทปืนคู่",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "ความเร็วการคลานเมื่อล้ม",
  T_46_META_WS_P_DOWNSPEED: "ความเร็วลง",
  T_46_META_WS_P_DRAG: "ค่าสัมประสิทธิ์ความต้านทานการเคลื่อนที่",
  T_46_META_WS_P_DRIVER: "คนขับ",
  T_46_META_WS_P_DROPITEMS: "ไอเทมที่ดรอป",
  T_46_META_WS_P_DURABILITY: "ความทนทาน",
  T_46_META_WS_P_DURABILITYRECOVERY: "ค่าการฟื้นตัวของความทนทาน",
  T_46_META_WS_P_DURATION: "ระยะเวลา",
  T_46_META_WS_P_EDGEFLASHTIME: "เวลาแฟลชที่ขอบ",
  T_46_META_WS_P_EFFECTACTIVE: "แสดงเอฟเฟ็กต์พิเศษ",
  T_46_META_WS_P_EFFECTCOLOR: "สีเอฟเฟ็กต์พิเศษ",
  T_46_META_WS_P_EFFECTDURATION: "ระยะเวลาเอฟเฟ็กต์",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "ช่วงของเวลาที่มีประสิทธิภาพ",
  T_46_META_WS_P_EFFECTRESID: "เส้นทางทรัพยากรเอฟเฟ็กต์",
  T_46_META_WS_P_ENABLE: "เปิดใช้งาน",
  T_46_META_WS_P_ENABLEATTACK: "เปิดการโจมตี",
  T_46_META_WS_P_ENABLEBOTREVIVE: "เปิดการชุบชีวิตของบอท",
  T_46_META_WS_P_ENABLEDEPTHMAP: "เปิดความลึกของแผนที่",
  T_46_META_WS_P_ENABLEDROPONDEATH: "เปิดการดรอปเมื่อตาย",
  T_46_META_WS_P_ENABLELOCALIZATION: "เปิดการแปล",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "เปิดการเคลื่อนที่กลางอากาศ",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "เปิดการชุบชีวิตของผู้เล่น",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "เปิดมุมมองผู้เล่น",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "เปิดการหมุนด้วยแรงโน้มถ่วง",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "เปิดคุณลักษณะของสกิน",
  T_46_META_WS_P_ENABLESWINGING: "เปิดการเหวียง",
  T_46_META_WS_P_ENABLETRACTION: "เปิดแรงฉุด",
  T_46_META_WS_P_ENDPOSITION: "ตำแหน่งสิ้นสุด",
  T_46_META_WS_P_ENDRADIUS: "รัศมีสิ้นสุด",
  T_46_META_WS_P_ENDTIME: "เวลาจบ (วินาที)",
  T_46_META_WS_P_ENDTIMES: "เวลาจบ (วินาที)",
  T_46_META_WS_P_ENDVALUE: "ค่าสุดท้าย",
  T_46_META_WS_P_ENERGY: "พลังงาน",
  T_46_META_WS_P_ENERGYCOST: "การใช้พลังงาน",
  T_46_META_WS_P_ENERGYRECOVERY: "ฟื้นฟูพลังงาน",
  T_46_META_WS_P_ENGINEHORSEPOWER: "แรงม้าของเครื่องยนต์",
  T_46_META_WS_P_ENGINETORQUE: "แรงบิดของเครื่องยนต์",
  T_46_META_WS_P_EP: "ค่าพลังงาน",
  T_46_META_WS_P_EPMAX: "ค่าพลังงานสูงสุด",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "ปริมาณการฟื้นตัวของพลังงาน",
  T_46_META_WS_P_EVENTS: "กิจกรรม",
  T_46_META_WS_P_EXPLODEDAMAGE: "ความเสียหายจากการระเบิด",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "ค่าสัมประสิทธิ์การลดความเสียหายจากการระเบิด",
  T_46_META_WS_P_EXPLODEDELAY: "ความล่าช้าในการระเบิด",
  T_46_META_WS_P_EXPLODERANGE: "ระยะการระเบิด",
  T_46_META_WS_P_EXPLOSIONDELAY: "ความล่าช้าในการระเบิด",
  T_46_META_WS_P_EXPLOSIONRANGE: "ระยะการระเบิด",
  T_46_META_WS_P_EXPLOSIONTIME: "ความล่าช้าในการระเบิด",
  T_46_META_WS_P_EXPPERDAMAGE: "ค่าประสบการณ์ต่อความเสียหาย",
  T_46_META_WS_P_EXPPERMOVEMILE: "ค่าประสบการณ์ต่อไมล์ที่เคลื่อนที่",
  T_46_META_WS_P_EXPPERSECOND: "ค่าประสบการณ์ต่อวินาที",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "ความจุกระเป๋าเป้เพิ่มเติม",
  T_46_META_WS_P_EXTRABAGCAPACITY: "พื้นที่กระเป๋าเป้เพิ่มเติม",
  T_46_META_WS_P_EXTRAHPRATIO: "ตัวคูณพลังชีวิตของผู้เล่น",
  T_46_META_WS_P_FACEPAINT: "แต่งหน้า",
  T_46_META_WS_P_FACTION: "ฝ่าย",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "อัตราส่วนความเสียหายจากการล้ม",
  T_46_META_WS_P_FALLSPEED: "ความเร็วการตก",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "ความเร็วในการโหลดอัตโนมัติ",
  T_46_META_WS_P_FILEID: "รหัสไฟล์",
  T_46_META_WS_P_FILL: "การเติม",
  T_46_META_WS_P_FILLAMOUNT: "เติมค่า",
  T_46_META_WS_P_FILLDIRECTION: "เติมทิศทาง",
  T_46_META_WS_P_FILLTYPE: "ประเภทการเติม",
  T_46_META_WS_P_FIREANGLELIMIT: "ขีดจำกัดมุมไฟ",
  T_46_META_WS_P_FIRETYPE: "ประเภทไฟ",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "พารามิเตอร์ค่าคะแนนแรก",
  T_46_META_WS_P_FIRSTSCORETITLE: "ข้อความชื่อคะแนนประเภทแรก",
  T_46_META_WS_P_FIRSTSCOREVALUE: "ค่าคะแนนแรก",
  T_46_META_WS_P_FIXEDDELTATIME: "เวลาแบบการอัปเดตเฟรมคงที่ (Fixed Delta Time)",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "สวิตช์เอฟเฟ็กต์การโจมตีด้วยระเบิดแฟลช",
  T_46_META_WS_P_FLIP: "พลิก",
  T_46_META_WS_P_FLIPTYPE: "ประเภทพลิก",
  T_46_META_WS_P_FLYMAXHEIGHT: "ระดับความสูงการบินสูงสุด",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "ความเร็วการบินแนวนอน",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "ความเร็วการบินแนวตั้ง",
  T_46_META_WS_P_FOGCOLOR: "สีหมอก",
  T_46_META_WS_P_FOLLOWTARGET: "ติดตามเป้าหมาย",
  T_46_META_WS_P_FONT: "แบบอักษร",
  T_46_META_WS_P_FONTSIZE: "ขนาดตัวอักษร",
  T_46_META_WS_P_FONTSTYLE: "สไตล์ตัวอักษร",
  T_46_META_WS_P_FONTTYPE: "รูปแบบตัวอักษร",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "บังคับการซิงโครไนซ์กับไคลเอนต์",
  T_46_META_WS_P_FORWARD: "ข้างหน้า",
  T_46_META_WS_P_FORWARDSPEED: "ความเร็วเดินหน้า",
  T_46_META_WS_P_FOV: "พื้นที่การมองเห็น",
  T_46_META_WS_P_FREEZEDURATION: "เวลาแช่แข็ง (วินาที)",
  T_46_META_WS_P_FRIENDFACTIONS: "ฝ่ายที่เป็นมิตร",
  T_46_META_WS_P_FRIENDLYPLAYERS: "ผู้เล่นที่เป็นมิตร",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "ระยะความเสียหายเต็ม",
  T_46_META_WS_P_FUNCTIONTYPE: "ประเภทฟังก์ชัน",
  T_46_META_WS_P_GAINHPCOLOR: "ได้รับสีพลังชีวิต",
  T_46_META_WS_P_GAMEFRAMECOUNT: "นับเฟรม",
  T_46_META_WS_P_GAMETIMECOUNT: "เวลาเกม",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "ความล่าช้าในการเปลี่ยนเกียร์",
  T_46_META_WS_P_GENDER: "เพศ",
  T_46_META_WS_P_GETONBOOSTCD: "คลูลดาวน์การบูสหลังขึ้น",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "สวิตช์คลูลดาวน์การบูสหลังขึ้น",
  T_46_META_WS_P_GETONSKATEBOARDCD: "คลูลดาวน์สเก็ตบอร์ดหลังขึ้น",
  T_46_META_WS_P_GRADIENT: "การไล่ระดับสี",
  T_46_META_WS_P_GRADIENTBOTTOM: "ไล่สีจากด้านล่าง",
  T_46_META_WS_P_GRADIENTTOP: "ไล่สีจากด้านบน",
  T_46_META_WS_P_GRAVITY: "แรงโน้มถ่วง",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "ความเสียหายการระเบิดสูงสุด",
  T_46_META_WS_P_GRENADEMINDAMAGE: "ความเสียหายการระเบิดสูงสุด",
  T_46_META_WS_P_GRENADERANGE: "ระยะการระเบิด",
  T_46_META_WS_P_GROUPID: "รหัสกลุ่ม",
  T_46_META_WS_P_HEAD: "หัว",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "ความเสียหายที่หัว",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "อัตราการลดความเสียหายจากการยิงหัว",
  T_46_META_WS_P_HEIGHT: "สูง",
  T_46_META_WS_P_HELMET: "หมวกกันน็อคปัจจุบัน",
  T_46_META_WS_P_HIGHESTBRRANK: "แรงก์โหมดทั่วไปสูงสุด",
  T_46_META_WS_P_HIGHESTCSRANK: "แรงก์โหมด 4v4 สูงสุด",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "มุมเหนือศีรษะขั้นต่ำ",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "มุมพวงมาลัยความเร็วสูง",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "ความเร็วมุมของพวงมาลัยความเร็วสูง",
  T_46_META_WS_P_HITPOINTEFFECT: "เอฟเฟ็กต์ Hit point",
  T_46_META_WS_P_HORIZONTALBAR: "บาร์แนวนอน",
  T_46_META_WS_P_HORIZONTALOFFSET: "ออฟเซตแนวนอน",
  T_46_META_WS_P_HOSTILETEAMS: "ทีมศัตรู",
  T_46_META_WS_P_HOSTTEAM: "ทีมเจ้าบ้าน",
  T_46_META_WS_P_HP: "พลังชีวิต",
  T_46_META_WS_P_HPMAX: "พลังชีวิตสูงสุด",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "ปริมาณการฟื้นคืนของพลังชีวิต",
  T_46_META_WS_P_HPRECOVERYSPEED: "ความเร็วการฟื้นคืนของพลังชีวิต (มิลลิวินาที)",
  T_46_META_WS_P_ICON: "ไอคอน",
  T_46_META_WS_P_ICONCOLOR: "สีไอคอน",
  T_46_META_WS_P_ICONNAME: "ชื่อไอคอน",
  T_46_META_WS_P_ICONRESOURCE: "ทรัพยากรไอคอน",
  T_46_META_WS_P_ID: "รหัส",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "ช่วงเวลาการโจมตีป้อมปืน (วินาที)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "การป้อนข้อมูลที่จะทำลายการยินเฉยๆ",
  T_46_META_WS_P_INACTIVATEDALPHA: "ไม่ได้เปิดใช้งานความโปร่งใส",
  T_46_META_WS_P_INDEX: "อินเด็กซ์",
  T_46_META_WS_P_INITIALMAGCOUNT: "จำนวนแม็กเริ่มต้น",
  T_46_META_WS_P_INITIALSPEED: "ความเร็วเริ่มต้น",
  T_46_META_WS_P_INITIALVALUE: "ค่าเริ่มต้น",
  T_46_META_WS_P_INITIALWORLDPOSITION: "พิกัดโลกเริ่มต้น",
  T_46_META_WS_P_INSCENE: "ในฉาก",
  T_46_META_WS_P_INSTANCEID: "รหัสอินสแตนซ์",
  T_46_META_WS_P_INTENSITY: "ความเข้ม",
  T_46_META_WS_P_INVERTFILL: "สลับการเติม",
  T_46_META_WS_P_INVINCIBLE: "อยู่ยงคงกระพัน",
  "T_46_META_WS_P_IS SHOW": "โชว์อยู่ไหม",
  T_46_META_WS_P_IS3D: "เป็น 3 มิติไหม",
  T_46_META_WS_P_ISACE: "ไม่ว่ากลุ่มจะถูกทำลาย",
  T_46_META_WS_P_ISACED: "ได้ ACE ไหม",
  T_46_META_WS_P_ISAI: "เป็น AI ไหม",
  T_46_META_WS_P_ISALWAYSINSCREEN: "อยู่บนหน้าจอเสมอไหม",
  T_46_META_WS_P_ISAPPLYSHADOW: "ใช้เงาไหม",
  T_46_META_WS_P_ISATTACKABLE: "สามารถโจมตีได้ไหม",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "ไล่ตามศัตรูโดยอัตโนมัติไหม",
  T_46_META_WS_P_ISAUTOPLAY: "เล่นอัตโนมัติไหม",
  T_46_META_WS_P_ISAUTOTELEPORT: "เทเลพอร์ตโดยอัตโนมัตไหม",
  T_46_META_WS_P_ISBILLBOARD: "หันหน้าเข้าหากล้องเสมอไหม",
  T_46_META_WS_P_ISBOLD: "ตัวหนา",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "ด้านล่างกำลังชนไหม",
  T_46_META_WS_P_ISCENTERPOS: "จุดศูนย์กลางไหม",
  T_46_META_WS_P_ISCONSUMEAMMO: "ใช้กระสุนไหม",
  T_46_META_WS_P_ISCONTINUOUS: "ต่อเนื่องไหม",
  T_46_META_WS_P_ISCOUNTDOWN: "นับถอยหลังอยู่ไหม",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "แอนิเมชันปัจจุบันเป็นแบบลูปไหม",
  T_46_META_WS_P_ISDEADDROP: "ตายดรอปไหม",
  T_46_META_WS_P_ISDEATHTRIGGER: "ทริกเกอร์เมื่อถูกทำให้ตาย",
  T_46_META_WS_P_ISDEBUG: "ดีบัคไหม",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "ใช้จุดเกิดตั้งต้นไหม",
  T_46_META_WS_P_ISDROPONELIMINATED: "ดรอปตอนถูกกำจัดไหม",
  T_46_META_WS_P_ISEND: "จบไหม",
  T_46_META_WS_P_ISFEBUTTON: "มันเป็นปุ่ม FE ไหม",
  T_46_META_WS_P_ISGREY: "เป็นสีเทาไหม",
  T_46_META_WS_P_ISGROUNDED: "อยู่ที่พื้นไหม",
  T_46_META_WS_P_ISIGNOREDEPTH: "ไม่สนความลึกไหม",
  T_46_META_WS_P_ISINVINCIBLE: "เป็นอมตะไหม",
  T_46_META_WS_P_ISITALIC: "ตัวเอียงไหม",
  T_46_META_WS_P_ISLASTROUND: "เป็นรอบสุดท้ายไหม",
  T_46_META_WS_P_ISLOCALPOS: "เป็นตำแหน่งแบบถ้องทิ่นไหม",
  T_46_META_WS_P_ISLOOP: "ลูปซ้ำไหม",
  T_46_META_WS_P_ISMATCHPOINT: "เป็นคะแนนสุดท้ายของการแข่งขันไหม",
  T_46_META_WS_P_ISMOVEABLE: "สามารถขยับได้ไหม",
  T_46_META_WS_P_ISOCCUPIED: "มันถูกครอบครองแล้วไหม",
  T_46_META_WS_P_ISOPENTWEEN: "เปิดใช้งานเอฟเฟ็กต์การเปลี่ยนแปลงสุขภาพ",
  T_46_META_WS_P_ISPLAYING: "กำลังเล่นอยู่ไหม",
  T_46_META_WS_P_ISPURCHASABLE: "สามารถซื้อได้ไหม",
  T_46_META_WS_P_ISREVERSE: "ไหมย้อนกลับ",
  T_46_META_WS_P_ISSERVERDRIVEN: "มันขับเคลื่อนด้วยเซิร์ฟเวอร์ไหม",
  T_46_META_WS_P_ISSHOW: "แสดงไหม",
  T_46_META_WS_P_ISSHOWHUDNAME: "แสดงชื่อ HUD ไหม",
  T_46_META_WS_P_ISSHOWMAPINFO: "แสดงข้อมูลแผนที่ไหม",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "แสดงข้อความแบบด่วนไหม",
  T_46_META_WS_P_ISSHOWSCAN: "แสดงการแสกนไหม",
  T_46_META_WS_P_ISSHOWTAG: "แสดงแท็กไหม",
  T_46_META_WS_P_ISSIDECOLLIDING: "ด้านข้างกำลังชนไหม",
  T_46_META_WS_P_ISSILENCE: "เงียบไหม / ใบ้ไหม",
  T_46_META_WS_P_ISSINGLESHOT: "ยิงนัดเดียวไหม",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "ข้ามแอนิเมชันที่ค้างไหม",
  T_46_META_WS_P_ISSLIDING: "กำลังสไลด์ไหม",
  T_46_META_WS_P_ISTOPCOLLIDING: "ข้างบนกำลังชนไหม",
  T_46_META_WS_P_ISUNDERLINE: "ขีดเส้นใต้ไหม",
  T_46_META_WS_P_ISVISIBLE: "มองเห็นได้ไหม",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "ไอเทมสีพื้นหลัง",
  T_46_META_WS_P_ITEMBACKGROUNDS: "ไอเทมพื้นหลัง",
  T_46_META_WS_P_ITEMCOUNTS: "จำนวนไอเทม",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "คำอธิบายไอเทม",
  T_46_META_WS_P_ITEMICONS: "ไอเทมไอคอน",
  T_46_META_WS_P_ITEMID: "รหัสไอเทม",
  T_46_META_WS_P_ITEMIDS: "รหัสไอเทม",
  T_46_META_WS_P_ITEMNAMES: "ชื่อไอเทม",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "รายการสิ่งของห้ามหยิบ",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "รัศมีขอบเขตการลากสูงสุดของจอยสติ๊ก",
  T_46_META_WS_P_JOYSTICKIMAGE: "ขอบเขตภาพจอยสติ๊ก",
  T_46_META_WS_P_JOYSTICKRADIUS: "ขอบเขตรัศมีจอยสติ๊ก",
  T_46_META_WS_P_JUMPCD: "คลูลดาวน์กระโดด",
  T_46_META_WS_P_JUMPHEIGHT: "ความสูงของกระโดด",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "อัตราส่วนสเกลความสูงของการกระโดด",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "โบนัสความเสียหายของการล้ม",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "สถานะการล้ม",
  T_46_META_WS_P_LABEL: "ฉลาก",
  T_46_META_WS_P_LABELCOLOR: "สีฉลาก",
  T_46_META_WS_P_LABELKEY: "คีย์ของฉลาก",
  T_46_META_WS_P_LABELPARAMS: "พารามิเตอร์ของฉลาก",
  T_46_META_WS_P_LASTCHECKPOINTID: "รหัสเช็กพ้อยต์ปัจจุบัน",
  T_46_META_WS_P_LASTSURVIVALTIME: "เวลาเอาชีวิตรอด",
  T_46_META_WS_P_LAYERTYPE: "ประเภทเรย์เยอร์",
  T_46_META_WS_P_LAYOUTTYPE: "ประเภทเค้าโครง",
  T_46_META_WS_P_LEFTARM: "แขนซ้าย",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "สีพื้นหลังด้านซ้าย",
  T_46_META_WS_P_LEFTCOLOR: "สีซ้าย",
  T_46_META_WS_P_LEFTDESCRIPTION: "คำอธิบายของทีมด้านซ้าย",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "ใช้งานเอฟเฟ็กต์ด้านซ้าย",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "มุมโค้งการยิงด้านซ้าย",
  T_46_META_WS_P_LEFTFOOT: "เท้าซ้าย",
  T_46_META_WS_P_LEFTHAND: "มือซ้าย",
  T_46_META_WS_P_LEFTICON: "ไอคอนด้านซ้าย",
  T_46_META_WS_P_LEFTICONNAME: "ชื่อไอคอนทางด้านซ้าย",
  T_46_META_WS_P_LEFTLEG: "ขาซ้าย",
  T_46_META_WS_P_LEFTPLAYERS: "อาร์เรย์ของผู้เล่นทางด้านซ้าย",
  T_46_META_WS_P_LEFTSCORE: "คะแนนทางด้านซ้าย",
  T_46_META_WS_P_LEFTSCOREAFTER: "คะแนนสุดท้ายทางซ้าย",
  T_46_META_WS_P_LEFTSCORETEXT: "คะแนนทางด้านซ้าย",
  T_46_META_WS_P_LEFTTEAM: "ทีมด้านซ้าย",
  T_46_META_WS_P_LEFTTEAMINDEX: "อินเด็กซ์ทีมซ้าย",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "จำนวนผู้รอดชีวิตในทีมทางด้านซ้าย",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "จำนวนธงของทีมฝ่ายซ้าย",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "อาร์เรย์สถานะผู้เล่นด้านซ้าย",
  T_46_META_WS_P_LEFTTEAMNAME: "ชื่อทีมด้านซ้าย",
  T_46_META_WS_P_LEFTTEAMSCORE: "คะแนนทีมทางซ้าย",
  T_46_META_WS_P_LEFTTEXT: "ข้อความด้านซ้าย",
  T_46_META_WS_P_LENGTH: "ความยาว",
  T_46_META_WS_P_LENSFLARE: "แฟร์แสงของเลน",
  T_46_META_WS_P_LEVEL: "ระดับ",
  T_46_META_WS_P_LIFETIME: "ระยะเวลาป้อมปืน (วินาที)",
  T_46_META_WS_P_LIGHTCOLOR: "สีของแสง",
  T_46_META_WS_P_LIGHTINTENSITY: "ความเข้มของแสง",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "ตัวคูณความเสียหายแขนขา",
  T_46_META_WS_P_LINESPACING: "ระยะห่างระหว่างเส้น",
  T_46_META_WS_P_LOCALPOSITION: "ตำแหน่งโดยอ้างอิงจากวัตถุแม่",
  T_46_META_WS_P_LOCALROTATION: "การหมุนโดยอ้างอิงจากวัตถุแม่",
  T_46_META_WS_P_LOCALROTATIONQ: "การหมุนควอเทอเนียนโดยอ้างอิงจากวัตถุแม่",
  T_46_META_WS_P_LOCALSCALE: "ขนาดโดยอ้างอิงจากวัตถุแม่",
  T_46_META_WS_P_LOCKEY: "คีย์การแปล",
  T_46_META_WS_P_LOOPCOUNT: "จำนวนรอบ",
  T_46_META_WS_P_LOOTSOCCER: "ปล้นจุดฟุตบอล",
  T_46_META_WS_P_LOSEHPCOLOR: "สีเลือดทีมแพ้",
  T_46_META_WS_P_LOSEMVPS: "รายชื่อ MVP ทีมแพ้",
  T_46_META_WS_P_LOSETEXT: "ข้อความแจ้งความแพ้",
  "T_46_META_WS_P_MAIN CAMERA": "กล้องหลัก",
  T_46_META_WS_P_MAINCOLOR: "สีหลัก",
  T_46_META_WS_P_MAINSCORELIST: "คะแนนหลัก",
  T_46_META_WS_P_MAINSCORETITLE: "ชื่อคะแนนหลัก",
  T_46_META_WS_P_MAINWEAPON: "อาวุธหลัก",
  T_46_META_WS_P_MAPSIZE: "ขนาดแผนที่",
  T_46_META_WS_P_MASK: "หน้ากาก",
  T_46_META_WS_P_MASKNAME: "ชื่อหน้ากาก",
  T_46_META_WS_P_MASS: "มวล (กก.)",
  T_46_META_WS_P_MATCHTITLELEFT: "หัวชื่อการแข่งขัน ซ้าย",
  T_46_META_WS_P_MATCHTITLERIGHT: "หัวชื่อการแข่งขัน ขวา",
  T_46_META_WS_P_MAXCAPACITY: "ช่องว่าง",
  T_46_META_WS_P_MAXCOUNT: "จำนวนสูงสุด",
  T_46_META_WS_P_MAXDAMAGE: "ความเสียหายสูงสุด",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "มุมมองลงสูงสุด",
  T_46_META_WS_P_MAXDISPLACEMENT: "การกระจัดสูงสุด",
  T_46_META_WS_P_MAXDISTANCE: "ระยะทางสูงสุด",
  T_46_META_WS_P_MAXDURABILITY: "ความทนทานสูงสุด",
  T_46_META_WS_P_MAXDURABILITYRATIO: "ตัวคูณความทนทานสูงสุด",
  T_46_META_WS_P_MAXENERGY: "พลังงานสูงสุด",
  T_46_META_WS_P_MAXEP: "ค่าพลังงานสูงสุด",
  T_46_META_WS_P_MAXHP: "ปริมาณพลังชีวิตสูงสุด",
  T_46_META_WS_P_MAXJUMPCOUNT: "จำนวนการกระโดดต่อเนื่องสูงสุด",
  T_46_META_WS_P_MAXJUMPHEIGHT: "ความสูงสูงสุด",
  T_46_META_WS_P_MAXLENGTH: "ความยาวสูงสุดของการกระโดด",
  T_46_META_WS_P_MAXPROGRESS: "ความก้าวหน้าสูงสุด",
  T_46_META_WS_P_MAXSCATTERRATIO: "ค่าการกระจายสูงสุด",
  T_46_META_WS_P_MAXSPEED: "ความเร็วสูงสุด",
  T_46_META_WS_P_MAXTURRETCOUNT: "จำนวนป้อมปืนสูงสุด",
  T_46_META_WS_P_MAXVALUE: "ค่าสูงสุด",
  T_46_META_WS_P_MAXWIDGETID: "รหัสวิดเจ็ตสูงสุด",
  T_46_META_WS_P_MINDAMAGE: "ความเสียหายขั้นต่ำ",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "ระยะเริ่มต้นความเสียหายขั้นต่ำ",
  T_46_META_WS_P_MINDISTANCE: "ระยะทางขั้นต่ำ",
  T_46_META_WS_P_MINELEVATIONANGLE: "มุมเงยขั้นต่ำ",
  T_46_META_WS_P_MINENDHEIGHT: "ความสูงขั้นต่ำสุด",
  T_46_META_WS_P_MINFLYHEIGHT: "ระดับความสูงขั้นต่ำในการบิน",
  T_46_META_WS_P_MINMOVEDISTANCE: "ระยะการเคลื่อนที่ขั้นต่ำ",
  T_46_META_WS_P_MINVALUE: "ค่าต่ำสุด",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "ความเสียหายสูงสุดของขีปนาวุธ",
  T_46_META_WS_P_MISSILEMINDAMAGE: "ความเสียหายขั้นต่ำของขีปนาวุธ",
  T_46_META_WS_P_MISSILERANGE: "ระยะขีปนาวุธ",
  T_46_META_WS_P_MODEL: "โมเดล",
  T_46_META_WS_P_MODELVISIBILITY: "การมองเห็นโมเดล",
  T_46_META_WS_P_MODELVISIBLE: "มองเห็นโมเดล",
  T_46_META_WS_P_MONEY: "เงิน",
  T_46_META_WS_P_MONEYLIST: "รายชื่อสกุลเงิน",
  T_46_META_WS_P_MONEYS: "สกุลเงิน",
  T_46_META_WS_P_MONEYTYPE: "ประเภทสกุลเงิน",
  T_46_META_WS_P_MONSTERTYPE: "ประเภทสัตว์ประหลาด",
  T_46_META_WS_P_MOTIONTYPE: "ประเภทการเคลื่อนไหว",
  T_46_META_WS_P_MOTIONVALUEX: "การเคลื่อนไหวในทิศทางแกน X",
  T_46_META_WS_P_MOTIONVALUEY: "การเคลื่อนไหวในทิศทางแกน Y",
  T_46_META_WS_P_MOTIONVALUEZ: "การเคลื่อนไหวในทิศทางแกน Z",
  T_46_META_WS_P_MOVEMENTDURATION: "ระยะเวลาการเคลื่อนไหว",
  T_46_META_WS_P_MULTIPLIER: "ตัวคูณ",
  T_46_META_WS_P_MUSICELEMENTTYPE: "ประเภทองค์ประกอบเพลง",
  T_46_META_WS_P_MUZZLEVELOCITY: "ความเร็วปากกระบอกปืน",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "ชื่อ",
  T_46_META_WS_P_NEXTROUNDINDEX: "อินเด็กซ์รอบต่อไป",
  T_46_META_WS_P_NICKNAME: "ชื่อเล่น",
  T_46_META_WS_P_NORMALCOLOR: "สีปกติ",
  T_46_META_WS_P_NORMALIZEDPOSITION: "ตำแหน่งปกติ",
  T_46_META_WS_P_NUMBERINFACTION: "หมายเลขในฝ่าย",
  T_46_META_WS_P_OBJECTID: "รหัสวัตถุ",
  T_46_META_WS_P_OFFSET: "ออฟเซต",
  T_46_META_WS_P_OPTIONS: "ตัวเลือก",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "ค่าสัมประสิทธิ์ความเสียหายต่อวัตถุอื่น",
  T_46_META_WS_P_OUTFIT: "เสื้อผ้า",
  T_46_META_WS_P_OVERFLOW: "ข้อความล้น",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "ความเร็วลดลงหลังจากสูงมาก",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "การกำหนดค่าผู้เล่นมีความสำคัญ",
  T_46_META_WS_P_OWNER: "เจ้าของ",
  T_46_META_WS_P_PARAMS: "ข้อมูลอาร์เรย์คำอธิบายพร้อมท์ข้อมูล",
  T_46_META_WS_P_PARENT: "เอนทิตีโหนดหลัก",
  T_46_META_WS_P_PARENTID: "การควบคุมโหนดหลัก EntityID",
  T_46_META_WS_P_PARENTUI: "UI ที่เป็นของ",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "โหนดหลักวิดเจ็ตรหัสเอนทิตี้",
  T_46_META_WS_P_PARENTWIDGETFILEID: "โหนดหลักวิดเจ็ตหรัสไฟล์",
  T_46_META_WS_P_PARTMASKA: "หน้ากากชิ้นส่วน 1",
  T_46_META_WS_P_PASSENGERS: "ผู้โดยสาร",
  T_46_META_WS_P_PATHID: "รหัสเส้นทางของวัตถุ",
  T_46_META_WS_P_PAUSEEVENT: "หยุดกิจกรรมชั่วคราว",
  T_46_META_WS_P_PERSONAID: "รหัสเพอโซน่า",
  T_46_META_WS_P_PHASEDURATION: "ระยะเวลา (มิลลิวินาที)",
  T_46_META_WS_P_PHASEENDTIME: "เวลาสิ้นสุด (มิลลิวินาที)",
  T_46_META_WS_P_PHYSICALLAYER: "เรย์เยอร์ทางกายภาพ",
  T_46_META_WS_P_PINID: "รหัสพิน",
  T_46_META_WS_P_PITCH: "มุมสนาม",
  T_46_META_WS_P_PIVOT: "จุดศูนย์กลางการหมุน",
  T_46_META_WS_P_PLAYER: "ผู้เล่น",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "ค่าสัมประสิทธิ์ความเร็วการเล็งของผู้เล่น",
  T_46_META_WS_P_PLAYERLIST: "รายชื่อผู้เล่น",
  T_46_META_WS_P_PLAYERNAME: "ชื่อ",
  T_46_META_WS_P_PLAYERRANK: "อันดับผู้เล่น",
  T_46_META_WS_P_PLAYERRANKS: "การจัดอันดับผู้เล่น",
  T_46_META_WS_P_PLAYERS: "รายชื่อผู้เล่น",
  T_46_META_WS_P_PLAYERSCORETYPES: "ประเภทคะแนนของผู้เล่น",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "ค่าสัมประสิทธิ์ความเร็วของผู้เล่น",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "ค่าสัมประสิทธิ์ความเร็วของผู้เล่นขณะยิง",
  T_46_META_WS_P_PLAYERSTATUS: "สถานะผู้เล่น",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "ความเร็วแรงฉุดของผู้เล่น",
  T_46_META_WS_P_PLAYINGSTATUS: "สถานะการเล่น",
  T_46_META_WS_P_PLAYSPEED: "ความเร็วในการเล่น",
  T_46_META_WS_P_POINTPOSITION: "ตำแหน่งจุด",
  T_46_META_WS_P_POINTS: "จุด",
  T_46_META_WS_P_POSITION: "ตำแหน่ง",
  T_46_META_WS_P_PREFABID: "รหัสพรีแฟบ",
  T_46_META_WS_P_PRESSEDCOLOR: "กดสี",
  T_46_META_WS_P_PRESSEDSPRITE: "กดรูปภาพ",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "กดประเภทภาพ",
  T_46_META_WS_P_PRICE: "ราคา",
  T_46_META_WS_P_PRIORITY: "ลำดับความสำคัญ",
  T_46_META_WS_P_PROFILEINFO: "นามบัตรผู้เล่น",
  T_46_META_WS_P_PROGRESS: "ความคืบหน้า [0,1]",
  T_46_META_WS_P_PROGRESSICON: "ไอคอนความคืบหน้า",
  T_46_META_WS_P_PROGRESSICONNAME: "ชื่อไอคอนความคืบหน้า",
  T_46_META_WS_P_PROPID: "รหัสของตกแต่ง",
  T_46_META_WS_P_PURCHASELIMIT: "ลิมิตการซื้อ",
  T_46_META_WS_P_RADIUS: "รัศมี",
  T_46_META_WS_P_RANGE: "ช่วงแสง",
  T_46_META_WS_P_RANK: "การจัดอันดับ",
  T_46_META_WS_P_RATIOSELFFACTOR: "ค่าสัมประสิทธิ์ความเสียหายของตัวเอง",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "ค่าสัมประสิทธิ์ความเสียหายของเพื่อนร่วมทีม",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "ค่าสัมประสิทธิ์ความเสียหายของยานพาหนะ",
  T_46_META_WS_P_REFRESHTIME: "เวลารีเฟรชบัฟ",
  T_46_META_WS_P_RELOADSPEED: "ความเร็วการเปลี่ยนกระสุน",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "ค่าสัมประสิทธิ์ความเร็วการเปลี่ยนกระสุน",
  T_46_META_WS_P_REMAINJUMPCOUNT: "จำนวนการกระโดดต่อเนื่องที่เหลือ",
  T_46_META_WS_P_REMAINQUANTITY: "ปริมาณปัจจุบัน",
  T_46_META_WS_P_RENDERTYPE: "ประเภทการเรนเดอร์",
  T_46_META_WS_P_REPEATTIMES: "จำนวนครั้งของการทำซ้ำ",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "แทนลำดับความสำคัญ",
  T_46_META_WS_P_REQUESTEDITEMLIST: "รายการสิ่งของที่ร้องขอ",
  T_46_META_WS_P_REQUESTTYPE: "ประเภทคำขอ",
  T_46_META_WS_P_RESETPERROUND: "รีเซตทุกรอบ",
  T_46_META_WS_P_RESETPOSITION: "รีเซตตำแหน่ง",
  T_46_META_WS_P_RESETTIME: "รีเซตเวลา",
  T_46_META_WS_P_RESOURCE: "ทรัพยากร",
  T_46_META_WS_P_RESOURCEID: "รหัสทรัพยากร",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "จำกัดเนื้อหาไว้ที่วิวพอร์ต",
  T_46_META_WS_P_RESULT: "ผลลัพธ์",
  T_46_META_WS_P_RESULTTYPE: "ประเภทผลลัพธ์",
  T_46_META_WS_P_REVIVALPOINT: "จุดฟื้นคืนชีพ",
  T_46_META_WS_P_REVIVECD: "ระยะเวลาการฟื้นคืนชีพ",
  T_46_META_WS_P_RIGHT: "ขวา",
  T_46_META_WS_P_RIGHTARM: "แขนขวา",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "สีพื้นหลังด้านขวา",
  T_46_META_WS_P_RIGHTCOLOR: "สีขวา",
  T_46_META_WS_P_RIGHTDESCRIPTION: "คำอธิบายของทีมด้านขวา",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "ใช้งานเอฟเฟ็กต์ด้านขวา",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "มุมโค้งการยิงด้านขวา",
  T_46_META_WS_P_RIGHTFOOT: "เท้าขวา",
  T_46_META_WS_P_RIGHTHAND: "มือขวา",
  T_46_META_WS_P_RIGHTICON: "ไอคอนด้านขวา",
  T_46_META_WS_P_RIGHTICONNAME: "ชื่อไอคอนทางด้านขวา",
  T_46_META_WS_P_RIGHTLEG: "ขาขวา",
  T_46_META_WS_P_RIGHTPLAYERS: "อาร์เรย์ของผู้เล่นทางด้านขวา",
  T_46_META_WS_P_RIGHTSCORE: "คะแนนทางด้านขวา",
  T_46_META_WS_P_RIGHTSCOREAFTER: "คะแนนสุดท้ายทางขวา",
  T_46_META_WS_P_RIGHTSCORETEXT: "คะแนนทางด้านขวา",
  T_46_META_WS_P_RIGHTTEAM: "ทีมด้านขวา",
  T_46_META_WS_P_RIGHTTEAMINDEX: "อินเด็กซ์ทีมขวา",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "จำนวนผู้รอดชีวิตในทีมทางด้านขวา",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "จำนวนธงของทีมฝ่ายขวา",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "อาร์เรย์สถานะผู้เล่นด้านขวา",
  T_46_META_WS_P_RIGHTTEAMNAME: "ชื่อทีมด้านขวา",
  T_46_META_WS_P_RIGHTTEAMSCORE: "คะแนนทีมทางขวา",
  T_46_META_WS_P_RIGHTTEXT: "ข้อความด้านขวา",
  T_46_META_WS_P_RIMALPHA: "ความโปร่งใสของขอบ",
  T_46_META_WS_P_RIMCOLOR: "สีขอบ",
  T_46_META_WS_P_RIMTEXTURE: "พื้นผิวของขอบ",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "ค่าสัมประสิทธิ์แรงเสียดทานของการม้วนตัว",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "ค่าสัมประสิทธิ์แรงเสียดทานของการม้วนตัวของ",
  T_46_META_WS_P_ROTATION: "หมุน",
  T_46_META_WS_P_ROTATIONANGLE: "มุมการหมุน",
  T_46_META_WS_P_ROTATIONQ: "หมุนควอเทอร์เนียน",
  T_46_META_WS_P_ROUNDINCOME: "มูลค่ารายได้แบบปัดเศษ",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "รายการรายละเอียดของมูลค่ารายได้แบบปัดเศษ",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "รายการชื่อรายละเอียดรายได้แบบปัดเศษ",
  T_46_META_WS_P_ROUNDINCOMETITLE: "ชื่อรายได้แบบปัดเศษ",
  T_46_META_WS_P_ROUNDNUM: "ตัวเลขรอบ",
  T_46_META_WS_P_ROUNDNUMKEY: "คีย์ตัวเลขรอบ",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "คีย์ท้องถิ่นตัวเลขรอบ",
  T_46_META_WS_P_RUNSPEED: "ความเร็วในการวิ่ง",
  T_46_META_WS_P_RUNSPEEDSCALE: "สเกลความเร็วการวิ่ง",
  T_46_META_WS_P_RUSHDISTANCE: "ระยะการวิ่งไว",
  T_46_META_WS_P_RUSHENERGYCOST: "การใช้พลังงานในการวิ่งไวต่อวินาที",
  T_46_META_WS_P_RUSHVERTICALSPEED: "ความเร็วแนวตั้งของการวิ่งไว",
  T_46_META_WS_P_SCALE: "ขนาด",
  T_46_META_WS_P_SCATTERINCREASESPEED: "ปัจจัยการขยายของเป้าเล็ง",
  T_46_META_WS_P_SCATTERMAX: "เกณฑ์การแพร่กระจายสูงสุด",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "ตัวคูณการแพร่กระจายของเป้าเล็งเมื่อเคลื่อนที่",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "การฟื้นตัวของเป้าเล็ง",
  T_46_META_WS_P_SCATTERSPEED: "ความเร็วของการกระจาย",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "ความเร็วการกระจายขณะหมอบ",
  T_46_META_WS_P_SCATTERTHRESHOLD: "เกณฑ์การกระจาย",
  T_46_META_WS_P_SCOPETYPE: "ประเภทของกล้องปืน",
  T_46_META_WS_P_SCORE: "จำนวนคะแนน",
  T_46_META_WS_P_SCORES1: "รายการคะแนน 1",
  T_46_META_WS_P_SCORES2: "รายการคะแนน 2",
  T_46_META_WS_P_SCORES3: "รายการคะแนน 3",
  T_46_META_WS_P_SCORES4: "รายการคะแนน 4",
  T_46_META_WS_P_SCORES5: "รายการคะแนน 5",
  T_46_META_WS_P_SCORETEXTKEY: "คีย์ข้อความคะแนน",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "คีย์พารามิเตอร์ข้อความคะแนน",
  T_46_META_WS_P_SCROLLCONTINUITY: "ความต่อเนื่องของการเลื่อน",
  T_46_META_WS_P_SCROLLDIRECTION: "ทิศทางการเลื่อน",
  T_46_META_WS_P_SCROLLEFFECT: "เอฟเฟ็กต์การเลื่อน",
  T_46_META_WS_P_SCROLLWHEELSPEED: "ความไวลูกกลิ้ง",
  T_46_META_WS_P_SECONDSCORETITLE: "ข้อความชื่อคะแนนแบบที่สอง",
  T_46_META_WS_P_SECONDSCOREVALUE: "ค่าคะแนนแบบที่สอง",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "พารามิเตอร์ค่าคะแนนแบบที่สอง",
  T_46_META_WS_P_SELECTEDCOLOR: "สีที่เลือก",
  T_46_META_WS_P_SELECTEDINDEX: "อินเด็กซ์ที่เลือก",
  T_46_META_WS_P_SELECTEDSPRITE: "รูปภาพที่เลือก",
  T_46_META_WS_P_SELECTEDTYPE: "ประเภทที่เลือก",
  T_46_META_WS_P_SELF: "ตนเอง",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "ค่าสัมประสิทธิ์ความเสียหายจากตัวเอง",
  T_46_META_WS_P_SET: "ตั้ง",
  T_46_META_WS_P_SHADERNAME: "ชื่อเชดเดอร์",
  T_46_META_WS_P_SHADOWCOLOR: "สีเงา",
  T_46_META_WS_P_SHADOWOFFSET: "ออฟเซตเงา",
  T_46_META_WS_P_SHADOWSTRENGTH: "ความเข้มของเงา",
  T_46_META_WS_P_SHELFS: "รายการชั้นวาง",
  T_46_META_WS_P_SHOES: "รองเท้า",
  T_46_META_WS_P_SHOOTANGLEMAX: "มุมการถ่ายภาพสูงสุด",
  T_46_META_WS_P_SHOOTANGLEMIN: "มุมการถ่ายภาพขั้นต่ำ",
  T_46_META_WS_P_SHOP: "ร้านค้า",
  T_46_META_WS_P_SHOPITEMS: "รายการสินค้า",
  T_46_META_WS_P_SHOWADDFRIEND: "แสดงการเพิ่มเพื่อน",
  T_46_META_WS_P_SHOWATTACKGRENADE: "แสดงการโจมตีระเบิด",
  T_46_META_WS_P_SHOWBACKGROUND: "แสดงพื้นหลัง",
  T_46_META_WS_P_SHOWCROUCH: "แสดงหมอบ",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "แสดงตัวเลขความเสียหาย",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "แสดงป้องกันระเบิด",
  T_46_META_WS_P_SHOWECCONOMY: "แสดงเศรษฐกิจ",
  T_46_META_WS_P_SHOWECONOMY: "แสดงเศรษฐกิจ",
  T_46_META_WS_P_SHOWFIRE: "แสดงการยิง",
  T_46_META_WS_P_SHOWFRAME: "แสดงเส้นขอบ",
  T_46_META_WS_P_SHOWGIFT: "แสดงการให้ของขวัญ",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "แสดงเอฟเฟ็กต์จุดตี",
  T_46_META_WS_P_SHOWJUMP: "แสดงกระโดด",
  T_46_META_WS_P_SHOWLIKE: "แสดงความชื่นชอบ",
  T_46_META_WS_P_SHOWLOBBY: "แสดงล็อบบี้",
  T_46_META_WS_P_SHOWMAPEVALUATE: "แสดงการประเมินแผนที่",
  T_46_META_WS_P_SHOWMATCHDETAIL: "แสดงรายละเอียดการแข่งขัน",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "แสดงจอยสติ๊กที่กำลังขยับ",
  T_46_META_WS_P_SHOWNAME: "แสดงชื่อเล่น",
  T_46_META_WS_P_SHOWPIN: "แสดงพิน",
  T_46_META_WS_P_SHOWPRONE: "แสดงนอนคว่ำ",
  T_46_META_WS_P_SHOWRANK: "แสดงอันดับ",
  T_46_META_WS_P_SHOWREPLAY: "แสดงการเล่น",
  T_46_META_WS_P_SHOWREPORT: "แสดงรายงาน",
  T_46_META_WS_P_SHOWSHARE: "แสดงการแชร์",
  T_46_META_WS_P_SHOWSPRINT: "แสดงวิ่งไว",
  T_46_META_WS_P_SHOWTAG: "แสดงแท็ก",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "แสดงข้อมูลเพื่อนร่วมทีม",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "แสดงสถานะเพื่อนร่วมทีม",
  T_46_META_WS_P_SHOWTEAMSCORE: "แสดงคะแนนทีม",
  T_46_META_WS_P_SHOWTIMETYPE: "แสดงประเภทของเวลา",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "แสดงคะแนนแบบสองทีม",
  T_46_META_WS_P_SHRINKDURATION: "เวลาหดตัว (มิลลิวินาที)",
  T_46_META_WS_P_SHRINKENDTIME: "เวลาสิ้นสุดการย่อ (มิลลิวินาที)",
  T_46_META_WS_P_SHRINKSPEED: "ความเร็วบรรจบกัน",
  T_46_META_WS_P_SHRINKSTARTTIME: "เวลาเริ่มต้นของการหดตัว (วินาที)",
  T_46_META_WS_P_SIGHTAIMASSIST: "อนุญาตให้ช่วยเล็งผ่านกล้องปืน",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "ค่าสัมประสิทธิ์อิทธิพลการลดทอนระยะการช่วยเล็ง (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "อิทธิพลของลำดับความสำคัญค่าสัมประสิทธิ์ระยะการช่วยเล็ง (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "ลำดับความสำคัญระยะการช่วยเล็งระยะทางสูงสุด",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "ลำดับความสำคัญระยะช่วยเล็งระยะต่ำสุด",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "อนุญาตให้ระยะของการช่วยเล็งก่อน",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "อัตราส่วนการดึงดูดช่วงหน้าจอช่วยเล็ง (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "ขอบเขตการขยายที่กำหนด",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "กำลังขยาย FOV",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "ค่าสัมประสิทธิ์ความไวในการหมุนขณะเล็งผ่านกล้องปืน",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "ขอบเขตปัจจัยการแก้ไขระยะความเสียหายขั้นต่ำ X",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "เวลาการขยายภาพของการเล็งผ่านกล้องปืน",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "การขยายภาพของการเล็งผ่านกล้องปืน",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "เวลาการฟื้นการขยายภาพของการเล็งผ่านกล้องปืน",
  T_46_META_WS_P_SIZE: "ขนาด",
  T_46_META_WS_P_SIZEDELTA: "ความต่างของขนาด",
  T_46_META_WS_P_SKELETON: "โครงกระดูก",
  T_46_META_WS_P_SKIN: "ผิว",
  T_46_META_WS_P_SKINID: "รหัสผิว",
  T_46_META_WS_P_SKINWIDTH: "ความหนาของผิวหนัง",
  T_46_META_WS_P_SKYBOXENV: "กล่องท้องฟ้า",
  T_46_META_WS_P_SKYBOXRESOURCE: "ทรัพยากรสกายบ็อกซ์พื้นฐาน",
  T_46_META_WS_P_SLOPELIMIT: "ความชันสูงสุด",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "เริ่มเลื่อนอย่างลื่นไหล",
  T_46_META_WS_P_SOFTNESS: "ความนุ่มนวล",
  T_46_META_WS_P_SORTTYPE: "จัดเรียงตามประเภท",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "จำนวนที่สร้างขึ้นต่อคลื่น",
  T_46_META_WS_P_SPAWNPOINT: "จุดเกิด",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "จำนวนคะแนนการเกิด",
  T_46_META_WS_P_SPAWNPOSITION: "พิกัดจุดเกิด",
  T_46_META_WS_P_SPEED: "ความเร็ว",
  T_46_META_WS_P_SPEEDWHILEAIMING: "ความเร็วเคลื่อนที่ขณะเล็งผ่านกล้องปืน",
  T_46_META_WS_P_SPRAYCOLOR: "สีสเปรย์",
  T_46_META_WS_P_SPRINTENERGYCOST: "พลังงานที่ใช้ในการวิ่ง",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "ความเร็วแนวนอนวิ่งเร็ว",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "อัตราส่วนสเกลความเร็วในการวิ่งไว",
  T_46_META_WS_P_SPRITENAME: "รูปร่างของภาพ",
  T_46_META_WS_P_SPRITERESOURCE: "ทรัพยากรของภาพ",
  T_46_META_WS_P_SRCVAL: "SrcVal",
  T_46_META_WS_P_STARTDROPTIME: "เวลาเริ่มดรอป (มิลลิวินาที)",
  T_46_META_WS_P_STARTEVENT: "เริ่มกิจกรรม",
  T_46_META_WS_P_STARTPOSITION: "ตำแหน่งเริ่มต้น",
  T_46_META_WS_P_STARTRADIUS: "รัศมีเริ่มต้น",
  T_46_META_WS_P_STARTSPAWNTIME: "เวลาเริ่มต้นการเกิด",
  T_46_META_WS_P_STARTTIME: "เวลาเริ่มต้น (วินาที)",
  T_46_META_WS_P_STARTVALUE: "ค่าเริ่มต้น",
  T_46_META_WS_P_STATICICONCOLORS: "สีไอตอนสเตติก",
  T_46_META_WS_P_STATICICONS: "ไอตอนสเตติก",
  T_46_META_WS_P_STATUS: "สถานะป้อมขนาดเล็ก",
  T_46_META_WS_P_STEPOFFSET: "ออฟเซตก้าว",
  T_46_META_WS_P_STOPDURATION: "ระยะเวลาหยุด",
  T_46_META_WS_P_STOPEVENT: "หยุดกิจกรรม",
  T_46_META_WS_P_STORE: "ร้านค้า",
  T_46_META_WS_P_STROPID: "Strop ID",
  T_46_META_WS_P_STYLE: "สไตล์",
  T_46_META_WS_P_SUBTITLE: "คำบรรยาย",
  T_46_META_WS_P_SUMMULTIPLIER: "ตัวคูณผลรวม",
  T_46_META_WS_P_SWINGEXITACCELERATION: "ความเร่งออกจากวงสวิง",
  T_46_META_WS_P_SWINGINGSPEED: "ความเร็วสวิง",
  T_46_META_WS_P_TAGS: "รายการแท็ก",
  T_46_META_WS_P_TARGETCHECKPOINTID: "เช็กพ้อยเป้าหมาย",
  T_46_META_WS_P_TARGETICONCOLORS: "สีไอคอนเป้าหมาย",
  T_46_META_WS_P_TARGETICONS: "ไอคอนเป้าหมาย",
  T_46_META_WS_P_TARGETID: "รหัสเป้าหมาย",
  T_46_META_WS_P_TARGETITEMID: "รหัสไอเทมเป้าหมาย",
  T_46_META_WS_P_TARGETROTATION: "ทิศทางการหมุนของเป้าหมาย",
  T_46_META_WS_P_TARGETSCALE: "ขนาดเป้าหมาย",
  T_46_META_WS_P_TEAMCOLOR: "สีทีม",
  T_46_META_WS_P_TEAMCOLORS: "สีของทีม",
  T_46_META_WS_P_TEAMINDEXS: "อินเด็กซ์ทีม",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "ค่าสัมประสิทธิ์ความเสียหายของเพื่อนร่วมทีม",
  T_46_META_WS_P_TEAMMEMBERNUM: "จำนวนสมาชิกในทีม",
  T_46_META_WS_P_TEAMNUM: "จำนวนทีม",
  T_46_META_WS_P_TEAMRANK: "อันดับทีม",
  T_46_META_WS_P_TEAMRANKDISPLAY: "การแสดงอันดับทีม",
  T_46_META_WS_P_TEAMRANKS: "อาร์เรย์การจัดอันดับทีม",
  T_46_META_WS_P_TEAMSCORES: "กลุ่มคะแนนทีม",
  T_46_META_WS_P_TEAMSEQ: "ลำดับทีม",
  T_46_META_WS_P_TEMPLATEENTITY: "เทมเพลตเอนทิตี",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "ค่าโล่ชั่วคราว",
  T_46_META_WS_P_TERRAINWETNESS: "ความชื้นของพื้นดิน",
  T_46_META_WS_P_TEXT: "ข้อความ",
  T_46_META_WS_P_TEXTCOLOR: "สีข้อความ",
  T_46_META_WS_P_TEXTKEY: "คีย์ของข้อความ",
  T_46_META_WS_P_TEXTKEYPARAMS: "พารามิเตอร์คีย์ของข้อความ",
  T_46_META_WS_P_TEXTURERESOURCE: "ทรัพยากรเท็กเจอร์",
  T_46_META_WS_P_THEMECOLOR: "สีของธีม",
  T_46_META_WS_P_THROWABLETYPE: "ประเภทของขว้างปา",
  T_46_META_WS_P_THROWINGSPEED: "ความเร็วในการขว้าง",
  T_46_META_WS_P_THROWSPEED: "ความเร็วขว้าง",
  T_46_META_WS_P_TICKINTERVAL: "ช่วงเวลาการติ๊ก",
  T_46_META_WS_P_TIMEREQUIRED: "เวลาที่ต้องการใช้ (มิลลิวินาที)",
  T_46_META_WS_P_TIPSTYPE: "ประเภทของเคล็ดลับ",
  T_46_META_WS_P_TITLE: "ข้อความชื่อเรื่อง",
  T_46_META_WS_P_TITLELIST: "รายการชื่อเรื่อง",
  T_46_META_WS_P_TITLES: "รายการชื่อเรื่อง",
  T_46_META_WS_P_TOP: "เสื้อผ้าร่างกายส่วนบน",
  T_46_META_WS_P_TOPALPHA: "ความโปร่งใสสูงสุด",
  T_46_META_WS_P_TOTALHP: "พลังชีวิตทั้งหมด",
  T_46_META_WS_P_TOTALLEVEL: "เลเวลทั้งหมด",
  T_46_META_WS_P_TOTALROUNDCOUNT: "จำนวนรอบทั้งหมด",
  T_46_META_WS_P_TOWSPEED: "ความเร็วดึง",
  T_46_META_WS_P_TRANSITIONSTAGE: "สถานะของทรานซิชั่น",
  T_46_META_WS_P_TRANSITIONTYPE: "ประเภทของทรานซิชั่น",
  T_46_META_WS_P_TRIGGERPLAYERID: "รหัสของผู้เล่นที่ทริกเกอร์",
  T_46_META_WS_P_TRIGGERRADIUS: "ระยะของทริกเกอร์",
  T_46_META_WS_P_TRIGGERRANGE: "ระยะของทริกเกอร์",
  T_46_META_WS_P_TRIGGERTIME: "เวลาทริกเกอร์",
  T_46_META_WS_P_TURNSPEED: "ความเร็วการหัน",
  T_46_META_WS_P_TWEENERENABLED: "เปิดใช้งาน Tweener",
  T_46_META_WS_P_TWEENSTYLE: "สไตล์ของ Tweener",
  T_46_META_WS_P_TYPE: "พิมพ์",
  T_46_META_WS_P_UNSELECTEDCOLOR: "ยกเลิกการเลือกสี",
  T_46_META_WS_P_UNSELECTEDSPRITE: "ยกเลิกการเลือกรูปภาพ",
  T_46_META_WS_P_UNSELECTEDTYPE: "ยกเลิกการเลือกประเภท",
  T_46_META_WS_P_UP: "ข้างบน",
  T_46_META_WS_P_UPDATETYPE: "ประเภทการอัพเดท",
  T_46_META_WS_P_UPENERGYCOST: "การใช้พลังงานเพิ่มขึ้นต่อวินาที",
  T_46_META_WS_P_UPSPEED: "ความเร็วเพิ่มขึ้น",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "ใช้ขนาดแรงผลักดันที่กำหนดเอง",
  T_46_META_WS_P_USECUSTOMRESOURCE: "ใช้ทรัพยากรที่กำหนดเอง",
  T_46_META_WS_P_USEDCAPACITY: "ความจุที่ถูกใช้ไปแล้ว",
  T_46_META_WS_P_USEGRAVITY: "ใช้แรงโน้มถ่วง",
  T_46_META_WS_P_USEPHYSICALCCT: "ใช้ CCT ทางกายภาพ",
  T_46_META_WS_P_USERUID: "UserUID",
  T_46_META_WS_P_UVOFFSET: "ออฟเซต UV",
  T_46_META_WS_P_UVSIZE: "ขนาด UV",
  T_46_META_WS_P_VALUE: "ค่า[0, 1]",
  T_46_META_WS_P_VAULTDISTANCE: "ระยะกระโดดข้าม/ปืน",
  T_46_META_WS_P_VAULTHEIGHT: "ความสูงกระโดดข้าม/ปืน",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "ค่าสัมประสิทธิ์ความเสียหายของยานพาหนะ",
  T_46_META_WS_P_VEHICLESKINID: "รหัสสกินยานพาหนะ",
  T_46_META_WS_P_VEHICLESKINIDS: "รหัสสกินยานพาหนะ",
  T_46_META_WS_P_VELOCITY: "ความเร็วเชิงเส้น (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "ความเร็วแกน XZ",
  T_46_META_WS_P_VELOCITYY: "ความเร็วแกน Y",
  T_46_META_WS_P_VERTICALBAR: "ประเภทการแสดงผลแนวตั้ง",
  T_46_META_WS_P_VERTICALOFFSET: "ออฟเซตแนวตั้ง",
  T_46_META_WS_P_VEST: "เสื้อเกราะ",
  T_46_META_WS_P_VFXTEXTURETYPE: "ประเภทของเอฟเฟ็กต์เท็กเจอร์",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "ข้อจำกัดของมุมมอง",
  T_46_META_WS_P_VISIBILITYLAYER: "เลเยอร์ที่มองเห็นได้ (0~15)",
  T_46_META_WS_P_VISIBLE: "มองเห็นได้หรือไม่",
  T_46_META_WS_P_VISIBLEONBACK: "สามารถมองเห็นได้เมื่ออยู่บนหลัง",
  T_46_META_WS_P_VISIBLEPLAYERS: "ผู้เล่นสามารถมองเห็นได้",
  T_46_META_WS_P_VOLUME: "ปริมาณ/เสียง",
  T_46_META_WS_P_WALLETID: "รหัสกระเป๋าตัง",
  T_46_META_WS_P_WANDERRANGE: "ระยะของการเดินสุ่ม",
  T_46_META_WS_P_WAVECOUNT: "จำนวนคลื่น",
  T_46_META_WS_P_WAVEINTERVAL: "ช่วงของคลื่น",
  T_46_META_WS_P_WEAPONDAMAGERATE: "ตัวคูณความเสียหายอาวุธ",
  T_46_META_WS_P_WEAPONSKINIDS: "รหัสสกินปืน",
  T_46_META_WS_P_WEAPONSUBTYPE: "ประเภทย่อยของอาวุธ",
  T_46_META_WS_P_WEAPONTYPE: "ประเภทอาวุธ",
  T_46_META_WS_P_WIDTH: "ความกว้าง",
  T_46_META_WS_P_WINMVPS: "รายชื่อ MVP ที่ชนะ",
  T_46_META_WS_P_WINTEXT: "ข้อความสำหรับชนะ",
  T_46_META_WS_P_WORDWRAP: "การตัดบรรทัดอัตโนมัติ",
  T_46_META_WS_P_WORLDPOSITION: "พิกัดโลก",
  T_46_META_WS_P_YAW: "มุมแนวนอน",
  T_46_META_WS_PATROLALONG: "ลาดตระเวนตาม",
  T_46_META_WS_PATROLTO: "ตระเวนไป",
  T_46_META_WS_PAUSE: "หยุดชั่วคราว",
  T_46_META_WS_PAUSEEMOTE: "หยุดการกระทำชั่วคราว",
  T_46_META_WS_PAUSEFIXEDUPDATE: "หยุดการอัปเดตเฟรมคงที่ชั่วคราว",
  T_46_META_WS_PHASE: "ช่วง",
  T_46_META_WS_PLAY: "เล่น",
  T_46_META_WS_PLAYANIMATION: "เล่นแอนิเมชั่น",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "เล่นคลิปแอนิเมชั่นตัวละคร",
  T_46_META_WS_PLAYEMOTE: "เล่นท่าทาง",
  T_46_META_WS_PLAYER: "ผู้เล่น",
  T_46_META_WS_PORTAL: "พอร์ทัล",
  T_46_META_WS_POSE: "ท่าโพส",
  T_46_META_WS_POSITION: "ที่ตั้ง",
  T_46_META_WS_PREPOSE: "ท่าโพสก่อน",
  T_46_META_WS_PROFANITYFILTER: "ตัวกรองคำสกปรก",
  T_46_META_WS_PURSUITTARGET: "ไล่ล่าเป้าหมาย",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "ควอเทอร์เนียนเป็นมุมแกน",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "ควอเทอร์เนียนเป็นมุมออยเลอร์",
  T_46_META_WS_QUITCHATCHANNEL: "ผู้เล่นออกจากช่อง",
  T_46_META_WS_QUITFACTION: "ลาออกจากฝ่าย",
  T_46_META_WS_QUITGAME: "ออกจากเกม",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "ออกจาก JailBreakMiniGame",
  T_46_META_WS_RANDOMFLOAT: "ทศนิยมสุ่ม",
  T_46_META_WS_RANDOMINT: "จำนวนเต็มสุ่ม",
  T_46_META_WS_RANK: "การจัดอันดับ",
  T_46_META_WS_READCSV: "อ่าน CSV",
  T_46_META_WS_READCSVCELL: "อ่านตาราง CSV",
  T_46_META_WS_READCSVCELLBYNAME: "อ่านตาราง CSV โดยชื่อ",
  T_46_META_WS_READCSVCELLFROMSERVER: "อ่านตาราง CSV จากเซิร์ฟเวอร์",
  T_46_META_WS_READCSVCOLUMN: "อ่านแถวแนวตั้งตาราง CSV",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "อ่านแถวแนวตั้งตาราง CSV จากเซิร์ฟเวอร์",
  T_46_META_WS_READCSVFROMSERVER: "อ่านตาราง CSV จากเชริฟเวอร์",
  T_46_META_WS_READCSVROW: "อ่านแถวแนวนอนตาราง CSV",
  T_46_META_WS_READCSVROWBYKEY: "อ่านแถวแนวนอนตาราง CSV โดยคีย์",
  T_46_META_WS_READCSVROWFROMSERVER: "อ่านแถวแนวนอนตาราง CSV จากเชริฟเวอร์",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "อ่านค่าจากที่เก็บข้อมูลสะสม",
  T_46_META_WS_READFROMDATASTORE: "อ่านค่าจากที่เก็บข้อมูล",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "อ่านค่าตารางอันดับในที่เก็บข้อมูล",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "อ่านค่าตารางการจัดอันดับในที่เก็บข้อมูลตามช่วงการจัดอันดับ",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "ลบการติดตามพิเศษของ AOI",
  T_46_META_WS_REMOVEBACKPACKSKIN: "ลบสกินกระเป๋าเป้สะพายหลัง",
  T_46_META_WS_REMOVEBUFF: "ลบบัฟ",
  T_46_META_WS_REMOVECOMPONENT: "ลบส่วนประกอบ",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "ลบปัจจัยแอตตริบิวต์ของสูตรออก",
  T_46_META_WS_REMOVEOUTFIT: "ถอดเสื้อผ้า",
  T_46_META_WS_REMOVESCRIPT: "ลบสคริปต์",
  T_46_META_WS_REMOVEVEHICLESKIN: "ถอดสกินออก",
  T_46_META_WS_REMOVEWEAPONSKIN: "ถอดสกินปืนออก",
  T_46_META_WS_REPLACE: "แทนที่",
  T_46_META_WS_REQUESTMATCHMAKING: "ขอการแข่งขัน",
  T_46_META_WS_RESET: "รีเซต",
  T_46_META_WS_RESETBACKPACKSKIN: "รีเซตสกินเป้สะพายหลัง",
  T_46_META_WS_RESETDYEING: "รีเซตการย้อมสี",
  T_46_META_WS_RESETJERSEY: "รีเซตเสื้อเจอซี่",
  T_46_META_WS_RESETOUTFIT: "รีเซตเสื้อผ้า",
  T_46_META_WS_RESETVEHICLESKIN: "รีเซตสกินยานพาหนะ",
  T_46_META_WS_RESETWEAPONSKIN: "รีเซตสกินอาวุธ",
  T_46_META_WS_RESUMEFIXEDUPDATE: "ดำเนินการอัปเดตเฟรมคงที่ต่อ (Fixed Update)",
  T_46_META_WS_REVERSE: "ย้อนกลับ",
  T_46_META_WS_REVIVALSOURCE: "แหล่งที่มาของการฟื้นคืนชีพ",
  T_46_META_WS_REVIVE: "การฟื้นคืนชีพ",
  T_46_META_WS_ROUND: "การปัดเศษ",
  T_46_META_WS_ROUNDINDEX: "ดัชนีกลม",
  T_46_META_WS_SAMPLEONCURVE: "ตัวอย่างบน Curve",
  T_46_META_WS_SCENENAME: "ชื่อฉาก",
  T_46_META_WS_SCORE: "คะแนน",
  T_46_META_WS_SCORER: "ผู้ทำคะแนน",
  T_46_META_WS_SCORETYPE: "ประเภทคะแนน",
  T_46_META_WS_SCREENMULTIRAYCAST: "เรย์แคสต์หลายอันจากหน้าจอ",
  T_46_META_WS_SCREENSINGLERAYCAST: "เรย์แคสต์อันเดียวจากหน้าจอ",
  T_46_META_WS_SCREENTOUCHRAY: "เรย์แคสต์ผ่านการสัมผัสหน้าจอ",
  T_46_META_WS_SCREENTOWORLDPOINT: "แปลงพิกัดหน้าจอเป็นพิกัดโลก",
  T_46_META_WS_SENDEVENT: "ส่งเหตุการณ์",
  T_46_META_WS_SETACTIVE: "ตั้งให้ใช้งาน",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "ตั้งค่าสถานะการเคลื่อนไหวของผู้เล่นทุกคน",
  T_46_META_WS_SETATTACKABLEENTITY: "ตั้งเอนทิตี้ที่สามารถโจมตีได้",
  T_46_META_WS_SETATTACKABLEFACTION: "ตั้งฝ่ายที่สามารถโจมตีได้",
  T_46_META_WS_SETATTACKABLETEAM: "ตั้งทีมที่สามารถโจมตีได้",
  T_46_META_WS_SETBACKPACKSKIN: "ตั้งสกินกระเป๋าเป้",
  T_46_META_WS_SETBEHAVIORSTATUS: "ตั้งค่าสถานะพฤติกรรม",
  T_46_META_WS_SETBLACKBOARDVALUE: "ตั้งค่าตัวแปรกระดานดำ",
  T_46_META_WS_SETBUNDLE: "ตั้งแพ็คเก็จ",
  T_46_META_WS_SETCAMERAFOCUS: "ตั้งโฟกัสของกล้อง",
  T_46_META_WS_SETCAMERAFOLLOW: "ตั้งการติดตามของกล้อง",
  T_46_META_WS_SETCHARACTER: "ตั้งตัวละคร",
  T_46_META_WS_SETCULLINGMASK: "ตั้งคัลลิงมาสก์",
  T_46_META_WS_SETCULLINGMASKLAYER: "ตั้งเลเยอร์ของคัลลิงมาสก์",
  T_46_META_WS_SETDEFAULTUISTATUS: "ตั้งค่าสถานะ UI เริ่มต้น",
  T_46_META_WS_SETDROPSTATUS: "ตั้งสถานะการดรอป",
  T_46_META_WS_SETFALLINGDAMAGE: "ตั้งความเสียหายจากการตก",
  T_46_META_WS_SETFOOTBALLPOSITION: "ตั้งตำแหน่งฟุตบอล",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "กำหนดคุณสมบัติตามสูตร",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "ปรับเปลี่ยนคุณสมบัติของสูตร",
  T_46_META_WS_SETFORWARD: "ตั้งข้างหน้า",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "ตั้งค่าเกณฑ์การนอนหลับโดยรวม",
  T_46_META_WS_SETINVINCIBILITY: "ตั้งอมตะ",
  T_46_META_WS_SETJERSEY: "เสื้อเจอซี่",
  T_46_META_WS_SETOUTFIT: "ตั้งเครื่องแต่งกาย",
  T_46_META_WS_SETPARENT: "ตั้งค่าโหนดหลัก",
  T_46_META_WS_SETPARENTCLIENT: "ตั้งค่าโหนดหลักของเอนทิตีวัตถุ",
  T_46_META_WS_SETPICKUPSTATUS: "ตั้งค่าสถานะการรับ",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "ตั้งค่าสถานะการแชทด่วนของผู้เล่น",
  T_46_META_WS_SETPLAYERVOICESTATUS: "ตั้งค่าสถานะการแชทด้วยเสียงของผู้เล่น",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "ตั้งค่าคุณสมบัติเอนทิตี (เรียบ)",
  T_46_META_WS_SETSKILLS: "กำหนดทักษะ",
  T_46_META_WS_SETSKYBOX: "ตั้งกล่องท้องฟ้า",
  T_46_META_WS_SETSLEEPTHRESHOLD: "กำหนดเกณฑ์การนอนหลับ",
  T_46_META_WS_SETSPECIALITEMSTATUS: "กำหนดสถานะรายการพิเศษ",
  T_46_META_WS_SETVEHICLESKIN: "ตั้งสกินยานพาหนะ",
  T_46_META_WS_SETWEAPONSKIN: "ตั้งสกินอาวุธ",
  T_46_META_WS_SETWIDGETPARENT: "ตั้งค่าโหนดหลักของวิดเจ็ต",
  T_46_META_WS_SHOPITEM: "ไอเทมในร้านค้า",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "แสดงกลุ่มลักษณะภายนอก",
  T_46_META_WS_SHUFFLE: "สับเปลี่ยน",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "เรย์แคสต์เดี่ยว",
  T_46_META_WS_SKILL: "ทักษะ",
  T_46_META_WS_SLEEP: "นอนหลับ",
  T_46_META_WS_SLERPQUATERNION: "Slerp ควอเทอเนียน",
  T_46_META_WS_SPAWNABLES: "สามารถเกิด/สร้างได้",
  T_46_META_WS_SPAWNEDITEM: "ไอเทมที่เกิด/สร้างมา",
  T_46_META_WS_SPAWNNEXTWAVE: "เกิดในละลอกถัดไป",
  T_46_META_WS_SPHERECAST: "สร้างแคสต์ทรงกลม",
  T_46_META_WS_SPHEREOVERLAP: "การตรวจจับการทับซ้อนกันของทรงกลม",
  T_46_META_WS_SPLIT: "ตัดแบ่ง",
  T_46_META_WS_SQRT: "รากที่สอง",
  T_46_META_WS_STARTPARACHUTE: "เริ่มกระโดดร่ม",
  T_46_META_WS_STARTPOSITION: "ตำแหน่งเริ่มต้น",
  T_46_META_WS_STATENAME: "ชื่อสถานะ",
  T_46_META_WS_STATUS: "สถานะ",
  T_46_META_WS_STRINGTOFLOAT: "แปลงสตริงให้เป็นตัวเลขทศนิยม",
  T_46_META_WS_STRINGTOINT: "แปลงสตริงเป็นจำนวนเต็ม",
  T_46_META_WS_STRIP: "ลบอักขระช่องว่างออกจากทั้งสองด้านของสตริง",
  T_46_META_WS_SUB: "การสกัดกั้นสตริง",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "สลับผู้สังเกตการณ์พร็อกซี AOI",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "สลับกลุ่มลักษณะภายนอก",
  T_46_META_WS_SWITCHAREA: "สลับพื้นที่",
  T_46_META_WS_SWITCHCAMERA: "สลับกล้อง",
  T_46_META_WS_SWITCHPHASE: "สลับช่วง",
  T_46_META_WS_SWITCHSCENE: "สลับฉาก",
  T_46_META_WS_SWITCHWEAPON: "สลับอาวุธ",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "เป้าหมาย",
  T_46_META_WS_TEAM: "ทีม",
  T_46_META_WS_TELEPORT: "เทเลพอต",
  T_46_META_WS_TELEPORTCCT: "เทเลพอต CCT",
  T_46_META_WS_TEXT: "เนื้อหาข้อความ",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "เวลาประทับเป็นตัวอักษรที่แปลแล้ว",
  T_46_META_WS_TIRE: "ยางรถ",
  T_46_META_WS_TOLOWER: "แปลงเป็นตัวพิมพ์เล็ก",
  T_46_META_WS_TOSTRING: "แปลงเป็นสตริง",
  T_46_META_WS_TOUPPER: "แปลงเป็นตัวพิมพ์ใหญ่",
  T_46_META_WS_TRANSFERMONEY: "สกุลเงินการซื้อขาย",
  T_46_META_WS_TRIGGER: "ทริกเกอร์",
  T_46_META_WS_TYPEIS: "ประเภทมีความสอดคล้องกันหรือไม่?",
  T_46_META_WS_UNLOADSCENE: "ถอนการติดตั้งฉาก",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "อัปเดต JailBreakMission",
  T_46_META_WS_UPLOADGAMERESULT: "อัปโหลดผลลัพธ์เกม",
  T_46_META_WS_VALUE: "ความเสียหาย",
  T_46_META_WS_VECTOR2ANGLE: "มุมเวกเตอร์สอง",
  T_46_META_WS_VECTOR2DISTANCE: "ระยะห่างเวกเตอร์สอง",
  T_46_META_WS_VECTOR2DOT: "ผลคูณดอทเวกเตอร์สอง",
  T_46_META_WS_VECTOR2MAGNITUDE: "ขนาดเวกเตอร์สอง",
  T_46_META_WS_VECTOR2NORMALIZE: "การทำให้เวกเตอร์สองเป็นมาตรฐาน",
  T_46_META_WS_VECTOR2REFLECT: "การสะท้อนของเวกเตอร์สอง",
  T_46_META_WS_VECTOR2TOVECTOR3: "แปลงเวกเตอร์สองมิติเป็นเวกเตอร์สาม",
  T_46_META_WS_VECTOR3REFLECT: "ภาพสะท้อนของเวกเตอร์สาม",
  T_46_META_WS_VECTOR3TOVECTOR2: "แปลงเวกเตอร์สามมิติเป็นเวกเตอร์สาม",
  T_46_META_WS_VEHICLE: "ยานพาหนะ",
  T_46_META_WS_VELOCITY: "ความเร็ว",
  T_46_META_WS_WAITFORMILESECOND: "รอเป็นมิลิวินาที",
  T_46_META_WS_WAITFORNEXTFRAME: "รอจนถึงเฟรมถัดไป",
  T_46_META_WS_WAKEUP: "ตื่น",
  T_46_META_WS_WAVES: "คลื่น",
  T_46_META_WS_WEAPON: "อาวุธ",
  T_46_META_WS_WORLDTOSCREENPOINT: "แปลงพิกัดโลกเป็นพิกัดหน้าจอ",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "เขียนค่าชดเชยตารางที่เก็บสะสม",
  T_46_META_WS_WRITETODATASTORE: "เขียนค่าตารางที่เก็บข้อมูล",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "เขียนค่าของตารางอันดับลงในที่เก็บข้อมูล",
  T_48_META_API_1_D: "รับผู้เล่นทั้งหมดในเกมปัจจุบันและกลับสู่รายชื่อผู้เล่น",
  T_48_META_API_1_R_D: "รายชื่อผู้เล่น",
  T_48_META_API_10_D: "รับวัตถุฉาก",
  T_48_META_API_10_P0_D: "ประเภทของวัตถุฉากที่จะกรอง",
  T_48_META_API_10_R_D: "รายการวัตถุฉาก",
  T_48_META_API_100_D: "การโหลดฉากจะไม่ยกเลิกการโหลดฉากที่โหลดไปแล้วโดยอัตโนมัติ",
  T_48_META_API_100_P0_D: "รหัสฉากที่จะโหลด",
  T_48_META_API_10000_D: "ส่งคืนเอนทิตีที่ถูกผูกไว้กับสคริปต์ปัจจุบัน",
  T_48_META_API_10000_R_D: "เอนทิตีเชื่อมโยงกับสคริปต์ปัจจุบัน",
  T_48_META_API_10001_D: "ใช้รหัสเอนทิตีเพื่อค้นหาเอนทิตีที่เกี่ยวข้อง API นี้ใช้โดยผู้แก้ไขเท่านั้น การใช้ API นี้ในฝั่งผู้ใช้ไม่สามารถรับประกันความเข้ากันได้ เช่น การลบออกหรือการปรับเปลี่ยน",
  T_48_META_API_10001_P0_D: "รหัสเอนทิตีเป้าหมาย",
  T_48_META_API_10001_R_D: "เอนทิตี",
  T_48_META_API_10002_D: "รับเอนทิตีระดับโลกของเกม",
  T_48_META_API_10002_R_D: "เอนทิตีระดับโลก",
  T_48_META_API_10003_D: "เทเลพอร์ตผู้เล่นไปยังพิกัดเฉพาะ (ล้าสมัย โปรดใช้เทเลพอร์ต)",
  T_48_META_API_10003_P0_D: "ผู้เล่นเทเลพอร์ต",
  T_48_META_API_10003_P1_D: "พิกัดของจุดเคลื่อนย้าย",
  T_48_META_API_10004_D: "รับตำแหน่งใกล้เพื่อนร่วมทีมและหลีกเลี่ยงตำแหน่งผู้เล่นที่ไม่สามารถยืนได้ (ล้าสมัย โปรดใช้ GetTeammateNearPosition)",
  T_48_META_API_10004_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_10004_R_D: "พิกัดใกล้เพื่อนร่วมทีม",
  T_48_META_API_10005_D: "รับผู้เล่นที่เป็นเจ้าของเอนทิตี",
  T_48_META_API_10005_P0_D: "เอนทิตีเป้าหมาย เอนทิตีจะถูกซิงโครไนซ์กับผู้เล่นที่เป็นของมันเท่านั้น",
  T_48_META_API_10005_R_D: "ผู้เล่นที่เป็นเจ้าของเอนทิตีเป้าหมาย",
  T_48_META_API_10006_D: "ทำให้ผู้เล่นอยู่ยงคงกระพัน",
  T_48_META_API_10006_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_10006_P1_D: "ระยะเวลาของเอฟเฟกต์การอยู่ยงคงกระพัน หน่วยเป็นวินาที",
  T_48_META_API_10007_D: "โคลนเอนทิตีที่เลือกและคุณสมบัติทั้งหมดในตำแหน่งดั้งเดิม",
  T_48_META_API_10007_P0_D: "สร้างเอนทิตีแล้ว",
  T_48_META_API_10007_P1_D: "เอนทิตีที่จะโคลน",
  T_48_META_API_10008_D: "สร้างความเสียหายให้กับผู้เล่น หากไม่มีการเลือกแหล่งความเสียหาย เป้าหมายจะได้รับความเสียหายจากระบบ",
  T_48_META_API_10008_P0_D: "เอนทิตีเกมเสียหาย",
  T_48_META_API_10008_P1_D: "เอนทิตีเกมที่สร้างความเสียหาย",
  T_48_META_API_10008_P2_D: "ประเภทความเสียหาย",
  T_48_META_API_10008_P3_D: "ความเสียหาย",
  T_48_META_API_10009_D: "การฟื้นคืนชีพของผู้เล่นที่ได้รับมอบหมาย",
  T_48_META_API_10009_P0_D: "ผู้เล่นที่ฟื้นคืนชีพ",
  T_48_META_API_1001_D: "หากตรงตามเงื่อนไข โหนดภายใต้ IF จะถูกรัน เมื่อไม่ตรงตามเงื่อนไข หากมี ELSE ให้รันโหนดที่อยู่ด้านล่าง ELSE หรือปิดท้ายคำสั่ง IF",
  T_48_META_API_1001_P0_D: "รายการเงื่อนไขจะต้องสอดคล้องกับจำนวนรายการกระบวนการย่อย (รายการสาขาเชิงตรรกะ)",
  T_48_META_API_10010_D: "สร้างรายการหรือรายการสินค้าในตำแหน่งที่ระบุ",
  T_48_META_API_10010_P0_D: "สถานที่สร้างรายการ",
  T_48_META_API_10010_P1_D: "สร้างรายการหรือรายการของรายการ",
  T_48_META_API_10010_P2_D: "จำนวนรายการที่สร้างขึ้น เมื่อสร้างรายการสินค้า คุณจะต้องกรอกรายการปริมาณสินค้าตามลำดับของรายการสินค้า",
  T_48_META_API_10011_D: "เอนทิตี AI ลาดตระเวนไปยังจุดเป้าหมาย",
  T_48_META_API_10011_P0_D: "เอนทิตี AI เป้าหมาย",
  T_48_META_API_10011_P1_D: "ย้ายจุดเป้าหมาย",
  T_48_META_API_10011_P2_D: "ไม่ว่าจะกลับไปสู่จุดเริ่มต้น",
  T_48_META_API_10011_P3_D: "ไม่ว่าจะตรวจจับและโจมตีเป้าหมายศัตรูขณะลาดตระเวน",
  T_48_META_API_10012_D: "หน่วยงาน AI ลาดตระเวนตามลำดับตามรายการพิกัด",
  T_48_META_API_10012_P0_D: "เอนทิตี AI เป้าหมาย",
  T_48_META_API_10012_P1_D: "การย้ายรายการจุดพิกัด",
  T_48_META_API_10012_P2_D: "ประเภทลาดตระเวน สามารถเลือกแบบเที่ยวเดียว ไปกลับ หรือรอบก็ได้",
  T_48_META_API_10012_P3_D: "ไม่ว่าจะตรวจจับและโจมตีเป้าหมายศัตรูขณะลาดตระเวน",
  T_48_META_API_10013_D: "ตัวสร้างจะรีเฟรชคลื่นลูกถัดไปของเอนทิตีหน่วยทันที",
  T_48_META_API_10013_P0_D: "เอนทิตีเครื่องกำเนิดไฟฟ้า",
  T_48_META_API_10014_D: "เพิ่มปัจจัยการคำนวณสำหรับคุณลักษณะที่คำนวณได้จะคำนวณผลลัพธ์สุดท้ายผ่านสูตรที่ประกอบด้วยปัจจัยต่างๆ",
  T_48_META_API_10014_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10014_P1_D: "ประเภทคุณสมบัติที่คำนวณได้",
  T_48_META_API_10014_P2_D: "คำนวณประเภทปัจจัย",
  T_48_META_API_10014_P3_D: "คำนวณค่าตัวประกอบ",
  T_48_META_API_10015_D: "ล้างปัจจัยการคำนวณสำหรับคุณสมบัติที่คำนวณได้",
  T_48_META_API_10015_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10015_P1_D: "ประเภทคุณสมบัติที่คำนวณได้",
  T_48_META_API_10016_D: "ล้างปัจจัยจากการคำนวณทั้งหมดสำหรับคุณสมบัติจากการคำนวณทั้งหมดของเอนทิตีเป้าหมาย",
  T_48_META_API_10016_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10017_D: "ปรับเปลี่ยนคุณสมบัติ",
  T_48_META_API_10017_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10017_P1_D: "ประเภททรัพย์สิน",
  T_48_META_API_10017_P2_D: "วิธีการแก้ไข",
  T_48_META_API_10017_P3_D: "ค่า",
  T_48_META_API_10018_D: "ตั้งค่าของคุณสมบัติที่คำนวณ",
  T_48_META_API_10018_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10018_P1_D: "ประเภททรัพย์สิน",
  T_48_META_API_10018_P2_D: "ค่า",
  T_48_META_API_10019_D: "ล้างการปรับเปลี่ยนคุณสมบัติที่คำนวณเพียงครั้งเดียว",
  T_48_META_API_10019_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10019_P1_D: "ประเภททรัพย์สิน",
  T_48_META_API_1002_D: "พารามิเตอร์ i เริ่มต้นจากค่าต่ำสุด และทุกครั้งที่รันโหนดล่าง ฉันจะเพิ่มค่าขั้นตอนจนกว่า i มากกว่าหรือเท่ากับค่าสูงสุด",
  T_48_META_API_1002_P0_D: "ชื่อของดัชนีลูป ซึ่งสามารถใช้เพื่อรับค่าดัชนีลูปบนตัวแปรโลคัล",
  T_48_META_API_1002_P1_D: "ค่าเริ่มต้นของลูป",
  T_48_META_API_1002_P2_D: "ค่าสิ้นสุดของลูป",
  T_48_META_API_1002_P3_D: "ขนาดขั้นตอนของลูป เมื่อค่าเริ่มต้นน้อยกว่าค่าสิ้นสุด ขนาดขั้นตอนควรมากกว่า 0 เมื่อค่าเริ่มต้นมากกว่าค่าสิ้นสุด ขนาดขั้นตอนควรน้อยกว่า 0",
  T_48_META_API_10020_D: "รับเอนทิตีทั้งหมดในเกมที่ตรงตามเงื่อนไขตัวกรอง",
  T_48_META_API_10020_P0_D: "ผลลัพธ์ตัวกรองจะต้องมีประเภทที่ป้อนในพารามิเตอร์นี้",
  T_48_META_API_10020_P1_D: "ผลลัพธ์ตัวกรองต้องไม่มีประเภทที่ป้อนในพารามิเตอร์นี้",
  T_48_META_API_10020_P2_D: "ผลลัพธ์ของตัวกรองมีอย่างน้อยหนึ่งประเภทที่ป้อนในพารามิเตอร์นี้",
  T_48_META_API_10020_R_D: "กรองรายการเอนทิตีผลลัพธ์",
  T_48_META_API_10021_D: "เพิ่มความเร็วให้กับลูกฟุตบอล ความเร็วจะเปลี่ยนไปเนื่องจากการเร่งความเร็วในทิศทางเดียวกัน",
  T_48_META_API_10021_P0_D: "ฟุตบอลเป้าหมาย",
  T_48_META_API_10021_P1_D: "เพิ่มความเร็วอวกาศ 3 มิติ",
  T_48_META_API_10022_D: "ทำลายเอนทิตีที่ระบุ",
  T_48_META_API_10022_P0_D: "เอนทิตีเป้าหมายที่จะถูกทำลาย",
  T_48_META_API_10023_D: "เพิ่มแท็กให้กับเอนทิตี",
  T_48_META_API_10023_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10023_P1_D: "ป้ายกำกับที่กำหนดเอง",
  T_48_META_API_10024_D: "ลบป้ายกำกับออกจากเอนทิตี",
  T_48_META_API_10024_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10024_P1_D: "ป้ายกำกับที่กำหนดเอง",
  T_48_META_API_10025_D: "ตรวจสอบว่าเอนทิตีเป้าหมายมีแท็กที่ระบุหรือไม่",
  T_48_META_API_10025_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10025_P1_D: "ป้ายกำกับที่กำหนดเอง",
  T_48_META_API_10025_R_D: "ไม่ว่าจะรวมแท็กที่ระบุหรือไม่",
  T_48_META_API_10026_D: "กำหนดตำแหน่งฟุตบอล",
  T_48_META_API_10026_P0_D: "เอนทิตีฟุตบอล",
  T_48_META_API_10026_P1_D: "ที่ตั้ง",
  T_48_META_API_10026_P2_D: "รักษาความเร็ว",
  T_48_META_API_10027_D: "รับเอนทิตีกล้องที่ผู้เล่นเป้าหมายใช้อยู่ในปัจจุบัน",
  T_48_META_API_10027_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_10027_R_D: "เอนทิตีกล้องที่ใช้อยู่ในปัจจุบัน",
  T_48_META_API_10028_D: "เปลี่ยนกล้องของผู้เล่นเป้าหมายเป็นกล้องเป้าหมาย",
  T_48_META_API_10028_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_10028_P1_D: "กล้องเป้าหมาย",
  T_48_META_API_10028_P2_D: "โหมดการสลับคุณสามารถเลือกที่จะเก็บตรรกะดั้งเดิมหรือแบบก้าวหน้าได้",
  T_48_META_API_10028_P3_D: "เวลาในการสลับคือเวลาในการสลับกล้องในโหมดโปรเกรสซีฟ",
  T_48_META_API_10029_D: "สร้างกล้อง",
  T_48_META_API_10029_P0_D: "สร้างประเภทกล้องแล้ว",
  T_48_META_API_10029_P1_D: "สร้างเอนทิตีกล้อง",
  T_48_META_API_1003_D: "ใช้การข้ามผ่านคอนเทนเนอร์ข้อมูล รับแต่ละองค์ประกอบย่อย และมีกระบวนการย่อย",
  T_48_META_API_1003_P0_D: "ข้ามไปยังชื่อขององค์ประกอบลูก คุณสามารถใช้เพื่อรับค่าองค์ประกอบลูกในตัวแปรท้องถิ่น",
  T_48_META_API_1003_P1_D: "ชื่อของดัชนีลูป ซึ่งสามารถใช้เพื่อรับค่าดัชนีลูปบนตัวแปรโลคัล",
  T_48_META_API_1003_P2_D: "ที่เก็บข้อมูลที่จะสำรวจในปัจจุบันรองรับประเภทต่อไปนี้: ประเภทอาร์เรย์",
  T_48_META_API_10030_D: "ฆ่าหน่วยงานที่สามารถต่อสู้ได้",
  T_48_META_API_10030_P0_D: "เอนทิตีเป้าหมาย จะต้องเป็นเอนทิตีที่สามารถต่อสู้ได้",
  T_48_META_API_10031_D: "ตั้งค่าสถานะกิจกรรมของเอนทิตีเป้าหมายและโหนดย่อย ความพร้อมใช้งาน การมองเห็น การชนกัน ฯลฯ ของออบเจ็กต์ที่ไม่ได้ใช้งานจะถูกปิด",
  T_48_META_API_10031_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10031_P1_D: "มันใช้งานอยู่หรือไม่?",
  T_48_META_API_10032_D: "ตั้งค่าตำแหน่งของเอนทิตีกล้องให้ติดตามเอนทิตีเป้าหมายเสมอ",
  T_48_META_API_10032_P0_D: "เอนทิตีกล้องเป้าหมาย",
  T_48_META_API_10032_P1_D: "องค์กรเป้าหมายที่จะปฏิบัติตาม",
  T_48_META_API_10032_P2_D: "ชดเชยจากพิกัดเอนทิตีเป้าหมาย",
  T_48_META_API_10032_P3_D: "ระบบพิกัดออฟเซ็ต",
  T_48_META_API_10033_D: "ตั้งค่าเอนทิตีของกล้องให้หันหน้าเข้าหาเอนทิตีเป้าหมายเสมอ",
  T_48_META_API_10033_P0_D: "เอนทิตีกล้องเป้าหมาย",
  T_48_META_API_10033_P1_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10033_P2_D: "การชดเชยจุดตรึงจากพิกัดเป้าหมาย",
  T_48_META_API_10033_P3_D: "ระบบพิกัดออฟเซ็ต",
  T_48_META_API_10034_D: "สร้าง Tweens",
  T_48_META_API_10034_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10034_P1_D: "รหัสคุณสมบัติ",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "สไตล์",
  T_48_META_API_10034_P5_D: "เส้นโค้ง",
  T_48_META_API_10034_P6_D: "ระยะเวลา",
  T_48_META_API_10034_P7_D: "ทวีเอนทิตี",
  T_48_META_API_10035_D: "ตั้งค่าโหนดพาเรนต์ โดยกำหนดให้ทั้งพาเรนต์และลูกต้องมีคอมโพเนนต์ Transform",
  T_48_META_API_10035_P0_D: "โหนดหลัก",
  T_48_META_API_10035_P1_D: "โหนดลูก",
  T_48_META_API_10035_P2_D: "ว่าจะรักษาตำแหน่งโลกปัจจุบัน การหมุน และการปรับขนาดของโหนดย่อยหรือไม่ รายการนี้ไม่ถูกต้องเมื่อตั้งค่า UI",
  T_48_META_API_10036_D: "NewCurve (เลิกใช้แล้ว โปรดใช้ CreateTweenCurve)",
  T_48_META_API_10036_P0_D: "จุดควบคุม",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "ความพยายามที่จะเล่นเอนทิตีเป้าหมายซึ่งจะต้องมีองค์ประกอบที่สามารถเล่นได้",
  T_48_META_API_10037_P0_D: "เป้าหมายเอนทิตีที่สามารถเล่นได้",
  T_48_META_API_10037_P1_D: `ไม่ว่าจะเล่นซ้ำ
จริง: เล่นซ้ำ
เท็จ: เล่นต่อ`,
  T_48_META_API_10038_D: "หยุดเอนทิตีที่สามารถเล่นได้ชั่วคราว",
  T_48_META_API_10038_P0_D: "เป้าหมายเอนทิตีที่สามารถเล่นได้",
  T_48_META_API_10039_D: "สร้างการเคลื่อนที่แบบ ballistic ซึ่งจะทำให้เอนทิตีเป้าหมายมีความเร็วเริ่มต้นและความเร่งตามทิศทาง",
  T_48_META_API_10039_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10039_P1_D: "ความเร็วเริ่มต้นของการเคลื่อนที่",
  T_48_META_API_10039_P2_D: "ความเร่งการเคลื่อนไหว",
  T_48_META_API_10039_P3_D: "ระยะการเคลื่อนที่สูงสุด",
  T_48_META_API_10039_P4_D: "สร้างเอนทิตีการเคลื่อนที่แบบขีปนาวุธ",
  T_48_META_API_10039_P5_D: "จะเริ่มเล่นโดยอัตโนมัติหลังจากสร้างหรือไม่",
  T_48_META_API_1004_D: "ขัดจังหวะกระบวนการลูปปัจจุบันและออกจากลูป",
  T_48_META_API_10040_D: "สร้างตำแหน่งตามการเคลื่อนไหว เอนทิตีเป้าหมายจะติดตามการเคลื่อนไหวของวัตถุที่ระบุ",
  T_48_META_API_10040_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10040_P1_D: "เอนทิตีวัตถุที่ติดตามการเคลื่อนไหว",
  T_48_META_API_10040_P2_D: "ระยะทางเป็นไปตามออฟเซ็ตของพิกัดเป้าหมาย",
  T_48_META_API_10040_P3_D: "ระบบพิกัดที่ใช้",
  T_48_META_API_10040_P4_D: "สร้างเอนทิตีการเคลื่อนไหวดังต่อไปนี้",
  T_48_META_API_10040_P5_D: "จะเริ่มเล่นโดยอัตโนมัติหลังจากสร้างหรือไม่",
  T_48_META_API_10041_D: "สร้างการเคลื่อนไหวแบบจ้องมองโดยที่เอนทิตีเป้าหมายจะยังคงหันหน้าไปทางวัตถุที่ระบุ",
  T_48_META_API_10041_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10041_P1_D: "เอนทิตีวัตถุที่กำลังถูกจับตามอง",
  T_48_META_API_10041_P2_D: "การชดเชยจุดจ้องมองจากเอนทิตีวัตถุ",
  T_48_META_API_10041_P3_D: "ระบบพิกัดที่ใช้",
  T_48_META_API_10041_P4_D: "สร้างเอนทิตีการเคลื่อนไหวตามการจ้องมอง",
  T_48_META_API_10041_P5_D: "จะเริ่มเล่นโดยอัตโนมัติหลังจากสร้างหรือไม่",
  T_48_META_API_10042_D: "เลิกใช้แล้ว",
  T_48_META_API_10042_P0_D: "เอนทิตีผู้เล่น",
  T_48_META_API_10042_P1_D: "ผลการแข่งขัน",
  T_48_META_API_10042_P2_D: "เลิกใช้แล้ว",
  T_48_META_API_10042_P3_D: "เลิกใช้แล้ว",
  T_48_META_API_10042_P4_D: "เลิกใช้แล้ว",
  T_48_META_API_10043_D: "ตั้งค่าคุณสมบัติของเอนทิตีเป้าหมายอย่างราบรื่น คุณสมบัติจะเปลี่ยนแปลงทันที แต่ไคลเอนต์จะเล่นประสิทธิภาพการเปลี่ยนแปลงที่ราบรื่น",
  T_48_META_API_10043_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_10043_P1_D: "คุณลักษณะของเอนทิตีเป้าหมาย",
  T_48_META_API_10043_P2_D: "ค่าเป้าหมายจะต้องสอดคล้องกับประเภทที่ต้องการเมื่อมีการกำหนดแอตทริบิวต์",
  T_48_META_API_10044_D: "ทำการตรวจจับรังสีและส่งคืนเอนทิตีแรกในทิศทางของรังสี เอนทิตีการชนจำเป็นต้องมีองค์ประกอบการชนกัน หากกรอกพารามิเตอร์ระดับในช่องว่าง จะสามารถตรวจจับภูมิประเทศได้",
  T_48_META_API_10044_P0_D: "พิกัดตำแหน่งเริ่มต้น",
  T_48_META_API_10044_P1_D: "ทิศทางการตรวจจับรังสี",
  T_48_META_API_10044_P2_D: "ระยะการตรวจจับรังสียอมรับเฉพาะค่าบวกเท่านั้น",
  T_48_META_API_10044_P3_D: "เลเยอร์มาสก์การตรวจจับรังสี เฉพาะระดับที่กรอกเท่านั้นที่จะเข้าร่วมในการสแกน การเว้นว่างไว้หมายความว่าทุกระดับจะมีส่วนร่วมในการสแกน",
  T_48_META_API_10044_P4_D: "เป็นไปได้ไหมที่จะสแกนทริกเกอร์?",
  T_48_META_API_10044_P5_D: "ตีเอนทิตี",
  T_48_META_API_10044_P6_D: "พิกัดจุดชน",
  T_48_META_API_10044_P7_D: "ระยะทางจากจุดปะทะถึงจุดเริ่มต้น",
  T_48_META_API_10044_P8_D: "ตีพื้นผิวปกติ",
  T_48_META_API_10045_D: "ทำการตรวจจับรังสีและส่งคืนเอนทิตีทั้งหมดที่ชนในทิศทางรังสีจากใกล้ไปไกล หากพารามิเตอร์ระดับถูกเติมลงในช่องว่าง จะสามารถตรวจจับภูมิประเทศได้",
  T_48_META_API_10045_P0_D: "พิกัดตำแหน่งเริ่มต้น",
  T_48_META_API_10045_P1_D: "ทิศทางการตรวจจับรังสี",
  T_48_META_API_10045_P2_D: "ระยะการตรวจจับรังสียอมรับเฉพาะค่าบวกเท่านั้น",
  T_48_META_API_10045_P3_D: "เลเยอร์มาสก์ เฉพาะเลเยอร์ที่กรอกแล้วเท่านั้นที่จะเข้าร่วมในการสแกน การเว้นว่างไว้หมายความว่าเลเยอร์ทั้งหมดจะมีส่วนร่วมในการสแกน",
  T_48_META_API_10045_P4_D: "เป็นไปได้ไหมที่จะตรวจจับทริกเกอร์",
  T_48_META_API_10045_P5_D: "รายการเอนทิตีที่ได้รับความนิยม",
  T_48_META_API_10045_P6_D: "รายการยอดฮิต",
  T_48_META_API_10045_P7_D: "ระยะทางจุดเริ่มต้น รายการระยะทางจุดเริ่มต้น",
  T_48_META_API_10045_P8_D: "ตีพื้นผิวปกติ",
  T_48_META_API_10046_D: "สร้างเอนทิตีสำหรับเทมเพลตโดยใช้รูปแบบสำเร็จรูป",
  T_48_META_API_10046_P0_D: "สร้างเอนทิตีแล้ว",
  T_48_META_API_10046_P1_D: "รหัสสำเร็จรูป",
  T_48_META_API_10047_D: "การย้อมสี",
  T_48_META_API_10047_P0_D: "ตั้งค่าวัตถุให้เป็นปกติ",
  T_48_META_API_10047_P1_D: "กำหนดจุดย้อมสี",
  T_48_META_API_10047_P2_D: "สี",
  T_48_META_API_10048_D: "สถานะการย้อมสี",
  T_48_META_API_10048_P0_D: "กำหนดจุดย้อมสี",
  T_48_META_API_10048_P1_D: "กำหนดทิศทาง",
  T_48_META_API_10048_P2_D: "กำหนดระยะทาง",
  T_48_META_API_10048_R_D: "สีDesc",
  T_48_META_API_10049_D: "สถิติการย้อมสี",
  T_48_META_API_10049_P0_D: "สี",
  T_48_META_API_10049_R_D: "ปริมาณการย้อมสี",
  T_48_META_API_1005_D: "ข้ามเนื้อหาลูปที่เหลือและไปที่ลูปถัดไปโดยตรง",
  T_48_META_API_10050_D: "การย้อมสีช่วงระนาบ",
  T_48_META_API_10050_P0_D: "ตั้งค่าวัตถุให้เป็นปกติ",
  T_48_META_API_10050_P1_D: "กำหนดจุดย้อมสี",
  T_48_META_API_10050_P2_D: "กำหนดช่วงการย้อมสี",
  T_48_META_API_10050_P3_D: "สี",
  T_48_META_API_10050_P4_D: "ปริมาณการย้อมสี",
  T_48_META_API_10051_D: "การย้อมสีพื้นที่",
  T_48_META_API_10051_P0_D: "ตั้งค่าวัตถุให้เป็นปกติ",
  T_48_META_API_10051_P1_D: "กำหนดจุดย้อมสี",
  T_48_META_API_10051_P2_D: "กำหนดช่วงการย้อมสี",
  T_48_META_API_10051_P3_D: "สี",
  T_48_META_API_10051_P4_D: "แก้ไขพื้นที่เปื้อน",
  T_48_META_API_10051_P5_D: "ค่าสัมประสิทธิ์สุ่ม",
  T_48_META_API_10051_P6_D: "ค่าสัมประสิทธิ์การลดทอนแบบสุ่ม",
  T_48_META_API_10051_P7_D: "ปริมาณการย้อมสี",
  T_48_META_API_10052_D: "รับโหนดย่อยทั้งหมดของเอนทิตีโหนดพาเรนต์เป้าหมาย",
  T_48_META_API_10052_P0_D: "เอนทิตีโหนดพาเรนต์",
  T_48_META_API_10052_R_D: "รายการโหนดย่อย",
  T_48_META_API_10053_D: "รับโหนดลูกที่ระบุของเอนทิตีโหนดหลักเป้าหมายตามดัชนี",
  T_48_META_API_10053_P0_D: "เอนทิตีโหนดพาเรนต์",
  T_48_META_API_10053_P1_D: "ดัชนีโหนดย่อย",
  T_48_META_API_10053_R_D: "เอนทิตีโหนดลูก",
  T_48_META_API_10054_D: "รับโหนดหลักของเอนทิตีโหนดลูกเป้าหมาย",
  T_48_META_API_10054_P0_D: "เอนทิตีโหนดลูก",
  T_48_META_API_10054_R_D: "เอนทิตีโหนดพาเรนต์",
  T_48_META_API_10055_D: "ลบโหนดย่อยทั้งหมดภายใต้เอนทิตีโหนดหลักที่ระบุ โหนดต้องมีคอมโพเนนต์การแปลง",
  T_48_META_API_10055_P0_D: "เอนทิตีโหนดพาเรนต์",
  T_48_META_API_10056_D: "เทเลพอร์ตเป้าหมายไปยังตำแหน่งที่ระบุ",
  T_48_META_API_10056_P0_D: "หน่วยที่กำลังเคลื่อนย้าย",
  T_48_META_API_10056_P1_D: "พิกัดจุดเทเลพอร์ต",
  T_48_META_API_10056_P2_D: "การวางแนวของหน่วยหลังการเคลื่อนย้ายมวลสาร",
  T_48_META_API_10057_D: "หาตำแหน่งใกล้กับเพื่อนร่วมทีมแบบสุ่ม คืนพิกัดใกล้ตัวคุณเมื่อไม่มีเพื่อนร่วมทีม และหลีกเลี่ยงตำแหน่งของผู้เล่นที่ไม่สามารถยืนได้",
  T_48_META_API_10057_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_10057_R_D: "พิกัดใกล้กับเพื่อนร่วมทีมของผู้เล่นเป้าหมาย",
  T_48_META_API_10058_D: "สถานะการย้อมสีที่ชัดเจน",
  T_48_META_API_10059_D: "เล่นเอฟเฟกต์เสียงที่ระบุ หากมีแอตทริบิวต์เพิ่มเติมที่จำเป็นต้องตั้งค่า ให้ตั้งค่าแอตทริบิวต์เอนทิตีผ่านเอนทิตีเพิ่มเติม",
  T_48_META_API_10059_P0_D: "รหัสนี้ใช้เพื่อแสดงชื่อของพารามิเตอร์อย่างเป็นทางการที่สร้างเอนทิตีเอฟเฟกต์เสียง และค่าตัวแปรท้องถิ่นที่สอดคล้องกันคือเอนทิตีที่สร้างเอฟเฟกต์เสียง",
  T_48_META_API_10059_P1_D: "เอนทิตีของผู้เล่นที่เป็นเจ้าของ มีเพียงผู้เล่นรายนี้เท่านั้นที่มองเห็นได้",
  T_48_META_API_10059_P2_D: "ประเภทเอฟเฟกต์เสียง ประเภทของเอฟเฟกต์เสียงที่ผู้เล่นสามารถเลือกได้",
  T_48_META_API_1006_D: "สิ้นสุดกระบวนการดำเนินการปัจจุบันและกลับสู่ตำแหน่งที่โทรโดยตรง คุณสามารถส่งคืนพร้อมข้อมูลได้",
  T_48_META_API_1006_P0_D: "ข้อมูลที่คาดว่าจะส่งคืนไปยังตำแหน่งที่โทร",
  T_48_META_API_10060_D: "เตะผู้เล่นเป้าหมายออกจากเกม",
  T_48_META_API_10060_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_10060_P1_D: "จะแสดงข้อมูลการเรียกเก็บเงินหรือไม่",
  T_48_META_API_10061_D: "ผู้เล่นเป้าหมายร้องขอให้ตรงกับแผนที่ที่ระบุ",
  T_48_META_API_10061_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_10061_P1_D: "รหัสสนามรบ",
  T_48_META_API_10061_P2_D: "หน้าต่างป๊อปอัพแจ้งให้คุณกลับสู่เกมเดิมเมื่อยกเลิกการแข่งขันหรือไม่",
  T_48_META_API_10062_D: "ขัดจังหวะเอนทิตีเอฟเฟกต์เสียงที่เล่น",
  T_48_META_API_10062_P0_D: "เอนทิตีเอฟเฟกต์เสียงที่ต้องหยุดชั่วคราว",
  T_48_META_API_10063_D: "เล่นเอฟเฟกต์เสียงต่อไป คุณสามารถเลือกได้ว่าจะเริ่มเล่นตั้งแต่ต้นหรือไม่",
  T_48_META_API_10063_P0_D: "เอนทิตีเอฟเฟกต์เสียงที่ต้องเล่นต่อหลังจากหยุดชั่วคราว",
  T_48_META_API_10063_P1_D: "ไม่ว่าจะเริ่มต้นใหม่",
  T_48_META_API_10064_D: "สร้าง Airdrop มีสามขั้นตอน: 1. การเตรียมการ 2. การลงจอด 3. การลงจอด แอตทริบิวต์ Airdrop สามารถแก้ไขได้ในสถานะ 1 เท่านั้น",
  T_48_META_API_10064_P0_D: "สร้างเอนทิตีกล่อง Airdrop",
  T_48_META_API_1007_D: "ใช้การวนซ้ำที่ดำเนินการต่อไปโดยขึ้นอยู่กับว่าเงื่อนไขเป็นจริงหรือไม่ จนกว่าเงื่อนไขจะเป็นเท็จและการวนซ้ำสิ้นสุดลง",
  T_48_META_API_1007_P0_D: "เมื่อเงื่อนไขเป็นจริง การวนซ้ำจะดำเนินต่อไป และเมื่อเงื่อนไขเป็นเท็จ การวนซ้ำจะสิ้นสุด",
  T_48_META_API_1008_D: `รอจนกระทั่งจุดเริ่มต้นของเฟรมลอจิคัลถัดไป
บนเซิร์ฟเวอร์ หากเปิดใช้งานโหมดอัตราเฟรมต่ำ การรอจะนานขึ้น
บนไคลเอนต์ เวลารอจะได้รับผลกระทบจากประสิทธิภาพของอุปกรณ์และความซับซ้อนของลอจิกของเฟรมปัจจุบัน
ใช้ API นี้ ฟังก์ชันจำเป็นต้องประกาศแบบอะซิงก์`,
  T_48_META_API_1009_D: "หลังจากรอเป็นระยะเวลาหนึ่ง ฟังก์ชันที่ใช้ API นี้จะต้องได้รับการประกาศเป็นแบบอะซิงก์",
  T_48_META_API_1009_P0_D: "เวลาที่รอคอย มีหน่วยเป็นมิลลิวินาที",
  T_48_META_API_101_D: "ถอนการติดตั้งฉากที่ระบุ",
  T_48_META_API_101_P0_D: "รหัสฉากที่จะถอนการติดตั้ง",
  T_48_META_API_1010: "การโทรกลับเหตุการณ์",
  T_48_META_API_1010_D: "การกระทำที่เกิดขึ้นเมื่อมีเหตุการณ์เกิดขึ้น",
  T_48_META_API_1010_P0: "ชื่อพารามิเตอร์เหตุการณ์",
  T_48_META_API_1010_P0_D: "ชื่อพารามิเตอร์ที่เป็นทางการของพารามิเตอร์เหตุการณ์ ซึ่งสามารถรับค่าพารามิเตอร์จริงบนตัวแปรโลคัลได้",
  T_48_META_API_1011: "บล็อคโค้ด",
  T_48_META_API_1011_D: "บล็อกโค้ดที่มี API รวมกัน",
  T_48_META_API_1011_P0: "ชื่อพารามิเตอร์",
  T_48_META_API_1011_P0_D: "ชื่อพารามิเตอร์ที่เป็นทางการเมื่อบล็อคโค้ดเป็นฟังก์ชันแบบกำหนดเอง",
  T_48_META_API_1012: "ค้นหาและเรียกใช้ API ที่กำหนดเองด้วย Serial",
  T_48_META_API_1012_D: "เรียกใช้ฟังก์ชันแบบกำหนดเองในลักษณะอนุกรม หากมีการรอในฟังก์ชันแบบกำหนดเอง ตำแหน่งที่เรียกก็จะรอเช่นกัน",
  T_48_META_API_1012_P0_D: "เอนทิตีที่มีฟังก์ชันแบบกำหนดเองอยู่",
  T_48_META_API_1012_P1: "รหัสกราฟ",
  T_48_META_API_1012_P1_D: "รหัสสคริปต์ซึ่งมีฟังก์ชันแบบกำหนดเองอยู่",
  T_48_META_API_1012_P2: "รหัสฟังก์ชั่น",
  T_48_META_API_1012_P2_D: "ID ฟังก์ชั่นที่เรียกโดยเป้าหมาย",
  T_48_META_API_1012_P3_D: "รายการอาร์กิวเมนต์ที่ส่งไปยังฟังก์ชันที่กำหนดเอง",
  T_48_META_API_1013: "ค้นหาและเรียกใช้ API แบบกำหนดเองด้วย Parallel",
  T_48_META_API_1013_D: "เรียกใช้ฟังก์ชันแบบกำหนดเองแบบขนาน ไม่ว่าจะมีการรอในฟังก์ชันแบบกำหนดเองหรือไม่ก็ตาม ฟังก์ชันก็จะกลับไปยังตำแหน่งที่เรียกทันทีและดำเนินการต่อไป",
  T_48_META_API_1013_P0_D: "เอนทิตีที่มีฟังก์ชันแบบกำหนดเองอยู่",
  T_48_META_API_1013_P1: "รหัสกราฟ",
  T_48_META_API_1013_P1_D: "รหัสสคริปต์ซึ่งมีฟังก์ชันแบบกำหนดเองอยู่",
  T_48_META_API_1013_P2: "รหัสฟังก์ชั่น",
  T_48_META_API_1013_P2_D: "ID ฟังก์ชั่นที่เรียกโดยเป้าหมาย",
  T_48_META_API_1013_P3_D: "รายการอาร์กิวเมนต์ที่ส่งไปยังฟังก์ชันที่กำหนดเอง",
  T_48_META_API_1014: "ค้นหาและเรียกใช้ API ที่กำหนดเองด้วย Serial",
  T_48_META_API_1014_D: "เรียกใช้ฟังก์ชันแบบกำหนดเองในสคริปต์ปัจจุบันในโหมดอนุกรม หากมีการรอในฟังก์ชันแบบกำหนดเอง ตำแหน่งที่เรียกก็จะรอเช่นกัน",
  T_48_META_API_1014_P0: "รหัสฟังก์ชั่น",
  T_48_META_API_1014_P0_D: "ID ฟังก์ชั่นที่เรียกโดยเป้าหมาย",
  T_48_META_API_1014_P1_D: "รายการอาร์กิวเมนต์ที่ส่งไปยังฟังก์ชันที่กำหนดเอง",
  T_48_META_API_1015: "ค้นหาและเรียกใช้ API ที่กำหนดเองด้วย Parallel",
  T_48_META_API_1015_D: "เรียกใช้ฟังก์ชันแบบกำหนดเองแบบขนาน ไม่ว่าจะมีการรอในฟังก์ชันแบบกำหนดเองหรือไม่ก็ตาม ฟังก์ชันก็จะกลับไปยังตำแหน่งที่เรียกทันทีและดำเนินการต่อไป",
  T_48_META_API_1015_P0: "ตั้งค่าตัวแปรท้องถิ่นตามดัชนี",
  T_48_META_API_1015_P0_D: "ID ฟังก์ชั่นที่เรียกโดยเป้าหมาย",
  T_48_META_API_1015_P1_D: "รายการอาร์กิวเมนต์ที่ส่งไปยังฟังก์ชันที่กำหนดเอง",
  T_48_META_API_1016_D: "รับประเภทของเป้าหมายเมื่อเรียกใช้ API นี้",
  T_48_META_API_1016_P0_D: "เป้าหมายที่ถูกสอบถาม",
  T_48_META_API_1016_R_D: "ประเภทตัวแปร",
  T_48_META_API_1017_D: "ตรวจสอบว่าตัวแปรเป้าหมายเป็นประเภทที่ระบุหรือไม่",
  T_48_META_API_1017_P0_D: "เป้าหมายที่ถูกสอบถาม",
  T_48_META_API_1017_P1_D: "ประเภทที่จะเปรียบเทียบ",
  T_48_META_API_1017_R_D: "มันสอดคล้องกันหรือไม่?",
  T_48_META_API_1018_D: "ตรวจสอบว่าตัวแปรเป้าหมายเป็นคลาสย่อยของประเภทใดประเภทหนึ่งหรือไม่ และค่าที่ส่งคืนคือค่าบูลีน",
  T_48_META_API_1018_P0_D: "ตัวแปรเป้าหมายที่กำลังสอบถาม",
  T_48_META_API_1018_P1_D: "ประเภทที่จะเปรียบเทียบ",
  T_48_META_API_1018_R_D: "ไม่ว่าจะเป็นคลาสย่อย",
  T_48_META_API_1019_D: "ทำให้เอนทิตีเป้าหมายทริกเกอร์เหตุการณ์แบบกำหนดเองที่ระบุ",
  T_48_META_API_1019_P0_D: "ส่งรหัสเหตุการณ์ที่กำหนดเองแล้ว",
  T_48_META_API_1019_P1_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_1019_P2_D: "รายการพารามิเตอร์",
  T_48_META_API_102_D: "การสลับไปยังฉากที่ระบุจะยกเลิกการโหลดฉากอื่นๆ ที่โหลดไว้",
  T_48_META_API_102_P0_D: "รหัสฉากที่จะเปลี่ยนไปใช้",
  T_48_META_API_1020_D: "ใช้การข้ามผ่านคอนเทนเนอร์และรับคู่คีย์-ค่าแต่ละคู่ รวมถึงกระบวนการย่อยด้วย",
  T_48_META_API_1020_P0_D: "ข้ามไปที่ชื่อของคีย์ คุณสามารถใช้เพื่อรับค่าคีย์บนตัวแปรโลคัลได้",
  T_48_META_API_1020_P1_D: "ข้ามไปยังชื่อของค่า ซึ่งสามารถใช้เพื่อรับค่าบนตัวแปรโลคัล",
  T_48_META_API_1020_P2_D: "ภาชนะที่จะสำรวจ",
  T_48_META_API_1021_D: "ทำลายบอทที่ระบุ",
  T_48_META_API_1021_P0_D: "ผู้เล่นบอทที่ต้องถูกทำลาย",
  T_48_META_API_1022_D: "บังคับให้ผู้เล่นเป้าหมายออกจากยานพาหนะ",
  T_48_META_API_1022_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_1023_D: "สร้างคำกระโดดที่สร้างความเสียหาย",
  T_48_META_API_1023_P0_D: "ข้ามเนื้อหาคำ",
  T_48_META_API_1023_P1_D: "ขนาดตัวอักษร",
  T_48_META_API_1023_P2_D: "สีตัวอักษร",
  T_48_META_API_1023_P3_D: "ระยะเวลาอยู่ในหน่วยมิลลิวินาที",
  T_48_META_API_1023_P4_D: "นิติบุคคลที่ได้รับความเสียหาย",
  T_48_META_API_1023_P5_D: "การชดเชยคำข้ามความเสียหายที่สัมพันธ์กับพิกัดโลกของเอนทิตีเป้าหมาย",
  T_48_META_API_1023_P6_D: "ขนาดช่วงของการแก้ไขตำแหน่งแบบสุ่มอีกครั้งที่ตำแหน่งกระโดดดาเมจ",
  T_48_META_API_1023_P7_D: "ไม่ว่าจะทำแอนิเมชั่น Tween หรือไม่",
  T_48_META_API_1024_D: "เลิกใช้แล้ว",
  T_48_META_API_1024_P0_D: "เลิกใช้แล้ว",
  T_48_META_API_1024_P1_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_1024_P2_D: "หลังจากเลือกแล้ว หากถูกเรียกบนเซิร์ฟเวอร์ ก็จะถูกส่งไปยังไคลเอนต์ หากถูกเรียกบนไคลเอนต์ ก็จะถูกส่งไปยังเซิร์ฟเวอร์",
  T_48_META_API_1024_P3_D: "รายการพารามิเตอร์",
  T_48_META_API_1025_D: "สืบค้นความคืบหน้าของงานที่กำหนดเอง",
  T_48_META_API_1025_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_1025_P1_D: "ID งานที่กำหนดเอง",
  T_48_META_API_1025_R_D: "ความคืบหน้าของงาน",
  T_48_META_API_1026_D: "รับสกินกระเป๋าเป้สะพายหลังของผู้เล่นเป้าหมาย",
  T_48_META_API_1026_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_1026_R_D: "รหัสสกินกระเป๋าเป้สะพายหลัง",
  T_48_META_API_1027_D: "ตั้งค่าสกินกระเป๋าเป้สะพายหลังของผู้เล่นเป้าหมาย",
  T_48_META_API_1027_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_1027_P1_D: "รหัสสกินกระเป๋าเป้สะพายหลัง",
  T_48_META_API_1028_D: "คืนค่าสกินกระเป๋าเป้สะพายหลังของผู้เล่นเป้าหมายให้เป็นการกำหนดค่าภายนอกเริ่มต้น",
  T_48_META_API_1028_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_1029_D: "ล้างสกินกระเป๋าเป้สะพายหลังของผู้เล่นเป้าหมาย",
  T_48_META_API_1029_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_103_D: "เปลี่ยนรูปแบบสภาพแวดล้อม skybox ของเกม คุณสามารถเลือกกลางวัน ค่ำ กลางคืน ฯลฯ",
  T_48_META_API_103_P0_D: "ประเภทสกายบ็อกซ์",
  T_48_META_API_1030_D: "รับตำแหน่งจุดห้อยกระดูกตามชื่อ",
  T_48_META_API_1030_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_1030_P1_D: "ชื่อจุดห้อยกระดูก",
  T_48_META_API_1030_R_D: "จุดโครงกระดูก",
  T_48_META_API_1031_D: "ตั้งค่าโหนดพาเรนต์ของเอนทิตีออบเจ็กต์ ซึ่งรองรับเอนทิตีที่ติดตั้งด้วยส่วนประกอบ Transform, SkeletonPart, Player และ MountPoint",
  T_48_META_API_1031_P0_D: "โหนดหลัก",
  T_48_META_API_1031_P1_D: "โหนดลูก",
  T_48_META_API_1031_P2_D: "ว่าจะรักษาตำแหน่งโลกปัจจุบัน การหมุน และการปรับขนาดของโหนดย่อยหรือไม่ รายการนี้ไม่ถูกต้องหากตั้งค่าโดย UI",
  T_48_META_API_1032_D: "เล่นเอฟเฟกต์ภาพเคลื่อนไหวของไอคอน ไอคอนจะแปลจากตำแหน่งเริ่มต้นไปยังตำแหน่งสิ้นสุดด้วยความเร็วในการเล่น",
  T_48_META_API_1032_P0_D: "รหัสทรัพยากรไอคอน",
  T_48_META_API_1032_P1_D: "สี",
  T_48_META_API_1032_P2_D: "ซูมไอคอน",
  T_48_META_API_1032_P3_D: "ตำแหน่งเริ่มต้น ศูนย์กลาง",
  T_48_META_API_1032_P4_D: "ช่วงพื้นที่เริ่มต้น",
  T_48_META_API_1032_P5_D: "ศูนย์กลางตำแหน่งสิ้นสุด",
  T_48_META_API_1032_P6_D: "ช่วงตำแหน่งสิ้นสุด",
  T_48_META_API_1032_P7_D: "ความเร็วในการเล่นคือระยะทางต่อวินาทีที่ไอคอนเคลื่อนที่",
  T_48_META_API_1033_D: "ดำเนินการอาร์กแทนเจนต์เพื่อให้ได้มุม",
  T_48_META_API_1033_P0_D: "พิกัดแกน Y",
  T_48_META_API_1033_P1_D: "พิกัดแกน X",
  T_48_META_API_1033_R_D: "มุม, ระยะ (-180, 180]",
  T_48_META_API_1034_D: "เพิ่มส่วนประกอบให้กับเอนทิตีเท่านั้นที่รองรับส่วนประกอบแบบกำหนดเองที่ผู้ใช้สร้างขึ้น",
  T_48_META_API_1034_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_1034_P1_D: "รหัสประเภทส่วนประกอบ รองรับเฉพาะส่วนประกอบที่กำหนดเองที่ผู้ใช้สร้างขึ้น",
  T_48_META_API_1034_P2_D: "ไม่ว่าจะเพิ่มสำเร็จแล้ว ส่วนประกอบที่มีอยู่หรือส่วนประกอบที่ไม่ได้กำหนดเองจะไม่สามารถเพิ่มได้",
  T_48_META_API_1035_D: "ลบส่วนประกอบออกจากเอนทิตีและสนับสนุนเฉพาะส่วนประกอบที่กำหนดเองเท่านั้น",
  T_48_META_API_1035_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_1035_P1_D: "รหัสประเภทส่วนประกอบ รองรับเฉพาะส่วนประกอบที่กำหนดเองที่ผู้ใช้สร้างขึ้น",
  T_48_META_API_1035_P2_D: "ไม่ว่าการลบจะสำเร็จหรือไม่ก็ตาม ส่วนประกอบที่ไม่มีอยู่หรือส่วนประกอบที่ไม่ได้กำหนดเองจะไม่สามารถลบออกได้",
  T_48_META_API_1036_D: "ปรับแต่งอินเทอร์เฟซทางออกของผู้เล่นตรงกลาง",
  T_48_META_API_1036_P0_D: "ชื่อ",
  T_48_META_API_1036_P1_D: "เนื้อหา",
  T_48_META_API_1036_P2_D: "ตัวเลือก",
  T_48_META_API_1036_P3_D: "ไม่ว่าจะแสดงพื้นหลัง",
  T_48_META_API_1037_D: "รับฉากที่โหลดทั้งหมดในปัจจุบัน",
  T_48_META_API_1037_R_D: "รายการฉาก",
  T_48_META_API_1038_D: "รับทิศทางการเล็งในพื้นที่ของผู้เล่น",
  T_48_META_API_1038_R_D: "ทิศทางการเล็ง",
  T_48_META_API_1039_D: "รับการประทับเวลาท้องถิ่น",
  T_48_META_API_1039_R_D: "การประทับเวลา",
  T_48_META_API_104_D: "สลับเครื่องเล่นไปยังตำแหน่งที่ระบุของฉากที่ระบุ ฉากที่ไม่ได้โหลดจะถูกโหลดโดยอัตโนมัติ และฉากที่โหลดจะไม่ถูกยกเลิกการโหลดโดยอัตโนมัติ",
  T_48_META_API_104_P0_D: "ผู้เล่น",
  T_48_META_API_104_P1_D: "รหัสฉากที่จะโหลด",
  T_48_META_API_104_P2_D: "ตำแหน่งของผู้เล่นในฉากใหม่",
  T_48_META_API_104_P3_D: "การวางแนวของผู้เล่นในฉากใหม่",
  T_48_META_API_1040_D: "หยุดการอัปเดตเฟรมคงที่ของแพลตฟอร์มปัจจุบันชั่วคราว หลังจากหยุดชั่วคราว เหตุการณ์การอัปเดตเฟรมคงที่ของแพลตฟอร์มจะไม่ถูกทริกเกอร์อีกต่อไป",
  T_48_META_API_1041_D: "ดำเนินการอัปเดตเฟรมคงที่ของแพลตฟอร์มปัจจุบันต่อ หลังจากการกู้คืน เหตุการณ์การอัปเดตเฟรมคงที่ของแพลตฟอร์มจะเริ่มทริกเกอร์อีกครั้ง",
  T_48_META_API_1042_D: "กำหนดความสัมพันธ์ของเพื่อนระหว่างผู้เล่นเป้าหมายและผู้เล่นไคลเอนต์ปัจจุบัน ตัวไคลเอนต์ปัจจุบันไม่ใช่เพื่อนของลูกค้าปัจจุบัน",
  T_48_META_API_1042_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_1042_R_D: "ไม่ว่าคุณจะเป็นเพื่อนกับลูกค้าปัจจุบัน",
  T_48_META_API_1043_D: "ทริกเกอร์เหตุการณ์ที่กำหนดเอง",
  T_48_META_API_1043_P0_D: "รหัสเหตุการณ์ที่กำหนดเอง",
  T_48_META_API_1043_P1_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_1043_P2_D: "แพลตฟอร์มที่ทำงานอยู่คือเซิร์ฟเวอร์หรือไคลเอนต์",
  T_48_META_API_1043_P3_D: "รายการพารามิเตอร์",
  T_48_META_API_1044_D: "เริ่มกระโดดร่ม",
  T_48_META_API_1044_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_1044_P1_D: "ร่มชูชีพจะถูกบังคับให้เปิดต่ำกว่าความสูงนี้",
  T_48_META_API_1044_P2_D: "ความเร็วเมื่อร่อน องค์ประกอบ X แสดงถึงความเร็วในแนวนอน และองค์ประกอบ Y แสดงถึงความเร็วในแนวตั้ง เมื่อองค์ประกอบ Y เป็นลบ ผู้เล่นจะตกลงไปด้านล่าง",
  T_48_META_API_1044_P3_D: "ความเร็วเมื่อดำน้ำ องค์ประกอบ X แสดงถึงความเร็วแนวนอน และองค์ประกอบ Y แสดงถึงความเร็วในแนวตั้ง เมื่อองค์ประกอบ Y เป็นลบ ผู้เล่นจะล้มลง",
  T_48_META_API_1044_P4_D: "ความเร็วเมื่อเปิดร่ม องค์ประกอบ X แสดงถึงความเร็วแนวนอน และองค์ประกอบ Y แสดงถึงความเร็วในแนวตั้ง เมื่อองค์ประกอบ Y เป็นลบ ผู้เล่นจะตกลงไปด้านล่าง",
  T_48_META_API_1045_D: "อ่านค่าที่สอดคล้องกับตัวระบุที่ระบุในตารางข้อมูล",
  T_48_META_API_1045_P0_D: "ชื่อตารางในฐานข้อมูล",
  T_48_META_API_1045_P1_D: "ID เฉพาะของผู้เล่น",
  T_48_META_API_1045_P2_D: "ระบุตัวระบุ",
  T_48_META_API_1045_P3_D: "อ่านผลลัพธ์",
  T_48_META_API_1045_P4_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูลซึ่งสามารถกรอกในช่องว่างได้ แสดงถึงรหัสสนามรบของแผนที่ปัจจุบัน",
  T_48_META_API_1045_P5_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1046_D: "อ่านค่าที่สอดคล้องกับตัวระบุที่ระบุในตารางข้อมูลการจัดอันดับ",
  T_48_META_API_1046_P0_D: "ชื่อตารางอันดับในฐานข้อมูล",
  T_48_META_API_1046_P1_D: "ระบุตัวระบุ",
  T_48_META_API_1046_P2_D: "อ่านผลลัพธ์",
  T_48_META_API_1046_P3_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูลซึ่งสามารถกรอกในช่องว่างได้ แสดงถึงรหัสสนามรบของแผนที่ปัจจุบัน",
  T_48_META_API_1046_P4_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1047_D: "อ่านค่าของช่วงการจัดอันดับที่ระบุในตารางข้อมูลการจัดอันดับ",
  T_48_META_API_1047_P0_D: "ชื่อตารางอันดับในฐานข้อมูล",
  T_48_META_API_1047_P1_D: "อันดับเริ่มต้นต้องน้อยกว่าหรือเท่ากับอันดับสิ้นสุด และอันดับเริ่มจาก 1",
  T_48_META_API_1047_P2_D: "จบอันดับ",
  T_48_META_API_1047_P3_D: "อ่านผลลัพธ์",
  T_48_META_API_1047_P4_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูลซึ่งสามารถกรอกในช่องว่างได้ แสดงถึงรหัสสนามรบของแผนที่ปัจจุบัน",
  T_48_META_API_1047_P5_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1048_D: "อ่านค่าที่สอดคล้องกับตัวระบุที่ระบุในตารางข้อมูลสะสม",
  T_48_META_API_1048_P0_D: "ชื่อตารางข้อมูลที่สะสมในฐานข้อมูล",
  T_48_META_API_1048_P1_D: "ระบุตัวระบุ",
  T_48_META_API_1048_P2_D: "อ่านผลลัพธ์",
  T_48_META_API_1048_P3_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูลซึ่งสามารถกรอกในช่องว่างได้ แสดงถึงรหัสสนามรบของแผนที่ปัจจุบัน",
  T_48_META_API_1048_P4_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1049_D: "เขียนค่าที่สอดคล้องกับตัวระบุที่ระบุในตารางข้อมูล",
  T_48_META_API_1049_P0_D: "ชื่อตารางในฐานข้อมูล",
  T_48_META_API_1049_P1_D: "ID เฉพาะของผู้เล่น",
  T_48_META_API_1049_P2_D: "ระบุตัวระบุ",
  T_48_META_API_1049_P3_D: "ค่าที่เขียน",
  T_48_META_API_1049_P4_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูลซึ่งสามารถกรอกในช่องว่างได้ แสดงถึงรหัสสนามรบของแผนที่ปัจจุบัน",
  T_48_META_API_1049_P5_D: "รหัสข้อผิดพลาด",
  T_48_META_API_105_D: "รับกล่องสกายบ็อกซ์ของที่เกิดเหตุ",
  T_48_META_API_105_P0_D: "รหัสฉาก",
  T_48_META_API_105_R_D: "สกายบ็อกซ์",
  T_48_META_API_1050_D: "รับจำนวนองค์ประกอบในรายการ",
  T_48_META_API_1050_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1050_R_D: "จำนวนองค์ประกอบ",
  T_48_META_API_1051_D: "รับค่าองค์ประกอบที่ดัชนีที่ระบุในรายการ",
  T_48_META_API_1051_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1051_P1_D: "ค่าดัชนีเริ่มต้นจาก 0",
  T_48_META_API_1051_R_D: "ค่าองค์ประกอบ",
  T_48_META_API_1052_D: "ตั้งค่าองค์ประกอบที่สอดคล้องกับดัชนีที่ระบุในรายการ",
  T_48_META_API_1052_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1052_P1_D: "ค่าดัชนีเริ่มต้นจาก 0",
  T_48_META_API_1052_P2_D: "ค่าองค์ประกอบ",
  T_48_META_API_1053_D: "เพิ่มองค์ประกอบต่อท้ายรายการ",
  T_48_META_API_1053_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1053_P1_D: "องค์ประกอบที่จะเพิ่ม",
  T_48_META_API_1054_D: "ลบองค์ประกอบที่สอดคล้องกับดัชนีที่ระบุออกจากรายการ",
  T_48_META_API_1054_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1054_P1_D: "ค่าดัชนีเริ่มต้นจาก 0",
  T_48_META_API_1055_D: "ล้างองค์ประกอบทั้งหมดในรายการ",
  T_48_META_API_1055_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1056_D: "ย้อนกลับรายการที่ระบุ ลำดับขององค์ประกอบในรายการจะถูกย้อนกลับ",
  T_48_META_API_1056_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1057_D: "คัดลอกรายการ",
  T_48_META_API_1057_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1057_R_D: "คัดลอกรายการใหม่แล้ว",
  T_48_META_API_1058_D: "แทรกองค์ประกอบใหม่ที่ตำแหน่งดัชนีที่ระบุในรายการ",
  T_48_META_API_1058_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1058_P1_D: "ตำแหน่งดัชนีที่จะแทรก ดัชนีจะคำนวณจาก 0",
  T_48_META_API_1058_P2_D: "ค่าองค์ประกอบใหม่ที่จะแทรก",
  T_48_META_API_1059_D: "สุ่มเรียงลำดับองค์ประกอบในรายการใหม่",
  T_48_META_API_1059_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1060_D: "เปรียบเทียบพารามิเตอร์ทั้งสองด้านแล้วคืนค่าจริงหรือเท็จ",
  T_48_META_API_1060_P0_D: "ค่าที่ใช้สำหรับการเปรียบเทียบ",
  T_48_META_API_1060_P1_D: "วิธีการเปรียบเทียบรองรับวิธีการต่อไปนี้: >,>=,==,!=,<=,<,And (ประเภทบูลจำกัด) หรือ (ประเภทบูลจำกัด)",
  T_48_META_API_1060_P2_D: "ค่าที่ใช้สำหรับการเปรียบเทียบ",
  T_48_META_API_1060_R_D: "เปรียบเทียบผลลัพธ์",
  T_48_META_API_1061_D: "การดำเนินการทางคณิตศาสตร์พื้นฐานสี่แบบ ได้แก่ การบวก การลบ การคูณ การหาร และเศษ การดำเนินการส่วนที่เหลือรองรับเฉพาะจำนวนเต็ม และการดำเนินการที่เหลือรองรับจำนวนเต็มหรือทศนิยม",
  T_48_META_API_1061_P0_D: "มูลค่าการดำเนินงาน",
  T_48_META_API_1061_P1_D: "การดำเนินการทางคณิตศาสตร์สี่ประเภท ได้แก่ การบวก การลบ การคูณ การหาร และเศษ การดำเนินการเศษไม่รองรับทศนิยม",
  T_48_META_API_1061_P2_D: "มูลค่าการดำเนินงาน",
  T_48_META_API_1061_R_D: "ผลการคำนวณ",
  T_48_META_API_1062_D: "สุ่มสร้างจำนวนเต็มระหว่างจำนวนเต็มที่น้อยที่สุด (รวม) และจำนวนเต็มที่ใหญ่ที่สุด (ไม่รวม)",
  T_48_META_API_1062_P0_D: "ช่วงซ้ายของช่วงสุ่มสามารถสุ่มถึงค่าที่กรอกได้",
  T_48_META_API_1062_P1_D: "ช่วงเวลาที่เหมาะสมของช่วงสุ่มจะไม่สุ่มตามค่าที่กรอกไว้",
  T_48_META_API_1062_R_D: "ผลลัพธ์แบบสุ่ม, จำนวนเต็ม",
  T_48_META_API_1063_D: "สุ่มสร้างทศนิยมระหว่างค่าทศนิยมที่น้อยที่สุด (รวม) และค่าทศนิยมที่ใหญ่ที่สุด (ไม่รวม)",
  T_48_META_API_1063_P0_D: "ช่วงซ้ายของช่วงสุ่มมีโอกาสน้อยที่ค่าที่กรอกจะเป็นแบบสุ่ม",
  T_48_META_API_1063_P1_D: "ช่วงเวลาที่เหมาะสมของช่วงสุ่มจะไม่สุ่มตามค่าที่กรอกไว้",
  T_48_META_API_1063_R_D: "สุ่มผลทศนิยมแม่นยำถึงทศนิยม 7 ตำแหน่ง",
  T_48_META_API_1064_D: "ตรวจสอบว่าวัตถุว่างเปล่าหรือไม่",
  T_48_META_API_1064_P0_D: "วัตถุที่จะตัดสินว่างเปล่า",
  T_48_META_API_1064_R_D: "ว่างมั้ย.",
  T_48_META_API_1065_D: "การปฏิเสธแบบลอจิคัล ค่าอินพุต: จริงหรือเท็จ ค่าส่งคืน: เท็จหรือจริง",
  T_48_META_API_1065_P0_D: "ต้องหาค่าของ non",
  T_48_META_API_1065_R_D: "ผลลัพธ์เชิงลบ",
  T_48_META_API_1066_D: "รับค่าสัมบูรณ์ รองรับจำนวนเต็มและทศนิยม",
  T_48_META_API_1066_P0_D: "จำเป็นต้องค้นหาค่าสัมบูรณ์ของค่า",
  T_48_META_API_1066_R_D: "ผลลัพธ์ของการรับค่าสัมบูรณ์",
  T_48_META_API_1067_D: "คำนวณรากที่สอง",
  T_48_META_API_1067_P0_D: "จำเป็นต้องค้นหารากที่สองของค่า",
  T_48_META_API_1067_R_D: "ผลลัพธ์ของการหารากที่สอง",
  T_48_META_API_1068_D: "คำนวณค่าลบ",
  T_48_META_API_1068_P0_D: "จำเป็นต้องค้นหาค่าลบ",
  T_48_META_API_1068_R_D: "ผลลัพธ์เชิงลบ",
  T_48_META_API_1069_D: "เชื่อมต่อสองสายเข้าด้วยกัน",
  T_48_META_API_1069_P0_D: "สตริง lvalue",
  T_48_META_API_1069_P1_D: "ค่าสตริง",
  T_48_META_API_1069_R_D: "ผลการต่อสตริง",
  T_48_META_API_1070_D: "รับความยาวสตริง",
  T_48_META_API_1070_P0_D: "เชือก",
  T_48_META_API_1070_R_D: "ความยาวสาย",
  T_48_META_API_1071_D: "ปัดเศษค่าที่ระบุให้เป็นจำนวนเต็มที่ใกล้ที่สุด",
  T_48_META_API_1071_P0_D: "ค่าที่ต้องปัดเศษลง",
  T_48_META_API_1071_R_D: "ผลของการปัดเศษลง",
  T_48_META_API_1072_D: "ปัดเศษค่าที่ระบุให้เป็นจำนวนเต็มที่ใกล้ที่สุด",
  T_48_META_API_1072_P0_D: "ค่าที่ต้องปัดเศษขึ้น",
  T_48_META_API_1072_R_D: "ผลของการปัดเศษขึ้น",
  T_48_META_API_1073_D: "ปัดเศษค่าที่ระบุให้เป็นจำนวนเต็ม",
  T_48_META_API_1073_P0_D: "ค่าที่ต้องปัดเศษ",
  T_48_META_API_1073_R_D: "ผลการปัดเศษ",
  T_48_META_API_1074_D: "หลังจากแทนที่สตริงที่ระบุทั้งหมดในสตริงเป้าหมายแล้ว ให้เอาท์พุตสตริงใหม่",
  T_48_META_API_1074_P0_D: "สตริงเป้าหมาย",
  T_48_META_API_1074_P1_D: "สตริงเก่าที่จะเปลี่ยน",
  T_48_META_API_1074_P2_D: "สตริงใหม่ที่จะแทนที่ด้วย",
  T_48_META_API_1074_R_D: "แทนที่สตริงที่เสร็จสมบูรณ์",
  T_48_META_API_1075_D: "ค้นหาสตริงเป้าหมายสำหรับการเกิดขึ้นครั้งแรกของสตริงที่ระบุ",
  T_48_META_API_1075_P0_D: "สตริงเป้าหมาย",
  T_48_META_API_1075_P1_D: "สตริงที่ระบุที่จะค้นหา",
  T_48_META_API_1075_P2_D: "ค้นหาสตริงจากตำแหน่งเริ่มต้น ตำแหน่งสตริงจะคำนวณจาก 0",
  T_48_META_API_1075_R_D: "ระบุตำแหน่งของสตริงที่เกิดขึ้นครั้งแรกในสตริงเป้าหมาย ตำแหน่งสตริงคำนวณจาก 0",
  T_48_META_API_1076_D: "หลังจากสกัดกั้นสตริงที่มีความยาวที่ระบุโดยเริ่มจากตำแหน่งที่ระบุ ให้เอาต์พุตสตริงใหม่",
  T_48_META_API_1076_P0_D: "สตริงเป้าหมาย",
  T_48_META_API_1076_P1_D: "ตำแหน่งที่การสกัดกั้นเริ่มต้น ตำแหน่งสตริงคำนวณจาก 0",
  T_48_META_API_1076_P2_D: "ตัดความยาวออกตามค่าเริ่มต้น จะตัดไปที่จุดสิ้นสุดของสตริง",
  T_48_META_API_1076_R_D: "สตริงที่ถูกดัก",
  T_48_META_API_1077_D: "เปรียบเทียบว่าองค์ประกอบของสองรายการเหมือนกันทุกประการหรือไม่ ความจุของรายการไม่ส่งผลต่อผลการเปรียบเทียบ",
  T_48_META_API_1077_P0_D: "แสดงรายการค่าที่ใช้สำหรับการเปรียบเทียบ",
  T_48_META_API_1077_P1_D: "แสดงรายการค่าที่ใช้ในการเปรียบเทียบ",
  T_48_META_API_1077_R_D: "เมื่อเปรียบเทียบผลลัพธ์ หากเนื้อหาสอดคล้องกัน จะส่งกลับค่า True หากเนื้อหาไม่สอดคล้องกัน จะส่งกลับค่า False",
  T_48_META_API_1078_D: "การใช้สตริงที่ระบุเป็นตัวคั่น ตัดสตริงเป้าหมายออกเป็นหลายส่วนแล้วส่งออกสตริงใหม่ ตัวคั่น N ที่ต่อเนื่องกันจะถูกตัดเป็นช่องว่างครึ่งความกว้าง N-1 และเอาต์พุตเป็นองค์ประกอบรายการสตริง",
  T_48_META_API_1078_P0_D: "สตริงเป้าหมาย",
  T_48_META_API_1078_P1_D: "สตริงตัวคั่น",
  T_48_META_API_1078_R_D: "รายการสตริงเอาต์พุตจะลงท้ายด้วยองค์ประกอบช่องว่างครึ่งความกว้างเสมอ",
  T_48_META_API_1079_D: "แยกอักขระตามรายการตำแหน่งสตริงและรวมเข้ากับเอาต์พุตสตริงใหม่",
  T_48_META_API_1079_P0_D: "สตริงเป้าหมาย",
  T_48_META_API_1079_P1_D: "รายการตำแหน่งสตริง ตำแหน่งสตริงจะถูกคำนวณโดยเริ่มจาก 0",
  T_48_META_API_1079_R_D: "สตริงเอาต์พุต",
  T_48_META_API_1080_D: "แปลงอักขระสตริงเป้าหมายเป็นตัวพิมพ์ใหญ่ทั้งหมด",
  T_48_META_API_1080_P0_D: "สตริงเป้าหมาย",
  T_48_META_API_1080_R_D: "สตริงเอาต์พุต",
  T_48_META_API_1081_D: "แปลงอักขระสตริงเป้าหมายทั้งหมดเป็นตัวพิมพ์เล็ก",
  T_48_META_API_1081_P0_D: "สตริงเป้าหมาย",
  T_48_META_API_1081_R_D: "สตริงเอาต์พุต",
  T_48_META_API_1082_D: "ลบช่องว่างทั้งหมดก่อนอักขระตัวแรกที่ไม่ใช่ช่องว่าง และหลังอักขระที่ไม่ใช่ช่องว่างตัวสุดท้ายของสตริงเป้าหมาย",
  T_48_META_API_1082_P0_D: "สตริงเป้าหมาย",
  T_48_META_API_1082_R_D: "สตริงเอาต์พุต",
  T_48_META_API_1083_D: "ส่งออกสตริงใหม่หลังจากเชื่อมโยงกับตัวระบุที่ระบุ",
  T_48_META_API_1083_P0_D: "รายการสตริงเป้าหมาย",
  T_48_META_API_1083_P1_D: "ตัวระบุที่ระบุใช้ในการต่อสตริง",
  T_48_META_API_1083_R_D: "สตริงเอาต์พุต",
  T_48_META_API_1084_D: "เขียนค่าที่สอดคล้องกับตัวระบุที่ระบุในตารางข้อมูลการจัดอันดับ",
  T_48_META_API_1084_P0_D: "ชื่อตารางอันดับในฐานข้อมูล",
  T_48_META_API_1084_P1_D: "ระบุตัวระบุ",
  T_48_META_API_1084_P2_D: "ค่าที่เขียน",
  T_48_META_API_1084_P3_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูลซึ่งสามารถกรอกในช่องว่างได้ แสดงถึงรหัสสนามรบของแผนที่ปัจจุบัน",
  T_48_META_API_1084_P4_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1085_D: "เขียนค่าออฟเซ็ตที่สอดคล้องกับตัวระบุที่ระบุในตารางข้อมูลสะสม",
  T_48_META_API_1085_P0_D: "ชื่อตารางข้อมูลที่สะสมในฐานข้อมูล",
  T_48_META_API_1085_P1_D: "ระบุตัวระบุ",
  T_48_META_API_1085_P2_D: "การดำเนินการทางคณิตศาสตร์สี่ประเภท",
  T_48_META_API_1085_P3_D: "เขียนค่าออฟเซ็ตแล้ว",
  T_48_META_API_1085_P4_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูลซึ่งสามารถกรอกในช่องว่างได้ แสดงถึงรหัสสนามรบของแผนที่ปัจจุบัน",
  T_48_META_API_1085_P5_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1086_D: "ลบค่าที่สอดคล้องกับตัวระบุที่ระบุในตารางข้อมูล",
  T_48_META_API_1086_P0_D: "ชื่อตารางในฐานข้อมูล",
  T_48_META_API_1086_P1_D: "ID เฉพาะของผู้เล่น",
  T_48_META_API_1086_P2_D: "ระบุตัวระบุ",
  T_48_META_API_1086_P3_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูลซึ่งสามารถกรอกในช่องว่างได้ แสดงถึงรหัสสนามรบของแผนที่ปัจจุบัน",
  T_48_META_API_1086_P4_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1087_D: "ลบค่าที่สอดคล้องกับตัวระบุที่ระบุในตารางข้อมูลการจัดอันดับ",
  T_48_META_API_1087_P0_D: "ชื่อตารางอันดับในฐานข้อมูล",
  T_48_META_API_1087_P1_D: "ระบุตัวระบุ",
  T_48_META_API_1087_P2_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูลซึ่งสามารถกรอกในช่องว่างได้ แสดงถึงรหัสสนามรบของแผนที่ปัจจุบัน",
  T_48_META_API_1087_P3_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1088_D: "ลบค่าที่สอดคล้องกับการจัดอันดับที่ระบุในตารางข้อมูลการจัดอันดับ",
  T_48_META_API_1088_P0_D: "ชื่อตารางอันดับในฐานข้อมูล",
  T_48_META_API_1088_P1_D: "ระบุอันดับ",
  T_48_META_API_1088_P2_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูลซึ่งสามารถกรอกในช่องว่างได้ แสดงถึงรหัสสนามรบของแผนที่ปัจจุบัน",
  T_48_META_API_1088_P3_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1089_D: "ส่งข้อความถึงผู้ใช้ถึง Persona",
  T_48_META_API_1089_P0_D: "เป้าหมาย PersonaID",
  T_48_META_API_1089_P1_D: "เนื้อหาข้อความ",
  T_48_META_API_1090_D: "ส่งข้อความระบบถึง Persona",
  T_48_META_API_1090_P0_D: "เป้าหมาย PersonaID",
  T_48_META_API_1090_P1_D: "เนื้อหาข้อความ",
  T_48_META_API_1091_D: "ล้างหน่วยความจำบุคคล",
  T_48_META_API_1091_P0_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1092_D: "ศูนย์สมาชิก Arouse",
  T_48_META_API_1092_P0_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1093_D: "รับการประทับเวลาการหมดอายุของสมาชิก",
  T_48_META_API_1093_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_1093_P1_D: "การประทับเวลา",
  T_48_META_API_1093_P2_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1094_D: "ตรวจสอบว่าผู้เล่นเป็นสมาชิกหรือไม่",
  T_48_META_API_1094_P0_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1094_P1_D: "คุณเป็นสมาชิกหรือไม่?",
  T_48_META_API_1095_D: "รับการประทับเวลาการหมดอายุของสมาชิก",
  T_48_META_API_1095_P0_D: "การประทับเวลา",
  T_48_META_API_1095_P1_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1096_D: "ตรวจสอบว่าผู้เล่นเป็นสมาชิกหรือไม่",
  T_48_META_API_1096_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_1096_P1_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1096_P2_D: "คุณเป็นสมาชิกหรือไม่?",
  T_48_META_API_1097_D: "ศูนย์สมาชิก Arouse",
  T_48_META_API_1097_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_1097_P1_D: "รหัสข้อผิดพลาด",
  T_48_META_API_1099_D: "ตั้งค่าผู้สังเกตการณ์ Persona และการสนทนากับ Persona ในภายหลังจะถูกส่งไปยังผู้สังเกตการณ์ด้วย",
  T_48_META_API_1099_P0_D: "เป้าหมาย PersonaID",
  T_48_META_API_1099_P1_D: "รายชื่อผู้สังเกตการณ์",
  T_48_META_API_11_D: "จบเฟสปัจจุบันและเข้าสู่เฟสถัดไป",
  T_48_META_API_1100_D: "ส่งข้อความผู้ใช้ถึง Persona โดยใช้การสตรีม",
  T_48_META_API_1100_P0_D: "เป้าหมาย PersonaID",
  T_48_META_API_1100_P1_D: "เนื้อหาข้อความ",
  T_48_META_API_1101_D: "ส่งข้อความระบบไปยัง Persona โดยใช้การสตรีม",
  T_48_META_API_1101_P0_D: "เป้าหมาย PersonaID",
  T_48_META_API_1101_P1_D: "เนื้อหาข้อความ",
  T_48_META_API_1101_P2_D: "ว่าจะตอบกลับหรือไม่",
  T_48_META_API_1103_D: "สร้างเมล็ดพันธุ์แบบสุ่ม",
  T_48_META_API_1103_P0_D: "เมล็ดพันธุ์",
  T_48_META_API_1103_R_D: "เครื่องกำเนิดตัวเลขสุ่ม",
  T_48_META_API_1104_D: "รับเลขสุ่มถัดไปจากตัวสร้างเลขสุ่มที่กำหนด ค่าสูงสุดคือ 32767",
  T_48_META_API_1104_P0_D: "เครื่องกำเนิดตัวเลขสุ่ม",
  T_48_META_API_1104_P1_D: "ช่วงขั้นต่ำ",
  T_48_META_API_1104_P2_D: "ช่วงสูงสุด",
  T_48_META_API_1104_R_D: "หมายเลขสุ่ม",
  T_48_META_API_1108_D: "รับภาษาไคลเอนต์ที่ผู้เล่นใช้",
  T_48_META_API_12_D: "พิมพ์บันทึกไปยังคอนโซล",
  T_48_META_API_12_P0_D: "สิ่งที่ต้องพิมพ์",
  T_48_META_API_13_D: "ส่งออกสตริงพร้อมพารามิเตอร์",
  T_48_META_API_13_P0_D: "ใช้ตัวยึดตำแหน่ง %v เพื่อแสดงพารามิเตอร์ จำนวน %v และจำนวนพารามิเตอร์ต้องสอดคล้องกัน",
  T_48_META_API_13_P1_D: "รายการพารามิเตอร์ที่เข้าร่วมในเอาต์พุตจะต้องสอดคล้องกับจำนวน %v ในคำอธิบายรูปแบบ",
  T_48_META_API_13_R_D: "สตริงเอาต์พุต",
  T_48_META_API_14_D: "ทำความสะอาดสิ่งตกค้างของวัตถุบนแผนที่ รวมถึงกล่องมรณะ วัตถุที่สร้างขึ้น วัตถุที่วาง เศษกระสุนปืน ฯลฯ",
  T_48_META_API_15_D: "ปรับแต่งบันทึกคะแนนการแข่งขันสำหรับการวิเคราะห์ข้อมูลประสบการณ์ผู้ใช้",
  T_48_META_API_15_P0_D: "รายชื่อเขตข้อมูลที่จะรายงาน",
  T_48_META_API_15_P1_D: "รายการค่าฟิลด์ที่จะรายงาน",
  T_48_META_API_1500_D: "รับองค์ประกอบ X ของเวกเตอร์สามมิติ",
  T_48_META_API_1500_P0_D: "เวกเตอร์ 3 มิติ",
  T_48_META_API_1500_R_D: "องค์ประกอบ X เวกเตอร์สามมิติ",
  T_48_META_API_1501_D: "รับองค์ประกอบ Y ของเวกเตอร์สามมิติ",
  T_48_META_API_1501_P0_D: "เวกเตอร์ 3 มิติ",
  T_48_META_API_1501_R_D: "องค์ประกอบ Y ของเวกเตอร์สามมิติ",
  T_48_META_API_1502_D: "รับองค์ประกอบ Z ของเวกเตอร์สามมิติ",
  T_48_META_API_1502_P0_D: "เวกเตอร์ 3 มิติ",
  T_48_META_API_1502_R_D: "องค์ประกอบเวกเตอร์ Z สามมิติ",
  T_48_META_API_1503_D: "ตั้งค่าองค์ประกอบ X ของเวกเตอร์สามมิติ",
  T_48_META_API_1503_P0_D: "เวกเตอร์ 3 มิติ",
  T_48_META_API_1503_P1_D: "ส่วนประกอบเอ็กซ์",
  T_48_META_API_1504_D: "ตั้งค่าองค์ประกอบ Y ของเวกเตอร์สามมิติ",
  T_48_META_API_1504_P0_D: "เวกเตอร์ 3 มิติ",
  T_48_META_API_1504_P1_D: "ส่วนประกอบ Y",
  T_48_META_API_1505_D: "ตั้งค่าองค์ประกอบ Z ของเวกเตอร์สามมิติ",
  T_48_META_API_1505_P0_D: "เวกเตอร์ 3 มิติ",
  T_48_META_API_1505_P1_D: "ส่วนประกอบ Z",
  T_48_META_API_1506_D: "เพิ่มเวกเตอร์สามมิติสองตัว",
  T_48_META_API_1506_P0_D: "ซ้าย",
  T_48_META_API_1506_P1_D: "ขวา",
  T_48_META_API_1506_R_D: "ผลลัพธ์การบวกเวกเตอร์สามมิติ",
  T_48_META_API_1507_D: "ลบเวกเตอร์สามมิติสองตัว",
  T_48_META_API_1507_P0_D: "ซ้าย",
  T_48_META_API_1507_P1_D: "ขวา",
  T_48_META_API_1507_R_D: "ผลลัพธ์ของการลบค่า r จากค่า lvalue ของเวกเตอร์สามมิติ",
  T_48_META_API_1508_D: "มาตราส่วนเวกเตอร์สามมิติ",
  T_48_META_API_1508_P0_D: "เวกเตอร์ 3 มิติที่จะปรับขนาด",
  T_48_META_API_1508_P1_D: "จำนวนมาตราส่วนเวกเตอร์ 3 มิติ",
  T_48_META_API_1508_R_D: "ผลลัพธ์การปรับขนาดเวกเตอร์ 3 มิติ",
  T_48_META_API_1509_D: "เวกเตอร์สามมิติผลคูณดอท ผลลัพธ์ของผลิตภัณฑ์ดอทเป็นสเกลาร์",
  T_48_META_API_1509_P0_D: "ซ้าย",
  T_48_META_API_1509_P1_D: "ขวา",
  T_48_META_API_1509_R_D: "ผลการคูณจุด",
  T_48_META_API_1510_D: "การคูณเวกเตอร์สามมิติสองตัวแบบไขว้ ผลลัพธ์ของการคูณข้ามคือเวกเตอร์ที่ตั้งฉากกับระนาบซึ่งมีเวกเตอร์สองตัวอยู่",
  T_48_META_API_1510_P0_D: "ซ้าย",
  T_48_META_API_1510_P1_D: "ขวา",
  T_48_META_API_1510_R_D: "ผลลัพธ์ของผลคูณไขว้ ทิศทางจะตั้งฉากกับระนาบซึ่งมีเวกเตอร์สองตัวที่เกี่ยวข้องกับการดำเนินการอยู่",
  T_48_META_API_1511_D: "ทำให้เวกเตอร์สามมิติเป็นปกติ",
  T_48_META_API_1511_P0_D: "เวกเตอร์ 3 มิติ",
  T_48_META_API_1511_R_D: "ส่งกลับเวกเตอร์มาตรฐานใหม่ ความยาวของแม่พิมพ์คือ 1",
  T_48_META_API_1512_D: "โมดูโล่เวกเตอร์สามมิติ",
  T_48_META_API_1512_P0_D: "เวกเตอร์ 3 มิติ",
  T_48_META_API_1512_R_D: "ผลลัพธ์แบบโมดูโลคือความยาวของโมดูลัสเวกเตอร์",
  T_48_META_API_1513_D: "คำนวณระยะทางแบบยุคลิดของเวกเตอร์สามมิติสองตัว",
  T_48_META_API_1513_P0_D: "ซ้าย",
  T_48_META_API_1513_P1_D: "ขวา",
  T_48_META_API_1513_R_D: "หลังจากลบเวกเตอร์สองตัวแล้ว ความยาวของโมดูลของเวกเตอร์ผลลัพธ์",
  T_48_META_API_1514_D: "คำนวณมุมระหว่างเวกเตอร์สามมิติสองตัว",
  T_48_META_API_1514_P0_D: "ซ้าย",
  T_48_META_API_1514_P1_D: "ขวา",
  T_48_META_API_1514_R_D: "มุมเวกเตอร์ ช่วงมุม 0-180",
  T_48_META_API_1515_D: "สร้างเวกเตอร์ 3 มิติ",
  T_48_META_API_1515_P0_D: "องค์ประกอบ X ของเวกเตอร์สามมิติ",
  T_48_META_API_1515_P1_D: "องค์ประกอบ Y ของเวกเตอร์สามมิติ",
  T_48_META_API_1515_P2_D: "องค์ประกอบ Z ของเวกเตอร์สามมิติ",
  T_48_META_API_1515_R_D: "เวกเตอร์สามมิติที่สร้างขึ้น",
  T_48_META_API_1516_D: "รับจุดทิศทางที่สร้างขึ้นใหม่ (เลิกใช้แล้ว ห้ามใช้)",
  T_48_META_API_1516_P0_D: "ที่ตั้ง",
  T_48_META_API_1516_P1_D: "ต่อ",
  T_48_META_API_1516_R_D: "ไดเรคพอยท์",
  T_48_META_API_1517_D: "รับตำแหน่งจุดทิศทาง (ล้าสมัย โปรดอย่าใช้)",
  T_48_META_API_1517_P0_D: "จุดทิศทาง",
  T_48_META_API_1517_R_D: "ตำแหน่ง",
  T_48_META_API_1518_D: "รับการวางแนวของจุดทิศทาง (ล้าสมัย โปรดอย่าใช้)",
  T_48_META_API_1518_P0_D: "จุดทิศทาง",
  T_48_META_API_1518_R_D: "ซึ่งไปข้างหน้า",
  T_48_META_API_1519_D: "สร้างรายการ",
  T_48_META_API_1519_P0_D: "ความยาวเริ่มต้นของรายการต้องน้อยกว่าหรือเท่ากับความจุเริ่มต้น",
  T_48_META_API_1519_P1_D: "ความจุเริ่มต้นของรายการต้องมากกว่าหรือเท่ากับความยาวเริ่มต้น ความจุสามารถขยายได้แบบไดนามิก แต่จะใช้ประสิทธิภาพจำนวนหนึ่ง ขอแนะนำให้ตั้งค่าที่เหมาะสมเมื่อสร้าง",
  T_48_META_API_1519_R_D: "รายการที่สร้างขึ้น",
  T_48_META_API_1520_D: "ตรวจสอบว่ารายการมีองค์ประกอบที่ระบุหรือไม่",
  T_48_META_API_1520_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1520_P1_D: "องค์ประกอบที่ระบุเพื่อตรวจสอบ",
  T_48_META_API_1520_R_D: "ไม่ว่าจะมีองค์ประกอบที่ระบุหรือไม่",
  T_48_META_API_1521_D: "เพิ่มองค์ประกอบหลายรายการต่อท้ายรายการเป้าหมาย",
  T_48_META_API_1521_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1521_P1_D: "ผนวกรายการ",
  T_48_META_API_1522_D: "ลบองค์ประกอบที่ระบุออกจากรายการ",
  T_48_META_API_1522_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1522_P1_D: "ค่าองค์ประกอบที่จะลบ",
  T_48_META_API_1523_D: "รับดัชนีตำแหน่งที่องค์ประกอบในรายการปรากฏขึ้นครั้งแรก หากไม่มีองค์ประกอบเป้าหมายในรายการ จะส่งกลับ -1",
  T_48_META_API_1523_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1523_P1_D: "ค่าองค์ประกอบ",
  T_48_META_API_1523_R_D: "ดัชนีตำแหน่ง",
  T_48_META_API_1524_D: "รับดัชนีขององค์ประกอบที่ปรากฏครั้งสุดท้ายในรายการ หากไม่มีองค์ประกอบเป้าหมายในรายการ จะส่งกลับ -1",
  T_48_META_API_1524_P0_D: "รายการเป้าหมาย",
  T_48_META_API_1524_P1_D: "ค่าองค์ประกอบ",
  T_48_META_API_1524_R_D: "ดัชนีตำแหน่ง",
  T_48_META_API_1525_D: "ค้นหาไซน์ของมุม",
  T_48_META_API_1525_P0_D: "มุม 360 แสดงถึง 360 องศา",
  T_48_META_API_1525_R_D: "ค่าไซน์",
  T_48_META_API_1526_D: "ค้นหาโคไซน์ของมุม",
  T_48_META_API_1526_P0_D: "มุม 360 แสดงถึง 360 องศา",
  T_48_META_API_1526_R_D: "โคไซน์",
  T_48_META_API_1527_D: "ค้นหาแทนเจนต์ของมุม",
  T_48_META_API_1527_P0_D: "มุม 360 แสดงถึง 360 องศา",
  T_48_META_API_1527_R_D: "แทนเจนต์",
  T_48_META_API_1528_D: "สร้างค่าสีโดยมีความโปร่งใสคงที่ที่ทศนิยม 255 ขั้นแรกให้แปลงช่องสัญญาณเป็นเลขฐานสอง แต่ละ 8 บิตแสดงถึงช่องสัญญาณ ประกบกันตาม R, G, B และความโปร่งใส จากนั้นแปลงเลขฐานสองเป็นประเภท Int32 และ ส่งคืน",
  T_48_META_API_1528_P0_D: "ค่าช่องสีแดงของสี ช่วงค่าคือ [0,255] หากเกินช่วงนั้นจะถูกยึดให้เป็นค่าทางกฎหมาย",
  T_48_META_API_1528_P1_D: "ค่าช่องสีเขียวของสี ช่วงค่าคือ [0,255] หากเกินช่วงนั้นจะถูกยึดให้เป็นค่าทางกฎหมาย",
  T_48_META_API_1528_P2_D: "ค่าช่องสีน้ำเงินของสี ช่วงค่าคือ [0,255] หากเกินช่วงนั้นจะถูกยึดให้เป็นค่าทางกฎหมาย",
  T_48_META_API_1528_R_D: "ค่าสีที่สร้างขึ้น",
  T_48_META_API_1529_D: "ดำเนินการอาร์คไซน์เพื่อให้ได้มุม",
  T_48_META_API_1529_P0_D: "ค่าสำหรับการดำเนินการอาร์กไซน์ ช่วงค่าคือ [-1,1]",
  T_48_META_API_1529_R_D: "มุม",
  T_48_META_API_1530_D: "ดำเนินการอาร์คโคไซน์เพื่อให้ได้มุม",
  T_48_META_API_1530_P0_D: "ค่าสำหรับการดำเนินการอาร์คโคไซน์ ช่วงค่าคือ [-1,1]",
  T_48_META_API_1530_R_D: "มุม",
  T_48_META_API_1531_D: "ดำเนินการอาร์กแทนเจนต์เพื่อให้ได้มุม",
  T_48_META_API_1531_P0_D: "ค่าที่จะดำเนินการดำเนินการอาร์กแทนเจนต์",
  T_48_META_API_1531_R_D: "มุม",
  T_48_META_API_1532_D: "ตรวจสอบว่าเอนทิตีเป้าหมายอยู่ภายในช่วงทรงกลมที่ระบุหรือไม่ หากเอนทิตีไม่มีแอตทริบิวต์ตำแหน่ง เท็จจะถูกส่งกลับ",
  T_48_META_API_1532_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_1532_P1_D: "ระบุจุดศูนย์กลางของทรงกลม",
  T_48_META_API_1532_P2_D: "ระบุรัศมีของทรงกลม",
  T_48_META_API_1532_R_D: "ผลการตัดสิน",
  T_48_META_API_1533_D: "ตรวจสอบว่าเอนทิตีเป้าหมายอยู่ภายในช่วงทรงกระบอกที่ระบุหรือไม่ หากเอนทิตีไม่มีแอตทริบิวต์ตำแหน่ง เท็จจะถูกส่งกลับ",
  T_48_META_API_1533_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_1533_P1_D: "ระบุจุดศูนย์กลางของกระบอกสูบ",
  T_48_META_API_1533_P2_D: "ระบุรัศมีหน้าตัดของกระบอกสูบ",
  T_48_META_API_1533_P3_D: "ระบุความสูงของกระบอกสูบ",
  T_48_META_API_1533_P4_D: "ระบุมุมการหมุนของออยเลอร์สามมิติของกระบอกสูบรอบจุดศูนย์กลาง",
  T_48_META_API_1533_R_D: "ผลการตัดสิน",
  T_48_META_API_1534_D: "ตรวจสอบว่าเอนทิตีเป้าหมายอยู่ภายในช่วงคิวบ์ที่ระบุหรือไม่",
  T_48_META_API_1534_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_1534_P1_D: "ระบุจุดกึ่งกลางของคิวบ์",
  T_48_META_API_1534_P2_D: "ระบุความยาวของคิวบ์",
  T_48_META_API_1534_P3_D: "ระบุความกว้างของคิวบ์",
  T_48_META_API_1534_P4_D: "ระบุความสูงของคิวบ์",
  T_48_META_API_1534_P5_D: "ระบุมุมออยเลอร์การหมุนสามมิติของลูกบาศก์รอบจุดศูนย์กลาง",
  T_48_META_API_1534_R_D: "ผลการตัดสิน",
  T_48_META_API_1535_D: "ตรวจสอบว่าเอนทิตีเป้าหมายอยู่ภายในช่วงทรงกระบอกเซกเตอร์ที่ระบุหรือไม่",
  T_48_META_API_1535_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_1535_P1_D: "ระบุจุดกึ่งกลางของส่วนตรงกลางของทรงกระบอกรูปทรงเซกเตอร์",
  T_48_META_API_1535_P2_D: "ระบุรัศมีส่วนกลางของทรงกระบอกรูปทรงเซกเตอร์",
  T_48_META_API_1535_P3_D: "รัศมีหน้าตัดของทรงกระบอกเซกเตอร์ที่ไม่ได้ทดสอบโดยจุดศูนย์กลางเป็นจุดศูนย์กลางของวงกลม พื้นที่ทรงกระบอกเซกเตอร์ขนาดเล็กจะไม่ถูกทดสอบ มีเพียงความแตกต่างระหว่างทรงกระบอกเซกเตอร์ที่ระบุและ ธีมรูปทรงเซกเตอร์ขนาดเล็กจะถูกตรวจพบ",
  T_48_META_API_1535_P4_D: "ระบุความสูงของทรงกระบอกเซกเตอร์",
  T_48_META_API_1535_P5_D: "มุมศูนย์กลางของส่วนทรงกระบอกรูปทรงเซกเตอร์สำหรับการตรวจจับ หากมากกว่า 360 จะถูกตรวจจับเป็นรูปทรงกระบอก หากน้อยกว่า 0 ขนาดพื้นที่การตรวจจับจะเป็น 0",
  T_48_META_API_1535_P6_D: "ระบุมุมการหมุนของออยเลอร์สามมิติของทรงกระบอกเซกเตอร์รอบจุดศูนย์กลาง",
  T_48_META_API_1535_R_D: "ผลการตัดสิน",
  T_48_META_API_1536_D: "เปรียบเทียบค่าของตัวเลขสองตัวและส่งกลับค่าที่มากกว่า",
  T_48_META_API_1536_P0_D: "ซ้าย",
  T_48_META_API_1536_P1_D: "ขวา",
  T_48_META_API_1536_R_D: "จำนวนที่มากขึ้น",
  T_48_META_API_1537_D: "ส่งคืนค่าสูงสุดในรายการ",
  T_48_META_API_1537_P0_D: "รายการเป้าหมาย ยอมรับเฉพาะประเภทองค์ประกอบรายการเป็นตัวเลข",
  T_48_META_API_1537_P1_D: "ผลการเปรียบเทียบ หากมีรายการที่ไม่ใช่ตัวเลข การเปรียบเทียบจะล้มเหลวและส่งกลับค่าเท็จ",
  T_48_META_API_1537_P2_D: "ส่งกลับค่าที่มากที่สุดในรายการหากการเปรียบเทียบสำเร็จ และส่งคืนค่า 0 หากการเปรียบเทียบล้มเหลว",
  T_48_META_API_1538_D: "เปรียบเทียบค่าของตัวเลขสองตัวและส่งกลับค่าที่น้อยกว่า",
  T_48_META_API_1538_P0_D: "ซ้าย",
  T_48_META_API_1538_P1_D: "ขวา",
  T_48_META_API_1538_R_D: "จำนวนที่น้อยกว่า",
  T_48_META_API_1539_D: "ส่งกลับค่าต่ำสุดในรายการ",
  T_48_META_API_1539_P0_D: "รายการเป้าหมาย ยอมรับเฉพาะประเภทองค์ประกอบรายการเป็นตัวเลข",
  T_48_META_API_1539_P1_D: "ผลการเปรียบเทียบ หากมีรายการที่ไม่ใช่ตัวเลข การเปรียบเทียบจะล้มเหลวและส่งกลับค่าเท็จ",
  T_48_META_API_1539_P2_D: "ส่งกลับค่าที่น้อยที่สุดในรายการหากการเปรียบเทียบสำเร็จ และส่งคืนค่า 0 หากการเปรียบเทียบล้มเหลว",
  T_48_META_API_1540_D: "การประมาณค่าเชิงเส้น ส่งกลับค่าที่สอดคล้องกับความคืบหน้าของการประมาณค่าระหว่างค่าเริ่มต้นและค่าเป้าหมาย ค่าสัมประสิทธิ์การประมาณค่า [0,1]",
  T_48_META_API_1540_P0_D: "ค่าเริ่มต้นของการประมาณค่าเชิงเส้น ค่านี้จะถูกส่งกลับเมื่อความคืบหน้าของการประมาณค่าเป็น 0",
  T_48_META_API_1540_P1_D: "ค่าเป้าหมายการแก้ไขเชิงเส้น ค่านี้จะถูกส่งกลับเมื่อความคืบหน้าในการแก้ไขเป็น 1",
  T_48_META_API_1540_P2_D: "ความคืบหน้าของการประมาณค่า ช่วงค่า [0,1] เมื่อค่าเป็น 0 ค่าเริ่มต้นจะถูกส่งกลับ เมื่อค่าเป็น 1 ค่าเป้าหมายจะถูกส่งกลับ เมื่อค่าเป็น 0.5 ค่าเฉลี่ยของค่าเริ่มต้นและเป้าหมาย ค่าจะถูกส่งกลับ",
  T_48_META_API_1540_R_D: "ค่าส่งคืนการประมาณค่าเชิงเส้น",
  T_48_META_API_1541_D: "จำกัดช่วงของค่าเป้าหมายและรับค่ากลางระหว่างพารามิเตอร์อินพุตทั้งสาม ฟังก์ชันคือการจำกัดค่าเป้าหมายให้อยู่ในช่วงที่ระบุ หากค่าเป้าหมายน้อยกว่าค่าต่ำสุด ค่าต่ำสุดจะถูกส่งกลับ ค่าเป้าหมายมากกว่าค่าสูงสุด ค่าสูงสุดจะถูกส่งกลับเมื่ออยู่ในระยะ",
  T_48_META_API_1541_P0_D: "ค่าเป้าหมาย",
  T_48_META_API_1541_P1_D: "ค่าต่ำสุดของช่วงที่จำกัด",
  T_48_META_API_1541_P2_D: "ค่าสูงสุดของช่วงที่จำกัด",
  T_48_META_API_1541_R_D: "ส่งกลับค่าหลังข้อจำกัด",
  T_48_META_API_1542_D: "รับค่าช่องสัญญาณของสีเป้าหมาย",
  T_48_META_API_1542_P0_D: "สีเป้าหมาย",
  T_48_META_API_1542_P1_D: "ค่า R ของสี ช่วง [0, 255]",
  T_48_META_API_1542_P2_D: "ค่า G ของสี ช่วง [0, 255]",
  T_48_META_API_1542_P3_D: "ค่า B ของสี ช่วง [0, 255]",
  T_48_META_API_1542_P4_D: "ค่าสี ช่วง [0, 255]",
  T_48_META_API_1543_D: "การยกกำลัง",
  T_48_META_API_1543_P0_D: "ฐาน",
  T_48_META_API_1543_P1_D: "ดัชนี",
  T_48_META_API_1543_R_D: "ผลการคำนวณ",
  T_48_META_API_1544_D: "การดำเนินการลอการิทึม",
  T_48_META_API_1544_P0_D: "ฐาน",
  T_48_META_API_1544_P1_D: "จำนวนจริง",
  T_48_META_API_1544_R_D: "ผลการคำนวณ",
  T_48_META_API_1545_D: "ทิศทางเวกเตอร์เป็นมุมออยเลอร์",
  T_48_META_API_1545_P0_D: "เวกเตอร์ทิศทาง",
  T_48_META_API_1545_R_D: "มุมออยเลอร์",
  T_48_META_API_1546_D: "เวกเตอร์ทิศทางการหมุนของมุมออยเลอร์",
  T_48_META_API_1546_P0_D: "มุมออยเลอร์",
  T_48_META_API_1546_R_D: "เวกเตอร์ทิศทาง",
  T_48_META_API_1547_D: "จำนวนเต็มเป็นจำนวนจุดลอยตัว",
  T_48_META_API_1547_P0_D: "จำนวนเต็ม",
  T_48_META_API_1547_R_D: "หมายเลขจุดลอยตัว",
  T_48_META_API_1548_D: "หมุนเวกเตอร์เป้าหมายตามควอเทอร์เนียน",
  T_48_META_API_1548_P0_D: "เวกเตอร์เป้าหมาย",
  T_48_META_API_1548_P1_D: "หมุนควอเทอร์เนียน",
  T_48_META_API_1548_R_D: "เวกเตอร์ที่หมุนแล้ว",
  T_48_META_API_1549_D: "แปลงหมายเลขเป้าหมายเป็นสตริง",
  T_48_META_API_1549_P0_D: "หมายเลขเป้าหมายที่จะแปลงเป็นสตริง",
  T_48_META_API_1549_P1_D: "รูปแบบสตริงตัวเลขเอาต์พุต",
  T_48_META_API_1549_R_D: "เชือก",
  T_48_META_API_1598_D: "รับการประทับเวลาของเซิร์ฟเวอร์",
  T_48_META_API_1598_R_D: "ส่งกลับจำนวนวินาทีตั้งแต่ 0:00:00 น. ของวันที่ 1 มกราคม 1970",
  T_48_META_API_1599_D: "รับพื้นที่เซิร์ฟเวอร์",
  T_48_META_API_1599_R_D: "ส่งกลับตัวย่อภูมิภาค (BR, SAC, ID, NA, US, IND, SG, BD, VN, TH, ME, RU, EU, PK, TW)",
  T_48_META_API_16_D: "บันทึกการติดตามผู้ใช้ที่กำหนดเองสำหรับการวิเคราะห์ข้อมูลประสบการณ์ผู้ใช้",
  T_48_META_API_16_P0_D: "ผู้เล่นที่จะรายงาน",
  T_48_META_API_16_P1_D: "รายชื่อเขตข้อมูลที่จะรายงาน",
  T_48_META_API_16_P2_D: "รายการค่าฟิลด์ที่จะรายงาน",
  T_48_META_API_1601_D: "สร้างพจนานุกรม",
  T_48_META_API_1601_R_D: "พจนานุกรมที่สร้างขึ้น",
  T_48_META_API_1602_D: "รับค่าที่สอดคล้องกับคีย์ที่ระบุในพจนานุกรม",
  T_48_META_API_1602_P0_D: "พจนานุกรมเป้าหมาย",
  T_48_META_API_1602_P1_D: "คีย์",
  T_48_META_API_1602_R_D: "ค่า",
  T_48_META_API_1603_D: "ตั้งค่าที่สอดคล้องกับคีย์ที่ระบุในพจนานุกรม",
  T_48_META_API_1603_P0_D: "พจนานุกรมเป้าหมาย",
  T_48_META_API_1603_P1_D: "คีย์",
  T_48_META_API_1603_P2_D: "ค่า",
  T_48_META_API_1604_D: "ลบคู่คีย์-ค่าที่ระบุออกจากพจนานุกรม",
  T_48_META_API_1604_P0_D: "พจนานุกรมเป้าหมาย",
  T_48_META_API_1604_P1_D: "คีย์",
  T_48_META_API_1605_D: "ล้างคู่คีย์-ค่าทั้งหมดในพจนานุกรม",
  T_48_META_API_1605_P0_D: "พจนานุกรมเป้าหมาย",
  T_48_META_API_1606_D: "รับจำนวนคู่คีย์-ค่าในพจนานุกรม",
  T_48_META_API_1606_P0_D: "พจนานุกรมเป้าหมาย",
  T_48_META_API_1606_R_D: "ความยาวพจนานุกรม",
  T_48_META_API_1607_D: "ตรวจสอบว่ามีคีย์อยู่ในพจนานุกรมหรือไม่",
  T_48_META_API_1607_P0_D: "พจนานุกรมเป้าหมาย",
  T_48_META_API_1607_P1_D: "คีย์",
  T_48_META_API_1607_R_D: "มีอยู่หรือไม่",
  T_48_META_API_1608_D: "รับคีย์ทั้งหมดของพจนานุกรมโดยส่งคืนเป็นรายการ",
  T_48_META_API_1608_P0_D: "พจนานุกรมเป้าหมาย",
  T_48_META_API_1608_R_D: "รายการค่าคีย์ทั้งหมด",
  T_48_META_API_17_D: "ใช้พื้นที่รูปทรงกล่องของการเคลื่อนที่เชิงเส้นในการตรวจจับ และส่งคืนเอนทิตีทั้งหมดที่พบในเส้นทางของพื้นที่รูปทรงกล่องจากใกล้ไปไกล หากในตอนแรกอยู่ภายในช่วงรูปทรงกล่อง พวกมันจะไม่ถูกตรวจพบ หากกรอกพารามิเตอร์ลำดับชั้นลงในช่องว่าง ก็สามารถตรวจพบภูมิประเทศได้",
  T_48_META_API_17_P0_D: "ครึ่งหนึ่งของความยาวทั้งสามด้านของพื้นที่กล่อง ยอมรับเฉพาะค่าบวกเท่านั้น",
  T_48_META_API_17_P1_D: "จุดกึ่งกลางของพื้นที่กล่อง",
  T_48_META_API_17_P2_D: "การหมุนพื้นที่กล่อง",
  T_48_META_API_17_P3_D: "ทิศทางการเดินทางของพื้นที่กล่อง",
  T_48_META_API_17_P4_D: "ระยะทางการเดินทางของพื้นที่กล่องยอมรับเฉพาะค่าบวกเท่านั้น",
  T_48_META_API_17_P5_D: "เลเยอร์มาสก์ เฉพาะเลเยอร์ที่กรอกแล้วเท่านั้นที่จะเข้าร่วมในการสแกน การเว้นว่างไว้หมายความว่าเลเยอร์ทั้งหมดจะมีส่วนร่วมในการสแกน",
  T_48_META_API_17_P6_D: "เป็นไปได้ไหมที่จะตรวจจับทริกเกอร์",
  T_48_META_API_17_P7_D: "รายการเอนทิตีที่ได้รับความนิยม",
  T_48_META_API_1700_D: "แปลงสตริงที่ระบุให้เป็นจำนวนเต็ม",
  T_48_META_API_1700_P0_D: "สตริงเป้าหมาย",
  T_48_META_API_1700_P1_D: "จำนวนเต็มผลลัพธ์",
  T_48_META_API_1700_P2_D: "การแปลงสำเร็จหรือไม่?",
  T_48_META_API_1701_D: "แปลงสตริงที่ระบุให้เป็นตัวเลขทศนิยม",
  T_48_META_API_1701_P0_D: "สตริงเป้าหมาย",
  T_48_META_API_1701_P1_D: "ผลลัพธ์ลอยตัว",
  T_48_META_API_1701_P2_D: "การแปลงสำเร็จหรือไม่?",
  T_48_META_API_18_D: "ใช้พื้นที่ทรงกลมเคลื่อนที่เป็นเส้นตรงเพื่อตรวจจับ และส่งคืนเอนทิตีทั้งหมดที่พบในเส้นทางพื้นที่ทรงกลมจากใกล้ไปไกล หากในตอนแรกพวกมันอยู่ในพื้นที่ทรงกลม พวกมันจะไม่ถูกตรวจพบหากกรอกพารามิเตอร์ระดับในช่องว่าง ,สามารถตรวจจับภูมิประเทศได้",
  T_48_META_API_18_P0_D: "รัศมีของพื้นที่ทรงกลมยอมรับเฉพาะค่าบวกเท่านั้น",
  T_48_META_API_18_P1_D: "จุดศูนย์กลางของพื้นที่ทรงกลม",
  T_48_META_API_18_P2_D: "ทิศทางการเคลื่อนที่ของพื้นที่ทรงกลม",
  T_48_META_API_18_P3_D: "ระยะทางที่เดินทางโดยพื้นที่ทรงกลม ยอมรับเฉพาะค่าบวกเท่านั้น",
  T_48_META_API_18_P4_D: "เลเยอร์มาสก์ เฉพาะเลเยอร์ที่กรอกแล้วเท่านั้นที่จะเข้าร่วมในการสแกน การเว้นว่างไว้หมายความว่าเลเยอร์ทั้งหมดจะมีส่วนร่วมในการสแกน",
  T_48_META_API_18_P5_D: "เป็นไปได้ไหมที่จะตรวจจับทริกเกอร์",
  T_48_META_API_18_P6_D: "รายการเอนทิตีที่ได้รับความนิยม",
  T_48_META_API_19_D: "ใช้พื้นที่แคปซูลที่เคลื่อนที่เป็นเส้นตรงเพื่อตรวจจับ และส่งคืนเอนทิตีทั้งหมดที่พบในเส้นทางของพื้นที่แคปซูลจากใกล้ไปไกล หากในตอนแรกพวกมันอยู่ภายในพื้นที่แคปซูล พวกมันจะไม่ถูกตรวจพบ หากมีการกรอกพารามิเตอร์ระดับนั้น สามารถตรวจจับภูมิประเทศได้",
  T_48_META_API_19_P0_D: "รัศมีของซีกโลกที่ปลายทั้งสองของพื้นที่แคปซูลยอมรับเฉพาะค่าบวกเท่านั้น",
  T_48_META_API_19_P1_D: "ระยะห่างระหว่างศูนย์กลางของซีกโลกที่ปลายทั้งสองของพื้นที่แคปซูล ค่านี้จะต้องมากกว่าสองเท่าของรัศมีของซีกโลกที่ปลายทั้งสอง",
  T_48_META_API_19_P2_D: "จุดศูนย์กลางของบริเวณแคปซูล",
  T_48_META_API_19_P3_D: "การหมุนของบริเวณแคปซูล",
  T_48_META_API_19_P4_D: "ทิศทางการเดินทางของบริเวณแคปซูล",
  T_48_META_API_19_P5_D: "ระยะทางที่เดินทางในพื้นที่แก้วเข็ม，เฉพาะค่าบวกเท่านั้นที่ยอมรับ",
  T_48_META_API_19_P6_D: "เลเยอร์มาสก์ เฉพาะเลเยอร์ที่กรอกแล้วเท่านั้นที่จะเข้าร่วมในการสแกน การเว้นว่างไว้หมายความว่าเลเยอร์ทั้งหมดจะมีส่วนร่วมในการสแกน",
  T_48_META_API_19_P7_D: "เป็นไปได้ไหมที่จะตรวจจับทริกเกอร์",
  T_48_META_API_19_P8_D: "รายการเอนทิตีที่ได้รับความนิยม",
  T_48_META_API_2_D: "รับทุกทีมในเกมปัจจุบันและกลับสู่รายชื่อทีม",
  T_48_META_API_2_R_D: "รายชื่อทีม",
  T_48_META_API_20_D: "ใช้พื้นที่รูปทรงกล่องคงที่เพื่อตรวจจับและส่งคืนเอนทิตีทั้งหมดภายในพื้นที่รูปทรงกล่อง หากกรอกพารามิเตอร์ระดับในช่องว่าง จะสามารถตรวจจับภูมิประเทศได้",
  T_48_META_API_20_P0_D: "ครึ่งหนึ่งของความยาวทั้งสามด้านของพื้นที่กล่อง ยอมรับเฉพาะค่าบวกเท่านั้น",
  T_48_META_API_20_P1_D: "จุดกึ่งกลางของพื้นที่กล่อง",
  T_48_META_API_20_P2_D: "การหมุนพื้นที่กล่อง",
  T_48_META_API_20_P3_D: "เลเยอร์มาสก์ เฉพาะเลเยอร์ที่กรอกแล้วเท่านั้นที่จะเข้าร่วมในการสแกน การเว้นว่างไว้หมายความว่าเลเยอร์ทั้งหมดจะมีส่วนร่วมในการสแกน",
  T_48_META_API_20_P4_D: "เป็นไปได้ไหมที่จะตรวจจับทริกเกอร์",
  T_48_META_API_20_P5_D: "รายการเอนทิตีที่ได้รับความนิยม",
  T_48_META_API_2000_D: "ตั้งค่าแอตทริบิวต์ของเอนทิตีเป้าหมาย ซึ่งกำหนดให้มีการกำหนดแอตทริบิวต์",
  T_48_META_API_2000_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_2000_P1_D: "คุณลักษณะของเอนทิตีเป้าหมาย",
  T_48_META_API_2000_P2_D: "ค่าเป้าหมายจะต้องสอดคล้องกับประเภทที่ต้องการเมื่อมีการกำหนดแอตทริบิวต์",
  T_48_META_API_2000_P3_D: "โหมดการทำงาน ทุกประเภทรองรับการกำหนด และประเภทตัวเลขยังรองรับการบวก การลบตัวเอง การคูณตัวเอง การหารตัวเอง และเศษเหลือในตัว",
  T_48_META_API_2001_D: "รับค่าแอตทริบิวต์ของเอนทิตี",
  T_48_META_API_2001_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_2001_P1_D: "รหัสแอตทริบิวต์ของเอนทิตี",
  T_48_META_API_2001_R_D: "ค่าแอตทริบิวต์",
  T_48_META_API_2002: "ตั้งค่าคุณสมบัติกราฟ",
  T_48_META_API_2002_D: "ตั้งค่าตัวแปรสคริปต์",
  T_48_META_API_2002_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_2002_P1: "รหัสกราฟ",
  T_48_META_API_2002_P1_D: "รหัสสคริปต์เป้าหมาย",
  T_48_META_API_2002_P2: "รหัสทรัพย์สิน",
  T_48_META_API_2002_P2_D: "ID แอ็ตทริบิวต์สมาชิกที่กำหนดไว้ในสคริปต์",
  T_48_META_API_2002_P3: "มูลค่าทรัพย์สิน",
  T_48_META_API_2002_P3_D: "ค่าเป้าหมายจะต้องสอดคล้องกับประเภทที่ต้องการเมื่อมีการกำหนดแอตทริบิวต์",
  T_48_META_API_2002_P4_D: "โหมดการทำงาน ทุกประเภทรองรับการกำหนด และประเภทตัวเลขยังรองรับการบวก การลบตัวเอง การคูณตัวเอง การหารตัวเอง และเศษเหลือในตัว",
  T_48_META_API_2003: "รับคุณสมบัติของกราฟ",
  T_48_META_API_2003_D: "รับตัวแปรสคริปต์",
  T_48_META_API_2003_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_2003_P1: "รหัสกราฟ",
  T_48_META_API_2003_P1_D: "รหัสสคริปต์เป้าหมาย",
  T_48_META_API_2003_P2: "รหัสทรัพย์สิน",
  T_48_META_API_2003_P2_D: "รหัสแอตทริบิวต์เป้าหมาย",
  T_48_META_API_2003_R_D: "ค่าแอตทริบิวต์",
  T_48_META_API_2004_D: "กำหนดและเริ่มต้นตัวแปรท้องถิ่น ขอบเขตของตัวแปรท้องถิ่นคือจากตำแหน่งการประกาศจนถึงจุดสิ้นสุดของบล็อกคำสั่ง",
  T_48_META_API_2004_P0_D: "ชื่อตัวแปร",
  T_48_META_API_2004_P1_D: "ค่าเริ่มต้นของตัวแปร",
  T_48_META_API_2004_P2_D: "ประเภทการประกาศตัวแปร เมื่อกำหนดค่า จะต้องสอดคล้องกับประเภทที่ประกาศ",
  T_48_META_API_2005_D: "ตั้งค่าของตัวแปรท้องถิ่น ขอบเขตของตัวแปรท้องถิ่นคือจากตำแหน่งการประกาศจนถึงจุดสิ้นสุดของบล็อกคำสั่ง",
  T_48_META_API_2005_P0_D: "ชื่อตัวแปร",
  T_48_META_API_2005_P1: "ค่าตัวแปร",
  T_48_META_API_2005_P1_D: "ค่าตัวแปร",
  T_48_META_API_2005_P2_D: "โหมดการทำงาน ทุกประเภทรองรับการกำหนด และประเภทตัวเลขยังรองรับการบวก การลบตัวเอง การคูณตัวเอง การหารตัวเอง และเศษเหลือในตัว",
  T_48_META_API_2006: "รับตัวแปรท้องถิ่น",
  T_48_META_API_2006_D: "รับค่าของตัวแปรท้องถิ่น ขอบเขตของตัวแปรท้องถิ่นมาจากตำแหน่งการประกาศจนถึงจุดสิ้นสุดของบล็อกคำสั่ง",
  T_48_META_API_2006_P0: "ชื่อตัวแปร",
  T_48_META_API_2006_P0_D: "ชื่อตัวแปร",
  T_48_META_API_2006_R_D: "ค่าตัวแปร",
  T_48_META_API_2009: "ค้นหาและเรียกใช้ Global Custom API ด้วย Serial",
  T_48_META_API_2009_D: "เรียกใช้ฟังก์ชันแบบกำหนดเองส่วนกลางในลักษณะอนุกรม หากมีการรอในฟังก์ชันแบบกำหนดเอง ตำแหน่งการโทรก็จะรอเช่นกัน",
  T_48_META_API_2009_P0: "รหัสกราฟ",
  T_48_META_API_2009_P0_D: "รหัสสคริปต์ซึ่งมีฟังก์ชันแบบกำหนดเองอยู่",
  T_48_META_API_2009_P1: "รหัสฟังก์ชั่น",
  T_48_META_API_2009_P1_D: "รหัสฟังก์ชันแบบกำหนดเองที่เรียกว่า",
  T_48_META_API_2009_P2_D: "รายการพารามิเตอร์ที่ส่งไปยังฟังก์ชันที่กำหนดเอง",
  T_48_META_API_2010: "ค้นหาและเรียกใช้ Global Custom API ด้วย Parallel",
  T_48_META_API_2010_D: "เรียกใช้ฟังก์ชันแบบกำหนดเองทั่วโลกพร้อมกัน ไม่ว่าจะมีการรอในฟังก์ชันแบบกำหนดเองหรือไม่ก็ตาม ฟังก์ชันก็จะกลับไปยังตำแหน่งที่เรียกทันทีและดำเนินการต่อไป",
  T_48_META_API_2010_P0: "รหัสกราฟ",
  T_48_META_API_2010_P0_D: "รหัสสคริปต์ซึ่งมีฟังก์ชันแบบกำหนดเองอยู่",
  T_48_META_API_2010_P1: "รหัสฟังก์ชั่น",
  T_48_META_API_2010_P1_D: "รหัสฟังก์ชันแบบกำหนดเองที่เรียกว่า",
  T_48_META_API_2010_P2_D: "รายการพารามิเตอร์ที่ส่งไปยังฟังก์ชันที่กำหนดเอง",
  T_48_META_API_2013: "ตั้งค่าคุณสมบัติกราฟของตัวเอง",
  T_48_META_API_2013_D: "ตั้งค่าตัวแปรสำหรับสคริปต์ปัจจุบัน",
  T_48_META_API_2013_P0: "รหัสทรัพย์สิน",
  T_48_META_API_2013_P0_D: "รหัสแอตทริบิวต์เป้าหมาย",
  T_48_META_API_2013_P1: "มูลค่าทรัพย์สิน",
  T_48_META_API_2013_P1_D: "ค่าเป้าหมาย",
  T_48_META_API_2013_P2_D: "โหมดการทำงาน ทุกประเภทรองรับการกำหนด และประเภทตัวเลขยังรองรับการบวก การลบตัวเอง การคูณตัวเอง การหารตัวเอง และเศษเหลือในตัว",
  T_48_META_API_2014: "รับคุณสมบัติกราฟด้วยตนเอง",
  T_48_META_API_2014_D: "รับตัวแปรของสคริปต์ปัจจุบัน",
  T_48_META_API_2014_P0: "รหัสทรัพย์สิน",
  T_48_META_API_2014_P0_D: "รหัสแอตทริบิวต์เป้าหมาย",
  T_48_META_API_2014_R_D: "ค่าแอตทริบิวต์",
  T_48_META_API_21_D: "ใช้พื้นที่ทรงกลมคงที่ในการตรวจจับและส่งคืนเอนทิตีทั้งหมดภายในพื้นที่ทรงกลม หากพารามิเตอร์ระดับถูกเติมลงในช่องว่าง จะสามารถตรวจจับภูมิประเทศได้",
  T_48_META_API_21_P0_D: "รัศมีของพื้นที่ทรงกลมยอมรับเฉพาะค่าบวกเท่านั้น",
  T_48_META_API_21_P1_D: "จุดศูนย์กลางของพื้นที่ทรงกลม",
  T_48_META_API_21_P2_D: "เลเยอร์มาสก์ เฉพาะเลเยอร์ที่กรอกแล้วเท่านั้นที่จะเข้าร่วมในการสแกน การเว้นว่างไว้หมายความว่าเลเยอร์ทั้งหมดจะมีส่วนร่วมในการสแกน",
  T_48_META_API_21_P3_D: "เป็นไปได้ไหมที่จะตรวจจับทริกเกอร์",
  T_48_META_API_21_P4_D: "รายการเอนทิตีที่ได้รับความนิยม",
  T_48_META_API_22_D: "ใช้พื้นที่แคปซูลคงที่ในการตรวจจับและส่งคืนเอนทิตีทั้งหมดภายในพื้นที่แคปซูล หากกรอกพารามิเตอร์ระดับ จะสามารถตรวจจับภูมิประเทศได้",
  T_48_META_API_22_P0_D: "รัศมีของซีกโลกที่ปลายทั้งสองของพื้นที่แคปซูลยอมรับเฉพาะค่าบวกเท่านั้น",
  T_48_META_API_22_P1_D: "ระยะห่างระหว่างศูนย์กลางของซีกโลกที่ปลายทั้งสองของพื้นที่แคปซูล ค่านี้จะต้องมากกว่าสองเท่าของรัศมีของซีกโลกที่ปลายทั้งสอง",
  T_48_META_API_22_P2_D: "จุดศูนย์กลางของบริเวณแคปซูล",
  T_48_META_API_22_P3_D: "การหมุนของบริเวณแคปซูล",
  T_48_META_API_22_P4_D: "เลเยอร์มาสก์ เฉพาะเลเยอร์ที่กรอกแล้วเท่านั้นที่จะเข้าร่วมในการสแกน การเว้นว่างไว้หมายความว่าเลเยอร์ทั้งหมดจะมีส่วนร่วมในการสแกน",
  T_48_META_API_22_P5_D: "เป็นไปได้ไหมที่จะตรวจจับทริกเกอร์",
  T_48_META_API_22_P6_D: "รายการเอนทิตีที่ได้รับความนิยม",
  T_48_META_API_23_D: "กำหนดสถานะรายการพิเศษสำหรับผู้เล่น คุณสามารถมีรายการพิเศษได้เพียงรายการเดียวเท่านั้น",
  T_48_META_API_23_P0_D: "ผู้เล่น",
  T_48_META_API_23_P1_D: "รหัสรายการ",
  T_48_META_API_23_P2_D: "ไม่ว่าจะเปิดใช้งานรายการนี้",
  T_48_META_API_23_P3_D: "เอนทิตีรายการพิเศษ",
  T_48_META_API_24_D: "ออกแรงไปยังเป้าหมายซึ่งต้องเป็นวัตถุทางกายภาพ",
  T_48_META_API_24_P0_D: "วัตถุทางกายภาพเป้าหมาย",
  T_48_META_API_24_P1_D: "เวกเตอร์แรง",
  T_48_META_API_24_P2_D: "ประเภทของแรง",
  T_48_META_API_25_D: "ออกแรงหนึ่งครั้งที่จุดใดจุดหนึ่ง เป้าหมายจะต้องเป็นวัตถุแข็งเกร็ง",
  T_48_META_API_25_P0_D: "เป้าหมายร่างกายแข็งเกร็ง",
  T_48_META_API_25_P1_D: "เวกเตอร์แรง",
  T_48_META_API_25_P2_D: "บังคับตำแหน่งแอปพลิเคชัน",
  T_48_META_API_25_P3_D: "ประเภทของแรง",
  T_48_META_API_26_D: "ใช้แรงบิดไปที่เป้าหมายซึ่งจะต้องเป็นตัวถังที่แข็งแรง",
  T_48_META_API_26_P0_D: "เป้าหมายร่างกายแข็งเกร็ง",
  T_48_META_API_26_P1_D: "แรงบิด",
  T_48_META_API_26_P2_D: "ประเภทแรง",
  T_48_META_API_27_D: "ย้ายวัตถุแข็งเกร็งเป้าหมายไปยังตำแหน่งที่ระบุ",
  T_48_META_API_27_P0_D: "เป้าหมายร่างกายแข็งเกร็ง",
  T_48_META_API_27_P1_D: "ระบุสถานที่",
  T_48_META_API_28_D: "หมุนเป้าหมายที่แข็งเกร็ง",
  T_48_META_API_28_P0_D: "เป้าหมายร่างกายแข็งเกร็ง",
  T_48_META_API_28_P1_D: "หมุนควอเทอร์เนียน",
  T_48_META_API_29_D: "สร้างการเคลื่อนไหวแบบสอดแทรก และคุณลักษณะที่ระบุของเอนทิตีเป้าหมายจะเคลื่อนที่ได้อย่างราบรื่นตามการตั้งค่า",
  T_48_META_API_29_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_29_P1_D: "รหัสแอตทริบิวต์ที่ต้องเปลี่ยน",
  T_48_META_API_29_P2_D: "ค่าเริ่มต้นของแอตทริบิวต์",
  T_48_META_API_29_P3_D: "ค่าสิ้นสุดของแอตทริบิวต์",
  T_48_META_API_29_P4_D: `คุณสามารถเลือกแบบเดี่ยว วนซ้ำ และสลับไปมาได้ 
 วนซ้ำหมายถึงหลังจากเสร็จสิ้นการเคลื่อนไหวแต่ละครั้ง เอนทิตีจะเคลื่อนที่อีกครั้งจากค่าเริ่มต้น สลับไปมาหมายถึงหลังจากเสร็จสิ้นการเคลื่อนไหวจากค่าเริ่มต้นไปยังค่าเป้าหมายแล้ว เอนทิตีจะเคลื่อนที่จากค่าเป้าหมายไปยังค่าเริ่มต้นอีกครั้ง จากนั้นทำซ้ำขั้นตอนดังกล่าว`,
  T_48_META_API_29_P5_D: "จุดควบคุมเส้นโค้งเบซิเยร์",
  T_48_META_API_29_P6_D: "ระยะเวลาของการเปลี่ยนแปลง หน่วยเป็นมิลลิวินาที",
  T_48_META_API_29_P7_D: "สร้างเอนทิตีการเคลื่อนไหวแบบสอดแทรก",
  T_48_META_API_29_P8_D: "จะเริ่มเล่นโดยอัตโนมัติหลังจากสร้างหรือไม่",
  T_48_META_API_3_D: "สลับเกมไปที่เฟสเป้าหมายและรอบก็เป็นเฟสพิเศษด้วย เมื่อเปลี่ยนเป็นเฟสภายในเทิร์น จำนวนเทิร์นจะเป็น 0",
  T_48_META_API_3_P0_D: "ดัชนีของรอบเป้าหมายหรือเฟส",
  T_48_META_API_30_D: "บังคับผู้เล่นเป้าหมายให้เข้าไปในยานพาหนะที่กำหนด",
  T_48_META_API_30_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_30_P1_D: "นิติบุคคลยานพาหนะ",
  T_48_META_API_30_P2_D: "หมายเลขที่นั่ง",
  T_48_META_API_30_P3_D: "ไม่ว่าผู้เล่นจะได้รับอนุญาตให้เข้าไปในยานพาหนะได้สำเร็จหรือไม่",
  T_48_META_API_3001_D: "ทำให้ผู้เล่นเป้าหมายดรอปไอเทม",
  T_48_META_API_3001_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3001_P1_D: "เอนทิตีรายการ",
  T_48_META_API_3002_D: "รับพิกัดที่มีอยู่ภายในจุดวางไข่แบบสุ่มที่มีอยู่ในปัจจุบันซึ่งยังไม่ถูกครอบครองอย่างเต็มที่ (ล้าสมัย โปรดใช้ GetRandomSpawnPosition)",
  T_48_META_API_3002_P0_D: "ผู้เล่นที่ต้องกำหนดพื้นที่วางไข่",
  T_48_META_API_3002_R_D: "พิกัดจุดสุ่มที่กำหนดแบบสุ่ม",
  T_48_META_API_3003_D: "รับค่าคะแนนรวมของประเภทคะแนนที่ระบุของผู้เล่น",
  T_48_META_API_3003_P0_D: "ผู้เล่น",
  T_48_META_API_3003_P1_D: "ประเภทจุด",
  T_48_META_API_3003_R_D: "ค่าคะแนน",
  T_48_META_API_3004_D: "ตั้งค่าแต้มกลมสำหรับประเภทแต้มที่ผู้เล่นระบุ",
  T_48_META_API_3004_P0_D: "เอนทิตีผู้เล่น",
  T_48_META_API_3004_P1_D: "ประเภทจุด",
  T_48_META_API_3004_P2_D: "ค่าคะแนน",
  T_48_META_API_3005_D: "รับค่าคะแนนรวมของประเภทคะแนนที่ระบุสำหรับทีม",
  T_48_META_API_3005_P0_D: "เอนทิตีของทีม",
  T_48_META_API_3005_P1_D: "ประเภทจุด",
  T_48_META_API_3005_R_D: "ค่าคะแนน",
  T_48_META_API_3006_D: "ตั้งค่าจุดกลมสำหรับประเภทจุดที่ระบุของทีม",
  T_48_META_API_3006_P0_D: "เอนทิตีของทีม",
  T_48_META_API_3006_P1_D: "ประเภทจุด",
  T_48_META_API_3006_P2_D: "ค่าคะแนน",
  T_48_META_API_3007_D: "รับคะแนนของผู้เล่นสำหรับรอบและประเภทคะแนนที่ระบุ",
  T_48_META_API_3007_P0_D: "เอนทิตีผู้เล่น",
  T_48_META_API_3007_P1_D: "ดัชนีกลม",
  T_48_META_API_3007_P2_D: "ประเภทจุด",
  T_48_META_API_3007_R_D: "ค่าคะแนน",
  T_48_META_API_3008_D: "รับคะแนนทีมตามรอบและประเภทคะแนนที่กำหนด",
  T_48_META_API_3008_P0_D: "เอนทิตีของทีม",
  T_48_META_API_3008_P1_D: "ดัชนีกลม",
  T_48_META_API_3008_P2_D: "ประเภทจุด",
  T_48_META_API_3008_R_D: "ค่าคะแนน",
  T_48_META_API_3009_D: "รับอันดับเกมรวมของผู้เล่น",
  T_48_META_API_3009_P0_D: "เอนทิตีผู้เล่น",
  T_48_META_API_3009_R_D: "การจัดอันดับ",
  T_48_META_API_3011_D: "รับอันดับโดยรวมของเกมของทีม",
  T_48_META_API_3011_P0_D: "เลิกใช้แล้ว",
  T_48_META_API_3011_R_D: "การจัดอันดับ",
  T_48_META_API_3013_D: "รับอันดับรอบที่ระบุของผู้เล่น",
  T_48_META_API_3013_P0_D: "เอนทิตีผู้เล่น",
  T_48_META_API_3013_P1_D: "ดัชนีกลม",
  T_48_META_API_3013_R_D: "การจัดอันดับ",
  T_48_META_API_3014_D: "รับอันดับรอบที่ทีมกำหนด",
  T_48_META_API_3014_P0_D: "เลิกใช้แล้ว",
  T_48_META_API_3014_P1_D: "ดัชนีกลม",
  T_48_META_API_3014_R_D: "การจัดอันดับ",
  T_48_META_API_3015_D: "รับกระเป๋าสตางค์ของเอนทิตีเป้าหมาย",
  T_48_META_API_3015_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_3015_P1_D: "กระเป๋าสตางค์มีอยู่จริงหรือไม่?",
  T_48_META_API_3015_P2_D: "ได้รับเอนทิตีกระเป๋าเงิน",
  T_48_META_API_3016_D: "สร้างกระเป๋าเงินสำหรับผู้เล่นเป้าหมาย หากผู้เล่นมีกระเป๋าเงินอยู่แล้วก็จะถือเป็นโมฆะ",
  T_48_META_API_3016_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3016_P1_D: "นิติบุคคลผูกมัดกับกระเป๋าเงินซึ่งเป็นเจ้าของกระเป๋าเงิน",
  T_48_META_API_3016_P2_D: "นิติบุคคลกระเป๋าเงิน",
  T_48_META_API_3017_D: "เพิ่มสกุลเงินในกระเป๋าเงินที่ระบุ",
  T_48_META_API_3017_P0_D: "กระเป๋าเงินเป้าหมาย",
  T_48_META_API_3017_P1_D: "เพิ่มประเภทสกุลเงิน",
  T_48_META_API_3017_P2_D: "จำนวนสกุลเงินที่เพิ่มขึ้น",
  T_48_META_API_3018_D: "ลดสกุลเงินสำหรับกระเป๋าเงินที่ระบุ",
  T_48_META_API_3018_P0_D: "กระเป๋าเงินเป้าหมาย",
  T_48_META_API_3018_P1_D: "ประเภทสกุลเงินที่ลดลง",
  T_48_META_API_3018_P2_D: "จำนวนเงินที่ลดลง",
  T_48_META_API_3019_D: "โอนสกุลเงินจากกระเป๋าเงินหนึ่งไปยังอีกกระเป๋าหนึ่ง",
  T_48_META_API_3019_P0_D: "กระเป๋าเงินสำหรับโอนเงินจาก",
  T_48_META_API_3019_P1_D: "ประเภทของสกุลเงินที่โอน",
  T_48_META_API_3019_P2_D: "จำนวนเงินที่โอน",
  T_48_META_API_3019_P3_D: "กระเป๋าเงินเพื่อโอนเงินไปที่",
  T_48_META_API_3020_D: "รับจำนวนสกุลเงินประเภทที่ระบุในกระเป๋าเงินที่ระบุ",
  T_48_META_API_3020_P0_D: "กระเป๋าเงินเป้าหมาย",
  T_48_META_API_3020_P1_D: "ค้นหาประเภทสกุลเงิน",
  T_48_META_API_3020_R_D: "ปริมาณสกุลเงิน",
  T_48_META_API_3021_D: "รับเอนทิตีของสกุลเงินประเภทที่ระบุในกระเป๋าเงินที่ระบุ",
  T_48_META_API_3021_P0_D: "กระเป๋าเงินเป้าหมาย",
  T_48_META_API_3021_P1_D: "ค้นหาประเภทสกุลเงิน",
  T_48_META_API_3021_R_D: "นิติบุคคลทางการเงิน",
  T_48_META_API_3022_D: "รับร้านค้าทั้งหมดในเกมกลับมาเป็นรายการ",
  T_48_META_API_3022_R_D: "รายการเอนทิตีของร้านค้า",
  T_48_META_API_3023_D: "แทนที่รูปลักษณ์ของผู้เล่นเป้าหมายด้วยรูปลักษณ์ของวัตถุฉากที่ระบุ",
  T_48_META_API_3023_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3023_P1_D: "เปลี่ยนวัตถุฉากเป้าหมาย",
  T_48_META_API_3023_P2_D: "องค์ประกอบปลอมแปลงการเปลี่ยนแปลงของผู้เล่นที่สร้างขึ้นหลังจากการแทนที่",
  T_48_META_API_3024_D: "ยกเลิกสถานะการปลอมตัวของผู้เล่น",
  T_48_META_API_3024_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3025_D: "สร้างโคลนของเอนทิตีฉากที่ผู้เล่นเป้าหมาย",
  T_48_META_API_3025_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3025_P1_D: "เอนทิตีฉากที่ใช้สำหรับอวตาร",
  T_48_META_API_3025_P2_D: "สร้างเอนทิตีโคลน",
  T_48_META_API_3026_D: "รับเอนทิตีปลอมตัวของผู้เล่น",
  T_48_META_API_3026_P0_D: "ผู้เล่น",
  T_48_META_API_3026_R_D: "ผู้เล่นที่ปลอมตัวเป็นนิติบุคคล",
  T_48_META_API_3027_D: "รับเอนทิตีช่องทางการแชทตามดัชนี",
  T_48_META_API_3027_P0_D: "ดัชนีช่องแชท ช่วง [1,8]",
  T_48_META_API_3027_R_D: "เอนทิตีช่องแชท",
  T_48_META_API_3028_D: "รับเอนทิตีช่องแชทที่ผู้เล่นที่ระบุอยู่ในปัจจุบัน",
  T_48_META_API_3028_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3028_R_D: "เอนทิตีช่องแชท",
  T_48_META_API_3029_D: "ให้ผู้เล่นเข้าร่วมช่องแชทที่ระบุ หากผู้เล่นอยู่ในช่องแชทอื่นอยู่แล้ว เขาจะสลับไปยังช่องแชทเป้าหมาย",
  T_48_META_API_3029_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3029_P1_D: "เอนทิตีช่องแชท",
  T_48_META_API_3030_D: "ทำให้ผู้เล่นออกจากช่องปัจจุบันแล้วอยู่ในสถานะไม่อยู่ในช่องแชทใดๆ",
  T_48_META_API_3030_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3031_D: "เลิกใช้แล้ว",
  T_48_META_API_3031_P0_D: "เอนทิตีช่องแชท ว่างเปล่าเมื่อไม่มีผู้เล่นในช่อง",
  T_48_META_API_3032_D: "ตั้งค่าสถานะพฤติกรรมของผู้เล่น",
  T_48_META_API_3032_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3032_P1_D: "ประเภทพฤติกรรมของผู้เล่น",
  T_48_META_API_3032_P2_D: `เปิดใช้งาน: มีปุ่ม HUD และสามารถใช้งานได้ตามปกติ
ปิดใช้งาน: ปุ่ม HUD ถูกปิดใช้งานและไม่สามารถเข้าสู่สถานะพฤติกรรมทั้งแบบแอ็คทีฟหรือแบบพาสซีฟได้
Shield: ปุ่ม HUD ถูกซ่อนไว้และไม่สามารถเข้าสู่สถานะพฤติกรรมได้ แต่สามารถเข้าสู่สถานะพฤติกรรมแบบพาสซีฟได้ สภาว`,
  T_48_META_API_3033_D: "ผู้เล่นแปลงร่างเป็นวัตถุฉากที่ระบุ",
  T_48_META_API_3033_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3033_P1_D: "วัตถุที่จะแปลงร่างเป็น",
  T_48_META_API_3033_P2_D: "เอนทิตีที่สร้างขึ้นหลังการเปลี่ยนแปลง",
  T_48_META_API_3034_D: "ผู้เล่นสร้างร่างโคลนของตัวเอง",
  T_48_META_API_3034_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3034_P1_D: "สร้างเอนทิตีโคลน",
  T_48_META_API_3035_D: "สร้างร้านค้าแบบกำหนดเองโดยที่ระดับถัดไปของร้านค้าคือชั้นวาง",
  T_48_META_API_3035_P0_D: "สร้างเอนทิตีร้านค้า",
  T_48_META_API_3036_D: "สร้างชั้นวางแบบกำหนดเอง ชั้นบนของชั้นวางคือร้านค้าและระดับถัดไปคือสินค้า",
  T_48_META_API_3036_P0_D: "สร้างเอนทิตีชั้นวางแล้ว",
  T_48_META_API_3037_D: "สร้างผลิตภัณฑ์แบบกำหนดเองที่สามารถเพิ่มรายการได้",
  T_48_META_API_3037_P0_D: "สร้างเอนทิตีผลิตภัณฑ์",
  T_48_META_API_3038_D: "เพิ่มสินค้าลงในผลิตภัณฑ์ สามารถเพิ่มสินค้าหลายรายการลงในผลิตภัณฑ์เดียวได้โดยใช้ข้อมูลพื้นฐานนี้หลายครั้ง",
  T_48_META_API_3038_P0_D: "เอนทิตีสินค้าโภคภัณฑ์",
  T_48_META_API_3038_P1_D: "รายการที่จะเพิ่ม",
  T_48_META_API_3038_P2_D: "ปริมาณรายการ",
  T_48_META_API_3039_D: "ให้รางวัลการแหกคุก",
  T_48_META_API_3039_P0_D: "เอนทิตีผู้เล่น",
  T_48_META_API_3039_P1_D: "ปริมาณ",
  T_48_META_API_3039_P2_D: "เงินจริง",
  T_48_META_API_3040_D: "อัปเดตงานการแหกคุก",
  T_48_META_API_3040_P0_D: "เอนทิตีผู้เล่น",
  T_48_META_API_3040_P1_D: "รหัสงาน",
  T_48_META_API_3040_P2_D: "ค่า",
  T_48_META_API_3041_D: "การได้รับพิกัดจุดเกิดแบบสุ่มจะสุ่มจากจุดเกิดที่มีอยู่ซึ่งไม่ได้ถูกครอบครองจนเต็มเท่านั้น",
  T_48_META_API_3041_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3041_R_D: "พิกัดจุดเกิดแบบสุ่ม หากไม่มีจุดเกิดที่ตรงตามเงื่อนไข ตำแหน่งที่ใกล้กับ (0, 0, 0) จะถูกส่งกลับ",
  T_48_META_API_3042_D: "ออกจากมินิเกมเจลเบรค",
  T_48_META_API_3042_P0_D: "เอนทิตีผู้เล่น",
  T_48_META_API_3042_P1_D: "รหัสงาน",
  T_48_META_API_3043_D: "ขึ้นอยู่กับอุปกรณ์ประกอบฉากแหกคุก",
  T_48_META_API_3043_P0_D: "เอนทิตีผู้เล่น",
  T_48_META_API_3043_P1_D: "ประเภทเสา",
  T_48_META_API_3043_P2_D: "รหัสอุปกรณ์ประกอบฉาก",
  T_48_META_API_31_D: "สร้างการเคลื่อนไหวด้วยตนเองแบบสัมพันธ์ และเอนทิตีเป้าหมายจะเปลี่ยนแปลงโดยสัมพันธ์กับค่าคุณลักษณะปัจจุบันในแต่ละครั้ง",
  T_48_META_API_31_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_31_P1_D: "คุณลักษณะที่ต้องมีการเปลี่ยนแปลงการเคลื่อนไหว",
  T_48_META_API_31_P2_D: "จำนวนการเปลี่ยนแปลงต่อการเคลื่อนไหว",
  T_48_META_API_31_P3_D: "จุดควบคุมเส้นโค้งเบซิเยร์",
  T_48_META_API_31_P4_D: `เดี่ยว: หยุดเมื่อคุณลักษณะเปลี่ยนจำนวนเดลต้า
วนซ้ำ: ทำซ้ำการเคลื่อนไหว แต่ละครั้งที่คุณลักษณะเปลี่ยนจำนวนเดลต้า`,
  T_48_META_API_31_P5_D: "ระยะเวลาของการเปลี่ยนแปลง หน่วยเป็นมิลลิวินาที",
  T_48_META_API_31_P6_D: "เอนทิตีที่เคลื่อนไหวด้วยตนเองแบบสัมพัทธ์ที่สร้างขึ้น",
  T_48_META_API_31_P7_D: "จะเริ่มเล่นโดยอัตโนมัติหลังจากสร้างหรือไม่",
  T_48_META_API_3100_D: "เป้าหมายเล่นภาพเคลื่อนไหวในสถานะที่ระบุ",
  T_48_META_API_3100_P0_D: "ส่วนประกอบเอนทิตีที่สามารถติดตั้งด้วยตัวควบคุมภาพเคลื่อนไหวเพื่อเล่นภาพเคลื่อนไหว",
  T_48_META_API_3100_P1_D: "สถานะที่ระบุของตัวควบคุมภาพเคลื่อนไหว",
  T_48_META_API_3100_P2_D: "การปรับขนาดความเร็วในการเล่นภาพเคลื่อนไหว",
  T_48_META_API_3100_P3_D: "ประเภทวนซ้ำ คุณสามารถเก็บตรรกะดั้งเดิมของภาพเคลื่อนไหวไว้ เล่นเพียงครั้งเดียวหรือเล่นวนซ้ำได้",
  T_48_META_API_3101_D: "เล่นภาพเคลื่อนไหวของตัวละครและสนับสนุนทรัพยากรภาพเคลื่อนไหวที่กำหนดเอง",
  T_48_META_API_3101_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3101_P1_D: "รหัสทรัพยากรภาพเคลื่อนไหวที่กำหนดเอง",
  T_48_META_API_3101_P2_D: "ไม่ว่าจะวนซ้ำ",
  T_48_META_API_3102_D: "ตั้งค่าทรัพยากรตัวละครของผู้เล่นที่ระบุ",
  T_48_META_API_3102_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3102_P1_D: "รหัสทรัพยากรบทบาทที่กำหนดเอง",
  T_48_META_API_3109_D: "เปิดพื้นที่ปลอดภัยที่จะเคลื่อนที่อย่างราบรื่นไปยังจุดสิ้นสุด",
  T_48_META_API_3109_P0_D: "ตำแหน่งเริ่มต้นของโซนปลอดภัย",
  T_48_META_API_3109_P1_D: "ตำแหน่งสิ้นสุดโซนปลอดภัย",
  T_48_META_API_3109_P2_D: "รัศมีเริ่มต้นของเขตปลอดภัย",
  T_48_META_API_3109_P3_D: "รัศมีสุดท้ายของเขตปลอดภัย",
  T_48_META_API_3109_P4_D: "เวลาที่ต้องใช้เพื่อให้โซนปลอดภัยถึงสถานะสุดท้าย มีหน่วยเป็นวินาที",
  T_48_META_API_3109_P5_D: "จำนวนความเสียหายที่ได้รับต่อวินาทีนอกเขตปลอดภัย",
  T_48_META_API_3110_D: "สลับกลุ่มลักษณะตัวละคร",
  T_48_META_API_3110_P0_D: "เป้า",
  T_48_META_API_3110_P1_D: "กลุ่มรูปลักษณ์",
  T_48_META_API_3111_D: "แสดงกลุ่มลักษณะตัวละคร",
  T_48_META_API_3111_P0_D: "เป้า",
  T_48_META_API_3111_P1_D: "กลุ่มรูปลักษณ์",
  T_48_META_API_3112_D: "ซ่อนกลุ่มลักษณะตัวละคร",
  T_48_META_API_3112_P0_D: "เป้า",
  T_48_META_API_3112_P1_D: "กลุ่มรูปลักษณ์",
  T_48_META_API_3121_D: "ส่งผลการยืนยันไปยังการใช้งานสถิติพีซีของ Craftland Studio",
  T_48_META_API_3121_P0_D: "การแสดงออกยืนยัน",
  T_48_META_API_3121_P1_D: "คำใบ้",
  T_48_META_API_32_D: "รับข้อมูลโทเค็นของผู้เล่นวันนี้",
  T_48_META_API_32_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_32_P1_D: "โทเค็นไอดี",
  T_48_META_API_32_P2_D: "จำนวนโทเค็น",
  T_48_META_API_32_P3_D: "ไม่ว่าจะเรียกดั้งเดิมสำเร็จหรือไม่",
  T_48_META_API_3200_D: "เพิ่มรายการให้กับเครื่องเล่นและส่งคืนรายการรายการที่ออก",
  T_48_META_API_3200_P0_D: "ผู้เล่น",
  T_48_META_API_3200_P1_D: "รหัสรายการ",
  T_48_META_API_3200_P2_D: "ปริมาณรายการ",
  T_48_META_API_3200_P3_D: "รายการที่เพิ่มสำหรับผู้เล่น กลับเป็นรายการแม้ว่าจะมีการเพิ่มเพียงรายการเดียวก็ตาม",
  T_48_META_API_3201_D: "คืนค่าปริมาตรเลือดของผู้เล่นที่ระบุ โดยไม่เกินขีดจำกัดบนของปริมาตรเลือด",
  T_48_META_API_3201_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3201_P1_D: "ค่าสำหรับเติมเลือดให้กับผู้เล่นเท่านั้นที่ยอมรับได้",
  T_48_META_API_3202_D: "กำหนดรายการทักษะของผู้เล่นเป้าหมาย",
  T_48_META_API_3202_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3202_P1_D: "รายการทักษะ",
  T_48_META_API_3203_D: "รับรายการทักษะของผู้เล่นเป้าหมาย",
  T_48_META_API_3203_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3203_R_D: "รายการทักษะ",
  T_48_META_API_3205_D: "ลบรายการจำนวนหนึ่งออกจากเครื่องเล่น",
  T_48_META_API_3205_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3205_P1_D: "ประเภทรายการที่จะลบ",
  T_48_META_API_3205_P2_D: "จำนวนที่จะลบ หากเกินจำนวนที่ผู้เล่นถืออยู่ เฉพาะรายการที่ถืออยู่เท่านั้นที่จะถูกลบ",
  T_48_META_API_3206_D: "รับจำนวนรายการที่ระบุที่ถือโดยผู้เล่น",
  T_48_META_API_3206_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3206_P1_D: "ประเภทรายการ",
  T_48_META_API_3206_R_D: "จำนวนเงินที่ผู้เล่นถืออยู่",
  T_48_META_API_3207_D: "ตรวจสอบว่าผู้เล่นสามารถเรียกจุดตรวจปัจจุบันได้หรือไม่",
  T_48_META_API_3207_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3207_P1_D: "ไกปืน",
  T_48_META_API_3207_R_D: "จริง: สามารถทริกเกอร์ได้ เท็จ: ไม่สามารถทริกเกอร์ได้",
  T_48_META_API_3208_D: "วิวัฒนาการซอมบี้โหมดการติดเชื้อ",
  T_48_META_API_3208_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3209_D: "เอนทิตี AI หยุด/ดำเนินการแผนผังพฤติกรรมเริ่มต้น",
  T_48_META_API_3209_P0_D: "เพื่อเปิดใช้งานเป้าหมายแผนผังพฤติกรรม",
  T_48_META_API_3209_P1_D: "ไม่ว่าจะดำเนินการแผนผังพฤติกรรมเริ่มต้นหรือไม่",
  T_48_META_API_3210_D: "หน่วยงาน AI ไล่ล่าเป้าหมายที่กำหนด",
  T_48_META_API_3210_P0_D: "เอนทิตี AI ที่ดำเนินการติดตาม",
  T_48_META_API_3210_P1_D: "เป้าหมายที่กำลังติดตาม",
  T_48_META_API_3211_D: "ทำลายรายการผู้เล่น (เลิกใช้แล้ว ใช้ DeleteEquipment)",
  T_48_META_API_3211_P0_D: "ผู้เล่นที่ไอเทมถูกทำลาย",
  T_48_META_API_3211_P1_D: "ประเภทรายการที่ถูกทำลาย",
  T_48_META_API_3211_P2_D: "ช่องอาวุธ มีผลเฉพาะกับอาวุธเท่านั้น",
  T_48_META_API_3212_D: "เปลี่ยนเสื้อ",
  T_48_META_API_3212_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3212_P1_D: "สไตล์เสื้อผ้า",
  T_48_META_API_3212_P2_D: "สีหลักหนึ่ง",
  T_48_META_API_3212_P3_D: "สีหลักสอง",
  T_48_META_API_3212_P4_D: "การกำหนดค่า",
  T_48_META_API_3213_D: "ฟื้นฟูเสื้อของผู้เล่นให้กลับสู่สภาพเดิม",
  T_48_META_API_3213_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3214_D: "เปิดและปิดการแชทด้วยเสียงของผู้เล่น",
  T_48_META_API_3214_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3214_P1_D: "ไม่ว่าจะปิดการแชทด้วยเสียง จริง: ปิดเท็จ: เปิด",
  T_48_META_API_3215_D: "สลับผู้เล่นแชทด่วน",
  T_48_META_API_3215_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3215_P1_D: "ไม่ว่าจะปิดแชทด่วน True: ปิด False: เปิด",
  T_48_META_API_3216_D: "กำหนดว่าผู้เล่นเป้าหมายจะสามารถรับไอเทมได้หรือไม่",
  T_48_META_API_3216_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3216_P1_D: "ไม่ว่าจะห้ามหยิบของ จริง: ห้ามหยิบของ เท็จ: สามารถรับได้",
  T_48_META_API_3217_D: "กำหนดว่าผู้เล่นเป้าหมายสามารถดรอปไอเทมได้หรือไม่",
  T_48_META_API_3217_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3217_P1_D: "ไม่ว่าจะห้ามวางของ จริง: ห้ามหยิบ เท็จ: หยิบได้",
  T_48_META_API_3218_D: "ทำลายอาวุธในช่องที่ผู้เล่นกำหนด",
  T_48_META_API_3218_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3218_P1_D: "ช่องอาวุธที่จะทำลาย",
  T_48_META_API_3218_P2_D: "ปริมาณที่จะทำลาย",
  T_48_META_API_3218_P3_D: "ไม่ว่าจะถูกทำลายสำเร็จหรือไม่ก็ตาม หากไม่มีอาวุธติดตั้งอยู่ในช่องอาวุธ การทำลายก็จะล้มเหลว",
  T_48_META_API_3219_D: "เคลียร์ไอเทมทั้งหมดออกจากกระเป๋าเป้สะพายหลังของผู้เล่นเป้าหมาย รวมถึงไอเทมที่สวมใส่ด้วย",
  T_48_META_API_3219_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3220_D: "กำหนดทิศทางของผู้เล่น",
  T_48_META_API_3220_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3220_P1_D: "ทิศทางของผู้เล่น",
  T_48_META_API_3221_D: "(เลิกใช้แล้ว โปรดอย่าใช้ สำหรับข้อมูลที่เกี่ยวข้อง โปรดดูแอตทริบิวต์ <Player>:Skeleton)",
  T_48_META_API_3221_P0_D: "เอนทิตีผู้เล่น",
  T_48_META_API_3221_P1_D: "ส่วนการซูม",
  T_48_META_API_3221_P2_D: "ค่าการซูม",
  T_48_META_API_3222_D: "ให้ผลกระทบการขับไล่ให้กับผู้เล่น ผู้เล่นเป้าหมายจะตกลงด้วยความเร่งความช้าที่กำหนดไว้ และผลกระทบการขับไล่จะหยุดชะงักเมื่อชนกันในอากาศ",
  T_48_META_API_3222_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3222_P1_D: "ทิศทางการบิน",
  T_48_META_API_3222_P2_D: "ระยะเวลาน็อคอัพ",
  T_48_META_API_3222_P3_D: "ความเร็วเริ่มต้นของแกน Y เมื่อบิน",
  T_48_META_API_3222_P4_D: "ความเร็วเริ่มต้นของเครื่องบิน XZ เมื่อบิน",
  T_48_META_API_3222_P5_D: "ไม่ว่าจะเปลี่ยนการวางแนวของผู้เล่น",
  T_48_META_API_3223_D: "รับรหัสเสื้อผ้าของผู้เล่นเป้าหมายหรือ NPC",
  T_48_META_API_3223_P0_D: "ผู้เล่นเป้าหมายหรือ NPC",
  T_48_META_API_3223_P1_D: "ประเภทเสื้อผ้า",
  T_48_META_API_3223_R_D: "รหัสเสื้อผ้า",
  T_48_META_API_3224_D: "กำหนดรหัสเสื้อผ้าของผู้เล่นเป้าหมายหรือ NPC",
  T_48_META_API_3224_P0_D: "ผู้เล่นเป้าหมายหรือ NPC",
  T_48_META_API_3224_P1_D: "รหัสเสื้อผ้า",
  T_48_META_API_3225_D: "คืนค่าเสื้อผ้าเริ่มต้นของผู้เล่นเป้าหมาย ซึ่งไม่สามารถใช้กับ NPC ได้",
  T_48_META_API_3225_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3226_D: "เอนทิตี AI โจมตีเป้าหมายที่กำหนด",
  T_48_META_API_3226_P0_D: "เอนทิตี AI ที่ทำการโจมตี",
  T_48_META_API_3226_P1_D: "เป้าหมายของการโจมตี",
  T_48_META_API_3227_D: "สลับอาวุธของผู้เล่นเป็นอาวุธในช่องที่ระบุ",
  T_48_META_API_3227_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3227_P1_D: "ช่องอาวุธที่จะเปลี่ยน",
  T_48_META_API_3227_P2_D: "ไม่ว่าสวิตช์จะสำเร็จหรือไม่ก็ตาม หากไม่มีอาวุธติดตั้งอยู่ในช่องอาวุธ สวิตช์ก็จะล้มเหลว",
  T_48_META_API_3228_D: "รับสกินอาวุธของผู้เล่นเป้าหมายหรือ NPC",
  T_48_META_API_3228_P0_D: "ผู้เล่นเป้าหมายหรือ NPC",
  T_48_META_API_3228_P1_D: "ID สกินอาวุธ",
  T_48_META_API_3228_R_D: "ID สกินอาวุธ",
  T_48_META_API_3229_D: "กำหนดสกินอาวุธของผู้เล่นเป้าหมายหรือ NPC",
  T_48_META_API_3229_P0_D: "ผู้เล่นเป้าหมายหรือ NPC",
  T_48_META_API_3229_P1_D: "ID สกินอาวุธ",
  T_48_META_API_3230_D: "คืนค่าสกินอาวุธเริ่มต้นของผู้เล่นเป้าหมาย ซึ่งไม่สามารถใช้กับ NPC ได้",
  T_48_META_API_3230_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3230_P1_D: "รหัสอาวุธ",
  T_48_META_API_3231_D: "จัดเตรียมเครื่องแต่งกายของผู้เล่น",
  T_48_META_API_3231_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3231_P1_D: "รายการเครื่องแต่งกาย",
  T_48_META_API_3232_D: "ถอดเสื้อผ้าทั้งหมดของประเภทเสื้อผ้าที่ระบุออกจากผู้เล่นเป้าหมายหรือ NPC",
  T_48_META_API_3232_P0_D: "ผู้เล่นเป้าหมายหรือ NPC",
  T_48_META_API_3232_P1_D: "ประเภทเสื้อผ้า",
  T_48_META_API_3233_D: "ลบสกินของอาวุธที่ผู้เล่นหรือ NPC ระบุออก",
  T_48_META_API_3233_P0_D: "ผู้เล่นเป้าหมายหรือ NPC",
  T_48_META_API_3233_P1_D: "รหัสอาวุธ",
  T_48_META_API_3234_D: "เพิ่มบัฟให้กับเป้าหมาย",
  T_48_META_API_3234_P0_D: "เอนทิตีเป้าหมายจะต้องเป็นเอนทิตีที่สามารถเพิ่มบัฟได้",
  T_48_META_API_3234_P1_D: "รหัสบัฟ",
  T_48_META_API_3235_D: "ลบบัฟออกจากเป้าหมาย",
  T_48_META_API_3235_P0_D: "เอนทิตีเป้าหมายจะต้องเป็นเอนทิตีที่สามารถเพิ่มบัฟได้",
  T_48_META_API_3235_P1_D: "รหัสบัฟ",
  T_48_META_API_3236_D: "รับบัฟปัจจุบันของเป้าหมาย",
  T_48_META_API_3236_P0_D: "เอนทิตีเป้าหมายจะต้องเป็นเอนทิตีที่สามารถเพิ่มบัฟได้",
  T_48_META_API_3236_R_D: "รายการบัฟ",
  T_48_META_API_3237_D: "รับไอเทมในกระเป๋าเป้สะพายหลังของผู้เล่นเป้าหมาย",
  T_48_META_API_3237_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3237_P1_D: "รายการอุปกรณ์ประกอบฉาก",
  T_48_META_API_3238_D: "การเพิ่มอุปกรณ์เสริมให้กับอาวุธในช่องที่ระบุจะไม่ถูกเพิ่ม การจับคู่ แต่อุปกรณ์เสริมที่ซ้ำกันจะเข้ามาแทนที่อุปกรณ์เสริมดั้งเดิมจะถูกส่งไปยังกระเป๋าเป้สะพายหลังของผู้เล่น อุปกรณ์เสริมดั้งเดิมจะถูกเพิ่มมาให้ที่ตำแหน่งปัจจุบันของผู้เล่น",
  T_48_META_API_3238_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3238_P1_D: "ช่องอุปกรณ์",
  T_48_META_API_3238_P2_D: "เครื่องประดับ",
  T_48_META_API_3238_P3_D: `ไม่ว่าจะเพิ่มอุปกรณ์เสริมสำเร็จหรือไม่
จริง: อุปกรณ์เสริมได้รับการติดตั้งกับอาวุธในช่องที่เกี่ยวข้อง
เท็จ: ไม่สามารถเพิ่มอุปกรณ์เสริมได้และจะไม่ปรากฏในกระเป๋าเป้สะพายหลังของผู้เล่น`,
  T_48_META_API_3238_P4_D: "เพิ่มอุปกรณ์เสริม ว่างเปล่าหากล้มเหลว",
  T_48_META_API_3239_D: "รับอุปกรณ์ในคอลัมน์อุปกรณ์กระเป๋าเป้สะพายหลัง",
  T_48_META_API_3239_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3239_P1_D: "ช่องอุปกรณ์",
  T_48_META_API_3239_P2_D: "อุปกรณ์ในช่องที่กำหนดหากไม่มีอุปกรณ์ก็จะว่างเปล่า",
  T_48_META_API_3239_P3_D: "อุปกรณ์เสริมทั้งหมดสำหรับอุปกรณ์นี้",
  T_48_META_API_3240_D: "ใช้องค์ประกอบ X ของเวกเตอร์สองมิติ",
  T_48_META_API_3240_P0_D: "เวกเตอร์ 2 มิติ",
  T_48_META_API_3240_R_D: "องค์ประกอบ X เวกเตอร์สองมิติ",
  T_48_META_API_3241_D: "ใช้องค์ประกอบ Y ของเวกเตอร์สองมิติ",
  T_48_META_API_3241_P0_D: "เวกเตอร์ 2 มิติ",
  T_48_META_API_3241_R_D: "องค์ประกอบ Y เวกเตอร์สองมิติ",
  T_48_META_API_3242_D: "เวกเตอร์ 2 มิติตั้งค่าองค์ประกอบ X",
  T_48_META_API_3242_P0_D: "เวกเตอร์ 2 มิติ",
  T_48_META_API_3242_P1_D: "องค์ประกอบ X เวกเตอร์สองมิติ",
  T_48_META_API_3243_D: "เวกเตอร์ 2 มิติตั้งค่าองค์ประกอบ Y",
  T_48_META_API_3243_P0_D: "เวกเตอร์ 2 มิติ",
  T_48_META_API_3243_P1_D: "องค์ประกอบ Y เวกเตอร์สองมิติ",
  T_48_META_API_3244_D: "เพิ่มเวกเตอร์ 2D สองตัว",
  T_48_META_API_3244_P0_D: "ซ้าย",
  T_48_META_API_3244_P1_D: "ขวา",
  T_48_META_API_3244_R_D: "ผลลัพธ์การบวกเวกเตอร์สองมิติ",
  T_48_META_API_3245_D: "ลบเวกเตอร์ 2D สองตัว",
  T_48_META_API_3245_P0_D: "ซ้าย",
  T_48_META_API_3245_P1_D: "ขวา",
  T_48_META_API_3245_R_D: "ผลการลบเวกเตอร์สองมิติ",
  T_48_META_API_3246_D: "คูณเวกเตอร์สองมิติ",
  T_48_META_API_3246_P0_D: "เวกเตอร์ 2 มิติ",
  T_48_META_API_3246_P1_D: "ค่าสเกลเวกเตอร์ 2D",
  T_48_META_API_3246_R_D: "ผลการคูณเวกเตอร์สองมิติ",
  T_48_META_API_3247_D: "ดอทโปรดัคเวกเตอร์สองมิติ ผลลัพธ์ของดอทโปรดัคคือสเกลาร์ ซึ่งแสดงถึงมุมระหว่างเวกเตอร์ทั้งสอง",
  T_48_META_API_3247_P0_D: "ซ้าย",
  T_48_META_API_3247_P1_D: "ขวา",
  T_48_META_API_3247_R_D: "ผลการคูณจุด",
  T_48_META_API_3248_D: "คำนวณระยะทางแบบยุคลิดของเวกเตอร์ 2D สองตัว",
  T_48_META_API_3248_P0_D: "ซ้าย",
  T_48_META_API_3248_P1_D: "ขวา",
  T_48_META_API_3248_R_D: "หลังจากลบเวกเตอร์สองตัวแล้ว ความยาวของโมดูลของเวกเตอร์ผลลัพธ์",
  T_48_META_API_3249_D: "คำนวณมุมระหว่างเวกเตอร์สองมิติสองตัว",
  T_48_META_API_3249_P0_D: "ซ้าย",
  T_48_META_API_3249_P1_D: "ขวา",
  T_48_META_API_3249_R_D: "มุมเวกเตอร์ ช่วงมุม 0-180",
  T_48_META_API_3250_D: "ทำให้เวกเตอร์ 2D เป็นมาตรฐาน",
  T_48_META_API_3250_P0_D: "เวกเตอร์ 2 มิติ",
  T_48_META_API_3250_R_D: "ผลลัพธ์ที่ทำให้เป็นมาตรฐานคือเวกเตอร์ที่มีความยาว 1 เมตรในทิศทางเดียวกัน",
  T_48_META_API_3251_D: "โมดูโล่เวกเตอร์สองมิติ",
  T_48_META_API_3251_P0_D: "เวกเตอร์ 2 มิติ",
  T_48_META_API_3251_R_D: "ผลลัพธ์แบบโมดูโลคือความยาวของเวกเตอร์",
  T_48_META_API_3252_D: "คำนวณเวกเตอร์ของเวกเตอร์สองมิติที่สะท้อนด้วยเส้นตรงแนวตั้งปกติ",
  T_48_META_API_3252_P0_D: "เหตุการณ์เวกเตอร์ 2 มิติ",
  T_48_META_API_3252_P1_D: "เวกเตอร์ 2D ปกติ",
  T_48_META_API_3252_R_D: "การสะท้อนเวกเตอร์ 2 มิติ",
  T_48_META_API_3253_D: "คำนวณเวกเตอร์ของเวกเตอร์สามมิติที่สะท้อนโดยระนาบตั้งฉากกับเส้นปกติ",
  T_48_META_API_3253_P0_D: "เวกเตอร์สามมิติของเหตุการณ์",
  T_48_META_API_3253_P1_D: "เวกเตอร์ 3 มิติปกติ",
  T_48_META_API_3253_R_D: "การสะท้อนเวกเตอร์ 3 มิติ",
  T_48_META_API_3254_D: "แปลงเวกเตอร์สามมิติเป็นเวกเตอร์สองมิติ และลบองค์ประกอบ Z ของเวกเตอร์สามมิติ",
  T_48_META_API_3254_P0_D: "เป้าหมายเวกเตอร์ 3 มิติ",
  T_48_META_API_3254_R_D: "แปลงเวกเตอร์สองมิติ",
  T_48_META_API_3255_D: "แปลงเวกเตอร์สองมิติเป็นเวกเตอร์สามมิติ และตั้งค่าองค์ประกอบ Z ของเวกเตอร์สามมิติเป็น 0",
  T_48_META_API_3255_P0_D: "เป้าหมายเวกเตอร์ 2 มิติ",
  T_48_META_API_3255_R_D: "เวกเตอร์สามมิติที่แปลงแล้ว",
  T_48_META_API_3256_D: "สร้างเวกเตอร์ 2 มิติ",
  T_48_META_API_3256_P0_D: "องค์ประกอบ X ของเวกเตอร์สองมิติ",
  T_48_META_API_3256_P1_D: "องค์ประกอบ Y ของเวกเตอร์สองมิติ",
  T_48_META_API_3256_R_D: "เวกเตอร์สองมิติที่สร้างขึ้น",
  T_48_META_API_3257_D: "ปรับแต่งบันทึกคะแนนการแข่งขันสำหรับการวิเคราะห์ข้อมูลประสบการณ์ผู้ใช้",
  T_48_META_API_3257_P0_D: "บันทึก",
  T_48_META_API_3258_D: "ปรับแต่งบันทึกคะแนนการแข่งขันสำหรับการวิเคราะห์ข้อมูลประสบการณ์ผู้ใช้",
  T_48_META_API_3258_P0_D: "ผู้เล่นที่จะรายงาน",
  T_48_META_API_3258_P1_D: "บันทึก",
  T_48_META_API_33_D: "ตัวกรองคำสกปรก",
  T_48_META_API_33_P0_D: "ข้อความต้นฉบับที่ต้องกรองคำสกปรก",
  T_48_META_API_33_R_D: "ข้อความที่กรองแล้ว",
  T_48_META_API_3301_D: "สร้างเอนทิตีค่าย",
  T_48_META_API_3301_P0_D: "เอนทิตีฝ่าย",
  T_48_META_API_3302_D: "เอนทิตีเป้าหมายเข้าร่วมค่ายที่ระบุ",
  T_48_META_API_3302_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_3302_P1_D: "เอนทิตีฝ่าย",
  T_48_META_API_3303_D: "รับค่ายโจมตีของค่าย",
  T_48_META_API_3303_P0_D: "ค่ายโจมตี",
  T_48_META_API_3303_R_D: "รายการเอนทิตีฝ่าย",
  T_48_META_API_3304_D: "ตั้งค่ายโจมตีของค่าย",
  T_48_META_API_3304_P0_D: "ค่ายโจมตี",
  T_48_META_API_3304_P1_D: "ค่ายเป้าหมาย",
  T_48_META_API_3304_P2_D: "มันสามารถโจมตีได้หรือไม่?",
  T_48_META_API_3305_D: "ตั้งค่าเพื่อโจมตีผู้เล่น",
  T_48_META_API_3305_P0_D: "ผู้เล่น",
  T_48_META_API_3305_P1_D: "สามารถโจมตีผู้เล่นได้",
  T_48_META_API_3305_P2_D: "มันสามารถโจมตีได้หรือไม่?",
  T_48_META_API_3306_D: "ตั้งทีมตัวรุกของทีม",
  T_48_META_API_3306_P0_D: "ทีมโจมตี",
  T_48_META_API_3306_P1_D: "ทีมเป้าหมาย",
  T_48_META_API_3306_P2_D: "มันสามารถโจมตีได้หรือไม่?",
  T_48_META_API_3307_D: "เลิกใช้แล้ว",
  T_48_META_API_3307_P0_D: "เลิกใช้แล้ว",
  T_48_META_API_3307_R_D: "รายชื่อเอนทิตีของผู้เล่น",
  T_48_META_API_3308_D: "เอนทิตีที่ระบุออกจากค่ายปัจจุบัน",
  T_48_META_API_3308_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_3309_D: "รับฝ่ายของเป้าหมาย",
  T_48_META_API_3309_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_3309_R_D: "เอนทิตีฝ่าย",
  T_48_META_API_3310_D: "พิจารณาว่าเป้าหมายสามารถถูกโจมตีได้หรือไม่",
  T_48_META_API_3310_P0_D: "ผู้โจมตี",
  T_48_META_API_3310_P1_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_3310_R_D: "มันสามารถโจมตีได้หรือไม่?",
  T_48_META_API_3311_D: "กำหนดเป้าหมายที่สามารถโจมตีได้สำหรับเอนทิตี",
  T_48_META_API_3311_P0_D: "ผู้โจมตี",
  T_48_META_API_3311_P1_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_3311_P2_D: "มันสามารถโจมตีได้หรือไม่?",
  T_48_META_API_3312_D: "รับเป้าหมายที่สามารถโจมตีได้ของเอนทิตี",
  T_48_META_API_3312_P0_D: "ผู้โจมตี",
  T_48_META_API_3312_R_D: "รายชื่อหน่วยงานที่สามารถโจมตีได้",
  T_48_META_API_34_D: "ตรวจสอบว่าเอนทิตีเป้าหมายมีส่วนประกอบหรือไม่",
  T_48_META_API_34_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_34_P1_D: "ประเภทส่วนประกอบ",
  T_48_META_API_34_R_D: "มีอยู่หรือไม่",
  T_48_META_API_35_D: "เพิ่มบอท",
  T_48_META_API_35_P0_D: "ระดับความยากของบอท",
  T_48_META_API_35_P1_D: "ทีมที่บอทอยู่",
  T_48_META_API_35_P2_D: "เอนทิตีผู้เล่น Bot ที่สร้างขึ้น",
  T_48_META_API_3500_D: "รับข้อมูลโทเค็นของผู้เล่น",
  T_48_META_API_3500_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3500_P1_D: "โทเค็นไอดี",
  T_48_META_API_3500_P2_D: "จำนวนโทเค็น",
  T_48_META_API_3500_P3_D: "ประสบความสำเร็จหรือไม่?",
  T_48_META_API_3501_D: "เพิ่มข้อมูลโทเค็นให้กับผู้เล่น",
  T_48_META_API_3501_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3501_P1_D: "โทเค็นไอดี",
  T_48_META_API_3501_P2_D: "จำนวนโทเค็น",
  T_48_META_API_3501_P3_D: "ไม่ว่าจะเรียกดั้งเดิมสำเร็จหรือไม่",
  T_48_META_API_3502_D: "ใช้โทเค็นของผู้เล่นเป้าหมาย",
  T_48_META_API_3502_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3502_P1_D: "โทเค็นไอดี",
  T_48_META_API_3502_P2_D: "จำนวนโทเค็น",
  T_48_META_API_3502_P3_D: "ไม่ว่าจะเรียกดั้งเดิมสำเร็จหรือไม่",
  T_48_META_API_3503_D: "เพิ่มโทเค็นในตำแหน่งที่ระบุ",
  T_48_META_API_3503_P0_D: "ที่ตั้ง",
  T_48_META_API_3503_P1_D: "โทเค็นไอดี",
  T_48_META_API_3503_P2_D: "จำนวนโทเค็น",
  T_48_META_API_3503_P3_D: "ไม่ว่าจะเรียกดั้งเดิมสำเร็จหรือไม่",
  T_48_META_API_3504_D: "Target AI เผยแพร่ทักษะที่ระบุ",
  T_48_META_API_3504_P0_D: "เป้าหมายเอไอ",
  T_48_META_API_3504_P1_D: "ทักษะ",
  T_48_META_API_3504_P2_D: "เป้าหมายทักษะ",
  T_48_META_API_3504_P3_D: "ไม่ว่าทักษะจะถูกปล่อยออกมาสำเร็จหรือไม่",
  T_48_META_API_3505_D: "สร้างเส้นทางค้นหาเส้นทางจากจุดเริ่มต้นไปยังจุดสิ้นสุด ซึ่งจะข้ามสิ่งกีดขวางและสามารถนำไปใช้ในการค้นหาเส้นทางของ AI ได้",
  T_48_META_API_3505_P0_D: "พิกัดจุดเริ่มต้น",
  T_48_META_API_3505_P1_D: "พิกัดจุดสิ้นสุด",
  T_48_META_API_3505_P2_D: "ไม่ว่าเส้นทางการค้นหาเส้นทางจะถูกสร้างขึ้นสำเร็จหรือไม่",
  T_48_META_API_3505_P3_D: "การรวบรวมจุดบอกทาง",
  T_48_META_API_3506_D: "ตั้งค่าตัวแปรกระดานดำแผนภูมิพฤติกรรม",
  T_48_META_API_3506_P0_D: "ต้นไม้พฤติกรรมเป้าหมาย",
  T_48_META_API_3506_P1_D: "ชื่อตัวแปร",
  T_48_META_API_3506_P2_D: "ค่าตัวแปร",
  T_48_META_API_3507_D: "รับตัวแปรกระดานดำแผนภูมิพฤติกรรม",
  T_48_META_API_3507_P0_D: "ต้นไม้พฤติกรรมเป้าหมาย",
  T_48_META_API_3507_P1_D: "ชื่อตัวแปร",
  T_48_META_API_3507_P2_D: "ค่าตัวแปร",
  T_48_META_API_3508_D: "รับพารามิเตอร์โหนดแผนผังพฤติกรรม",
  T_48_META_API_3508_P0_D: "โหนดต้นไม้พฤติกรรมเป้าหมาย",
  T_48_META_API_3508_P1_D: "ชื่อพารามิเตอร์",
  T_48_META_API_3508_P2_D: "ค่าพารามิเตอร์",
  T_48_META_API_3509_D: "รับสกินพาหนะของผู้เล่นเป้าหมาย",
  T_48_META_API_3509_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3509_P1_D: "รหัสยานพาหนะ",
  T_48_META_API_3509_R_D: "ผิวรถ",
  T_48_META_API_3510_D: "กำหนดสกินพาหนะของผู้เล่นเป้าหมาย",
  T_48_META_API_3510_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3510_P1_D: "ID สกินยานพาหนะ",
  T_48_META_API_3511_D: "ล้างผิวยานพาหนะที่กำหนดของนักเล่นเป้าหมาย",
  T_48_META_API_3511_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3511_P1_D: "รหัสยานพาหนะ",
  T_48_META_API_3512_D: "คืนค่าสกินพาหนะเริ่มต้นของผู้เล่นเป้าหมาย",
  T_48_META_API_3512_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_3512_P1_D: "รหัสยานพาหนะ",
  T_48_META_API_36_D: "เป้าหมายการนอนหลับ สามารถใช้กับวัตถุแข็งประเภทไดนามิกเท่านั้น",
  T_48_META_API_36_P0_D: "เป้าหมายร่างกายแข็งเกร็ง",
  T_48_META_API_37_D: "ปลุกเป้าหมาย ใช้ได้เฉพาะกับวัตถุแข็งประเภทไดนามิกเท่านั้น",
  T_48_META_API_37_P0_D: "เป้าหมายร่างกายแข็งเกร็ง",
  T_48_META_API_38_D: "ตรวจสอบว่าร่างกายแข็งเกร็งของเป้าหมายกำลังหลับอยู่หรือไม่",
  T_48_META_API_38_P0_D: "เป้าหมายร่างกายแข็งเกร็ง",
  T_48_META_API_38_R_D: "นอนอยู่หรือเปล่า",
  T_48_META_API_39_D: "กำหนดเกณฑ์การนอนหลับ",
  T_48_META_API_39_P0_D: "เป้าหมายร่างกายแข็งเกร็ง",
  T_48_META_API_39_P1_D: "เกณฑ์การนอนหลับ ร่างกายที่แข็งเกร็งจะเข้าสู่สถานะสลีปหลังจากที่การเคลื่อนไหวและการหมุนน้อยกว่าค่านี้เป็นระยะเวลาหนึ่ง",
  T_48_META_API_4_D: "ตั้งค่าว่าผู้เล่นทุกคนสามารถเคลื่อนไหวได้หรือไม่",
  T_48_META_API_4_P0_D: `จริง: สามารถเคลื่อนย้ายได้
เท็จ: ไม่สามารถเคลื่อนย้ายได้`,
  T_48_META_API_40_D: "รับเกณฑ์การนอนหลับ",
  T_48_META_API_40_P0_D: "เป้าหมายร่างกายแข็งเกร็ง",
  T_48_META_API_40_R_D: "เกณฑ์การนอนหลับ ร่างกายที่แข็งเกร็งจะเข้าสู่สถานะสลีปหลังจากที่การเคลื่อนไหวและการหมุนน้อยกว่าค่านี้เป็นระยะเวลาหนึ่ง",
  T_48_META_API_4000_D: "อ่านเนื้อหาของตารางทั้งหมดและส่งกลับอาร์เรย์สองมิติตามลำดับแถว",
  T_48_META_API_4000_P0_D: "ชื่อตาราง",
  T_48_META_API_4000_R_D: "เนื้อหาของตาราง",
  T_48_META_API_4001_D: "อ่านเนื้อหาของแถวของตารางและส่งกลับอาร์เรย์",
  T_48_META_API_4001_P0_D: "ชื่อตาราง",
  T_48_META_API_4001_P1_D: "จำนวนแถวที่จะอ่าน เริ่มต้นจาก 1",
  T_48_META_API_4001_R_D: "ตารางระบุเนื้อหาของแถว",
  T_48_META_API_4002_D: "อ่านเนื้อหาของคอลัมน์ในตารางและส่งกลับอาร์เรย์",
  T_48_META_API_4002_P0_D: "ชื่อตาราง",
  T_48_META_API_4002_P1_D: "จำนวนคอลัมน์ที่จะอ่าน เริ่มต้นจาก 1",
  T_48_META_API_4002_R_D: "ตารางระบุเนื้อหาของคอลัมน์",
  T_48_META_API_4003_D: "อ่านเนื้อหาของเซลล์ตาราง",
  T_48_META_API_4003_P0_D: "ชื่อตาราง",
  T_48_META_API_4003_P1_D: "จำนวนแถวที่จะอ่าน เริ่มต้นจาก 1",
  T_48_META_API_4003_P2_D: "จำนวนคอลัมน์ที่จะอ่าน เริ่มต้นจาก 1",
  T_48_META_API_4003_R_D: "เนื้อหาของเซลล์ที่ระบุในตาราง",
  T_48_META_API_4004_D: "อ่านเนื้อหาของเซลล์บางเซลล์ในตารางตามหมายเลขแถวและชื่อคอลัมน์",
  T_48_META_API_4004_P0_D: "ชื่อตาราง",
  T_48_META_API_4004_P1_D: "จำนวนแถวที่จะอ่าน เริ่มต้นจาก 1",
  T_48_META_API_4004_P2_D: "ชื่อคอลัมน์ที่จะอ่าน",
  T_48_META_API_4004_R_D: "เนื้อหาของเซลล์ที่ระบุในตาราง",
  T_48_META_API_4005_D: "อ่านเนื้อหาของตารางทั้งหมดและส่งกลับอาร์เรย์สองมิติ",
  T_48_META_API_4005_P0_D: "ชื่อตาราง",
  T_48_META_API_4005_R_D: "เนื้อหาของตาราง อาร์เรย์สองมิติ",
  T_48_META_API_4006_D: "อ่านเนื้อหาของแถวใดแถวหนึ่งของตารางทั้งหมดและส่งกลับอาร์เรย์",
  T_48_META_API_4006_P0_D: "ชื่อตาราง",
  T_48_META_API_4006_P1_D: "จำนวนแถวที่จะอ่าน เริ่มต้นจาก 1",
  T_48_META_API_4006_R_D: "ตารางระบุเนื้อหาของแถวอาร์เรย์",
  T_48_META_API_4007_D: "อ่านเนื้อหาของคอลัมน์ของทั้งตารางและส่งกลับอาร์เรย์",
  T_48_META_API_4007_P0_D: "ชื่อตาราง",
  T_48_META_API_4007_P1_D: "จำนวนคอลัมน์ที่จะอ่าน เริ่มต้นจาก 1",
  T_48_META_API_4007_R_D: "ตารางระบุเนื้อหาของคอลัมน์อาร์เรย์",
  T_48_META_API_4008_D: "อ่านเนื้อหาของเซลล์ตาราง",
  T_48_META_API_4008_P0_D: "ชื่อตาราง",
  T_48_META_API_4008_P1_D: "จำนวนแถวที่จะอ่าน เริ่มต้นจาก 1",
  T_48_META_API_4008_P2_D: "จำนวนคอลัมน์ที่จะอ่าน เริ่มต้นจาก 1",
  T_48_META_API_4008_R_D: "เนื้อหาของเซลล์ที่ระบุในตาราง",
  T_48_META_API_4009_D: "ค้นหาแถวที่ระบุตามหมายเลขคอลัมน์และค่าเซลล์",
  T_48_META_API_4009_P0_D: "ชื่อตาราง",
  T_48_META_API_4009_P1_D: "จำนวนคอลัมน์ที่จะอ่าน",
  T_48_META_API_4009_P2_D: "ค่าของเซลล์ที่จะค้นหา",
  T_48_META_API_4009_R_D: "เนื้อหาของแถวอาร์เรย์ที่พบ",
  T_48_META_API_4010_D: "รับหมายเลขคอลัมน์ตามชื่อคอลัมน์",
  T_48_META_API_4010_P0_D: "ชื่อตาราง",
  T_48_META_API_4010_P1_D: "ชื่อคอลัมน์สำหรับตรวจสอบหมายเลขซีเรียล",
  T_48_META_API_4010_R_D: "จำนวนคอลัมน์ นับจาก 1",
  T_48_META_API_41_D: "ตั้งค่าขีดจำกัดการนอนหลับโดยรวม ซึ่งใช้ได้เฉพาะกับเนื้อหาที่แข็งประเภทไดนามิกที่สร้างขึ้นใหม่เท่านั้น",
  T_48_META_API_41_P0_D: "เกณฑ์การนอนหลับ ร่างกายที่แข็งเกร็งจะเข้าสู่สถานะสลีปหลังจากที่การเคลื่อนไหวและการหมุนน้อยกว่าค่านี้เป็นระยะเวลาหนึ่ง",
  T_48_META_API_42_D: "รับเกณฑ์การนอนหลับทั่วโลก",
  T_48_META_API_42_R_D: "เกณฑ์การนอนหลับ ค่าเริ่มต้นคือ 0.005 ร่างกายแข็งเกร็งจะเข้าสู่สถานะสลีปหลังจากการเคลื่อนไหวและการหมุนน้อยกว่าค่านี้เป็นระยะเวลาหนึ่ง",
  T_48_META_API_43_D: "แปลงควอเทอร์เนียนที่กำหนดให้เป็นมุมออยเลอร์ ลำดับการหมุนของมุมออยเลอร์คือ YXZ",
  T_48_META_API_43_P0_D: "อินพุตควอเทอร์เนียน",
  T_48_META_API_43_R_D: "กลับมุมออยเลอร์",
  T_48_META_API_44_D: "แปลงมุมออยเลอร์ที่กำหนดให้เป็นควอเทอร์เนียน",
  T_48_META_API_44_P0_D: "ป้อนมุมออยเลอร์",
  T_48_META_API_44_R_D: "ควอเทอร์เนียนกลับมาแล้ว",
  T_48_META_API_45_D: "แปลงการหมุนที่แสดงด้วยมุมแกนเป็นควอเทอร์เนียน",
  T_48_META_API_45_P0_D: "แกนหมุน",
  T_48_META_API_45_P1_D: "มุมการหมุนตามเข็มนาฬิการอบแกนการหมุน",
  T_48_META_API_45_R_D: "ควอเทอร์เนียนกลับมาแล้ว",
  T_48_META_API_46_D: "แปลงควอเทอร์เนียนเพื่อแสดงมุมแกน",
  T_48_META_API_46_P0_D: "อินพุตควอเทอร์เนียน",
  T_48_META_API_46_P1_D: "แกนหมุน",
  T_48_META_API_46_P2_D: "มุมการหมุนตามเข็มนาฬิการอบแกนการหมุน",
  T_48_META_API_47_D: "ตั้งค่าความคืบหน้าในการเสร็จสิ้นงานแบบกำหนดเอง",
  T_48_META_API_47_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_47_P1_D: "รหัสงาน",
  T_48_META_API_47_P2_D: "ความคืบหน้าเสร็จสมบูรณ์ ไม่อนุญาตให้ใช้ตัวเลขติดลบ",
  T_48_META_API_48_D: "สร้างเส้นโค้งเบซิเยร์ที่สามารถใช้เพื่อประมาณการเคลื่อนไหว",
  T_48_META_API_48_P0_D: "จุดควบคุมเส้นโค้ง",
  T_48_META_API_48_R_D: "เส้นโค้งเบซิเยร์",
  T_48_META_API_49_D: "รับรหัสแผนที่ฉาก",
  T_48_META_API_49_P0_D: "รหัสฉาก",
  T_48_META_API_49_R_D: "รหัสแผนที่",
  T_48_META_API_5_D: "ลบวัตถุที่วางอยู่ในฉาก (ล้าสมัย โปรดใช้ DeleteEntity)",
  T_48_META_API_5_P0_D: "เอนทิตีวัตถุที่จะถูกลบ",
  T_48_META_API_50_D: "สร้างการเคลื่อนไหวที่สัมพันธ์กับตัวมันเองทุกๆ เฟรม เอนทิตีเป้าหมายจะเปลี่ยนแอตทริบิวต์ของตัวเองทุกๆ เฟรม และในแต่ละครั้งจะเปลี่ยนโดยสัมพันธ์กับค่าแอตทริบิวต์ปัจจุบัน",
  T_48_META_API_50_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_50_P1_D: "คุณลักษณะที่ต้องมีการเปลี่ยนแปลงการเคลื่อนไหว",
  T_48_META_API_50_P2_D: "จำนวนการเปลี่ยนแปลงต่อการเคลื่อนไหว",
  T_48_META_API_50_P3_D: `การกำหนดค่าเมื่อใช้ร่วมกับโหมดการเคลื่อนไหวอื่นๆ
จริง: สามารถใช้ร่วมกับการเคลื่อนไหวสัมพัทธ์ได้
เท็จ: สามารถใช้ร่วมกับการเคลื่อนไหวสัมบูรณ์ได้`,
  T_48_META_API_50_P4_D: "เอนทิตีการเคลื่อนไหวที่สร้างขึ้นโดยสัมพันธ์กับตัวมันเองต่อเฟรม",
  T_48_META_API_50_P5_D: "จะเริ่มเล่นโดยอัตโนมัติหลังจากสร้างหรือไม่",
  T_48_META_API_5000_D: "อ่านค่าที่สอดคล้องกับคีย์ในตารางในฐานข้อมูล",
  T_48_META_API_5000_P0_D: "ชื่อตารางในฐานข้อมูล",
  T_48_META_API_5000_P1_D: "ทำเครื่องหมายผู้เล่นและจัดการกับสถานการณ์ที่เกิดขึ้นพร้อมกัน",
  T_48_META_API_5000_P2_D: "ชื่อที่กำหนดเองที่ใช้ในการระบุข้อมูล",
  T_48_META_API_5000_P3_D: "ส่งคืนผลลัพธ์การอ่าน",
  T_48_META_API_5000_P4_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูล",
  T_48_META_API_5001_D: "เขียนค่าที่สอดคล้องกับคีย์ในตารางในฐานข้อมูล",
  T_48_META_API_5001_P0_D: "ชื่อตารางในฐานข้อมูล",
  T_48_META_API_5001_P1_D: "ทำเครื่องหมายผู้เล่นและจัดการกับสถานการณ์ที่เกิดขึ้นพร้อมกัน",
  T_48_META_API_5001_P2_D: "ชื่อที่กำหนดเองที่ใช้ในการระบุข้อมูล",
  T_48_META_API_5001_P3_D: "ค่าที่เขียน",
  T_48_META_API_5001_P4_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูลซึ่งสามารถกรอกในช่องว่างได้ แสดงถึงรหัสสนามรบของแผนที่ปัจจุบัน",
  T_48_META_API_5002_D: "ลบค่าที่สอดคล้องกับคีย์บางตัวในตารางบางตัวในฐานข้อมูล",
  T_48_META_API_5002_P0_D: "ชื่อตารางในฐานข้อมูล",
  T_48_META_API_5002_P1_D: "ทำเครื่องหมายผู้เล่นและจัดการกับสถานการณ์ที่เกิดขึ้นพร้อมกัน",
  T_48_META_API_5002_P2_D: "ชื่อที่กำหนดเองที่ใช้ในการระบุข้อมูล",
  T_48_META_API_5002_P3_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูล",
  T_48_META_API_5003_D: "อ่านค่าที่สอดคล้องกับคีย์ในตารางการจัดอันดับในฐานข้อมูล",
  T_48_META_API_5003_P0_D: "ชื่อตารางอันดับในฐานข้อมูล",
  T_48_META_API_5003_P1_D: "ชื่อที่กำหนดเองที่ใช้ในการระบุข้อมูล",
  T_48_META_API_5003_P2_D: "ส่งคืนผลลัพธ์การอ่าน",
  T_48_META_API_5003_P3_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูล",
  T_48_META_API_5004_D: "เขียนค่าที่สอดคล้องกับคีย์ในตารางการจัดอันดับในฐานข้อมูล",
  T_48_META_API_5004_P0_D: "ชื่อตารางอันดับในฐานข้อมูล",
  T_48_META_API_5004_P1_D: "ชื่อที่กำหนดเองที่ใช้ในการระบุข้อมูล",
  T_48_META_API_5004_P2_D: "ค่าที่เขียน",
  T_48_META_API_5004_P3_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูล",
  T_48_META_API_5005_D: "ลบค่าที่สอดคล้องกับคีย์ในตารางการจัดอันดับในฐานข้อมูล",
  T_48_META_API_5005_P0_D: "ชื่อตารางในฐานข้อมูล",
  T_48_META_API_5005_P1_D: "ชื่อที่กำหนดเองที่ใช้ในการระบุข้อมูล",
  T_48_META_API_5005_P2_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูล",
  T_48_META_API_5006_D: "ลบค่าที่สอดคล้องกับการจัดอันดับในตารางการจัดอันดับในฐานข้อมูล",
  T_48_META_API_5006_P0_D: "ชื่อตารางในฐานข้อมูล",
  T_48_META_API_5006_P1_D: "ตำแหน่งในกระดานผู้นำ",
  T_48_META_API_5006_P2_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูล",
  T_48_META_API_5007_D: "อ่านค่าจากการจัดอันดับหนึ่งไปจนถึงการจัดอันดับหนึ่งๆ ในตารางการจัดอันดับในฐานข้อมูล",
  T_48_META_API_5007_P0_D: "ชื่อตารางในฐานข้อมูล",
  T_48_META_API_5007_P1_D: "อันดับเริ่มต้น",
  T_48_META_API_5007_P2_D: "จบอันดับ",
  T_48_META_API_5007_P3_D: "ส่งคืนผลลัพธ์การอ่าน",
  T_48_META_API_5007_P4_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูล",
  T_48_META_API_5008_D: "อ่านค่าที่สอดคล้องกับคีย์ในตารางในฐานข้อมูลสะสม",
  T_48_META_API_5008_P0_D: "ชื่อตารางในฐานข้อมูล",
  T_48_META_API_5008_P1_D: "ชื่อที่กำหนดเองที่ใช้ในการระบุข้อมูล",
  T_48_META_API_5008_P2_D: "ส่งคืนผลลัพธ์การอ่าน",
  T_48_META_API_5008_P3_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูล",
  T_48_META_API_5009_D: "เขียนค่าออฟเซ็ตที่สอดคล้องกับคีย์ในตารางในฐานข้อมูลสะสม",
  T_48_META_API_5009_P0_D: "ชื่อตารางในฐานข้อมูล",
  T_48_META_API_5009_P1_D: "ชื่อที่กำหนดเองที่ใช้ในการระบุข้อมูล",
  T_48_META_API_5009_P2_D: "การดำเนินการทางคณิตศาสตร์สี่ประเภทในปัจจุบันรองรับประเภทต่อไปนี้: ประเภท Int รองรับการบวก การลบ การคูณ การหาร และเศษ ส่วนประเภททศนิยมรองรับการบวก การลบ การคูณ และการหาร",
  T_48_META_API_5009_P3_D: "เขียนค่าออฟเซ็ตแล้ว",
  T_48_META_API_5009_P4_D: "รหัสสนามรบที่สอดคล้องกับฐานข้อมูล",
  T_48_META_API_51_D: "รีเซ็ตเอนทิตีที่สามารถเล่นได้และคืนค่าเอนทิตีที่สามารถเล่นได้เป็นรูปแบบเริ่มต้นโดยไม่ต้องเปลี่ยนสถานะการเล่น",
  T_48_META_API_51_P0_D: "เป้าหมายเอนทิตีที่สามารถเล่นได้",
  T_48_META_API_52_D: "คูณสองควอเทอร์เนียน A*B หมายถึงการหมุน A ก่อนแล้วจึงหมุน B ลำดับการหมุนที่ต่างกันจะนำไปสู่ผลลัพธ์ที่ต่างกัน",
  T_48_META_API_52_P0_D: "ค่าควอเทอร์เนียน",
  T_48_META_API_52_P1_D: "ค่า quaternion",
  T_48_META_API_52_R_D: "ผลควอเทอร์เนียน",
  T_48_META_API_53_D: "สร้างควอเตอร์เนียนที่หมุนไปในทิศทางที่กำหนด",
  T_48_META_API_53_P0_D: "ระบุทิศทาง",
  T_48_META_API_53_P1_D: "ทิศทางขึ้น",
  T_48_META_API_53_R_D: "จำนวนการหมุนที่ต้องใช้ในการจัดตำแหน่งในทิศทางที่กำหนด",
  T_48_META_API_54_D: "การประมาณค่าทรงกลมควอเทอร์เนียนจาก A ถึง B",
  T_48_META_API_54_P0_D: "ค่า",
  T_48_META_API_54_P1_D: "ค่าบี",
  T_48_META_API_54_P2_D: "ความคืบหน้าของการประมาณค่า ช่วงค่า [0,1] เมื่อค่าเป็น 0 ค่าเริ่มต้นจะถูกส่งกลับ เมื่อค่าเป็น 1 ค่าเป้าหมายจะถูกส่งกลับ",
  T_48_META_API_54_R_D: "ผลควอเทอร์เนียน",
  T_48_META_API_57_D: "พิมพ์ข้อมูลเป้าหมายไปยังคอนโซลเพื่อเป็นการเตือน",
  T_48_META_API_57_P0_D: "สิ่งที่ต้องพิมพ์",
  T_48_META_API_58_D: "พิมพ์ข้อมูลเป้าหมายไปยังคอนโซลในรูปแบบข้อผิดพลาด",
  T_48_META_API_58_P0_D: "สิ่งที่ต้องพิมพ์",
  T_48_META_API_59_D: "รับค่าบนเส้นโค้ง",
  T_48_META_API_59_P0_D: "เส้นโค้ง",
  T_48_META_API_59_P1_D: "จุดสุ่มตัวอย่าง ช่วงค่า [0,1]",
  T_48_META_API_59_R_D: "ผลลัพธ์",
  T_48_META_API_6_D: "สร้างวัตถุฉากตามพิกัดที่ระบุ",
  T_48_META_API_6_P0_D: "สร้างเอนทิตีวัตถุฉาก",
  T_48_META_API_6_P1_D: "ตำแหน่งที่สร้างวัตถุ",
  T_48_META_API_6_P2_D: "เมื่อใช้รหัสประเภทออบเจ็กต์ที่สร้างขึ้นในสคริปต์โค้ด คุณต้องลงทะเบียนการแจงนับออบเจ็กต์ระดับในการลงทะเบียนสินทรัพย์ล่วงหน้า",
  T_48_META_API_60_D: "สอดแทรกจากเส้นโค้ง",
  T_48_META_API_60_P0_D: "ประเภทค่า",
  T_48_META_API_60_P1_D: "ค่าเริ่มต้น",
  T_48_META_API_60_P2_D: "ค่าเป้าหมาย",
  T_48_META_API_60_P3_D: "เส้นโค้ง",
  T_48_META_API_60_P4_D: "จุดสุ่มตัวอย่าง ช่วงค่า [0,1]",
  T_48_META_API_60_R_D: "ผลลัพธ์",
  T_48_META_API_6000_D: "เพิ่มสคริปต์สำหรับเอนทิตีเป้าหมาย",
  T_48_META_API_6000_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_6000_P1_D: "รหัสสคริปต์",
  T_48_META_API_6001_D: "ถอนการติดตั้งสคริปต์สำหรับเอนทิตีเป้าหมาย",
  T_48_META_API_6001_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_6001_P1_D: "รหัสสคริปต์",
  T_48_META_API_6002_D: "ตรวจสอบว่าสคริปต์ที่ระบุมีอยู่ในเอนทิตีเป้าหมายหรือไม่",
  T_48_META_API_6002_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_API_6002_P1_D: "รหัสสคริปต์",
  T_48_META_API_6002_R_D: "ไม่ว่าจะมีสคริปต์ที่ระบุอยู่หรือไม่",
  T_48_META_API_61_D: "ตั้งค่าโหนดหลักของการควบคุม UI",
  T_48_META_API_61_P0_D: "โหนดหลัก คุณสามารถระบุการควบคุม UI หรือ UI ที่กำหนดเองได้",
  T_48_META_API_61_P1_D: "โหนดลูก",
  T_48_META_API_62_D: "เลิกใช้แล้ว",
  T_48_META_API_62_P0_D: "เลิกใช้แล้ว",
  T_48_META_API_62_P1_D: "เลิกใช้แล้ว",
  T_48_META_API_62_P2_D: "เลิกใช้แล้ว",
  T_48_META_API_62_P3_D: "เลิกใช้แล้ว",
  T_48_META_API_62_P4_D: "เลิกใช้แล้ว",
  T_48_META_API_63_D: "สร้างรังสีจากกล้องปัจจุบันไปยังจุดสัมผัสหน้าจอ",
  T_48_META_API_63_P0_D: "จุดสัมผัสหน้าจอ",
  T_48_META_API_63_P1_D: "จุดเริ่มต้น",
  T_48_META_API_63_P2_D: "ทิศทางเรย์",
  T_48_META_API_64_D: "อัปโหลดข้อมูลการเรียกเก็บเงินที่กำหนดเอง",
  T_48_META_API_64_P0_D: "เอนทิตีผู้เล่น",
  T_48_META_API_64_P1_D: "ผลการแข่งขัน",
  T_48_META_API_64_P2_D: "ชื่อคะแนน",
  T_48_META_API_64_P3_D: "ค่าคะแนน",
  T_48_META_API_65_D: "เล่นเอฟเฟกต์เสียงที่ระบุ หากมีคุณสมบัติเพิ่มเติมที่จำเป็นต้องตั้งค่า คุณสามารถตั้งค่าคุณสมบัติเอนทิตีได้",
  T_48_META_API_65_P0_D: "สร้างเอนทิตีเอฟเฟกต์เสียง",
  T_48_META_API_65_P1_D: "ผู้เล่นเป้าหมาย เฉพาะผู้เล่นเป้าหมายเท่านั้นที่สามารถได้ยินเสียงเอฟเฟกต์",
  T_48_META_API_65_P2_D: "ประเภทเอฟเฟกต์เสียง",
  T_48_META_API_65_P3_D: "ประเภทห่วง",
  T_48_META_API_65_P4_D: "ไม่ว่าจะเล่นได้ทันที",
  T_48_META_API_66_D: "สร้างเอฟเฟ็กต์ภาพที่ระบุ หากมีคุณสมบัติเพิ่มเติมที่จำเป็นต้องตั้งค่า คุณสามารถตั้งค่าคุณสมบัติเอนทิตีได้",
  T_48_META_API_66_P0_D: "สร้างเอนทิตีเอฟเฟกต์พิเศษ",
  T_48_META_API_66_P1_D: "ผู้เล่นเป้าหมาย มีเพียงผู้เล่นเป้าหมายเท่านั้นที่มองเห็นได้",
  T_48_META_API_66_P2_D: "ประเภทเอฟเฟกต์พิเศษ",
  T_48_META_API_66_P3_D: "ประเภทห่วง",
  T_48_META_API_66_P4_D: "ไม่ว่าจะเล่นได้ทันที",
  T_48_META_API_67_D: "สร้างเอฟเฟกต์เสียงที่ระบุ หากมีคุณสมบัติเพิ่มเติมที่จำเป็นต้องตั้งค่า คุณสามารถตั้งค่าคุณสมบัติเอนทิตีได้",
  T_48_META_API_67_P0_D: "สร้างเอนทิตีเอฟเฟกต์เสียง",
  T_48_META_API_67_P1_D: "ประเภทเอฟเฟกต์เสียง",
  T_48_META_API_67_P2_D: "ประเภทห่วง",
  T_48_META_API_67_P3_D: "ไม่ว่าจะเล่นได้ทันที",
  T_48_META_API_68_D: "แปลงพิกัดโลกเป็นพิกัดหน้าจอ",
  T_48_META_API_68_P0_D: "พิกัดโลก",
  T_48_META_API_68_P1_D: "ไม่ว่าจะทำแผนที่บนหน้าจอ",
  T_48_META_API_68_P2_D: "ที่ตั้งแผนที่",
  T_48_META_API_69_D: "แปลงพิกัดหน้าจอเป็นพิกัดโลก",
  T_48_META_API_69_P0_D: "พิกัดหน้าจอ",
  T_48_META_API_69_P1_D: "ระยะห่างจากหน้าจอ",
  T_48_META_API_69_P2_D: "พิกัดโลก",
  T_48_META_API_7_D: "แปลงค่าเป้าหมายเป็นสตริง",
  T_48_META_API_7_P0_D: "ค่าเป้าหมายที่จะแปลงเป็นสตริง",
  T_48_META_API_7_R_D: "เชือก",
  T_48_META_API_70_D: "ดำเนินการตรวจจับรังสีผ่านการสัมผัสหน้าจอ และส่งคืนเอนทิตีการโจมตีครั้งแรก",
  T_48_META_API_70_P0_D: "สัมผัสหน้าจอหลัก",
  T_48_META_API_70_P1_D: "ระยะการตรวจจับ",
  T_48_META_API_70_P2_D: "เลเยอร์มาสก์ เฉพาะเลเยอร์ที่กรอกแล้วเท่านั้นที่จะเข้าร่วมในการสแกน การเว้นว่างไว้หมายความว่าเลเยอร์ทั้งหมดจะมีส่วนร่วมในการสแกน",
  T_48_META_API_70_P3_D: "เป็นไปได้ไหมที่จะตรวจจับทริกเกอร์",
  T_48_META_API_70_P4_D: "ตีเอนทิตี",
  T_48_META_API_70_P5_D: "พิกัดจุดชน",
  T_48_META_API_70_P6_D: "ระยะทางจากจุดปะทะถึงจุดเริ่มต้น",
  T_48_META_API_70_P7_D: "ตีพื้นผิวปกติ",
  T_48_META_API_71_D: "การตรวจจับรังสีผ่านการสัมผัสหน้าจอ ส่งคืนเอนทิตีการโจมตีทั้งหมด",
  T_48_META_API_71_P0_D: "สัมผัสหน้าจอหลัก",
  T_48_META_API_71_P1_D: "ระยะการตรวจจับ",
  T_48_META_API_71_P2_D: "เลเยอร์มาสก์ เฉพาะเลเยอร์ที่กรอกแล้วเท่านั้นที่จะเข้าร่วมในการสแกน การเว้นว่างไว้หมายความว่าเลเยอร์ทั้งหมดจะมีส่วนร่วมในการสแกน",
  T_48_META_API_71_P3_D: "เป็นไปได้ไหมที่จะตรวจจับทริกเกอร์",
  T_48_META_API_71_P4_D: "รายการเอนทิตีที่ได้รับความนิยม",
  T_48_META_API_71_P5_D: "รายการพิกัดจุดเข้าชม",
  T_48_META_API_71_P6_D: "รายการระยะทางระหว่างจุดปะทะและจุดเริ่มต้น",
  T_48_META_API_71_P7_D: "เข้าชมรายการปกติของพื้นผิว",
  T_48_META_API_72_D: "สร้างเอฟเฟ็กต์ภาพที่ระบุ หากมีคุณสมบัติเพิ่มเติมที่จำเป็นต้องตั้งค่า คุณสามารถตั้งค่าคุณสมบัติเอนทิตีได้",
  T_48_META_API_72_P0_D: "สร้างเอนทิตีเอฟเฟกต์พิเศษ",
  T_48_META_API_72_P1_D: "ประเภทเอฟเฟกต์พิเศษ",
  T_48_META_API_72_P2_D: "ประเภทห่วง",
  T_48_META_API_72_P3_D: "ไม่ว่าจะเล่นได้ทันที",
  T_48_META_API_73_D: "สร้าง UI ในตัวที่ไม่ซิงโครไนซ์กับไคลเอนต์อื่น",
  T_48_META_API_73_P0_D: "สร้างเอนทิตี UI ในตัว",
  T_48_META_API_73_P1_D: "ประเภท UI ในตัว",
  T_48_META_API_74_D: "สร้าง UI แบบกำหนดเองที่จะไม่ถูกซิงค์กับไคลเอนต์อื่น",
  T_48_META_API_74_P0_D: "สร้างเอนทิตี UI แบบกำหนดเอง",
  T_48_META_API_74_P1_D: "ดัชนี UI ที่กำหนดเอง",
  T_48_META_API_75_D: "รับผู้เล่นที่สอดคล้องกับไคลเอนต์ปัจจุบัน",
  T_48_META_API_75_R_D: "เอนทิตีผู้เล่น",
  T_48_META_API_76_D: "สร้างสัตว์ประหลาด AI",
  T_48_META_API_76_P0_D: "เป้าหมายเอไอ",
  T_48_META_API_76_P1_D: "สร้างสถานที่",
  T_48_META_API_76_P2_D: "ประเภทเอไอ",
  T_48_META_API_76_P3_D: "ทีม",
  T_48_META_API_76_P4_D: "ไม่ว่าจะค้นหาศัตรูโดยอัตโนมัติ",
  T_48_META_API_76_P5_D: "โหมดการโจมตี",
  T_48_META_API_76_P6_D: "เส้นทางการเดินทาง",
  T_48_META_API_77_D: "ตั้งค่าองค์ประกอบแรกของเวกเตอร์",
  T_48_META_API_77_P0_D: "เวกเตอร์",
  T_48_META_API_77_P1_D: "ค่าองค์ประกอบแรก",
  T_48_META_API_77_R_D: "เวกเตอร์หลังจากแก้ไของค์ประกอบแรก",
  T_48_META_API_78_D: "ตั้งค่าองค์ประกอบที่สองของเวกเตอร์",
  T_48_META_API_78_P0_D: "เวกเตอร์",
  T_48_META_API_78_P1_D: "ค่าองค์ประกอบที่สอง",
  T_48_META_API_78_R_D: "เวกเตอร์หลังจากแก้ไของค์ประกอบที่สอง",
  T_48_META_API_79_D: "ตั้งค่าองค์ประกอบที่สามของเวกเตอร์",
  T_48_META_API_79_P0_D: "เวกเตอร์",
  T_48_META_API_79_P1_D: "ค่าองค์ประกอบที่สาม",
  T_48_META_API_79_R_D: "เวกเตอร์หลังจากแก้ไของค์ประกอบที่สาม",
  T_48_META_API_8_D: "เปิดพื้นที่ปลอดภัยที่จะย่อไปยังจุดพิกัดกึ่งกลาง",
  T_48_META_API_8_P0_D: "จุดศูนย์กลางของเขตปลอดภัย",
  T_48_META_API_8_P1_D: "รัศมีของเขตปลอดภัย",
  T_48_META_API_8_P2_D: "เวลารอเป็นวินาที หลังจากนั้นโซนปลอดภัยจะเริ่มหดตัวลงสู่จุดกึ่งกลาง",
  T_48_META_API_8_P3_D: "เวลาที่ต้องใช้เพื่อให้พื้นที่ปลอดภัยหดตัวลงสู่จุดศูนย์กลาง หน่วยเป็นวินาที",
  T_48_META_API_8_P4_D: "จำนวนความเสียหายที่ได้รับต่อวินาทีนอกเขตปลอดภัย",
  T_48_META_API_80_D: "ตั้งค่าองค์ประกอบแรกของเวกเตอร์สองมิติ",
  T_48_META_API_80_P0_D: "เวกเตอร์ 2 มิติ",
  T_48_META_API_80_P1_D: "ค่าองค์ประกอบแรก",
  T_48_META_API_80_R_D: "เวกเตอร์สองมิติหลังจากแก้ไของค์ประกอบแรก",
  T_48_META_API_81_D: "ตั้งค่าองค์ประกอบที่สองของเวกเตอร์ 2D",
  T_48_META_API_81_P0_D: "เวกเตอร์ 2 มิติ",
  T_48_META_API_81_P1_D: "ค่าองค์ประกอบที่สอง",
  T_48_META_API_81_R_D: "เวกเตอร์สองมิติหลังจากแก้ไของค์ประกอบที่สอง",
  T_48_META_API_82_D: "ย้ายตัวควบคุมอักขระไปยังตำแหน่งที่ระบุ หากส่งผลต่อผู้เล่น ผู้เล่นจะต้องเปิดตัวควบคุมผู้เล่นที่ใช้เอฟเฟ็กต์ทางกายภาพจึงจะมีผล",
  T_48_META_API_82_P0_D: "ตัวควบคุมอักขระเป้าหมาย",
  T_48_META_API_82_P1_D: "ระบุสถานที่",
  T_48_META_API_83_D: "รับโหนดย่อยที่ระบุของเอนทิตีโหนดหลักเป้าหมายตามชื่อ",
  T_48_META_API_83_P0_D: "เอนทิตีโหนดพาเรนต์",
  T_48_META_API_83_P1_D: "ชื่อโหนดลูก",
  T_48_META_API_83_R_D: "เอนทิตีโหนดลูก",
  T_48_META_API_84_D: "เพิ่มความสนใจเป็นพิเศษของ AOI โดยซิงโครไนซ์เสมอโดยไม่คำนึงถึงระยะห่าง",
  T_48_META_API_84_P0_D: "เป้าหมายที่น่ากังวลเป็นพิเศษ",
  T_48_META_API_84_P1_D: "ผู้สังเกตการณ์",
  T_48_META_API_85_D: "ลบความสนใจเป็นพิเศษของ AOI และยกเลิกการซิงโครไนซ์ AOI ที่อยู่นอกสายตา",
  T_48_META_API_85_P0_D: "เป้าหมายที่น่ากังวลเป็นพิเศษ",
  T_48_META_API_85_P1_D: "ผู้สังเกตการณ์",
  T_48_META_API_86_D: "ล้าง AOI ทั้งหมดของเป้าหมายที่ระบุ",
  T_48_META_API_86_P0_D: "เป้าหมายที่น่ากังวลเป็นพิเศษ",
  T_48_META_API_87_D: "พิจารณาว่ามีข้อกังวลพิเศษของ AOI หรือไม่",
  T_48_META_API_87_P0_D: "เป้าหมายที่น่ากังวลเป็นพิเศษ",
  T_48_META_API_87_P1_D: "เลิกใช้แล้ว",
  T_48_META_API_87_R_D: "มีอยู่หรือไม่",
  T_48_META_API_88_D: "สลับผู้สังเกตการณ์พร็อกซีของผู้เล่น",
  T_48_META_API_88_P0_D: "ผู้เล่น",
  T_48_META_API_88_P1_D: "ผู้สังเกตการณ์ตัวแทน",
  T_48_META_API_89_D: "ย้ายตัวควบคุมตัวละครหนึ่งครั้ง หากส่งผลต่อผู้เล่น ผู้เล่นจะต้องเปิดตัวควบคุมผู้เล่นที่ใช้เอฟเฟ็กต์ทางกายภาพจึงจะมีผล",
  T_48_META_API_89_P0_D: "วัตถุเป้าหมาย หากเป็นผู้เล่น ผู้เล่นจะต้องเปิดตัวควบคุมผู้เล่นโดยใช้ฟิสิกส์เพื่อให้เอฟเฟกต์มีผล",
  T_48_META_API_89_P1_D: "เวกเตอร์การกระจัด",
  T_48_META_API_9_D: "ปิดกลไกโซนปลอดภัย เมื่อลดโซนปลอดภัย ผู้เล่นที่อยู่นอกโซนปลอดภัยจะยังคงได้รับอันตรายต่อไป หลังจากปิดกลไกโซนปลอดภัย ผู้เล่นจะปลอดภัยอีกครั้ง",
  T_48_META_API_90_D: "กำหนดว่าผู้เล่นสามารถออกได้อย่างอิสระหรือไม่",
  T_48_META_API_90_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_90_P1_D: "เป็นไปได้ไหมที่จะออกอย่างอิสระ?",
  T_48_META_API_9000_D: "สร้าง UI ในตัวที่มองเห็นได้เฉพาะผู้เล่นที่ได้รับมอบหมายเท่านั้น",
  T_48_META_API_9000_P0_D: "สร้างเอนทิตี UI ในตัว",
  T_48_META_API_9000_P1_D: "เอนทิตีผู้เล่นที่มี UI อยู่ ซึ่งมองเห็นได้เฉพาะผู้เล่นรายนี้",
  T_48_META_API_9000_P2_D: "ประเภท UI ในตัว",
  T_48_META_API_9001_D: "ลบ UI ของเกมในตัว",
  T_48_META_API_9001_P0_D: "เอนทิตี UI ในตัวที่จะลบ",
  T_48_META_API_9002_D: "สร้างไอคอนโดยใช้ประเภทไอคอนที่ระบุ หากมีคุณสมบัติเพิ่มเติมที่จำเป็นต้องตั้งค่า ให้ตั้งค่าคุณสมบัติเอนทิตีเพิ่มเติมผ่านเอนทิตี (ล้าสมัย โปรดใช้ CreateLevelObject)",
  T_48_META_API_9002_P0_D: "รหัสนี้ใช้เพื่อแสดงชื่อของพารามิเตอร์อย่างเป็นทางการที่สร้างเอนทิตีไอคอน และค่าตัวแปรท้องถิ่นที่สอดคล้องกันคือเอนทิตีที่สร้างไอคอน",
  T_48_META_API_9002_P1_D: "เอนทิตีของผู้เล่นที่เป็นเจ้าของ มีเพียงผู้เล่นรายนี้เท่านั้นที่มองเห็นได้",
  T_48_META_API_9002_P2_D: "เส้นทางทรัพยากร เส้นทางทรัพยากรที่สอดคล้องกับไอคอนที่เลือกโดยผู้เล่น",
  T_48_META_API_9003_D: "ลบไอคอนที่ระบุ (เลิกใช้แล้ว โปรดใช้ DeleteEntity)",
  T_48_META_API_9003_P0_D: "เอนทิตีไอคอนที่จะลบ",
  T_48_META_API_9004_D: "สร้างข้อความโดยใช้เนื้อหาข้อความที่ระบุ หากมีคุณสมบัติเพิ่มเติมที่จำเป็นต้องตั้งค่า ให้ตั้งค่าคุณสมบัติเอนทิตีเพิ่มเติมผ่านเอนทิตี (ล้าสมัย โปรดใช้ CreateLevelObject)",
  T_48_META_API_9004_P0_D: "รหัสนี้ใช้เพื่อแสดงชื่อของพารามิเตอร์อย่างเป็นทางการที่สร้างเอนทิตีข้อความ และค่าตัวแปรท้องถิ่นที่สอดคล้องกันคือเอนทิตีที่สร้างข้อความ",
  T_48_META_API_9004_P1_D: "เอนทิตีของผู้เล่นที่เป็นเจ้าของ มีเพียงผู้เล่นรายนี้เท่านั้นที่มองเห็นได้",
  T_48_META_API_9004_P2_D: "เนื้อหาข้อความที่จะแสดงผล",
  T_48_META_API_9005_D: "ลบข้อความที่ระบุ (เลิกใช้แล้ว โปรดใช้ DeleteEntity)",
  T_48_META_API_9005_P0_D: "เอนทิตีข้อความที่จะลบ",
  T_48_META_API_9006_D: "สร้างไอคอนโดยใช้ประเภทเอฟเฟกต์ที่ระบุ หากมีคุณสมบัติเพิ่มเติมที่จำเป็นต้องตั้งค่า ให้ตั้งค่าคุณสมบัติเอนทิตีเพิ่มเติมผ่านเอนทิตี (ล้าสมัย โปรดใช้ CreateEffect)",
  T_48_META_API_9006_P0_D: "รหัสนี้ใช้เพื่อแสดงชื่อของพารามิเตอร์อย่างเป็นทางการที่สร้างเอนทิตีเอฟเฟกต์พิเศษ และค่าตัวแปรท้องถิ่นที่สอดคล้องกันคือเอนทิตีที่สร้างเอฟเฟกต์พิเศษ",
  T_48_META_API_9006_P1_D: "เอนทิตีของผู้เล่นที่เป็นเจ้าของ มีเพียงผู้เล่นรายนี้เท่านั้นที่มองเห็นได้",
  T_48_META_API_9006_P2_D: "ประเภทเอฟเฟกต์พิเศษ ประเภทของเอฟเฟกต์พิเศษที่ผู้เล่นสามารถเลือกได้",
  T_48_META_API_9007_D: "ลบเอฟเฟกต์ที่ระบุ (เลิกใช้แล้ว โปรดใช้ DeleteEntity)",
  T_48_META_API_9007_P0_D: "เอนทิตีเอฟเฟกต์ที่จะลบ",
  T_48_META_API_9008_D: "สร้าง UI แบบกำหนดเองที่มองเห็นได้เฉพาะผู้เล่นที่ได้รับมอบหมายเท่านั้น",
  T_48_META_API_9008_P0_D: "สร้างเอนทิตี UI แบบกำหนดเอง",
  T_48_META_API_9008_P1_D: "เอนทิตีผู้เล่นที่มี UI อยู่ ซึ่งมองเห็นได้เฉพาะผู้เล่นรายนี้",
  T_48_META_API_9008_P2_D: "ดัชนี UI ที่กำหนดเอง",
  T_48_META_API_9009_D: "ลบ UI ของเกมที่กำหนดเอง",
  T_48_META_API_9009_P0_D: "เอนทิตี UI แบบกำหนดเองที่จะลบ",
  T_48_META_API_9010_D: "รับการควบคุม UI จาก UI ที่กำหนดเอง",
  T_48_META_API_9010_P0_D: "เอนทิตีผู้เล่นที่เป็นของ UI",
  T_48_META_API_9010_P1_D: "เอนทิตี UI แบบกำหนดเอง",
  T_48_META_API_9010_P2_D: "ควบคุมดัชนีเฉพาะ",
  T_48_META_API_9010_R_D: "เอนทิตีการควบคุม UI",
  T_48_META_API_9011_D: "เล่นเอฟเฟกต์เสียงที่ระบุ หากมีคุณสมบัติเพิ่มเติมที่จำเป็นต้องตั้งค่า ให้ตั้งค่าคุณสมบัติเอนทิตีเพิ่มเติมผ่านเอนทิตี (ล้าสมัย โปรดใช้ CreateSound)",
  T_48_META_API_9011_P0_D: "รหัสนี้ใช้เพื่อแสดงชื่อของพารามิเตอร์อย่างเป็นทางการที่สร้างเอนทิตีเอฟเฟกต์เสียง และค่าตัวแปรท้องถิ่นที่สอดคล้องกันคือเอนทิตีที่สร้างเอฟเฟกต์เสียง",
  T_48_META_API_9011_P1_D: "เอนทิตีของผู้เล่นที่เป็นเจ้าของ มีเพียงผู้เล่นรายนี้เท่านั้นที่มองเห็นได้",
  T_48_META_API_9011_P2_D: "ประเภทเอฟเฟกต์เสียง ประเภทของเอฟเฟกต์เสียงที่ผู้เล่นสามารถเลือกได้",
  T_48_META_API_9012_D: "ลบเอฟเฟกต์เสียงที่ระบุ (เลิกใช้แล้ว โปรดใช้ DeleteEntity)",
  T_48_META_API_9012_P0_D: "เอนทิตีเสียงที่จะลบ",
  T_48_META_API_9013_D: "รับการควบคุม UI โดยใช้เส้นทางจาก UI ที่กำหนดเอง",
  T_48_META_API_9013_P0_D: "เอนทิตีผู้เล่นที่เป็นของ UI",
  T_48_META_API_9013_P1_D: "UI ที่กำหนดเอง",
  T_48_META_API_9013_P2_D: "เส้นทางการควบคุม",
  T_48_META_API_9013_R_D: "เอนทิตีการควบคุม UI",
  T_48_META_API_9014_D: "ขัดจังหวะเอนทิตีเสียงที่เล่น (เลิกใช้แล้ว โปรดใช้ PauseSound)",
  T_48_META_API_9014_P0_D: "เอนทิตีเอฟเฟกต์เสียงที่ต้องหยุดชั่วคราว",
  T_48_META_API_9015_D: "เล่นเอฟเฟกต์เสียงต่อไป คุณสามารถเลือกได้ว่าจะเริ่มเล่นตั้งแต่ต้นหรือไม่ (ล้าสมัย โปรดใช้ ResumeSound)",
  T_48_META_API_9015_P0_D: "เอนทิตีเอฟเฟกต์เสียงที่ต้องเล่นต่อหลังจากหยุดชั่วคราว",
  T_48_META_API_9015_P1_D: "ไม่ว่าจะเริ่มต้นใหม่",
  T_48_META_API_9016_D: "สร้างการควบคุม UI แบบกำหนดเอง",
  T_48_META_API_9016_P0_D: "สร้างเอนทิตีการควบคุมแบบกำหนดเอง",
  T_48_META_API_9016_P1_D: "ประเภทของการควบคุมที่สร้างขึ้น",
  T_48_META_API_9016_P2_D: "เป็นเอนทิตี UI",
  T_48_META_API_9016_P3_D: "การควบคุมหลักที่เป็นของ ถ้าปล่อยว่างไว้ เอนทิตี UI ที่เป็นของโหนดหลัก",
  T_48_META_API_9017_D: "ตั้งค่าหน้ากากเลเยอร์กล้องเป้าหมาย",
  T_48_META_API_9017_P0_D: "เอนทิตีกล้องเป้าหมาย",
  T_48_META_API_9017_P1_D: "เลเยอร์มาสก์ เฉพาะเลเยอร์ที่กรอกแล้วเท่านั้นที่จะถูกแสดงในกล้องเป้าหมาย การเว้นว่างไว้หมายความว่าเลเยอร์ทั้งหมดจะถูกแสดง",
  T_48_META_API_9018_D: "รับหน้ากากเลเยอร์กล้องเป้าหมาย",
  T_48_META_API_9018_P0_D: "เอนทิตีกล้องเป้าหมาย",
  T_48_META_API_9018_R_D: "เลเยอร์มาสก์ เฉพาะเลเยอร์ภายในเลเยอร์มาสก์เท่านั้นที่จะแสดงในกล้องเป้าหมาย",
  T_48_META_API_9019_D: "ตั้งค่าว่าจะให้กล้องเป้าหมายมองเห็นระดับที่ระบุหรือไม่",
  T_48_META_API_9019_P0_D: "เอนทิตีกล้องเป้าหมาย",
  T_48_META_API_9019_P1_D: "ระดับการมองเห็น",
  T_48_META_API_9019_P2_D: "มองเห็นได้หรือไม่",
  T_48_META_API_9020_D: "ตั้งค่าสถานะการมองเห็นอินเทอร์เฟซเริ่มต้นของผู้เล่นเป้าหมาย",
  T_48_META_API_9020_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_9020_P1_D: "ประเภทอินเทอร์เฟซของผู้เล่น ประเภทอินเทอร์เฟซของผู้เล่นเป็นองค์ประกอบ UI ที่ใช้ในการควบคุมผู้เล่นและเนื้อหาที่เกี่ยวข้องกับผู้เล่น",
  T_48_META_API_9020_P2_D: "ค่าสวิตช์จะกำหนดการมองเห็นอินเทอร์เฟซของเครื่องเล่น",
  T_48_META_API_9021_D: "สร้างสตริงที่แปลเป็นภาษาท้องถิ่นของการประทับเวลา",
  T_48_META_API_9021_P0_D: "การประทับเวลา",
  T_48_META_API_9021_P1_D: "การจัดรูปแบบสไตล์",
  T_48_META_API_9021_R_D: "สตริงการแปลการประทับเวลา",
  T_48_META_API_9022_D: "สร้างไอคอนแผนที่ย่อ",
  T_48_META_API_9022_P0_D: "สร้างเอนทิตีไอคอนแผนที่ย่อแล้ว",
  T_48_META_API_9022_P1_D: "เป็นของผู้เล่น ไอคอนแผนที่ย่อที่สร้างขึ้นจะมองเห็นได้เฉพาะผู้เล่นคนนั้นเท่านั้น",
  T_48_META_API_9022_P2_D: "เส้นทางทรัพยากรไอคอนแผนที่ย่อ",
  T_48_META_API_9023_D: "สร้างไอคอนโดยใช้ประเภทเอฟเฟกต์พิเศษที่ระบุ หากมีคุณสมบัติเพิ่มเติมที่จำเป็นต้องตั้งค่า ให้ตั้งค่าคุณสมบัติเอนทิตีเพิ่มเติมผ่านเอนทิตี",
  T_48_META_API_9023_P0_D: "รหัสนี้ใช้เพื่อแสดงชื่อของพารามิเตอร์อย่างเป็นทางการที่สร้างเอนทิตีเอฟเฟกต์พิเศษ และค่าตัวแปรท้องถิ่นที่สอดคล้องกันคือเอนทิตีที่สร้างเอฟเฟกต์พิเศษ",
  T_48_META_API_9023_P1_D: "เอนทิตีของผู้เล่นที่เป็นเจ้าของ มีเพียงผู้เล่นรายนี้เท่านั้นที่มองเห็นได้",
  T_48_META_API_9023_P2_D: "ประเภทเอฟเฟกต์พิเศษ ประเภทของเอฟเฟกต์พิเศษที่ผู้เล่นสามารถเลือกได้",
  T_48_META_API_9024_D: "ลบเอฟเฟกต์ที่ระบุ (เลิกใช้แล้ว โปรดใช้ DeleteEntity)",
  T_48_META_API_9024_P0_D: "เอนทิตีเอฟเฟกต์ที่จะลบ",
  T_48_META_API_9025_D: "สร้างพิกเซลคงที่บนแผนที่สำหรับวัตถุเป้าหมาย พิกเซลคงที่จะไม่เคลื่อนที่ไปพร้อมกับวัตถุเป้าหมาย",
  T_48_META_API_9025_P0_D: "สร้างเอนทิตีพิกเซลแบบคงที่",
  T_48_META_API_9025_P1_D: "เป็นของผู้เล่น พิกเซลคงที่ที่สร้างขึ้นจะมองเห็นได้เฉพาะผู้เล่นเท่านั้น",
  T_48_META_API_9025_P2_D: "เอนทิตีวัตถุเป้าหมาย",
  T_48_META_API_9026_D: "รับเอนทิตีแผนที่ย่อของผู้เล่นเป้าหมาย",
  T_48_META_API_9026_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_9026_R_D: "แผนที่ย่อของผู้เล่นปัจจุบัน",
  T_48_META_API_9027_D: "ตั้งค่าความเสียหายจากการตกของผู้เล่นได้",
  T_48_META_API_9027_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_9027_P1_D: "รายการที่มีการแบ่งส่วนสูง",
  T_48_META_API_9027_P2_D: "รายการส่วนความเสียหาย",
  T_48_META_API_91_D: "การเพิ่มเป้าหมายให้กับทีมที่ระบุจะทำให้เป้าหมายออกจากทีมเดิม",
  T_48_META_API_91_P0_D: "เป้าหมายที่ต้องเพิ่มให้กับทีม",
  T_48_META_API_91_P1_D: "ทีมที่จะเข้าร่วม",
  T_48_META_API_91_P2_D: "ประสบความสำเร็จหรือไม่?",
  T_48_META_API_92_D: "การเพิ่มเป้าหมายให้กับทีมใหม่จะทำให้เป้าหมายออกจากทีมเดิม",
  T_48_META_API_92_P0_D: "เป้าหมายที่ต้องเพิ่มให้กับทีม",
  T_48_META_API_92_P1_D: "ชื่อทีมใหม่",
  T_48_META_API_92_P2_D: "ประสบความสำเร็จหรือไม่?",
  T_48_META_API_94_D: "ตั้งค่าตัวแปรท้องถิ่นโดยใช้ดัชนี ก่อนตั้งค่า จะต้องกำหนดตัวแปรในกระบวนการเรียกปัจจุบัน",
  T_48_META_API_94_P0: "ดัชนี",
  T_48_META_API_94_P0_D: "รับตัวแปรโดยดัชนี",
  T_48_META_API_94_P1: "ค่าตัวแปร",
  T_48_META_API_94_P1_D: "ค่าตัวแปรเป้าหมาย",
  T_48_META_API_94_P2: "ประเภทเลขคณิต",
  T_48_META_API_94_P2_D: "วิธีดำเนินการ ประเภททั้งหมดรองรับการกำหนด และประเภทตัวเลขยังรองรับการเพิ่ม การลด การคูณ การหาร และการดำเนินการโมดูลัสอีกด้วย",
  T_48_META_API_94_P3: "ชื่อตัวแปร",
  T_48_META_API_94_P3_D: "ชื่อตัวแปรเป้าหมาย ใช้เฉพาะสำหรับการแสดงผลข้อผิดพลาด",
  T_48_META_API_95: "รับตัวแปรท้องถิ่นโดยดัชนี",
  T_48_META_API_95_D: "รับค่าของตัวแปรท้องถิ่น; ก่อนที่จะรับค่า ตัวแปรจะต้องถูกกำหนดในกระบวนการเรียกปัจจุบัน",
  T_48_META_API_95_P0: "ดัชนี",
  T_48_META_API_95_P0_D: "ดัชนีตัวแปร",
  T_48_META_API_95_P1: "ชื่อตัวแปร",
  T_48_META_API_95_P1_D: "ชื่อตัวแปรเป้าหมาย ใช้เฉพาะสำหรับการแสดงผลข้อผิดพลาด",
  T_48_META_API_9500_D: "แจ้งไคลเอนต์ของผู้เล่นเป้าหมายให้เล่นเอฟเฟกต์พิเศษ",
  T_48_META_API_9500_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_9500_P1_D: "เส้นทางทรัพยากรเอฟเฟกต์พิเศษ",
  T_48_META_API_9500_P2_D: "สี",
  T_48_META_API_9500_P3_D: "ขนาดการซูม ค่าเริ่มต้นคือ 1",
  T_48_META_API_9500_P4_D: "วัตถุที่มีผลผูกพัน เอฟเฟกต์พิเศษจะถูกแนบเป็นโหนดย่อย",
  T_48_META_API_9500_P5_D: "พิกัดโลกชดเชยสัมพันธ์กับวัตถุที่ถูกผูกไว้",
  T_48_META_API_9501_D: "แจ้งเตือนไคลเอนต์ของผู้เล่นเป้าหมายให้เล่นเอฟเฟกต์เสียง",
  T_48_META_API_9501_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_9501_P1_D: "ประเภทเอฟเฟกต์เสียง",
  T_48_META_API_9502_D: 'แจ้งลูกค้าผู้เล่นเป้าหมายให้แสดงคำว่า "ลอย"',
  T_48_META_API_9502_P0_D: "ผู้เล่นเป้าหมาย",
  T_48_META_API_9502_P1_D: "เนื้อหาเปียวซี",
  T_48_META_API_9502_P2_D: "สีของคำลอยตัว ชนิดคือสี",
  T_48_META_API_9502_P3_D: "ระยะเวลาของอักขระลอยในหน่วยมิลลิวินาที",
  T_48_META_API_9503_D: "ทำให้ยูนิตเป้าหมายเล่นนิพจน์การกระทำของ Emote หนึ่งครั้ง",
  T_48_META_API_9503_P0_D: "เป้าหมายในการเล่น Emote",
  T_48_META_API_9503_P1_D: "ประเภทอิโมติคอน",
  T_48_META_API_9504_D: "หยุดชั่วคราว/เล่นต่อการแสดงออกทางอิโมติคอนของหน่วย",
  T_48_META_API_9504_P0_D: "หยุดชั่วคราว/เล่นต่อเป้าหมายอิโมติคอน",
  T_48_META_API_9504_P1_D: "จริง: หยุดเล่นชั่วคราว เท็จ: เล่นต่อ",
  T_48_META_EVT_1_D: "ทริกเกอร์เมื่อเกมเริ่ม เซิร์ฟเวอร์จะพร้อมใช้งานเร็วกว่าไคลเอนต์",
  T_48_META_EVT_10_D: "ทริกเกอร์ก่อนที่เอนทิตีปัจจุบันจะได้รับความเสียหาย",
  T_48_META_EVT_10_P0_D: "เอนทิตีของผู้โจมตีอาจว่างเปล่า",
  T_48_META_EVT_10_P1_D: "ประเภทความเสียหาย",
  T_48_META_EVT_10_P2_D: "จำนวนความเสียหายที่เกิดขึ้น",
  T_48_META_EVT_10_P3_D: "ส่วนที่ได้รับบาดเจ็บ",
  T_48_META_EVT_1000_D: "ทริกเกอร์เมื่อคะแนนของผู้เล่นเปลี่ยนแปลง",
  T_48_META_EVT_1000_P0_D: "ผู้เล่นที่คะแนนมีการเปลี่ยนแปลง",
  T_48_META_EVT_1000_P1_D: "ประเภทของจุดเปลี่ยน",
  T_48_META_EVT_1000_P2_D: "ค่าอินทิกรัลหลังการเปลี่ยนแปลงอินทิกรัล",
  T_48_META_EVT_1001_D: "ทริกเกอร์เมื่อคะแนนทีมเปลี่ยนแปลง",
  T_48_META_EVT_1001_P0_D: "ทีมที่มีการเปลี่ยนแปลงคะแนน",
  T_48_META_EVT_1001_P1_D: "ประเภทของจุดเปลี่ยน",
  T_48_META_EVT_1001_P2_D: "ค่าอินทิกรัลหลังการเปลี่ยนแปลงอินทิกรัล",
  T_48_META_EVT_1002_D: "ทริกเกอร์เมื่ออันดับผู้เล่นเปลี่ยนแปลง",
  T_48_META_EVT_1002_P0_D: "ผู้เล่นที่อันดับมีการเปลี่ยนแปลง",
  T_48_META_EVT_1002_P1_D: "อันดับหลังจากการเปลี่ยนแปลงอันดับ",
  T_48_META_EVT_1003_D: "เลิกใช้แล้ว",
  T_48_META_EVT_1003_P0_D: "เลิกใช้แล้ว",
  T_48_META_EVT_1003_P1_D: "อันดับหลังจากการเปลี่ยนแปลงอันดับ",
  T_48_META_EVT_11_D: "เกิดขึ้นเมื่อผู้เล่นออกจากเกมกลางคัน",
  T_48_META_EVT_11_P0_D: "ผู้เล่นที่ออกจากเกมกลางคัน",
  T_48_META_EVT_12_D: "ทริกเกอร์เมื่อตัวควบคุมของผู้เล่นสัมผัสกับเอนทิตี โดยจะถูกทริกเกอร์เมื่อตัวควบคุมเคลื่อนไหวอย่างแข็งขันเท่านั้น",
  T_48_META_EVT_12_P0_D: "หน่วยงานที่พบเจอ",
  T_48_META_EVT_13_D: "ทริกเกอร์ก่อนที่เอนทิตีปัจจุบันจะสร้างความเสียหาย",
  T_48_META_EVT_13_P0_D: "หน่วยงานได้รับความเสียหาย",
  T_48_META_EVT_13_P1_D: "ประเภทความเสียหาย",
  T_48_META_EVT_13_P2_D: "จำนวนความเสียหายที่เกิดขึ้น",
  T_48_META_EVT_13_P3_D: "ส่วนที่ได้รับบาดเจ็บ",
  T_48_META_EVT_14_D: "ทริกเกอร์ทุกครั้งที่เอนทิตีที่สามารถเล่นวนซ้ำได้ เมื่อเอนทิตีที่สามารถเล่นได้นั้นเป็นเอฟเฟกต์เสียง เอฟเฟกต์พิเศษ ฯลฯ เหตุการณ์นี้จะมีผลกับไคลเอนต์เท่านั้น",
  T_48_META_EVT_2_D: "ทริกเกอร์เมื่อมีการอัปเดตเฟรมลอจิคัล ความถี่ของการทริกเกอร์เหตุการณ์นี้จะแตกต่างกันไปขึ้นอยู่กับแพลตฟอร์มและการตั้งค่า",
  T_48_META_EVT_2002_D: "เกิดขึ้นเมื่อผู้เล่นเสียชีวิต",
  T_48_META_EVT_2002_P0_D: "ผู้เล่นที่ตายแล้ว",
  T_48_META_EVT_2003_D: "เกิดขึ้นเมื่อผู้เล่นแอสซิสต์",
  T_48_META_EVT_2003_P0_D: "ผู้เล่นที่ได้รับแอสซิสต์",
  T_48_META_EVT_2003_P1_D: "ผู้เล่นที่ถูกฆ่า",
  T_48_META_EVT_2004_D: "เกิดขึ้นเมื่อผู้เล่นสร้างความเสียหาย",
  T_48_META_EVT_2004_P0_D: "ผู้เล่นที่สร้างความเสียหาย",
  T_48_META_EVT_2004_P1_D: "ผู้เล่นที่ได้รับอันตราย",
  T_48_META_EVT_2004_P2_D: "ประเภทความเสียหาย",
  T_48_META_EVT_2004_P3_D: "ความเสียหาย",
  T_48_META_EVT_2004_P4_D: "ส่วนที่ได้รับบาดเจ็บ",
  T_48_META_EVT_2005_D: "เกิดขึ้นเมื่อผู้เล่นทำการสังหาร",
  T_48_META_EVT_2005_P0_D: "ผู้เล่นที่ก่อเหตุสังหาร",
  T_48_META_EVT_2005_P1_D: "ผู้เล่นที่ถูกฆ่า",
  T_48_META_EVT_2005_P2_D: "ประเภทความเสียหาย",
  T_48_META_EVT_2006_D: "เกิดขึ้นเมื่อผู้เล่นเข้าร่วมเกม",
  T_48_META_EVT_2006_P0_D: "ผู้เล่นที่เข้าร่วมเกม",
  T_48_META_EVT_2007_D: "ทริกเกอร์เมื่อผู้เล่นฟื้นคืนชีพ",
  T_48_META_EVT_2007_P0_D: "ผู้เล่นที่ฟื้นคืนชีพ",
  T_48_META_EVT_2007_P1_D: "แหล่งที่มาของการฟื้นคืนชีพ",
  T_48_META_EVT_2008_D: "ทริกเกอร์เมื่อผู้เล่นล้มลง",
  T_48_META_EVT_2008_P0_D: "ผู้เล่นที่กระดก",
  T_48_META_EVT_2008_P1_D: "ผู้เล่นที่โจมตี",
  T_48_META_EVT_2009_D: "ยิงเมื่อผู้เล่นตัดการเชื่อมต่อ",
  T_48_META_EVT_2009_P0_D: "เครื่องเล่นถูกตัดการเชื่อมต่อ",
  T_48_META_EVT_2010_D: "เริ่มทำงานเมื่อผู้เล่นเชื่อมต่อใหม่",
  T_48_META_EVT_2010_P0_D: "ผู้เล่นกำลังเชื่อมต่อใหม่",
  T_48_META_EVT_2100_D: "เกิดขึ้นเมื่อทีมถูกถอดออก",
  T_48_META_EVT_2100_P0_D: "ทีมที่ถูกลบออก",
  T_48_META_EVT_2101_D: "เกิดขึ้นเมื่อเพิ่มทีม",
  T_48_META_EVT_2101_P0_D: "เพิ่มทีมแล้ว",
  T_48_META_EVT_2102_D: "ทริกเกอร์เมื่อทีมถูกทำลาย",
  T_48_META_EVT_2102_P0_D: "ทีมที่ถูกกวาดล้างออกไป",
  T_48_META_EVT_3_D: "เริ่มทำงานเมื่อเกมจบลง กิจกรรมนี้จะเริ่มก่อนที่เกมจะจบลงบนเซิร์ฟเวอร์",
  T_48_META_EVT_30_D: "เกิดขึ้นเมื่อโหลดฉากสำเร็จ",
  T_48_META_EVT_30_P0_D: "ชื่อฉาก",
  T_48_META_EVT_3000_D: "เริ่มทำงานหลังจากสร้างเอนทิตีปัจจุบัน",
  T_48_META_EVT_3001_D: "ทริกเกอร์ก่อนที่เอนทิตีปัจจุบันจะถูกทำลาย",
  T_48_META_EVT_3002_D: "ยิงเมื่อผู้เล่นเข้าสู่ทริกเกอร์",
  T_48_META_EVT_3002_P0_D: "ผู้เล่นเข้าสู่ทริกเกอร์",
  T_48_META_EVT_3003_D: "ยิงเมื่อผู้เล่นออกจากไกปืน",
  T_48_META_EVT_3003_P0_D: "ผู้เล่นออกจากทริกเกอร์",
  T_48_META_EVT_3004_D: "เริ่มทำงานหลังจากคลิกปุ่มควบคุม UI",
  T_48_META_EVT_3004_P0_D: "ผู้เล่นที่คลิก",
  T_48_META_EVT_3005_D: "เริ่มทำงานเมื่อมีการคลิกปุ่มใน UI ในตัว",
  T_48_META_EVT_3005_P0_D: "ชื่อของตัวควบคุมปุ่มที่ถูกคลิก",
  T_48_META_EVT_3006_D: "เกิดขึ้นเมื่อผู้เล่นใช้เวคบอร์ด",
  T_48_META_EVT_3007_D: "เริ่มทำงานหลังจากเอนทิตีปัจจุบันพร้อมใช้งาน",
  T_48_META_EVT_3008_D: "เริ่มทำงานหลังจากที่เอนทิตีปัจจุบันไม่พร้อมใช้งาน",
  T_48_META_EVT_3009_D: "ทริกเกอร์เมื่อเอนทิตีเข้าสู่ทริกเกอร์ เมื่อทริกเกอร์เหตุการณ์ถูกทริกเกอร์ ทั้งสองฝ่ายจะได้รับเหตุการณ์นั้น ฝ่ายหนึ่งต้องเป็นวัตถุแข็งและอีกฝ่ายต้องเป็นทริกเกอร์ โดยเฉพาะอย่างยิ่ง เมื่อทริกเกอร์เป็นอ็อบเจ็กต์ทริกเกอร์แบบกำหนดเอง เฉพาะทริกเกอร์เท่านั้นที่จะได้รับเหตุการณ์นั้น",
  T_48_META_EVT_3009_P0_D: "เอนทิตีคู่สัญญาเมื่อเหตุการณ์ทริกเกอร์เกิดขึ้น",
  T_48_META_EVT_3010_D: "ทริกเกอร์เมื่อเอนทิตีออกจากทริกเกอร์ เมื่อทริกเกอร์เหตุการณ์ ทั้งสองฝ่ายจะได้รับเหตุการณ์ ฝ่ายหนึ่งต้องเป็นวัตถุแข็ง และอีกฝ่ายต้องเป็นทริกเกอร์ โดยเฉพาะอย่างยิ่ง เมื่อทริกเกอร์เป็นอ็อบเจ็กต์ทริกเกอร์แบบกำหนดเอง เฉพาะทริกเกอร์เท่านั้นที่จะได้รับเหตุการณ์",
  T_48_META_EVT_3010_P0_D: "เอนทิตีคู่สัญญาเมื่อเหตุการณ์ทริกเกอร์เกิดขึ้น",
  T_48_META_EVT_3011_D: "ทริกเกอร์หลังจากเอนทิตีปัจจุบันถูกทำลาย",
  T_48_META_EVT_3011_P0_D: "เอนทิตีของผู้โจมตีอาจว่างเปล่า",
  T_48_META_EVT_3011_P1_D: "ประเภทความเสียหาย",
  T_48_META_EVT_3011_P2_D: "ส่วนที่ได้รับบาดเจ็บ",
  T_48_META_EVT_3012_D: "ทริกเกอร์หลังจากเอนทิตีปัจจุบันถูกโจมตี",
  T_48_META_EVT_3012_P0_D: "เอนทิตีของผู้โจมตีอาจว่างเปล่า",
  T_48_META_EVT_3012_P1_D: "ประเภทความเสียหาย",
  T_48_META_EVT_3012_P2_D: "จำนวนความเสียหายที่เกิดขึ้น",
  T_48_META_EVT_3012_P3_D: "ส่วนที่ได้รับบาดเจ็บ",
  T_48_META_EVT_3013_D: "ทริกเกอร์หลังจากเอนทิตีปัจจุบันสร้างความเสียหาย",
  T_48_META_EVT_3013_P0_D: "หน่วยงานได้รับความเสียหาย",
  T_48_META_EVT_3013_P1_D: "ประเภทความเสียหาย",
  T_48_META_EVT_3013_P2_D: "จำนวนความเสียหายที่เกิดขึ้น",
  T_48_META_EVT_3013_P3_D: "ส่วนที่ได้รับบาดเจ็บ",
  T_48_META_EVT_3014_D: "ทริกเกอร์หลังจากเอนทิตีปัจจุบันทำลายเอนทิตีอื่น",
  T_48_META_EVT_3014_P0_D: "เอนทิตีที่ถูกทำลาย",
  T_48_META_EVT_3014_P1_D: "ส่วนที่ได้รับบาดเจ็บ",
  T_48_META_EVT_3015_D: "ทริกเกอร์เมื่อผู้เล่นฟื้นคืนชีพ",
  T_48_META_EVT_3015_P0_D: "ประเภทแหล่งที่มาของการฟื้นคืนชีพของผู้เล่น",
  T_48_META_EVT_3016_D: "ไฟไหม้เมื่อเครื่องกำเนิดไฟฟ้าสร้างเอนทิตี",
  T_48_META_EVT_3016_P0_D: "รายการเอนทิตีที่สร้างขึ้น",
  T_48_META_EVT_3016_P1_D: "หมายเลขคลื่น",
  T_48_META_EVT_3017_D: "เรียกว่าเมื่อผู้เล่นเข้าสู่ท่าคุกเข่าน็อคดาวน์",
  T_48_META_EVT_3018_D: "เกิดขึ้นเมื่อสมาชิกในทีมทุกคนเสียชีวิต",
  T_48_META_EVT_3019_D: "เกิดขึ้นเมื่อสวมใส่หมวกกันน็อค ชุดเกราะ หรือกระเป๋าเป้สะพายหลัง",
  T_48_META_EVT_3019_P0_D: "รหัสอุปกรณ์",
  T_48_META_EVT_3020_D: "เกิดขึ้นเมื่อถืออาวุธหลัก อาวุธรอง หรืออาวุธประชิด รวมถึงเมื่อเปลี่ยนเป็นหมัด",
  T_48_META_EVT_3020_P0_D: "เอนทิตีอาวุธที่ติดตั้งเมื่อถูกทริกเกอร์",
  T_48_META_EVT_3021_D: "ทริกเกอร์หลังจากใช้อุปกรณ์ประกอบฉากที่ต้องใช้เวลาจะทำให้เกิดเหตุการณ์นี้หลังจากใช้งานเสร็จแล้ว",
  T_48_META_EVT_3021_P0_D: "รหัสอุปกรณ์ประกอบฉาก",
  T_48_META_EVT_3021_P1_D: "เอนทิตีเสาอาจว่างเปล่า",
  T_48_META_EVT_3021_P2_D: "เอนทิตีเสาใหม่ที่สร้างขึ้นโดยใช้อุปกรณ์ประกอบฉากอาจว่างเปล่า",
  T_48_META_EVT_3022_D: "ทริกเกอร์เมื่อได้รับไอเท็ม",
  T_48_META_EVT_3022_P0_D: "ประเภทรายการ",
  T_48_META_EVT_3022_P1_D: "เอนทิตีรายการ อาจว่างเปล่า",
  T_48_META_EVT_3023_D: "ทริกเกอร์เมื่อคะแนนเอนทิตีเปลี่ยนแปลง",
  T_48_META_EVT_3023_P0_D: "ประเภทของจุดเปลี่ยน",
  T_48_META_EVT_3023_P1_D: "ค่าอินทิกรัลหลังการเปลี่ยนแปลงอินทิกรัล",
  T_48_META_EVT_3024_D: "ทริกเกอร์เมื่ออันดับของเอนทิตีเปลี่ยนแปลง",
  T_48_META_EVT_3024_P0_D: "อันดับหลังจากการเปลี่ยนแปลงอันดับ",
  T_48_META_EVT_3025_D: "ทริกเกอร์เมื่อช่วยเหลือ",
  T_48_META_EVT_3025_P0_D: "วัตถุที่ถูกฆ่า",
  T_48_META_EVT_3026_D: "เกิดขึ้นเมื่อนิติบุคคลเข้าไปในยานพาหนะ รวมทั้งในฐานะคนขับและผู้โดยสาร",
  T_48_META_EVT_3026_P0_D: "ตัวตนที่เข้ามาในยานพาหนะ",
  T_48_META_EVT_3026_P1_D: "กำลังเข้ารถ",
  T_48_META_EVT_3027_D: "เกิดขึ้นเมื่อนิติบุคคลออกจากยานพาหนะ",
  T_48_META_EVT_3027_P0_D: "นิติบุคคลที่ออกจากยานพาหนะ",
  T_48_META_EVT_3027_P1_D: "รถออกเดินทาง",
  T_48_META_EVT_3028_D: "เกิดขึ้นเมื่อนิติบุคคลกำลังขับขี่ยานพาหนะและเป็นผู้ขับขี่ในยานพาหนะ",
  T_48_META_EVT_3028_P0_D: "นิติบุคคลที่ขับรถ",
  T_48_META_EVT_3028_P1_D: "ขับรถ",
  T_48_META_EVT_3029_D: "ทริกเกอร์เมื่อยานพาหนะถูกป้อนโดยเอนทิตี",
  T_48_META_EVT_3029_P0_D: "ทริกเกอร์เอนทิตี",
  T_48_META_EVT_3030_D: "ทริกเกอร์เมื่อนิติบุคคลยานพาหนะออก",
  T_48_META_EVT_3030_P0_D: "ทริกเกอร์เอนทิตี",
  T_48_META_EVT_3031_D: "ทริกเกอร์เมื่อยานพาหนะถูกขับเคลื่อนโดยเอนทิตี",
  T_48_META_EVT_3031_P0_D: "ทริกเกอร์เอนทิตี",
  T_48_META_EVT_3032_D: "ทริกเกอร์หลังจากที่เอนทิตีใช้พอร์ทัลเพื่อเทเลพอร์ต (ล้าสมัย โปรดใช้ OnBouncesOffTire)",
  T_48_META_EVT_3032_P0_D: "เอนทิตีที่ใช้พอร์ทัล",
  T_48_META_EVT_3032_P1_D: "พอร์ทัลที่ใช้",
  T_48_META_EVT_3033_D: "ทริกเกอร์เมื่อเอนทิตีตีกลับ",
  T_48_META_EVT_3033_P0_D: "ทริกเกอร์เอนทิตี",
  T_48_META_EVT_3033_P1_D: "วัตถุเด้งที่ใช้",
  T_48_META_EVT_3034_D: "ทริกเกอร์หลังจากพอร์ทัลเทเลพอร์ตเอนทิตี",
  T_48_META_EVT_3034_P0_D: "นิติบุคคลที่ส่งสัญญาณ",
  T_48_META_EVT_3035_D: "เกิดขึ้นหลังจากที่ยางกระดอนเอนทิตี",
  T_48_META_EVT_3035_P0_D: "เอนทิตีตีกลับ",
  T_48_META_EVT_3036_D: "เกิดขึ้นเมื่อกลไกทำให้เอนทิตีลอยไปในอากาศ",
  T_48_META_EVT_3036_P0_D: "หน่วยงานที่ถูกเคาะออกไป",
  T_48_META_EVT_3036_P1_D: "วัตถุทางกล",
  T_48_META_EVT_3037_D: "ยิงเมื่อเอนทิตีเข้าสู่ทริกเกอร์",
  T_48_META_EVT_3037_P0_D: "ทริกเกอร์รายการ",
  T_48_META_EVT_3038_D: "เริ่มทำงานเมื่อเอนทิตีออกจากทริกเกอร์",
  T_48_META_EVT_3038_P0_D: "ทริกเกอร์ออกเดินทาง",
  T_48_META_EVT_3039_D: "ทริกเกอร์เมื่อได้รับเอนทิตีอาวุธ",
  T_48_META_EVT_3039_P0_D: "เอนทิตีอาวุธ",
  T_48_META_EVT_3040_D: "ทริกเกอร์เมื่อเอนทิตีถูกทำให้ล้มลงโดยกลไก",
  T_48_META_EVT_3040_P0_D: "หน่วยงานที่ถูกเคาะออกไป",
  T_48_META_EVT_3040_P1_D: "วัตถุทางกล",
  T_48_META_EVT_3041_D: "ทริกเกอร์เมื่อกำหนดเป้าหมายเอนทิตีที่สามารถกำหนดเป้าหมายได้",
  T_48_META_EVT_3041_P0_D: "เอนทิตีเป้าหมาย",
  T_48_META_EVT_3042_D: "ทริกเกอร์เมื่อเป้าหมายโดยผู้เล่น",
  T_48_META_EVT_3042_P0_D: "ผู้เล่นกำลังเล็ง",
  T_48_META_EVT_3043_D: "เกิดขึ้นเมื่อกระสุนโดนเป้าหมาย",
  T_48_META_EVT_3043_P0_D: "ตีเป้าหมาย",
  T_48_META_EVT_3043_P1_D: "พิกัดโลกที่กระสุนโดน",
  T_48_META_EVT_3044_D: "เกิดขึ้นเมื่อถูกโจมตีด้วยอาวุธ",
  T_48_META_EVT_3044_P0_D: "แขน",
  T_48_META_EVT_3044_P1_D: "พิกัดโลกของพื้นที่ที่ถูกโจมตี",
  T_48_META_EVT_3045_D: "ทริกเกอร์เมื่อผู้เล่นเลือกที่จะแปลงร่างเป็นวัตถุในระดับนี้",
  T_48_META_EVT_3045_P0_D: "ผู้เล่นแปลงร่างเป็นเอนทิตี ไม่ใช่วัตถุในฉาก",
  T_48_META_EVT_3046_D: "เกิดขึ้นเมื่อผู้เล่นฟื้นคืนชีพที่จุดเกิดใหม่นี้",
  T_48_META_EVT_3046_P0_D: "ผู้เล่นฟื้นคืนชีพที่จุดเกิดใหม่นี้",
  T_48_META_EVT_3047_D: "เกิดขึ้นเมื่อผู้เล่นทิ้งอาวุธ",
  T_48_META_EVT_3047_P0_D: "เอนทิตีอาวุธที่ถูกทิ้ง",
  T_48_META_EVT_3048_D: "เกิดขึ้นเมื่อผู้เล่นดรอปไอเท็มอื่นที่ไม่ใช่อาวุธ",
  T_48_META_EVT_3048_P0_D: "ประเภทรายการ",
  T_48_META_EVT_3048_P1_D: "เอนทิตีรายการ อาจว่างเปล่า",
  T_48_META_EVT_3049_D: "เหตุเกิดเมื่อโดนปืนฟุตบอล",
  T_48_META_EVT_3049_P0_D: "ผู้เล่น",
  T_48_META_EVT_3049_P1_D: "ความเร็วหลังจากถูกโจมตี",
  T_48_META_EVT_3050_D: "เกิดขึ้นเมื่อฟุตบอลชนกับเอนทิตี",
  T_48_META_EVT_3050_P0_D: "วัตถุชนกัน",
  T_48_META_EVT_3050_P1_D: "ความเร็วหลังจากการชน",
  T_48_META_EVT_3051_D: "ทริกเกอร์เมื่อผู้เล่นเข้าร่วมช่องเสียงได้สำเร็จ",
  T_48_META_EVT_3051_P0_D: "เอนทิตีช่องทางเสียง",
  T_48_META_EVT_3052_D: "ทริกเกอร์เมื่อผู้เล่นไม่สามารถเข้าร่วมช่องเสียงได้",
  T_48_META_EVT_3052_P0_D: "เอนทิตีช่องทางเสียง",
  T_48_META_EVT_3053_D: "เกิดขึ้นเมื่อผู้เล่นออกจากช่องเสียง",
  T_48_META_EVT_3053_P0_D: "เอนทิตีช่องทางเสียง",
  T_48_META_EVT_3054_D: "เกิดขึ้นเมื่อฟุตบอลเข้าประตู",
  T_48_META_EVT_3054_P0_D: "เป้าหมาย",
  T_48_META_EVT_3054_P1_D: "ผู้ทำประตู ผู้เล่นคนสุดท้ายที่สัมผัสบอลก่อนทำประตู",
  T_48_META_EVT_3054_P2_D: "Assister ผู้เล่นคนสุดท้ายที่สัมผัสบอลก่อนเข้าประตู",
  T_48_META_EVT_3055_D: "เกิดขึ้นเมื่อผู้เล่นกดปุ่มยิง",
  T_48_META_EVT_3056_D: "เกิดขึ้นเมื่อผู้เล่นกระโดด",
  T_48_META_EVT_3057_D: "ทริกเกอร์เมื่อผู้เล่นหมอบอยู่",
  T_48_META_EVT_3058_D: "ทริกเกอร์เมื่อผู้เล่นคว่ำ",
  T_48_META_EVT_3059_D: "ทริกเกอร์เมื่อผู้เล่นวิ่ง",
  T_48_META_EVT_3060_D: "ทริกเกอร์เมื่อมีการซื้อสินค้าในร้านค้าสำเร็จ",
  T_48_META_EVT_3060_P0_D: "ผู้เล่นที่ซื้อสินค้า",
  T_48_META_EVT_3060_P1_D: "สินค้าโภคภัณฑ์",
  T_48_META_EVT_3061_D: "ทริกเกอร์เมื่อผู้เล่นติดตั้งอาวุธ",
  T_48_META_EVT_3061_P0_D: "ผู้เล่นที่ติดตั้งอาวุธ",
  T_48_META_EVT_3062_D: "เกิดขึ้นเมื่อยูนิตถูกสังหารด้วยอาวุธนี้",
  T_48_META_EVT_3062_P0_D: "นิติบุคคลที่ถูกฆ่า",
  T_48_META_EVT_3063_D: "เกิดขึ้นเมื่ออาวุธนี้ถูกใช้สร้างความเสียหายให้กับยูนิต",
  T_48_META_EVT_3063_P0_D: "นิติบุคคลที่ได้รับความเสียหาย",
  T_48_META_EVT_3063_P1_D: "ความเสียหาย",
  T_48_META_EVT_3064_D: "เกิดขึ้นเมื่ออาวุธเปลี่ยนกระสุน",
  T_48_META_EVT_3065_D: "ทริกเกอร์เมื่อเอนทิตีเข้าไปในยานพาหนะ เหตุการณ์นี้สามารถถูกทริกเกอร์ในฐานะคนขับหรือผู้โดยสาร",
  T_48_META_EVT_3065_P0_D: "กำลังเข้ารถ",
  T_48_META_EVT_3066_D: "เกิดขึ้นเมื่อนิติบุคคลออกจากยานพาหนะ",
  T_48_META_EVT_3066_P0_D: "รถออกเดินทาง",
  T_48_META_EVT_3067_D: "เกิดขึ้นเมื่อนิติบุคคลขับรถ",
  T_48_META_EVT_3067_P0_D: "ขับรถ",
  T_48_META_EVT_3068_D: "ทริกเกอร์หลังจากเอนทิตีเทเลพอร์ตโดยใช้พอร์ทัล",
  T_48_META_EVT_3068_P0_D: "พอร์ทัลที่ใช้",
  T_48_META_EVT_3069_D: "เกิดขึ้นหลังจากที่เอนทิตีถูกยางเด้ง",
  T_48_META_EVT_3069_P0_D: "ยางที่ใช้",
  T_48_META_EVT_3070_D: "ทริกเกอร์เมื่อเอนทิตีถูกทำให้ล้มลงโดยกลไก",
  T_48_META_EVT_3070_P0_D: "วัตถุทางกล",
  T_48_META_EVT_3071_D: "ทริกเกอร์หลังจากที่ผู้เล่นกดปุ่มควบคุม UI",
  T_48_META_EVT_3071_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3072_D: "เริ่มทำงานหลังจากที่ปุ่มควบคุม UI ถูกยกขึ้น",
  T_48_META_EVT_3072_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3073_D: "ทริกเกอร์หลังจากที่ผู้เล่นดับเบิลคลิกการควบคุมปุ่ม UI",
  T_48_META_EVT_3073_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3074_D: "พื้นที่แหกคุกเริ่มต้นขึ้น",
  T_48_META_EVT_3075_D: "สิ้นสุดพื้นที่แหกคุก",
  T_48_META_EVT_3076_D: "เริ่มทำงานเมื่อผู้เล่นหยุดใช้เวคบอร์ด",
  T_48_META_EVT_3077_D: "ทริกเกอร์เมื่อเนื้อหาข้อความของตัวควบคุมกล่องอินพุต UI มีการเปลี่ยนแปลงโดยโปรแกรมเล่น",
  T_48_META_EVT_3077_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3077_P1_D: "เนื้อหาข้อความที่เปลี่ยนแปลง",
  T_48_META_EVT_3078_D: "เริ่มทำงานเมื่อเอนทิตีที่สามารถเล่นได้เริ่มเล่น",
  T_48_META_EVT_3078_P0_D: "เอนทิตีที่สามารถเล่นได้",
  T_48_META_EVT_3079_D: "ทริกเกอร์เมื่อเอนทิตีที่สามารถเล่นได้สิ้นสุดการเล่น เมื่อเอนทิตีที่สามารถเล่นได้นั้นเป็นเอฟเฟกต์เสียง เอฟเฟกต์พิเศษ ฯลฯ เหตุการณ์นี้จะมีผลกับไคลเอนต์เท่านั้น",
  T_48_META_EVT_3079_P0_D: "เอนทิตีที่สามารถเล่นได้",
  T_48_META_EVT_3080_D: "เริ่มทำงานเมื่อเอนทิตีที่สามารถเล่นได้เล่นต่อ",
  T_48_META_EVT_3080_P0_D: "เอนทิตีที่สามารถเล่นได้",
  T_48_META_EVT_3081_D: "ทริกเกอร์เมื่อเอนทิตีที่สามารถเล่นได้หยุดการเล่นชั่วคราว",
  T_48_META_EVT_3081_P0_D: "เอนทิตีที่สามารถเล่นได้",
  T_48_META_EVT_3082_D: "ผู้เล่นที่เจลเบรคแล้วเข้าร่วม",
  T_48_META_EVT_3082_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3083_D: "ผู้เล่นที่เจลเบรคแล้วออก",
  T_48_META_EVT_3083_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3084_D: "ไฟเมื่อสิ้นสุดการนับถอยหลัง",
  T_48_META_EVT_3084_P0_D: "นิติบุคคลที่เป็นเจ้าของ",
  T_48_META_EVT_3085_D: "ทริกเกอร์เมื่อมีการหยิบไอเท็ม",
  T_48_META_EVT_3085_P0_D: "ผู้เล่นที่หยิบไอเทมขึ้นมา",
  T_48_META_EVT_3086_D: "ทริกเกอร์เมื่อไอเท็มหล่น",
  T_48_META_EVT_3086_P0_D: "ผู้เล่นที่ดรอปไอเทม",
  T_48_META_EVT_3087_D: "ทริกเกอร์เมื่อไอเท็มนี้ถูกสวมใส่",
  T_48_META_EVT_3088_D: "ยิงเมื่อวัตถุเริ่มต้นหลังจากสร้างทุ่นระเบิดแล้ว",
  T_48_META_EVT_3089_D: "ยิงเมื่อวัตถุทำงานหลังจากสร้างทุ่นระเบิดแล้ว",
  T_48_META_EVT_3089_P0_D: "กระตุ้นเป้าหมายของวัตถุหลังจากสร้างทุ่นระเบิดแล้ว",
  T_48_META_EVT_3090_D: "ทริกเกอร์ก่อนซื้อสินค้าในร้านค้า",
  T_48_META_EVT_3090_P0_D: "ผู้เล่นที่ซื้อสินค้า",
  T_48_META_EVT_3090_P1_D: "สินค้าโภคภัณฑ์",
  T_48_META_EVT_3091_D: "เริ่มทำงานเมื่อมีการใช้งานอุปกรณ์นี้",
  T_48_META_EVT_3092_D: "เกิดขึ้นเมื่อมีการยิงปืนต่อสู้",
  T_48_META_EVT_3093_D: "เกิดขึ้นเมื่อกระสุนปืนระเบิดหลังจากถูกขว้าง",
  T_48_META_EVT_3093_P0_D: "จุดระเบิด",
  T_48_META_EVT_3094_D: "เกิดขึ้นเมื่อโดนปืนฉีด",
  T_48_META_EVT_3094_P0_D: "นิติบุคคลปืนฉีด",
  T_48_META_EVT_3094_P1_D: "จุดตี",
  T_48_META_EVT_3094_P2_D: "ตีปกติ",
  T_48_META_EVT_3095_D: "เกิดขึ้นเมื่อโดนปืนพ่นสี",
  T_48_META_EVT_3095_P0_D: "ตีวัตถุ",
  T_48_META_EVT_3095_P1_D: "จุดตี",
  T_48_META_EVT_3095_P2_D: "ตีปกติ",
  T_48_META_EVT_3096_D: "เกิดขึ้นเมื่อยานพาหนะหรือถังสีย้อมระเบิด",
  T_48_META_EVT_3096_P0_D: "ผู้เล่นที่ทำให้เกิดการระเบิด",
  T_48_META_EVT_3096_P1_D: "รายชื่อผู้เล่นที่ได้รับผลกระทบจากเหตุระเบิด",
  T_48_META_EVT_3097_D: "ยิงเมื่ออาวุธหยุดยิง",
  T_48_META_EVT_3097_P0_D: "จำนวนกระสุนที่เหลืออยู่ในแม็กกาซีนปัจจุบันเมื่อหยุดการยิง",
  T_48_META_EVT_3098_D: "เกิดขึ้นเมื่อเป้าหมายไล่ล่าเข้าสู่ระยะไล่ล่า",
  T_48_META_EVT_3099_D: "เกิดขึ้นเมื่อเป้าหมายไล่ล่าออกจากระยะไล่ล่า",
  T_48_META_EVT_31_D: "ทริกเกอร์เมื่อการสลับฉากสำเร็จ",
  T_48_META_EVT_31_P0_D: "ชื่อฉาก",
  T_48_META_EVT_3100_D: "ทริกเกอร์เมื่อเป้าหมายการโจมตีเข้าสู่ระยะการโจมตี",
  T_48_META_EVT_3101_D: "เริ่มทำงานเมื่อเป้าหมายการโจมตีออกจากระยะการโจมตี",
  T_48_META_EVT_3102_D: "เหตุการณ์นี้จะถูกทริกเกอร์เมื่อมีการทริกเกอร์การตรวจจับรังสีของกล้องผ่านเหตุการณ์การคลิกของไคลเอ็นต์",
  T_48_META_EVT_3102_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3102_P1_D: "ไม่ว่ารังสีของกล้องจะกระทบกับวัตถุหรือไม่",
  T_48_META_EVT_3102_P2_D: "รังสีกล้องกระทบตำแหน่ง",
  T_48_META_EVT_3102_P3_D: "การวางแนวกล้องไคลเอนต์",
  T_48_META_EVT_3102_P4_D: "ตำแหน่งกล้องไคลเอนต์",
  T_48_META_EVT_3102_P5_D: "ตีเอนทิตี",
  T_48_META_EVT_3103_D: "ทริกเกอร์เมื่อเปิดอินเทอร์เฟซร้านค้า",
  T_48_META_EVT_3103_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3104_D: "ทริกเกอร์เมื่อปิดอินเทอร์เฟซร้านค้า",
  T_48_META_EVT_3104_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3105_D: "ทริกเกอร์เมื่อตรรกะแผนผังพฤติกรรมเข้าสู่โหนดนี้",
  T_48_META_EVT_3105_P0_D: "ชื่อโหนด",
  T_48_META_EVT_3105_P1_D: "นิติบุคคลที่เป็นเจ้าของ",
  T_48_META_EVT_3106_D: "ทริกเกอร์เมื่อลอจิกแผนผังพฤติกรรมออกจากโหนด",
  T_48_META_EVT_3106_P0_D: "ชื่อโหนด",
  T_48_META_EVT_3106_P1_D: "นิติบุคคลที่เป็นเจ้าของ",
  T_48_META_EVT_3107_D: "เกิดขึ้นเมื่อร่างกายแข็งเกร็งตื่นขึ้น",
  T_48_META_EVT_3108_D: "เกิดขึ้นเมื่อร่างกายแข็งเกร็งหลับไป",
  T_48_META_EVT_3109_D: "ทริกเกอร์เมื่อผู้เล่นเคลื่อนไหว",
  T_48_META_EVT_3109_P0_D: "ทัศนคติ",
  T_48_META_EVT_3110_D: "ทริกเกอร์เมื่อผู้เล่นไม่ได้ใช้งาน",
  T_48_META_EVT_3110_P0_D: "ทัศนคติ",
  T_48_META_EVT_3111_D: "ทริกเกอร์เมื่อผู้เล่นใช้ทักษะ",
  T_48_META_EVT_3111_P0_D: "ทักษะที่ใช้",
  T_48_META_EVT_3112_D: "เกิดขึ้นเมื่อผู้เล่นวิ่งเสร็จแล้ว",
  T_48_META_EVT_3113_D: "ทริกเกอร์เมื่อได้รับรายการที่สอดคล้องกับช่องภายใต้การแจงนับ SwitchEquipSlot",
  T_48_META_EVT_3113_P0_D: "เอนทิตีรายการที่ได้รับ",
  T_48_META_EVT_3114_D: "เกิดขึ้นเมื่อเปลี่ยนสิ่งของที่ถือ รวมถึงเมื่อเปลี่ยนเป็นหมัด",
  T_48_META_EVT_3114_P0_D: "เอนทิตีของรายการที่ถูกระงับหลังจากการสลับ",
  T_48_META_EVT_3115_D: "เกิดขึ้นเมื่อผู้เล่นในร้านค้าร้องขอให้ผู้อื่นซื้อสินค้า",
  T_48_META_EVT_3115_P0_D: "ผู้เล่นที่ขอสินค้า",
  T_48_META_EVT_3115_P1_D: "สินค้าโภคภัณฑ์",
  T_48_META_EVT_3116_D: "เกิดขึ้นเมื่อผู้เล่นในร้านค้าร้องขอให้ผู้อื่นซื้อสินค้าและคำขอได้รับการยอมรับ",
  T_48_META_EVT_3116_P0_D: "ผู้เล่นที่ช่วยซื้อ",
  T_48_META_EVT_3116_P1_D: "ผู้เล่นขอความช่วยเหลือในการซื้อ",
  T_48_META_EVT_3116_P2_D: "สินค้าโภคภัณฑ์",
  T_48_META_EVT_3117_D: "ทริกเกอร์เมื่อมีการอัปเดตเฟรมคงที่ ความถี่จะคงที่ 30 ครั้งต่อวินาที",
  T_48_META_EVT_3118_D: "ทริกเกอร์หลังจากเรียก API เกมหยุดชั่วคราว",
  T_48_META_EVT_3119_D: "ทริกเกอร์หลังจากเรียก Resume Game API",
  T_48_META_EVT_3120_D: "เกิดขึ้นเมื่อผู้เล่นเพิ่มหรือลบเพื่อน",
  T_48_META_EVT_3121_D: "ทริกเกอร์เมื่อได้รับข้อมูล Persona",
  T_48_META_EVT_3121_P0_D: "เนื้อหาข้อมูล",
  T_48_META_EVT_3121_P1_D: "ตัวตนของผู้ส่ง",
  T_48_META_EVT_3122_D: "ยิงเมื่อสิ้นสุดการกระโดดของผู้เล่น",
  T_48_META_EVT_3123_D: "ทริกเกอร์เมื่อผู้เล่นล้ม",
  T_48_META_EVT_3124_D: "ทริกเกอร์เมื่อผู้เล่นล้มลง",
  T_48_META_EVT_3125_D: "ทริกเกอร์เมื่อได้รับพฤติกรรมของ Persona",
  T_48_META_EVT_3125_P0_D: "พฤติกรรม",
  T_48_META_EVT_3125_P1_D: "ตัวตนของผู้ส่ง",
  T_48_META_EVT_3126_D: "ทริกเกอร์เมื่อข้อมูลสมาชิกเปลี่ยนแปลง",
  T_48_META_EVT_3126_P0_D: "สถานะสมาชิกภายหลังการเปลี่ยนแปลง",
  T_48_META_EVT_3127_D: "เกิดขึ้นเมื่อเข้าสู่ศูนย์สมาชิก",
  T_48_META_EVT_3128_D: "เกิดขึ้นเมื่อออกจากศูนย์สมาชิก",
  T_48_META_EVT_3129_D: "ทริกเกอร์เมื่อผู้เล่นเข้าสู่สถานะกระดก",
  T_48_META_EVT_3129_P0_D: "เอนทิตีของผู้โจมตีอาจว่างเปล่า",
  T_48_META_EVT_3130_D: "ทริกเกอร์เมื่อได้รับสถานะ Persona",
  T_48_META_EVT_3130_P0_D: "ตัวตนของผู้ส่ง",
  T_48_META_EVT_3130_P1_D: "รหัสข้อผิดพลาด",
  T_48_META_EVT_3131_D: "ทริกเกอร์เมื่อส่งข้อมูลไปยัง Persona ผ่าน UI",
  T_48_META_EVT_3131_P0_D: "เนื้อหาข้อมูล",
  T_48_META_EVT_3131_P1_D: "ตัวตนของผู้ส่ง",
  T_48_META_EVT_3132_D: "ทริกเกอร์เมื่อได้รับการสิ้นสุดของ Persona",
  T_48_META_EVT_3132_P0_D: "ตัวตนของผู้ส่ง",
  T_48_META_EVT_3132_P1_D: "รหัสข้อผิดพลาด",
  T_48_META_EVT_32_D: "เกิดขึ้นเมื่อผู้เล่นเปลี่ยนฉาก",
  T_48_META_EVT_32_P0_D: "ชื่อฉาก",
  T_48_META_EVT_3200_D: "เริ่มทำงานเมื่อคลิปแอนิเมชั่นเล่นจบแล้ว",
  T_48_META_EVT_3200_P0_D: "ชื่อคลิปแอนิเมชัน",
  T_48_META_EVT_3201_D: "ทริกเกอร์เมื่อการเล่นสถานะภาพเคลื่อนไหวเสร็จสมบูรณ์",
  T_48_META_EVT_3201_P0_D: "ชื่อสถานะแอนิเมชัน",
  T_48_META_EVT_3204_D: "ทริกเกอร์เมื่อสถานะของการควบคุม Toggle เปลี่ยนแปลง",
  T_48_META_EVT_3204_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3204_P1_D: "สถานะ",
  T_48_META_EVT_3260_D: "เริ่มทำงานเมื่อเครื่องเล่นกดทัชแพด",
  T_48_META_EVT_3260_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3260_P1_D: "กดตำแหน่ง",
  T_48_META_EVT_3261_D: "เริ่มทำงานเมื่อยกทัชแพดขึ้น",
  T_48_META_EVT_3261_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3261_P1_D: "ยกตำแหน่ง",
  T_48_META_EVT_3262_D: "เริ่มทำงานเมื่อทัชแพดเริ่มเลื่อน",
  T_48_META_EVT_3262_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3262_P1_D: "เริ่มเลื่อนตำแหน่ง",
  T_48_META_EVT_3263_D: "ทริกเกอร์ระหว่างการเลื่อนทัชแพด ในระหว่างการเลื่อน เหตุการณ์นี้จะถูกทริกเกอร์หนึ่งครั้งในทุกเฟรม",
  T_48_META_EVT_3263_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3263_P1_D: "เริ่มเลื่อนตำแหน่ง",
  T_48_META_EVT_3263_P2_D: "การกระจัด",
  T_48_META_EVT_3264_D: "ไฟไหม้ที่ส่วนท้ายของสไลด์ทัชแพด",
  T_48_META_EVT_3264_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3264_P1_D: "ตำแหน่งเลื่อนสิ้นสุด",
  T_48_META_EVT_3265_D: "เริ่มทำงานเมื่อกด JoyStick",
  T_48_META_EVT_3265_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3266_D: "เริ่มทำงานเมื่อ JoyStick ถูกยกขึ้น",
  T_48_META_EVT_3266_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3267_D: "ทริกเกอร์เมื่อใช้ JoyStick",
  T_48_META_EVT_3267_P0_D: "ทริกเกอร์ผู้เล่น",
  T_48_META_EVT_3267_P1_D: "การกระจัดของเอาท์พุต",
  T_48_META_EVT_3268_D: "เกิดขึ้นเมื่อผู้เล่นยืนขึ้นจากท่าทางอื่น",
  T_48_META_EVT_3268_P0_D: "ท่าทางของผู้เล่นก่อนลุกขึ้นยืน",
  T_48_META_EVT_3269_D: "เกิดขึ้นเมื่ออาวุธถูกยิง",
  T_48_META_EVT_4_D: "เกิดขึ้นตั้งแต่ต้นแต่ละรอบ",
  T_48_META_EVT_4_P0_D: "ดัชนีแบบกลม เริ่มต้นจาก 0",
  T_48_META_EVT_5_D: "ทริกเกอร์เมื่อสิ้นสุดแต่ละรอบ",
  T_48_META_EVT_5_P0_D: "ดัชนีแบบกลม เริ่มต้นจาก 0",
  T_48_META_EVT_6_D: "ทริกเกอร์เมื่อเอนทิตีชนกัน เฉพาะเอนทิตีที่มีส่วนประกอบตัวถังแข็งที่ติดตั้งอยู่เท่านั้นที่รองรับเหตุการณ์นี้",
  T_48_META_EVT_6_P0_D: "หน่วยงานที่พบเจอ",
  T_48_META_EVT_7_D: "เกิดขึ้นที่จุดเริ่มต้นของแต่ละเฟส",
  T_48_META_EVT_7_P0_D: "เอนทิตีบนเวที",
  T_48_META_EVT_8_D: "เกิดขึ้นเมื่อสิ้นสุดแต่ละเฟส",
  T_48_META_EVT_8_P0_D: "เอนทิตีบนเวที",
  T_48_META_EVT_9_D: "ทริกเกอร์เมื่อสิ้นสุดการชนกันของเอนทิตีเท่านั้นที่รองรับเหตุการณ์นี้",
  T_48_META_EVT_9_P0_D: "หน่วยงานที่พบเจอ",
  T_49_META_TYP_10_I1_D: "รายการแท็ก",
  T_49_META_TYP_10_I2_D: "มีจำหน่ายมั้ย?",
  T_49_META_TYP_10_I3_D: "โหนดหลักทั้งหมดพร้อมใช้งานหรือยัง?",
  T_49_META_TYP_10_I4_D: "ในฉากมีมั้ย?",
  T_49_META_TYP_10_I5_D: "ว่าจะเปิดใช้งานการอัปเดตลอจิกหรือไม่ หากปิดใช้งาน สคริปต์บนเอนทิตีจะหยุดอัปเดตทุกเฟรม",
  T_49_META_TYP_10_I6_D: "ชื่อนิติบุคคล",
  T_49_META_TYP_10_I7_D: "ตัวเลือกตัวกรองพื้นที่ 0 หมายถึงมีการควบคุมการคำนวณอัตโนมัติหรือไม่ 1 หมายถึงไม่มีการควบคุมและซิงโครไนซ์เสมอ 2 หมายถึงมีการควบคุม",
  T_49_META_TYP_100_I0_D: "ตั้งค่าช่วงการทริกเกอร์",
  T_49_META_TYP_100_I1_D: "การมองเห็นโมเดล",
  T_49_META_TYP_101_I0_D: "ผู้เล่น",
  T_49_META_TYP_101_I1_D: "รหัสไอเทมเป้าหมาย",
  T_49_META_TYP_101_I2_D: "ทิศทางการหมุนของเป้าหมาย",
  T_49_META_TYP_101_I3_D: "ขนาดเป้าหมาย",
  T_49_META_TYP_1010_I1_D: "ระยะเวลาในการจับเวลาเป็นวินาที",
  T_49_META_TYP_1010_I2_D: "เวลาเริ่มต้นของการนับถอยหลังเป็นวินาทีของเกม",
  T_49_META_TYP_1010_I3_D: "ประเภทการอัปเดตของเวลา ดู `EUITimeUpdateType` ตัวเลือก: คงที่, เวลา, นับถอยหลัง",
  T_49_META_TYP_1010_I4_D: "ตำแหน่งการแสดง เมื่อมีเป้าหมายที่จะติดตาม จะเป็นค่าออฟเซ็ตที่สัมพันธ์กับจุดกำเนิดเป้าหมาย เมื่อไม่มีเป้าหมายที่จะติดตาม จะเป็นพิกัดหน้าจอ",
  T_49_META_TYP_1011_I10_D: "ชื่อไอคอนความคืบหน้า",
  T_49_META_TYP_1011_I2_D: "สีของธีม",
  T_49_META_TYP_1011_I3_D: "ว่าจะเปิดใช้งานการแสดงผลแบบโลคัลหรือไม่",
  T_49_META_TYP_1011_I4_D: "ข้อความชื่อเรื่อง",
  T_49_META_TYP_1011_I5_D: "ข้อความคำอธิบาย",
  T_49_META_TYP_1011_I6_D: "ชื่อทรัพยากรไอคอน",
  T_49_META_TYP_1011_I7_D: "ความก้าวหน้าสูงสุด",
  T_49_META_TYP_1011_I8_D: "ความคืบหน้าในปัจจุบัน",
  T_49_META_TYP_1011_I9_D: "ไอคอนความคืบหน้า",
  T_49_META_TYP_1012_I1_D: "ว่าจะเปิดใช้งานการแปลหรือไม่",
  T_49_META_TYP_1012_I2_D: "ข้อความตัวเลขกลม",
  T_49_META_TYP_1012_I3_D: "คีย์ท้องถิ่นตัวเลขรอบ",
  T_49_META_TYP_1012_I5_D: "สีซ้าย",
  T_49_META_TYP_1012_I6_D: "สีขวา",
  T_49_META_TYP_1013_I2_D: "ข้อความตัวเลขกลม",
  T_49_META_TYP_1013_I3_D: "คีย์ท้องถิ่นตัวเลขรอบ",
  T_49_META_TYP_1014_I2_D: "ข้อความชื่อเรื่องคะแนนแรก",
  T_49_META_TYP_1014_I3_D: "คะแนนแรกมีค่า",
  T_49_META_TYP_1014_I4_D: "พารามิเตอร์ค่าคะแนนแรก",
  T_49_META_TYP_1014_I5_D: "ข้อความชื่อเรื่องคะแนนที่สอง",
  T_49_META_TYP_1014_I6_D: "ค่าคะแนนที่สอง",
  T_49_META_TYP_1014_I7_D: "พารามิเตอร์ค่าคะแนนแบบที่สอง",
  T_49_META_TYP_1016_I1_D: "แสดงสถานะตามค่า ชนะ (1), แพ้ (2), เสมอ (3), บูย่า (4)",
  T_49_META_TYP_1016_I2_D: "แสดงคะแนนของ 2 ทีม หากเป็นจริงคะแนนจะแสดง หากไม่เป็นจริงคะแนนจะถูกซ่อน",
  T_49_META_TYP_1016_I3_D: "คะแนนทีมทางซ้าย",
  T_49_META_TYP_1016_I4_D: "คะแนนทีมทางขวา",
  T_49_META_TYP_1016_I5_D: "ประทับเวลาสิ้นสุดเฟส",
  T_49_META_TYP_1017_I1_D: "ชื่อทีมด้านซ้าย",
  T_49_META_TYP_1017_I2_D: "คำอธิบายของทีมด้านซ้าย",
  T_49_META_TYP_1017_I3_D: "ชื่อทีมด้านขวา",
  T_49_META_TYP_1017_I4_D: "คำอธิบายของทีมด้านขวา",
  T_49_META_TYP_1018_I1_D: "ตัวเลขรอบ",
  T_49_META_TYP_1018_I4_D: "คะแนนทีมซ้าย",
  T_49_META_TYP_1018_I6_D: "คะแนนทีมขวา",
  T_49_META_TYP_1019_I1_D: "ชนะ แพ้ เสมอ สอดคล้องกับ 1 2 3 ตามลำดับ",
  T_49_META_TYP_102_I0_D: "ประเภทแหล่งที่มาของการฟื้นคืนชีพ ผู้เล่นฟื้นคืนชีพจากความตาย",
  T_49_META_TYP_102_I1_D: "ประเภทแหล่งการฟื้นคืนชีพ ผู้เล่นฟื้นคืนชีพจากสถานะล้มลง",
  T_49_META_TYP_1020_I2_D: "ปุ่มข้อความที่จะแสดง",
  T_49_META_TYP_1020_I3_D: "อาร์เรย์พารามิเตอร์ที่สอดคล้องกับคีย์ข้อความ",
  T_49_META_TYP_1021_I1_D: "เวลาฐานเป็นวินาที",
  T_49_META_TYP_1021_I2_D: "ระยะเวลาเป็นวินาที",
  T_49_META_TYP_1021_I3_D: "ตำแหน่งการแสดงผล เมื่อมีเป้าหมายที่จะติดตาม จะเป็นค่าออฟเซ็ตที่สัมพันธ์กับจุดกำเนิดของเป้าหมาย เมื่อไม่มีเป้าหมายที่จะติดตาม จะเป็นพิกัดหน้าจอ ค่าเริ่มต้นคือ Vector3(0)",
  T_49_META_TYP_1022_I2_D: "ปุ่มข้อความที่จะแสดง",
  T_49_META_TYP_1022_I3_D: "อาร์เรย์พารามิเตอร์ที่สอดคล้องกับคีย์ข้อความ",
  T_49_META_TYP_1023_I1_D: "การแสดงคะแนนทีมจะแสดงเมื่อเป็นจริง มิฉะนั้นจะปิด",
  T_49_META_TYP_1023_I4_D: "แสดงเมื่อสถานะผู้เล่นเป็นจริง มิฉะนั้นจะปิด",
  T_49_META_TYP_1023_I5_D: "อาร์เรย์สถานะของผู้เล่นด้านซ้าย 0: จำนวนผู้เล่นที่ยังมีชีวิตอยู่ 1: จำนวนผู้เล่นที่เสียชีวิต 2: จำนวนผู้เล่นที่เสียชีวิต",
  T_49_META_TYP_1023_I6_D: "อาร์เรย์สถานะของผู้เล่นด้านขวา 0: จำนวนผู้เล่นที่ยังมีชีวิตอยู่ 1: จำนวนผู้เล่นที่เสียชีวิต 2: จำนวนผู้เล่นที่เสียชีวิต",
  T_49_META_TYP_1023_I7_D: "จำนวนธงของทีมฝ่ายซ้าย",
  T_49_META_TYP_1023_I8_D: "จำนวนธงของทีมฝ่ายขวา",
  T_49_META_TYP_1024_I2_D: "ออฟเซ็ต",
  T_49_META_TYP_1024_I3_D: "การจัดอันดับ",
  T_49_META_TYP_1024_I4_D: "สีทีม",
  T_49_META_TYP_1024_I5_D: "ชื่อไอคอน",
  T_49_META_TYP_1024_I6_D: "หากเส้นขอบเป็นจริงมันจะแสดง หากเส้นขอบเป็นจริงมันจะถูกปิด",
  T_49_META_TYP_1024_I7_D: "คีย์ข้อความคะแนน",
  T_49_META_TYP_1024_I8_D: "คีย์พารามิเตอร์ข้อความคะแนน",
  T_49_META_TYP_1028_I1_D: "จำนวนผู้รอดชีวิตในทีมทางด้านซ้าย",
  T_49_META_TYP_1028_I2_D: "จำนวนผู้รอดชีวิตในทีมทางด้านขวา",
  T_49_META_TYP_1028_I3_D: "สีพื้นหลังด้านซ้าย",
  T_49_META_TYP_1028_I4_D: "สีพื้นหลังด้านขวา",
  T_49_META_TYP_1028_I5_D: "ชื่อไอคอนทางด้านซ้าย",
  T_49_META_TYP_1028_I6_D: "ชื่อไอคอนทางด้านขวา",
  T_49_META_TYP_1029_I1_D: "ชื่อไอคอน",
  T_49_META_TYP_1029_I2_D: "ชื่อไอคอนพื้นหลัง",
  T_49_META_TYP_103_I0_D: "อาวุธหลักA",
  T_49_META_TYP_103_I1_D: "อาวุธหลักB",
  T_49_META_TYP_103_I10_D: "ระเบิดแช่แข็ง",
  T_49_META_TYP_103_I11_D: "กำแพงน้ำแข็ง",
  T_49_META_TYP_103_I12_D: "กับระเบิด",
  T_49_META_TYP_103_I13_D: "ป้อมปืนอัตโนมัติ",
  T_49_META_TYP_103_I14_D: "ระเบิดจำลอง",
  T_49_META_TYP_103_I16_D: "สเก็ตบอร์ด ลายพราง...",
  T_49_META_TYP_103_I2_D: "อาวุธรอง",
  T_49_META_TYP_103_I3_D: "อาวุธระเบิด",
  T_49_META_TYP_103_I5_D: "อาวุธหนัก",
  T_49_META_TYP_1030_I3_D: "จำนวนผู้รอดชีวิตในทีมทางด้านซ้าย",
  T_49_META_TYP_1030_I4_D: "จำนวนผู้รอดชีวิตในทีมทางด้านขวา",
  T_49_META_TYP_1030_I5_D: "ชื่อไอคอนทีมอยู่ทางซ้าย",
  T_49_META_TYP_1030_I6_D: "ชื่อไอคอนทีมอยู่ทางขวา",
  T_49_META_TYP_1031_I2_D: "คำอธิบายข้อมูลด่วน",
  T_49_META_TYP_1031_I3_D: "เริ่มนับถอยหลังเวลาเป็นวินาที",
  T_49_META_TYP_1031_I4_D: "พารามิเตอร์คำอธิบาย",
  T_49_META_TYP_1032_I1_D: "ประเภทของเคล็ดลับ",
  T_49_META_TYP_1032_I3_D: "ข้อมูลอาร์เรย์คำอธิบายพร้อมท์ข้อมูล",
  T_49_META_TYP_1033_I1_D: "เฟสการสลับ 0 หมายถึงรอบปัจจุบันเสร็จสิ้นแล้ว 1 หมายถึงรอบต่อไปเริ่ม",
  T_49_META_TYP_1033_I10_D: "ข้อความแจ้งเตือนความล้มเหลว ปล่อยว่างไว้เพื่อใช้เป็นค่าเริ่มต้น",
  T_49_META_TYP_1033_I11_D: "ชื่อรายได้แบบปัดเศษ",
  T_49_META_TYP_1033_I12_D: "มูลค่ารายได้แบบปัดเศษ",
  T_49_META_TYP_1033_I13_D: "รายการชื่อรายละเอียดรายได้แบบปัดเศษ",
  T_49_META_TYP_1033_I14_D: "รายละเอียดของค่ารายได้รอบจะสอดคล้องกับรายการรายละเอียดหัวข้อด้านบน",
  T_49_META_TYP_1033_I15_D: "ชื่อเล่นผู้เล่น MVP",
  T_49_META_TYP_1033_I16_D: "อินเด็กซ์รอบต่อไป",
  T_49_META_TYP_1033_I17_D: "เป็นคะแนนสุดท้ายของการแข่งขันไหม",
  T_49_META_TYP_1033_I18_D: "เป็นรอบสุดท้ายไหม",
  T_49_META_TYP_1033_I6_D: "ชื่อไอคอนทีมอยู่ทางซ้าย",
  T_49_META_TYP_1033_I7_D: "ชื่อไอคอนทีมอยู่ทางขวา",
  T_49_META_TYP_1033_I8_D: "แสดงสถานะที่สอดคล้องกันตามค่าชัยชนะ (1) ความล้มเหลว (2)",
  T_49_META_TYP_1033_I9_D: "ข้อความแจ้งเตือนชัยชนะ ปล่อยว่างไว้เพื่อใช้ค่าเริ่มต้น",
  T_49_META_TYP_1036_I1_D: "ระบุจำนวนระดับ",
  T_49_META_TYP_1036_I2_D: "ระบุระดับซอมบี้ในปัจจุบัน",
  T_49_META_TYP_1037_I1_D: "ระบุจำนวนจุดที่จะแสดง",
  T_49_META_TYP_1039_I3_D: "เริ่มนับถอยหลังเวลาเป็นวินาที",
  T_49_META_TYP_104_I0_D: "สไตล์ A",
  T_49_META_TYP_104_I1_D: "สไตล์ B",
  T_49_META_TYP_104_I2_D: "สไตล์ C",
  T_49_META_TYP_1040_I10_D: "คำอธิบายไอเทม",
  T_49_META_TYP_1040_I11_D: "ดัชนีของรายการที่เลือก เริ่มจาก 0 ถ้ามีค่าน้อยกว่า 0 แสดงว่ายกเลิกการเลือก",
  T_49_META_TYP_1040_I12_D: "อาร์เรย์ของชื่อปุ่ม",
  T_49_META_TYP_1040_I13_D: "อาร์เรย์สีของปุ่ม",
  T_49_META_TYP_1040_I2_D: "คีย์นับถอยหลัง",
  T_49_META_TYP_1040_I3_D: "ความยาวนับถอยหลัง",
  T_49_META_TYP_1040_I4_D: "ข้อมูลคำอธิบายคีย์",
  T_49_META_TYP_1040_I5_D: "คำอธิบายข้อมูลพารามิเตอร์อาร์เรย์",
  T_49_META_TYP_1040_I6_D: "ไอเทมพื้นหลัง",
  T_49_META_TYP_1040_I7_D: "ไอเทมสีพื้นหลัง",
  T_49_META_TYP_1040_I8_D: "ไอเทมไอคอน",
  T_49_META_TYP_1040_I9_D: "ชื่อไอเทม",
  T_49_META_TYP_1041_I2_D: "ตำแหน่ง",
  T_49_META_TYP_1041_I3_D: "ภาพไอคอน",
  T_49_META_TYP_1041_I4_D: "ฉลาก",
  T_49_META_TYP_1041_I5_D: "สีพื้นหลัง",
  T_49_META_TYP_1042_I1_D: "ตำแหน่งโดยอ้างอิงจากวัตถุแม่",
  T_49_META_TYP_1043_I4_D: "สี",
  T_49_META_TYP_1043_I5_D: "คีย์ของฉลาก",
  T_49_META_TYP_1043_I6_D: "พารามิเตอร์ของฉลาก",
  T_49_META_TYP_1045_I2_D: "ไอคอนปุ่ม",
  T_49_META_TYP_1045_I3_D: "สีไอคอน",
  T_49_META_TYP_1045_I4_D: "ขนาดความกว้างและความสูงเท่ากัน",
  T_49_META_TYP_1045_I5_D: "ตำแหน่งสัมพันธ์กับจุดยึดด้านล่างขวา",
  T_49_META_TYP_1045_I6_D: "ปริมาณการชาร์จซ่อนไว้หากน้อยกว่า 0",
  T_49_META_TYP_1045_I7_D: "เวลาเริ่มต้นซีดีเป็นมิลลิวินาที",
  T_49_META_TYP_1045_I8_D: "ระยะเวลาซีดีเป็นมิลลิวินาที",
  T_49_META_TYP_1045_I9_D: "หากเป็น True ปุ่มจะกลายเป็นสีเทา และหากเป็น False ปุ่มจะถูกคืนค่า",
  T_49_META_TYP_106_I1_D: "เปิดใช้งาน",
  T_49_META_TYP_106_I2_D: "ปิดการใช้งาน",
  T_49_META_TYP_109_I0_D: "รหัสช่องพูดคุย",
  T_49_META_TYP_109_I1_D: "รายการผู้เล่น",
  T_49_META_TYP_11_I0_D: "เกมปัจจุบันอยู่ในสถานะผิดกฎหมายหรือไม่ หากอยู่ในสถานะผิดกฎหมาย แสดงว่าเกมสูญเสียคุณค่าในการเผชิญหน้า ขอแนะนำให้ยุติเกมโดยตรง",
  T_49_META_TYP_11_I1_D: "ระยะเวลาของเกมปัจจุบันเป็นมิลลิวินาที",
  T_49_META_TYP_11_I10_D: "ไม่ว่าจะรีเซ็ตอุปกรณ์ทุก ๆ รอบ",
  T_49_META_TYP_11_I11_D: "ว่าจะเปิดใช้งานกลไกวงพิษหรือไม่",
  T_49_META_TYP_11_I12_D: "ขนาดของพื้นที่ปลอดภัย",
  T_49_META_TYP_11_I13_D: "เวลาเริ่มของการหดเล็กลง",
  T_49_META_TYP_11_I14_D: "ระยะเวลาของการหดเล็กลง",
  T_49_META_TYP_11_I15_D: "ความเสียหายเมื่ออยู่นอกพื้นที่",
  T_49_META_TYP_11_I18_D: "ประเภทของการฟื้นคืนชีพ",
  T_49_META_TYP_11_I2_D: "ดัชนีรอบปัจจุบัน ซึ่งสามารถใช้รับเอนทิตีรอบปัจจุบันได้",
  T_49_META_TYP_11_I27_D: "จำนวนรอบทั้งหมด",
  T_49_META_TYP_11_I3_D: "ดัชนีขั้นตอนปัจจุบัน ซึ่งสามารถใช้รับเอนทิตีขั้นตอนปัจจุบันได้",
  T_49_META_TYP_11_I32_D: "จำนวนเหรียญทองที่ได้รับในช่วงเริ่มต้นรอบ",
  T_49_META_TYP_11_I33_D: "จำนวนเหรียญทองที่ได้รับจากการฆ่า",
  T_49_META_TYP_11_I34_D: "จำนวนเหรียญทองที่ได้รับเมื่อชนะ",
  T_49_META_TYP_11_I35_D: "ว่าจะแสดง UI ของกระเป๋าเงินหรือไม่",
  T_49_META_TYP_11_I36_D: "สกายบ็อกซ์เอนทิตี้",
  T_49_META_TYP_11_I37_D: "เฟรมการทำงานสะสมตั้งแต่เกมเริ่มต้น",
  T_49_META_TYP_11_I38_D: "สามารถขยับได้ไหม",
  T_49_META_TYP_11_I39_D: "ไม่ว่าจะปรับแต่งการตั้งถิ่นฐาน",
  T_49_META_TYP_11_I4_D: "ID เทมเพลตของโหมด UGC ที่ตั้งไว้ล่วงหน้า",
  T_49_META_TYP_11_I40_D: "สามารถเข้าร่วมกลางทางได้หรือเปล่า?",
  T_49_META_TYP_11_I41_D: "เปิดโหมดเฟรมเรตต่ำ เกมจะทำงานที่ 15FPS มิฉะนั้นจะทำงานที่ 30FPS",
  T_49_META_TYP_11_I42_D: "ช่วงเวลาระหว่างการอัปเดตเฟรมลอจิกสองครั้งของเซิร์ฟเวอร์เกม",
  T_49_META_TYP_11_I43_D: "ช่วงเวลาการอัพเดตเฟรมคงที่เป็นมิลลิวินาที",
  T_49_META_TYP_11_I5_D: "หากปิด การคืนชีพของผู้เล่นจะถูกปิดใช้งาน",
  T_49_META_TYP_11_I6_D: "หากปิด การฟื้นคืนชีพของบอทจะถูกปิดใช้งาน",
  T_49_META_TYP_11_I7_D: "ระยะเวลาการฟื้นคืนชีพเป็นวินาที",
  T_49_META_TYP_11_I8_D: "จำนวนทีมทั้งหมดในเกม",
  T_49_META_TYP_11_I9_D: "จำนวนสมาชิกต่อทีม",
  T_49_META_TYP_110_I0_D: "ช่อง A",
  T_49_META_TYP_110_I1_D: "ช่อง B",
  T_49_META_TYP_110_I2_D: "ช่อง C",
  T_49_META_TYP_110_I3_D: "ช่อง D",
  T_49_META_TYP_110_I4_D: "ช่อง E",
  T_49_META_TYP_110_I5_D: "ช่อง F",
  T_49_META_TYP_111_I1_D: "วิ่ง",
  T_49_META_TYP_111_I2_D: "โจมตี",
  T_49_META_TYP_111_I3_D: "กระโดด",
  T_49_META_TYP_111_I4_D: "ปืนข้าม/กระโดดข้าม",
  T_49_META_TYP_111_I5_D: "ขับ",
  T_49_META_TYP_111_I6_D: "เข้ายานพาหนะ",
  T_49_META_TYP_111_I7_D: "ออกยานพาหนะ",
  T_49_META_TYP_111_I8_D: "ขับขี่ยานพาหนะ",
  T_49_META_TYP_112_I0_D: "เปิดใช้งาน",
  T_49_META_TYP_112_I1_D: "ปิดการใช้งาน",
  T_49_META_TYP_112_I2_D: "ล่องหน",
  T_49_META_TYP_117_I0_D: "ปรบมือ",
  T_49_META_TYP_117_I1_D: "ไฮแฮท",
  T_49_META_TYP_117_I2_D: "เตะ",
  T_49_META_TYP_117_I3_D: "เปิดไฮแฮช",
  T_49_META_TYP_117_I4_D: "ขี่",
  T_49_META_TYP_117_I5_D: "บ่วง",
  T_49_META_TYP_118_I0_D: "ว่าสมาชิกในค่ายตายกันหมดหรือยัง",
  T_49_META_TYP_118_I1_D: "รายชื่อผู้เล่นทั้งหมด",
  T_49_META_TYP_118_I2_D: "ฝ่ายพันธมิตร",
  T_49_META_TYP_118_I3_D: "ฝ่ายที่สามารถโจมตีได้",
  T_49_META_TYP_118_I4_D: "ว่าจะแสดงชื่อ UI หรือไม่",
  T_49_META_TYP_118_I5_D: "ว่าจะแสดงข้อมูลแผนที่หรือไม่",
  T_49_META_TYP_118_I6_D: "ว่าจะแสดง",
  T_49_META_TYP_118_I7_D: "ว่าจะแสดง",
  T_49_META_TYP_118_I8_D: "สมาชิกทั้งหมด",
  T_49_META_TYP_118_I9_D: "แสดงข้อความแบบด่วนไหม",
  T_49_META_TYP_119_I0_D: "ใช่",
  T_49_META_TYP_119_I1_D: "ไม่ใช่",
  T_49_META_TYP_120_I1_D: "เอนทิตี้เป้าหมายที่จะติดตาม ค่าเริ่มต้นคือว่างเปล่า",
  T_49_META_TYP_120_I2_D: "สี UI",
  T_49_META_TYP_120_I3_D: "ความยาว UI",
  T_49_META_TYP_120_I4_D: "ค่าความคืบหน้าปัจจุบัน 0 ถึง 1.0",
  T_49_META_TYP_120_I5_D: "ตำแหน่งการแสดงผล เมื่อมีเป้าหมายที่จะติดตาม จะเป็นค่าออฟเซ็ตที่สัมพันธ์กับจุดกำเนิดของเป้าหมาย เมื่อไม่มีเป้าหมายที่จะติดตาม จะเป็นพิกัดหน้าจอ ค่าเริ่มต้นคือ Vector3(0)",
  T_49_META_TYP_121_I0_D: "3 วินาที",
  T_49_META_TYP_121_I1_D: "5 วินาที",
  T_49_META_TYP_121_I2_D: "10 วินาที",
  T_49_META_TYP_121_I3_D: "15 วินาที",
  T_49_META_TYP_121_I4_D: "30 วินาที",
  T_49_META_TYP_121_I5_D: "9999 วินาที",
  T_49_META_TYP_122_I0_D: "ทรัพยากรสกายบ็อกซ์พื้นฐาน",
  T_49_META_TYP_122_I1_D: "สีของแสง",
  T_49_META_TYP_122_I10_D: "GUID ของฉากย่อย",
  T_49_META_TYP_122_I11_D: "สวิตซ์เอฟเฟกต์หมอก",
  T_49_META_TYP_122_I12_D: "โหมดเอฟเฟกต์หมอก",
  T_49_META_TYP_122_I13_D: "ความหนาแน่นของหมอกแบบเอ็กซ์โพเนนเชียล",
  T_49_META_TYP_122_I14_D: "ระยะเริ่มต้นของหมอกเชิงเส้น",
  T_49_META_TYP_122_I15_D: "ระยะสิ้นสุดของหมอกเชิงเส้น",
  T_49_META_TYP_122_I16_D: "เปิดใช้งานคุณสมบัติเอฟเฟกต์หมอก",
  T_49_META_TYP_122_I17_D: "มุมการหมุนของแหล่งกำเนิดแสงหลัก",
  T_49_META_TYP_122_I18_D: "เปิดใช้งานคุณสมบัติมุมหมุนแหล่งกำเนิดแสงหลัก",
  T_49_META_TYP_122_I2_D: "ความเข้มข้นของแสง",
  T_49_META_TYP_122_I3_D: "ความมืด",
  T_49_META_TYP_122_I4_D: "ความแรงของเงา",
  T_49_META_TYP_122_I5_D: "ความเปียกของภูมิประเทศ",
  T_49_META_TYP_122_I6_D: "แสงตกกระทบจากเลนส์",
  T_49_META_TYP_122_I7_D: "สีของหมอก",
  T_49_META_TYP_122_I8_D: "สีบรรยากาศ",
  T_49_META_TYP_123_I0_D: "วัน",
  T_49_META_TYP_123_I1_D: "กลางคืน",
  T_49_META_TYP_123_I2_D: "พลบค่ำ",
  T_49_META_TYP_123_I3_D: "มุมมองเมือง",
  T_49_META_TYP_123_I4_D: "ท้องฟ้ามีสีสัน",
  T_49_META_TYP_123_I5_D: "ดวงจันทร์เยือกแข็ง",
  T_49_META_TYP_124_I0_D: "ระยะใกล้",
  T_49_META_TYP_124_I1_D: "ระยะกลาง",
  T_49_META_TYP_124_I2_D: "ระยะไกล",
  T_49_META_TYP_125_I0_D: "สีการกระจาย (Diffuse Color)",
  T_49_META_TYP_125_I2_D: "เท็กเจอร์ของการกระจาย (Diffuse Texture)",
  T_49_META_TYP_125_I4_D: "ความโปร่งของการกระจาย (Diffuse Alpha)",
  T_49_META_TYP_126_I1_D: "ชื่อ",
  T_49_META_TYP_126_I2_D: "มูลค่าความก้าวหน้าในปัจจุบัน",
  T_49_META_TYP_126_I3_D: "ค่าความก้าวหน้าสูงสุด",
  T_49_META_TYP_126_I4_D: "พิกัดหน้าจอค่าเริ่มต้นคือ Vector3(0)",
  T_49_META_TYP_126_I5_D: "ความยาวของแถบความคืบหน้า ค่าเริ่มต้นปัจจุบันคือความยาวของ UI บนพรีแฟบ",
  T_49_META_TYP_127_I0_D: "การแปลตามแกนใดแกนหนึ่ง สามารถรวมแกนทั้งสามเข้าด้วยกันได้",
  T_49_META_TYP_127_I1_D: "หมุนตามแกนใดแกนหนึ่ง สามารถรวมแกนทั้งสามเข้าด้วยกันได้",
  T_49_META_TYP_127_I2_D: "ซูมไปตามแกนใดแกนหนึ่ง คุณสามารถรวมแกนทั้งสามเข้าด้วยกันได้",
  T_49_META_TYP_128_I0_D: "พุ่มไม้",
  T_49_META_TYP_128_I1_D: "ฟักทอง",
  T_49_META_TYP_128_I2_D: "หุ่นไล่กา",
  T_49_META_TYP_128_I3_D: "ตู้",
  T_49_META_TYP_129_I0_D: "ของปล้นแบบสุ่ม",
  T_49_META_TYP_129_I1_D: "กระสุนปืนไรเฟิล",
  T_49_META_TYP_129_I2_D: "กระสุนปินกลเบา",
  T_49_META_TYP_129_I3_D: "กระสุน SN",
  T_49_META_TYP_129_I4_D: "กระสุน HG",
  T_49_META_TYP_129_I5_D: "กระสุน SG",
  T_49_META_TYP_129_I6_D: "กระสุนธนู",
  T_49_META_TYP_13_I1_D: "พิกัดจุดยึดสัมพันธ์กับโหนดหลัก",
  T_49_META_TYP_13_I10_D: "ความแตกต่างของขนาดกล่องวิดเจ็ตและจุดยึด",
  T_49_META_TYP_13_I11_D: "จุดศูนย์กลางการหมุน",
  T_49_META_TYP_13_I12_D: "ความลึก",
  T_49_META_TYP_13_I14_D: "ลำดับของโหนดย่อยทั้งหมดภายใต้โหนดหลักเดียวกัน",
  T_49_META_TYP_13_I15_D: "การควบคุมโหนดหลัก EntityID",
  T_49_META_TYP_13_I16_D: "รหัสประจำตัวเฉพาะ",
  T_49_META_TYP_13_I17_D: "ลำดับความสำคัญ",
  T_49_META_TYP_13_I18_D: "ตำแหน่งที่แท้จริง",
  T_49_META_TYP_13_I2_D: "ความกว้าง",
  T_49_META_TYP_13_I4_D: "มุมการหมุนแกน Z",
  T_49_META_TYP_13_I6_D: "ID ภายในของการควบคุมใน Prefab",
  T_49_META_TYP_13_I7_D: "เอนทิตี้ UI",
  T_49_META_TYP_13_I8_D: "สมอต่ำสุด",
  T_49_META_TYP_13_I9_D: "สมอสูงสุด",
  T_49_META_TYP_130_I0_D: "ของใช้สิ้นเปลืองแบบสุ่ม",
  T_49_META_TYP_130_I1_D: "ชุดยา",
  T_49_META_TYP_130_I2_D: "ชุดเครื่องมือซ่อมแซม",
  T_49_META_TYP_130_I3_D: "ฮอริซาลีน",
  T_49_META_TYP_130_I4_D: "เครื่องพ่นยา",
  T_49_META_TYP_131_I0_D: "ปล้นเกราะแบบสุ่ม",
  T_49_META_TYP_131_I1_D: "เกราะระดับ 1",
  T_49_META_TYP_131_I2_D: "เกราะระดับที่สอง",
  T_49_META_TYP_131_I3_D: "เกราะระดับ 3",
  T_49_META_TYP_132_I0_D: "การโยนแบบสุ่ม",
  T_49_META_TYP_132_I1_D: "ระเบิดมือ",
  T_49_META_TYP_132_I4_D: "แช่แสง",
  T_49_META_TYP_133_I0_D: "สุ่มปล้นสโคป",
  T_49_META_TYP_133_I1_D: "กล้อง 2x",
  T_49_META_TYP_133_I2_D: "กล้อง 4x",
  T_49_META_TYP_133_I3_D: "ขอบเขตความร้อน",
  T_49_META_TYP_134_I0_D: "ลูทอาวุธสุ่ม",
  T_49_META_TYP_134_I5_D: "ปืนลูกซอง",
  T_49_META_TYP_134_I8_D: "ปืนฟุตบอล",
  T_49_META_TYP_135_I0_D: "ขโมยจุดกระสุน",
  T_49_META_TYP_136_I0_D: "ไอเทมที่ใช้แล้วได้คะแนนสะสม",
  T_49_META_TYP_137_I0_D: "ไอเทมที่ใช้แล้วได้คะแนนสะสม",
  T_49_META_TYP_138_I0_D: "จุดซูมปล้น",
  T_49_META_TYP_139_I0_D: "ปล้นแต้มเกราะ",
  T_49_META_TYP_14_I0_D: "สุขภาพของผู้เล่นในปัจจุบัน",
  T_49_META_TYP_14_I1_D: "ค่าสุขภาพสูงสุดในปัจจุบันของผู้เล่น",
  T_49_META_TYP_14_I11_D: "ฝ่ายผู้เล่น",
  T_49_META_TYP_14_I12_D: "ตัวคูณความเสียหายของผู้เล่นเช่น 2x คือ 2.0",
  T_49_META_TYP_14_I13_D: "ใช้โครงกระดูกที่เหมือนกันทุกประการกับตัวละครชายหรือหญิง 0 หมายถึงอย่าเปลี่ยนโมเดล",
  T_49_META_TYP_14_I14_D: "จะไม่ขัดแย้งกับการปรับความเร็วที่มีอยู่",
  T_49_META_TYP_14_I15_D: "จะไม่ขัดแย้งกับการปรับความสูงการกระโดดที่มีอยู่",
  T_49_META_TYP_14_I16_D: "ตัวตน 0 ผู้เล่นทั่วไป 1 นักล่า 2 ซอมบี้แม่ 3 ซอมบี้ทั่วไป 4 ซอมบี้ประเภทวิวัฒนาการ 1 ซอมบี้ประเภทวิวัฒนาการ 5 ซอมบี้ประเภทวิวัฒนาการ 2 ซอมบี้ประเภทวิวัฒนาการ 6",
  T_49_META_TYP_14_I17_D: "เลเวลซอมบี้ 1~3",
  T_49_META_TYP_14_I19_D: "ชื่อเล่นของผู้เล่น",
  T_49_META_TYP_14_I2_D: "ตรวจสอบว่าผู้เล่นปัจจุบันเป็นผู้เล่น AI หรือไม่ AI มักจะเป็น NPC หรือมอนสเตอร์ PVE",
  T_49_META_TYP_14_I20_D: "เมื่อได้รับความเสียหาย สามารถลดหรือเพิ่มเปอร์เซ็นต์ความเสียหายได้",
  T_49_META_TYP_14_I21_D: "EP ปัจจุบันของผู้เล่น",
  T_49_META_TYP_14_I22_D: "EP ผู้เล่นสูงสุด",
  T_49_META_TYP_14_I23_D: "อาวุธหลักที่อยู่ในมือขณะนี้",
  T_49_META_TYP_14_I24_D: "ดรอปตอนถูกกำจัดไหม",
  T_49_META_TYP_14_I26_D: "ประเภทของตัวช่วยเล็ง",
  T_49_META_TYP_14_I27_D: "อนุญาตให้ล็อคโดย Aim Assist",
  T_49_META_TYP_14_I28_D: "สลับการแชทด้วยเสียง: true จะปิดเสียง false จะเปิดเสียง",
  T_49_META_TYP_14_I29_D: "สลับการแชทด่วน: true จะปิดเสียง false จะเปิดเสียง",
  T_49_META_TYP_14_I3_D: "สถานะผู้เล่น",
  T_49_META_TYP_14_I30_D: "ช่อง",
  T_49_META_TYP_14_I35_D: "สลับการรับรายการ: true เพื่อปิดใช้งานการรับ, false เพื่อเปิดใช้งานการรับ",
  T_49_META_TYP_14_I36_D: "สลับการทิ้งรายการ: true เพื่อป้องกันไม่ให้รายการถูกทิ้ง false เพื่ออนุญาตให้รายการถูกทิ้ง",
  T_49_META_TYP_14_I37_D: "เป้าหมายที่สามารถโจมตีได้",
  T_49_META_TYP_14_I38_D: "ผู้เล่นที่เป็นมิตร",
  T_49_META_TYP_14_I39_D: "ฝ่าย",
  T_49_META_TYP_14_I4_D: "ระยะเวลาเอาชีวิตรอดของผู้เล่น หากผู้เล่นตาย เวลาจะถูกคำนวณใหม่",
  T_49_META_TYP_14_I40_D: "หมายเลขในฝ่าย",
  T_49_META_TYP_14_I41_D: "กล้องที่ผู้เล่นกำลังใช้",
  T_49_META_TYP_14_I42_D: "แรงโน้มถ่วงแบบกำหนดเอง",
  T_49_META_TYP_14_I43_D: "หมวกกันน็อคปัจจุบัน",
  T_49_META_TYP_14_I44_D: "เสื้อเกราะ",
  T_49_META_TYP_14_I5_D: "ความอยู่ยงคงกระพันของผู้เล่น",
  T_49_META_TYP_14_I52_D: "รหัสผู้ใช้",
  T_49_META_TYP_14_I53_D: "อัตราการลดความเสียหายจากการยิงหัว",
  T_49_META_TYP_14_I54_D: "AVATAR ที่ถูกผูกไว้กับผู้เล่น",
  T_49_META_TYP_14_I55_D: "เพศ",
  T_49_META_TYP_14_I56_D: "รหัสสกินปืน",
  T_49_META_TYP_14_I57_D: "จุดเกิดของผู้เล่น",
  T_49_META_TYP_14_I58_D: "จุดคืนชีพของผู้เล่น หากไม่มีบันทึกจุดตรวจ จุดเกิดจะถูกใช้ หากไม่เช่นนั้น จุดตรวจจะถูกใช้",
  T_49_META_TYP_14_I59_D: "ตำแหน่งปัจจุบันของผู้เล่น",
  T_49_META_TYP_14_I6_D: "หน่วยงานที่ผู้เล่นเป็นสมาชิกอยู่",
  T_49_META_TYP_14_I60_D: "ทิศทางของผู้เล่นในปัจจุบัน",
  T_49_META_TYP_14_I61_D: "โหนดที่ใช้เข้าถึงกระดูกผิวหนัง",
  T_49_META_TYP_14_I62_D: "กระเป๋าเป้",
  T_49_META_TYP_14_I63_D: "ค่าโล่ชั่วคราว",
  T_49_META_TYP_14_I64_D: "รหัสสกินยานพาหนะ",
  T_49_META_TYP_14_I65_D: "ข้ามแอนิเมชันที่ค้างไหม",
  T_49_META_TYP_14_I66_D: "ปิดความเสียหายจากการตก",
  T_49_META_TYP_14_I67_D: "รายการที่ถืออยู่ในปัจจุบัน",
  T_49_META_TYP_14_I68_D: "รายการสิ่งของห้ามหยิบ",
  T_49_META_TYP_14_I69_D: "รหัสทรัพยากรผู้เล่น",
  T_49_META_TYP_14_I7_D: "รหัสจุดตรวจปัจจุบัน",
  T_49_META_TYP_14_I70_D: "เป้าหมายส่งข้อความขอซื้อไปที่",
  T_49_META_TYP_14_I71_D: "ID ของทรัพยากร Emote ที่กำลังเล่นอยู่ขณะนี้",
  T_49_META_TYP_14_I72_D: "ไม่ว่า Emote ที่กำลังเล่นอยู่ในปัจจุบันจะวนซ้ำอยู่หรือไม่",
  T_49_META_TYP_14_I73_D: "การรับมือกับสภาวะน็อคดาวน์",
  T_49_META_TYP_14_I74_D: "ไม่ว่าจะเปิดใช้งานการกระโดดความเสียหายหรือไม่ ค่าเริ่มต้นคือ True ซึ่งหมายความว่าเปิดใช้งานแล้ว",
  T_49_META_TYP_14_I76_D: "ฉันสามารถออกกลางคันได้ไหม?",
  T_49_META_TYP_14_I77_D: "ข้อมูลเครื่องแต่งกายที่ผู้เล่นจะต้องเก็บไว้เมื่อแปลงร่างเป็นตัวละครอื่น",
  T_49_META_TYP_14_I8_D: "รหัสจุดตรวจที่เป้าหมายกำลังมุ่งหน้าไป",
  T_49_META_TYP_140_I0_D: "คลื่นที่ 1",
  T_49_META_TYP_140_I1_D: "คลื่นที่ 2",
  T_49_META_TYP_140_I2_D: "คลื่นที่ 3",
  T_49_META_TYP_140_I3_D: "ต่อเนื่อง",
  T_49_META_TYP_141_I0_D: "ลูทฟุตบอลสุ่ม",
  T_49_META_TYP_141_I1_D: "ลูทโล่ฟุตบอล",
  T_49_META_TYP_141_I2_D: "ระเบิดน้ำแข็ง",
  T_49_META_TYP_142_I0_D: "ปล้นจุดฟุตบอล",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "เปียโนC3",
  T_49_META_TYP_146_I1_D: "เปียโน C3#",
  T_49_META_TYP_146_I10_D: "เปียโนA3#",
  T_49_META_TYP_146_I11_D: "เปียโนB3",
  T_49_META_TYP_146_I12_D: "เปียโนC4",
  T_49_META_TYP_146_I13_D: "เปียโน C4#",
  T_49_META_TYP_146_I14_D: "เปียโนD4",
  T_49_META_TYP_146_I15_D: "เปียโนD4#",
  T_49_META_TYP_146_I16_D: "เปียโนE4",
  T_49_META_TYP_146_I17_D: "เปียโนF4",
  T_49_META_TYP_146_I18_D: "เปียโนF4#",
  T_49_META_TYP_146_I19_D: "เปียโนG4",
  T_49_META_TYP_146_I2_D: "เปียโนD3",
  T_49_META_TYP_146_I20_D: "เปียโน G4#",
  T_49_META_TYP_146_I21_D: "เปียโนA4",
  T_49_META_TYP_146_I22_D: "เปียโนA4#",
  T_49_META_TYP_146_I23_D: "เปียโนB4",
  T_49_META_TYP_146_I3_D: "เปียโนD3#",
  T_49_META_TYP_146_I4_D: "เปียโนE3",
  T_49_META_TYP_146_I5_D: "เปียโนF3",
  T_49_META_TYP_146_I6_D: "เปียโนF3#",
  T_49_META_TYP_146_I7_D: "เปียโนG3",
  T_49_META_TYP_146_I8_D: "เปียโนG3#",
  T_49_META_TYP_146_I9_D: "เปียโนA3",
  T_49_META_TYP_147_I0_D: "FF คลาสสิค (ยิงปืน)",
  T_49_META_TYP_147_I1_D: "บุคคลที่สาม",
  T_49_META_TYP_147_I2_D: "เกมยิงมุมมองบุคคลที่หนึ่ง",
  T_49_META_TYP_147_I3_D: "มุมมองด้านบน",
  T_49_META_TYP_147_I4_D: "เลื่อนแนวนอน",
  T_49_META_TYP_147_I5_D: "กำหนดค่าเอง",
  T_49_META_TYP_147_I6_D: "ไล่ล่า",
  T_49_META_TYP_147_I7_D: "ผู้เล่นควบคุมกล้องได้และเคลื่อนไหวได้อย่างอิสระ",
  T_49_META_TYP_147_I8_D: "กล้องถ่ายภาพบุคคลที่หนึ่งแบบใหม่",
  T_49_META_TYP_148_I0_D: "มีกล้องประเภทต่างๆ ให้เลือกตั้งค่าล่วงหน้า รวมถึงกล้องประเภทที่กำหนดเอง",
  T_49_META_TYP_148_I1_D: "ขอบเขตการมองเห็นคือมุมมองของกล้อง",
  T_49_META_TYP_148_I10_D: "ประเภทของแอนิเมชั่นการสลับกล้อง",
  T_49_META_TYP_148_I11_D: "จะมีผลเฉพาะเมื่อสวิตช์เป็นแบบเรียบเท่านั้น เวลาในการเปลี่ยนสวิตช์เป็นกล้องนี้ใช้เวลาเป็นมิลลิวินาที",
  T_49_META_TYP_148_I12_D: "เมื่อมีสิ่งกีดขวางระหว่างกล้องกับวัตถุที่ถูกติดตาม โหมดการเคลื่อนที่ของกล้อง",
  T_49_META_TYP_148_I13_D: "กล้องจะเรนเดอร์ภาพอย่างไร",
  T_49_META_TYP_148_I14_D: "ติดตามระบบพิกัดอ้างอิงออฟเซ็ตวัตถุ",
  T_49_META_TYP_148_I15_D: "สังเกตระบบพิกัดอ้างอิงออฟเซ็ตวัตถุ",
  T_49_META_TYP_148_I16_D: "หน้ากากเลเยอร์การเรนเดอร์ของกล้องสามารถกรองวัตถุที่เรนเดอร์ของกล้องตามระดับการมองเห็นได้",
  T_49_META_TYP_148_I17_D: "ข้อจำกัดของมุมมอง",
  T_49_META_TYP_148_I2_D: "โดยทั่วไปหมายถึงค่าชดเชยของตำแหน่งกล้องเมื่อเทียบกับตำแหน่งต้นกำเนิดของผู้เล่น ความหมายเฉพาะจะแตกต่างกันไปตามประเภทของกล้อง",
  T_49_META_TYP_148_I3_D: "โดยทั่วไปหมายถึงค่าออฟเซ็ตของจุดโฟกัสของกล้องเมื่อเทียบกับตำแหน่งต้นกำเนิดของผู้เล่น ความหมายเฉพาะจะแตกต่างกันไปตามประเภทของกล้อง",
  T_49_META_TYP_148_I4_D: "มุมการหมุนแนวตั้งของกล้อง",
  T_49_META_TYP_148_I5_D: "มุมการหมุนแนวนอนของกล้อง",
  T_49_META_TYP_148_I7_D: "เป้าหมายที่กล้องติดตาม",
  T_49_META_TYP_148_I8_D: "สิ่งที่กล้องกำลังมองดู",
  T_49_META_TYP_148_I9_D: "ผู้เล่นที่กำลังใช้กล้องอยู่",
  T_49_META_TYP_15_I0_D: "ว่าสมาชิกในทีมทั้งหมดเสียชีวิตแล้วหรือไม่",
  T_49_META_TYP_15_I1_D: "รายชื่อสมาชิกทีมทั้งหมด",
  T_49_META_TYP_15_I3_D: "รายชื่อทีมศัตรู",
  T_49_META_TYP_15_I4_D: "รายชื่อทีมกระชับมิตร",
  T_49_META_TYP_15_I5_D: "ทีมหมายเลข",
  T_49_META_TYP_150_I0_D: "ความทนทาน",
  T_49_META_TYP_150_I1_D: "รัศมีของซีกโลกที่ปลายทั้งสองข้างของแคปซูล",
  T_49_META_TYP_150_I2_D: "ค่าสัมประสิทธิ์ความเสียหาย",
  T_49_META_TYP_152_I1_D: "แรงโน้มถ่วงแบบกำหนดเอง",
  T_49_META_TYP_152_I2_D: "ไม่ว่าจะแสดงทริกเกอร์ True หมายถึงแสดง",
  T_49_META_TYP_154_I0_D: "ไม่สามารถใช้สองมือได้",
  T_49_META_TYP_154_I1_D: "สามารถใช้ได้สองมือเท่านั้นด้วยปืนชนิดเดียวกัน",
  T_49_META_TYP_154_I2_D: "สามารถใช้ได้ทั้งอาวุธอื่นหรือกับตัวเอง",
  T_49_META_TYP_155_I0_D: "ระดับ",
  T_49_META_TYP_155_I1_D: "ความทนทานสูงสุด",
  T_49_META_TYP_155_I2_D: "ความทนทานปัจจุบัน",
  T_49_META_TYP_155_I3_D: "ค่าสัมประสิทธิ์การลดความเสียหาย",
  T_49_META_TYP_155_I4_D: "ค่าสัมประสิทธิ์การลดความเสียหายจากการระเบิด",
  T_49_META_TYP_155_I5_D: "สามารถเสียค่าความทนทานได้ไหม",
  T_49_META_TYP_155_I6_D: "สามารถทำลายได้ไหม",
  T_49_META_TYP_156_I1_D: "ความทนทานสูงสุด",
  T_49_META_TYP_156_I2_D: "ความทนทานปัจจุบัน",
  T_49_META_TYP_156_I3_D: "ค่าสัมประสิทธิ์การลดความเสียหาย",
  T_49_META_TYP_156_I4_D: "ค่าสัมประสิทธิ์การลดความเสียหายจากการระเบิด",
  T_49_META_TYP_156_I5_D: "สามารถเสียค่าความทนทานได้ไหม",
  T_49_META_TYP_156_I6_D: "สามารถทำลายได้ไหม",
  T_49_META_TYP_157_I0_D: "ไม่มีแอนิเมชั่น",
  T_49_META_TYP_157_I1_D: "เรียบ",
  T_49_META_TYP_158_I2_D: "การแจงนับประเภทการยึด UI ค่าเริ่มต้นคือ 9 (ศูนย์กลาง)",
  T_49_META_TYP_158_I6_D: "คีย์ของฉลาก",
  T_49_META_TYP_158_I7_D: "พารามิเตอร์ของฉลาก",
  T_49_META_TYP_158_I8_D: "เปิดใช้งาน Tweener",
  T_49_META_TYP_16_I1_D: "รหัสรายการที่สอดคล้องกับนิติบุคคล",
  T_49_META_TYP_16_I2_D: "ใช้เฉพาะเมื่อโหลดวัตถุแบบคงที่เพื่อกำหนดว่า NavMesh ถูกสร้างขึ้นแบบคงที่หรือไม่",
  T_49_META_TYP_16_I3_D: "ไม่ว่าจะเป็นการบล็อคแบบไดนามิกของ NavMesh",
  T_49_META_TYP_16_I4_D: "การโหลดแบบอะซิงโครนัส",
  T_49_META_TYP_160_I0_D: "ก้อนอิฐ A",
  T_49_META_TYP_160_I1_D: "กระเบื้อง A",
  T_49_META_TYP_160_I10_D: "แซนด์ เอ",
  T_49_META_TYP_160_I11_D: "สโนว์ A",
  T_49_META_TYP_160_I12_D: "ไม้ A",
  T_49_META_TYP_160_I13_D: "โทน A",
  T_49_META_TYP_160_I14_D: "สนามหญ้า B",
  T_49_META_TYP_160_I15_D: "ก้อนอิฐ B",
  T_49_META_TYP_160_I16_D: "ก้อนอิฐ C",
  T_49_META_TYP_160_I17_D: "ชัดเจน",
  T_49_META_TYP_160_I2_D: "กระเบื้อง B",
  T_49_META_TYP_160_I3_D: "กระเบื้อง C",
  T_49_META_TYP_160_I4_D: "ไม้ไผ่ A",
  T_49_META_TYP_160_I5_D: "ซีเมนต์ A",
  T_49_META_TYP_160_I6_D: "ที่เก็บของ A",
  T_49_META_TYP_160_I7_D: "สนามหญ้า A",
  T_49_META_TYP_160_I8_D: "น้ำแข็ง เอ",
  T_49_META_TYP_160_I9_D: "แม็กม่า A",
  T_49_META_TYP_165_I0_D: "ว่าจะเปิดใช้งานการปะทะกันหรือไม่",
  T_49_META_TYP_165_I1_D: "ไม่ว่าจะทำหน้าที่เป็นตัวกระตุ้น",
  T_49_META_TYP_165_I2_D: "ระดับกายภาพ ตั้งค่าระดับในโมดูลกายภาพได้สูงสุดถึง 16",
  T_49_META_TYP_166_I0_D: "อิโมติคอน1",
  T_49_META_TYP_166_I1_D: "อิโมติคอน2",
  T_49_META_TYP_166_I2_D: "อิโมติคอน3",
  T_49_META_TYP_166_I3_D: "อิโมติคอน4",
  T_49_META_TYP_166_I4_D: "อิโมติคอน5",
  T_49_META_TYP_167_I0_D: "ประเภทของเอฟเฟ็กต์เท็กเจอร์",
  T_49_META_TYP_170_I0_D: "มองเห็นได้หรือไม่ หากมองไม่เห็น ไคลเอนต์จะหยุดการเรนเดอร์เป้าหมาย",
  T_49_META_TYP_170_I1_D: "ระดับการมองเห็น ช่วงค่า [0,15] ส่งผลต่อการมองเห็นในกล้อง",
  T_49_META_TYP_171_I0_D: "พลังงาน",
  T_49_META_TYP_172_I0_D: "จำนวนกระสุน",
  T_49_META_TYP_173_I0_D: "ความจุกระเป๋าเป้เพิ่มเติม",
  T_49_META_TYP_173_I1_D: "การกำหนดรูปลักษณ์ของผู้เล่นนอกเกมมีความสำคัญสูงสุด",
  T_49_META_TYP_173_I2_D: "ID สกินกระเป๋าเป้, การกำหนดค่าสกินกระเป๋าเป้",
  T_49_META_TYP_174_I2_D: "ความเสียหายสูงสุด",
  T_49_META_TYP_174_I4_D: "ความเร็วในการขว้าง",
  T_49_META_TYP_174_I5_D: "ความล่าช้าของการระเบิดเป็นวินาที",
  T_49_META_TYP_174_I6_D: "ค่าสัมประสิทธิ์ความเสียหายของตัวเอง",
  T_49_META_TYP_174_I7_D: "ค่าสัมประสิทธิ์ความเสียหายของเพื่อนร่วมทีม",
  T_49_META_TYP_174_I8_D: "ค่าสัมประสิทธิ์ความเสียหายของยานพาหนะ",
  T_49_META_TYP_174_I9_D: "ผิว",
  T_49_META_TYP_175_I0_D: "รัศมีพื้นที่แช่แข็ง",
  T_49_META_TYP_175_I1_D: "ระยะเวลาของพื้นที่แช่แข็งเป็นวินาที",
  T_49_META_TYP_176_I0_D: "ประเภทอาวุธหลัก",
  T_49_META_TYP_176_I1_D: "ประเภทย่อยของอาวุธ",
  T_49_META_TYP_177_I0_D: "เมื่อมีสิ่งกีดขวางระหว่างกล้องกับวัตถุที่ถูกติดตาม กล้องจะไม่ทำการเปลี่ยนแปลงใดๆ",
  T_49_META_TYP_177_I1_D: "เมื่อมีสิ่งกีดขวางระหว่างกล้องกับวัตถุที่ถูกติดตาม กล้องจะเคลื่อนเข้าใกล้วัตถุที่ถูกติดตามมากขึ้น",
  T_49_META_TYP_177_I2_D: "เมื่อมีสิ่งบดบังระหว่างกล้องกับวัตถุที่ติดตาม สิ่งบดบังจะกลายเป็นกึ่งโปร่งใส",
  T_49_META_TYP_178_I0_D: "เมื่อกล้องตรวจพบวัตถุ วัตถุที่อยู่ใกล้จะดูใหญ่ขึ้น และวัตถุที่อยู่ไกลจะดูเล็กลง",
  T_49_META_TYP_178_I1_D: "เมื่อกล้องตรวจพบวัตถุ วัตถุที่อยู่ใกล้และไกลจะมีขนาดเท่ากัน",
  T_49_META_TYP_184_I0_D: "ระบุ UUID ของทรัพยากรที่ต้องการแสดงผล",
  T_49_META_TYP_185_I0_D: "เรนเดอร์โมเดลตาข่ายที่จะใช้",
  T_49_META_TYP_185_I1_D: "รายการวัสดุที่ใช้ในการเรนเดอร์",
  T_49_META_TYP_187_I0_D: "รหัสไอเทม",
  T_49_META_TYP_190_I0_D: "สถานะเปิด",
  T_49_META_TYP_190_I1_D: "ผลการแข่งขัน",
  T_49_META_TYP_190_I10_D: "รายการคะแนน 1",
  T_49_META_TYP_190_I11_D: "รายการคะแนน 2",
  T_49_META_TYP_190_I12_D: "รายการคะแนน 3",
  T_49_META_TYP_190_I13_D: "รายชื่อ MVP ที่ชนะ",
  T_49_META_TYP_190_I14_D: "รายชื่อ MVP ทีมแพ้",
  T_49_META_TYP_190_I15_D: "แสดงรายละเอียดการแข่งขัน",
  T_49_META_TYP_190_I16_D: "แสดงการประเมินแผนที่",
  T_49_META_TYP_190_I17_D: "แสดงการให้ของขวัญ",
  T_49_META_TYP_190_I18_D: "แสดงรายงาน",
  T_49_META_TYP_190_I19_D: "แสดงการเล่น",
  T_49_META_TYP_190_I20_D: "แสดงการแชร์",
  T_49_META_TYP_190_I21_D: "แสดงล็อบบี้",
  T_49_META_TYP_190_I22_D: "แสดงความชื่นชอบ",
  T_49_META_TYP_190_I23_D: "แสดงการเพิ่มเพื่อน",
  T_49_META_TYP_190_I24_D: "แสดงเศรษฐกิจ",
  T_49_META_TYP_190_I4_D: "ทีมด้านซ้าย",
  T_49_META_TYP_190_I5_D: "ทีมด้านขวา",
  T_49_META_TYP_190_I6_D: "อันดับผู้เล่น",
  T_49_META_TYP_190_I9_D: "รายการชื่อเรื่อง",
  T_49_META_TYP_191_I0_D: "ช่วงกลาง",
  T_49_META_TYP_191_I4_D: "เวลาแฟลชกลางเป็นมิลลิวินาที",
  T_49_META_TYP_191_I5_D: "เวลาแฟลชขอบเป็นมิลลิวินาที",
  T_49_META_TYP_191_I6_D: "สวิตช์เอฟเฟ็กต์การโจมตีด้วยระเบิดแฟลช",
  T_49_META_TYP_192_I3_D: "ระยะเวลาของเอฟเฟกต์พิเศษเป็นวินาที",
  T_49_META_TYP_193_I1_D: "หัวชื่อการแข่งขัน ซ้าย",
  T_49_META_TYP_193_I10_D: "รายการคะแนน 1",
  T_49_META_TYP_193_I11_D: "รายการคะแนน 2",
  T_49_META_TYP_193_I12_D: "รายการคะแนน 3",
  T_49_META_TYP_193_I13_D: "รายการคะแนน 4",
  T_49_META_TYP_193_I14_D: "รายการคะแนน 5",
  T_49_META_TYP_193_I15_D: "รายชื่อ MVP ที่ชนะ",
  T_49_META_TYP_193_I16_D: "รายชื่อ MVP ทีมแพ้",
  T_49_META_TYP_193_I17_D: "แสดงรายละเอียดการแข่งขัน",
  T_49_META_TYP_193_I18_D: "แสดงการประเมินแผนที่",
  T_49_META_TYP_193_I19_D: "แสดงการให้ของขวัญ",
  T_49_META_TYP_193_I2_D: "หัวชื่อการแข่งขัน ขวา",
  T_49_META_TYP_193_I20_D: "แสดงรายงาน",
  T_49_META_TYP_193_I21_D: "แสดงการเล่น",
  T_49_META_TYP_193_I22_D: "แสดงการแชร์",
  T_49_META_TYP_193_I23_D: "แสดงล็อบบี้",
  T_49_META_TYP_193_I24_D: "แสดงความชื่นชอบ",
  T_49_META_TYP_193_I25_D: "แสดงการเพิ่มเพื่อน",
  T_49_META_TYP_193_I26_D: "แสดงเศรษฐกิจ",
  T_49_META_TYP_193_I3_D: "ผลการแข่งขัน",
  T_49_META_TYP_193_I4_D: "อันดับทีม",
  T_49_META_TYP_193_I5_D: "อันดับผู้เล่น",
  T_49_META_TYP_193_I6_D: "อันดับทีม",
  T_49_META_TYP_193_I7_D: "ชื่อคะแนนหลัก",
  T_49_META_TYP_193_I8_D: "คะแนนหลัก",
  T_49_META_TYP_193_I9_D: "รายการชื่อเรื่อง",
  T_49_META_TYP_194_I0_D: "เวลาเป็นวินาทีที่ทุ่นระเบิดจะเริ่มทำงาน",
  T_49_META_TYP_194_I1_D: "รัศมีการทริกเกอร์",
  T_49_META_TYP_194_I2_D: "เวลาที่จำเป็นในการกระตุ้นทุ่นระเบิดภายในระยะทุ่นระเบิดเป็นวินาที",
  T_49_META_TYP_194_I3_D: "มันสามารถทริกเกอร์ตัวเองได้ไหม",
  T_49_META_TYP_194_I4_D: "ทีมสามารถทริกเกอร์ได้ไหม",
  T_49_META_TYP_194_I5_D: "สามารถถูกทริกเกอร์โดยยานพาหนะได้ไหม",
  T_49_META_TYP_194_I6_D: "เวลาการดำรงอยู่ของทุ่นระเบิดซึ่งจะระเบิดโดยอัตโนมัติหลังจากเสร็จสิ้น เวลาเริ่มต้นจากเวลาที่วางทุ่นระเบิดเป็นวินาที",
  T_49_META_TYP_194_I7_D: "สามารถโจมตีได้ไหม",
  T_49_META_TYP_194_I8_D: "สุขภาพ",
  T_49_META_TYP_195_I0_D: "ครั้งหนึ่ง",
  T_49_META_TYP_195_I2_D: "การเคลื่อนไหวแบบลูกสูบ",
  T_49_META_TYP_197_I0_D: "มันกำลังเล่นอยู่เหรอ?",
  T_49_META_TYP_197_I1_D: "มาร์คบิต",
  T_49_META_TYP_197_I2_D: "เลือกให้เล่นอัตโนมัติเมื่อสร้าง",
  T_49_META_TYP_198_I0_D: "รหัสทรัพย์สินที่สอดคล้องกับสิ่งที่แนบมา",
  T_49_META_TYP_199_I0_D: "ค่าพลังงานสูงสุด",
  T_49_META_TYP_199_I1_D: "การใช้พลังงาน",
  T_49_META_TYP_199_I10_D: "อัตราส่วนความเสียหายจากการล้ม",
  T_49_META_TYP_199_I11_D: "พลังงานปัจจุบัน",
  T_49_META_TYP_199_I2_D: "การใช้พลังงานเพิ่มขึ้นต่อวินาที",
  T_49_META_TYP_199_I3_D: "พลังงานที่ใช้ในการวิ่ง",
  T_49_META_TYP_199_I4_D: "การใช้พลังงานในการวิ่งไวต่อวินาที",
  T_49_META_TYP_199_I5_D: "ความเร็วแนวนอนพื้นฐาน",
  T_49_META_TYP_199_I6_D: "ความเร็วแนวนอนวิ่งเร็ว",
  T_49_META_TYP_199_I7_D: "ความเร็วฐานแนวตั้ง",
  T_49_META_TYP_199_I8_D: "ความเร็วสปรินต์แนวตั้ง",
  T_49_META_TYP_199_I9_D: "ระยะการวิ่งไว",
  T_49_META_TYP_200_I0_D: "รหัสภูมิภาค",
  T_49_META_TYP_200_I1_D: "รหัสเกม",
  T_49_META_TYP_201_I0_D: "เปอร์เซ็นต์การช้าลง: เปอร์เซ็นต์ที่ความเร็วของวัตถุในน้ำเปิดถูกทำให้ช้าลง",
  T_49_META_TYP_203_I0_D: "เอนทิตีเป้าหมาย",
  T_49_META_TYP_203_I1_D: "รหัสของตกแต่ง",
  T_49_META_TYP_203_I10_D: "เวลาที่เซิร์ฟเวอร์เกมเริ่มทำการติ๊ก",
  T_49_META_TYP_203_I11_D: "ค่าเริ่มต้น",
  T_49_META_TYP_203_I12_D: "ค่าสุดท้าย",
  T_49_META_TYP_203_I13_D: "เปอร์เซ็นต์ที่ผ่าน",
  T_49_META_TYP_203_I4_D: "สไตล์ของ Tweener",
  T_49_META_TYP_203_I6_D: "ระยะเวลา",
  T_49_META_TYP_203_I7_D: "ไหมย้อนกลับ",
  T_49_META_TYP_203_I8_D: "จุดควบคุม",
  T_49_META_TYP_203_I9_D: "สถานะเซิร์ฟเวอร์เกมการบังคับซิงค์",
  T_49_META_TYP_204_I0_D: "ความสูงสูงสุด",
  T_49_META_TYP_204_I1_D: "เปอร์เซ็นต์ความเสียหายจากการตก",
  T_49_META_TYP_204_I2_D: "ฟื้นฟูพลังงาน",
  T_49_META_TYP_204_I3_D: "การบริโภคพลังงาน",
  T_49_META_TYP_204_I4_D: "พลังงานสูงสุด",
  T_49_META_TYP_205_I0_D: "ระดับความสูงขั้นต่ำในการบิน",
  T_49_META_TYP_205_I1_D: "ความสูงขั้นต่ำสุด",
  T_49_META_TYP_205_I2_D: "ความเร็วการบินแนวนอน",
  T_49_META_TYP_205_I3_D: "ความเร็วการบินแนวตั้ง",
  T_49_META_TYP_205_I4_D: "ความเร็วการตก",
  T_49_META_TYP_205_I5_D: "ความเร็วการหัน",
  T_49_META_TYP_205_I6_D: "ระดับความสูงการบินสูงสุด",
  T_49_META_TYP_205_I7_D: "ความเร็วลดลงหลังจากสูงมาก",
  T_49_META_TYP_205_I8_D: "การเร่งความเร็วแบบแปรผัน",
  T_49_META_TYP_206_I0_D: "ความเร็ว",
  T_49_META_TYP_206_I1_D: "ความเร่ง",
  T_49_META_TYP_206_I10_D: "ที่ความเร็วสูง มุมเลี้ยวสูงสุด",
  T_49_META_TYP_206_I11_D: "อัตราฐานการสอดแทรกมุมพวงมาลัยความเร็วสูง",
  T_49_META_TYP_206_I2_D: "ความเร็วการบูสต์",
  T_49_META_TYP_206_I3_D: "ระยะเวลาการวิ่งเป็นวินาที",
  T_49_META_TYP_206_I4_D: "เวลาคูลดาวน์ของสปรินต์เป็นวินาที",
  T_49_META_TYP_206_I6_D: "กระโดดซีดีภายในไม่กี่วินาที",
  T_49_META_TYP_206_I7_D: "สปรินท์ซีดีหลังจากขึ้นสเก็ตบอร์ด หน่วย: วินาที",
  T_49_META_TYP_206_I8_D: "สวิตช์คลูลดาวน์การบูสหลังขึ้น",
  T_49_META_TYP_206_I9_D: "ซีดีการสไลด์บนสเก็ตบอร์ดในไม่กี่วินาที",
  T_49_META_TYP_207_I1_D: "อินเด็กซ์จุดเริ่ม",
  T_49_META_TYP_207_I2_D: "ตำแหน่งสิ้นสุด",
  T_49_META_TYP_207_I3_D: "รหัสซิปไลน์",
  T_49_META_TYP_207_I4_D: "รหัสกลุ่ม",
  T_49_META_TYP_207_I5_D: "มันจบแล้วเหรอ?",
  T_49_META_TYP_21_I0_D: "ระดับพื้นฐานของ UI",
  T_49_META_TYP_210_I1_D: "ความเร็วเริ่มต้น",
  T_49_META_TYP_210_I2_D: "ความเร่ง",
  T_49_META_TYP_210_I3_D: "การเปลี่ยนแปลงตำแหน่งสูงสุด",
  T_49_META_TYP_210_I4_D: "พิกัดโลกเริ่มต้น",
  T_49_META_TYP_210_I5_D: "เซิร์ฟเวอร์เกมบังคับให้ซิงโครไนซ์ข้อมูลตำแหน่ง",
  T_49_META_TYP_211_I0_D: "ตำแหน่งโดยอ้างอิงจากวัตถุแม่",
  T_49_META_TYP_211_I1_D: "ตำแหน่งบนโลก",
  T_49_META_TYP_212_I0_D: "ตนเอง",
  T_49_META_TYP_212_I2_D: "พิกัดออฟเซ็ต",
  T_49_META_TYP_213_I0_D: "ตนเอง",
  T_49_META_TYP_213_I2_D: "พิกัดออฟเซ็ต",
  T_49_META_TYP_215_I0_D: "ชัยชนะ",
  T_49_META_TYP_215_I1_D: "ความพ่ายแพ้",
  T_49_META_TYP_215_I2_D: "บูย่า",
  T_49_META_TYP_215_I3_D: "เสมอ",
  T_49_META_TYP_218_I0_D: "ความเข้ม",
  T_49_META_TYP_218_I1_D: "ช่วงแสง",
  T_49_META_TYP_218_I2_D: "สีอ่อน",
  T_49_META_TYP_22_I0_D: "หากสถานะเปิดเป็นจริงจะแสดง หากไม่เป็นจริงก็จะถูกปิด",
  T_49_META_TYP_22_I1_D: "รหัสพรีแฟบ",
  T_49_META_TYP_22_I2_D: "รหัสควบคุมสูงสุดปัจจุบัน",
  T_49_META_TYP_22_I3_D: "ระดับพื้นฐานของ UI",
  T_49_META_TYP_22_I4_D: "เปิดมุมมองผู้เล่น",
  T_49_META_TYP_22_I5_D: "ตำแหน่งบนโลก",
  T_49_META_TYP_22_I6_D: "มันอยู่ในฉากมั้ย?",
  T_49_META_TYP_22_I7_D: "การหมุนในพิกัดโลก",
  T_49_META_TYP_22_I8_D: "การปรับขนาดในพิกัดโลก",
  T_49_META_TYP_221_I0_D: "ค่าหน่วงการเปลี่ยนเกียร์ ยิ่งมาก ความเร็วในการเปลี่ยนเกียร์ก็จะยิ่งช้าลง",
  T_49_META_TYP_222_I0_D: "ค่าหน่วงการเปลี่ยนเกียร์ ยิ่งมาก ความเร็วในการเปลี่ยนเกียร์ก็จะยิ่งช้าลง",
  T_49_META_TYP_225_I0_D: "ความเสียหายของป้อมปราการ",
  T_49_META_TYP_225_I1_D: "ช่วงเวลาการโจมตีป้อมปืน (วินาที)",
  T_49_META_TYP_225_I10_D: "ไฟภายในมุม",
  T_49_META_TYP_225_I11_D: "อัตราการลดความเสียหาย",
  T_49_META_TYP_225_I12_D: "การเจาะเกราะ",
  T_49_META_TYP_225_I2_D: "ความแม่นยำ",
  T_49_META_TYP_225_I3_D: "ระยะ",
  T_49_META_TYP_225_I4_D: "ความเร็วเชิงมุม",
  T_49_META_TYP_225_I5_D: "มุมขึ้น",
  T_49_META_TYP_225_I6_D: "มุมลง",
  T_49_META_TYP_225_I7_D: "พลังชีวิตสูงสุด",
  T_49_META_TYP_225_I8_D: "ระยะเวลาป้อมปืน (วินาที)",
  T_49_META_TYP_225_I9_D: "จำนวนป้อมปืนสูงสุด",
  T_49_META_TYP_226_I0_D: "สภาพปราการปัจจุบัน",
  T_49_META_TYP_226_I1_D: "เปิดการโจมตี",
  T_49_META_TYP_227_I0_D: "วิดเจ็ตแบบทั่วไป",
  T_49_META_TYP_227_I1_D: "วิดเจ็ตรูปภาพ",
  T_49_META_TYP_227_I10_D: "เท็กเจอร์ของวิดเจ็ต",
  T_49_META_TYP_227_I11_D: "วิดเจ็ตโปรไฟล์",
  T_49_META_TYP_227_I12_D: "เปิด/ปิด วิดเจ็ต",
  T_49_META_TYP_227_I13_D: "ทัชแพดวิดเจ็ต",
  T_49_META_TYP_227_I14_D: "วิดเจ็ตจอยสติ๊ก",
  T_49_META_TYP_227_I15_D: "วิดเจ็ตปุ่มสังคม",
  T_49_META_TYP_227_I2_D: "วิดเจ็ตป้าย",
  T_49_META_TYP_227_I3_D: "ปุ่มวิดเจ็ต",
  T_49_META_TYP_227_I4_D: "วิดเจ็ตที่สามารถป้อนข้อมูล",
  T_49_META_TYP_227_I5_D: "แผง",
  T_49_META_TYP_227_I6_D: "แผงเลื่อน",
  T_49_META_TYP_227_I7_D: "กริด",
  T_49_META_TYP_227_I8_D: "เรย์เอาต์วิดเจ็ต",
  T_49_META_TYP_227_I9_D: "วิจเจตต์ภาชนะ",
  T_49_META_TYP_231_I0_D: "ค่าการฟื้นตัวของความทนทาน",
  T_49_META_TYP_231_I1_D: "ระยะเวลาที่จะเริ่มมีผลเป็นวินาที",
  T_49_META_TYP_233_I2_D: "เวลาสิ้นสุดของการจับเวลาเป็นวินาที",
  T_49_META_TYP_233_I4_D: "ชื่อทรัพยากรไอคอน",
  T_49_META_TYP_234_I0_D: "เวลาทริกเกอร์เป็นวินาที",
  T_49_META_TYP_234_I1_D: "มันสามารถทริกเกอร์ตัวเองได้ไหม",
  T_49_META_TYP_234_I10_D: "สุขภาพในปัจจุบัน",
  T_49_META_TYP_234_I2_D: "ทีมสามารถทริกเกอร์ได้ไหม",
  T_49_META_TYP_234_I3_D: "สามารถถูกทริกเกอร์โดยยานพาหนะได้ไหม",
  T_49_META_TYP_234_I4_D: "ระยะเวลาเป็นวินาที",
  T_49_META_TYP_234_I5_D: "สามารถโจมตีได้ไหม",
  T_49_META_TYP_234_I6_D: "สุขภาพ",
  T_49_META_TYP_235_I0_D: "สุขภาพสูงสุด",
  T_49_META_TYP_235_I2_D: "จำนวนสูงสุด",
  T_49_META_TYP_237_I0_D: "ความเร็วขว้าง",
  T_49_META_TYP_237_I1_D: "ความเร็วแรงฉุดของผู้เล่น",
  T_49_META_TYP_238_I0_D: "สีสเปรย์",
  T_49_META_TYP_239_I0_D: "ความเร็วเริ่มต้น",
  T_49_META_TYP_239_I1_D: "ความเร่ง (เช่น แรงโน้มถ่วง)",
  T_49_META_TYP_24_I0_D: "การต่อสู้ระยะประชิด",
  T_49_META_TYP_24_I1_D: "ปืน",
  T_49_META_TYP_24_I10_D: "ความเสียหายจากแอร์ดรอป ความเสียหายจากการฆ่าตัวตายของมอนสเตอร์",
  T_49_META_TYP_24_I11_D: "ความเสียหายเผาไหม้จากการระเบิดของยานพาหนะ",
  T_49_META_TYP_24_I12_D: "ถังน้ำมันระเบิด",
  T_49_META_TYP_24_I13_D: "อาวุธประเภทขีปนาวุธ",
  T_49_META_TYP_24_I14_D: "สัตว์ประหลาด",
  T_49_META_TYP_24_I15_D: "พื้นที่ความเสียหาย",
  T_49_META_TYP_24_I17_D: "ทักษะของตัวละคร",
  T_49_META_TYP_24_I2_D: "โจมตีโยน",
  T_49_META_TYP_24_I3_D: "พื้นที่ปลอดภัย",
  T_49_META_TYP_24_I4_D: "ยานพาหนะ",
  T_49_META_TYP_24_I5_D: "การตก",
  T_49_META_TYP_24_I6_D: "พื้นที่สังหาร",
  T_49_META_TYP_24_I7_D: "ออก",
  T_49_META_TYP_24_I8_D: "ตัดการเชื่อมต่อ",
  T_49_META_TYP_24_I9_D: "การระเบิดของยานพาหนะ",
  T_49_META_TYP_241_I0_D: "ความเร็วในการลากจูง",
  T_49_META_TYP_241_I1_D: "ความเร็วสวิง",
  T_49_META_TYP_241_I2_D: "เปิดปุ่มควบคุมแรงดึง",
  T_49_META_TYP_241_I3_D: "เปิดปุ่มสวิง",
  T_49_META_TYP_241_I4_D: "จุดยึดการเคลื่อนไหว",
  T_49_META_TYP_241_I5_D: "ความเร่งออกจากวงสวิง",
  T_49_META_TYP_242_I2_D: "ใช้งานเอฟเฟ็กต์ด้านซ้าย",
  T_49_META_TYP_242_I3_D: "ใช้งานเอฟเฟ็กต์ด้านขวา",
  T_49_META_TYP_242_I4_D: "เปิดใช้เส้นกึ่งกลาง",
  T_49_META_TYP_242_I5_D: "ค่า[0, 1]",
  T_49_META_TYP_242_I7_D: "ตำแหน่ง UI มีเพียงส่วนประกอบ XY เท่านั้นที่ถูกต้อง",
  T_49_META_TYP_242_I8_D: "ตำแหน่งเส้นกลาง[0,1]",
  T_49_META_TYP_243_I0_D: "หน้าอก",
  T_49_META_TYP_243_I1_D: "ขา",
  T_49_META_TYP_243_I2_D: "รองเท้า",
  T_49_META_TYP_243_I3_D: "การเพ้นท์หน้า",
  T_49_META_TYP_243_I4_D: "เครื่องสวมใส่ศรีษะ",
  T_49_META_TYP_243_I5_D: "บอดี้สูท",
  T_49_META_TYP_243_I6_D: "เพ้นท์หน้า",
  T_49_META_TYP_244_I0_D: "ข้อความที่จะแสดง",
  T_49_META_TYP_244_I10_D: "รายชื่อผู้เล่นที่สามารถมองเห็นเอนทิตี้นี้ได้",
  T_49_META_TYP_244_I11_D: "ลำดับชั้นการแสดงผล",
  T_49_META_TYP_244_I2_D: "ติดตามเป้าหมาย",
  T_49_META_TYP_244_I3_D: "หากละเลยความลึกก็สามารถแสดงผ่านผนังได้ มิฉะนั้นจะไม่สามารถแสดงได้",
  T_49_META_TYP_244_I4_D: "หันหน้าเข้าหากล้องเสมอไหม",
  T_49_META_TYP_244_I5_D: "เมื่อตั้งค่าเป็นจริง ตำแหน่งจะปรากฏบนหน้าจอเมื่ออยู่นอกหน้าจอ",
  T_49_META_TYP_244_I6_D: "สไตล์ตัวอักษร",
  T_49_META_TYP_244_I7_D: "ชนิดของตัวอักษร",
  T_49_META_TYP_244_I8_D: "ขนาดตัวอักษร",
  T_49_META_TYP_245_I0_D: "เส้นทางทรัพยากรเอฟเฟ็กต์",
  T_49_META_TYP_245_I11_D: "ลำดับชั้นการแสดงผล",
  T_49_META_TYP_245_I3_D: "หากละเลยความลึกก็สามารถแสดงผ่านผนังได้ มิฉะนั้นจะไม่สามารถแสดงได้",
  T_49_META_TYP_245_I4_D: "เมื่อตั้งค่าเป็นจริง ตำแหน่งจะปรากฏบนหน้าจอเมื่ออยู่นอกหน้าจอ",
  T_49_META_TYP_245_I5_D: "หันหน้าเข้าหากล้องเสมอไหม",
  T_49_META_TYP_245_I6_D: "ประเภทการเรนเดอร์",
  T_49_META_TYP_245_I7_D: "ความกว้าง",
  T_49_META_TYP_246_I0_D: "ส้ม",
  T_49_META_TYP_246_I1_D: "สีม่วง",
  T_49_META_TYP_246_I2_D: "สีแดง",
  T_49_META_TYP_246_I3_D: "สีเขียว",
  T_49_META_TYP_246_I4_D: "น้ำเงิน",
  T_49_META_TYP_247_I1_D: "วิ่ง",
  T_49_META_TYP_247_I14_D: "ท่าทาง",
  T_49_META_TYP_247_I15_D: "การพูดคุยด่วน",
  T_49_META_TYP_247_I16_D: "รถกระบะ",
  T_49_META_TYP_247_I17_D: "การแสดงการพูดคุยด่วน",
  T_49_META_TYP_247_I18_D: "พลังชีวิต",
  T_49_META_TYP_247_I19_D: "EP",
  T_49_META_TYP_247_I2_D: "โจมตี",
  T_49_META_TYP_247_I20_D: "เกราะ",
  T_49_META_TYP_247_I21_D: "โหลดซ้ำ",
  T_49_META_TYP_247_I22_D: "ปุ่มเปลี่ยนปืนอย่างรวดเร็ว",
  T_49_META_TYP_247_I23_D: "ปุ่มแตรรถสามารถเปิด/ปิดได้",
  T_49_META_TYP_247_I24_D: "ปุ่มเปิด/ปิดเสียง (ไมโครโฟน)",
  T_49_META_TYP_247_I25_D: "สลับปุ่มเครื่องหมายเปิด/ปิด",
  T_49_META_TYP_247_I27_D: "ปุ่มสัญญาณเครือข่ายสามารถเปิด/ปิดได้",
  T_49_META_TYP_247_I28_D: "เปิดใช้งานทักษะ",
  T_49_META_TYP_247_I29_D: "เป้าเล็ง",
  T_49_META_TYP_247_I3_D: "กระโดด",
  T_49_META_TYP_247_I30_D: "ทักษะติดตัว",
  T_49_META_TYP_247_I4_D: "เคล็ดลับการฆ่า",
  T_49_META_TYP_247_I5_D: "สล็อตอาวุธ",
  T_49_META_TYP_247_I6_D: "แผนที่ขนาดย่อ",
  T_49_META_TYP_247_I7_D: "กระเป๋าเป้สะพายหลัง UI",
  T_49_META_TYP_247_I8_D: "อุปกรณ์ประกอบฉากทางการแพทย์",
  T_49_META_TYP_247_I9_D: "หากเป็นจริงจะแสดง หากเป็นจริงจะถูกปิด",
  T_49_META_TYP_249_I3_D: "อาวุธระเบิด",
  T_49_META_TYP_249_I5_D: "อาวุธหนัก",
  T_49_META_TYP_249_I8_D: "ระเบิดแช่แข็ง",
  T_49_META_TYP_249_I9_D: "ระเบิดจำลอง",
  T_49_META_TYP_25_I0_D: "ดัชนีของขั้นตอนปัจจุบันที่สอดคล้องกับดัชนีในโปรแกรมแก้ไขกระบวนการ",
  T_49_META_TYP_25_I1_D: "เวลาเริ่มต้นของขั้นตอนปัจจุบันเป็นมิลลิวินาที",
  T_49_META_TYP_25_I2_D: "เวลาสิ้นสุดของขั้นตอนปัจจุบันเป็นมิลลิวินาที",
  T_49_META_TYP_25_I3_D: "ระยะเวลาของเฟสปัจจุบัน หน่วยเป็นมิลลิวินาที",
  T_49_META_TYP_250_I1_D: "สีเอฟเฟกต์พิเศษ RGBA สี่ช่อง ช่วงค่าช่องเดียว 0~255 เก็บไว้ใน Int32",
  T_49_META_TYP_250_I3_D: "ประเภทของเอฟเฟ็กต์เท็กเจอร์",
  T_49_META_TYP_250_I4_D: "ความโปร่งของการกระจาย (Diffuse Alpha)",
  T_49_META_TYP_2500_I1_D: "ใช้จุดเกิดตั้งต้นไหม",
  T_49_META_TYP_2500_I3_D: "มีผู้เล่นที่เกิดในพื้นที่เกิดนี้แล้วหรือไม่?",
  T_49_META_TYP_2500_I4_D: "พิกัดของจุดเกิดที่สามารถกำหนดได้ในปัจจุบัน",
  T_49_META_TYP_2502_I0_D: "ไม่ว่าจะเป็นทริกเกอร์แห่งความตาย หากไม่ใช่ทริกเกอร์แห่งความตาย มันก็เป็นทริกเกอร์แห่งความอยู่ยงคงกระพัน (นี่เป็นปัญหาเดิมจาก OB32 กรุณาแยกฟังก์ชันการทำงานในอนาคต!)",
  T_49_META_TYP_2502_I1_D: "ว่าจะแสดงขอบทริกเกอร์หรือไม่ จริงหมายถึงการแสดง",
  T_49_META_TYP_2503_I0_D: "รหัสเช็กพอยต์",
  T_49_META_TYP_2503_I2_D: "ตำแหน่งจุดตรวจ",
  T_49_META_TYP_2507_I0_D: "หอคอยป้องกันนั้นเป็นของค่ายไหน หากเป็นค่ายเดียวกับผู้เล่น ก็จะไม่โจมตีผู้เล่น",
  T_49_META_TYP_2507_I1_D: "พลังชีวิต",
  T_49_META_TYP_2507_I10_D: "รหัสวัตถุ",
  T_49_META_TYP_2507_I2_D: "ปริมาณพลังชีวิตสูงสุด",
  T_49_META_TYP_2507_I3_D: "ความเสียหายจากการโจมตี ความเสียหายที่การโจมตีครั้งเดียวสามารถสร้างให้กับผู้เล่นได้",
  T_49_META_TYP_2507_I4_D: "ช่วงเวลาระหว่างการโจมตีสองครั้งเป็นวินาที",
  T_49_META_TYP_2507_I5_D: "พื้นที่ที่มีจุดศูนย์กลางเป็นศูนย์กลางและมีรัศมีขนาดใดๆ ก็สามารถถูกโจมตีได้",
  T_49_META_TYP_2507_I6_D: "อัตราการลดความเสียหาย ทศนิยมน้อยกว่า 1 ความเสียหายสุดท้ายคือค่าความเสียหายคูณด้วย (1-อัตราการลดความเสียหาย)",
  T_49_META_TYP_2507_I7_D: "เป้าหมายการโจมตี",
  T_49_META_TYP_2507_I8_D: "มุม",
  T_49_META_TYP_2507_I9_D: "สถานะป้อมขนาดเล็ก",
  T_49_META_TYP_2508_I0_D: "จำนวนของซอมบี้ที่จะเกิดขึ้นในแต่ละระลอก",
  T_49_META_TYP_2508_I1_D: "ซอมบี้จะออกมากี่ระลอก?",
  T_49_META_TYP_2508_I2_D: "จะสร้างต่อเนื่องก็ได้ แต่จะมีขีดจำกัดบนหน้าจอเดียวกัน",
  T_49_META_TYP_2508_I3_D: "คลื่นใดที่เกิดขึ้นในปัจจุบัน?",
  T_49_META_TYP_2508_I5_D: "ซอมบี้ประเภทไหนที่ปรากฏในคลื่นปัจจุบัน",
  T_49_META_TYP_2508_I6_D: "เมื่อ AI ตาย จะดรอปอุปกรณ์หรือไอเทมหรือเปล่า?",
  T_49_META_TYP_2508_I7_D: "เวลาเริ่มต้นการเกิด",
  T_49_META_TYP_2508_I8_D: "ช่วงเวลาระหว่างคลื่นถัดไปและคลื่นก่อนหน้า",
  T_49_META_TYP_2509_I0_D: "จำนวนหน่วยที่จะเกิดขึ้นในแต่ละรอบ",
  T_49_META_TYP_2509_I1_D: "เครื่องกำเนิดคลื่นทั้งหมดจะผลิตได้กี่หน่วย",
  T_49_META_TYP_2509_I2_D: "คลื่นใดที่เกิดขึ้นในปัจจุบัน?",
  T_49_META_TYP_2509_I4_D: "เอนทิตี้ใดที่จะนำมาใช้เป็นเทมเพลตสำหรับการสร้างคลื่นแต่ละคลื่น?",
  T_49_META_TYP_2509_I5_D: "เวลาเกิดของหน่วย",
  T_49_META_TYP_2509_I6_D: "จะสร้างต่อเนื่องก็ได้ แต่จะมีขีดจำกัดบนหน้าจอเดียวกัน",
  T_49_META_TYP_2509_I7_D: "ช่วงเวลาระหว่างคลื่นถัดไปและคลื่นก่อนหน้า",
  T_49_META_TYP_2509_I8_D: "PrefabID ของเทมเพลต",
  T_49_META_TYP_2510_I0_D: "จำนวนคะแนนการเกิด",
  T_49_META_TYP_252_I1_D: "ไอคอนด้านซ้าย",
  T_49_META_TYP_252_I2_D: "ข้อความด้านซ้าย",
  T_49_META_TYP_252_I3_D: "คะแนนทางด้านซ้าย",
  T_49_META_TYP_252_I5_D: "ไอคอนด้านขวา",
  T_49_META_TYP_252_I6_D: "ข้อความด้านขวา",
  T_49_META_TYP_252_I7_D: "คะแนนทางด้านขวา",
  T_49_META_TYP_252_I8_D: "ความคืบหน้า [0,1]",
  T_49_META_TYP_253_I0_D: "เลือกไอคอน",
  T_49_META_TYP_253_I1_D: "ข้อความ",
  T_49_META_TYP_253_I2_D: "แสดงเอฟเฟ็กต์พิเศษ",
  T_49_META_TYP_253_I3_D: "ตำแหน่ง UI",
  T_49_META_TYP_254_I1_D: "เช่น 1.25 หมายถึง 1.25 เท่าของความเร็วปกติ",
  T_49_META_TYP_254_I2_D: "สี",
  T_49_META_TYP_256_I0_D: "ยังคงนิ่งสนิท สมรรถนะที่ประหยัดที่สุด",
  T_49_META_TYP_256_I1_D: "ใช้แรงตามปกติ การบริโภคประสิทธิภาพสูงสุด",
  T_49_META_TYP_256_I2_D: "การเคลื่อนไหวสามารถควบคุมได้ด้วยสคริปต์ และมวลสามารถพิจารณาได้ว่าไม่มีที่สิ้นสุด",
  T_49_META_TYP_257_I0_D: "วัตถุแข็งประเภทต่าง ๆ มีหน้าที่แตกต่างกัน",
  T_49_META_TYP_257_I1_D: "ใช้แรงโน้มถ่วง",
  T_49_META_TYP_257_I2_D: "มวล (กก.) มวลที่มีประสิทธิภาพขั้นต่ำคือ 0.001 กก. หากเป็น 0 แสดงว่ามวลไม่มีที่สิ้นสุดและจะไม่เคลื่อนที่ภายใต้แรง",
  T_49_META_TYP_257_I3_D: "ตำแหน่งจุดศูนย์ถ่วง ระบบพิกัดท้องถิ่น",
  T_49_META_TYP_257_I4_D: "ความเร็วเชิงเส้นของการเคลื่อนที่ของวัตถุแข็ง",
  T_49_META_TYP_257_I5_D: "ความเร็วเชิงมุมของวัตถุแข็ง",
  T_49_META_TYP_257_I6_D: "ค่าสัมประสิทธิ์การลดทอนตามธรรมชาติของความเร็วเชิงเส้น ยิ่งค่าสัมประสิทธิ์มากขึ้น ความเร็วในการเคลื่อนที่ก็จะสลายตัวเร็วขึ้น",
  T_49_META_TYP_257_I7_D: "ค่าสัมประสิทธิ์การลดทอนตามธรรมชาติของความเร็วเชิงมุม ยิ่งค่าสัมประสิทธิ์มากขึ้น ความเร็วในการเคลื่อนที่จะสลายตัวเร็วขึ้น",
  T_49_META_TYP_257_I8_D: "ข้อจำกัดที่กำหนดให้กับวัตถุแข็งคือคอลเลกชันของ RigidbodyConstrainType",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "พื้นหลัง",
  T_49_META_TYP_259_I1_D: "ข้อความ",
  T_49_META_TYP_259_I2_D: "ตำแหน่ง UI",
  T_49_META_TYP_259_I4_D: "สีข้อความ",
  T_49_META_TYP_260_I0_D: "เลือกไอคอน",
  T_49_META_TYP_260_I1_D: "สีของแถบความคืบหน้า",
  T_49_META_TYP_260_I2_D: "ค่า[0, 1]",
  T_49_META_TYP_260_I3_D: "ความเร็ว, ม./วินาที",
  T_49_META_TYP_260_I4_D: "ว่าจะแสดงผลพิเศษหรือไม่",
  T_49_META_TYP_260_I5_D: "ตำแหน่ง UI [0,1]",
  T_49_META_TYP_260_I6_D: "ความคืบหน้าเบื้องต้นของทักษะมีค่าเป็น [0, 1] หลังจากสร้าง UI แล้ว ความคืบหน้าจะซิงโครไนซ์กับความคืบหน้าปัจจุบันทันที",
  T_49_META_TYP_260_I7_D: "สีเอฟเฟ็กต์พิเศษ",
  T_49_META_TYP_260_I8_D: "ตั้งค่ามาตราส่วนของวัตถุ",
  T_49_META_TYP_265_I1_D: "ไม่ว่าจะทำการกรอกพื้นหลัง",
  T_49_META_TYP_265_I2_D: "ชื่อพื้นหลัง",
  T_49_META_TYP_265_I3_D: "สีพื้นหลัง",
  T_49_META_TYP_265_I5_D: "บีจีแอลฟา",
  T_49_META_TYP_265_I6_D: "ประเภทการตัด",
  T_49_META_TYP_265_I7_D: "ประเภทหน้ากากคือชื่อของภาพที่เลือกเมื่อทำการมาสก์",
  T_49_META_TYP_265_I8_D: "หน่วยปรับขอบให้นุ่ม",
  T_49_META_TYP_267_I0_D: "จุดเริ่มต้นการเลื่อนค่าเริ่มต้นอยู่ที่มุมซ้ายบน",
  T_49_META_TYP_267_I1_D: "รองรับการเลื่อนหลายทิศทาง",
  T_49_META_TYP_267_I10_D: "บาร์แนวนอน",
  T_49_META_TYP_267_I11_D: "แสดงตำแหน่ง",
  T_49_META_TYP_267_I2_D: "ลากส่วนประกอบในทิศทาง XY",
  T_49_META_TYP_267_I3_D: "รองรับเอฟเฟกต์ลากหลายแบบ",
  T_49_META_TYP_267_I4_D: "ปัจจัยการเลื่อน ยิ่งค่ามากขึ้น การเลื่อนก็จะเร็วขึ้น",
  T_49_META_TYP_267_I5_D: "ปัจจัยความเฉื่อย ยิ่งค่ามากขึ้น ความเฉื่อยขณะกลิ้งก็จะมากขึ้น",
  T_49_META_TYP_267_I6_D: "การลากจะถูกจำกัดไว้ที่ช่องมองภาพหรือไม่ โดยเลือกไว้ตามค่าเริ่มต้น",
  T_49_META_TYP_267_I7_D: "เมื่อทำเครื่องหมายไว้ การลากจะเริ่มต้นด้วยการเคลื่อนไหวช้า หากไม่ได้ทำเครื่องหมายไว้ การลากจะเริ่มต้นด้วยความเร็วเท่ากับการเคลื่อนไหวของเมาส์",
  T_49_META_TYP_267_I8_D: "เมื่อพอดีกับช่องมองภาพแล้ว ให้ออกจากการลาก",
  T_49_META_TYP_267_I9_D: "ประเภทการแสดงผลแนวตั้ง",
  T_49_META_TYP_268_I0_D: "ค่าเริ่มต้น",
  T_49_META_TYP_268_I1_D: "ปิด",
  T_49_META_TYP_268_I2_D: "แสดง",
  T_49_META_TYP_269_I0_D: "เจ้าของ",
  T_49_META_TYP_269_I1_D: "ตั้งค่า ID",
  T_49_META_TYP_269_I2_D: "รหัสเครื่องประดับศีรษะ",
  T_49_META_TYP_269_I3_D: "การระบุใบหน้า",
  T_49_META_TYP_269_I4_D: "แต่งหน้า ID",
  T_49_META_TYP_269_I5_D: "รหัสประจำตัวส่วนบนของร่างกาย",
  T_49_META_TYP_269_I6_D: "รหัสประจำตัวส่วนล่างของร่างกาย",
  T_49_META_TYP_269_I7_D: "รหัสรองเท้า",
  T_49_META_TYP_272_I0_D: "เพศหญิง",
  T_49_META_TYP_272_I1_D: "ชาย",
  T_49_META_TYP_273_I0_D: "พิกัดโลกที่สอดคล้องกับจุดศูนย์กลางของแผนที่ขนาดเล็ก",
  T_49_META_TYP_273_I1_D: "แผนที่ขนาดเล็ก ความกว้างและความสูงเท่ากัน",
  T_49_META_TYP_273_I2_D: "ว่าจะเปิดใช้งานโหมดแสดงแผนที่ความลึกของแผนที่ย่อหรือไม่",
  T_49_META_TYP_274_I1_D: "การปรับขนาด",
  T_49_META_TYP_274_I4_D: "ระดับการแสดงไอคอน",
  T_49_META_TYP_275_I0_D: "ขนาดกระดูก",
  T_49_META_TYP_275_I1_D: "พิกัดโลกของโหนดกระดูก",
  T_49_META_TYP_276_I0_D: "ศีรษะ",
  T_49_META_TYP_276_I1_D: "แขนซ้าย",
  T_49_META_TYP_276_I2_D: "มือซ้าย",
  T_49_META_TYP_276_I3_D: "แขนขวา",
  T_49_META_TYP_276_I4_D: "มือขวา",
  T_49_META_TYP_276_I5_D: "ตัว",
  T_49_META_TYP_276_I6_D: "ขาซ้าย",
  T_49_META_TYP_276_I7_D: "เท้าซ้าย",
  T_49_META_TYP_276_I8_D: "ขาขวา",
  T_49_META_TYP_276_I9_D: "เท้าขวา",
  T_49_META_TYP_277_I1_D: "ระยะการตรวจจับรังสีของกล้อง",
  T_49_META_TYP_277_I2_D: "หน้ากากชั้นการชนสำหรับการตรวจจับรังสีกล้อง",
  T_49_META_TYP_277_I3_D: "ออฟเซ็ตตำแหน่งปุ่ม",
  T_49_META_TYP_277_I4_D: "รหัสทรัพยากรไอคอน",
  T_49_META_TYP_277_I5_D: "ขนาดพื้นที่คลิก",
  T_49_META_TYP_277_I6_D: "ว่าจะแสดงวัตถุที่จุดเป้าหมายหรือไม่",
  T_49_META_TYP_277_I7_D: "วัตถุแสดงจุดเป้าหมาย",
  T_49_META_TYP_278_I0_D: "เอนทิตี้เป้าหมายในการสร้างพิกเซลแผนที่",
  T_49_META_TYP_28_I0_D: "สามารถรีเซตได้ทุกรอบเลยมั้ย?",
  T_49_META_TYP_280_I0_D: "รัศมีทรงกลม",
  T_49_META_TYP_281_I0_D: "รัศมีของซีกโลกที่ปลายทั้งสองข้างของแคปซูล",
  T_49_META_TYP_29_I0_D: "ทรงกลม",
  T_49_META_TYP_29_I1_D: "ลำแสง",
  T_49_META_TYP_29_I10_D: "เสาไฟที่ฝ่าเท้าตอนนี้ใช้สำหรับการตอบรับเมื่อเข้าสู่เส้นชัย",
  T_49_META_TYP_29_I11_D: "แช่แข็ง",
  T_49_META_TYP_29_I12_D: "แสงสว่าง",
  T_49_META_TYP_29_I13_D: "สายลมที่พัดขึ้น",
  T_49_META_TYP_29_I14_D: "การระเบิดของแก๊ส",
  T_49_META_TYP_29_I15_D: "ผู้ซ่อนตัวถูกฆ่าตาย",
  T_49_META_TYP_29_I16_D: "อาละวาด",
  T_49_META_TYP_29_I17_D: "โคลนตาย",
  T_49_META_TYP_29_I18_D: "ผลตอบลัพธ์จากการยิง",
  T_49_META_TYP_29_I19_D: "โคลนตาย",
  T_49_META_TYP_29_I2_D: "บูม",
  T_49_META_TYP_29_I20_D: "โคลน",
  T_49_META_TYP_29_I21_D: "ประตูมิติ",
  T_49_META_TYP_29_I22_D: "ประกายไฟของระเบิดแสง",
  T_49_META_TYP_29_I23_D: "บอลไฟ",
  T_49_META_TYP_29_I24_D: "การเผาไหม้แบบวนลูป",
  T_49_META_TYP_29_I25_D: "ก๊าซพิษ",
  T_49_META_TYP_29_I26_D: "หัวใจ",
  T_49_META_TYP_29_I29_D: "ประตู",
  T_49_META_TYP_29_I30_D: "พุ/ดอกไม้ไฟ",
  T_49_META_TYP_29_I31_D: "VFX รองเท้าวิ่ง",
  T_49_META_TYP_29_I32_D: "VFX การระเบิด",
  T_49_META_TYP_29_I33_D: "VFX จุดเกิด",
  T_49_META_TYP_29_I34_D: "VFX เลเซอร์",
  T_49_META_TYP_29_I35_D: "VFX ร่ายทักษะ",
  T_49_META_TYP_29_I36_D: "เอฟเฟ็กต์กระสุน",
  T_49_META_TYP_29_I37_D: "VFX กระสุนโดน",
  T_49_META_TYP_29_I38_D: "VFX การยิง",
  T_49_META_TYP_29_I39_D: "VFX ทักษะ",
  T_49_META_TYP_29_I40_D: "รัศมี",
  T_49_META_TYP_29_I41_D: "ฟอง",
  T_49_META_TYP_29_I42_D: "ควันและฝุ่น",
  T_49_META_TYP_29_I43_D: "เศษซากบิน",
  T_49_META_TYP_29_I44_D: "เส้น",
  T_49_META_TYP_29_I45_D: "การกระพริบ",
  T_49_META_TYP_29_I47_D: "อนุภาคที่ขึ้น",
  T_49_META_TYP_29_I48_D: "ควัน",
  T_49_META_TYP_29_I49_D: "เครื่องราง",
  T_49_META_TYP_29_I50_D: "พื้นที่ที่ถูกแช่แข็ง",
  T_49_META_TYP_29_I51_D: "หมอก",
  T_49_META_TYP_29_I52_D: "เกล็ดหิมะ",
  T_49_META_TYP_29_I53_D: "ไฟ",
  T_49_META_TYP_29_I54_D: "ลำแสง",
  T_49_META_TYP_29_I55_D: "ก๊าซพิษแพร่กระจาย",
  T_49_META_TYP_29_I56_D: "ก๊าซพิษ",
  T_49_META_TYP_29_I57_D: "ไฟการระเบิด",
  T_49_META_TYP_29_I58_D: "เอฟเฟ็กต์แสง",
  T_49_META_TYP_29_I59_D: "ดาว",
  T_49_META_TYP_29_I6_D: "ฮาโลอยู่ใต้เท้าคุณ",
  T_49_META_TYP_29_I60_D: "กองไฟที่ลุกโชน",
  T_49_META_TYP_29_I61_D: "น้ำกระเด็น",
  T_49_META_TYP_29_I62_D: "ไฟฟ้าช็อต",
  T_49_META_TYP_29_I63_D: "VFX หมึก",
  T_49_META_TYP_29_I64_D: "VFX หลุมดำ",
  T_49_META_TYP_29_I65_D: "VFX การระเบิดของหลุมดำ",
  T_49_META_TYP_29_I66_D: "VFX บอลคริสตัล",
  T_49_META_TYP_29_I67_D: "เอฟเฟกต์พิเศษกระสุนเลเซอร์",
  T_49_META_TYP_29_I68_D: "ผลกระทบที่ตามมา",
  T_49_META_TYP_29_I69_D: "ผลกระทบจากเมฆ",
  T_49_META_TYP_29_I7_D: "เครื่องหมายภาคพื้น",
  T_49_META_TYP_29_I8_D: "ควัน",
  T_49_META_TYP_29_I9_D: "เครื่องรางระเบิด",
  T_49_META_TYP_290_I0_D: "ระยะเวลาการรีเฟรช ยิ่งตัวเลขมากขึ้น การรีเฟรชก็จะยิ่งช้าลง เป็นมิลลิวินาที",
  T_49_META_TYP_290_I1_D: "ว่าจะเปิดใช้งานการแก้จุดบกพร่องหรือไม่",
  T_49_META_TYP_291_I0_D: "โหนดเงื่อนไข",
  T_49_META_TYP_291_I1_D: "โหนดการกระทำ",
  T_49_META_TYP_293_I0_D: "รหัสแผนผังต้นไม้พฤติกรรม",
  T_49_META_TYP_293_I1_D: "แนบเป้าหมาย",
  T_49_META_TYP_294_I1_D: "ประเภทเค้าโครง",
  T_49_META_TYP_294_I10_D: "จัดเรียงตามประเภท",
  T_49_META_TYP_294_I2_D: "ทิศทางเริ่มต้น",
  T_49_META_TYP_294_I3_D: "ทิศทางการจัดวาง",
  T_49_META_TYP_294_I4_D: "ความกว้างและความสูงของกริดรายการย่อย",
  T_49_META_TYP_294_I5_D: "พื้นที่ของตาราง",
  T_49_META_TYP_294_I6_D: "ตัวข้อจำกัด",
  T_49_META_TYP_294_I7_D: "จำนวนจำกัด",
  T_49_META_TYP_294_I8_D: "ออฟเซ็ตแนวตั้ง",
  T_49_META_TYP_294_I9_D: "ออฟเซ็ตแนวนอน",
  T_49_META_TYP_295_I2_D: "ความเร็วของการเล่น",
  T_49_META_TYP_296_I1_D: "ความยาวคลิป",
  T_49_META_TYP_297_I0_D: "วัตถุที่ถูกผูกไว้",
  T_49_META_TYP_297_I4_D: "รหัสทรัพยากรณ์",
  T_49_META_TYP_298_I0_D: "ค่าเริ่มต้น",
  T_49_META_TYP_298_I2_D: "ครั้งหนึ่ง",
  T_49_META_TYP_30_I0_D: "สี่เหลี่ยม",
  T_49_META_TYP_30_I1_D: "รูปสี่เหลี่ยม",
  T_49_META_TYP_30_I10_D: "ลูกศร",
  T_49_META_TYP_30_I11_D: "เครื่องหมาย",
  T_49_META_TYP_30_I12_D: "หิน",
  T_49_META_TYP_30_I13_D: "กรรไกร",
  T_49_META_TYP_30_I14_D: "กระดาษ",
  T_49_META_TYP_30_I15_D: "ชอบ",
  T_49_META_TYP_30_I16_D: "ขวา",
  T_49_META_TYP_30_I17_D: "ผิด",
  T_49_META_TYP_30_I18_D: "บวก",
  T_49_META_TYP_30_I19_D: "ฟ้าผ่า",
  T_49_META_TYP_30_I2_D: "สี่เหลี่ยมคางหมูมุมขวา",
  T_49_META_TYP_30_I20_D: "หัวใจ",
  T_49_META_TYP_30_I21_D: "ดาว",
  T_49_META_TYP_30_I22_D: "ดวงจันทร์",
  T_49_META_TYP_30_I23_D: "ดวงอาทิตย์",
  T_49_META_TYP_30_I24_D: "แว่นตา",
  T_49_META_TYP_30_I25_D: "คีย์",
  T_49_META_TYP_30_I26_D: "ถ้วยรางวัล",
  T_49_META_TYP_30_I27_D: "ธง",
  T_49_META_TYP_30_I28_D: "นาฬิกาทราย",
  T_49_META_TYP_30_I29_D: "แฟ้ม",
  T_49_META_TYP_30_I3_D: "สี่เหลี่ยมคางหมู",
  T_49_META_TYP_30_I30_D: "เปิดแฟ้ม",
  T_49_META_TYP_30_I31_D: "บ้าน",
  T_49_META_TYP_30_I32_D: "พักผ่อน",
  T_49_META_TYP_30_I33_D: "รีเฟรช",
  T_49_META_TYP_30_I34_D: "วนลูป",
  T_49_META_TYP_30_I35_D: "แว่นขยาย",
  T_49_META_TYP_30_I36_D: "ถังขยะ",
  T_49_META_TYP_30_I37_D: "กลับ",
  T_49_META_TYP_30_I38_D: "เพชร",
  T_49_META_TYP_30_I39_D: "แหวนว่ายน้ำ",
  T_49_META_TYP_30_I4_D: "หกเหลี่ยม",
  T_49_META_TYP_30_I40_D: "เงิน",
  T_49_META_TYP_30_I41_D: "ล็อค",
  T_49_META_TYP_30_I42_D: "การตั้งค่า",
  T_49_META_TYP_30_I43_D: "ออก",
  T_49_META_TYP_30_I44_D: "บทสนทนา",
  T_49_META_TYP_30_I45_D: "เป้าเล็ง",
  T_49_META_TYP_30_I46_D: "ปืน",
  T_49_META_TYP_30_I47_D: "ดาบ",
  T_49_META_TYP_30_I48_D: "การระเบิด",
  T_49_META_TYP_30_I49_D: "เล็ง",
  T_49_META_TYP_30_I5_D: "กลม",
  T_49_META_TYP_30_I50_D: "ข้าม",
  T_49_META_TYP_30_I51_D: "โล่",
  T_49_META_TYP_30_I52_D: "สัตว์ประหลาด",
  T_49_META_TYP_30_I53_D: "รีไซเคิล",
  T_49_META_TYP_30_I54_D: "ของขวัญ",
  T_49_META_TYP_30_I55_D: "เสื้อผ้า",
  T_49_META_TYP_30_I56_D: "เกม",
  T_49_META_TYP_30_I57_D: "ผู้เล่น",
  T_49_META_TYP_30_I58_D: "เก็บ",
  T_49_META_TYP_30_I59_D: "ทางออก",
  T_49_META_TYP_30_I6_D: "สามเหลี่ยม",
  T_49_META_TYP_30_I60_D: "คำเตือน",
  T_49_META_TYP_30_I61_D: "ข้อความ",
  T_49_META_TYP_30_I62_D: "วัตถุตัวจับเวลา",
  T_49_META_TYP_30_I63_D: "กระดิ่ง",
  T_49_META_TYP_30_I64_D: "สัตว์เลี้ยง",
  T_49_META_TYP_30_I65_D: "ระเบิด",
  T_49_META_TYP_30_I66_D: "ซ่อมแซม",
  T_49_META_TYP_30_I67_D: "หน้ายิ้ม",
  T_49_META_TYP_30_I68_D: "ลำโพง",
  T_49_META_TYP_30_I7_D: "อัศเจรีย์",
  T_49_META_TYP_30_I70_D: "มงกุฎ",
  T_49_META_TYP_30_I71_D: "กระต่อสู้",
  T_49_META_TYP_30_I72_D: "กิลด์",
  T_49_META_TYP_30_I73_D: "จังหวะหัวใจ",
  T_49_META_TYP_30_I74_D: "ดนตรี",
  T_49_META_TYP_30_I75_D: "ยานพาหนะ",
  T_49_META_TYP_30_I76_D: "ระยะประชิด",
  T_49_META_TYP_30_I77_D: "ปืนพก",
  T_49_META_TYP_30_I78_D: "ไรเฟิล",
  T_49_META_TYP_30_I79_D: "สไนเปอร์ไรเฟิล",
  T_49_META_TYP_30_I8_D: "เครื่องหมายคำถาม",
  T_49_META_TYP_30_I80_D: "ปืนลูกซอง",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "ปืนฮีล",
  T_49_META_TYP_30_I83_D: "เกราะแตกสลาย",
  T_49_META_TYP_30_I84_D: "ยิงเข้าหัว",
  T_49_META_TYP_30_I85_D: "ทักษะ 1",
  T_49_META_TYP_30_I86_D: "ทักษะ 2",
  T_49_META_TYP_30_I87_D: "ทักษะ 3",
  T_49_META_TYP_30_I88_D: "ทักษะ 4",
  T_49_META_TYP_30_I89_D: "ทักษะ 5",
  T_49_META_TYP_30_I9_D: "เครื่องหมาย",
  T_49_META_TYP_30_I90_D: "ทักษะ 6",
  T_49_META_TYP_30_I91_D: "ทักษะ 7",
  T_49_META_TYP_30_I92_D: "ทักษะ8",
  T_49_META_TYP_30_I93_D: "ทักษะ 9",
  T_49_META_TYP_30_I94_D: "ทักษะ 10",
  T_49_META_TYP_300_I0_D: "รหัสทรัพยากรณ์",
  T_49_META_TYP_300_I2_D: "การหมุน",
  T_49_META_TYP_300_I3_D: "สร้างเอนทิตี้",
  T_49_META_TYP_301_I1_D: "ระเบิดตัวเอง",
  T_49_META_TYP_301_I2_D: "พุ่งโจมตี",
  T_49_META_TYP_301_I3_D: "คลื่นกระแทก",
  T_49_META_TYP_301_I4_D: "การโจมตีด้วยลม",
  T_49_META_TYP_301_I5_D: "กระโดดโจมตี",
  T_49_META_TYP_301_I6_D: "โล่ขึ้น",
  T_49_META_TYP_301_I7_D: "โล่แตก",
  T_49_META_TYP_302_I5_D: "กระเป๋า",
  T_49_META_TYP_302_I7_D: "สเก็ตบอร์ด ลายพราง...",
  T_49_META_TYP_303_I0_D: "เพิ่ม HP สูงสุดของผู้เล่น",
  T_49_META_TYP_303_I1_D: "ฟื้น HP ของผู้เล่นอย่างต่อเนื่อง",
  T_49_META_TYP_305_I0_D: "เสร็จ",
  T_49_META_TYP_305_I1_D: "วิ่ง",
  T_49_META_TYP_307_I0_D: "ค่าประสบการณ์ต่อความเสียหาย",
  T_49_META_TYP_307_I1_D: "ค่าประสบการณ์ต่อไมล์ที่เคลื่อนที่",
  T_49_META_TYP_307_I2_D: "ค่าประสบการณ์ต่อวินาที",
  T_49_META_TYP_307_I3_D: "ชิปประสบการณ์",
  T_49_META_TYP_307_I4_D: "ขีดจำกัดการชาร์จ",
  T_49_META_TYP_308_I0_D: "เครื่องผลิตเจล",
  T_49_META_TYP_31_I0_D: "ระเบิดมือ",
  T_49_META_TYP_31_I1_D: "เสียงปืน",
  T_49_META_TYP_31_I10_D: "เสียงเอฟเฟกต์การโดนตีแล้วเกิดความเสียหาย",
  T_49_META_TYP_31_I11_D: "อัพเกรดเอฟเฟกต์เสียง",
  T_49_META_TYP_31_I12_D: "เอฟเฟกต์เสียงคลิกอ่อน",
  T_49_META_TYP_31_I13_D: "ผู้เล่นเหยียบเอฟเฟกต์เสียงกลไก",
  T_49_META_TYP_31_I14_D: "เสียงเอฟเฟกต์การซ่อมอุปกรณ์",
  T_49_META_TYP_31_I15_D: "เสียงเอฟเฟกต์การซ่อมอุปกรณ์",
  T_49_META_TYP_31_I16_D: "เอฟเฟกต์เสียงผิดพลาดหรือหายไป",
  T_49_META_TYP_31_I17_D: "เอฟเฟกต์เสียงเตือนความจำ",
  T_49_META_TYP_31_I18_D: "เสียงเอฟเฟคฟุตบอลลงจอด",
  T_49_META_TYP_31_I19_D: "เอฟเฟกต์เสียงเชียร์",
  T_49_META_TYP_31_I2_D: "เสียงบี๊บ นับถอยหลัง",
  T_49_META_TYP_31_I20_D: "เอฟเฟกต์เสียงเตือนระเบิด",
  T_49_META_TYP_31_I21_D: "เอฟเฟคเสียงระเบิด",
  T_49_META_TYP_31_I22_D: "ฮันเตอร์ปรากฎเสียงเอฟเฟค",
  T_49_META_TYP_31_I23_D: "เอฟเฟกต์เสียง BGM สุดท้าย",
  T_49_META_TYP_31_I24_D: "เสียงเอฟเฟกต์รีเฟรชกล่องซัพพลาย",
  T_49_META_TYP_31_I25_D: "เอฟเฟกต์เสียงเครื่องเร่งความเร็ว",
  T_49_META_TYP_31_I26_D: "เอฟเฟกต์เสียงเตือนการหายตัวไป",
  T_49_META_TYP_31_I27_D: "เอฟเฟคภาพ เสียง เอฟเฟคต่างๆ",
  T_49_META_TYP_31_I28_D: "เอฟเฟกต์เสียงแมลงตอนกลางคืน",
  T_49_META_TYP_31_I29_D: "เอฟเฟกต์เสียงการตีที่น่าเบื่อ",
  T_49_META_TYP_31_I3_D: "UI แตะ",
  T_49_META_TYP_31_I30_D: "เอฟเฟกต์เสียงตอบสนอง",
  T_49_META_TYP_31_I31_D: "ค้นพบเอฟเฟกต์เสียงที่น่าประหลาดใจ",
  T_49_META_TYP_31_I32_D: "เสียงเอฟเฟคผีน้อยเล่น",
  T_49_META_TYP_31_I33_D: "เอฟเฟกต์เสียงเริ่มเฟส",
  T_49_META_TYP_31_I34_D: "เอฟเฟกต์เสียงซอมบี้",
  T_49_META_TYP_31_I35_D: "เอฟเฟกต์เสียงสยองขวัญ",
  T_49_META_TYP_31_I36_D: "เอฟเฟกต์เสียงการแปลงร่าง",
  T_49_META_TYP_31_I37_D: "เอฟเฟกต์เสียงหัวใจเต้นเร็ว",
  T_49_META_TYP_31_I38_D: "เอฟเฟกต์เสียงเต้นหัวใจความเร็วปานกลาง",
  T_49_META_TYP_31_I39_D: "เอฟเฟกต์เสียงหัวใจเต้นช้า",
  T_49_META_TYP_31_I4_D: "ผู้หญิงกรีดร้องเมื่อโดนโจมตี",
  T_49_META_TYP_31_I40_D: "เอฟเฟกต์เสียงโกรธ",
  T_49_META_TYP_31_I41_D: "เอฟเฟกต์เสียงคลิก",
  T_49_META_TYP_31_I42_D: "เอฟเฟกต์เสียงการกู้คืนทักษะ",
  T_49_META_TYP_31_I43_D: "เพิ่มเอฟเฟกต์เสียงในเกม",
  T_49_META_TYP_31_I44_D: "เอฟเฟกต์เสียงสะท้อนจากกลไก",
  T_49_META_TYP_31_I45_D: "เอฟเฟคเสียงยุง",
  T_49_META_TYP_31_I46_D: "เอฟเฟกต์เสียง Ding Ding Ding 1 แบบเข้มข้น",
  T_49_META_TYP_31_I47_D: "เอฟเฟกต์เสียง Ding Ding Ding 2 แบบเข้มข้น",
  T_49_META_TYP_31_I48_D: "เอฟเฟกต์เสียงการเปิดกลไก",
  T_49_META_TYP_31_I49_D: "เอฟเฟกต์เสียงการชาร์จ 1",
  T_49_META_TYP_31_I5_D: "ผู้ชายกรีดร้องเมื่อโดนโจมตี",
  T_49_META_TYP_31_I50_D: "เอฟเฟกต์เสียงเตือนเสียงฝีเท้า",
  T_49_META_TYP_31_I51_D: "เสียงเอฟเฟกต์แจ้งภารกิจสำเร็จ 1",
  T_49_META_TYP_31_I52_D: "เสียงเตือนอันตราย เอฟเฟกต์เสียง 1",
  T_49_META_TYP_31_I53_D: "เสียงเตือนอันตราย 2 เอฟเฟกต์เสียง",
  T_49_META_TYP_31_I54_D: "เอฟเฟกต์เสียงนับถอยหลัง 3",
  T_49_META_TYP_31_I55_D: "แสดงเคล็ดลับเอฟเฟกต์เสียง",
  T_49_META_TYP_31_I56_D: "เอฟเฟกต์เสียงรอบข้างของเสียงการ้อง",
  T_49_META_TYP_31_I57_D: "เอฟเฟกต์เสียงการเทเลพอร์ตไปยังพื้นที่ผิดโดยใช้เครื่องเทเลพอร์ต",
  T_49_META_TYP_31_I58_D: "เอฟเฟกต์เสียงของการเทเลพอร์ตไปยังพื้นที่ที่ถูกต้องโดยใช้จุดเทเลพอร์ต",
  T_49_META_TYP_31_I59_D: "ส่งเสียง",
  T_49_META_TYP_31_I6_D: "เสียงเอฟเฟคการเก็บเหรียญทอง",
  T_49_META_TYP_31_I60_D: "เอฟเฟคเสียงไฟฟ้าช็อต",
  T_49_META_TYP_31_I61_D: "รับเอฟเฟกต์เสียงประกอบฉาก",
  T_49_META_TYP_31_I62_D: "เอฟเฟกต์เสียงดนตรีประกอบอิเล็กทรอนิกส์น่ารักฝันๆ",
  T_49_META_TYP_31_I63_D: "เอฟเฟกต์เสียงเพลงประกอบเกมสบายๆ",
  T_49_META_TYP_31_I64_D: "เปิดกล่อง",
  T_49_META_TYP_31_I65_D: "อันดับเพิ่ม",
  T_49_META_TYP_31_I66_D: "เลเวลสูงสุด",
  T_49_META_TYP_31_I67_D: "แตะปุ่ม",
  T_49_META_TYP_31_I68_D: "นับถอยหลัง",
  T_49_META_TYP_31_I69_D: "เอาชนะศัตรู",
  T_49_META_TYP_31_I7_D: "เอฟเฟกต์เสียงทริกเกอร์สำหรับการผ่านเส้นชัยในการแข่งขัน",
  T_49_META_TYP_31_I70_D: "จบ",
  T_49_META_TYP_31_I71_D: "ไปข้างหน้า",
  T_49_META_TYP_31_I72_D: "ชัยชนะ",
  T_49_META_TYP_31_I73_D: "จุดตรวจฐานฝึกอบรม",
  T_49_META_TYP_31_I74_D: "นับถอยหลัง",
  T_49_META_TYP_31_I75_D: "เกมเริ่ม",
  T_49_META_TYP_31_I76_D: "รับทองก้อนใหญ่",
  T_49_META_TYP_31_I77_D: "รับทองปานกลาง",
  T_49_META_TYP_31_I78_D: "รับทองขนาดเล็ก",
  T_49_META_TYP_31_I79_D: "เข้าร่วมการต่อสู้",
  T_49_META_TYP_31_I8_D: "เอฟเฟกต์เสียงทริกเกอร์",
  T_49_META_TYP_31_I80_D: "ทรัพยากรณ์กิลด์",
  T_49_META_TYP_31_I81_D: "ลำโพง",
  T_49_META_TYP_31_I82_D: "หัวหน้ากิลด์ที่ถูกถอดถอน",
  T_49_META_TYP_31_I83_D: "การจัดเก็บคลัง",
  T_49_META_TYP_31_I84_D: "เสียงปืนพิเศษ",
  T_49_META_TYP_31_I85_D: "กระสุนโดน",
  T_49_META_TYP_31_I86_D: "เคลื่อนไหว",
  T_49_META_TYP_31_I87_D: "แตะปุ่มปิดการใช้งาน",
  T_49_META_TYP_31_I88_D: "ชาร์จทักษะเสร็จสมบูรณ์",
  T_49_META_TYP_31_I89_D: "ทักษะเลเซอร์",
  T_49_META_TYP_31_I9_D: "เอฟเฟกต์เสียงเสื่อมลง",
  T_49_META_TYP_31_I90_D: "ได้รับของบริโภค 2",
  T_49_META_TYP_31_I91_D: "นับถอยหลัง 3",
  T_49_META_TYP_31_I92_D: "เกมจบ 2",
  T_49_META_TYP_31_I93_D: "คำเตือนการฆ่า",
  T_49_META_TYP_31_I94_D: "การระเบิด",
  T_49_META_TYP_31_I95_D: "ทักษะลูกแก้วพลังงาน",
  T_49_META_TYP_31_I96_D: "ทักษะสระเลือด",
  T_49_META_TYP_311_I1_D: "ความเสียหายสูงสุด",
  T_49_META_TYP_311_I3_D: "ความเร็วในการบินของวัตถุที่ถูกโยนหลังจากออกจากมือเป็นเมตรต่อวินาที",
  T_49_META_TYP_311_I4_D: "ระยะเวลาตั้งแต่เมื่อวัตถุที่ถูกโยนถูกปล่อยจนกระทั่งวัตถุนั้นมีผล เป็นวินาที",
  T_49_META_TYP_313_I0_D: "รัศมีพื้นที่",
  T_49_META_TYP_313_I1_D: "ระยะเวลาของโซนเคาน์เตอร์เป็นวินาที",
  T_49_META_TYP_314_I0_D: "รหัสทรัพยากรตัวควบคุมแอนิเมชัน",
  T_49_META_TYP_314_I1_D: "ตัวควบคุมแอนิเมชัน",
  T_49_META_TYP_315_I0_D: "เจ้าของกระเป๋าเป้",
  T_49_META_TYP_315_I1_D: "พื้นที่สำหรับสะพายเป้",
  T_49_META_TYP_315_I2_D: "ใช้ความจุ",
  T_49_META_TYP_315_I3_D: "เสบียงทั้งหมด",
  T_49_META_TYP_316_I0_D: "ทรัพยากรเท็กเจอร์",
  T_49_META_TYP_316_I1_D: "ชื่อเชดเดอร์",
  T_49_META_TYP_316_I11_D: "วิธีการพลิกกลับ",
  T_49_META_TYP_316_I2_D: "ออฟเซต UV",
  T_49_META_TYP_316_I3_D: "ขนาด UV",
  T_49_META_TYP_316_I4_D: "เติมประเภท",
  T_49_META_TYP_316_I5_D: "ขอบซ้ายขวา",
  T_49_META_TYP_316_I6_D: "ขอบบนล่าง",
  T_49_META_TYP_317_I0_D: "ไม่มี",
  T_49_META_TYP_317_I1_D: "แช่ตำแหน่ง X",
  T_49_META_TYP_317_I2_D: "แช่ตำแหน่ง Y",
  T_49_META_TYP_317_I3_D: "แช่ตำแหน่ง Z",
  T_49_META_TYP_317_I4_D: "จำกัดการหมุนรอบแกน X",
  T_49_META_TYP_317_I5_D: "จำกัดการหมุนรอบแกน Y",
  T_49_META_TYP_317_I6_D: "จำกัดการหมุนรอบแกน Z",
  T_49_META_TYP_317_I7_D: "แช่ตำแหน่ง",
  T_49_META_TYP_317_I8_D: "แช่การหมุน",
  T_49_META_TYP_317_I9_D: "แช่ทั้งหมด",
  T_49_META_TYP_318_I0_D: "พิสัย",
  T_49_META_TYP_318_I1_D: "ระยะความเสียหายเต็ม",
  T_49_META_TYP_318_I10_D: "ค่าสัมประสิทธิ์ความเร็วการเล็งของผู้เล่น",
  T_49_META_TYP_318_I11_D: "ขอบเขตการขยายที่กำหนด",
  T_49_META_TYP_318_I12_D: "กำลังขยาย FOV",
  T_49_META_TYP_318_I13_D: "การขยายภาพของการเล็งผ่านกล้องปืน",
  T_49_META_TYP_318_I14_D: "เวลาการขยายภาพของการเล็งผ่านกล้องปืน",
  T_49_META_TYP_318_I15_D: "เวลาการฟื้นการขยายภาพของการเล็งผ่านกล้องปืน",
  T_49_META_TYP_318_I16_D: "ปัจจัยการแก้ไขระยะความเสียหายขั้นต่ำสำหรับขอบเขต",
  T_49_META_TYP_318_I17_D: "อนุญาตให้ช่วยเล็งผ่านกล้องปืน",
  T_49_META_TYP_318_I18_D: "อัตราส่วนการดึงดูดช่วงหน้าจอช่วยเล็ง (0-1)",
  T_49_META_TYP_318_I19_D: "ค่าสัมประสิทธิ์อิทธิพลการลดทอนระยะการช่วยเล็ง (0-1)",
  T_49_META_TYP_318_I2_D: "ระยะเริ่มต้นความเสียหายขั้นต่ำ",
  T_49_META_TYP_318_I20_D: "อนุญาตให้ระยะของการช่วยเล็งก่อน",
  T_49_META_TYP_318_I21_D: "ลำดับความสำคัญระยะช่วยเล็งระยะต่ำสุด",
  T_49_META_TYP_318_I22_D: "ลำดับความสำคัญระยะการช่วยเล็งระยะทางสูงสุด",
  T_49_META_TYP_318_I23_D: "อิทธิพลของลำดับความสำคัญค่าสัมประสิทธิ์ระยะการช่วยเล็ง (>=1)",
  T_49_META_TYP_318_I24_D: "ค่าสัมประสิทธิ์ความไวในการหมุนขณะเล็งผ่านกล้องปืน",
  T_49_META_TYP_318_I25_D: "ความเร็วบรรจบกัน",
  T_49_META_TYP_318_I3_D: "ขนาดคลิปกระสุน",
  T_49_META_TYP_318_I4_D: "ช่วงเวลาการโจมตี",
  T_49_META_TYP_318_I5_D: "ความเร็วการเปลี่ยนกระสุน",
  T_49_META_TYP_318_I6_D: "ความเร็วในการโหลดอัตโนมัติ",
  T_49_META_TYP_318_I7_D: "ความเร็วของการกระจาย",
  T_49_META_TYP_318_I8_D: "อัตราการกระจายเมื่อหมอบหรือนอนลง ทุกๆ 0.1 หมายความว่าระยะเป้าเล็งจะเพิ่มขึ้น 10% สำหรับกระสุนแต่ละนัด",
  T_49_META_TYP_318_I9_D: "เกณฑ์การแพร่กระจายสูงสุด",
  T_49_META_TYP_319_I0_D: "เรียบง่าย",
  T_49_META_TYP_319_I1_D: "หั่น",
  T_49_META_TYP_319_I2_D: "ปูกระเบื้อง",
  T_49_META_TYP_319_I3_D: "เติมเต็ม",
  T_49_META_TYP_319_I4_D: "พอดี",
  T_49_META_TYP_32_I0_D: "ผู้เล่นอยู่ในสถานะใช้งานปกติ",
  T_49_META_TYP_32_I1_D: "ผู้เล่นอยู่ในสถานะล้มลง",
  T_49_META_TYP_32_I2_D: "ผู้เล่นอยู่ในสถานะตาย",
  T_49_META_TYP_320_I0_D: "แนวนอน",
  T_49_META_TYP_320_I1_D: "แนวตั้ง",
  T_49_META_TYP_320_I2_D: "รัศมี 90°",
  T_49_META_TYP_320_I3_D: "รัศมี 180°",
  T_49_META_TYP_320_I4_D: "รัศมี 360°",
  T_49_META_TYP_321_I0_D: "ระยะห่างสูงสุดในการกระตุ้นการช่วยเล็ง",
  T_49_META_TYP_321_I1_D: "การปรับค่าชดเชยของเป้าเล็งเมื่อการเล็งด้วยความช่วยเหลือถูกกระตุ้น หากจุดชดเชยไม่อยู่ในเอนทิตี การเล็งด้วยความช่วยเหลือจะล้มเหลว",
  T_49_META_TYP_322_I0_D: "ไม่มี",
  T_49_META_TYP_322_I1_D: "ศีรษะ",
  T_49_META_TYP_322_I2_D: "ร่างกาย",
  T_49_META_TYP_322_I3_D: "แขนขา",
  T_49_META_TYP_323_I0_D: "ขนาด",
  T_49_META_TYP_323_I1_D: "รหัสบัญชี",
  T_49_META_TYP_323_I2_D: "ข้อมูลโปรไฟล์ผู้เล่น",
  T_49_META_TYP_323_I3_D: "สไตล์",
  T_49_META_TYP_323_I4_D: "แสดงอันดับ",
  T_49_META_TYP_323_I5_D: "แสดงพิน",
  T_49_META_TYP_323_I6_D: "แสดงชื่อเล่น",
  T_49_META_TYP_324_I0_D: "สร้างแรงที่มีขนาดตามที่กำหนด",
  T_49_META_TYP_324_I1_D: "สร้างความเร่งตามขนาดที่กำหนด",
  T_49_META_TYP_324_I2_D: "สร้างแรงกระตุ้นที่มีขนาดที่กำหนด",
  T_49_META_TYP_324_I3_D: "สร้างความเร็วตามขนาดที่กำหนด",
  T_49_META_TYP_326_I0_D: "รหัสบัญชี",
  T_49_META_TYP_326_I1_D: "รหัสอวตาร",
  T_49_META_TYP_326_I2_D: "รหัสป้ายแบนเนอร์",
  T_49_META_TYP_326_I3_D: "รหัสพิน",
  T_49_META_TYP_326_I4_D: "ชื่อเล่นของผู้เล่น",
  T_49_META_TYP_326_I5_D: "อันดับ BR",
  T_49_META_TYP_326_I6_D: "แรงก์โหมดทั่วไปสูงสุด",
  T_49_META_TYP_326_I7_D: "อันดับ CS",
  T_49_META_TYP_326_I8_D: "แรงก์โหมด 4v4 สูงสุด",
  T_49_META_TYP_327_I0_D: "รหัสทรัพยากร",
  T_49_META_TYP_327_I1_D: "มาสก์ชิ้นส่วน 1",
  T_49_META_TYP_327_I2_D: "มาสก์ชิ้นส่วน 2",
  T_49_META_TYP_327_I3_D: "มาสก์ชิ้นส่วน 3",
  T_49_META_TYP_327_I4_D: "มาสก์ชิ้นส่วน 4",
  T_49_META_TYP_329_I0_D: "คนขับรถ",
  T_49_META_TYP_329_I1_D: "ผู้โดยสาร A",
  T_49_META_TYP_329_I2_D: "ผู้โดยสาร B",
  T_49_META_TYP_329_I3_D: "ผู้โดยสาร ค",
  T_49_META_TYP_33_I0_D: "หากเรียงจากน้อยไปมาก จะไม่สนใจค่าศูนย์และเรียงลำดับไว้เป็นอันดับสุดท้าย",
  T_49_META_TYP_33_I1_D: "ลงจากใหญ่ไปเล็ก",
  T_49_META_TYP_33_I2_D: "ขึ้นจากเล็กไปใหญ่",
  T_49_META_TYP_330_I4_D: "ระยะเวลาของผลความคงกระพัน (หน่วย: วินาที)",
  T_49_META_TYP_330_I5_D: "จุดควบคุม",
  T_49_META_TYP_330_I8_D: "ค่าเดลต้า",
  T_49_META_TYP_332_I0_D: "ลูปหรือไม่",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "ตัวย่ออารบิก",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFF Latin",
  T_49_META_TYP_333_I4_D: "Agency FB",
  T_49_META_TYP_333_I5_D: "ห้างสรรพสินค้า",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "เส้นทางทรัพยากรว่างเปล่าตามค่าเริ่มต้น",
  T_49_META_TYP_335_I1_D: "จำนวนการเล่น ค่าเริ่มต้นคือ 1",
  T_49_META_TYP_335_I2_D: "ระดับเสียงค่าเริ่มต้นคือ 50",
  T_49_META_TYP_335_I3_D: "ระยะทางสูงสุด",
  T_49_META_TYP_335_I4_D: "ระยะทางขั้นต่ำ",
  T_49_META_TYP_335_I5_D: "มันคือดนตรี 3D ใช่ไหม?",
  T_49_META_TYP_335_I6_D: "ลำดับความสำคัญ",
  T_49_META_TYP_335_I7_D: "เวลาในการรอเริ่มต้นเป็นวินาที",
  T_49_META_TYP_335_I8_D: "กำลังเล่นอยู่ไหม",
  T_49_META_TYP_338_I0_D: "สถานะมือถือ",
  T_49_META_TYP_338_I1_D: "สถานะสปรินท์",
  T_49_META_TYP_338_I2_D: "สถานะการโจมตี",
  T_49_META_TYP_338_I3_D: "สถานะการกระโดด",
  T_49_META_TYP_338_I4_D: "รัฐปีนเขา",
  T_49_META_TYP_338_I5_D: "ลงรถ(คนขับ)",
  T_49_META_TYP_338_I6_D: "การขึ้นยานพาหนะ (ผู้โดยสาร)",
  T_49_META_TYP_338_I7_D: "ออกยานพาหนะ",
  T_49_META_TYP_338_I8_D: "ขับ",
  T_49_META_TYP_339_I0_D: "ค่าสัมประสิทธิ์ความเสียหายของแขนขา",
  T_49_META_TYP_339_I1_D: "ค่าสัมประสิทธิ์ความเสียหายที่ศีรษะ",
  T_49_META_TYP_339_I2_D: "ตัวคูณความทนทานสูงสุด",
  T_49_META_TYP_339_I3_D: "ตัวคูณพลังชีวิตของผู้เล่น",
  T_49_META_TYP_339_I4_D: "ปัจจัยลดความเสียหายจากการระเบิดเพิ่มเติม (%)",
  T_49_META_TYP_339_I5_D: "ความจุกระเป๋าเป้เพิ่มเติม",
  T_49_META_TYP_339_I6_D: "แทนลำดับความสำคัญ",
  T_49_META_TYP_34_I0_D: "กำปั้นเริ่มต้น",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "ฟามาส-อี",
  T_49_META_TYP_34_I101_D: "โกรซ่า-เอ็กซ์",
  T_49_META_TYP_34_I102_D: "สวท.ย.",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "เอ็ม4เอ1-ไอ",
  T_49_META_TYP_34_I106_D: "เอ็ม4เอ1-ไอ",
  T_49_META_TYP_34_I107_D: "เอ็ม4เอ1-III",
  T_49_META_TYP_34_I108_D: "เอ็ม4เอ1-III",
  T_49_META_TYP_34_I109_D: "ปืนลูกซองชาร์จ",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "ปืนใหญ่",
  T_49_META_TYP_34_I112_D: "ปินน้ำแข็ง",
  T_49_META_TYP_34_I113_D: "ปืนโล่",
  T_49_META_TYP_34_I114_D: "เอ็มพี 5-2",
  T_49_META_TYP_34_I115_D: "เอ็มพี 5-3",
  T_49_META_TYP_34_I116_D: "เอ็มพี 5-3",
  T_49_META_TYP_34_I117_D: "เอ็ม 60-ทู",
  T_49_META_TYP_34_I118_D: "เอ็ม 60-III",
  T_49_META_TYP_34_I119_D: "เอ็ม 60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "วีเอสเอส-ทู",
  T_49_META_TYP_34_I121_D: "วีเอสเอส-3",
  T_49_META_TYP_34_I122_D: "เอ็ม14-ทู",
  T_49_META_TYP_34_I123_D: "เอ็ม14-III",
  T_49_META_TYP_34_I124_D: "เอ็ม14-III",
  T_49_META_TYP_34_I125_D: "คาร98เค-ทู",
  T_49_META_TYP_34_I126_D: "คาร98เค-III",
  T_49_META_TYP_34_I127_D: "คาร98เค-III",
  T_49_META_TYP_34_I128_D: "ฟามาส-II",
  T_49_META_TYP_34_I129_D: "ฟามาส-III",
  T_49_META_TYP_34_I13_D: "ระเบิดเปลวไฟ",
  T_49_META_TYP_34_I133_D: "ระเบิดแสง",
  T_49_META_TYP_34_I134_D: "ระเบิดควัน",
  T_49_META_TYP_34_I135_D: "ระเบิดน้ำแข็ง",
  T_49_META_TYP_34_I136_D: "เสื้อเกราะกันกระสุน Lv1",
  T_49_META_TYP_34_I137_D: "เสื้อเกราะกันกระสุน Lv2",
  T_49_META_TYP_34_I138_D: "เสื้อเกราะกันกระสุน Lv3",
  T_49_META_TYP_34_I139_D: "หมวกกันน็อค Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "หมวกกันน็อค Lv2",
  T_49_META_TYP_34_I141_D: "หมวกกันน็อค Lv3",
  T_49_META_TYP_34_I142_D: "เกราะป้องกันการระเบิด",
  T_49_META_TYP_34_I143_D: "กระเป๋าเป้ Lv1",
  T_49_META_TYP_34_I144_D: "กระเป๋าเป้ Lv2",
  T_49_META_TYP_34_I145_D: "กระเป๋าเป้ Lv3",
  T_49_META_TYP_34_I146_D: "ปากกระบอกปืน Lv1",
  T_49_META_TYP_34_I147_D: "ปากกระบอกปืน Lv2",
  T_49_META_TYP_34_I148_D: "ปากกระบอกปืน Lv3",
  T_49_META_TYP_34_I149_D: "หม้อพักไอเสีย",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "ปากกระบอกปืนจู่โจม",
  T_49_META_TYP_34_I151_D: "ปากกระบอกกว้าง",
  T_49_META_TYP_34_I152_D: "นิตยสาร Lv1",
  T_49_META_TYP_34_I153_D: "นิตยสาร Lv2",
  T_49_META_TYP_34_I154_D: "แม็กกาซีน Lv3",
  T_49_META_TYP_34_I155_D: "แม็กกาซีนมัดคู่",
  T_49_META_TYP_34_I156_D: "นิตยสารเชน",
  T_49_META_TYP_34_I157_D: "ยึดเกาะ Lv1",
  T_49_META_TYP_34_I158_D: "ยึดเกาะ Lv2",
  T_49_META_TYP_34_I159_D: "ยึดเกาะ Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "ขาตั้งพับได้",
  T_49_META_TYP_34_I161_D: "ด้ามปืนไรเฟิล Marksman",
  T_49_META_TYP_34_I162_D: "พานท้ายปืนลูกซอง",
  T_49_META_TYP_34_I163_D: "พานท้ายปืนไรเฟิล",
  T_49_META_TYP_34_I164_D: "กล้องส่องตรวจภาพความร้อน",
  T_49_META_TYP_34_I165_D: "สต๊อก Lv1",
  T_49_META_TYP_34_I166_D: "สต๊อก Lv2",
  T_49_META_TYP_34_I167_D: "สต๊อก Lv3",
  T_49_META_TYP_34_I168_D: "โล่ขยาย",
  T_49_META_TYP_34_I169_D: "เกราะป้องกันร่างกายแบบเต็มตัว",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "การซ้อนทับที่มากเกินไป",
  T_49_META_TYP_34_I171_D: "ชั้นกลางป้องกันการระเบิด",
  T_49_META_TYP_34_I172_D: "การขยายเป้สะพายหลัง",
  T_49_META_TYP_34_I173_D: "เครื่องช่วยหายใจรักษา",
  T_49_META_TYP_34_I174_D: "ฮอริซาลีน",
  T_49_META_TYP_34_I175_D: "ชุดยา",
  T_49_META_TYP_34_I176_D: "ชุดซ่อมเกราะ",
  T_49_META_TYP_34_I177_D: "หอคอยป้องกันปัญญาประดิษฐ์ที่ทำจากวัสดุไฮเทคจะค้นหาและโจมตีศัตรูภายในระยะที่กำหนดอย่างแข็งขัน",
  T_49_META_TYP_34_I178_D: "เห็ดระดับ 1",
  T_49_META_TYP_34_I179_D: "เห็ดระดับ 2",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "เห็ดระดับ 3",
  T_49_META_TYP_34_I181_D: "เห็ดระดับ 4",
  T_49_META_TYP_34_I182_D: "UAV ส่วนบุคคล",
  T_49_META_TYP_34_I184_D: "เหมืองใกล้บ้าน",
  T_49_META_TYP_34_I185_D: "รองเท้าบินเจ็ท",
  T_49_META_TYP_34_I186_D: "รองเท้าบูทบาวน์ซ์พาวเวอร์",
  T_49_META_TYP_34_I187_D: "แฮงไกลเดอร์",
  T_49_META_TYP_34_I188_D: "ระเบิดล่อ",
  T_49_META_TYP_34_I189_D: "โฮเวอร์บอร์ดแม่เหล็ก",
  T_49_META_TYP_34_I19_D: "เดเซิร์ทอีเกิล",
  T_49_META_TYP_34_I190_D: "คีมกำจัดระเบิด",
  T_49_META_TYP_34_I191_D: "อัพเกรดปืน",
  T_49_META_TYP_34_I192_D: "กระสุนไรเฟิล",
  T_49_META_TYP_34_I193_D: "กระสุนปืนพก",
  T_49_META_TYP_34_I194_D: "กระสุนไรเฟิลซุ่มยิง",
  T_49_META_TYP_34_I195_D: "กระสุนปืนลูกซอง",
  T_49_META_TYP_34_I196_D: "กระสุนปืนกลเบา",
  T_49_META_TYP_34_I197_D: "ลูกศร",
  T_49_META_TYP_34_I198_D: "ระเบิดM79",
  T_49_META_TYP_34_I199_D: "กระสุนพ่นไฟ",
  T_49_META_TYP_34_I2_D: "หน้าไม้",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "มีดขว้าง2",
  T_49_META_TYP_34_I201_D: "ตะขอ",
  T_49_META_TYP_34_I202_D: "ปืนฟุตบอล",
  T_49_META_TYP_34_I203_D: "มวย",
  T_49_META_TYP_34_I204_D: "Flamethrower",
  T_49_META_TYP_34_I205_D: "การ์ด Monkeygod",
  T_49_META_TYP_34_I206_D: "เมดแมนเอการ์ด",
  T_49_META_TYP_34_I207_D: "ดีเจมาเล่การ์ด",
  T_49_META_TYP_34_I208_D: "การ์ดกราฟฟิตี้",
  T_49_META_TYP_34_I209_D: "การ์ดนักสืบ",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "บัตรศาสตราจารย์",
  T_49_META_TYP_34_I211_D: "การ์ดล่าค่าหัว",
  T_49_META_TYP_34_I212_D: "ซุปเปอร์สตาร์การ์ด",
  T_49_META_TYP_34_I213_D: "เอ็กซ์ตรีมการ์ด",
  T_49_META_TYP_34_I214_D: "มิวสิคโบรการ์ด",
  T_49_META_TYP_34_I215_D: "เคนตะการ์ด",
  T_49_META_TYP_34_I216_D: "การ์ดติดตาม",
  T_49_META_TYP_34_I217_D: "การ์ดสาวบ้า",
  T_49_META_TYP_34_I218_D: "รันสปีดอัพการ์ด",
  T_49_META_TYP_34_I219_D: "การ์ดซานติโน",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "การ์ดคนร้าย",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "สการ์-ไอ",
  T_49_META_TYP_34_I25_D: "สการ์-ทู",
  T_49_META_TYP_34_I26_D: "สการ์-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "ลูทโล่ฟุตบอล",
  T_49_META_TYP_34_I30_D: "ปืนพลังงานความร้อนสูง",
  T_49_META_TYP_34_I31_D: "ปืนความร้อนสูงเกินไป-I",
  T_49_META_TYP_34_I32_D: "ปืนความร้อนซุปเปอร์ฮีท-II",
  T_49_META_TYP_34_I33_D: "ปืนความร้อนสูง-III",
  T_49_META_TYP_34_I34_D: "พลาสม่า-เอ็กซ์",
  T_49_META_TYP_34_I35_D: "ฮีลลิ่งพิสทอล-วาย",
  T_49_META_TYP_34_I36_D: "ฮีลสไนเปอร์",
  T_49_META_TYP_34_I37_D: "ปืนรักษา",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "GROZA",
  T_49_META_TYP_34_I4_D: "ฟุตบอลน้ำแข็ง",
  T_49_META_TYP_34_I40_D: "GROZA",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "กระทะ",
  T_49_META_TYP_34_I44_D: "มีดพร้า",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "เอ็ม249-เอ็กซ์",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "ไม้เบสบอล",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "ดาบคาทานะ",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "แกตลิ่ง",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "ปืนขอที่ทรงพลัง",
  T_49_META_TYP_34_I71_D: "มีด FF",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "กระสุน 3 นัด 1887",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "เอ็ม82บี",
  T_49_META_TYP_34_I78_D: "เอ็ม82บี",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "นกหัวขวาน",
  T_49_META_TYP_34_I83_D: "เวกเตอร์",
  T_49_META_TYP_34_I84_D: "แม็ก-7",
  T_49_META_TYP_34_I85_D: "แม็ก-7",
  T_49_META_TYP_34_I86_D: "เคียว",
  T_49_META_TYP_34_I87_D: "ค้อน",
  T_49_META_TYP_34_I88_D: "มีดขว้าง (หยิบ)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "ยูเอสพี-2",
  T_49_META_TYP_34_I92_D: "กระเต็น",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "เอ็มพี5-ไอ",
  T_49_META_TYP_34_I95_D: "เอ็ม 60-ไอ",
  T_49_META_TYP_34_I96_D: "วีเอสเอส-ไอ",
  T_49_META_TYP_34_I97_D: "เอ็ม14-ไอ",
  T_49_META_TYP_34_I98_D: "คาร98เค-ไอ",
  T_49_META_TYP_34_I99_D: "เอดับบลิวเอ็ม_วาย",
  T_49_META_TYP_340_I0_D: "ง่าย",
  T_49_META_TYP_340_I1_D: "เรียบง่าย",
  T_49_META_TYP_340_I2_D: "ปกติ",
  T_49_META_TYP_340_I3_D: "ปานกลาง",
  T_49_META_TYP_340_I4_D: "ยาก",
  T_49_META_TYP_340_I5_D: "นรก",
  T_49_META_TYP_342_I0_D: "เริ่มกิจกรรม",
  T_49_META_TYP_342_I1_D: "หยุดกิจกรรม",
  T_49_META_TYP_342_I2_D: "หยุดกิจกรรมชั่วคราว",
  T_49_META_TYP_342_I3_D: "ต้องรอหลังจากสร้างเสร็จเพื่อเริ่มจับเวลากี่มิลลิวินาที",
  T_49_META_TYP_342_I4_D: "จำนวนรอบ",
  T_49_META_TYP_342_I5_D: "กิจกรรม",
  T_49_META_TYP_342_I6_D: "นับถอยหลัง หรือ นับถอยหลัง",
  T_49_META_TYP_342_I7_D: "สถานะผู้เล่น",
  T_49_META_TYP_342_I8_D: "เวลาสิ้นสุดของการจับเวลาเป็นวินาที",
  T_49_META_TYP_345_I10_D: "ปืนใหญ่",
  T_49_META_TYP_345_I12_D: "ปืนกำแพงน้ำแข็ง",
  T_49_META_TYP_345_I13_D: "Flamethrower",
  T_49_META_TYP_345_I4_D: "ปืนลูกซอง",
  T_49_META_TYP_345_I6_D: "ปืนพิเศษ",
  T_49_META_TYP_345_I8_D: "ปืนชาร์จ",
  T_49_META_TYP_346_I0_D: "กระสุนไรเฟิล",
  T_49_META_TYP_346_I1_D: "กระสุนปืนพก",
  T_49_META_TYP_346_I2_D: "กระสุนไรเฟิลซุ่มยิง",
  T_49_META_TYP_346_I3_D: "กระสุนปืนลูกซอง",
  T_49_META_TYP_346_I4_D: "กระสุนปืนกลเบา",
  T_49_META_TYP_346_I5_D: "ลูกศร",
  T_49_META_TYP_346_I6_D: "ระเบิดM79",
  T_49_META_TYP_346_I7_D: "ตะขอ",
  T_49_META_TYP_346_I8_D: "M79 ระเบิดเฉพาะทาง",
  T_49_META_TYP_347_I3_D: "หากเป็นจริง สามารถรวมกับการเคลื่อนที่สัมพันธ์ได้ หากเป็นเท็จ จะต้องรวมกับการเคลื่อนที่สัมบูรณ์ มิฉะนั้น คุณสมบัติจะไม่ทำงานอย่างถูกต้อง",
  T_49_META_TYP_347_I6_D: "ค่าเดลต้า",
  T_49_META_TYP_350_I0_D: "รถสปอร์ต",
  T_49_META_TYP_350_I1_D: "รถมอเตอร์ไซค์",
  T_49_META_TYP_350_I2_D: "รถจี๊ป",
  T_49_META_TYP_350_I3_D: "รถเอสยูวี",
  T_49_META_TYP_350_I4_D: "รถบรรทุกมอนสเตอร์",
  T_49_META_TYP_350_I5_D: "ตุ๊กตุ๊ก",
  T_49_META_TYP_352_I1_D: "ยกเลิกการเลือกรูปภาพ",
  T_49_META_TYP_352_I2_D: "ไม่ได้เลือกประเภทภาพ",
  T_49_META_TYP_352_I3_D: "ยกเลิกการเลือกสี",
  T_49_META_TYP_352_I4_D: "รูปภาพที่เลือก",
  T_49_META_TYP_352_I5_D: "เลือกประเภทภาพ",
  T_49_META_TYP_352_I6_D: "สีที่เลือก",
  T_49_META_TYP_353_I0_D: "ปริมาณการฟื้นคืนของพลังชีวิต",
  T_49_META_TYP_353_I1_D: "ความเร็วการฟื้นคืนของพลังชีวิต (มิลลิวินาที)",
  T_49_META_TYP_353_I2_D: "เวลาที่ต้องการใช้ (มิลลิวินาที)",
  T_49_META_TYP_354_I0_D: "ปริมาณการฟื้นตัวของพลังงาน",
  T_49_META_TYP_355_I0_D: "ปริมาณการฟื้นคืนของพลังชีวิต",
  T_49_META_TYP_355_I1_D: "ปริมาณการฟื้นตัวของพลังงาน",
  T_49_META_TYP_355_I2_D: "เวลาที่ต้องการใช้ (มิลลิวินาที)",
  T_49_META_TYP_356_I0_D: "ไอเทมที่ดรอป",
  T_49_META_TYP_356_I1_D: "เวลาการดรอปกล่อง Airdrop มิลลิวินาที",
  T_49_META_TYP_356_I2_D: "สถานะแอร์ดรอป",
  T_49_META_TYP_357_I0_D: "พื้นผิว",
  T_49_META_TYP_357_I1_D: "เขตแดน",
  T_49_META_TYP_359_I0_D: "ไม่ว่าจะใช้ตัวควบคุมผู้เล่นกับฟิสิกส์หรือไม่",
  T_49_META_TYP_359_I1_D: "หากวางบนทางลาดเกินมุมนี้ จะไถลลง",
  T_49_META_TYP_359_I10_D: "ความเร่งโน้มถ่วงนี้ใช้ได้กับตัวควบคุมผู้เล่นเท่านั้น",
  T_49_META_TYP_359_I11_D: "มวล, กก.",
  T_49_META_TYP_359_I12_D: "หากความลาดชันเกินกว่าระดับความลาดชันสูงสุดในการขึ้นเขาก็จะไถลลง",
  T_49_META_TYP_359_I16_D: "หลังจากเปิดแล้ว ไพรมิทีฟหรือสคริปต์ฝั่งเซิร์ฟเวอร์จะควบคุมการเคลื่อนไหว",
  T_49_META_TYP_359_I17_D: "เมื่อเปิดใช้งาน แรงที่ตัวละครใช้เมื่อดันวัตถุแข็งสามารถปรับแต่งได้",
  T_49_META_TYP_359_I18_D: "ปริมาณแรงที่ใช้เมื่อตัวละครผลักวัตถุแข็ง",
  T_49_META_TYP_359_I19_D: "เป็นจริงเมื่อส่วนล่างสัมผัสกับเครื่องชน โดยทั่วไปใช้เพื่อกำหนดว่าผู้เล่นอยู่บนพื้นหรือไม่",
  T_49_META_TYP_359_I2_D: "สิ่งกีดขวางที่เกินความสูงนี้เท่านั้นที่จะสามารถบล็อกได้ ช่วงค่าคือ [0, ความสูง]",
  T_49_META_TYP_359_I20_D: "ระดับกายภาพที่กำหนดเอง ค่า [0,15]",
  T_49_META_TYP_359_I21_D: "เปิดการหมุนด้วยแรงโน้มถ่วง",
  T_49_META_TYP_359_I3_D: "ความลึกของแคปซูลที่สามารถฝังได้ มันสามารถป้องกันไม่ให้ตัวละครติดหรือสั่นไหวได้ ไม่แนะนำให้ดัดแปลงเว้นแต่จะมีความจำเป็นพิเศษ ช่วงค่า (0, รัศมี]",
  T_49_META_TYP_359_I4_D: "ระยะเคลื่อนที่ขั้นต่ำ การเคลื่อนที่ที่มีขนาดเล็กกว่าค่านี้จะไม่ถูกดำเนินการ หากไม่มีความจำเป็นพิเศษแนะนำให้เก็บไว้เป็น 0",
  T_49_META_TYP_359_I5_D: "ออฟเซ็ตของศูนย์กลางกล่องการชนจากจุดกำเนิดพิกัดท้องถิ่น",
  T_49_META_TYP_359_I6_D: "รัศมีแคปซูลค่าต่ำสุด 0.01",
  T_49_META_TYP_359_I7_D: "ความสูงรวมของแคปซูลรวมทั้งซีกบนและซีกล่างโดยมีค่าต่ำสุด 2*รัศมี",
  T_49_META_TYP_359_I8_D: "ความเร็วเชิงเส้นปัจจุบันเป็นเมตรต่อวินาที",
  T_49_META_TYP_360_I0_D: "มุมโค้งการยิงด้านซ้าย",
  T_49_META_TYP_360_I1_D: "มุมโค้งการยิงด้านขวา",
  T_49_META_TYP_360_I2_D: "มุมเงยขั้นต่ำ",
  T_49_META_TYP_360_I3_D: "มุมมองลงสูงสุด",
  T_49_META_TYP_360_I4_D: "ความเร็วปากกระบอกปืน",
  T_49_META_TYP_362_I0_D: "ระยะเวลาการแช่แข็งหลังจากตีผู้เล่นเป็นวินาที",
  T_49_META_TYP_363_I0_D: "ปิดใช้งานการร้องขอการซื้อ HUD",
  T_49_META_TYP_363_I1_D: "ขอความช่วยเหลือจากทีมงานในการจัดซื้อ",
  T_49_META_TYP_363_I2_D: "ขอความช่วยเหลือจากฝ่ายจัดซื้อ",
  T_49_META_TYP_364_I0_D: "จุดศูนย์กลางไหม",
  T_49_META_TYP_364_I1_D: "ไม่ว่าจะวนซ้ำ",
  T_49_META_TYP_364_I2_D: "ชื่อแอนิเมชั่น",
  T_49_META_TYP_364_I3_D: "ไม่ว่าจะเล่นอัตโนมัติหรือไม่",
  T_49_META_TYP_364_I4_D: "ใช้ทรัพยากรที่กำหนดเอง",
  T_49_META_TYP_366_I0_D: "ระบุ UUID ของทรัพยากรแบตช์ที่จะถูกเรนเดอร์",
  T_49_META_TYP_367_I1_D: "แสดงแท็ก",
  T_49_META_TYP_367_I2_D: "รูปแบบไอคอนสำหรับการทำเครื่องหมายเป้าหมาย",
  T_49_META_TYP_367_I3_D: "สีซ้อนทับของไอคอนที่แสดงเมื่อทำเครื่องหมายเป้าหมาย",
  T_49_META_TYP_367_I4_D: "รูปแบบไอคอนที่แสดงบนมาตราส่วน",
  T_49_META_TYP_367_I5_D: "สีไอคอนซ้อนทับที่แสดงบนมาตราส่วน",
  T_49_META_TYP_367_I6_D: "แสดงมาร์คเสมอ",
  T_49_META_TYP_370_I0_D: "หัวข้อหลัก",
  T_49_META_TYP_370_I1_D: "คำบรรยาย",
  T_49_META_TYP_370_I2_D: "สีพื้นหลังด้านบน",
  T_49_META_TYP_370_I3_D: "สีพื้นหลังด้านล่าง",
  T_49_META_TYP_371_I2_D: "คะแนนทางด้านซ้าย",
  T_49_META_TYP_371_I3_D: "คะแนนทางด้านขวา",
  T_49_META_TYP_371_I4_D: "คะแนนสุดท้ายทางด้านซ้าย ใช้สำหรับเล่นแอนิเมชั่นสลับคะแนน",
  T_49_META_TYP_371_I5_D: "คะแนนสุดท้ายทางด้านขวาใช้สำหรับเล่นแอนิเมชั่นสลับคะแนน",
  T_49_META_TYP_372_I0_D: "ยืน",
  T_49_META_TYP_372_I1_D: "แสดงหมอบ",
  T_49_META_TYP_372_I10_D: "การตกจากที่สูง",
  T_49_META_TYP_372_I11_D: "การตกจากที่สูง เช่น การกระโดด",
  T_49_META_TYP_372_I12_D: "รองเท้าบิน",
  T_49_META_TYP_372_I13_D: "กระโดดสองครั้ง",
  T_49_META_TYP_372_I14_D: "นั่งบนเก้าอี้",
  T_49_META_TYP_372_I15_D: "ถูกดีดตัวออกด้วยเครื่องดีด",
  T_49_META_TYP_372_I16_D: "ขั้นตอนการเตรียมเครื่องดีด",
  T_49_META_TYP_372_I17_D: "อุปกรณ์ร่อนร่อน",
  T_49_META_TYP_372_I18_D: "ใบพัดลอยตัว",
  T_49_META_TYP_372_I19_D: "โดนยางเด้ง",
  T_49_META_TYP_372_I2_D: "วิ่ง",
  T_49_META_TYP_372_I20_D: "ถูกยางรถมนุษย์กระแทก",
  T_49_META_TYP_372_I21_D: "การดำเนินการในพื้นที่ปาร์ตี้",
  T_49_META_TYP_372_I22_D: "ขึ้นเครื่องบิน",
  T_49_META_TYP_372_I23_D: "เข้าสู่ปืนใหญ่",
  T_49_META_TYP_372_I24_D: "เมื่อออกจากปืนใหญ่ ยานพาหนะ ฯลฯ หากวัตถุที่คุณกำลังขับอยู่กำลังบินอยู่ นี่คือสถานะ",
  T_49_META_TYP_372_I25_D: "หลังกระโดดจากสปริงบอร์ด",
  T_49_META_TYP_372_I26_D: "ลงจากซิปไลน์",
  T_49_META_TYP_372_I27_D: "ไม่ได้ใช้",
  T_49_META_TYP_372_I3_D: "คลาน",
  T_49_META_TYP_372_I4_D: "ว่ายน้ำเร็ว",
  T_49_META_TYP_372_I5_D: "หยดแนวตั้ง",
  T_49_META_TYP_372_I6_D: "ข้ามกำแพง",
  T_49_META_TYP_372_I7_D: "ไม่ได้ใช้",
  T_49_META_TYP_372_I8_D: "ล้มลงแต่ไม่ตาย",
  T_49_META_TYP_372_I9_D: "ใช้กระดานน้ำ",
  T_49_META_TYP_374_I0_D: "สุขภาพ ระดับ และสีเส้น",
  T_49_META_TYP_374_I1_D: "เมื่อสุขภาพลดลง ส่วนที่หายไปจะแสดงสีนี้เป็นเวลาสั้นๆ",
  T_49_META_TYP_374_I10_D: "ออฟเซ็ตสัมพันธ์กับเป้าหมายที่จะติดตาม",
  T_49_META_TYP_374_I11_D: "ค่าสุขภาพระหว่างเส้นแบ่งแต่ละเส้นจะไม่ปรากฏถ้าค่ามีค่าน้อยกว่าหรือเท่ากับ 0",
  T_49_META_TYP_374_I12_D: "พลังชีวิตทั้งหมด",
  T_49_META_TYP_374_I13_D: "พลังชีวิตปัจจุบัน",
  T_49_META_TYP_374_I14_D: "เมื่อเปิดใช้งาน การเปลี่ยนแปลงด้านสุขภาพจะแสดงเป็นสีต่างๆ",
  T_49_META_TYP_374_I15_D: "เมื่อเปิดใช้งาน คุณสมบัติออฟเซ็ตจะถูกแปลงเป็นพิกัดโลกโดยใช้ระบบพิกัดท้องถิ่น",
  T_49_META_TYP_374_I2_D: "เมื่อสุขภาพเพิ่มขึ้น ส่วนที่เพิ่มขึ้นจะแสดงสีนี้เป็นเวลาสั้นๆ",
  T_49_META_TYP_374_I3_D: "สีของขอบสุขภาพและด้านล่างเบลอ",
  T_49_META_TYP_374_I4_D: "ช่วง 0~1 ความโปร่งใสของ UI โดยรวม",
  T_49_META_TYP_374_I5_D: "กำหนดขนาด UI โดยรวมและแบบอักษรจะถูกปรับขนาดร่วมกัน",
  T_49_META_TYP_374_I6_D: "ระบุชื่อเจ้าของแถบสุขภาพปัจจุบัน",
  T_49_META_TYP_374_I8_D: "ความยาวของแถบสุขภาพที่แสดงบนหน้าจอ",
  T_49_META_TYP_374_I9_D: "จะต้องติดตามเอนทิตีที่มีส่วนประกอบการแปลง",
  T_49_META_TYP_375_I1_D: "สิ่งมีชีวิตแห่งการต่อสู้",
  T_49_META_TYP_376_I1_D: "สิ่งมีชีวิตแห่งการต่อสู้",
  T_49_META_TYP_38_I0_D: "ค่าความโปร่งใส",
  T_49_META_TYP_382_I0_D: "ค่าเริ่มต้น",
  T_49_META_TYP_382_I1_D: "ข้ามสถานะน็อคดาวน์และตายทันที",
  T_49_META_TYP_382_I2_D: "ไม่มีการข้ามน็อคดาวน์",
  T_49_META_TYP_387_I1_D: "อนุญาตให้กดด้านนอก",
  T_49_META_TYP_389_I0_D: "ค่าเริ่มต้นของฐาน",
  T_49_META_TYP_389_I1_D: "สไปรท์พื้นหลัง",
  T_49_META_TYP_389_I10_D: "ไม่ได้เปิดใช้งานความโปร่งใส",
  T_49_META_TYP_389_I2_D: "รัศมีพื้นหลัง",
  T_49_META_TYP_389_I3_D: "ขอบเขตภาพจอยสติ๊ก",
  T_49_META_TYP_389_I4_D: "ขอบเขตรัศมีจอยสติ๊ก",
  T_49_META_TYP_389_I5_D: "รัศมีขอบเขตการลากสูงสุดของจอยสติ๊ก",
  T_49_META_TYP_389_I6_D: "ภาพลูกศร",
  T_49_META_TYP_389_I7_D: "ขนาดลูกศร",
  T_49_META_TYP_389_I8_D: "ออฟเซตลูกศร",
  T_49_META_TYP_389_I9_D: "เปิดใช้งานความโปร่งใส",
  T_49_META_TYP_39_I1_D: "รูปร่างของภาพ",
  T_49_META_TYP_39_I10_D: "ไล่สีจากด้านบน",
  T_49_META_TYP_39_I11_D: "ไล่สีจากด้านล่าง",
  T_49_META_TYP_39_I12_D: "ความโปร่งใสสูงสุด",
  T_49_META_TYP_39_I13_D: "ความโปร่งใสด้านล่าง",
  T_49_META_TYP_39_I3_D: "พลิก",
  T_49_META_TYP_39_I4_D: "เติมเต็ม",
  T_49_META_TYP_39_I5_D: "ศูนย์กลางล่องหน",
  T_49_META_TYP_39_I6_D: "เติมทิศทาง",
  T_49_META_TYP_39_I7_D: "เติมค่า",
  T_49_META_TYP_39_I8_D: "สลับการเติม",
  T_49_META_TYP_39_I9_D: "การไล่ระดับสี",
  T_49_META_TYP_392_I0_D: "เวลาที่โซนปลอดภัยปรากฏขึ้นในแต่ละรอบในเกมค่าเริ่มต้นคือ 0 หน่วยเป็นมิลลิวินาที",
  T_49_META_TYP_392_I1_D: "เวลาที่ใช้ในการย่อวงกลมเป็นมิลลิวินาที",
  T_49_META_TYP_392_I10_D: "เวลาสิ้นสุดของวงกลมหดตัวเป็นมิลลิวินาที",
  T_49_META_TYP_392_I12_D: "รัศมีปลายวงพิษ",
  T_49_META_TYP_392_I13_D: "เวลาเริ่มของการหดเล็กลง",
  T_49_META_TYP_392_I14_D: "ช่วงเวลาความเสียหาย (มิลลิวินาที)",
  T_49_META_TYP_392_I3_D: "จำนวนความเสียหายที่เกิดขึ้นกับผู้เล่นในวงกลมพิษ",
  T_49_META_TYP_392_I4_D: "รายชื่อผู้เล่นในโซนปลอดภัย",
  T_49_META_TYP_392_I5_D: "เวลาการหายตัวไปของโซนปลอดภัย หากเวลาการหายตัวไปของโซนปลอดภัยน้อยกว่าเวลาที่มีผลบังคับใช้ โซนปลอดภัยจะไม่เกิดขึ้น",
  T_49_META_TYP_392_I6_D: "รหัสกลุ่ม",
  T_49_META_TYP_392_I7_D: "รัศมีเริ่มต้นของวงพิษ",
  T_49_META_TYP_392_I8_D: "สถานะสิ้นสุด",
  T_49_META_TYP_392_I9_D: "สถานภาพ",
  T_49_META_TYP_394_I0_D: "มีค่าประมาณ 3.1416",
  T_49_META_TYP_394_I1_D: "มีค่าประมาณ 2.7183",
  T_49_META_TYP_396_I0_D: "หัวเรื่อง",
  T_49_META_TYP_396_I1_D: "เนื้อหา",
  T_49_META_TYP_396_I2_D: "ตัวเลือก",
  T_49_META_TYP_396_I3_D: "แสดงพื้นหลัง",
  T_49_META_TYP_399_I0_D: "ความสูงของกระโดด",
  T_49_META_TYP_399_I1_D: "จำนวนครั้งที่กระโดดติดต่อกันได้ก่อนจะลงจอด",
  T_49_META_TYP_399_I2_D: "คุณสามารถกระโดดหลายครั้งก่อนที่จะลงจอด",
  T_49_META_TYP_399_I3_D: "เปิดการเคลื่อนที่กลางอากาศ",
  T_49_META_TYP_40_I1_D: "ฉลาก",
  T_49_META_TYP_40_I10_D: "ระยะห่างระหว่างเส้น",
  T_49_META_TYP_40_I11_D: "วิธีการล้น",
  T_49_META_TYP_40_I12_D: "สไตล์ตัวอักษร",
  T_49_META_TYP_40_I13_D: "ใช้เงาไหม",
  T_49_META_TYP_40_I14_D: "สีเงา",
  T_49_META_TYP_40_I15_D: "ออฟเซตเงา",
  T_49_META_TYP_40_I3_D: "คีย์การแปล สามารถใช้งานได้หลายภาษา",
  T_49_META_TYP_40_I5_D: "การจัดตำแหน่ง",
  T_49_META_TYP_40_I6_D: "การจัดแนวแนวตั้ง",
  T_49_META_TYP_40_I7_D: "ตัวหนา",
  T_49_META_TYP_40_I8_D: "ตัวเอียงไหม",
  T_49_META_TYP_40_I9_D: "ขีดเส้นใต้ไหม",
  T_49_META_TYP_400_I0_D: "เปิดใช้งาน",
  T_49_META_TYP_400_I1_D: "พาสซีฟ",
  T_49_META_TYP_400_I2_D: "ไม่มีการโจมตี",
  T_49_META_TYP_401_I0_D: "ไม่สามารถยิงได้",
  T_49_META_TYP_401_I1_D: "สามารถยิงได้อย่างต่อเนื่อง",
  T_49_META_TYP_401_I2_D: "ยิงหนึ่งครั้งต่อคำสั่งโจมตี",
  T_49_META_TYP_401_I3_D: "คำสั่งโจมตีแต่ละครั้งจะยิงสามครั้ง",
  T_49_META_TYP_401_I4_D: "คำสั่งโจมตีแต่ละครั้งจะยิงสองครั้ง",
  T_49_META_TYP_401_I5_D: "กระสุนปืน",
  T_49_META_TYP_402_I0_D: "เป้าหมายที่จะเพิ่มเป็นเพื่อน",
  T_49_META_TYP_402_I1_D: "ประเภทฟังก์ชัน",
  T_49_META_TYP_402_I2_D: "สไตล์",
  T_49_META_TYP_403_I0_D: "เพิ่มเพื่อน",
  T_49_META_TYP_403_I1_D: "รายงาน",
  T_49_META_TYP_404_I0_D: "สว่าง",
  T_49_META_TYP_404_I1_D: "มืด",
  T_49_META_TYP_405_I0_D: "ตามลำดับขั้น (Hierarchy)",
  T_49_META_TYP_405_I1_D: "ตามลำดับความสำคัญจากสูงไปต่ำ",
  T_49_META_TYP_405_I2_D: "ตามลำดับความสำคัญจากต่ำไปสูง",
  T_49_META_TYP_406_I0_D: "ควบคุมระยะทางของการกระโดดของผู้เล่น",
  T_49_META_TYP_406_I1_D: "ควบคุมความสูงของร่างกายผู้เล่นขณะปีนขึ้นและลง",
  T_49_META_TYP_407_I0_D: "ท้องถิ่น(Local)",
  T_49_META_TYP_407_I1_D: "ลูกค้า",
  T_49_META_TYP_407_I2_D: "เซิร์ฟเวอร์",
  T_49_META_TYP_407_I3_D: "ทั้งสอง",
  T_49_META_TYP_409_I0_D: "ไม่มีข้อผิดพลาด",
  T_49_META_TYP_409_I1_D: "การหมดเวลาการจัดเก็บข้อมูล ส่วนใหญ่ใช้สำหรับการดำเนินการอ่าน",
  T_49_META_TYP_409_I10_D: "การเปลี่ยนทีมล้มเหลว - ทีมเป้าหมายไม่ถูกต้อง",
  T_49_META_TYP_409_I11_D: "การเปลี่ยนทีมล้มเหลว - ผู้เล่นที่เสียชีวิตไม่สามารถเปลี่ยนทีมได้",
  T_49_META_TYP_409_I12_D: "การเปลี่ยนทีมล้มเหลว - ไม่อนุญาตให้เปลี่ยนทีมในยานพาหนะ",
  T_49_META_TYP_409_I2_D: "ความถี่การอ่านและเขียนที่เก็บข้อมูลเกินขีดจำกัด",
  T_49_META_TYP_409_I3_D: "ความผิดปกติของพารามิเตอร์",
  T_49_META_TYP_409_I4_D: "สร้างห้องไม่สำเร็จ: ไม่มี PersonaID ที่ถูกต้อง",
  T_49_META_TYP_409_I5_D: "สถานะข้อผิดพลาดไม่ชัดเจน",
  T_49_META_TYP_409_I6_D: "บริการเชิงพาณิชย์ถูกปิดและผู้ใช้ไม่สามารถใช้บริการของผู้พัฒนาได้อีกต่อไป",
  T_49_META_TYP_409_I7_D: "การเปลี่ยนทีมล้มเหลว - โหมดไม่ได้รับการรองรับ",
  T_49_META_TYP_409_I8_D: "การเปลี่ยนทีมล้มเหลว - ขณะนี้อยู่ในทีมเป้าหมายแล้ว",
  T_49_META_TYP_409_I9_D: "การเปลี่ยนทีมล้มเหลว - วัตถุไม่ถูกต้อง",
  T_49_META_TYP_41_I0_D: "รูปร่างของภาพ",
  T_49_META_TYP_41_I19_D: "ปิดใช้งานกล่องชน",
  T_49_META_TYP_41_I3_D: "ปิดสี",
  T_49_META_TYP_41_I4_D: "กดสี",
  T_49_META_TYP_41_I5_D: "เติมประเภท",
  T_49_META_TYP_41_I6_D: "มันเป็นปุ่ม FE ไหม",
  T_49_META_TYP_41_I7_D: "กดรูปภาพ",
  T_49_META_TYP_41_I8_D: "กดประเภทภาพ",
  T_49_META_TYP_41_I9_D: "ประเภทพลิก",
  T_49_META_TYP_411_I0_D: "ความเร็วเดินหน้า",
  T_49_META_TYP_411_I1_D: "ความเร็วถอยหลัง",
  T_49_META_TYP_411_I2_D: "ความเร็วเพิ่มขึ้น",
  T_49_META_TYP_411_I3_D: "ความเร็วลง",
  T_49_META_TYP_411_I4_D: "ความเสียหายการระเบิดสูงสุด",
  T_49_META_TYP_411_I5_D: "ความเสียหายการระเบิดสูงสุด",
  T_49_META_TYP_411_I6_D: "ระยะการระเบิด",
  T_49_META_TYP_412_I0_D: "ปริมาณแรงม้าที่รถได้รับเมื่อใช้ปุ่มคันเร่ง",
  T_49_META_TYP_412_I1_D: "ปริมาณแรงม้าที่รถได้รับเมื่อใช้ปุ่มถอยหลัง/เบรก",
  T_49_META_TYP_412_I2_D: "ที่ความเร็วสูง มุมเลี้ยวสูงสุด",
  T_49_META_TYP_412_I3_D: "เกณฑ์ความเร็วสำหรับการใช้งานมุมเลี้ยวสูงสุดที่ความเร็วสูง",
  T_49_META_TYP_412_I4_D: "เมื่อถึงความเร็วสูงสุดแล้ว รถจะไม่ส่งแรงม้าเพิ่ม แต่รถอาจจะขับเกินความเร็วสูงสุดนี้ได้ (เช่น ลงเขา)",
  T_49_META_TYP_412_I5_D: "เมื่อไม่ได้ควบคุมรถ รถจะลดความเร็วลงโดยคูณ IdleBrakeInput ด้วย BrakeTorque",
  T_49_META_TYP_412_I6_D: "ใช้ในการคำนวณความเสียหายจากการตีคน โดยใช้พารามิเตอร์ของสูตรความเสียหาย",
  T_49_META_TYP_412_I7_D: "ใช้เพื่อคำนวณความเสียหายจากการตีคน เมื่อเกินความเร็วนี้แล้วความเสียหายจะไม่เพิ่มขึ้น",
  T_49_META_TYP_412_I8_D: "ใช้เพื่อคำนวณความเสียหายจากการชน ความเสียหายขั้นต่ำ",
  T_49_META_TYP_412_I9_D: "ใช้สำหรับคำนวณความเสียหายจากการชน ความเสียหายสูงสุด",
  T_49_META_TYP_413_I0_D: "เสื้อผ้าที่เปลี่ยนรูปร่างของผู้เล่น (NPC)",
  T_49_META_TYP_414_I1_D: "ช่วงกว้าง",
  T_49_META_TYP_415_I0_D: "รหัสเพอโซน่า",
  T_49_META_TYP_415_I1_D: "ชื่อเล่น",
  T_49_META_TYP_415_I2_D: "อวตาร",
  T_49_META_TYP_416_I1_D: "ตัวตนที่ถูกผูกมัด",
  T_49_META_TYP_416_I2_D: "ออฟเซ็ต",
  T_49_META_TYP_416_I3_D: "ความสูง",
  T_49_META_TYP_416_I4_D: "ว่าจะตอบกลับข้อความระบบหรือไม่",
  T_49_META_TYP_416_I5_D: "ชื่อเล่นตัวละคร",
  T_49_META_TYP_416_I6_D: "เพอร์โซน่าอวาตาร์",
  T_49_META_TYP_416_I7_D: "ชื่อเล่นของผู้ใช้",
  T_49_META_TYP_416_I8_D: "รูปประจำตัวผู้ใช้",
  T_49_META_TYP_417_I0_D: "รหัสทรัพยากร",
  T_49_META_TYP_418_I0_D: "วันหมดอายุสมาชิก",
  T_49_META_TYP_418_I1_D: "สมัครสมาชิก",
  T_49_META_TYP_418_I2_D: "การต่ออายุสมาชิก",
  T_49_META_TYP_42_I0_D: "ข้อความตั้งต้น",
  T_49_META_TYP_42_I1_D: "เปิดใช้งานเนื้อหาข้อความ",
  T_49_META_TYP_42_I10_D: "ความยาวสูงสุดของการกระโดด",
  T_49_META_TYP_42_I14_D: "กดสี",
  T_49_META_TYP_42_I16_D: "คีย์การแปล สามารถใช้งานได้หลายภาษา",
  T_49_META_TYP_42_I3_D: "การจัดตำแหน่ง",
  T_49_META_TYP_42_I4_D: "การจัดแนวแนวตั้ง",
  T_49_META_TYP_42_I5_D: "ตัวหนา",
  T_49_META_TYP_42_I6_D: "ตัวเอียงไหม",
  T_49_META_TYP_42_I7_D: "ขีดเส้นใต้ไหม",
  T_49_META_TYP_42_I8_D: "ระยะห่างระหว่างเส้น",
  T_49_META_TYP_42_I9_D: "การตัดบรรทัดอัตโนมัติ",
  T_49_META_TYP_424_I0_D: "เอฟเฟกต์หมอกเชิงเส้น",
  T_49_META_TYP_424_I1_D: "เอฟเฟกต์หมอกดัชนี",
  T_49_META_TYP_424_I2_D: "เอฟเฟกต์หมอกสี่เหลี่ยมเอ็กซ์โพเนนเชียล",
  T_49_META_TYP_426_I0_D: "ความเข้ม",
  T_49_META_TYP_426_I1_D: "ช่วงแสง",
  T_49_META_TYP_426_I2_D: "มุมของโคนสปอตไลท์เป็นองศา",
  T_49_META_TYP_426_I3_D: "สีอ่อน",
  T_49_META_TYP_428_I0_D: "รหัสสกินปืน",
  T_49_META_TYP_428_I2_D: "ตั้งค่า ID",
  T_49_META_TYP_428_I3_D: "รหัสเครื่องประดับศีรษะ",
  T_49_META_TYP_428_I4_D: "การระบุใบหน้า",
  T_49_META_TYP_428_I5_D: "แต่งหน้า ID",
  T_49_META_TYP_428_I6_D: "รหัสประจำตัวส่วนบนของร่างกาย",
  T_49_META_TYP_428_I7_D: "รหัสประจำตัวส่วนล่างของร่างกาย",
  T_49_META_TYP_428_I8_D: "รหัสรองเท้า",
  T_49_META_TYP_431_I1_D: "เส้นทางการเคลื่อนที่ของเอนทิตี้เป้าหมาย",
  T_49_META_TYP_431_I3_D: "ความเร็วในการเคลื่อนที่ หน่วย: ม./วินาที",
  T_49_META_TYP_431_I4_D: `เมื่อเคลื่อนที่ ควรหันไปตามเส้นสัมผัสของเส้นทางหรือไม่?
ค่าเริ่มต้น: False วัตถุจะคงทิศทางเดิม
หากตั้งค่าเป็น True วัตถุจะหันไปตามทิศทางการเคลื่อนที่บนเส้นทาง`,
  T_49_META_TYP_431_I5_D: "เปอร์เซ็นต์การเล่น",
  T_49_META_TYP_432_I0_D: "มุมม้วนซึ่งส่งผลต่อการหมุนในแนวรัศมีของเส้นทางทั้งสองด้านของจุดนี้",
  T_49_META_TYP_432_I1_D: "ตำแหน่งสัมพันธ์ของจุดควบคุมแทนเจนต์และจุดอ้างอิงจะกำหนดแทนเจนต์ของเส้นทาง",
  T_49_META_TYP_433_I0_D: "แทรกเส้นตรงระหว่างจุดเส้นทาง",
  T_49_META_TYP_433_I1_D: "การสอดแทรกแบบโค้งระหว่างจุดเส้นทางเพื่อการเคลื่อนไหวที่ราบรื่น",
  T_49_META_TYP_433_I2_D: "รองรับการปรับค่าแทนเจนต์ของจุดโค้งด้วยตนเอง",
  T_49_META_TYP_434_I0_D: "ประเภทเส้นทาง",
  T_49_META_TYP_434_I1_D: "ความยาวรวมของเส้นทาง",
  T_49_META_TYP_434_I2_D: "ไม่ว่าจุดเริ่มต้นและจุดสิ้นสุดจะเชื่อมโยงกันหรือไม่",
  T_49_META_TYP_434_I3_D: "การรวบรวมจุดอ้างอิง",
  T_49_META_TYP_437_I3_D: "อาร์เรย์ของผู้เล่นทางด้านซ้าย",
  T_49_META_TYP_437_I4_D: "อาร์เรย์ของผู้เล่นทางด้านขวา",
  T_49_META_TYP_437_I5_D: "อาร์เรย์ของชื่อชนิดอินทิกรัล",
  T_49_META_TYP_437_I6_D: "อาร์เรย์คะแนนทางด้านซ้าย (รายการมิติเดียว: ผู้เล่น; รายการมิติสอง: ข้อมูลคะแนนที่กรอกตามประเภทคะแนนที่กำหนดเอง)",
  T_49_META_TYP_437_I7_D: "อาร์เรย์คะแนนทางด้านขวา (รายการมิติเดียว: ผู้เล่น; รายการมิติสอง: ข้อมูลคะแนนที่กรอกตามประเภทคะแนนที่กำหนดเอง)",
  T_49_META_TYP_438_I1_D: "การจัดกลุ่มผู้เล่นอาร์เรย์",
  T_49_META_TYP_438_I2_D: "การจัดลำดับกลุ่ม",
  T_49_META_TYP_438_I3_D: "อาร์เรย์คะแนนกลุ่ม",
  T_49_META_TYP_438_I4_D: "อาร์เรย์ของชื่อชนิดอินทิกรัล",
  T_49_META_TYP_438_I5_D: "อาร์เรย์สีแบบกลุ่ม",
  T_49_META_TYP_438_I6_D: "อาร์เรย์คะแนนผู้เล่น (ตามลำดับเมื่อไม่ได้จัดกลุ่ม)",
  T_49_META_TYP_442_I1_D: "คะแนนทางด้านซ้าย",
  T_49_META_TYP_442_I10_D: "ไอคอนความตายทางด้านขวา",
  T_49_META_TYP_442_I2_D: "คะแนนทางด้านขวา",
  T_49_META_TYP_442_I3_D: "จำนวนผู้รอดชีวิตด้านซ้าย",
  T_49_META_TYP_442_I4_D: "จำนวนผู้รอดชีวิตด้านขวา",
  T_49_META_TYP_442_I5_D: "ยอดผู้เสียชีวิตฝั่งซ้าย",
  T_49_META_TYP_442_I6_D: "ยอดผู้เสียชีวิตฝั่งขวา",
  T_49_META_TYP_442_I7_D: "ไอคอนการเอาชีวิตรอดอยู่ทางด้านซ้าย",
  T_49_META_TYP_442_I8_D: "ไอคอนการเอาชีวิตรอดทางด้านขวา",
  T_49_META_TYP_442_I9_D: "ไอคอนความตายที่ด้านซ้าย",
  T_49_META_TYP_444_I0_D: "ภาษาอังกฤษ",
  T_49_META_TYP_444_I1_D: "ภาษาจีนตัวย่อ",
  T_49_META_TYP_444_I10_D: "ภาษาฝรั่งเศส",
  T_49_META_TYP_444_I11_D: "เยอรมัน",
  T_49_META_TYP_444_I12_D: "ภาษาตุรกี",
  T_49_META_TYP_444_I13_D: "ภาษาฮินดี",
  T_49_META_TYP_444_I14_D: "ญี่ปุ่น",
  T_49_META_TYP_444_I15_D: "โรมาเนีย",
  T_49_META_TYP_444_I16_D: "ภาษาอาหรับ",
  T_49_META_TYP_444_I17_D: "พม่า",
  T_49_META_TYP_444_I18_D: "อูรดู",
  T_49_META_TYP_444_I19_D: "ภาษาเบงกาลี",
  T_49_META_TYP_444_I2_D: "ภาษาจีนแบบดั้งเดิม",
  T_49_META_TYP_444_I3_D: "แบบไทย",
  T_49_META_TYP_444_I4_D: "เวียดนาม",
  T_49_META_TYP_444_I5_D: "ชาวอินโดนีเซีย",
  T_49_META_TYP_444_I6_D: "โปรตุเกส",
  T_49_META_TYP_444_I7_D: "สเปน",
  T_49_META_TYP_444_I8_D: "รัสเซีย",
  T_49_META_TYP_444_I9_D: "เกาหลี",
  T_49_META_TYP_51_I0_D: "ซอมบี้ธรรมดา",
  T_49_META_TYP_51_I1_D: "ซอมบี้ตัดไม้",
  T_49_META_TYP_51_I10_D: "ระเบิดผึ้งบิน",
  T_49_META_TYP_51_I11_D: "ซอมบี้มังกร",
  T_49_META_TYP_51_I2_D: "ขว้างซอมบี้",
  T_49_META_TYP_51_I3_D: "ซอมบี้ระเบิด",
  T_49_META_TYP_51_I4_D: "ซอมบี้ผเด็จการ",
  T_49_META_TYP_51_I5_D: "ขว้างซอมบี้แดง",
  T_49_META_TYP_51_I6_D: "มิสเตอร์วี",
  T_49_META_TYP_51_I7_D: "ซอมบี้แท้งค์",
  T_49_META_TYP_51_I8_D: "ซอมบี้สว่าน",
  T_49_META_TYP_51_I9_D: "ซามูไร",
  T_49_META_TYP_56_I10_D: "ความล่าช้าในการระเบิด",
  T_49_META_TYP_56_I11_D: "ระยะการระเบิด",
  T_49_META_TYP_56_I12_D: "ความเสียหายจากการระเบิด",
  T_49_META_TYP_56_I13_D: "เวลาการเผาไหม้",
  T_49_META_TYP_56_I14_D: "ความเสียหายจากการเผาไหม้",
  T_49_META_TYP_56_I15_D: "ช่วงเวลาความเสียหายจากการเผาไหม้",
  T_49_META_TYP_56_I17_D: "พนักงานขับรถ",
  T_49_META_TYP_56_I18_D: "ผู้โดยสารทุกคนบนเรือ",
  T_49_META_TYP_56_I19_D: "รหัสสกินยานพาหนะ",
  T_49_META_TYP_56_I20_D: "การกำหนดค่าผู้เล่นมีความสำคัญ",
  T_49_META_TYP_56_I21_D: "ปริมาณพลังชีวิตสูงสุด",
  T_49_META_TYP_56_I22_D: "พลังชีวิต",
  T_49_META_TYP_57_I0_D: "ไม่ว่าจะโอนด้วยตนเองหรืออัตโนมัติ (ด้วยตนเองตามค่าเริ่มต้น)",
  T_49_META_TYP_58_I0_D: "สร้างประเภท BUFF",
  T_49_META_TYP_58_I1_D: "เวลาตั้งแต่เมื่อหยิบ BUFF ขึ้นมาจนกระทั่งสร้าง BUFF ครั้งต่อไป เป็นวินาที",
  T_49_META_TYP_59_I0_D: "ประเภทการเคลื่อนไหว",
  T_49_META_TYP_59_I1_D: "การเคลื่อนไหวในทิศทางแกน X",
  T_49_META_TYP_59_I2_D: "การเคลื่อนไหวในทิศทางแกน Y",
  T_49_META_TYP_59_I3_D: "การเคลื่อนไหวในทิศทางแกน Z",
  T_49_META_TYP_59_I4_D: "ระยะเวลาการเคลื่อนไหว",
  T_49_META_TYP_59_I5_D: "ระยะเวลาหยุด",
  T_49_META_TYP_59_I6_D: "ปิดการเคลื่อนไหวแบบลูกสูบ",
  T_49_META_TYP_60_I0_D: "ปล้นคะแนนอาวุธ",
  T_49_META_TYP_61_I0_D: "ผูกเอนทิตีร้านค้า",
  T_49_META_TYP_61_I1_D: "ตั้งค่าช่วงการทริกเกอร์",
  T_49_META_TYP_61_I2_D: "การมองเห็นโมเดล",
  T_49_META_TYP_62_I0_D: "ความเร็วแกน XZ",
  T_49_META_TYP_62_I1_D: "ความเร็วแกน Y",
  T_49_META_TYP_64_I0_D: "ประเภทส่วนประกอบของดนตรี",
  T_49_META_TYP_66_I0_D: "ID อินสแตนซ์",
  T_49_META_TYP_66_I1_D: "จุดเส้นทาง",
  T_49_META_TYP_68_I0_D: "สุขภาพของ AI ในปัจจุบัน",
  T_49_META_TYP_68_I1_D: "สุขภาพสูงสุดของ AI ในปัจจุบัน",
  T_49_META_TYP_68_I10_D: "เมื่อ AI ตาย จะดรอปอุปกรณ์หรือไอเทมหรือเปล่า?",
  T_49_META_TYP_68_I11_D: "ไม่ว่า AI จะอยู่ในสถานะที่ไม่อาจเอาชนะได้ในปัจจุบันหรือไม่",
  T_49_META_TYP_68_I12_D: "เมื่อได้รับความเสียหาย สามารถลดหรือเพิ่มเปอร์เซ็นต์ความเสียหายได้",
  T_49_META_TYP_68_I13_D: "ประเภทของ AI",
  T_49_META_TYP_68_I14_D: "ไม่ว่าจะค้นหาศัตรูโดยอัตโนมัติ",
  T_49_META_TYP_68_I15_D: "0 หมายถึงโจมตีอัตโนมัติ, 1 หมายถึงโจมตีป้องกัน, 2 หมายถึงไม่โจมตีเลย",
  T_49_META_TYP_68_I16_D: "รหัสเส้นทางของวัตถุ",
  T_49_META_TYP_68_I17_D: "เป้าหมายการไล่ล่า",
  T_49_META_TYP_68_I18_D: "เป้าหมายโจมตี",
  T_49_META_TYP_68_I19_D: "พิกัดจุดเกิดของ AI",
  T_49_META_TYP_68_I2_D: "รับตัวตนของทีมที่ AI เป็นสมาชิกอยู่",
  T_49_META_TYP_68_I20_D: "หมายเลขกลุ่มทีม",
  T_49_META_TYP_68_I4_D: "สามารถแก้ไขได้เฉพาะพลังโจมตีของการโจมตีปกติเท่านั้น และจะไม่นับพลังโจมตีของทักษะ",
  T_49_META_TYP_68_I7_D: "ระยะการเคลื่อนไหวอิสระของ AI คุณสามารถปรับเปลี่ยนค่าพื้นฐานได้เท่านั้น หากมีโบนัสเพิ่มเติม จะถูกเพิ่มตามค่าพื้นฐาน",
  T_49_META_TYP_68_I8_D: "AI ตรวจจับระยะของศัตรูและปรับเปลี่ยนได้เฉพาะค่าพื้นฐานเท่านั้น หากมีโบนัสเพิ่มเติมจะเพิ่มตามค่าที่กำหนด",
  T_49_META_TYP_68_I9_D: "ความเร็วในการเคลื่อนที่จริง หากมีการเร่งความเร็วของทักษะก็จะคูณด้วยความเร็วนั้น",
  T_49_META_TYP_70_I0_D: "ID เอนทิตี้เป้าหมายของสูตร ซึ่งใช้ภายในและไม่ปรากฏให้ผู้เล่นเห็น",
  T_49_META_TYP_70_I1_D: "รหัสแอตทริบิวต์เอนทิตีเป้าหมายของสูตร ซึ่งใช้ภายในและไม่ปรากฏให้ผู้เล่นเห็น",
  T_49_META_TYP_70_I2_D: "ค่าต่ำสุดที่ได้รับอนุญาต",
  T_49_META_TYP_70_I3_D: "ค่าสูงสุดที่ได้รับอนุญาต",
  T_49_META_TYP_70_I4_D: "ค่าสัมประสิทธิ์พื้นฐาน",
  T_49_META_TYP_70_I5_D: "ก่อนการสะสม",
  T_49_META_TYP_70_I6_D: "ตัวคูณ",
  T_49_META_TYP_70_I7_D: "ทวีคูณสะสม",
  T_49_META_TYP_70_I8_D: "หลังการสะสม",
  T_49_META_TYP_71_I0_D: "หมายเลขสินค้า",
  T_49_META_TYP_71_I1_D: "ราคา",
  T_49_META_TYP_71_I10_D: "สามารถซื้อได้ไหม",
  T_49_META_TYP_71_I2_D: "ประเภทของเงิน",
  T_49_META_TYP_71_I3_D: "ขีดจำกัดการซื้อโดยรวม",
  T_49_META_TYP_71_I4_D: "ข้อจำกัดการซื้อโดยรวมในปัจจุบัน",
  T_49_META_TYP_71_I5_D: "ชื่อสินค้า",
  T_49_META_TYP_71_I6_D: "คำอธิบายสินค้า",
  T_49_META_TYP_71_I7_D: "รายการสินค้า",
  T_49_META_TYP_71_I8_D: "จำนวนไอเทม",
  T_49_META_TYP_71_I9_D: "เส้นทางทรัพยากรว่างเปล่าตามค่าเริ่มต้น",
  T_49_META_TYP_72_I1_D: "รายการสินค้า",
  T_49_META_TYP_73_I1_D: "รายการชั้นวาง",
  T_49_META_TYP_74_I0_D: "อาวุธ",
  T_49_META_TYP_74_I1_D: "หมวกนริภัย",
  T_49_META_TYP_74_I2_D: "เสื้อกั๊ก",
  T_49_META_TYP_74_I3_D: "ระเบิดมือ",
  T_49_META_TYP_75_I0_D: "วันเวย์",
  T_49_META_TYP_75_I1_D: "ไปและกลับ",
  T_49_META_TYP_76_I0_D: "ลาดตระเวนเท่านั้น ไม่โจมตีเป้าหมายระหว่างทาง",
  T_49_META_TYP_76_I1_D: "ตระเวนขณะโจมตี",
  T_49_META_TYP_79_I0_D: "พลังโจมตีอาวุธ",
  T_49_META_TYP_79_I1_D: "ระยะโจมตี",
  T_49_META_TYP_79_I10_D: "จำนวนการกระจายของกระสุนตอนเริ่ม",
  T_49_META_TYP_79_I11_D: "รหัสไอเทม",
  T_49_META_TYP_79_I12_D: "ระยะเวลาการรอขั้นต่ำระหว่างการยิง 2 นัดเป็นวินาที การยิงแต่ละนัดอาจยิงกระสุนได้หลายนัดขึ้นอยู่กับประเภทของการยิง",
  T_49_META_TYP_79_I13_D: "ผู้เล่นที่เป็นเจ้าของอาวุธนี้",
  T_49_META_TYP_79_I14_D: "ใช้กระสุนไหม",
  T_49_META_TYP_79_I15_D: "ประเภทการใช้อาวุธคู่ (0: ไม่ถืออาวุธคู่, 1: มีอาวุธคู่, 2: อาวุธใดก็ได้)",
  T_49_META_TYP_79_I16_D: "ค่าสัมประสิทธิ์ความเสียหายของเกราะ",
  T_49_META_TYP_79_I17_D: "ความเร็วในการเคลื่อนที่ของผู้เล่น",
  T_49_META_TYP_79_I18_D: "อัตราความเสียหายจากการโจมตีบริเวณลำตัว",
  T_49_META_TYP_79_I19_D: "อัตราความเสียหายจากการยิงหัว",
  T_49_META_TYP_79_I2_D: "เวลาการรอขั้นต่ำระหว่างกระสุนสองนัดเป็นวินาที",
  T_49_META_TYP_79_I20_D: "อัตราความเสียหายต่อแขนขา",
  T_49_META_TYP_79_I21_D: "อัตราความเสียหายเพิ่มเติม (รถ, กำแพงน้ำแข็งถังน้ำมัน)",
  T_49_META_TYP_79_I22_D: "สามารถมองเห็นได้เมื่ออยู่บนหลัง",
  T_49_META_TYP_79_I23_D: "กระแทกพื้นเพื่อสร้างความเสียหายเพิ่มเติม",
  T_49_META_TYP_79_I24_D: "กระสุนต่อนัด",
  T_49_META_TYP_79_I25_D: "ความเร็วในการโหลดซ้ำ (ความเร็วพื้นฐาน * ค่าสัมประสิทธิ์)",
  T_49_META_TYP_79_I26_D: "นับจำนวนกระสุนปัจจุบัน",
  T_49_META_TYP_79_I27_D: "การระบุสกินปืน",
  T_49_META_TYP_79_I28_D: "เมื่อการกำหนดค่าของผู้เล่นมีความสำคัญ การกำหนดค่าสกินปืนของผู้เล่นจะแทนที่คุณลักษณะสกินปืนของอาวุธนั้นเอง",
  T_49_META_TYP_79_I29_D: "เมื่อเขียนคุณสมบัติของสกินปืนลงบนอาวุธ ค่าพื้นฐานของอาวุธจะได้รับผลกระทบจากสกินปืน",
  T_49_META_TYP_79_I3_D: "ขนาดแม็กกระสุน",
  T_49_META_TYP_79_I30_D: "อัตราการเพิ่มสเปรด (0.1 = การยิงรัวแต่ละครั้งจะเพิ่มเป้าเล็ง 10%)",
  T_49_META_TYP_79_I31_D: "ความเร็วในการฟื้นตัวแบบกระจัดกระจาย",
  T_49_META_TYP_79_I32_D: "ความเร็วของผู้เล่นขณะยิงส่งผลต่อ",
  T_49_META_TYP_79_I33_D: "ขนาดการแพร่กระจายเมื่อเคลื่อนที่ (1.5 = 1.5 * ขนาดฐานของเป้าเล็ง)",
  T_49_META_TYP_79_I34_D: "ประเภทอาวุธ",
  T_49_META_TYP_79_I36_D: "ประเภทไฟ",
  T_49_META_TYP_79_I37_D: "ยิงนัดเดียวไหม",
  T_49_META_TYP_79_I38_D: "เงียบไหม / ใบ้ไหม",
  T_49_META_TYP_79_I39_D: "ความเร็วเคลื่อนที่ขณะเล็งผ่านกล้องปืน",
  T_49_META_TYP_79_I4_D: "จำนวนแม็กเริ่มต้น",
  T_49_META_TYP_79_I5_D: "การเจาะเกราะ",
  T_49_META_TYP_79_I6_D: "ระยะความเสียหายเต็ม",
  T_49_META_TYP_79_I7_D: "ระยะเริ่มต้นความเสียหายขั้นต่ำ",
  T_49_META_TYP_79_I8_D: "ความเสียหายขั้นต่ำ",
  T_49_META_TYP_79_I9_D: "จำนวนกระสุนที่สามารถยิงได้ก่อนเริ่มการกระเจิง",
  T_49_META_TYP_80_I1_D: "เมื่อเป็นจริง การปิดด้วยมือจะถูกห้าม",
  T_49_META_TYP_80_I2_D: "ผูกมัดตัวตนร้านค้า",
  T_49_META_TYP_80_I4_D: "รายชื่อเอนทิตีสกุลเงินที่ถูกผูกไว้",
  T_49_META_TYP_80_I5_D: "ผูกข้อมูลกระเป๋าสตางค์",
  T_49_META_TYP_80_I6_D: "ประเภทของเป้าหมายที่ผู้เล่น UI ร้องขอในปัจจุบัน",
  T_49_META_TYP_80_I7_D: "รายการสิ่งของที่ร้องขอ",
  T_49_META_TYP_81_I0_D: "บัฟแบบสุ่ม",
  T_49_META_TYP_81_I1_D: "เสริมพลัง พลังชีวิต",
  T_49_META_TYP_81_I2_D: "เสริมพลังกระสุน",
  T_49_META_TYP_81_I3_D: "เสริมพลังเกราะ",
  T_49_META_TYP_82_I1_D: "ไอคอนปุ่ม",
  T_49_META_TYP_82_I3_D: "ตำแหน่งสัมพันธ์กับจุดยึด",
  T_49_META_TYP_83_I1_D: "รหัสของผู้เล่นที่ทริกเกอร์",
  T_49_META_TYP_83_I2_D: "การส่งพารามิเตอร์",
  T_49_META_TYP_86_I0_D: "น้อยสุด",
  T_49_META_TYP_86_I1_D: "ค่ามากสุด",
  T_49_META_TYP_86_I2_D: "ค่าสัมประสิทธิ์ฐานคูณด้วยค่าเดิมก่อนการคำนวณทั้งหมด",
  T_49_META_TYP_86_I3_D: "พรีแอคคูมูเลเตอร์ สะสมก่อนการคูณและร่วมคำนวณการคูณ",
  T_49_META_TYP_86_I4_D: "ตัวคูณต่อเนื่อง การคูณต่อเนื่อง เช่น (ลดลงเหลือ 90% เสริมเป็น 110%) ผลลัพธ์คือ ค่า*90%*110%",
  T_49_META_TYP_86_I5_D: "ตัวสะสมการคูณ เช่น (บวก 10%, บวก 5%) มีผลเป็นค่า*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "หลังการสะสม ไม่เข้าร่วมในการคำนวณคูณ และถูกเพิ่มในตอนท้าย",
  T_49_META_TYP_88_I0_D: "ประเภทพื้นฐาน สกุลเงินเกมพื้นฐานที่สุด ประเภทการกำหนดราคาของสินค้าทั่วไปในเวอร์ชันปัจจุบัน",
  T_49_META_TYP_89_I0_D: "ปัจจุบันมีเฉพาะสกุลเงินฐานในเวอร์ชันเท่านั้น",
  T_49_META_TYP_89_I1_D: "ปริมาณสกุลเงิน",
  T_49_META_TYP_89_I2_D: "ไอคอนสกุลเงิน",
  T_49_META_TYP_89_I3_D: "สีไอคอนสกุลเงิน",
  T_49_META_TYP_90_I0_D: "เนื้อหาในกระเป๋าสตางค์เป็นสกุลเงินต่างๆ",
  T_49_META_TYP_92_I0_D: "ลังไม้สี่เหลี่ยม",
  T_49_META_TYP_92_I1_D: "ลังไม้ยาว",
  T_49_META_TYP_92_I10_D: "หอคอยสังเกตุการณ์",
  T_49_META_TYP_92_I100_D: "บันได",
  T_49_META_TYP_92_I101_D: "บันไดลง B",
  T_49_META_TYP_92_I102_D: "บันไดลง A",
  T_49_META_TYP_92_I103_D: "ตู้โทรศัพท์",
  T_49_META_TYP_92_I104_D: "กำแพงธีม BIS",
  T_49_META_TYP_92_I105_D: "BIS ธีมแปลงดอกไม้",
  T_49_META_TYP_92_I106_D: "ตู้หยอดเหรียญ",
  T_49_META_TYP_92_I107_D: "สิ่งมีชีวิตประเภทมอนสเตอร์",
  T_49_META_TYP_92_I108_D: "เครื่องกำเนิดยูนิต",
  T_49_META_TYP_92_I109_D: "รถสปอร์ต",
  T_49_META_TYP_92_I11_D: "ป้อมยาม",
  T_49_META_TYP_92_I110_D: "ตุ๊กตุ๊ก",
  T_49_META_TYP_92_I111_D: "กล่องไม้ที่สามารถทำลายได้",
  T_49_META_TYP_92_I112_D: "รถเอสยูวี",
  T_49_META_TYP_92_I113_D: "รถมอเตอร์ไซค์",
  T_49_META_TYP_92_I114_D: "รถบรรทุกมอนสเตอร์",
  T_49_META_TYP_92_I115_D: "ตัวสร้างทอง",
  T_49_META_TYP_92_I116_D: "บันไดลง C",
  T_49_META_TYP_92_I117_D: "ป้ายบอกทาง",
  T_49_META_TYP_92_I118_D: "รั้ว",
  T_49_META_TYP_92_I119_D: "เครื่องผลิตเจอร์ซี่",
  T_49_META_TYP_92_I12_D: "บ้านสองชั้น",
  T_49_META_TYP_92_I121_D: "เสาคอนกรีต",
  T_49_META_TYP_92_I122_D: "เก็บกล่องไอเทมฟุตบอล",
  T_49_META_TYP_92_I123_D: "ถังน้ำมัน",
  T_49_META_TYP_92_I124_D: "พื้นที่แรงโน้มถ่วงต่ำ",
  T_49_META_TYP_92_I125_D: "อาวุธ",
  T_49_META_TYP_92_I126_D: "รั้ว B",
  T_49_META_TYP_92_I127_D: "บ้านหลังเล็ก A",
  T_49_META_TYP_92_I128_D: "รถบรรทุกที่ได้รับความเสียหาย",
  T_49_META_TYP_92_I129_D: "ทรงกลมพื้นฐาน",
  T_49_META_TYP_92_I13_D: "ประติมากรรมทราย",
  T_49_META_TYP_92_I130_D: "กรวยธรรมดา",
  T_49_META_TYP_92_I131_D: "ทรงกระบอกธรรมดา",
  T_49_META_TYP_92_I132_D: "ตัวสร้างของบริโภค",
  T_49_META_TYP_92_I133_D: "แหล่งน้ำที่กำหนดเอง",
  T_49_META_TYP_92_I134_D: "ลูกศร",
  T_49_META_TYP_92_I135_D: "กล่องสีเหลืองย้อมสี",
  T_49_META_TYP_92_I136_D: "ถังน้ำมันย้อมสี",
  T_49_META_TYP_92_I137_D: "ข้อความ",
  T_49_META_TYP_92_I138_D: "ไอคอน",
  T_49_META_TYP_92_I139_D: "ตุ๊กตาน้ำแข็ง",
  T_49_META_TYP_92_I14_D: "บ่อน้ำพุ",
  T_49_META_TYP_92_I140_D: "ตัวทริกเกอร์แบบแคปซูล",
  T_49_META_TYP_92_I141_D: "ทริกเกอร์การชนกันของทรงกลม",
  T_49_META_TYP_92_I142_D: "บล็อกพื้นฐานสีทึบสะท้อนแสง 1",
  T_49_META_TYP_92_I143_D: "ผู้ผลิตรถบั๊ม",
  T_49_META_TYP_92_I144_D: "บล็อกสวนสนุกตารางหมากรุก",
  T_49_META_TYP_92_I145_D: "หน้าจอขนาดใหญ่",
  T_49_META_TYP_92_I146_D: "แท่น",
  T_49_META_TYP_92_I147_D: "อมยิ้มยักษ์",
  T_49_META_TYP_92_I148_D: "รถขายอาหาร B",
  T_49_META_TYP_92_I15_D: "ต้นซากุระ",
  T_49_META_TYP_92_I16_D: "บ้านชั้นเดียว",
  T_49_META_TYP_92_I17_D: "บ้านสามชั้น",
  T_49_META_TYP_92_I18_D: "ต้นกล้วย",
  T_49_META_TYP_92_I19_D: "ห้องน้ำ",
  T_49_META_TYP_92_I2_D: "ลังไม้ยาวหุ้มพุ่มไม้",
  T_49_META_TYP_92_I20_D: "รั้ว",
  T_49_META_TYP_92_I21_D: "ที่เก็บของที่สามารถทำลายได้",
  T_49_META_TYP_92_I22_D: "รั่วที่สามารถทำลายได้",
  T_49_META_TYP_92_I23_D: "ยางรถยนต์",
  T_49_META_TYP_92_I24_D: "รถบั๊ม",
  T_49_META_TYP_92_I25_D: "ยานพาหนะสะเทินน้ำสะเทินบก",
  T_49_META_TYP_92_I26_D: "รถจี๊ป",
  T_49_META_TYP_92_I27_D: "ถังขยะ",
  T_49_META_TYP_92_I28_D: "เต็นท์แพทย์",
  T_49_META_TYP_92_I29_D: "โรงรถ",
  T_49_META_TYP_92_I3_D: "กองฟาง",
  T_49_META_TYP_92_I30_D: "ผนังทาสี",
  T_49_META_TYP_92_I31_D: "โทริอิ",
  T_49_META_TYP_92_I32_D: "แท่นเหล็ก",
  T_49_META_TYP_92_I33_D: "บ้านคอนเทนเนอร์",
  T_49_META_TYP_92_I34_D: "ตัวอย่าง",
  T_49_META_TYP_92_I35_D: "กำแพง A",
  T_49_META_TYP_92_I36_D: "โน้ตดนตรี - เปียโน",
  T_49_META_TYP_92_I37_D: "โน้ตดนตรี - เปียโน",
  T_49_META_TYP_92_I38_D: "โน้ตดนตรี - กลอง 1",
  T_49_META_TYP_92_I39_D: "โน้ตดนตรี - กลอง 1",
  T_49_META_TYP_92_I4_D: "รถที่พัง",
  T_49_META_TYP_92_I40_D: "โน้ตดนตรี - ซินธิไซเซอร์ A",
  T_49_META_TYP_92_I41_D: "โน้ตดนตรี - ซินธิไซเซอร์ A",
  T_49_META_TYP_92_I42_D: "โน้ตดนตรี - ซินธิไซเซอร์ B",
  T_49_META_TYP_92_I43_D: "โน้ตดนตรี - ซินธิไซเซอร์ B",
  T_49_META_TYP_92_I44_D: "โน้ตดนตรี - ซินธิไซเซอร์ C",
  T_49_META_TYP_92_I45_D: "โน้ตดนตรี - ซินธิไซเซอร์ C",
  T_49_META_TYP_92_I46_D: "ตัวสร้างการเสริมพลัง",
  T_49_META_TYP_92_I47_D: "กลไกใบพัด",
  T_49_META_TYP_92_I48_D: "กลไกของกระทะทอด",
  T_49_META_TYP_92_I49_D: "บล็อคกับดัก",
  T_49_META_TYP_92_I5_D: "รถบัสที่พัง",
  T_49_META_TYP_92_I50_D: "กลไกแบบวงแหวน",
  T_49_META_TYP_92_I51_D: "กับดักค้อนยักษ์",
  T_49_META_TYP_92_I52_D: "บอร์ดโมบาย",
  T_49_META_TYP_92_I53_D: "เป้าเคลื่อนที่",
  T_49_META_TYP_92_I54_D: "ผนังยืดหดได้",
  T_49_META_TYP_92_I55_D: "ส่วนประกอบอาวุธจุดปล้น",
  T_49_META_TYP_92_I56_D: "ส่วนประกอบกระสุนจุดขโมย",
  T_49_META_TYP_92_I57_D: "ส่วนประกอบของไอเทมสิ้นเปลืองจากจุดปล้น",
  T_49_META_TYP_92_I58_D: "ส่วนประกอบไอเทมทอยจุดปล้น",
  T_49_META_TYP_92_I59_D: "ส่วนประกอบการซูมจุดขโมย",
  T_49_META_TYP_92_I6_D: "ที่เก็บของ A",
  T_49_META_TYP_92_I60_D: "ส่วนประกอบเกราะจุดปล้น",
  T_49_META_TYP_92_I61_D: "ท่อ I",
  T_49_META_TYP_92_I62_D: "ท่อ T",
  T_49_META_TYP_92_I63_D: "ท่อไขว้",
  T_49_META_TYP_92_I64_D: "ท่อหักศอก",
  T_49_META_TYP_92_I65_D: "กลุ่มเห็ดยักษ์",
  T_49_META_TYP_92_I66_D: "ราวตากผ้า",
  T_49_META_TYP_92_I67_D: "สะพานไม้กระดาน",
  T_49_META_TYP_92_I68_D: "หน้าจอ",
  T_49_META_TYP_92_I69_D: "เสาคอนกรีต",
  T_49_META_TYP_92_I7_D: "ตู้คอนเทนเนอร์ B",
  T_49_META_TYP_92_I70_D: "ต้นกระบองเพชร",
  T_49_META_TYP_92_I71_D: "ต้นไม้ไร้ใบ",
  T_49_META_TYP_92_I72_D: "โคมไฟพระราชวัง",
  T_49_META_TYP_92_I73_D: "ไฟถนน",
  T_49_META_TYP_92_I74_D: "แผงโซลาร์เซลล์",
  T_49_META_TYP_92_I75_D: "เครื่องปรับอากาศ",
  T_49_META_TYP_92_I76_D: "สี่เหลี่ยม",
  T_49_META_TYP_92_I77_D: "ความลาดชัน",
  T_49_META_TYP_92_I78_D: "รถขายอาหาร",
  T_49_META_TYP_92_I79_D: "ทริกเกอร์ความตายหรือการอยู่ยงคงกระพัน",
  T_49_META_TYP_92_I8_D: "ตู้คอนเทนเนอร์ C",
  T_49_META_TYP_92_I80_D: "เช็กพอยต์",
  T_49_META_TYP_92_I81_D: "ตำแหน่งของจุดจบ",
  T_49_META_TYP_92_I82_D: "ลูกเต๋า",
  T_49_META_TYP_92_I83_D: "ม้านั่ง",
  T_49_META_TYP_92_I84_D: "สถานีรถบัส",
  T_49_META_TYP_92_I85_D: "บ้านสุนัข",
  T_49_META_TYP_92_I86_D: "บิลบอร์ด (หันหน้าเข้ากล้องเสมอ)",
  T_49_META_TYP_92_I87_D: "เหยือกน้ำ",
  T_49_META_TYP_92_I88_D: "กำแพงกราฟฟิตี้",
  T_49_META_TYP_92_I89_D: "กระท่อมมุงจาก",
  T_49_META_TYP_92_I9_D: "ห้องโดยสาร",
  T_49_META_TYP_92_I90_D: "สะพานหินโค้ง",
  T_49_META_TYP_92_I91_D: "ชุดพาทิโอพร้อมร่ม",
  T_49_META_TYP_92_I92_D: "ป้ายเสร็จ",
  T_49_META_TYP_92_I93_D: "ป้อม",
  T_49_META_TYP_92_I94_D: "จุดเกิดของมอนสเตอร์",
  T_49_META_TYP_92_I95_D: "เครื่องหมาย",
  T_49_META_TYP_92_I97_D: "ทริกเกอร์แบบกำหนดค่าเอง",
  T_49_META_TYP_92_I98_D: "ประตูบานคู่",
  T_49_META_TYP_92_I99_D: "สิ่งกีดขวางถนน",
  T_49_META_TYP_94_I0_D: "เพิ่ม",
  T_49_META_TYP_94_I1_D: "คูณ",
  T_49_META_TYP_95_I0_D: "ประเภทของเงิน",
  T_49_META_TYP_95_I1_D: "ปริมาณสกุลเงิน",
  T_49_META_TYP_96_I0_D: "รับกระเป๋าเงิน",
  T_49_META_TYP_96_I1_D: "ตำแหน่งการแสดงผล (จุดยึดอยู่ที่มุมขวาบน)",
  T_49_META_TYP_97_I0_D: "ตำแหน่งในพิกัดโลก",
  T_49_META_TYP_97_I1_D: "มุมการหมุนในระบบพิกัดโลก ส่วนประกอบ XYZ คือ มุมพิทช์ มุมหัน และมุมม้วน และลำดับการหมุนคือ YXZ",
  T_49_META_TYP_97_I10_D: "ทิศทางของแกนพิกัดท้องถิ่น x",
  T_49_META_TYP_97_I11_D: "ทิศทางของแกนพิกัดท้องถิ่น z",
  T_49_META_TYP_97_I2_D: "การปรับขนาดในพิกัดโลก",
  T_49_META_TYP_97_I3_D: "โหนดหลักของโหนดนี้",
  T_49_META_TYP_97_I4_D: "การหมุนในพิกัดโลกแสดงเป็นควอเทอร์เนียน",
  T_49_META_TYP_97_I5_D: "ตำแหน่งในระบบพิกัดท้องถิ่น",
  T_49_META_TYP_97_I6_D: "การหมุนในระบบพิกัดท้องถิ่น แสดงเป็นควอเทอร์เนียน",
  T_49_META_TYP_97_I7_D: "มุมการหมุนในระบบพิกัดท้องถิ่น ส่วนประกอบ XYZ คือ มุมพิทช์ มุมหัน และมุมม้วน และลำดับการหมุนคือ YXZ",
  T_49_META_TYP_97_I8_D: "การปรับขนาดในระบบพิกัดท้องถิ่น",
  T_49_META_TYP_97_I9_D: "ทิศทางของแกนพิกัดท้องถิ่น y",
  T_49_META_TYP_99_I0_D: "รัศมีฟุตบอล",
  T_49_META_TYP_99_I1_D: "ค่าสัมประสิทธิ์แรงเสียดทานภายใต้สภาวะปกติ",
  T_49_META_TYP_99_I2_D: "ค่าสัมประสิทธิ์แรงเสียดทานภายใต้แรงกระแทก",
  T_49_META_TYP_99_I3_D: "มุมการถ่ายภาพขั้นต่ำ",
  T_49_META_TYP_99_I4_D: "มุมเหนือศีรษะขั้นต่ำ",
  T_49_META_TYP_99_I5_D: "รีเซตเวลา",
  T_49_META_TYP_99_I6_D: "มุมการถ่ายภาพสูงสุด",
  T_49_META_TYP_99_I7_D: "รีเซตตำแหน่ง",
  T_49_META_TYPE_0_D: "วัตถุรากของลำดับชั้นชนิด",
  T_49_META_TYPE_1_D: "รายการคือภาชนะสำหรับชุดข้อมูล",
  T_49_META_TYPE_10_D: "ส่วนประกอบฐานเอนทิตี้ ส่วนประกอบทั้งหมดจะรวมส่วนประกอบนี้เข้าด้วยกัน",
  T_49_META_TYPE_100_D: "เครื่องเสื้อเจอร์ซี่",
  T_49_META_TYPE_101_D: "วัตถุที่เปลี่ยนร่าง",
  T_49_META_TYPE_1010_D: "ข้อมูลตัวจับเวลา",
  T_49_META_TYPE_1011_D: "แผ่นป้ายเปิด",
  T_49_META_TYPE_1012_D: "แบนเนอร์เอนทิตีในช่วงเริ่มต้นของรอบของทั้งสองทีม การแก้ไขคุณสมบัติของเอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1013_D: "โดยทั่วไป แบนเนอร์เอนทิตีในช่วงเริ่มต้นของรอบ การแก้ไขคุณสมบัติของเอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1014_D: "แบนเนอร์คะแนนรอบทีม การปรับเปลี่ยนแอตทริบิวต์ของเอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1015_D: "เอนทิตี้ของ Checkpoint Manager การปรับเปลี่ยนแอตทริบิวต์ของเอนทิตี้จะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1016_D: "เอนทิตี้จะแสดงเมื่อสิ้นสุดรอบ การแก้ไขแอตทริบิวต์เอนทิตี้จะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1017_D: "หากมี 2 ทีมในตอนเริ่มต้น ให้แสดงแบนเนอร์ของ 2 ทีมที่ต่อสู้กัน",
  T_49_META_TYPE_1018_D: "คะแนนของทั้งสองทีม",
  T_49_META_TYPE_1019_D: "ผลสุดท้าย: ชนะ, แพ้, เสมอ",
  T_49_META_TYPE_102_D: "ประเภทแหล่งที่มาของการฟื้นคืนชีพ: ความตาย, การตกต่ำ",
  T_49_META_TYPE_1020_D: "การเปลี่ยนแปลงหมายเลขเอนทิตี้ การปรับเปลี่ยนแอตทริบิวต์เอนทิตี้จะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1021_D: "เอนทิตีนับถอยหลังเฟส การแก้ไขแอตทริบิวต์เอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1022_D: "เอนทิตีคำบรรยายข้อมูลเกม การแก้ไขแอตทริบิวต์เอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1023_D: "ข้อมูลเอนทิตีเกมของสองทีม การแก้ไขแอตทริบิวต์เอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1024_D: "ข้อมูลการแข่งขันของทีม UI เอนทิตี้ การแก้ไขแอตทริบิวต์เอนทิตี้จะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1027_D: "อธิบายประเภทของประเภทที่ส่งคืนเมื่อใช้ Typeof",
  T_49_META_TYPE_1028_D: "ข้อมูลเอนทิตี้ของฝ่าย การแก้ไขแอตทริบิวต์เอนทิตี้จะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1029_D: "ไอคอนแจ้งข้อมูลเอนทิตี การแก้ไขแอตทริบิวต์เอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_103_D: "การนับประเภทช่องรายการ",
  T_49_META_TYPE_1030_D: "ข้อมูลเกมของทั้งสองทีมในรูปแบบที่เรียบง่าย การแก้ไขแอตทริบิวต์ของข้อมูลจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1031_D: "อินเทอร์เฟซพร้อมท์เวลาของเอนทิตี การปรับเปลี่ยนแอตทริบิวต์ของเอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1032_D: "ข้อความลอยตัวจะแจ้งให้เอนทิตีทราบ การแก้ไขแอตทริบิวต์ของเอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1033_D: "เอนทิตีการสลับเทิร์นประกอบด้วยการชำระเทิร์นปัจจุบันและข้อมูลการเริ่มต้นเทิร์นถัดไป การแก้ไขแอตทริบิวต์เอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1035_D: "เปิดเอนทิตี UI ของปุ่มสกอร์บอร์ด การแก้ไขแอตทริบิวต์เอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1036_D: "โหมดการติดเชื้อ UI แสดงระดับซอมบี้ปัจจุบัน",
  T_49_META_TYPE_1037_D: "เพิ่มเอนทิตี UI เอฟเฟกต์ไดนามิกของจุด การแก้ไขแอตทริบิวต์เอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_1038_D: "เอฟเฟกต์ UI ซอมบี้โหมดติดเชื้อ",
  T_49_META_TYPE_1039_D: "เอนทิตีข้อความแจ้งเตือนการนับถอยหลังแบบลอยตัว การปรับเปลี่ยนแอตทริบิวต์ของเอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_104_D: "รูปแบบเสื้อเจอร์ซี่",
  T_49_META_TYPE_1040_D: "UI สำหรับแผงเลือกการ์ด",
  T_49_META_TYPE_1041_D: "UI แจ้งเตือนตัวตน",
  T_49_META_TYPE_1042_D: "UI รับถอยหลัง 5 วินาที",
  T_49_META_TYPE_1043_D: "UI ป้ายพาดหัว",
  T_49_META_TYPE_1044_D: "เปลี่ยนบิลด์อิน UI",
  T_49_META_TYPE_1045_D: "UI ปุ่มทักษะ",
  T_49_META_TYPE_105_D: "เป้าหมายฟุตบอล",
  T_49_META_TYPE_106_D: "ประเภทการช่วยเล็ง",
  T_49_META_TYPE_107_D: "สามารถเล็งเป้าและโจมตีได้แต่จะไม่ได้รับความเสียหายอย่างแน่นอน",
  T_49_META_TYPE_108_D: "ประเภทจำนวนเต็ม จำนวนเต็มที่มีเครื่องหมาย 64 บิต",
  T_49_META_TYPE_109_D: "ช่องแชทเป็นคอนเทนเนอร์ที่ประกอบด้วย ID ช่องและผู้เล่นของตัวเอง",
  T_49_META_TYPE_11_D: "ตัวตนระดับโลกที่ไม่ซ้ำใครในเกมทั้งหมด",
  T_49_META_TYPE_110_D: "ช่องเสียงว่าง",
  T_49_META_TYPE_111_D: "ประเภทพฤติกรรม",
  T_49_META_TYPE_112_D: "ประเภทสถานะพฤติกรรมของผู้เล่น",
  T_49_META_TYPE_113_D: "เพลงกลอง",
  T_49_META_TYPE_114_D: "เพลงนำ 1",
  T_49_META_TYPE_115_D: "เพลงนำ 2",
  T_49_META_TYPE_116_D: "เพลงนำ 3",
  T_49_META_TYPE_117_D: "ประเภทส่วนประกอบของดนตรีกลอง",
  T_49_META_TYPE_118_D: "ฝ่าย",
  T_49_META_TYPE_119_D: "ตัวเลือกการโจมตี",
  T_49_META_TYPE_12_D: "สิ่งมีชีวิตต่อสู้ที่สามารถโจมตี, ถูกโจมตี, ฆ่า ฯลฯ",
  T_49_META_TYPE_120_D: "UI แถบความคืบหน้า",
  T_49_META_TYPE_121_D: "เวลาช่วงคลื่นแต่ละช่วง",
  T_49_META_TYPE_122_D: "กล่องท้องฟ้า (Skybox)",
  T_49_META_TYPE_123_D: "การนับชนิดฐานสกายบ็อกซ์",
  T_49_META_TYPE_124_D: "ช่วงการค้นหา",
  T_49_META_TYPE_125_D: "คุณสามารถปรับเปลี่ยนลักษณะพื้นฐานของวัตถุได้ เช่น พื้นผิวและความโปร่งใส",
  T_49_META_TYPE_126_D: "หลอดพลังชีวิต",
  T_49_META_TYPE_127_D: "วิธีการเคลื่อนย้ายวัตถุ",
  T_49_META_TYPE_128_D: "วัตถุที่เปลี่ยนรูปได้",
  T_49_META_TYPE_129_D: "ประเภทกระสุนที่เก็บ",
  T_49_META_TYPE_13_D: "เอนทิตีการควบคุม UI",
  T_49_META_TYPE_130_D: "ประเภทของที่บริโภคได้",
  T_49_META_TYPE_131_D: "ประเภทเกราะที่เก็บ",
  T_49_META_TYPE_132_D: "ประเภทของขว้างที่เก็บ",
  T_49_META_TYPE_133_D: "ประเภทกล้องส่องที่เก็บ",
  T_49_META_TYPE_134_D: "ประเภทอาวุธที่เก็บ",
  T_49_META_TYPE_135_D: "จะทำให้กระสุนประเภทที่เลือกหล่น",
  T_49_META_TYPE_136_D: "จะทำการผลิตอุปกรณ์ประเภทดรอปตามที่เลือก",
  T_49_META_TYPE_137_D: "จะทำให้มีกระสุนประเภทที่เลือกตกลงมา",
  T_49_META_TYPE_138_D: "จะทำให้ขอบเขตของประเภทที่เลือกลดลง",
  T_49_META_TYPE_139_D: "จะทำให้เกราะประเภทที่เลือกหล่น",
  T_49_META_TYPE_14_D: "เอนทิตีผู้เล่นในเกม หนึ่งเอนทิตีต่อผู้ใช้หนึ่งคน",
  T_49_META_TYPE_140_D: "คลื่น",
  T_49_META_TYPE_141_D: "ประเภทฟุตบอลที่เก็บ",
  T_49_META_TYPE_142_D: "เก็บกล่องไอเทมฟุตบอล",
  T_49_META_TYPE_143_D: "ประเภทส่วนประกอบดนตรี Lead1",
  T_49_META_TYPE_144_D: "ประเภทส่วนประกอบดนตรี Lead2",
  T_49_META_TYPE_145_D: "ประเภทส่วนประกอบดนตรี Lead3",
  T_49_META_TYPE_146_D: "ประเภทส่วนประกอบของคีย์บอร์ดดนตรี",
  T_49_META_TYPE_147_D: "มีกล้องประเภทต่างๆ ให้เลือกตั้งค่าล่วงหน้า รวมถึงกล้องประเภทที่กำหนดเอง",
  T_49_META_TYPE_148_D: "ส่วนประกอบของกล้อง",
  T_49_META_TYPE_149_D: "คีย์ของการปรับให้เข้ากับท้องถิ่น",
  T_49_META_TYPE_15_D: "ตัวตนของทีมในเกม หนึ่งคนต่อหนึ่งทีม",
  T_49_META_TYPE_150_D: "ถังน้ำมัน",
  T_49_META_TYPE_151_D: "ควอเทอร์เนียนคือเวกเตอร์สี่มิติพิเศษที่ใช้แสดงการหมุนเท่านั้น",
  T_49_META_TYPE_152_D: "พื้นที่แรงโน้มถ่วงต่ำ",
  T_49_META_TYPE_153_D: "คอนเทนเนอร์เอนทิตี้ซึ่งจะสร้างเอนทิตี้ของประเภทที่สอดคล้องกันที่ตำแหน่ง",
  T_49_META_TYPE_154_D: "ประเภทอาวุธคู่",
  T_49_META_TYPE_155_D: "ตัวตนหมวกกันน็อค",
  T_49_META_TYPE_156_D: "หน่วยงานเกราะป้องกันร่างกาย",
  T_49_META_TYPE_157_D: "ประเภททรานซิชันกล้อง",
  T_49_META_TYPE_158_D: "อินเทอร์เฟซพร้อมท์ข้อความ",
  T_49_META_TYPE_159_D: "เวกเตอร์ 2 (Vector2)",
  T_49_META_TYPE_16_D: "วัตถุระดับเอนทิตี้",
  T_49_META_TYPE_160_D: "ประเภทแผนที่",
  T_49_META_TYPE_161_D: "เท็กเจอร์ VFX แบบไม่สามารถเปลี่ยนได้",
  T_49_META_TYPE_162_D: "รายการของประเภท",
  T_49_META_TYPE_163_D: "ประเภท หรือ รายการประเภท",
  T_49_META_TYPE_164_D: "Component เป็นคลาสฐานของส่วนประกอบเอนทิตี้ทั้งหมดหรือคลาสส่วนประกอบเฉพาะ",
  T_49_META_TYPE_165_D: "ส่วนประกอบกล่องกันกระแทก",
  T_49_META_TYPE_166_D: "อิโมติคอน",
  T_49_META_TYPE_167_D: "เอนทิตีเอฟเฟกต์พิเศษแสดงถึงเอฟเฟกต์พิเศษที่แสดง (ลบ รีไซเคิลได้ และนำกลับมาใช้ใหม่ได้)",
  T_49_META_TYPE_17_D: "รายการวัตถุในด่าน",
  T_49_META_TYPE_170_D: "ระบุว่าสามารถตั้งค่าการมองเห็นได้หรือไม่",
  T_49_META_TYPE_171_D: "เห็ด",
  T_49_META_TYPE_172_D: "กระสุน",
  T_49_META_TYPE_173_D: "กระเป๋าเป๋",
  T_49_META_TYPE_174_D: "ส่วนประกอบของระเบิดมือ",
  T_49_META_TYPE_175_D: "ระเบิดแช่แข็ง",
  T_49_META_TYPE_176_D: "ตัวสร้างอาวุธ",
  T_49_META_TYPE_177_D: "เมื่อมีสิ่งกีดขวางระหว่างกล้องกับวัตถุที่ถูกติดตาม โหมดการเคลื่อนที่ของกล้อง",
  T_49_META_TYPE_178_D: "กล้องจะเรนเดอร์ภาพอย่างไร",
  T_49_META_TYPE_179_D: "ทรงกลมพื้นฐาน",
  T_49_META_TYPE_18_D: "(หมดอายุการใช้งาน อย่าใช้)",
  T_49_META_TYPE_180_D: "หมายถึงคุณสมบัติของส่วนประกอบ",
  T_49_META_TYPE_181_D: "ใช้เพื่ออธิบายประเภทของทรัพย์สินแบบตาข่าย",
  T_49_META_TYPE_182_D: "ใช้เพื่ออธิบายประเภทของทรัพย์สินทางวัตถุ",
  T_49_META_TYPE_183_D: "ใช้เพื่ออธิบายประเภทของทรัพย์สินพื้นผิว",
  T_49_META_TYPE_184_D: "ส่วนประกอบการเรนเดอร์สะพานสำหรับการเรนเดอร์โดยใช้ทรัพยากรโมเดลในตัว",
  T_49_META_TYPE_185_D: "ส่วนประกอบการเรนเดอร์แบบกำหนดเองสำหรับการเรนเดอร์ด้วยทรัพยากรโมเดลแบบกำหนดเอง",
  T_49_META_TYPE_186_D: "ส่วนประกอบวัตถุว่างที่สามารถใช้กับส่วนประกอบตัวเรนเดอร์ ส่วนประกอบตัวชน ฯลฯ",
  T_49_META_TYPE_187_D: "ตัวจำกัด",
  T_49_META_TYPE_188_D: "ทรงกระบอกพื้นฐาน",
  T_49_META_TYPE_189_D: "รายชื่อสตริงที่แปลเป็นภาษาท้องถิ่น",
  T_49_META_TYPE_19_D: "เทมเพลตรายการ คุณสามารถระบุชนิดของเนื้อหาได้ผ่าน T",
  T_49_META_TYPE_190_D: "แผงคะแนนแบบสองทีม",
  T_49_META_TYPE_191_D: "อาวุธขว้างทางยุทธวิธีที่สามารถทำให้ศัตรูที่อยู่ในระยะมองเห็นได้ชั่วคราว",
  T_49_META_TYPE_192_D: "หลังการใช้งานจะสามารถสร้างควันที่ปกปิดเหตุการณ์ได้ซึ่งเป็นอาวุธที่ทรงพลังในการขัดขวางการโจมตีของศัตรู",
  T_49_META_TYPE_193_D: "แผงผลลัพธ์แบบหลายทีม",
  T_49_META_TYPE_194_D: "สามารถวางทุ่นระเบิดเหนี่ยวนำไว้บนพื้นได้ ทุ่นระเบิดจะระเบิดเมื่อศัตรูเข้ามาใกล้ ระวังอย่าเหยียบทุ่นระเบิด",
  T_49_META_TYPE_195_D: "การเคลื่อนไหวแบบสอดแทรกเกิดขึ้นได้อย่างไร",
  T_49_META_TYPE_197_D: "ส่วนประกอบที่สามารถเล่นได้",
  T_49_META_TYPE_198_D: "ไอเทมพื้นฐาน",
  T_49_META_TYPE_199_D: "อุปกรณ์เสริมสำหรับการรบทางอากาศแต่ต้องใส่ใจเรื่องการใช้พลังงานตลอดเวลา",
  T_49_META_TYPE_2_D: "ประเภทบูลีน ใช้แทนค่าจริง เท็จ ใช่ หรือไม่",
  T_49_META_TYPE_20_D: "การแจงนับประเภทอินเทอร์เฟซในตัวซึ่งสร้างขึ้นโดยอัตโนมัติตามระบบประเภท",
  T_49_META_TYPE_200_D: "พื้นที่เจลเบรก",
  T_49_META_TYPE_201_D: "พื้นที่ที่สามารถเล่นน้ำได้หลังจากเข้าไปแล้ว",
  T_49_META_TYPE_202_D: "รหัสตัสตรวจจับการชน",
  T_49_META_TYPE_203_D: "การเคลื่อนที่แบบสอดแทรก",
  T_49_META_TYPE_204_D: "รองเท้าที่ติดตั้งอุปกรณ์เทคโนโลยีพลังสูงที่ให้คุณกระโดดสองครั้งกลางอากาศได้",
  T_49_META_TYPE_205_D: "เครื่องร่อนที่สามารถบินได้บนท้องฟ้า สามารถใช้ลงจอดจากที่สูงและเคลื่อนที่ไปยังที่ที่ไกลออกไปได้",
  T_49_META_TYPE_206_D: "สเก็ตบอร์ด",
  T_49_META_TYPE_207_D: "ซิปไลน์",
  T_49_META_TYPE_208_D: "รายการที่สามารถเล่นได้",
  T_49_META_TYPE_209_D: "เล่นได้หรือรายการเล่นได้",
  T_49_META_TYPE_21_D: "อินเทอร์เฟซในตัวที่รวมอินเทอร์เฟซของฟังก์ชั่นเฉพาะไว้ด้วยกัน",
  T_49_META_TYPE_210_D: "แอนิเมชั่นการเคลื่อนที่ของกระสุนปืนคือการจำลองการเคลื่อนที่ของกระสุนปืน",
  T_49_META_TYPE_211_D: "ระบบพิกัด",
  T_49_META_TYPE_212_D: "วัตถุหนึ่งตามวัตถุอื่น",
  T_49_META_TYPE_213_D: "ด้านหน้าของวัตถุจะหันไปทางวัตถุอีกชิ้นเสมอ",
  T_49_META_TYPE_214_D: "ID ที่ใช้ในการอธิบายทรัพยากรสไปรท์ของแอตลาส",
  T_49_META_TYPE_215_D: "ผลการแข่งขัน",
  T_49_META_TYPE_216_D: "ตัวบรรจุข้อมูลพจนานุกรม องค์ประกอบข้อมูลเป็นคู่ของคีย์ ค่า",
  T_49_META_TYPE_217_D: "เทมเพลตข้อมูลพจนานุกรม สามารถระบุชนิดเนื้อหาได้ด้วย T1 และ T2",
  T_49_META_TYPE_218_D: "แหล่งกำเนิดแสงชนิดหนึ่งที่เปล่งแสงที่มีความเข้มข้นเท่ากันในทุกทิศทางจากตำแหน่งที่ตั้ง",
  T_49_META_TYPE_219_D: "ยานยนต์รถจักรยานยนต์",
  T_49_META_TYPE_22_D: "อินเทอร์เฟซที่กำหนดเอง อินเทอร์เฟซที่สร้างโดยผู้เล่นผ่านตัวแก้ไขอินเทอร์เฟซ",
  T_49_META_TYPE_220_D: "รถตุ๊ก-ตุ๊ก (รถสามล้อ)",
  T_49_META_TYPE_221_D: "รถจักรยานยนต์สะเทินน้ำสะเทินบก/ปืนกล",
  T_49_META_TYPE_222_D: "รถยนต์สี่ล้อ",
  T_49_META_TYPE_224_D: "รายการประเภททักษะ",
  T_49_META_TYPE_225_D: "ป้อมปืนปัญญาประดิษฐ์ที่ทำจากวัสดุไฮเทคจะค้นหาและโจมตีศัตรูภายในระยะที่กำหนดอย่างแข็งขัน",
  T_49_META_TYPE_226_D: "ป้อมปืนที่สร้างขึ้นหลังจากใช้ใบพัดป้อมปืน",
  T_49_META_TYPE_227_D: "การระบุประเภทการควบคุม UI ที่กำหนดเอง",
  T_49_META_TYPE_23_D: "การแจงนับประเภทวัตถุระดับซึ่งจะสร้างขึ้นโดยอัตโนมัติตามระบบประเภท",
  T_49_META_TYPE_231_D: "ชุดเครื่องมือซ่อมแซม",
  T_49_META_TYPE_233_D: "วงกลมความคืบหน้า",
  T_49_META_TYPE_234_D: "สร้างกับระเบิดแล้ว",
  T_49_META_TYPE_235_D: "ไอซ์วอลล์",
  T_49_META_TYPE_236_D: "สร้างกำแพงน้ำแข็งแล้ว",
  T_49_META_TYPE_237_D: "ปืนตะขอ",
  T_49_META_TYPE_238_D: "ปืนพ่นสีรุ้ง",
  T_49_META_TYPE_239_D: "ปืนสเปรย์ยาว",
  T_49_META_TYPE_24_D: "ประเภทความเสียหายที่ระบบกำหนดในปัจจุบัน",
  T_49_META_TYPE_240_D: "เอนทิตีคือผู้ให้บริการของส่วนประกอบทั้งหมด ส่วนประกอบจะต้องแนบไปกับเอนทิตีเพื่อสร้างอินสแตนซ์",
  T_49_META_TYPE_241_D: "ปืนขอที่ทรงพลัง",
  T_49_META_TYPE_242_D: "แถบคะแนน",
  T_49_META_TYPE_243_D: "ช่องเสื้อผ้า",
  T_49_META_TYPE_244_D: "เอนทิตีข้อความแสดงถึงข้อความที่แสดง",
  T_49_META_TYPE_245_D: "เอนทิตีไอคอนแสดงถึงไอคอนที่แสดง",
  T_49_META_TYPE_246_D: "สีสเปรย์",
  T_49_META_TYPE_247_D: "ประเภท UI ของผู้เล่น",
  T_49_META_TYPE_248_D: "เอนทิตีสวิตช์ UI ทั่วไป",
  T_49_META_TYPE_249_D: "ช่องเปลี่ยนอุปกรณ์",
  T_49_META_TYPE_25_D: "ขั้นตอนในกระบวนการเล่นเกม เช่น การเริ่มเกม การเตรียมเกม การจบเกม ฯลฯ",
  T_49_META_TYPE_250_D: "เอนทิตี้เอฟเฟกต์แสดงถึงเอฟเฟกต์ที่แสดง",
  T_49_META_TYPE_2500_D: "จุดเกิดของผู้เล่น",
  T_49_META_TYPE_2501_D: "ทริกเกอร์ใช้เพื่อทริกเกอร์เหตุการณ์เข้าและออกของผู้เล่น (หรือวัตถุอื่น ๆ)",
  T_49_META_TYPE_2502_D: "ทริกเกอร์ความตายหรือการอยู่ยงคงกระพัน เมื่อผู้เล่นเข้ามา มันจะควบคุมว่าจะเป็นเอฟเฟกต์ความตายหรือการอยู่ยงคงกระพันตามแอตทริบิวต์",
  T_49_META_TYPE_2503_D: "จุดตรวจในโหมดการแข่งขัน",
  T_49_META_TYPE_2504_D: "โดยทั่วไปจะใช้ในโหมดแข่งขันเพื่อระบุผู้เล่นที่เข้าสู่เส้นชัยที่กำหนด นี่คือทริกเกอร์เฉพาะ ทริกเกอร์ที่กำหนดเองจะเปิดขึ้นในภายหลัง จุดสิ้นสุดนี้เป็นเพียงตัวห่อหุ้มของทริกเกอร์ที่กำหนดเอง",
  T_49_META_TYPE_2505_D: "รั้วรอบจุดเกิด หลังจากปิดแล้ว คุณสามารถออกจากจุดเกิดได้",
  T_49_META_TYPE_2507_D: "ป้อมปืน",
  T_49_META_TYPE_2508_D: "เกิดสัตว์ประหลาด",
  T_49_META_TYPE_2509_D: "สามารถสร้างอินสแตนซ์ของประเภทที่สอดคล้องกันได้ตามความต้องการ",
  T_49_META_TYPE_251_D: "ตัวเก็บเอฟเฟ็กต์",
  T_49_META_TYPE_2510_D: "พื้นที่เกิดของผู้เล่น (สี่เหลี่ยมผืนผ้า)",
  T_49_META_TYPE_252_D: "UI ผลลัพธ์สเปรย์",
  T_49_META_TYPE_253_D: "ปุ่มเคล็ดลับ",
  T_49_META_TYPE_254_D: "เอฟเฟ็กต์ จังหวะหัวใจ",
  T_49_META_TYPE_255_D: "ตัวอักษรการประทับเวลาที่แปลแล้ว",
  T_49_META_TYPE_256_D: "ประเภทริจิดบอดี้ (Rigidbody)",
  T_49_META_TYPE_257_D: "ส่วนประกอบ Rigidbody",
  T_49_META_TYPE_258_D: "ประเภทสไตล์รูปแบบการประทับเวลา",
  T_49_META_TYPE_259_D: "เคล็ดลับ",
  T_49_META_TYPE_26_D: "รอบในเกมโดยทั่วไปจะเป็นรอบเล็ก ๆ ซึ่งประกอบด้วยหลายด่าน",
  T_49_META_TYPE_260_D: "ปุ่มความคืบหน้าของทักษะ",
  T_49_META_TYPE_261_D: "รหัสประจำตัวเฉพาะ",
  T_49_META_TYPE_262_D: "รหัสสกินอาวุธ",
  T_49_META_TYPE_263_D: "รหัสเสื้อผ้า",
  T_49_META_TYPE_264_D: "ID ไอเทม เมื่อเวอร์ชันมีเพียง ID อาวุธ",
  T_49_META_TYPE_265_D: "เอนทิตี้ของแผง UI",
  T_49_META_TYPE_267_D: "เอนทิตีมุมมองการเลื่อน UI UI ที่ผู้เล่นแก้ไขผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_268_D: "สวิตช์ที่มี 3 สถานะ นอกจากเปิดและปิดแล้ว คุณยังเลือกคงตรรกะเดิมไว้ได้อีกด้วย",
  T_49_META_TYPE_269_D: "อุปกรณ์ของผู้เล่น",
  T_49_META_TYPE_270_D: "รหัสเอนทิตี้หรือพรีเฟบ",
  T_49_META_TYPE_271_D: "เอนทิตีแผง UI คือ UI ที่ผู้เล่นแก้ไขผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_272_D: "การนับเพศ",
  T_49_META_TYPE_273_D: "แผนที่ย่อ",
  T_49_META_TYPE_274_D: "ไอคอนที่แสดงบนแผนที่ขนาดเล็กสามารถติดตามเป้าหมายได้",
  T_49_META_TYPE_275_D: "โหนดชิ้นส่วนแต่ละชิ้นในโครงกระดูก",
  T_49_META_TYPE_276_D: "โหนดที่ใช้เข้าถึงกระดูกผิวหนัง",
  T_49_META_TYPE_277_D: "การตรวจจับรังสีกล้องด้านไคลเอนต์",
  T_49_META_TYPE_278_D: "บล็อกพิกเซลที่แสดงบนแผนที่ขนาดเล็กแสดงขนาดการชนของวัตถุในตำแหน่งนั้น",
  T_49_META_TYPE_279_D: "ถังสี",
  T_49_META_TYPE_28_D: "ในช่วงเริ่มต้นของแต่ละรอบ สถานะจะถูกรีเซ็ต",
  T_49_META_TYPE_280_D: "ตัวทริกเกอร์แบบทรงกลม",
  T_49_META_TYPE_281_D: "ตัวทริกเกอร์แบบแคปซูล",
  T_49_META_TYPE_282_D: "อธิบายประเภทของ ID การกำหนดค่าสินทรัพย์ ซึ่งใช้เพื่อระบุ ID การกำหนดค่าสินทรัพย์ที่มาพร้อมกับแพ็คเกจหลัก ซึ่งจำเป็นต้องแยกวิเคราะห์ผ่านตารางการกำหนดค่าก่อนโหลด",
  T_49_META_TYPE_283_D: "อธิบายประเภทของสินทรัพย์ที่ใช้แสดงตัวระบุสินทรัพย์และสามารถโหลดได้โดยตรง",
  T_49_META_TYPE_284_D: "แสดงถึงทรัพยากรโมเดลมนุษย์ที่สามารถแทนที่ด้วยตัวละครผู้เล่นได้",
  T_49_META_TYPE_285_D: "รายการหรือพจนานุกรมสามารถวนซ้ำได้",
  T_49_META_TYPE_286_D: "ID ที่อธิบายทรัพยากรสคริปต์",
  T_49_META_TYPE_287_D: "ID ที่อธิบายทรัพย์สินสคริปต์แบบคงที่",
  T_49_META_TYPE_288_D: "ID ที่อธิบายทรัพยากร UI แบบกำหนดเอง",
  T_49_META_TYPE_289_D: "ID ที่ใช้ในการอธิบายสินทรัพย์ที่ตั้งไว้ล่วงหน้า",
  T_49_META_TYPE_29_D: "เอฟเฟกต์พิเศษ",
  T_49_META_TYPE_290_D: "ผังต้นไม้พฤติกรรม",
  T_49_META_TYPE_291_D: "ประเภทโหนดผังต้นไม้พฤติกรรม",
  T_49_META_TYPE_292_D: "ผังต้นไม้พฤติกรรมโหนดปรับแต่ง",
  T_49_META_TYPE_293_D: "ผังต้นไม้พฤติกรรมที่สามารถติดได้",
  T_49_META_TYPE_294_D: "เอนทิตีเค้าโครง UI UI ที่ผู้เล่นแก้ไขได้ผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_295_D: "สถานะ",
  T_49_META_TYPE_296_D: "คลิปแอนิเมชั่น",
  T_49_META_TYPE_297_D: "ตัวควบคุมแอนิเมชัน",
  T_49_META_TYPE_298_D: "ประเภทของลูป (Loop)",
  T_49_META_TYPE_3_D: "ประเภทจำนวนเต็ม จำนวนเต็มที่มีเครื่องหมาย 32 บิต",
  T_49_META_TYPE_30_D: "ไอคอน",
  T_49_META_TYPE_300_D: "เอนทิตี้ UI3DContainer UI ที่ผู้เล่นแก้ไขผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_301_D: "ประเภททักษะของ AI",
  T_49_META_TYPE_302_D: "การนับช่องอุปกรณ์",
  T_49_META_TYPE_303_D: "ตามที่สอดคล้องกับคอลัมน์ Id ใน BuffData.csv โปรดยืนยันกับ GPP ว่าสามารถใช้ได้หรือไม่ก่อนที่จะเพิ่มรายการใหม่",
  T_49_META_TYPE_304_D: "รายการประเภทการเสริมพลัง",
  T_49_META_TYPE_305_D: "สถานะโหนดผังต้นไม้พฤติกรรม",
  T_49_META_TYPE_306_D: "คุณสามารถเพิ่มบัฟ ลบบัฟ และรับรายการบัฟที่เพิ่มเข้ามาได้",
  T_49_META_TYPE_307_D: "ตัวสร้างกำแพงน้ำแข็ง",
  T_49_META_TYPE_308_D: "ประเภทรหัสไอเทมพิเศษ",
  T_49_META_TYPE_309_D: "อุปกรณ์การขว้างปา",
  T_49_META_TYPE_31_D: "เสียง",
  T_49_META_TYPE_310_D: "หน้าไม้",
  T_49_META_TYPE_311_D: "ระเบิดทั่วไป",
  T_49_META_TYPE_312_D: "อุปกรณ์การขว้างปา",
  T_49_META_TYPE_313_D: "ระเบิดกำแพงทำแข็ง",
  T_49_META_TYPE_314_D: "การจัดการตัวควบคุมแอนิเมชันและทรัพยากร",
  T_49_META_TYPE_315_D: "กระเป๋าเป๋าของผู้เล่น",
  T_49_META_TYPE_316_D: "เอนทิตี้ UITexture, UI ที่แก้ไขโดยผู้เล่นผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_317_D: "ข้อจำกัดการเคลื่อนไหวของร่างกายแบบแข็ง ข้อจำกัดแต่ละข้อสามารถใช้ร่วมกันได้",
  T_49_META_TYPE_318_D: "อุปกรณ์เสริม",
  T_49_META_TYPE_319_D: "การกรอกประเภทการนับ",
  T_49_META_TYPE_32_D: "ประเภทสถานะผู้เล่น",
  T_49_META_TYPE_320_D: "การกรอกตัวเลขทิศทาง",
  T_49_META_TYPE_321_D: "หน่วยงานที่สามารถกำหนดเป้าหมายได้",
  T_49_META_TYPE_322_D: "ประเภทชิ้นส่วนร่างกายที่เสียหาย",
  T_49_META_TYPE_323_D: "เอนทิตี้ UIProfileInfo UI ที่ผู้เล่นแก้ไขได้ผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_324_D: "ผลกระทบที่แตกต่างกันของแรงที่กระทำต่อวัตถุแข็ง โปรดทราบว่านี่ใช้ได้เฉพาะกับวัตถุแข็งแบบไดนามิกเท่านั้น",
  T_49_META_TYPE_325_D: "ID ที่ใช้ในการอธิบายการควบคุมในทรัพยากรอินเทอร์เฟซที่กำหนดเอง",
  T_49_META_TYPE_326_D: "ข้อมูลโปรไฟล์ผู้เล่น",
  T_49_META_TYPE_327_D: "เปลี่ยนทดแทนตามการกำหนดค่าของแต่ละส่วนประกอบ",
  T_49_META_TYPE_328_D: "รหัสผังต้นไม้พฤติกรรม",
  T_49_META_TYPE_329_D: "ประเภทที่นั่ง",
  T_49_META_TYPE_33_D: "เรียงตาม: เรียงจากน้อยไปมาก ไม่สนใจค่าศูนย์ เรียงจากมากไปน้อย เรียงจากน้อยไปมาก",
  T_49_META_TYPE_330_D: "การเคลื่อนไหวสัมพันธ์กับตนเอง",
  T_49_META_TYPE_331_D: "เส้นโค้งเบเซียร์",
  T_49_META_TYPE_332_D: "ส่วนประกอบที่สามารถนำกลับมาใช้ใหม่ได้",
  T_49_META_TYPE_333_D: "ประเภทรูปแบบตัวอักษร",
  T_49_META_TYPE_334_D: "รหัสสกินยาพาหนะ",
  T_49_META_TYPE_335_D: "เอนทิตีเอฟเฟกต์เสียงแสดงถึงเอฟเฟกต์เสียงที่กำลังเล่น",
  T_49_META_TYPE_336_D: "รายการเอฟเฟ็กต์เสียง",
  T_49_META_TYPE_337_D: "เสียงเอฟเฟ็กต์หรือรายการเสียงเอฟเฟ็กต์",
  T_49_META_TYPE_338_D: "เอนทิตีการซิงโครไนซ์คุณลักษณะพฤติกรรมผู้เล่น",
  T_49_META_TYPE_339_D: "อุปกรณ์ อุปกรณ์เสริม",
  T_49_META_TYPE_34_D: "รหัสไอเทม",
  T_49_META_TYPE_340_D: "ประเภทความยากของบอท",
  T_49_META_TYPE_341_D: "พจนานุกรมจำนวนเต็ม",
  T_49_META_TYPE_342_D: "วัตถุตัวจับเวลา",
  T_49_META_TYPE_343_D: "มีดขว้าง (หยิบ)",
  T_49_META_TYPE_344_D: "มืดป่า",
  T_49_META_TYPE_345_D: "ประเภทอาวุธ",
  T_49_META_TYPE_346_D: "ประเภทกระสุน",
  T_49_META_TYPE_347_D: "กรอบญาติตัวเอง",
  T_49_META_TYPE_348_D: "ตัวชี้ฟังก์ชันจะชี้ไปที่อินสแตนซ์ฟังก์ชันเพื่อใช้งานฟังก์ชันเสมือนหรือกลไกการมอบหมาย",
  T_49_META_TYPE_349_D: "หมายถึงตัวจับของคอรูทีน และสามารถดำเนินการจับบางอย่างได้",
  T_49_META_TYPE_350_D: "การนับจำนวนยานพาหนะ",
  T_49_META_TYPE_351_D: "อธิบายประเภทของวัตถุ",
  T_49_META_TYPE_352_D: "เอนทิตี้ UIToggle UI ที่ผู้เล่นแก้ไขผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_353_D: "ชุดปฐมพยาบาล",
  T_49_META_TYPE_354_D: "เครื่องพ่นยา",
  T_49_META_TYPE_355_D: "Horizaline",
  T_49_META_TYPE_356_D: "การกระโดดจากที่สูง หลังจากเวลาเตรียมตัวสิ้นสุดลง",
  T_49_META_TYPE_357_D: "สีบรรยายวัตถุ เช่น ขอบ พื้นผิว ฯลฯ (ลบได้ รีไซเคิลได้)",
  T_49_META_TYPE_358_D: "หมายถึงเหตุการณ์",
  T_49_META_TYPE_359_D: "ตัวควบคุมผู้เล่นพร้อมเอฟเฟกต์ฟิสิกส์ สามารถใช้แรงและรับแรงได้",
  T_49_META_TYPE_360_D: "แท่นปล่อยตัว",
  T_49_META_TYPE_361_D: "ปืนใหญ่ที่พับไว้สามารถใช้ยิงคนได้เมื่อกางออก ระวังอย่าให้ตัวเองกระเด็นออกนอกโซนปลอดภัย!",
  T_49_META_TYPE_362_D: "เกมส์ปาหิมะ! ค่าใช้จ่าย!",
  T_49_META_TYPE_363_D: "ขอซื้อร้านค้า",
  T_49_META_TYPE_364_D: "ทริกเกอร์แอนิเมชั่น",
  T_49_META_TYPE_365_D: "ส่วนประกอบอินเทอร์เฟซทริกเกอร์แอนิเมชัน",
  T_49_META_TYPE_366_D: "เรนเดอร์แบบรวมชุด",
  T_49_META_TYPE_367_D: "เข็มทิศด้านบน",
  T_49_META_TYPE_368_D: "รหัสทรัพยากรบทบาทที่กำหนดเอง",
  T_49_META_TYPE_369_D: "รหัสทรัพยากรภาพเคลื่อนไหวที่กำหนดเอง",
  T_49_META_TYPE_370_D: "ข้อมูลที่แสดงในช่วงเริ่มต้นของรอบ",
  T_49_META_TYPE_371_D: "แสดงผลเมื่อจบแต่ละรอบ",
  T_49_META_TYPE_372_D: "ประเภทท่าทางของผู้เล่น",
  T_49_META_TYPE_373_D: "รหัสคอลเลกชัน ใช้ในการรวบรวมข้อมูลทรัพยากร",
  T_49_META_TYPE_374_D: "ตามหลอดพลังชีวิต",
  T_49_META_TYPE_375_D: "การระบุประเภทเป้าหมายการโจมตีของมอนสเตอร์",
  T_49_META_TYPE_376_D: "การระบุประเภทเป้าหมายการโจมตีหอคอยป้องกัน",
  T_49_META_TYPE_377_D: "นามแฝงสำหรับเอนทิตีผู้เล่นและประเภทเอนทิตียานพาหนะ",
  T_49_META_TYPE_378_D: "ID ที่อธิบายสินทรัพย์เสียง",
  T_49_META_TYPE_379_D: "ID ที่ใช้ในการอธิบายสินทรัพย์ตารางการกำหนดค่า",
  T_49_META_TYPE_38_D: "เอนทิตี้ของวิดเจ็ต UI ที่ว่างเปล่า UI ถูกแก้ไขโดยผู้เล่นผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_380_D: "ID ที่อธิบายสินทรัพย์ที่มีเอฟเฟกต์พิเศษ",
  T_49_META_TYPE_381_D: "ID ที่อธิบายสินทรัพย์ควบคุมแอนิเมชัน",
  T_49_META_TYPE_382_D: "วิธีการจัดการสถานะน็อคดาวน์",
  T_49_META_TYPE_383_D: "พื้นผิวแผนที่หรือการตกแต่ง",
  T_49_META_TYPE_384_D: "รายการไอเทม",
  T_49_META_TYPE_385_D: "รหัสทักษะตัวละคร",
  T_49_META_TYPE_386_D: "รายการรหัสทักษะ",
  T_49_META_TYPE_387_D: "เอนทิตี้ UITouchPad คือ UI ที่ผู้เล่นแก้ไขผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_388_D: "รหัสสกินกระเป๋า",
  T_49_META_TYPE_389_D: "เอนทิตี้ของจอยสติ๊ก, UI ที่แก้ไขโดยผู้เล่นผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_39_D: "เอนทิตี้ภาพ UI, UI ที่แก้ไขโดยผู้เล่นผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_390_D: "Hierarchical",
  T_49_META_TYPE_391_D: "UI หรือวิดเจ็ตปรับแต่ง",
  T_49_META_TYPE_392_D: "วัตถุวงพิษที่สามารถวางได้",
  T_49_META_TYPE_393_D: "เอนทิตีที่มีส่วนประกอบ PhysicalCCT หรือ Rigidbody",
  T_49_META_TYPE_394_D: "ค่าคงที่ทางคณิตศาสตร์",
  T_49_META_TYPE_395_D: "เอนทิตีที่มีส่วนประกอบ PhysicalCCT หรือ PlayerCCT สามารถเคลื่อนย้ายไปกับพวกมันได้",
  T_49_META_TYPE_396_D: "การกำหนดค่าการออกกลางเกม",
  T_49_META_TYPE_397_D: "ส่วนประกอบที่ใช้ในการอธิบายรูปร่างการชน",
  T_49_META_TYPE_398_D: "ตัวอักษรหรือตัวอักษรที่แปลแล้ว",
  T_49_META_TYPE_399_D: "ตัวควบคุมตัวละครที่มีเอฟเฟกต์ทางกายภาพ เฉพาะตัวละคร FF เท่านั้น",
  T_49_META_TYPE_4_D: "ประเภทจุดลอยตัว ตัวเลขจุดลอยตัวความแม่นยำเดี่ยว 32 บิต",
  T_49_META_TYPE_40_D: "ข้อความ UI เอนทิตี้ UI ที่แก้ไขโดยผู้เล่นผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_400_D: "การมีพฤติกรรมก้าวร้าวมีได้อย่างไร",
  T_49_META_TYPE_401_D: "ประเภทไฟ",
  T_49_META_TYPE_402_D: "วิดเจ็ตปุ่มสังคม",
  T_49_META_TYPE_403_D: "ประเภทปุ่มโซเชียล",
  T_49_META_TYPE_404_D: "รูปแบบปุ่มโซเชียล",
  T_49_META_TYPE_405_D: "ประเภทการเรียงลำดับเรย์เอาต์",
  T_49_META_TYPE_406_D: "สามารถทริกเกอร์ข้ามสิ่งกีดขวางได้",
  T_49_META_TYPE_407_D: "ประเภทของพื้นแพลตฟอร์ม",
  T_49_META_TYPE_408_D: "ข้อมูลพื้นฐานของนามแฝง",
  T_49_META_TYPE_409_D: "การแจงนับรหัสข้อผิดพลาด",
  T_49_META_TYPE_41_D: "ปุ่ม UI เอนทิตี้ UI ที่ผู้เล่นแก้ไขผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_410_D: "นามแฝงสำหรับเอนทิตีผู้เล่น หรือ ประเภทเอนทิตีการแปลง",
  T_49_META_TYPE_411_D: "ยานพาหนะเฮลิคอปเตอร์",
  T_49_META_TYPE_412_D: "ส่วนประกอบของรถยนต์คือการขยายการทำงานของส่วนประกอบของยานพาหนะ",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "จำกัดมุมการหมุนของกล้อง",
  T_49_META_TYPE_415_D: "เพอร์โซน่า",
  T_49_META_TYPE_416_D: "อินเทอร์เฟซหน้าต่างแชท Persona",
  T_49_META_TYPE_417_D: "ส่วนประกอบของอนุภาค",
  T_49_META_TYPE_418_D: "การนับสถานะสมาชิก",
  T_49_META_TYPE_419_D: "ประเภทผิวปืน",
  T_49_META_TYPE_42_D: "เอนทิตีอินพุต UI คือ UI ที่ผู้เล่นแก้ไขผ่านทางตัวแก้ไข UI",
  T_49_META_TYPE_420_D: "ประเภทผิวของยานพาหนะ",
  T_49_META_TYPE_421_D: "ประเภทผิว",
  T_49_META_TYPE_422_D: "ประเภทผิวเป้",
  T_49_META_TYPE_423_D: "รหัสเพอโซน่า",
  T_49_META_TYPE_424_D: "ประเภทพื้นฐานเอฟเฟกต์หมอก",
  T_49_META_TYPE_425_D: "รหัสสินทรัพย์อนุภาค",
  T_49_META_TYPE_426_D: "แหล่งกำเนิดแสงชนิดหนึ่งที่เปล่งแสงทรงกรวยจากแหล่งกำเนิดแสงไปยังแกน Y เชิงลบของแหล่งกำเนิดแสง โดยส่องสว่างพื้นดินตามค่าเริ่มต้น",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "ข้อมูลเครื่องแต่งกายที่ผู้เล่นจะต้องเก็บไว้เมื่อแปลงร่างเป็นตัวละครอื่น",
  T_49_META_TYPE_429_D: "ผู้เล่นหรือเอนทิตี้ NPC",
  T_49_META_TYPE_43_D: "ประเภทองค์ประกอบจะต้องเป็นรายการของเอนทิตีผู้เล่น",
  T_49_META_TYPE_430_D: "เครื่องกำเนิดตัวเลขสุ่ม",
  T_49_META_TYPE_431_D: "วัตถุเคลื่อนที่จะเคลื่อนที่ไปตามเส้นทางที่กำหนดเอง",
  T_49_META_TYPE_432_D: "ปรับแต่งจุดอ้างอิงเส้นทางโค้ง",
  T_49_META_TYPE_433_D: "ปรับแต่งประเภทจุดอ้างอิงเส้นทางโค้ง",
  T_49_META_TYPE_434_D: "เส้นทางโค้งที่กำหนดเอง",
  T_49_META_TYPE_435_D: "รายการตัวระบุเฉพาะของผู้เล่น",
  T_49_META_TYPE_436_D: "รายการรหัสข้อผิดพลาด",
  T_49_META_TYPE_437_D: "รายละเอียดการแข่งขัน UI ของทั้งสองทีม การแก้ไขแอตทริบิวต์ของเอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_438_D: "รายละเอียดการแข่งขันหลายทีม UI เอนทิตี การแก้ไขแอตทริบิวต์เอนทิตีจะส่งผลต่อเนื้อหาที่แสดงบน UI ที่เกี่ยวข้อง",
  T_49_META_TYPE_439_D: "รวม",
  T_49_META_TYPE_44_D: "ประเภทองค์ประกอบต้องเป็นรายการของหน่วยงานทีม",
  T_49_META_TYPE_440_D: "ไทม์ไลน์",
  T_49_META_TYPE_441_D: "รหัสทรัพยากรไทม์ไลน์",
  T_49_META_TYPE_442_D: "ส่วนประกอบเอนทิตี้ที่เรียบง่ายใหม่สำหรับข้อมูลการแข่งขันสองทีม รองรับการแสดงตัวเลขที่ปรับแต่งได้อย่างสมบูรณ์",
  T_49_META_TYPE_443_D: "รหัสสินทรัพย์การไหลของบทสนทนา",
  T_49_META_TYPE_444_D: "ประเภทภาษา",
  T_49_META_TYPE_45_D: "รายการบูลีน (Bool)",
  T_49_META_TYPE_46_D: "รายการเลขจำนวนเต็ม (Int List)",
  T_49_META_TYPE_47_D: "รายการเลขทศนิยม (Float List)",
  T_49_META_TYPE_48_D: "รายการตัวอักษร (String)",
  T_49_META_TYPE_49_D: "รายการเวกเตอร์ 3 (Vector3 List)",
  T_49_META_TYPE_5_D: "ชนิดสตริง ค่าเป็นเนื้อหาข้อความ",
  T_49_META_TYPE_50_D: "ประเภทองค์ประกอบจะต้องเป็นรายการของเอนทิตี้",
  T_49_META_TYPE_51_D: "ประเภทซอมบี้",
  T_49_META_TYPE_53_D: "วัตถุระดับทั่วไป",
  T_49_META_TYPE_54_D: "วัตถุที่สามารถทำลายได้",
  T_49_META_TYPE_55_D: "จุดเกิดทั่วไป",
  T_49_META_TYPE_56_D: "ยานพาหนะ",
  T_49_META_TYPE_57_D: "ผู้เล่นสามารถเทเลพอร์ตไปยังตำแหน่งที่กำหนดเมื่อเข้า",
  T_49_META_TYPE_58_D: "สามารถสร้างบัฟได้ตามต้องการ",
  T_49_META_TYPE_59_D: "พื้นที่ขยับได้",
  T_49_META_TYPE_6_D: "เวกเตอร์สามมิติ ซึ่งสามารถแสดงพิกัดเชิงพื้นที่หรือทิศทางเชิงพื้นที่ได้",
  T_49_META_TYPE_60_D: "จะทำให้มีการดรอปอาวุธประเภทที่เลือก",
  T_49_META_TYPE_61_D: "เมื่อเข้าสู่ช่วงทริกเกอร์ จะเปิดร้านค้าที่ถูกผูกไว้",
  T_49_META_TYPE_62_D: "ลูกเต๋าที่มีการเด้งดี",
  T_49_META_TYPE_63_D: "ผู้เล่นจะถูกเด้งไปยังตำแหน่งที่กำหนดเมื่อพวกเขาเหยียบลงไป",
  T_49_META_TYPE_64_D: "เมื่อผู้เล่นเหยียบลงไปก็จะมีเสียง",
  T_49_META_TYPE_65_D: "ปรับขนาดได้แบบพื้นฐาน",
  T_49_META_TYPE_66_D: "เส้นทางปรับแต่ง",
  T_49_META_TYPE_67_D: "จุดเส้นทาง",
  T_49_META_TYPE_68_D: "สิ่งมีชีวิตประเภทมอนสเตอร์ AI เช่น ซอมบี้",
  T_49_META_TYPE_69_D: "ตัวเลขขนาดใหญ่เป็นตัวเลขจุดลอยตัวที่มีความแม่นยำสูง",
  T_49_META_TYPE_7_D: "Number เป็นนามแฝงประเภทสำหรับจำนวนเต็ม จำนวนเต็ม 64 บิต หรือประเภทจุดลอยตัว",
  T_49_META_TYPE_70_D: "สูตรแอตทริบิวต์ใช้เพื่อคำนวณค่าแอตทริบิวต์ของเอนทิตี้ ปัจจุบันรองรับเฉพาะแอตทริบิวต์ผู้เล่นและแอตทริบิวต์อาวุธบางส่วนเท่านั้น",
  T_49_META_TYPE_71_D: "ใช้เฉพาะกับสินค้าที่ขายในร้านค้าเท่านั้น สินค้ามีความแตกต่างจากแนวคิดของสินค้าที่ได้มาโดยการซื้อสินค้า",
  T_49_META_TYPE_72_D: "ประกอบด้วยผลิตภัณฑ์หลายชนิด",
  T_49_META_TYPE_73_D: "มีชั้นวางของหลายชั้น",
  T_49_META_TYPE_74_D: "รหัสไอเทม",
  T_49_META_TYPE_75_D: "กลับมา",
  T_49_META_TYPE_76_D: "สไตล์สายตรวจ",
  T_49_META_TYPE_77_D: "เอนทิตีเครื่องกำเนิดไฟฟ้าที่สามารถสร้างและรีเฟรชวัตถุได้",
  T_49_META_TYPE_78_D: "หน่วยเอนทิตีที่สามารถดูดซับโดยเครื่องกำเนิดหน่วยและสร้างเป็นชุดได้",
  T_49_META_TYPE_79_D: "อาวุธ",
  T_49_META_TYPE_8_D: "เงื่อนไขเป็นชนิดบูลพิเศษ",
  T_49_META_TYPE_80_D: "อินเทอร์เฟซร้านค้า",
  T_49_META_TYPE_81_D: "ประเภทของตัวเสริมพลัง",
  T_49_META_TYPE_82_D: "UI จังหวะหัวใจ",
  T_49_META_TYPE_83_D: "ปุ่มโต้ตอบ",
  T_49_META_TYPE_84_D: "หน่วยงานที่สามารถจัดอันดับได้",
  T_49_META_TYPE_85_D: "เอนทิตีที่สามารถรวมเข้าด้วยกันได้จะมีอินทิกรัลของตัวเอง",
  T_49_META_TYPE_86_D: "ชนิดปัจจัยสูตรแอตทริบิวต์",
  T_49_META_TYPE_87_D: "อธิบายประเภทของสี RGBA โดยแต่ละช่องมีค่าตั้งแต่ 0~255",
  T_49_META_TYPE_88_D: "ประเภทสกุลเงิน ปัจจุบันมีเพียงประเภทสกุลเงินฐานเท่านั้น",
  T_49_META_TYPE_89_D: "หน่วยสกุลเงิน ใช้เพื่ออธิบายประเภทและปริมาณของสกุลเงิน",
  T_49_META_TYPE_9_D: "ชุดเงื่อนไข",
  T_49_META_TYPE_90_D: "เอนทิตีกระเป๋าสตางค์คือภาชนะสำหรับเอนทิตีสกุลเงินจำนวนหนึ่ง",
  T_49_META_TYPE_91_D: "หมายถึงจำนวนเต็มหรือชนิดอาร์เรย์จำนวนเต็ม",
  T_49_META_TYPE_92_D: "ประเภทวัตถุที่สร้างได้แบบไดนามิก",
  T_49_META_TYPE_93_D: "เอนทิตีที่มีคุณสมบัติที่กำหนดสูตรได้",
  T_49_META_TYPE_94_D: "วิธีการปรับเปลี่ยนคุณสมบัติ",
  T_49_META_TYPE_95_D: "ตัวสร้างทอง",
  T_49_META_TYPE_96_D: "กระเป๋าตัง",
  T_49_META_TYPE_97_D: "ตำแหน่ง การหมุนและการปรับขนาด รองรับโครงสร้างพ่อแม่-ลูก",
  T_49_META_TYPE_98_D: "แสดงรายการประเภททั้งหมดที่มี",
  T_49_META_TYPE_99_D: "ฟุตบอล"
};
export {
  _ as default
};
